import React__default, { createElement, Component, cloneElement, Fragment, useState, useRef, useEffect, Children, isValidElement, createContext, createRef, useContext, forwardRef, useCallback } from 'react';
import Measure from 'react-measure';
import { debounce } from 'throttle-debounce';
import ReactDOM from 'react-dom';
import FocusTrap from 'focus-trap-react';
import { Swipeable } from 'react-swipeable';
import AnimateHeight from 'react-animate-height';
import { Link as Link$1 } from 'react-router-dom';
import 'intersection-observer';
import ReactHtmlParser from 'react-html-parser';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

/**
 * Takes a number and returns an array counting up to that number.
 * @param amount number
 * @returns number[]
 */
var count = function (amount) {
    var rangeArr = [];
    for (var i = 0; i < amount; i++) {
        rangeArr.push(i);
    }
    return rangeArr;
};

var isInBrowser = function () { return !!(typeof window !== 'undefined' && window.document && window.document.createElement); };

/**
 * Asserts the type of a variable by checking if the given property exists on the given variable
 * @param varToBeChecked Variable to assert type of
 * @param propertyToCheckFor Function checks for the existence of this property
 * @return boolean, but also asserts type for the TS compiler
 */
var isOfType = function (varToBeChecked, propertyToCheckFor) {
    return varToBeChecked[propertyToCheckFor] !== undefined;
};

/**
 * Checks if a point is within a Client Rect
 * @param clientRect the clientRect to check the point against
 * @param x the horizontal coordinate to check
 * @param y the vertical coordinate to check
 * @returns boolean
 */
var isPointInClientRect = function (clientRect, x, y) {
    var top = clientRect.top, left = clientRect.left, right = clientRect.right, bottom = clientRect.bottom;
    return top < y && y < bottom && left < x && x < right;
};

var joinClasses = function () {
    var classes = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        classes[_i] = arguments[_i];
    }
    return classes.filter(function (c) { return Boolean(c); }).join(' ');
};

/**
 * Creates an array with numbers ranging from <from> to <to>
 * @param from number to start from
 * @param to number to end before
 * @returns an array of numbers
 */
var range = function (from, to) {
    var rangeArr = [];
    for (var i = from; i < to; i++) {
        rangeArr.push(i);
    }
    return rangeArr;
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var animations = createCommonjsModule(function (module) {
  module.exports.animationEasings = {}; // This is the most common easing curve.

  module.exports.animationEasings.animateEaseInOut = 'cubic-bezier(0.4, 0, 0.2, 1)'; // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.

  module.exports.animationEasings.animateEaseOut = 'cubic-bezier(0.0, 0, 0.2, 1)'; // Objects leave the screen at full velocity. They do not decelerate when off-screen.

  module.exports.animationEasings.animateEaseIn = 'cubic-bezier(0.4, 0, 1, 1)'; // The sharp curve is used by objects that may return to the screen at any time.

  module.exports.animationEasings.animateEaseSharp = 'cubic-bezier(0.4, 0, 0.6, 1)';
  module.exports.animationDurations = {};
  module.exports.animationDurations.animateDurationMicro = 180;
  module.exports.animationDurations.animateDurationNormal = 300;
  module.exports.animationDurations.animateDurationMacro = 500;
  module.exports.animationDurations.animateDurationShortest = 150;
  module.exports.animationDurations.animateDurationShorter = 200;
  module.exports.animationDurations.animateDurationShort = 250; // most basic recommended timing

  module.exports.animationDurations.animateDurationStandard = 300; // this is to be used in complex animations

  module.exports.animationDurations.animateDurationComplex = 375; // recommended when something is entering screen

  module.exports.animationDurations.animateDurationEnter = 225; // recommended when something is leaving screen

  module.exports.animationDurations.animateDurationLeave = 195;
});

var mqSmallScreenMaxWidthLimit = 599;
var mqMediumScreenMinWidthLimit = 600;
var mqMediumScreenMaxWidthLimit = 959;
var mqLargeScreenMinWidthLimit = 960;
var breakpoints = {
  mqSmallScreenMaxWidthLimit: mqSmallScreenMaxWidthLimit,
  mqMediumScreenMinWidthLimit: mqMediumScreenMinWidthLimit,
  mqMediumScreenMaxWidthLimit: mqMediumScreenMaxWidthLimit,
  mqLargeScreenMinWidthLimit: mqLargeScreenMinWidthLimit
};

var columnCountSm = 4;
var columnCountMd = 12;
var columnCountLg = 12;
var columns = {
  columnCountSm: columnCountSm,
  columnCountMd: columnCountMd,
  columnCountLg: columnCountLg
};

var pageBgColor = '#FFFFFF';
var rootFontSize = 16;
var minTargetSize = 44;
var base = {
  pageBgColor: pageBgColor,
  rootFontSize: rootFontSize,
  minTargetSize: minTargetSize
};

var titleFontEn = 'UniqloProBold, system-ui, -apple-system, sans-serif';
var titleFontJa = '"ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "Hiragino Sans", "Noto Sans CJK JP", Osaka, Meiryo, メイリオ, "MS PGothic", "ＭＳ Ｐゴシック", YuGothic, "Yu Gothic", "Hiragino Sans GB", Helvetica Neue, HelveticaNeue , Helvetica, Noto Sans, Roboto,Arial, "Arial Unicode MS", sans-serif';
var regularFontEn = 'UniqloProRegular, sans-serif';
var lightFontEn = 'UniqloProLight, system-ui, -apple-system, sans-serif';
var bodyFontEn = "'Helvetica Neue', Helvetica, Arial, system-ui, -apple-system, sans-serif";
var bodyFontJa = '"ヒラギノ角ゴ Pro", "Hiragino Kaku Gothic Pro", "Hiragino Sans", "Noto Sans CJK JP", Osaka, Meiryo, メイリオ, "MS PGothic", "ＭＳ Ｐゴシック", YuGothic, "Yu Gothic", "Hiragino Sans GB", Helvetica Neue, HelveticaNeue , Helvetica, Noto Sans, Roboto,Arial, "Arial Unicode MS", sans-serif';
var font = {
  titleFontEn: titleFontEn,
  titleFontJa: titleFontJa,
  regularFontEn: regularFontEn,
  lightFontEn: lightFontEn,
  bodyFontEn: bodyFontEn,
  bodyFontJa: bodyFontJa
};

var FONT_WEIGHT_LIGHT = 300;
var FONT_WEIGHT_REGULAR = 400;
var FONT_WEIGHT_MEDIUM = 500;
var FONT_WEIGHT_SEMI_BOLD = 600;
var FONT_WEIGHT_BOLD = 700;
var FONT_WEIGHT_EXTRA_BOLD = 800;
var fontWeightLight = FONT_WEIGHT_LIGHT;
var fontWeightRegular = FONT_WEIGHT_REGULAR;
var fontWeightMedium = FONT_WEIGHT_MEDIUM;
var fontWeightSemiBold = FONT_WEIGHT_SEMI_BOLD;
var fontWeightBold = FONT_WEIGHT_BOLD;
var fontWeightExtraBold = FONT_WEIGHT_EXTRA_BOLD;
var fontWeight = {
  fontWeightLight: fontWeightLight,
  fontWeightRegular: fontWeightRegular,
  fontWeightMedium: fontWeightMedium,
  fontWeightSemiBold: fontWeightSemiBold,
  fontWeightBold: fontWeightBold,
  fontWeightExtraBold: fontWeightExtraBold
};

var gridSizeLg = 1200;
var gridSizeLgLimitWithFixedMargin = 1248;
var gridSizeLgLimitWithAutoMargin = 1249;
var grid = {
  gridSizeLg: gridSizeLg,
  gridSizeLgLimitWithFixedMargin: gridSizeLgLimitWithFixedMargin,
  gridSizeLgLimitWithAutoMargin: gridSizeLgLimitWithAutoMargin
};

var line_height_01 = 1;
var line_height_02 = 1.1;
var line_height_03 = 1.2;
var line_height_04 = 1.4;
var line_height_05 = 1.5;
var lineHeight = {
  line_height_01: line_height_01,
  line_height_02: line_height_02,
  line_height_03: line_height_03,
  line_height_04: line_height_04,
  line_height_05: line_height_05
};

var rootFontSize$1 = base.rootFontSize;
var letterSpacingUniqloPro = rootFontSize$1 / 40;
var letterSpacing = {
  letterSpacingUniqloPro: letterSpacingUniqloPro
};

var BORDER_PRIMARY_OUTLINE_COLOR = '#000000';
var BORDER_PRIMARY_OUTLINE_HOVER_COLOR = '#2A2A2A';
var BORDER_NOTICEABLE_COLOR = '#005DB5';
var BORDER_NOTICEABLE_HOVER_COLOR = '#006ED7';
var BORDER_INTERACTIVE_OUTLINE_COLOR = '#767676';
var BORDER_INTERACTIVE_OUTLINE_HOVER_COLOR = '#5D5D5D';
var BORDER_LINES_COLOR = '#DADADA';
var BORDER_LINES_HOVER_COLOR = '#DADADA';
var BORDER_FOCUS_COLOR = '#005DB5';
var BORDER_FOCUS_HOVER_COLOR = '#006ED7';
var BORDER_ERROR_COLOR = '#EE0000';
var BORDER_ERROR_HOVER_COLOR = '#DD3535';
var BORDER_BACKGROUND_COLOR = '#000000';
var BORDER_SECONDARY_COLOR = '#6A6A6A';
var BORDER_SELECTED_COLOR = '#000000';
var BORDER_SELECTED_HOVER_COLOR = '#2A2A2A';
var borderPrimaryOutlineColor = BORDER_PRIMARY_OUTLINE_COLOR;
var borderPrimaryOutlineHoverColor = BORDER_PRIMARY_OUTLINE_HOVER_COLOR;
var borderNoticeableColor = BORDER_NOTICEABLE_COLOR;
var borderNoticeableHoverColor = BORDER_NOTICEABLE_HOVER_COLOR;
var borderInteractiveOutlineColor = BORDER_INTERACTIVE_OUTLINE_COLOR;
var borderInteractiveOutlineHoverColor = BORDER_INTERACTIVE_OUTLINE_HOVER_COLOR;
var borderLinesColor = BORDER_LINES_COLOR;
var borderLinesHoverColor = BORDER_LINES_HOVER_COLOR;
var borderFocusColor = BORDER_FOCUS_COLOR;
var borderFocusHoverColor = BORDER_FOCUS_HOVER_COLOR;
var borderErrorColor = BORDER_ERROR_COLOR;
var borderErrorHoverColor = BORDER_ERROR_HOVER_COLOR;
var borderBackgroundColor = BORDER_BACKGROUND_COLOR;
var borderSecondaryColor = BORDER_SECONDARY_COLOR;
var borderSelectedColor = BORDER_SELECTED_COLOR;
var borderSelectedHoverColor = BORDER_SELECTED_HOVER_COLOR;
var border = {
  borderPrimaryOutlineColor: borderPrimaryOutlineColor,
  borderPrimaryOutlineHoverColor: borderPrimaryOutlineHoverColor,
  borderNoticeableColor: borderNoticeableColor,
  borderNoticeableHoverColor: borderNoticeableHoverColor,
  borderInteractiveOutlineColor: borderInteractiveOutlineColor,
  borderInteractiveOutlineHoverColor: borderInteractiveOutlineHoverColor,
  borderLinesColor: borderLinesColor,
  borderLinesHoverColor: borderLinesHoverColor,
  borderFocusColor: borderFocusColor,
  borderFocusHoverColor: borderFocusHoverColor,
  borderErrorColor: borderErrorColor,
  borderErrorHoverColor: borderErrorHoverColor,
  borderBackgroundColor: borderBackgroundColor,
  borderSecondaryColor: borderSecondaryColor,
  borderSelectedColor: borderSelectedColor,
  borderSelectedHoverColor: borderSelectedHoverColor
};

var FILL_ATTENTION_COLOR = '#EE0000';
var FILL_ATTENTION_HOVER_COLOR = '#EF5555';
var FILL_PRIMARY_COLOR = '#000000';
var FILL_PRIMARY_HOVER_COLOR = '#2A2A2A';
var FILL_SECONDARY_COLOR = '#FFFFFF';
var FILL_SECONDARY_HOVER_COLOR = '#FFFFFF';
var FILL_TERTIARY_COLOR = '#474747';
var FILL_NOTICEABLE_COLOR = '#005DB5';
var FILL_NOTICEABLE_HOVER_COLOR = '#006ED7';
var FILL_INTERACTIVE_COLOR = '#ABABAB';
var FILL_INTERACTIVE_HOVER_COLOR = '#BCBCBC';
var FILL_DISABLED_COLOR = '#DADADA';
var FILL_DISABLED_HOVER_COLOR = '#DADADA';
var FILL_ERROR_COLOR = '#EE0000';
var FILL_ERROR_HOVER_COLOR = '#EF5555';
var FILL_SELECTED_COLOR = '#000000';
var FILL_SELECTED_HOVER_COLOR = '#2A2A2A';
var FILL_SELECTED_TAB_COLOR = '#000000';
var FILL_BACKGROUND_COLOR = '#F4F4F4';
var FILL_BACKGROUND_HOVER_COLOR = '#F4F4F4';
var FILL_BACKGROUND_BALLOON_TIP_COLOR = 'rgba(0, 0, 0, 0.85)';
var FILL_SELECTED_TAB_HOVER_COLOR = '#2A2A2A';
var FILL_SELECTED_STAR_COLOR = '#000000';
var FILL_SELECTED_STAR_HOVER_COLOR = '#2A2A2A';
var FILL_SELECTED_HEART_COLOR = '#EE0000';
var FILL_SELECTED_HEART_HOVER_COLOR = '#DD3535';
var FILL_POSITIVE_COLOR = '#00AB0F';
var FILL_BACKGROUND_SELECTED_COLOR = '#F4F4F4';
var FILL_OVERLAY_COLOR = 'rgba(0, 0, 0, 0.5)';
var FILL_SKELETON_COLOR = '#F4F4F4';
var FILL_SKELETON_HIGHLIGHT_COLOR = '#FAFAFA';
var fillAttentionColor = FILL_ATTENTION_COLOR;
var fillAttentionHoverColor = FILL_ATTENTION_HOVER_COLOR;
var fillPrimaryColor = FILL_PRIMARY_COLOR;
var fillPrimaryHoverColor = FILL_PRIMARY_HOVER_COLOR;
var fillSecondaryColor = FILL_SECONDARY_COLOR;
var fillSecondaryHoverColor = FILL_SECONDARY_HOVER_COLOR;
var fillTertiaryColor = FILL_TERTIARY_COLOR;
var fillNoticeableColor = FILL_NOTICEABLE_COLOR;
var fillNoticeableHoverColor = FILL_NOTICEABLE_HOVER_COLOR;
var fillInteractiveColor = FILL_INTERACTIVE_COLOR;
var fillInteractiveHoverColor = FILL_INTERACTIVE_HOVER_COLOR;
var fillDisabledColor = FILL_DISABLED_COLOR;
var fillDisabledHoverColor = FILL_DISABLED_HOVER_COLOR;
var fillErrorColor = FILL_ERROR_COLOR;
var fillErrorHoverColor = FILL_ERROR_HOVER_COLOR;
var fillSelectedColor = FILL_SELECTED_COLOR;
var fillSelectedHoverColor = FILL_SELECTED_HOVER_COLOR;
var fillSelectedTabColor = FILL_SELECTED_TAB_COLOR;
var fillBackgroundColor = FILL_BACKGROUND_COLOR;
var fillBackgroundHoverColor = FILL_BACKGROUND_HOVER_COLOR;
var fillBackgroundBalloonTipColor = FILL_BACKGROUND_BALLOON_TIP_COLOR;
var fillSelectedTabHoverColor = FILL_SELECTED_TAB_HOVER_COLOR;
var fillSelectedStarColor = FILL_SELECTED_STAR_COLOR;
var fillSelectedStarHoverColor = FILL_SELECTED_STAR_HOVER_COLOR;
var fillSelectedHeartColor = FILL_SELECTED_HEART_COLOR;
var fillSelectedHeartHoverColor = FILL_SELECTED_HEART_HOVER_COLOR;
var fillPositiveColor = FILL_POSITIVE_COLOR;
var fillBackgroundSelectedColor = FILL_BACKGROUND_SELECTED_COLOR;
var fillOverlayColor = FILL_OVERLAY_COLOR;
var fillSkeletonColor = FILL_SKELETON_COLOR;
var fillSkeletonHighlightColor = FILL_SKELETON_HIGHLIGHT_COLOR;
var fill = {
  fillAttentionColor: fillAttentionColor,
  fillAttentionHoverColor: fillAttentionHoverColor,
  fillPrimaryColor: fillPrimaryColor,
  fillPrimaryHoverColor: fillPrimaryHoverColor,
  fillSecondaryColor: fillSecondaryColor,
  fillSecondaryHoverColor: fillSecondaryHoverColor,
  fillTertiaryColor: fillTertiaryColor,
  fillNoticeableColor: fillNoticeableColor,
  fillNoticeableHoverColor: fillNoticeableHoverColor,
  fillInteractiveColor: fillInteractiveColor,
  fillInteractiveHoverColor: fillInteractiveHoverColor,
  fillDisabledColor: fillDisabledColor,
  fillDisabledHoverColor: fillDisabledHoverColor,
  fillErrorColor: fillErrorColor,
  fillErrorHoverColor: fillErrorHoverColor,
  fillSelectedColor: fillSelectedColor,
  fillSelectedHoverColor: fillSelectedHoverColor,
  fillSelectedTabColor: fillSelectedTabColor,
  fillBackgroundColor: fillBackgroundColor,
  fillBackgroundHoverColor: fillBackgroundHoverColor,
  fillBackgroundBalloonTipColor: fillBackgroundBalloonTipColor,
  fillSelectedTabHoverColor: fillSelectedTabHoverColor,
  fillSelectedStarColor: fillSelectedStarColor,
  fillSelectedStarHoverColor: fillSelectedStarHoverColor,
  fillSelectedHeartColor: fillSelectedHeartColor,
  fillSelectedHeartHoverColor: fillSelectedHeartHoverColor,
  fillPositiveColor: fillPositiveColor,
  fillBackgroundSelectedColor: fillBackgroundSelectedColor,
  fillOverlayColor: fillOverlayColor,
  fillSkeletonColor: fillSkeletonColor,
  fillSkeletonHighlightColor: fillSkeletonHighlightColor
};

var TEXT_PRIMARY_DARK_COLOR = '#000000';
var TEXT_PRIMARY_DARK_HOVER_COLOR = '#2A2A2A';
var TEXT_PRIMARY_LIGHT_COLOR = '#FFFFFF';
var TEXT_PRIMARY_LIGHT_HOVER_COLOR = '#FFFFFF';
var TEXT_SECONDARY_COLOR = '#6A6A6A';
var TEXT_SECONDARY_HOVER_COLOR = '#919191';
var TEXT_NOTICEABLE_COLOR = '#005DB5';
var TEXT_NOTICEABLE_HOVER_COLOR = '#006ED7';
var TEXT_DISABLED_COLOR = '#ABABAB';
var TEXT_DISABLED_HOVER_COLOR = '#ABABAB';
var TEXT_ERROR_COLOR = '#EE0000';
var TEXT_ERROR_HOVER_COLOR = '#EF5555';
var TEXT_PROMOTIONAL_COLOR = '#EE0000';
var TEXT_PROMOTIONAL_HOVER_COLOR = '#EF5555';
var TEXT_PLACEHOLDER_COLOR = '#767676';
var TEXT_PLACEHOLDER_HOVER_COLOR = '#767676';
var TEXT_TERTIARY_COLOR = '#767676';
var TEXT_SELECTED_TAB_NAVIGATION_COLOR = '#000000';
var TEXT_POSITIVE_COLOR = '#008A24';
var TEXT_NOTICEABLE_BLUE_COLOR = '#005DB5';
var TEXT_NOTICEABLE_BLUE_HOVER_COLOR = '#006ED7';
var TEXT_NOTICEABLE_BLACK_COLOR = '#000000';
var textPrimaryDarkColor = TEXT_PRIMARY_DARK_COLOR;
var textPrimaryDarkHoverColor = TEXT_PRIMARY_DARK_HOVER_COLOR;
var textPrimaryLightColor = TEXT_PRIMARY_LIGHT_COLOR;
var textPrimaryLightHoverColor = TEXT_PRIMARY_LIGHT_HOVER_COLOR;
var textSecondaryColor = TEXT_SECONDARY_COLOR;
var textSecondaryHoverColor = TEXT_SECONDARY_HOVER_COLOR;
var textNoticeableColor = TEXT_NOTICEABLE_COLOR;
var textNoticeableHoverColor = TEXT_NOTICEABLE_HOVER_COLOR;
var textDisabledColor = TEXT_DISABLED_COLOR;
var textDisabledHoverColor = TEXT_DISABLED_HOVER_COLOR;
var textErrorColor = TEXT_ERROR_COLOR;
var textErrorHoverColor = TEXT_ERROR_HOVER_COLOR;
var textPromotionalColor = TEXT_PROMOTIONAL_COLOR;
var textPromotionalHoverColor = TEXT_PROMOTIONAL_HOVER_COLOR;
var textPlaceholderColor = TEXT_PLACEHOLDER_COLOR;
var textPlaceholderHoverColor = TEXT_PLACEHOLDER_HOVER_COLOR;
var textTertiaryColor = TEXT_TERTIARY_COLOR;
var textSelectedTabNavigationColor = TEXT_SELECTED_TAB_NAVIGATION_COLOR;
var textPositiveColor = TEXT_POSITIVE_COLOR;
var textNoticeableBlueColor = TEXT_NOTICEABLE_BLUE_COLOR;
var textNoticeableBlueHoverColor = TEXT_NOTICEABLE_BLUE_HOVER_COLOR;
var textNoticeableBlackColor = TEXT_NOTICEABLE_BLACK_COLOR;
var text = {
  textPrimaryDarkColor: textPrimaryDarkColor,
  textPrimaryDarkHoverColor: textPrimaryDarkHoverColor,
  textPrimaryLightColor: textPrimaryLightColor,
  textPrimaryLightHoverColor: textPrimaryLightHoverColor,
  textSecondaryColor: textSecondaryColor,
  textSecondaryHoverColor: textSecondaryHoverColor,
  textNoticeableColor: textNoticeableColor,
  textNoticeableHoverColor: textNoticeableHoverColor,
  textDisabledColor: textDisabledColor,
  textDisabledHoverColor: textDisabledHoverColor,
  textErrorColor: textErrorColor,
  textErrorHoverColor: textErrorHoverColor,
  textPromotionalColor: textPromotionalColor,
  textPromotionalHoverColor: textPromotionalHoverColor,
  textPlaceholderColor: textPlaceholderColor,
  textPlaceholderHoverColor: textPlaceholderHoverColor,
  textTertiaryColor: textTertiaryColor,
  textSelectedTabNavigationColor: textSelectedTabNavigationColor,
  textPositiveColor: textPositiveColor,
  textNoticeableBlueColor: textNoticeableBlueColor,
  textNoticeableBlueHoverColor: textNoticeableBlueHoverColor,
  textNoticeableBlackColor: textNoticeableBlackColor
};

var EFFECTS_BOX_SHADOW_COLOR = '#1B1B1B';
var effectsBoxShadowColor = EFFECTS_BOX_SHADOW_COLOR;
var effects = {
  effectsBoxShadowColor: effectsBoxShadowColor
};

var UI_ATTENTION_DEFAULT_COLOR = '#FF0000';
var UI_ATTENTION_HOVER_COLOR = '#FF5959';
var UI_PRIMARY_DEFAULT_COLOR = '#1B1B1B';
var UI_PRIMARY_HOVER_COLOR = '#6A6A6A';
var UI_SECONDARY_DEFAULT_OUTLINE_COLOR = '#1B1B1B';
var UI_SECONDARY_DEFAULT_BACKGROUND_COLOR = '#FFFFFF';
var UI_SECONDARY_DEFAULT_HOVER_COLOR = '#6A6A6A';
var UI_GLOBAL_BACKGROUND_COLOR = '#F4F4F4';
var UI_GLOBAL_ERROR_COLOR = '#CC0000';
var UI_GLOBAL_FOCUS_COLOR = '#006ED7';
var UI_GLOBAL_FOCUS_ERROR_COLOR = '#CC0000';
var UI_GLOBAL_DISABLED_COLOR = '#DADADA';
var UI_GLOBAL_BORDER_COLOR = '#DADADA';
var UI_GLOBAL_INTERACTIVE_COLOR = '#ABABAB';
var UI_FORM_INPUTS_BACKGROUND_PASSIVE_COLOR = '#F7F7F7';
var UI_FORM_INPUTS_BACKGROUND_ACTIVE_COLOR = '#FFFFFF';
var SUPPORTING_GENDER_WOMEN_COLOR = '#FF0000';
var SUPPORTING_GENDER_MEN_COLOR = '#000082';
var SUPPORTING_GENDER_KIDS_COLOR = '#50B4F0';
var SUPPORTING_GENDER_BABY_COLOR = '#96C800';
var SUPPORTING_GENDER_GIRLS_COLOR = '#EB64A5';
var SUPPORTING_GENDER_BOYS_COLOR = '#0091D7';
var COLOR_YELLOW = '#ebbe00';
var uiAttentionDefaultColor = UI_ATTENTION_DEFAULT_COLOR;
var uiAttentionHoverColor = UI_ATTENTION_HOVER_COLOR;
var uiPrimaryDefaultColor = UI_PRIMARY_DEFAULT_COLOR;
var uiPrimaryHoverColor = UI_PRIMARY_HOVER_COLOR;
var uiSecondaryDefaultOutlineColor = UI_SECONDARY_DEFAULT_OUTLINE_COLOR;
var uiSecondaryDefaultBackgroundColor = UI_SECONDARY_DEFAULT_BACKGROUND_COLOR;
var uiSecondaryDefaultHoverColor = UI_SECONDARY_DEFAULT_HOVER_COLOR;
var uiGlobalBackgroundColor = UI_GLOBAL_BACKGROUND_COLOR;
var uiGlobalErrorColor = UI_GLOBAL_ERROR_COLOR;
var uiGlobalFocusColor = UI_GLOBAL_FOCUS_COLOR;
var uiGlobalFocusErrorColor = UI_GLOBAL_FOCUS_ERROR_COLOR;
var uiGlobalDisabledColor = UI_GLOBAL_DISABLED_COLOR;
var uiGlobalBorderColor = UI_GLOBAL_BORDER_COLOR;
var uiGlobalInteractiveColor = UI_GLOBAL_INTERACTIVE_COLOR;
var uiFormInputsBackgroundPassiveColor = UI_FORM_INPUTS_BACKGROUND_PASSIVE_COLOR;
var uiFormInputsBackgroundActiveColor = UI_FORM_INPUTS_BACKGROUND_ACTIVE_COLOR;
var supportingGenderWomenColor = SUPPORTING_GENDER_WOMEN_COLOR;
var supportingGenderMenColor = SUPPORTING_GENDER_MEN_COLOR;
var supportingGenderKidsColor = SUPPORTING_GENDER_KIDS_COLOR;
var supportingGenderBabyColor = SUPPORTING_GENDER_BABY_COLOR;
var supportingGenderGirlsColor = SUPPORTING_GENDER_GIRLS_COLOR;
var supportingGenderBoysColor = SUPPORTING_GENDER_BOYS_COLOR;
var colorYellow = COLOR_YELLOW;
var additionals = {
  uiAttentionDefaultColor: uiAttentionDefaultColor,
  uiAttentionHoverColor: uiAttentionHoverColor,
  uiPrimaryDefaultColor: uiPrimaryDefaultColor,
  uiPrimaryHoverColor: uiPrimaryHoverColor,
  uiSecondaryDefaultOutlineColor: uiSecondaryDefaultOutlineColor,
  uiSecondaryDefaultBackgroundColor: uiSecondaryDefaultBackgroundColor,
  uiSecondaryDefaultHoverColor: uiSecondaryDefaultHoverColor,
  uiGlobalBackgroundColor: uiGlobalBackgroundColor,
  uiGlobalErrorColor: uiGlobalErrorColor,
  uiGlobalFocusColor: uiGlobalFocusColor,
  uiGlobalFocusErrorColor: uiGlobalFocusErrorColor,
  uiGlobalDisabledColor: uiGlobalDisabledColor,
  uiGlobalBorderColor: uiGlobalBorderColor,
  uiGlobalInteractiveColor: uiGlobalInteractiveColor,
  uiFormInputsBackgroundPassiveColor: uiFormInputsBackgroundPassiveColor,
  uiFormInputsBackgroundActiveColor: uiFormInputsBackgroundActiveColor,
  supportingGenderWomenColor: supportingGenderWomenColor,
  supportingGenderMenColor: supportingGenderMenColor,
  supportingGenderKidsColor: supportingGenderKidsColor,
  supportingGenderBabyColor: supportingGenderBabyColor,
  supportingGenderGirlsColor: supportingGenderGirlsColor,
  supportingGenderBoysColor: supportingGenderBoysColor,
  colorYellow: colorYellow
};

var color = {
  border: border,
  fill: fill,
  text: text,
  effects: effects,
  additionals: additionals
};

var DISPLAY1_COLOR_DISABLED = color.text.textDisabledColor;
var DISPLAY1_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var DISPLAY2_COLOR_DISABLED = color.text.textDisabledColor;
var DISPLAY2_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var DISPLAY3_COLOR_DISABLED = color.text.textDisabledColor;
var DISPLAY3_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var DISPLAY4_COLOR_DISABLED = color.text.textDisabledColor;
var DISPLAY4_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var DISPLAY5_COLOR_DISABLED = color.text.textDisabledColor;
var DISPLAY5_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var DYNAMIC_COLOR_DISABLED = color.text.textDisabledColor;
var DYNAMIC_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var TITLE_COLOR_DISABLED = color.text.textDisabledColor;
var TITLE_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var TITLE_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var FLAG_COLOR_SECONDARY = color.text.textSecondaryColor;
var BADGE_LARGE_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var BADGE_SMALL_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var BADGE_LARGE_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var BADGE_SMALL_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var CAPTION_STANDARD_COLOR_DISABLED = color.text.textDisabledColor;
var CAPTION_STANDARD_COLOR_ERROR = color.text.textErrorColor;
var CAPTION_STANDARD_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var CAPTION_STANDARD_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var CAPTION_STANDARD_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var CAPTION_STANDARD_COLOR_SECONDARY = color.text.textSecondaryColor;
var CAPTION_EMPHASIZED_COLOR_DISABLED = color.text.textDisabledColor;
var CAPTION_EMPHASIZED_COLOR_ERROR = color.text.textErrorColor;
var CAPTION_EMPHASIZED_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var CAPTION_EMPHASIZED_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var CAPTION_EMPHASIZED_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var CAPTION_EMPHASIZED_COLOR_SECONDARY = color.text.textSecondaryColor;
var LABEL_PRIMARY_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var LABEL_PRIMARY_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var LABEL_PRIMARY_COLOR_DISABLED = color.text.textDisabledColor;
var LABEL_PRIMARY_COLOR_SECONDARY = color.text.textSecondaryColor;
var LABEL_PRIMARY_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var LABEL_PRIMARY_COLOR_INTERACTIVE = color.fill.fillInteractiveColor;
var LABEL_SECONDARY_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var LABEL_SECONDARY_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var LABEL_SECONDARY_COLOR_DISABLED = color.text.textDisabledColor;
var LABEL_SECONDARY_COLOR_SECONDARY = color.text.textSecondaryColor;
var LABEL_SECONDARY_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var LABEL_SECONDARY_COLOR_INTERACTIVE = color.fill.fillInteractiveColor;
var LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var LABEL_TERTIARY_STANDARD_COLOR_DISABLED = color.text.textDisabledColor;
var LABEL_TERTIARY_STANDARD_COLOR_SECONDARY = color.text.textSecondaryColor;
var LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var LABEL_TERTIARY_STANDARD_COLOR_INTERACTIVE = color.fill.fillInteractiveColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_DISABLED = color.text.textDisabledColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_SECONDARY = color.text.textSecondaryColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_INTERACTIVE = color.fill.fillInteractiveColor;
var LABEL_SUPPORTIVE_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var LABEL_SUPPORTIVE_COLOR_PRIMARY_LIGHT = color.text.textPrimaryLightColor;
var LABEL_SUPPORTIVE_COLOR_DISABLED = color.text.textDisabledColor;
var LABEL_SUPPORTIVE_COLOR_SECONDARY = color.text.textSecondaryColor;
var LABEL_SUPPORTIVE_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var LABEL_SUPPORTIVE_COLOR_INTERACTIVE = color.fill.fillInteractiveColor;
var BODY_STANDARD_COLOR_PLACEHOLDER = color.text.textPlaceholderColor;
var BODY_STANDARD_COLOR_DISABLED = color.text.textDisabledColor;
var BODY_STANDARD_COLOR_ERROR = color.text.textErrorColor;
var BODY_STANDARD_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var BODY_STANDARD_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var BODY_STANDARD_COLOR_SECONDARY = color.text.textSecondaryColor;
var BODY_STANDARD_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var BODY_EMPHASIZED_COLOR_PLACEHOLDER = color.text.textPlaceholderColor;
var BODY_EMPHASIZED_COLOR_DISABLED = color.text.textDisabledColor;
var BODY_EMPHASIZED_COLOR_ERROR = color.text.textErrorColor;
var BODY_EMPHASIZED_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var BODY_EMPHASIZED_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var BODY_EMPHASIZED_COLOR_SECONDARY = color.text.textSecondaryColor;
var BODY_EMPHASIZED_COLOR_PRIMARY_HOVER = color.fill.fillPrimaryHoverColor;
var PRICE_SMALL_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var PRICE_SMALL_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var PRICE_MEDIUM_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var PRICE_MEDIUM_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var PRICE_LARGE_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var PRICE_LARGE_COLOR_PROMOTIONAL = color.text.textPromotionalColor;
var HINT_COLOR_PRIMARY_DARK = color.text.textPrimaryDarkColor;
var HINT_COLOR_SECONDARY = color.text.textSecondaryColor;
var HINT_COLOR_DISABLED = color.text.textDisabledColor;
var HINT_COLOR_ERROR = color.text.textErrorColor;
var display1_ColorDisabled = DISPLAY1_COLOR_DISABLED;
var display1_ColorPrimaryDark = DISPLAY1_COLOR_PRIMARY_DARK;
var display2_ColorDisabled = DISPLAY2_COLOR_DISABLED;
var display2_ColorPrimaryDark = DISPLAY2_COLOR_PRIMARY_DARK;
var display3_ColorDisabled = DISPLAY3_COLOR_DISABLED;
var display3_ColorPrimaryDark = DISPLAY3_COLOR_PRIMARY_DARK;
var display4_ColorDisabled = DISPLAY4_COLOR_DISABLED;
var display4_ColorPrimaryDark = DISPLAY4_COLOR_PRIMARY_DARK;
var display5_ColorDisabled = DISPLAY5_COLOR_DISABLED;
var display5_ColorPrimaryDark = DISPLAY5_COLOR_PRIMARY_DARK;
var dynamic_ColorDisabled = DYNAMIC_COLOR_DISABLED;
var dynamic_ColorPrimaryDark = DYNAMIC_COLOR_PRIMARY_DARK;
var titleColorDisabled = TITLE_COLOR_DISABLED;
var titleColorPrimaryDark = TITLE_COLOR_PRIMARY_DARK;
var titleColorPromotional = TITLE_COLOR_PROMOTIONAL;
var flagColorSecondary = FLAG_COLOR_SECONDARY;
var badgeLargeColorPrimaryDark = BADGE_LARGE_COLOR_PRIMARY_DARK;
var badgeSmallColorPrimaryDark = BADGE_SMALL_COLOR_PRIMARY_DARK;
var badgeLargeColorPrimaryLight = BADGE_LARGE_COLOR_PRIMARY_LIGHT;
var badgeSmallColorPrimaryLight = BADGE_SMALL_COLOR_PRIMARY_LIGHT;
var captionStandardColorDisabled = CAPTION_STANDARD_COLOR_DISABLED;
var captionStandardColorError = CAPTION_STANDARD_COLOR_ERROR;
var captionStandardColorPrimaryDark = CAPTION_STANDARD_COLOR_PRIMARY_DARK;
var captionStandardColorPrimaryLight = CAPTION_STANDARD_COLOR_PRIMARY_LIGHT;
var captionStandardColorPromotional = CAPTION_STANDARD_COLOR_PROMOTIONAL;
var captionStandardColorSecondary = CAPTION_STANDARD_COLOR_SECONDARY;
var captionEmphasizedColorDisabled = CAPTION_EMPHASIZED_COLOR_DISABLED;
var captionEmphasizedColorError = CAPTION_EMPHASIZED_COLOR_ERROR;
var captionEmphasizedColorPrimaryDark = CAPTION_EMPHASIZED_COLOR_PRIMARY_DARK;
var captionEmphasizedColorPrimaryLight = CAPTION_EMPHASIZED_COLOR_PRIMARY_LIGHT;
var captionEmphasizedColorPromotional = CAPTION_EMPHASIZED_COLOR_PROMOTIONAL;
var captionEmphasizedColorSecondary = CAPTION_EMPHASIZED_COLOR_SECONDARY;
var labelPrimaryColorPrimaryDark = LABEL_PRIMARY_COLOR_PRIMARY_DARK;
var labelPrimaryColorPrimaryLight = LABEL_PRIMARY_COLOR_PRIMARY_LIGHT;
var labelPrimaryColorDisabled = LABEL_PRIMARY_COLOR_DISABLED;
var labelPrimaryColorSecondary = LABEL_PRIMARY_COLOR_SECONDARY;
var labelPrimaryColorPrimaryHover = LABEL_PRIMARY_COLOR_PRIMARY_HOVER;
var labelPrimaryColorInteractive = LABEL_PRIMARY_COLOR_INTERACTIVE;
var labelSecondaryColorPrimaryDark = LABEL_SECONDARY_COLOR_PRIMARY_DARK;
var labelSecondaryColorPrimaryLight = LABEL_SECONDARY_COLOR_PRIMARY_LIGHT;
var labelSecondaryColorDisabled = LABEL_SECONDARY_COLOR_DISABLED;
var labelSecondaryColorSecondary = LABEL_SECONDARY_COLOR_SECONDARY;
var labelSecondaryColorPrimaryHover = LABEL_SECONDARY_COLOR_PRIMARY_HOVER;
var labelSecondaryColorInteractive = LABEL_SECONDARY_COLOR_INTERACTIVE;
var labelTertiaryStandardColorPrimaryDark = LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_DARK;
var labelTertiaryStandardColorPrimaryLight = LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_LIGHT;
var labelTertiaryStandardColorDisabled = LABEL_TERTIARY_STANDARD_COLOR_DISABLED;
var labelTertiaryStandardColorSecondary = LABEL_TERTIARY_STANDARD_COLOR_SECONDARY;
var labelTertiaryStandardColorPrimaryHover = LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_HOVER;
var labelTertiaryStandardColorInteractive = LABEL_TERTIARY_STANDARD_COLOR_INTERACTIVE;
var labelTertiaryEmphasizedColorPrimaryDark = LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_DARK;
var labelTertiaryEmphasizedColorPrimaryLight = LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_LIGHT;
var labelTertiaryEmphasizedColorDisabled = LABEL_TERTIARY_EMPHASIZED_COLOR_DISABLED;
var labelTertiaryEmphasizedColorSecondary = LABEL_TERTIARY_EMPHASIZED_COLOR_SECONDARY;
var labelTertiaryEmphasizedColorPrimaryHover = LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_HOVER;
var labelTertiaryEmphasizedColorInteractive = LABEL_TERTIARY_EMPHASIZED_COLOR_INTERACTIVE;
var labelSupportiveColorPrimaryDark = LABEL_SUPPORTIVE_COLOR_PRIMARY_DARK;
var labelSupportiveColorPrimaryLight = LABEL_SUPPORTIVE_COLOR_PRIMARY_LIGHT;
var labelSupportiveColorDisabled = LABEL_SUPPORTIVE_COLOR_DISABLED;
var labelSupportiveColorSecondary = LABEL_SUPPORTIVE_COLOR_SECONDARY;
var labelSupportiveColorPrimaryHover = LABEL_SUPPORTIVE_COLOR_PRIMARY_HOVER;
var labelSupportiveColorInteractive = LABEL_SUPPORTIVE_COLOR_INTERACTIVE;
var bodyStandardColorPlaceholder = BODY_STANDARD_COLOR_PLACEHOLDER;
var bodyStandardColorDisabled = BODY_STANDARD_COLOR_DISABLED;
var bodyStandardColorError = BODY_STANDARD_COLOR_ERROR;
var bodyStandardColorPrimaryDark = BODY_STANDARD_COLOR_PRIMARY_DARK;
var bodyStandardColorPromotional = BODY_STANDARD_COLOR_PROMOTIONAL;
var bodyStandardColorSecondary = BODY_STANDARD_COLOR_SECONDARY;
var bodyStandardColorPrimaryHover = BODY_STANDARD_COLOR_PRIMARY_HOVER;
var bodyEmphasizedColorPlaceholder = BODY_EMPHASIZED_COLOR_PLACEHOLDER;
var bodyEmphasizedColorDisabled = BODY_EMPHASIZED_COLOR_DISABLED;
var bodyEmphasizedColorError = BODY_EMPHASIZED_COLOR_ERROR;
var bodyEmphasizedColorPrimaryDark = BODY_EMPHASIZED_COLOR_PRIMARY_DARK;
var bodyEmphasizedColorPromotional = BODY_EMPHASIZED_COLOR_PROMOTIONAL;
var bodyEmphasizedColorSecondary = BODY_EMPHASIZED_COLOR_SECONDARY;
var bodyEmphasizedColorPrimaryHover = BODY_EMPHASIZED_COLOR_PRIMARY_HOVER;
var priceSmallColorPrimaryDark = PRICE_SMALL_COLOR_PRIMARY_DARK;
var priceSmallColorPromotional = PRICE_SMALL_COLOR_PROMOTIONAL;
var priceMediumColorPrimaryDark = PRICE_MEDIUM_COLOR_PRIMARY_DARK;
var priceMediumColorPromotional = PRICE_MEDIUM_COLOR_PROMOTIONAL;
var priceLargeColorPrimaryDark = PRICE_LARGE_COLOR_PRIMARY_DARK;
var priceLargeColorPromotional = PRICE_LARGE_COLOR_PROMOTIONAL;
var hintColorPrimaryDark = HINT_COLOR_PRIMARY_DARK;
var hintColorSecondary = HINT_COLOR_SECONDARY;
var hintColorDisabled = HINT_COLOR_DISABLED;
var hintColorError = HINT_COLOR_ERROR;
var typographyColor = {
  display1_ColorDisabled: display1_ColorDisabled,
  display1_ColorPrimaryDark: display1_ColorPrimaryDark,
  display2_ColorDisabled: display2_ColorDisabled,
  display2_ColorPrimaryDark: display2_ColorPrimaryDark,
  display3_ColorDisabled: display3_ColorDisabled,
  display3_ColorPrimaryDark: display3_ColorPrimaryDark,
  display4_ColorDisabled: display4_ColorDisabled,
  display4_ColorPrimaryDark: display4_ColorPrimaryDark,
  display5_ColorDisabled: display5_ColorDisabled,
  display5_ColorPrimaryDark: display5_ColorPrimaryDark,
  dynamic_ColorDisabled: dynamic_ColorDisabled,
  dynamic_ColorPrimaryDark: dynamic_ColorPrimaryDark,
  titleColorDisabled: titleColorDisabled,
  titleColorPrimaryDark: titleColorPrimaryDark,
  titleColorPromotional: titleColorPromotional,
  flagColorSecondary: flagColorSecondary,
  badgeLargeColorPrimaryDark: badgeLargeColorPrimaryDark,
  badgeSmallColorPrimaryDark: badgeSmallColorPrimaryDark,
  badgeLargeColorPrimaryLight: badgeLargeColorPrimaryLight,
  badgeSmallColorPrimaryLight: badgeSmallColorPrimaryLight,
  captionStandardColorDisabled: captionStandardColorDisabled,
  captionStandardColorError: captionStandardColorError,
  captionStandardColorPrimaryDark: captionStandardColorPrimaryDark,
  captionStandardColorPrimaryLight: captionStandardColorPrimaryLight,
  captionStandardColorPromotional: captionStandardColorPromotional,
  captionStandardColorSecondary: captionStandardColorSecondary,
  captionEmphasizedColorDisabled: captionEmphasizedColorDisabled,
  captionEmphasizedColorError: captionEmphasizedColorError,
  captionEmphasizedColorPrimaryDark: captionEmphasizedColorPrimaryDark,
  captionEmphasizedColorPrimaryLight: captionEmphasizedColorPrimaryLight,
  captionEmphasizedColorPromotional: captionEmphasizedColorPromotional,
  captionEmphasizedColorSecondary: captionEmphasizedColorSecondary,
  labelPrimaryColorPrimaryDark: labelPrimaryColorPrimaryDark,
  labelPrimaryColorPrimaryLight: labelPrimaryColorPrimaryLight,
  labelPrimaryColorDisabled: labelPrimaryColorDisabled,
  labelPrimaryColorSecondary: labelPrimaryColorSecondary,
  labelPrimaryColorPrimaryHover: labelPrimaryColorPrimaryHover,
  labelPrimaryColorInteractive: labelPrimaryColorInteractive,
  labelSecondaryColorPrimaryDark: labelSecondaryColorPrimaryDark,
  labelSecondaryColorPrimaryLight: labelSecondaryColorPrimaryLight,
  labelSecondaryColorDisabled: labelSecondaryColorDisabled,
  labelSecondaryColorSecondary: labelSecondaryColorSecondary,
  labelSecondaryColorPrimaryHover: labelSecondaryColorPrimaryHover,
  labelSecondaryColorInteractive: labelSecondaryColorInteractive,
  labelTertiaryStandardColorPrimaryDark: labelTertiaryStandardColorPrimaryDark,
  labelTertiaryStandardColorPrimaryLight: labelTertiaryStandardColorPrimaryLight,
  labelTertiaryStandardColorDisabled: labelTertiaryStandardColorDisabled,
  labelTertiaryStandardColorSecondary: labelTertiaryStandardColorSecondary,
  labelTertiaryStandardColorPrimaryHover: labelTertiaryStandardColorPrimaryHover,
  labelTertiaryStandardColorInteractive: labelTertiaryStandardColorInteractive,
  labelTertiaryEmphasizedColorPrimaryDark: labelTertiaryEmphasizedColorPrimaryDark,
  labelTertiaryEmphasizedColorPrimaryLight: labelTertiaryEmphasizedColorPrimaryLight,
  labelTertiaryEmphasizedColorDisabled: labelTertiaryEmphasizedColorDisabled,
  labelTertiaryEmphasizedColorSecondary: labelTertiaryEmphasizedColorSecondary,
  labelTertiaryEmphasizedColorPrimaryHover: labelTertiaryEmphasizedColorPrimaryHover,
  labelTertiaryEmphasizedColorInteractive: labelTertiaryEmphasizedColorInteractive,
  labelSupportiveColorPrimaryDark: labelSupportiveColorPrimaryDark,
  labelSupportiveColorPrimaryLight: labelSupportiveColorPrimaryLight,
  labelSupportiveColorDisabled: labelSupportiveColorDisabled,
  labelSupportiveColorSecondary: labelSupportiveColorSecondary,
  labelSupportiveColorPrimaryHover: labelSupportiveColorPrimaryHover,
  labelSupportiveColorInteractive: labelSupportiveColorInteractive,
  bodyStandardColorPlaceholder: bodyStandardColorPlaceholder,
  bodyStandardColorDisabled: bodyStandardColorDisabled,
  bodyStandardColorError: bodyStandardColorError,
  bodyStandardColorPrimaryDark: bodyStandardColorPrimaryDark,
  bodyStandardColorPromotional: bodyStandardColorPromotional,
  bodyStandardColorSecondary: bodyStandardColorSecondary,
  bodyStandardColorPrimaryHover: bodyStandardColorPrimaryHover,
  bodyEmphasizedColorPlaceholder: bodyEmphasizedColorPlaceholder,
  bodyEmphasizedColorDisabled: bodyEmphasizedColorDisabled,
  bodyEmphasizedColorError: bodyEmphasizedColorError,
  bodyEmphasizedColorPrimaryDark: bodyEmphasizedColorPrimaryDark,
  bodyEmphasizedColorPromotional: bodyEmphasizedColorPromotional,
  bodyEmphasizedColorSecondary: bodyEmphasizedColorSecondary,
  bodyEmphasizedColorPrimaryHover: bodyEmphasizedColorPrimaryHover,
  priceSmallColorPrimaryDark: priceSmallColorPrimaryDark,
  priceSmallColorPromotional: priceSmallColorPromotional,
  priceMediumColorPrimaryDark: priceMediumColorPrimaryDark,
  priceMediumColorPromotional: priceMediumColorPromotional,
  priceLargeColorPrimaryDark: priceLargeColorPrimaryDark,
  priceLargeColorPromotional: priceLargeColorPromotional,
  hintColorPrimaryDark: hintColorPrimaryDark,
  hintColorSecondary: hintColorSecondary,
  hintColorDisabled: hintColorDisabled,
  hintColorError: hintColorError
};

var rootFontSize$2 = base.rootFontSize;
var SPACING_01 = rootFontSize$2 * 0.25;
var SPACING_02 = rootFontSize$2 * 0.5;
var SPACING_03 = rootFontSize$2 * 0.75;
var SPACING_04 = rootFontSize$2;
var SPACING_05 = rootFontSize$2 * 1.5;
var SPACING_06 = rootFontSize$2 * 2;
var SPACING_07 = rootFontSize$2 * 3.25;
var SPACING_08 = rootFontSize$2 * 5.5;
var SPACING_HALF_GUTTER = rootFontSize$2 * 0.75;
var SPACING_GUTTER = SPACING_HALF_GUTTER * 2;
var SPACING_COLUMN_INSET = rootFontSize$2 * 1.5;
var spacing_01 = SPACING_01;
var spacing_02 = SPACING_02;
var spacing_03 = SPACING_03;
var spacing_04 = SPACING_04;
var spacing_05 = SPACING_05;
var spacing_06 = SPACING_06;
var spacing_07 = SPACING_07;
var spacing_08 = SPACING_08;
var spacingNegative_01 = SPACING_01 * -1;
var spacingNegative_02 = SPACING_02 * -1;
var spacingNegative_03 = SPACING_03 * -1;
var spacingNegative_04 = SPACING_04 * -1;
var spacingNegative_05 = SPACING_05 * -1;
var spacingNegative_06 = SPACING_06 * -1;
var spacingNegative_07 = SPACING_07 * -1;
var spacingNegative_08 = SPACING_08 * -1;
var spacingHalfGutter = SPACING_HALF_GUTTER;
var spacingGutter = SPACING_GUTTER;
var spacingColumnInset = SPACING_COLUMN_INSET;
var spacingRowGap = SPACING_HALF_GUTTER;
var spacingRowGapAtLarge = SPACING_GUTTER + SPACING_COLUMN_INSET;
var spacingGridMarginAtMedium = rootFontSize$2 * 1.5;
var spacingGridMarginAtLarge = rootFontSize$2 * 3;
var spacingGridMarginAtExtraLarge = 'auto';
var spacingGutterSm = rootFontSize$2;
var spacingGutterMd = SPACING_GUTTER;
var spacingGutterLg = SPACING_GUTTER;
var spacingInsetSm = rootFontSize$2;
var spacingInsetMd = rootFontSize$2;
var spacingInsetLg = rootFontSize$2 * 1.5;
var spacingOutsetSm = rootFontSize$2 * 1.25;
var spacingOutsetMd = rootFontSize$2 * 0.75;
var spacingOutsetLg = rootFontSize$2 * 0.75;
var spacing = {
  spacing_01: spacing_01,
  spacing_02: spacing_02,
  spacing_03: spacing_03,
  spacing_04: spacing_04,
  spacing_05: spacing_05,
  spacing_06: spacing_06,
  spacing_07: spacing_07,
  spacing_08: spacing_08,
  spacingNegative_01: spacingNegative_01,
  spacingNegative_02: spacingNegative_02,
  spacingNegative_03: spacingNegative_03,
  spacingNegative_04: spacingNegative_04,
  spacingNegative_05: spacingNegative_05,
  spacingNegative_06: spacingNegative_06,
  spacingNegative_07: spacingNegative_07,
  spacingNegative_08: spacingNegative_08,
  spacingHalfGutter: spacingHalfGutter,
  spacingGutter: spacingGutter,
  spacingColumnInset: spacingColumnInset,
  spacingRowGap: spacingRowGap,
  spacingRowGapAtLarge: spacingRowGapAtLarge,
  spacingGridMarginAtMedium: spacingGridMarginAtMedium,
  spacingGridMarginAtLarge: spacingGridMarginAtLarge,
  spacingGridMarginAtExtraLarge: spacingGridMarginAtExtraLarge,
  spacingGutterSm: spacingGutterSm,
  spacingGutterMd: spacingGutterMd,
  spacingGutterLg: spacingGutterLg,
  spacingInsetSm: spacingInsetSm,
  spacingInsetMd: spacingInsetMd,
  spacingInsetLg: spacingInsetLg,
  spacingOutsetSm: spacingOutsetSm,
  spacingOutsetMd: spacingOutsetMd,
  spacingOutsetLg: spacingOutsetLg
};

var rootFontSize$3 = base.rootFontSize;
var typeScaleLatinMinus_2 = rootFontSize$3 * 0.75;
var typeScaleLatinMinus_1 = rootFontSize$3 * 0.875;
var typeScaleLatinBase = rootFontSize$3 * 1;
var typeScaleLatinPlus_1 = rootFontSize$3 * 1.125;
var typeScaleLatinPlus_2 = rootFontSize$3 * 1.25;
var typeScaleLatinPlus_3 = rootFontSize$3 * 1.5;
var typeScaleLatinPlus_4 = rootFontSize$3 * 1.75;
var typeScaleLatinPlus_5 = rootFontSize$3 * 2;
var typeScaleLatinPlus_6 = rootFontSize$3 * 2.25;
var typeScaleLatinPlus_7 = rootFontSize$3 * 2.625;
var typeScaleLatinPlus_8 = rootFontSize$3 * 3;
var typeScaleLatinPlus_9 = rootFontSize$3 * 3.375;
var typeScaleLatinPlus_10 = rootFontSize$3 * 3.75;
var typeScaleCjkMinus_2 = 11;
var typeScaleCjkMinus_1 = 13;
var typeScaleCjkBase = 15;
var typeScaleCjkPlus_1 = 17;
var typeScaleCjkPlus_2 = 19;
var typeScaleCjkPlus_3 = 22;
var typeScaleCjkPlus_4 = 26;
var typeScaleCjkPlus_5 = 30;
var typeScaleCjkPlus_6 = 36;
var typeScaleCjkPlus_7 = 40;
var typeScaleCjkPlus_8 = 45;
var typeScaleCjkPlus_9 = 51;
var typeScaleCjkPlus_10 = 56;
var typeScale = {
  typeScaleLatinMinus_2: typeScaleLatinMinus_2,
  typeScaleLatinMinus_1: typeScaleLatinMinus_1,
  typeScaleLatinBase: typeScaleLatinBase,
  typeScaleLatinPlus_1: typeScaleLatinPlus_1,
  typeScaleLatinPlus_2: typeScaleLatinPlus_2,
  typeScaleLatinPlus_3: typeScaleLatinPlus_3,
  typeScaleLatinPlus_4: typeScaleLatinPlus_4,
  typeScaleLatinPlus_5: typeScaleLatinPlus_5,
  typeScaleLatinPlus_6: typeScaleLatinPlus_6,
  typeScaleLatinPlus_7: typeScaleLatinPlus_7,
  typeScaleLatinPlus_8: typeScaleLatinPlus_8,
  typeScaleLatinPlus_9: typeScaleLatinPlus_9,
  typeScaleLatinPlus_10: typeScaleLatinPlus_10,
  typeScaleCjkMinus_2: typeScaleCjkMinus_2,
  typeScaleCjkMinus_1: typeScaleCjkMinus_1,
  typeScaleCjkBase: typeScaleCjkBase,
  typeScaleCjkPlus_1: typeScaleCjkPlus_1,
  typeScaleCjkPlus_2: typeScaleCjkPlus_2,
  typeScaleCjkPlus_3: typeScaleCjkPlus_3,
  typeScaleCjkPlus_4: typeScaleCjkPlus_4,
  typeScaleCjkPlus_5: typeScaleCjkPlus_5,
  typeScaleCjkPlus_6: typeScaleCjkPlus_6,
  typeScaleCjkPlus_7: typeScaleCjkPlus_7,
  typeScaleCjkPlus_8: typeScaleCjkPlus_8,
  typeScaleCjkPlus_9: typeScaleCjkPlus_9,
  typeScaleCjkPlus_10: typeScaleCjkPlus_10
};

var Z_INDEX_BASE_00 = 0;
var Z_INDEX_BASE_01 = 2;
var Z_INDEX_BASE_02 = 4;
var Z_INDEX_BASE_03 = 6;
var Z_INDEX_BASE_04 = 8;
var Z_INDEX_FLAT_00 = 10;
var Z_INDEX_FLAT_01 = 12;
var Z_INDEX_FLAT_02 = 14;
var Z_INDEX_FLAT_03 = 16;
var Z_INDEX_FLAT_04 = 18;
var Z_INDEX_OVERAY_00 = 20;
var Z_INDEX_OVERAY_01 = 22;
var Z_INDEX_OVERAY_02 = 24;
var Z_INDEX_OVERAY_03 = 26;
var Z_INDEX_OVERAY_04 = 28;
var Z_INDEX_FLOATING_00 = 30;
var Z_INDEX_FLOATING_01 = 32;
var Z_INDEX_FLOATING_02 = 34;
var Z_INDEX_FLOATING_03 = 36;
var Z_INDEX_FLOATING_04 = 38;
var Z_INDEX_HEADER_00 = 40;
var Z_INDEX_HEADER_01 = 42;
var Z_INDEX_HEADER_02 = 44;
var Z_INDEX_HEADER_03 = 46;
var Z_INDEX_HEADER_04 = 48;
var Z_INDEX_MODAL_00 = 50;
var Z_INDEX_MODAL_01 = 52;
var Z_INDEX_MODAL_02 = 54;
var Z_INDEX_MODAL_03 = 56;
var Z_INDEX_MODAL_04 = 58;
var zIndexBase_00 = Z_INDEX_BASE_00;
var zIndexBase_01 = Z_INDEX_BASE_01;
var zIndexBase_02 = Z_INDEX_BASE_02;
var zIndexBase_03 = Z_INDEX_BASE_03;
var zIndexBase_04 = Z_INDEX_BASE_04;
var zIndexFlat_00 = Z_INDEX_FLAT_00;
var zIndexFlat_01 = Z_INDEX_FLAT_01;
var zIndexFlat_02 = Z_INDEX_FLAT_02;
var zIndexFlat_03 = Z_INDEX_FLAT_03;
var zIndexFlat_04 = Z_INDEX_FLAT_04;
var zIndexOverlay_00 = Z_INDEX_OVERAY_00;
var zIndexOverlay_01 = Z_INDEX_OVERAY_01;
var zIndexOverlay_02 = Z_INDEX_OVERAY_02;
var zIndexOverlay_03 = Z_INDEX_OVERAY_03;
var zIndexOverlay_04 = Z_INDEX_OVERAY_04;
var zIndexFloating_00 = Z_INDEX_FLOATING_00;
var zIndexFloating_01 = Z_INDEX_FLOATING_01;
var zIndexFloating_02 = Z_INDEX_FLOATING_02;
var zIndexFloating_03 = Z_INDEX_FLOATING_03;
var zIndexFloating_04 = Z_INDEX_FLOATING_04;
var zIndexHeader_00 = Z_INDEX_HEADER_00;
var zIndexHeader_01 = Z_INDEX_HEADER_01;
var zIndexHeader_02 = Z_INDEX_HEADER_02;
var zIndexHeader_03 = Z_INDEX_HEADER_03;
var zIndexHeader_04 = Z_INDEX_HEADER_04;
var zIndexModal_00 = Z_INDEX_MODAL_00;
var zIndexModal_01 = Z_INDEX_MODAL_01;
var zIndexModal_02 = Z_INDEX_MODAL_02;
var zIndexModal_03 = Z_INDEX_MODAL_03;
var zIndexModal_04 = Z_INDEX_MODAL_04;
var zIndex = {
  zIndexBase_00: zIndexBase_00,
  zIndexBase_01: zIndexBase_01,
  zIndexBase_02: zIndexBase_02,
  zIndexBase_03: zIndexBase_03,
  zIndexBase_04: zIndexBase_04,
  zIndexFlat_00: zIndexFlat_00,
  zIndexFlat_01: zIndexFlat_01,
  zIndexFlat_02: zIndexFlat_02,
  zIndexFlat_03: zIndexFlat_03,
  zIndexFlat_04: zIndexFlat_04,
  zIndexOverlay_00: zIndexOverlay_00,
  zIndexOverlay_01: zIndexOverlay_01,
  zIndexOverlay_02: zIndexOverlay_02,
  zIndexOverlay_03: zIndexOverlay_03,
  zIndexOverlay_04: zIndexOverlay_04,
  zIndexFloating_00: zIndexFloating_00,
  zIndexFloating_01: zIndexFloating_01,
  zIndexFloating_02: zIndexFloating_02,
  zIndexFloating_03: zIndexFloating_03,
  zIndexFloating_04: zIndexFloating_04,
  zIndexHeader_00: zIndexHeader_00,
  zIndexHeader_01: zIndexHeader_01,
  zIndexHeader_02: zIndexHeader_02,
  zIndexHeader_03: zIndexHeader_03,
  zIndexHeader_04: zIndexHeader_04,
  zIndexModal_00: zIndexModal_00,
  zIndexModal_01: zIndexModal_01,
  zIndexModal_02: zIndexModal_02,
  zIndexModal_03: zIndexModal_03,
  zIndexModal_04: zIndexModal_04
};

var SHADOW_FLOATING = '0px 2px 4px rgba(0, 0, 0, 0.2)';
var SHADOW_FLOATING_ER = '0px 0px 10px rgba(0, 0, 0, 0.1)';
var SHADOW_BUTTON_BLACK = '0px 0px 0px 0px #00000000';
var SHADOW_BUTTON_PRIMARY = '0px 0px 0px 0px #00000000';
var SHADOW_OTHER = '0px 2px 2px rgba(0, 0, 0, 0.6)';
var SHADOW_CHIP = '0px 0px 4px rgba(0, 0, 0, 0.8)';
var SHADOW_TEXT_ICON_ER = '0px 1px 1px rgba(0, 0, 0, 0.6)';
var SHADOW_BOTTOM_NAVIGATION_ER = '0px 0px 20px rgba(0, 0, 0, 0.1)';
var shadow_floating = SHADOW_FLOATING;
var shadow_floating_er = SHADOW_FLOATING_ER;
var shadow_button_black = SHADOW_BUTTON_BLACK;
var shadow_button_primary = SHADOW_BUTTON_PRIMARY;
var shadow_other = SHADOW_OTHER;
var shadow_chip = SHADOW_CHIP;
var shadow_text_icon_er = SHADOW_TEXT_ICON_ER;
var shadow_bottom_navigation_er = SHADOW_BOTTOM_NAVIGATION_ER;
var shadow = {
  shadow_floating: shadow_floating,
  shadow_floating_er: shadow_floating_er,
  shadow_button_black: shadow_button_black,
  shadow_button_primary: shadow_button_primary,
  shadow_other: shadow_other,
  shadow_chip: shadow_chip,
  shadow_text_icon_er: shadow_text_icon_er,
  shadow_bottom_navigation_er: shadow_bottom_navigation_er
};

var BORDER_RADIUS_PILL = '999px';
var BORDER_RADIUS_ROUND = '0';
var BORDER_RADIUS_BUTTON_H_32 = '0';
var BORDER_RADIUS_BUTTON_H_40 = '0';
var BORDER_RADIUS_BUTTON_H_50 = '0';
var BORDER_RADIUS_BUTTON_H_52 = '0';
var BORDER_RADIUS_CHIP_LONG_TEXT = '0';
var border_radius_pill = BORDER_RADIUS_PILL;
var border_radius_round = BORDER_RADIUS_ROUND;
var border_radius_button_h_32 = BORDER_RADIUS_BUTTON_H_32;
var border_radius_button_h_40 = BORDER_RADIUS_BUTTON_H_40;
var border_radius_button_h_50 = BORDER_RADIUS_BUTTON_H_50;
var border_radius_button_h_52 = BORDER_RADIUS_BUTTON_H_52;
var border_radius_chip_long_text = BORDER_RADIUS_CHIP_LONG_TEXT;
var borderRadius = {
  border_radius_pill: border_radius_pill,
  border_radius_round: border_radius_round,
  border_radius_button_h_32: border_radius_button_h_32,
  border_radius_button_h_40: border_radius_button_h_40,
  border_radius_button_h_50: border_radius_button_h_50,
  border_radius_button_h_52: border_radius_button_h_52,
  border_radius_chip_long_text: border_radius_chip_long_text
};

var animationDurations = animations.animationDurations,
    animationEasings = animations.animationEasings;
var rootFontSize$4 = base.rootFontSize,
    pageBgColor$1 = base.pageBgColor,
    minTargetSize$1 = base.minTargetSize;
var designTokens = {
  animationDurations: animationDurations,
  animationEasings: animationEasings,
  breakpoints: breakpoints,
  columns: columns,
  dtColor: color,
  font: font,
  fontWeight: fontWeight,
  grid: grid,
  lineHeight: lineHeight,
  letterSpacing: letterSpacing,
  typographyColor: typographyColor,
  rootFontSize: rootFontSize$4,
  pageBgColor: pageBgColor$1,
  minTargetSize: minTargetSize$1,
  spacing: spacing,
  typeScale: typeScale,
  zIndex: zIndex,
  shadow: shadow,
  borderRadius: borderRadius
};
var designTokens_2 = designTokens.animationEasings;
var designTokens_3 = designTokens.breakpoints;
var designTokens_15 = designTokens.spacing;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

var styles = {"badge-text":"fr-ec-badge-text","badgeText":"fr-ec-badge-text","badge-text--large":"fr-ec-badge-text--large","badgeTextLarge":"fr-ec-badge-text--large","badge-text--small":"fr-ec-badge-text--small","badgeTextSmall":"fr-ec-badge-text--small","badge-text--large-color-primary-dark":"fr-ec-badge-text--large-color-primary-dark","badgeTextLargeColorPrimaryDark":"fr-ec-badge-text--large-color-primary-dark","badge-text--small-color-primary-dark":"fr-ec-badge-text--small-color-primary-dark","badgeTextSmallColorPrimaryDark":"fr-ec-badge-text--small-color-primary-dark","badge-text--large-color-primary-light":"fr-ec-badge-text--large-color-primary-light","badgeTextLargeColorPrimaryLight":"fr-ec-badge-text--large-color-primary-light","badge-text--small-color-primary-light":"fr-ec-badge-text--small-color-primary-light","badgeTextSmallColorPrimaryLight":"fr-ec-badge-text--small-color-primary-light"};

var BadgeText = function BadgeText(_a) {
  var Element = _a.element,
      _b = _a.variant,
      variant = _b === void 0 ? 'large' : _b,
      _c = _a.color,
      color = _c === void 0 ? 'primary-dark' : _c,
      className = _a.className,
      props = __rest(_a, ["element", "variant", "color", "className"]);

  return /*#__PURE__*/createElement(Element, __assign({
    className: joinClasses(styles.badgeText, styles["badge-text--" + variant], styles["badge-text--" + variant + "-color-" + color], className)
  }, props));
};
BadgeText.displayName = 'CoreBadgeText';

var iconMap = {
  'account-sharp-32': function accountSharp32() {
    return import('./account-sharp-32-icon-0bc1a083-9717596b.js');
  },
  'account-sharp-filled-32': function accountSharpFilled32() {
    return import('./account-sharp-filled-32-icon-ecd4a573-56e2388b.js');
  },
  'account': function account() {
    return import('./account-icon-5f61ef63-6a849024.js');
  },
  'arrow-down': function arrowDown() {
    return import('./arrow-down-icon-213e3ef3-3998836a.js');
  },
  'attention': function attention() {
    return import('./attention-icon-c0e1607e-e518da38.js');
  },
  'cancel': function cancel() {
    return import('./cancel-icon-9da6274c-703bab57.js');
  },
  'cart': function cart() {
    return import('./cart-icon-333ec8e3-e158335d.js');
  },
  'check-large': function checkLarge() {
    return import('./check-large-icon-ff535f56-fecdeb26.js');
  },
  'chevron-down': function chevronDown() {
    return import('./chevron-down-icon-92f9e93c-4dc5b70f.js');
  },
  'chevron-left': function chevronLeft() {
    return import('./chevron-left-icon-53083b0a-102ff1fe.js');
  },
  'chevron-right-32': function chevronRight32() {
    return import('./chevron-right-32-icon-47c18536-549dcfd1.js');
  },
  'chevron-right': function chevronRight() {
    return import('./chevron-right-icon-77c4b4fe-7aea9924.js');
  },
  'chevron-up': function chevronUp() {
    return import('./chevron-up-icon-73cb2629-0fc79be0.js');
  },
  'close_big-resize-32': function close_bigResize32() {
    return import('./close_big-resize-32-icon-485bbe26-8a576f7f.js');
  },
  'close-big': function closeBig() {
    return import('./close-big-icon-3432f331-ac1733be.js');
  },
  'close': function close() {
    return import('./close-icon-7167bb9a-a6d95b94.js');
  },
  'copy': function copy() {
    return import('./copy-icon-6ccdf9ba-f4427a82.js');
  },
  'coupon': function coupon() {
    return import('./coupon-icon-10880b16-3b620b17.js');
  },
  'delete': function _delete() {
    return import('./delete-icon-eed832da-6fb1196f.js');
  },
  'euro': function euro() {
    return import('./euro-icon-86f62cb5-0d0a9ce6.js');
  },
  'external-link': function externalLink() {
    return import('./external-link-icon-a5a3d16a-1b520768.js');
  },
  'feature-menu': function featureMenu() {
    return import('./feature-menu-icon-e91f77d3-4ef1a518.js');
  },
  'filter-opened': function filterOpened() {
    return import('./filter-opened-icon-fa5e8f8e-5ee0b734.js');
  },
  'filter': function filter() {
    return import('./filter-icon-724992e0-d8964330.js');
  },
  'floor-map': function floorMap() {
    return import('./floor-map-icon-a8fd8efc-2cff731d.js');
  },
  'gift-card': function giftCard() {
    return import('./gift-card-icon-a854472a-df4fcecc.js');
  },
  'gift': function gift() {
    return import('./gift-icon-9f65b453-3661886c.js');
  },
  'global': function global() {
    return import('./global-icon-f0d3e0bf-26f251a6.js');
  },
  'gu-ec-account-sharp-32': function guEcAccountSharp32() {
    return import('./gu-ec-account-sharp-32-icon-6cda6895-00ef2f14.js');
  },
  'gu-ec-account-sharp-filled-32': function guEcAccountSharpFilled32() {
    return import('./gu-ec-account-sharp-filled-32-icon-cb95b7d3-5d81eac2.js');
  },
  'gu-ec-account': function guEcAccount() {
    return import('./gu-ec-account-icon-cffc58f9-a82babc6.js');
  },
  'gu-ec-arrow-down': function guEcArrowDown() {
    return import('./gu-ec-arrow-down-icon-7f3bab1e-db49b7b4.js');
  },
  'gu-ec-attention': function guEcAttention() {
    return import('./gu-ec-attention-icon-7025bf5f-cc57de60.js');
  },
  'gu-ec-cart': function guEcCart() {
    return import('./gu-ec-cart-icon-5e0a9593-339b1ed3.js');
  },
  'gu-ec-check-large': function guEcCheckLarge() {
    return import('./gu-ec-check-large-icon-2a6cb743-57cb85b1.js');
  },
  'gu-ec-chevron-down': function guEcChevronDown() {
    return import('./gu-ec-chevron-down-icon-c33eb3a4-2ba718de.js');
  },
  'gu-ec-chevron-left': function guEcChevronLeft() {
    return import('./gu-ec-chevron-left-icon-1d872e7e-2efe7cda.js');
  },
  'gu-ec-chevron-right-32': function guEcChevronRight32() {
    return import('./gu-ec-chevron-right-32-icon-726157fa-7d2b03b2.js');
  },
  'gu-ec-chevron-right': function guEcChevronRight() {
    return import('./gu-ec-chevron-right-icon-30a194b2-5f548a5a.js');
  },
  'gu-ec-chevron-up': function guEcChevronUp() {
    return import('./gu-ec-chevron-up-icon-55d3e1f5-33ff2f7d.js');
  },
  'gu-ec-close_big-resize-32': function guEcClose_bigResize32() {
    return import('./gu-ec-close_big-resize-32-icon-8ccc22f4-752fc471.js');
  },
  'gu-ec-close-big': function guEcCloseBig() {
    return import('./gu-ec-close-big-icon-5d221ed3-c3a8b21f.js');
  },
  'gu-ec-close': function guEcClose() {
    return import('./gu-ec-close-icon-8505d2f1-4e9a4076.js');
  },
  'gu-ec-copy': function guEcCopy() {
    return import('./gu-ec-copy-icon-1d4a6cda-852d3092.js');
  },
  'gu-ec-coupon': function guEcCoupon() {
    return import('./gu-ec-coupon-icon-e4f7db12-ca9420c8.js');
  },
  'gu-ec-delete': function guEcDelete() {
    return import('./gu-ec-delete-icon-a92c130f-cbc0a564.js');
  },
  'gu-ec-euro': function guEcEuro() {
    return import('./gu-ec-euro-icon-0ec751e7-57995f84.js');
  },
  'gu-ec-external-link': function guEcExternalLink() {
    return import('./gu-ec-external-link-icon-d8a7945f-6da6583b.js');
  },
  'gu-ec-feature-menu': function guEcFeatureMenu() {
    return import('./gu-ec-feature-menu-icon-bc1e53f3-1a521721.js');
  },
  'gu-ec-filter-opened': function guEcFilterOpened() {
    return import('./gu-ec-filter-opened-icon-3cf3bb01-b60f686d.js');
  },
  'gu-ec-filter': function guEcFilter() {
    return import('./gu-ec-filter-icon-8411ea47-fcf5d60c.js');
  },
  'gu-ec-floor-map': function guEcFloorMap() {
    return import('./gu-ec-floor-map-icon-54cf2749-ba218fb7.js');
  },
  'gu-ec-gift-card': function guEcGiftCard() {
    return import('./gu-ec-gift-card-icon-d85aa057-a4d883f1.js');
  },
  'gu-ec-gift': function guEcGift() {
    return import('./gu-ec-gift-icon-89e7a175-da2d5645.js');
  },
  'gu-ec-global': function guEcGlobal() {
    return import('./gu-ec-global-icon-04af930d-0d2a06ee.js');
  },
  'gu-ec-heart-filled': function guEcHeartFilled() {
    return import('./gu-ec-heart-filled-icon-ec29a4a2-c0d7475f.js');
  },
  'gu-ec-heart': function guEcHeart() {
    return import('./gu-ec-heart-icon-2a6fd3fe-a97fbc2a.js');
  },
  'gu-ec-help': function guEcHelp() {
    return import('./gu-ec-help-icon-b37a4c68-7064bc4d.js');
  },
  'gu-ec-home-resize-32': function guEcHomeResize32() {
    return import('./gu-ec-home-resize-32-icon-6f205d43-814becac.js');
  },
  'gu-ec-home-resize-filled-32': function guEcHomeResizeFilled32() {
    return import('./gu-ec-home-resize-filled-32-icon-7162bce8-0aa908bd.js');
  },
  'gu-ec-indicator-carousel': function guEcIndicatorCarousel() {
    return import('./gu-ec-indicator-carousel-icon-d1c254b8-bc0f66eb.js');
  },
  'gu-ec-information': function guEcInformation() {
    return import('./gu-ec-information-icon-fad514ca-0f64de23.js');
  },
  'gu-ec-iqchat-light': function guEcIqchatLight() {
    return import('./gu-ec-iqchat-light-icon-72937d6a-d9864986.js');
  },
  'gu-ec-item': function guEcItem() {
    return import('./gu-ec-item-icon-9d96304f-4a9922ac.js');
  },
  'gu-ec-location': function guEcLocation() {
    return import('./gu-ec-location-icon-7698726f-98c292d1.js');
  },
  'gu-ec-lock-locked': function guEcLockLocked() {
    return import('./gu-ec-lock-locked-icon-b602ed95-ca7b0dbe.js');
  },
  'gu-ec-menu': function guEcMenu() {
    return import('./gu-ec-menu-icon-4dd9aee1-63b31f24.js');
  },
  'gu-ec-minus': function guEcMinus() {
    return import('./gu-ec-minus-icon-d75efd20-f8e57a1e.js');
  },
  'gu-ec-no-video': function guEcNoVideo() {
    return import('./gu-ec-no-video-icon-28ae9f42-9781a914.js');
  },
  'gu-ec-notification-resize': function guEcNotificationResize() {
    return import('./gu-ec-notification-resize-icon-a3c63695-f72ec9ed.js');
  },
  'gu-ec-notification': function guEcNotification() {
    return import('./gu-ec-notification-icon-8518ff7a-63daa1d0.js');
  },
  'gu-ec-o2o': function guEcO2o() {
    return import('./gu-ec-o2o-icon-e138ae45-4dde0266.js');
  },
  'gu-ec-parking': function guEcParking() {
    return import('./gu-ec-parking-icon-cb546805-d2811527.js');
  },
  'gu-ec-pause': function guEcPause() {
    return import('./gu-ec-pause-icon-885c595b-4cb9dea3.js');
  },
  'gu-ec-phone': function guEcPhone() {
    return import('./gu-ec-phone-icon-b597c686-fa9ded8c.js');
  },
  'gu-ec-play': function guEcPlay() {
    return import('./gu-ec-play-icon-efc4b539-f06ad4d7.js');
  },
  'gu-ec-plus': function guEcPlus() {
    return import('./gu-ec-plus-icon-6721123c-a2588eae.js');
  },
  'gu-ec-product-search': function guEcProductSearch() {
    return import('./gu-ec-product-search-icon-281e88a8-11203756.js');
  },
  'gu-ec-product': function guEcProduct() {
    return import('./gu-ec-product-icon-4cbcefd8-a15e7b26.js');
  },
  'gu-ec-prohibited': function guEcProhibited() {
    return import('./gu-ec-prohibited-icon-6f64f05f-d34463c8.js');
  },
  'gu-ec-quotation-end': function guEcQuotationEnd() {
    return import('./gu-ec-quotation-end-icon-3da948b5-a4d502fe.js');
  },
  'gu-ec-quotation-start': function guEcQuotationStart() {
    return import('./gu-ec-quotation-start-icon-1067701c-34149b2a.js');
  },
  'gu-ec-radio-circle-checked': function guEcRadioCircleChecked() {
    return import('./gu-ec-radio-circle-checked-icon-4dbe3d29-87a5cb96.js');
  },
  'gu-ec-radio-circle': function guEcRadioCircle() {
    return import('./gu-ec-radio-circle-icon-80210d0c-05de7f6e.js');
  },
  'gu-ec-rise': function guEcRise() {
    return import('./gu-ec-rise-icon-e033db4f-2af373f8.js');
  },
  'gu-ec-search-resize-32': function guEcSearchResize32() {
    return import('./gu-ec-search-resize-32-icon-6b09cb5c-b04835d0.js');
  },
  'gu-ec-search': function guEcSearch() {
    return import('./gu-ec-search-icon-f0dd1dfc-8977f562.js');
  },
  'gu-ec-semi-order': function guEcSemiOrder() {
    return import('./gu-ec-semi-order-icon-663781de-2ad0c9f5.js');
  },
  'gu-ec-share': function guEcShare() {
    return import('./gu-ec-share-icon-f48ee5e1-34265cee.js');
  },
  'gu-ec-size-chart': function guEcSizeChart() {
    return import('./gu-ec-size-chart-icon-47c8671c-92f1527e.js');
  },
  'gu-ec-size': function guEcSize() {
    return import('./gu-ec-size-icon-66d3b839-dec5ad32.js');
  },
  'gu-ec-sort': function guEcSort() {
    return import('./gu-ec-sort-icon-8fad321e-427f877e.js');
  },
  'gu-ec-star-filled': function guEcStarFilled() {
    return import('./gu-ec-star-filled-icon-bbb984ea-3f43b75d.js');
  },
  'gu-ec-star-half-filled': function guEcStarHalfFilled() {
    return import('./gu-ec-star-half-filled-icon-a31180b0-44c72cac.js');
  },
  'gu-ec-star': function guEcStar() {
    return import('./gu-ec-star-icon-6c689fd6-91186b7c.js');
  },
  'gu-ec-store': function guEcStore() {
    return import('./gu-ec-store-icon-76fb8b78-d750ddf4.js');
  },
  'gu-ec-verified-badge': function guEcVerifiedBadge() {
    return import('./gu-ec-verified-badge-icon-6045ec1f-0bf4bf27.js');
  },
  'gu-ec-visual-search': function guEcVisualSearch() {
    return import('./gu-ec-visual-search-icon-aa748d8a-8aaf13e5.js');
  },
  'gu-ec-warehouse': function guEcWarehouse() {
    return import('./gu-ec-warehouse-icon-2c6c837d-f87b49f8.js');
  },
  'heart-filled': function heartFilled() {
    return import('./heart-filled-icon-79cc7004-e44fc79e.js');
  },
  'heart': function heart() {
    return import('./heart-icon-222772f4-b8d17033.js');
  },
  'help': function help() {
    return import('./help-icon-0c786239-0ff48606.js');
  },
  'home-resize-32': function homeResize32() {
    return import('./home-resize-32-icon-ef648d1f-74aa1ed2.js');
  },
  'home-resize-filled-32': function homeResizeFilled32() {
    return import('./home-resize-filled-32-icon-f5097121-f2373eb2.js');
  },
  'information': function information() {
    return import('./information-icon-60f9bda1-0dd705ae.js');
  },
  'iqchat-light': function iqchatLight() {
    return import('./iqchat-light-icon-6a9a95b7-5065f651.js');
  },
  'item': function item() {
    return import('./item-icon-575d97fe-91d82207.js');
  },
  'location': function location() {
    return import('./location-icon-013a600a-56d022f2.js');
  },
  'lock-locked': function lockLocked() {
    return import('./lock-locked-icon-ababa867-4a2aa995.js');
  },
  'menu': function menu() {
    return import('./menu-icon-cd4cee75-fa41f355.js');
  },
  'minus': function minus() {
    return import('./minus-icon-8499faf7-d59f0d09.js');
  },
  'no-video': function noVideo() {
    return import('./no-video-icon-dd89ec5e-6b8b9252.js');
  },
  'notification-resize': function notificationResize() {
    return import('./notification-resize-icon-ff1e816d-01f2d98a.js');
  },
  'notification': function notification() {
    return import('./notification-icon-1e95058f-4a28bb2b.js');
  },
  'o2o': function o2o() {
    return import('./o2o-icon-d3c1f70e-499e4f16.js');
  },
  'parking': function parking() {
    return import('./parking-icon-c2b7d222-b13f4657.js');
  },
  'pause': function pause() {
    return import('./pause-icon-e98fe723-485b3bec.js');
  },
  'phone': function phone() {
    return import('./phone-icon-0a7df68d-15b0ee31.js');
  },
  'play': function play() {
    return import('./play-icon-e6011a83-ce4416cd.js');
  },
  'plst-ec-account-sharp-32': function plstEcAccountSharp32() {
    return import('./plst-ec-account-sharp-32-icon-a02a4f5e-9dc96405.js');
  },
  'plst-ec-account-sharp-filled-32': function plstEcAccountSharpFilled32() {
    return import('./plst-ec-account-sharp-filled-32-icon-cdf01bef-5911da5f.js');
  },
  'plst-ec-account': function plstEcAccount() {
    return import('./plst-ec-account-icon-d92300b5-60f16caa.js');
  },
  'plst-ec-arrow-down': function plstEcArrowDown() {
    return import('./plst-ec-arrow-down-icon-e9a64bde-6e76db91.js');
  },
  'plst-ec-attention': function plstEcAttention() {
    return import('./plst-ec-attention-icon-ada57d2a-174a6498.js');
  },
  'plst-ec-cancel': function plstEcCancel() {
    return import('./plst-ec-cancel-icon-59944913-6e883fcd.js');
  },
  'plst-ec-cart': function plstEcCart() {
    return import('./plst-ec-cart-icon-82bdaa99-f5c54d04.js');
  },
  'plst-ec-check-large': function plstEcCheckLarge() {
    return import('./plst-ec-check-large-icon-591d6885-5c38380b.js');
  },
  'plst-ec-chevron-down': function plstEcChevronDown() {
    return import('./plst-ec-chevron-down-icon-c7552a9b-78136d04.js');
  },
  'plst-ec-chevron-left': function plstEcChevronLeft() {
    return import('./plst-ec-chevron-left-icon-42d5de50-43102f24.js');
  },
  'plst-ec-chevron-right-32': function plstEcChevronRight32() {
    return import('./plst-ec-chevron-right-32-icon-f0ae9205-06224e26.js');
  },
  'plst-ec-chevron-right': function plstEcChevronRight() {
    return import('./plst-ec-chevron-right-icon-1c59d78d-b4653c22.js');
  },
  'plst-ec-chevron-up': function plstEcChevronUp() {
    return import('./plst-ec-chevron-up-icon-2f69c0a9-5803b396.js');
  },
  'plst-ec-close_big-resize-32': function plstEcClose_bigResize32() {
    return import('./plst-ec-close_big-resize-32-icon-601db0af-3d5ba9c8.js');
  },
  'plst-ec-close-big': function plstEcCloseBig() {
    return import('./plst-ec-close-big-icon-d6de6442-2aef1101.js');
  },
  'plst-ec-close': function plstEcClose() {
    return import('./plst-ec-close-icon-4b1b1beb-8242faea.js');
  },
  'plst-ec-copy': function plstEcCopy() {
    return import('./plst-ec-copy-icon-e03f4bde-f66fcc53.js');
  },
  'plst-ec-coupon': function plstEcCoupon() {
    return import('./plst-ec-coupon-icon-8a33fb00-3b1973d7.js');
  },
  'plst-ec-delete': function plstEcDelete() {
    return import('./plst-ec-delete-icon-d01a96ed-0e55491d.js');
  },
  'plst-ec-euro': function plstEcEuro() {
    return import('./plst-ec-euro-icon-a401891f-7ca33e21.js');
  },
  'plst-ec-external-link': function plstEcExternalLink() {
    return import('./plst-ec-external-link-icon-6d88cc87-3893b604.js');
  },
  'plst-ec-feature-menu': function plstEcFeatureMenu() {
    return import('./plst-ec-feature-menu-icon-e061e71b-527f8f82.js');
  },
  'plst-ec-filter-opened': function plstEcFilterOpened() {
    return import('./plst-ec-filter-opened-icon-97ec3a7c-c318f0c4.js');
  },
  'plst-ec-filter': function plstEcFilter() {
    return import('./plst-ec-filter-icon-bd5b5e14-e07e4d49.js');
  },
  'plst-ec-floor-map': function plstEcFloorMap() {
    return import('./plst-ec-floor-map-icon-e59f188f-56001a02.js');
  },
  'plst-ec-gift-card': function plstEcGiftCard() {
    return import('./plst-ec-gift-card-icon-ac47aa0b-84854c6d.js');
  },
  'plst-ec-gift': function plstEcGift() {
    return import('./plst-ec-gift-icon-57a0ee61-df6473ab.js');
  },
  'plst-ec-global': function plstEcGlobal() {
    return import('./plst-ec-global-icon-372adcff-5c28f6a4.js');
  },
  'plst-ec-heart-filled': function plstEcHeartFilled() {
    return import('./plst-ec-heart-filled-icon-f2c267f0-62588dff.js');
  },
  'plst-ec-heart': function plstEcHeart() {
    return import('./plst-ec-heart-icon-a4e11b65-7b617daf.js');
  },
  'plst-ec-help': function plstEcHelp() {
    return import('./plst-ec-help-icon-da370f92-c54a7c18.js');
  },
  'plst-ec-home-resize-32': function plstEcHomeResize32() {
    return import('./plst-ec-home-resize-32-icon-b708d376-4116aaa9.js');
  },
  'plst-ec-home-resize-filled-32': function plstEcHomeResizeFilled32() {
    return import('./plst-ec-home-resize-filled-32-icon-81b86908-b23402a4.js');
  },
  'plst-ec-indicator-carousel': function plstEcIndicatorCarousel() {
    return import('./plst-ec-indicator-carousel-icon-fd076e19-0f41b077.js');
  },
  'plst-ec-information': function plstEcInformation() {
    return import('./plst-ec-information-icon-fd8bb67f-6706c77b.js');
  },
  'plst-ec-iqchat-light': function plstEcIqchatLight() {
    return import('./plst-ec-iqchat-light-icon-816b646a-d20230e9.js');
  },
  'plst-ec-item': function plstEcItem() {
    return import('./plst-ec-item-icon-561a9fad-a4522a1a.js');
  },
  'plst-ec-list-disc': function plstEcListDisc() {
    return import('./plst-ec-list-disc-icon-5ea2285f-e39f191c.js');
  },
  'plst-ec-location': function plstEcLocation() {
    return import('./plst-ec-location-icon-5be9fee9-c3592a66.js');
  },
  'plst-ec-lock-locked': function plstEcLockLocked() {
    return import('./plst-ec-lock-locked-icon-f195c252-b368f414.js');
  },
  'plst-ec-menu': function plstEcMenu() {
    return import('./plst-ec-menu-icon-ed51ea46-f57ea445.js');
  },
  'plst-ec-minus': function plstEcMinus() {
    return import('./plst-ec-minus-icon-764774e4-a0a99429.js');
  },
  'plst-ec-no-video': function plstEcNoVideo() {
    return import('./plst-ec-no-video-icon-a90e0b1c-d44451cb.js');
  },
  'plst-ec-notification-resize': function plstEcNotificationResize() {
    return import('./plst-ec-notification-resize-icon-239ea971-5f42c3a2.js');
  },
  'plst-ec-notification': function plstEcNotification() {
    return import('./plst-ec-notification-icon-a880604e-7fbf4d01.js');
  },
  'plst-ec-parking': function plstEcParking() {
    return import('./plst-ec-parking-icon-1aedcb3f-b004614a.js');
  },
  'plst-ec-pause': function plstEcPause() {
    return import('./plst-ec-pause-icon-382bb498-a78d9d93.js');
  },
  'plst-ec-phone': function plstEcPhone() {
    return import('./plst-ec-phone-icon-465fc622-0269ed28.js');
  },
  'plst-ec-play': function plstEcPlay() {
    return import('./plst-ec-play-icon-8c658e2e-cc67f286.js');
  },
  'plst-ec-plus': function plstEcPlus() {
    return import('./plst-ec-plus-icon-69dc09c1-62f638bc.js');
  },
  'plst-ec-product-search': function plstEcProductSearch() {
    return import('./plst-ec-product-search-icon-3ec6c2cb-e3157ce2.js');
  },
  'plst-ec-product': function plstEcProduct() {
    return import('./plst-ec-product-icon-ebc0ebef-62d46892.js');
  },
  'plst-ec-prohibited': function plstEcProhibited() {
    return import('./plst-ec-prohibited-icon-de53014a-a5699428.js');
  },
  'plst-ec-quotation-end': function plstEcQuotationEnd() {
    return import('./plst-ec-quotation-end-icon-b61d6b13-98a5c64a.js');
  },
  'plst-ec-quotation-start': function plstEcQuotationStart() {
    return import('./plst-ec-quotation-start-icon-f3a47e3a-6f162718.js');
  },
  'plst-ec-radio-circle-checked': function plstEcRadioCircleChecked() {
    return import('./plst-ec-radio-circle-checked-icon-90e38dd7-54e45396.js');
  },
  'plst-ec-radio-circle': function plstEcRadioCircle() {
    return import('./plst-ec-radio-circle-icon-38412581-2c8cbc59.js');
  },
  'plst-ec-rise': function plstEcRise() {
    return import('./plst-ec-rise-icon-a0408f19-7cd80333.js');
  },
  'plst-ec-search-resize-32': function plstEcSearchResize32() {
    return import('./plst-ec-search-resize-32-icon-1e040568-41485110.js');
  },
  'plst-ec-search': function plstEcSearch() {
    return import('./plst-ec-search-icon-7fa22b38-924bf3bc.js');
  },
  'plst-ec-semi-order': function plstEcSemiOrder() {
    return import('./plst-ec-semi-order-icon-4807cce9-737afb96.js');
  },
  'plst-ec-share': function plstEcShare() {
    return import('./plst-ec-share-icon-482809d5-6d18156d.js');
  },
  'plst-ec-size-chart': function plstEcSizeChart() {
    return import('./plst-ec-size-chart-icon-37045dd4-e5b01dcc.js');
  },
  'plst-ec-size': function plstEcSize() {
    return import('./plst-ec-size-icon-731d4dae-280c4dc1.js');
  },
  'plst-ec-sort': function plstEcSort() {
    return import('./plst-ec-sort-icon-b5b16e1a-a54710df.js');
  },
  'plst-ec-star-filled': function plstEcStarFilled() {
    return import('./plst-ec-star-filled-icon-6560abf2-ea893cc0.js');
  },
  'plst-ec-star-half-filled': function plstEcStarHalfFilled() {
    return import('./plst-ec-star-half-filled-icon-5ebc401b-5b147de7.js');
  },
  'plst-ec-store': function plstEcStore() {
    return import('./plst-ec-store-icon-f460d0a0-2ea37c7b.js');
  },
  'plst-ec-verified-badge': function plstEcVerifiedBadge() {
    return import('./plst-ec-verified-badge-icon-a5df736e-e86f07b6.js');
  },
  'plst-ec-visual-search': function plstEcVisualSearch() {
    return import('./plst-ec-visual-search-icon-bde9e04f-e8710af2.js');
  },
  'plst-ec-warehouse': function plstEcWarehouse() {
    return import('./plst-ec-warehouse-icon-859d36e5-9fac9f4c.js');
  },
  'plus': function plus() {
    return import('./plus-icon-eb4c191e-6f5910da.js');
  },
  'product-search': function productSearch() {
    return import('./product-search-icon-a0c816d7-4bd69e4a.js');
  },
  'product': function product() {
    return import('./product-icon-f24b68ff-813c7f93.js');
  },
  'prohibited': function prohibited() {
    return import('./prohibited-icon-09a49c77-f3779a10.js');
  },
  'question': function question() {
    return import('./question-icon-aaf37a05-80cd0e2e.js');
  },
  'quotation-end': function quotationEnd() {
    return import('./quotation-end-icon-fc8aab35-c40dcc7f.js');
  },
  'quotation-start': function quotationStart() {
    return import('./quotation-start-icon-f67041b7-50ca84e3.js');
  },
  'rise': function rise() {
    return import('./rise-icon-ae220d8f-dd24e6fb.js');
  },
  'search-resize-32': function searchResize32() {
    return import('./search-resize-32-icon-078f7358-cb49badf.js');
  },
  'search': function search() {
    return import('./search-icon-e3922fcd-6d88b892.js');
  },
  'semi-order': function semiOrder() {
    return import('./semi-order-icon-922455c6-f2444c21.js');
  },
  'share': function share() {
    return import('./share-icon-e0a63e47-299765f3.js');
  },
  'size-chart': function sizeChart() {
    return import('./size-chart-icon-0ca0dcb6-6d22b75e.js');
  },
  'size': function size() {
    return import('./size-icon-c79701ab-4b200c76.js');
  },
  'sort': function sort() {
    return import('./sort-icon-21c309c1-1218bd40.js');
  },
  'star-filled': function starFilled() {
    return import('./star-filled-icon-59280370-2044ce62.js');
  },
  'star-half-filled': function starHalfFilled() {
    return import('./star-half-filled-icon-b97a90ff-11873b46.js');
  },
  'store': function store() {
    return import('./store-icon-96afbbe7-026748e5.js');
  },
  'subtract': function subtract() {
    return import('./subtract-icon-95bc4d89-2b5b05bd.js');
  },
  'thumbs-up-toggle': function thumbsUpToggle() {
    return import('./thumbs-up-toggle-icon-5829d27e-8c57d7bc.js');
  },
  'uq-ec-account-sharp-32': function uqEcAccountSharp32() {
    return import('./uq-ec-account-sharp-32-icon-e7f7a32d-e7bb3f50.js');
  },
  'uq-ec-account-sharp-filled-32': function uqEcAccountSharpFilled32() {
    return import('./uq-ec-account-sharp-filled-32-icon-2e45a349-9ce94b9e.js');
  },
  'uq-ec-account': function uqEcAccount() {
    return import('./uq-ec-account-icon-32f76406-77d36be5.js');
  },
  'uq-ec-arrow-down': function uqEcArrowDown() {
    return import('./uq-ec-arrow-down-icon-1b027f9a-45856ce5.js');
  },
  'uq-ec-attention': function uqEcAttention() {
    return import('./uq-ec-attention-icon-87069534-50cd84c2.js');
  },
  'uq-ec-cancel': function uqEcCancel() {
    return import('./uq-ec-cancel-icon-8d391b8d-91737b0e.js');
  },
  'uq-ec-cart': function uqEcCart() {
    return import('./uq-ec-cart-icon-e5db9ec3-dad3ec47.js');
  },
  'uq-ec-check-large': function uqEcCheckLarge() {
    return import('./uq-ec-check-large-icon-83a4b10b-894e1471.js');
  },
  'uq-ec-chevron-down': function uqEcChevronDown() {
    return import('./uq-ec-chevron-down-icon-f0779da7-2f5c5880.js');
  },
  'uq-ec-chevron-left': function uqEcChevronLeft() {
    return import('./uq-ec-chevron-left-icon-f0b0ec12-29ef00a5.js');
  },
  'uq-ec-chevron-right-32': function uqEcChevronRight32() {
    return import('./uq-ec-chevron-right-32-icon-35df4417-5d4b9890.js');
  },
  'uq-ec-chevron-right': function uqEcChevronRight() {
    return import('./uq-ec-chevron-right-icon-1ad20d8c-2a22c1fc.js');
  },
  'uq-ec-chevron-up': function uqEcChevronUp() {
    return import('./uq-ec-chevron-up-icon-459781bd-1b43c522.js');
  },
  'uq-ec-close_big-resize-32': function uqEcClose_bigResize32() {
    return import('./uq-ec-close_big-resize-32-icon-b9e1a379-ac41e5a0.js');
  },
  'uq-ec-close-big': function uqEcCloseBig() {
    return import('./uq-ec-close-big-icon-b69946a8-59714ce9.js');
  },
  'uq-ec-close': function uqEcClose() {
    return import('./uq-ec-close-icon-1c52a50b-9629470f.js');
  },
  'uq-ec-copy': function uqEcCopy() {
    return import('./uq-ec-copy-icon-913b4f92-ee2bb807.js');
  },
  'uq-ec-coupon': function uqEcCoupon() {
    return import('./uq-ec-coupon-icon-e8777d42-90ead998.js');
  },
  'uq-ec-credit-card': function uqEcCreditCard() {
    return import('./uq-ec-credit-card-icon-2afa4a49-0b7d9ad1.js');
  },
  'uq-ec-delete': function uqEcDelete() {
    return import('./uq-ec-delete-icon-9e2258b7-50d63512.js');
  },
  'uq-ec-euro': function uqEcEuro() {
    return import('./uq-ec-euro-icon-3bf21a95-2ec6d95d.js');
  },
  'uq-ec-external-link': function uqEcExternalLink() {
    return import('./uq-ec-external-link-icon-46a763bc-a7afd8a2.js');
  },
  'uq-ec-feature-menu': function uqEcFeatureMenu() {
    return import('./uq-ec-feature-menu-icon-1a8ee59c-5a1c96ca.js');
  },
  'uq-ec-filter-opened': function uqEcFilterOpened() {
    return import('./uq-ec-filter-opened-icon-01dd4e2f-551caeb0.js');
  },
  'uq-ec-filter': function uqEcFilter() {
    return import('./uq-ec-filter-icon-710c273a-a1e397aa.js');
  },
  'uq-ec-floor-map': function uqEcFloorMap() {
    return import('./uq-ec-floor-map-icon-04cd9a18-ccce55f6.js');
  },
  'uq-ec-gift-card': function uqEcGiftCard() {
    return import('./uq-ec-gift-card-icon-29cd5194-e483017a.js');
  },
  'uq-ec-gift': function uqEcGift() {
    return import('./uq-ec-gift-icon-2c8e6daf-0ffe035f.js');
  },
  'uq-ec-global': function uqEcGlobal() {
    return import('./uq-ec-global-icon-de77fe27-69884519.js');
  },
  'uq-ec-heart-filled': function uqEcHeartFilled() {
    return import('./uq-ec-heart-filled-icon-ef30f623-41c95ca9.js');
  },
  'uq-ec-heart': function uqEcHeart() {
    return import('./uq-ec-heart-icon-46a1eb64-acb0ca69.js');
  },
  'uq-ec-help': function uqEcHelp() {
    return import('./uq-ec-help-icon-6cbf3eb1-e009ff30.js');
  },
  'uq-ec-home-resize-32': function uqEcHomeResize32() {
    return import('./uq-ec-home-resize-32-icon-1de20bb0-b0603390.js');
  },
  'uq-ec-home-resize-filled-32': function uqEcHomeResizeFilled32() {
    return import('./uq-ec-home-resize-filled-32-icon-6eeb3ed3-b3f699af.js');
  },
  'uq-ec-information': function uqEcInformation() {
    return import('./uq-ec-information-icon-241fd540-4b2f3f73.js');
  },
  'uq-ec-iqchat-light': function uqEcIqchatLight() {
    return import('./uq-ec-iqchat-light-icon-d8195e5b-af92baa7.js');
  },
  'uq-ec-item': function uqEcItem() {
    return import('./uq-ec-item-icon-899fa085-d23d1325.js');
  },
  'uq-ec-location': function uqEcLocation() {
    return import('./uq-ec-location-icon-98349aa4-54b9f26a.js');
  },
  'uq-ec-lock-locked': function uqEcLockLocked() {
    return import('./uq-ec-lock-locked-icon-64c34b90-31d4bbb5.js');
  },
  'uq-ec-menu': function uqEcMenu() {
    return import('./uq-ec-menu-icon-81259f0a-66ec2e5b.js');
  },
  'uq-ec-minus': function uqEcMinus() {
    return import('./uq-ec-minus-icon-0cc48636-2537f95f.js');
  },
  'uq-ec-no-video': function uqEcNoVideo() {
    return import('./uq-ec-no-video-icon-cc87745b-259c1016.js');
  },
  'uq-ec-notification-resize': function uqEcNotificationResize() {
    return import('./uq-ec-notification-resize-icon-c0cbd1a4-598902c1.js');
  },
  'uq-ec-notification': function uqEcNotification() {
    return import('./uq-ec-notification-icon-4114742e-0d6b4b21.js');
  },
  'uq-ec-o2o': function uqEcO2o() {
    return import('./uq-ec-o2o-icon-bdb299f3-ba5f64f4.js');
  },
  'uq-ec-parking': function uqEcParking() {
    return import('./uq-ec-parking-icon-5413fd4b-8102d240.js');
  },
  'uq-ec-pause': function uqEcPause() {
    return import('./uq-ec-pause-icon-11739fff-4ce9ffd3.js');
  },
  'uq-ec-phone': function uqEcPhone() {
    return import('./uq-ec-phone-icon-b93290c4-fbabadf7.js');
  },
  'uq-ec-play': function uqEcPlay() {
    return import('./uq-ec-play-icon-025f76f0-e17c2bf7.js');
  },
  'uq-ec-plus': function uqEcPlus() {
    return import('./uq-ec-plus-icon-ba33c32c-39e91fba.js');
  },
  'uq-ec-product-search': function uqEcProductSearch() {
    return import('./uq-ec-product-search-icon-4c72b0c6-55820484.js');
  },
  'uq-ec-product': function uqEcProduct() {
    return import('./uq-ec-product-icon-e6e5fb06-23d77b7c.js');
  },
  'uq-ec-prohibited': function uqEcProhibited() {
    return import('./uq-ec-prohibited-icon-bb1ef6be-963bc831.js');
  },
  'uq-ec-quotation-end': function uqEcQuotationEnd() {
    return import('./uq-ec-quotation-end-icon-24d1e404-873e5049.js');
  },
  'uq-ec-quotation-start': function uqEcQuotationStart() {
    return import('./uq-ec-quotation-start-icon-c52c1b9d-f99b7683.js');
  },
  'uq-ec-rise': function uqEcRise() {
    return import('./uq-ec-rise-icon-8d4f991c-29afe661.js');
  },
  'uq-ec-search-resize-32': function uqEcSearchResize32() {
    return import('./uq-ec-search-resize-32-icon-de6677c6-2571fa35.js');
  },
  'uq-ec-search': function uqEcSearch() {
    return import('./uq-ec-search-icon-4eb49829-08be63ae.js');
  },
  'uq-ec-semi-order': function uqEcSemiOrder() {
    return import('./uq-ec-semi-order-icon-831944bc-f28fd81a.js');
  },
  'uq-ec-share': function uqEcShare() {
    return import('./uq-ec-share-icon-f484b643-f3c29db4.js');
  },
  'uq-ec-size-chart': function uqEcSizeChart() {
    return import('./uq-ec-size-chart-icon-321275ac-682b1153.js');
  },
  'uq-ec-size': function uqEcSize() {
    return import('./uq-ec-size-icon-dfd83728-e6cc21b7.js');
  },
  'uq-ec-sort': function uqEcSort() {
    return import('./uq-ec-sort-icon-ddc8a178-c5ad3f6e.js');
  },
  'uq-ec-star-filled': function uqEcStarFilled() {
    return import('./uq-ec-star-filled-icon-0ab809dc-71537f7f.js');
  },
  'uq-ec-star-half-filled': function uqEcStarHalfFilled() {
    return import('./uq-ec-star-half-filled-icon-37442011-bd1e0353.js');
  },
  'uq-ec-star': function uqEcStar() {
    return import('./uq-ec-star-icon-1895e09f-e194e674.js');
  },
  'uq-ec-store': function uqEcStore() {
    return import('./uq-ec-store-icon-869cef3c-1809563f.js');
  },
  'uq-ec-subtract': function uqEcSubtract() {
    return import('./uq-ec-subtract-icon-8af1b3a4-9223361c.js');
  },
  'uq-ec-thumbs-up-toggle': function uqEcThumbsUpToggle() {
    return import('./uq-ec-thumbs-up-toggle-icon-2f5c83df-fe71deec.js');
  },
  'uq-ec-verified-badge': function uqEcVerifiedBadge() {
    return import('./uq-ec-verified-badge-icon-8e868dda-9ae60d78.js');
  },
  'uq-ec-visual-search': function uqEcVisualSearch() {
    return import('./uq-ec-visual-search-icon-df0950ca-50ca560f.js');
  },
  'uq-ec-warehouse': function uqEcWarehouse() {
    return import('./uq-ec-warehouse-icon-96c14b52-93a79d48.js');
  },
  'verified-badge': function verifiedBadge() {
    return import('./verified-badge-icon-88da84bc-f0ba2124.js');
  },
  'visual-search': function visualSearch() {
    return import('./visual-search-icon-2c4e4e89-e9b21496.js');
  },
  'warehouse': function warehouse() {
    return import('./warehouse-icon-73f59bbd-73a79657.js');
  }
};

var styles$1 = {"icon":"fr-ec-icon","icon--default":"fr-ec-icon--default","iconDefault":"fr-ec-icon--default","icon--inline":"fr-ec-icon--inline","iconInline":"fr-ec-icon--inline","icon--fill":"fr-ec-icon--fill","iconFill":"fr-ec-icon--fill","icon--dot":"fr-ec-icon--dot","iconDot":"fr-ec-icon--dot"};

var Icon =
/** @class */
function (_super) {
  __extends(Icon, _super);

  function Icon(props) {
    var _this = _super.call(this, props) || this;

    _this.setDynamicIcons = function (iconName) {
      var size = _this.props.size;

      if (size && parseInt(size, 0) >= 28) {
        switch (iconName) {
          case 'close-big':
            return 'close_big-resize-32';

          case 'notification':
            return 'notification-resize';

          case 'search':
            return 'search-resize-32';

          case 'chevron-right':
            return 'chevron-right-32';

          default:
            return iconName;
        }
      }

      return iconName;
    };

    _this.setIconComponentFromName = function (name) {
      var iconName = _this.setDynamicIcons(name);

      if (typeof iconMap[iconName] === 'function') {
        iconMap[iconName]().then(function (response) {
          _this.setState({
            IconComponent: response["default"]
          });
        })["catch"](function () {
          return 'svg';
        });
      } else {
        // tslint:disable-next-line:no-console
        console.error(new Error("Invalid icon name: " + name));
      }
    };

    _this.state = {
      IconComponent: 'svg'
    };
    return _this;
  }

  Icon.prototype.componentDidMount = function () {
    this.setIconComponentFromName(this.setDynamicIcons(this.props.name));
  };

  Icon.prototype.componentDidUpdate = function (_a) {
    var prevName = _a.name;
    var currName = this.props.name;

    if (currName !== prevName) {
      this.setIconComponentFromName(currName);
    }
  };

  Icon.prototype.render = function () {
    var _a = this.props,
        _b = _a.variant,
        variant = _b === void 0 ? 'default' : _b,
        size = _a.size,
        className = _a.className,
        _c = _a.title,
        title = _c === void 0 ? '' : _c,
        showRedDot = _a.showRedDot;
    var IconComponent = this.state.IconComponent;
    var sizeStyles = size ? {
      width: size,
      height: size
    } : undefined;
    var IconComp =
    /*#__PURE__*/
    // @ts-ignore
    createElement(IconComponent, {
      className: joinClasses(styles$1.icon, styles$1["icon--" + variant], className),
      style: sizeStyles,
      title: title,
      role: title === '' ? 'presentation' : undefined
    });

    if (!showRedDot) {
      return IconComp;
    }

    return /*#__PURE__*/createElement("div", {
      className: styles$1.iconDot
    }, IconComp, showRedDot && /*#__PURE__*/createElement(Badge, {
      variant: 'dot',
      content: 1
    }));
  };

  Icon.displayName = 'CoreIcon';
  Icon.defaultProps = {
    title: '',
    variant: 'default'
  };
  return Icon;
}(Component);

var styles$1$1 = {"badge":"fr-ec-badge","badge--icon-container":"fr-ec-badge--icon-container","badgeIconContainer":"fr-ec-badge--icon-container","badge__icon":"fr-ec-badge__icon","badgeIcon":"fr-ec-badge__icon","badge--dot":"fr-ec-badge--dot","badgeDot":"fr-ec-badge--dot"};

var Badge = function Badge(_a) {
  var content = _a.content,
      _b = _a.className,
      className = _b === void 0 ? '' : _b,
      iconBrand = _a.iconBrand,
      _c = _a.variant,
      variant = _c === void 0 ? "numeric" : _c,
      props = __rest(_a, ["content", "className", "iconBrand", "variant"]);

  var children = '';

  if (typeof content === 'number') {
    children = /*#__PURE__*/createElement(BadgeText, {
      element: "span",
      variant: "small",
      color: "primary-light"
    }, content > 999 ? '999+' : content);
  } else if (typeof content === 'string') {
    children = /*#__PURE__*/createElement(Icon, {
      name: iconBrand ? "" + iconBrand + content : content,
      variant: "inline",
      className: styles$1$1.badgeIcon
    });
  }

  var badgeClassName = typeof content === 'string' ? styles$1$1.badgeIconContainer : '';
  var isDot = variant === 'dot';
  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$1$1.badge, badgeClassName, isDot && styles$1$1.badgeDot, className)
  }, props), !isDot && children);
};
Badge.displayName = 'CoreBadge';

var interactionsStyles = {"link-nav-text-base":"fr-ec-link-nav-text-base","linkNavTextBase":"fr-ec-link-nav-text-base","borderIn":"fr-ec-borderIn","link-nav-text-base--selected":"fr-ec-link-nav-text-base--selected","linkNavTextBaseSelected":"fr-ec-link-nav-text-base--selected","cursor-pointer":"fr-ec-cursor-pointer","cursorPointer":"fr-ec-cursor-pointer","scroll-disabled":"fr-ec-scroll-disabled","scrollDisabled":"fr-ec-scroll-disabled"};

var resetStyles = {"fieldset-reset":"fr-ec-fieldset-reset","fieldsetReset":"fr-ec-fieldset-reset","mark-reset":"fr-ec-mark-reset","markReset":"fr-ec-mark-reset","button-reset":"fr-ec-button-reset","buttonReset":"fr-ec-button-reset","textinput-reset":"fr-ec-textinput-reset","textinputReset":"fr-ec-textinput-reset","max-width-reset":"fr-ec-max-width-reset","maxWidthReset":"fr-ec-max-width-reset"};

var productTileChipWidth = 16;
var productTileChipMargin = 6;
var productTileChipSmallWidth = 10;
var productTileChipSmallMargin = 4;

var styles$2 = {"chip-group-product-tile":"fr-ec-chip-group-product-tile","chipGroupProductTile":"fr-ec-chip-group-product-tile","chip-group-product-tile__fieldset":"fr-ec-chip-group-product-tile__fieldset","chipGroupProductTileFieldset":"fr-ec-chip-group-product-tile__fieldset","chip-group-product-tile__fieldset--expanded":"fr-ec-chip-group-product-tile__fieldset--expanded","chipGroupProductTileFieldsetExpanded":"fr-ec-chip-group-product-tile__fieldset--expanded","chip--product-tile":"fr-ec-chip--product-tile","chipProductTile":"fr-ec-chip--product-tile","chip-group-product-tile__legend":"fr-ec-chip-group-product-tile__legend","chipGroupProductTileLegend":"fr-ec-chip-group-product-tile__legend","chip-group-product-tile__toggle-button":"fr-ec-chip-group-product-tile__toggle-button","chipGroupProductTileToggleButton":"fr-ec-chip-group-product-tile__toggle-button","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","chip-group-product-tile__toggle-button-icon":"fr-ec-chip-group-product-tile__toggle-button-icon","chipGroupProductTileToggleButtonIcon":"fr-ec-chip-group-product-tile__toggle-button-icon","chip-group-product-tile__chip-hidden":"fr-ec-chip-group-product-tile__chip-hidden","chipGroupProductTileChipHidden":"fr-ec-chip-group-product-tile__chip-hidden","chip-group-product-tile__button-wrapper":"fr-ec-chip-group-product-tile__button-wrapper","chipGroupProductTileButtonWrapper":"fr-ec-chip-group-product-tile__button-wrapper","chip-group-product-tile__chip":"fr-ec-chip-group-product-tile__chip","chipGroupProductTileChip":"fr-ec-chip-group-product-tile__chip"};

var chipWithMargin = productTileChipWidth + productTileChipMargin;
var chipSmallWithMargin = productTileChipSmallWidth + productTileChipSmallMargin;

var ChipGroupProductTile =
/** @class */
function (_super) {
  __extends(ChipGroupProductTile, _super);

  function ChipGroupProductTile(props) {
    var _this = _super.call(this, props) || this;

    _this.toggleExpanded = function (event) {
      _this.setState({
        expanded: !_this.isExpanded
      });

      if (_this.props.onExpandedToggle) {
        _this.props.onExpandedToggle(!_this.isExpanded, event);
      }
    };

    _this.setChipGroupWidth = function (contentRect) {
      if (isOfType(contentRect.bounds, 'height')) {
        var _a = contentRect.bounds,
            height = _a.height,
            width = _a.width;

        _this.setState({
          chipGroupDimensions: {
            height: height,
            width: width
          }
        });
      }
    };

    _this.doChipsOverflowGroup = function (chipCount, chipWidth, chipGroupWidth) {
      return chipCount * chipWidth > chipGroupWidth - _this.offset;
    };

    _this.shouldHideChip = function (expanded, isOverflowing, i, chipGroupDimensions) {
      return !expanded && _this.doesChipOverflowGroup(isOverflowing, i, chipGroupDimensions);
    };

    _this.state = {
      chipGroupDimensions: {
        height: -1,
        width: -1
      },
      expanded: _this.props.expanded || false
    };
    _this.offset = 2; // An offset value to stop overflow, if there is any margin or border is applied through css

    return _this;
  }

  Object.defineProperty(ChipGroupProductTile.prototype, "isExpanded", {
    get: function get() {
      return this.props.expanded !== undefined ? this.props.expanded : this.state.expanded;
    },
    enumerable: true,
    configurable: true
  });

  ChipGroupProductTile.prototype.doesChipOverflowGroup = function (isOverflowing, i, chipGroupDimensions) {
    var chipWidth = this.props.containerWidth === 'small' ? productTileChipSmallWidth : productTileChipWidth;
    var chipWithMarginWidth = this.props.containerWidth === 'small' ? chipSmallWithMargin : chipWithMargin;
    return isOverflowing && i >= Math.floor((Math.floor(chipGroupDimensions.width) - chipWidth - this.offset) / chipWithMarginWidth);
  };

  ChipGroupProductTile.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        title = _a.title,
        children = _a.children,
        id = _a.id,
        className = _a.className,
        onFocus = _a.onFocus,
        onBlur = _a.onBlur,
        expandButtonAlt = _a.expandButtonAlt,
        collapseButtonAlt = _a.collapseButtonAlt,
        iconBrand = _a.iconBrand,
        _b = _a.enableInteraction,
        enableInteraction = _b === void 0 ? false : _b,
        props = __rest(_a, ["title", "children", "id", "className", "onFocus", "onBlur", "expandButtonAlt", "collapseButtonAlt", "expanded", "onExpandedToggle", "iconBrand", "enableInteraction"]);

    var chipGroupDimensions = this.state.chipGroupDimensions;
    var chipCount = children.length;
    var isOverflowing = this.doChipsOverflowGroup(chipCount, chipWithMargin, Math.floor(chipGroupDimensions.width - this.offset));
    var chipChildren = children.map(function (chip, i) {
      var chipHidden = _this.shouldHideChip(_this.isExpanded, isOverflowing, i, chipGroupDimensions);

      var hideChipClass = chipHidden ? styles$2.chipGroupProductTileChipHidden : '';
      return /*#__PURE__*/cloneElement(chip, {
        className: joinClasses(chip.props.className, styles$2.chipGroupProductTileChip, hideChipClass),
        disabled: !enableInteraction,
        hidden: chipHidden,
        variant: 'product-tile'
      });
    });
    var buttonIcon = this.isExpanded ? 'minus' : 'plus';
    var legendId = id + "-legend";
    return /*#__PURE__*/createElement(Measure, {
      bounds: true,
      onResize: this.setChipGroupWidth
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/createElement("div", __assign({
        ref: measureRef,
        className: joinClasses(styles$2.chipGroupProductTile, className)
      }, props), /*#__PURE__*/createElement("div", {
        className: styles$2.chipGroupProductTileButtonWrapper
      }, /*#__PURE__*/createElement("button", {
        hidden: !isOverflowing,
        className: joinClasses(styles$2.chipGroupProductTileToggleButton, interactionsStyles.cursorPointer, resetStyles.buttonReset),
        onClick: _this.toggleExpanded,
        "aria-expanded": _this.isExpanded,
        "aria-controls": id,
        "aria-describedby": legendId,
        onFocus: onFocus,
        onBlur: onBlur
      }, /*#__PURE__*/createElement(Icon, {
        title: _this.isExpanded ? collapseButtonAlt : expandButtonAlt,
        name: iconBrand ? "" + iconBrand + buttonIcon : buttonIcon,
        className: styles$2.chipGroupProductTileToggleButtonIcon
      }))), /*#__PURE__*/createElement("fieldset", {
        id: id,
        className: joinClasses(styles$2.chipGroupProductTileFieldset, _this.isExpanded ? styles$2.chipGroupProductTileFieldsetExpanded : '', resetStyles.fieldsetReset)
      }, /*#__PURE__*/createElement("legend", {
        id: legendId,
        className: styles$2.chipGroupProductTileLegend
      }, title), chipChildren));
    });
  };

  ChipGroupProductTile.displayName = 'CoreChipGroupProductTile';
  return ChipGroupProductTile;
}(Component);

var TEXT_PRIMARY_DARK_COLOR$1 = '#1B1B1B';
var TEXT_PRIMARY_LIGHT_COLOR$1 = '#FFFFFF';
var TEXT_SECONDARY_COLOR$1 = '#787878';
var TEXT_DISABLED_COLOR$1 = '#ABABAB';
var TEXT_PROMOTIONAL_COLOR$1 = '#FF0000';
var TEXT_ERROR_COLOR$1 = '#CC0000';
var TEXT_PLACEHOLDER_COLOR$1 = '#787878';
var UI_ATTENTION_DEFAULT_COLOR$1 = '#FF0000';
var UI_ATTENTION_HOVER_COLOR$1 = '#FF5959';
var UI_PRIMARY_DEFAULT_COLOR$1 = '#1B1B1B';
var UI_PRIMARY_HOVER_COLOR$1 = '#6A6A6A';
var UI_SECONDARY_DEFAULT_OUTLINE_COLOR$1 = '#1B1B1B';
var UI_SECONDARY_DEFAULT_BACKGROUND_COLOR$1 = '#FFFFFF';
var UI_SECONDARY_DEFAULT_HOVER_COLOR$1 = '#6A6A6A';
var UI_GLOBAL_BACKGROUND_COLOR$1 = '#F4F4F4';
var UI_GLOBAL_ERROR_COLOR$1 = '#CC0000';
var UI_GLOBAL_FOCUS_COLOR$1 = '#378694';
var UI_GLOBAL_FOCUS_ERROR_COLOR$1 = '#CC0000';
var UI_GLOBAL_DISABLED_COLOR$1 = '#DADADA';
var UI_GLOBAL_BORDER_COLOR$1 = '#DADADA';
var UI_GLOBAL_INTERACTIVE_COLOR$1 = '#ABABAB';
var UI_FORM_INPUTS_BACKGROUND_PASSIVE_COLOR$1 = '#F7F7F7';
var UI_FORM_INPUTS_BACKGROUND_ACTIVE_COLOR$1 = '#FFFFFF';
var SUPPORTING_GENDER_WOMEN_COLOR$1 = '#FF0000';
var SUPPORTING_GENDER_MEN_COLOR$1 = '#000082';
var SUPPORTING_GENDER_KIDS_COLOR$1 = '#50B4F0';
var SUPPORTING_GENDER_BABY_COLOR$1 = '#96C800';
var SUPPORTING_GENDER_GIRLS_COLOR$1 = '#EB64A5';
var SUPPORTING_GENDER_BOYS_COLOR$1 = '#0091D7';
var textPrimaryDarkColor$1 = TEXT_PRIMARY_DARK_COLOR$1;
var textPrimaryLightColor$1 = TEXT_PRIMARY_LIGHT_COLOR$1;
var textSecondaryColor$1 = TEXT_SECONDARY_COLOR$1;
var textDisabledColor$1 = TEXT_DISABLED_COLOR$1;
var textPromotionalColor$1 = TEXT_PROMOTIONAL_COLOR$1;
var textErrorColor$1 = TEXT_ERROR_COLOR$1;
var textPlaceholderColor$1 = TEXT_PLACEHOLDER_COLOR$1;
var uiAttentionDefaultColor$1 = UI_ATTENTION_DEFAULT_COLOR$1;
var uiAttentionHoverColor$1 = UI_ATTENTION_HOVER_COLOR$1;
var uiPrimaryDefaultColor$1 = UI_PRIMARY_DEFAULT_COLOR$1;
var uiPrimaryHoverColor$1 = UI_PRIMARY_HOVER_COLOR$1;
var uiSecondaryDefaultOutlineColor$1 = UI_SECONDARY_DEFAULT_OUTLINE_COLOR$1;
var uiSecondaryDefaultBackgroundColor$1 = UI_SECONDARY_DEFAULT_BACKGROUND_COLOR$1;
var uiSecondaryDefaultHoverColor$1 = UI_SECONDARY_DEFAULT_HOVER_COLOR$1;
var uiGlobalBackgroundColor$1 = UI_GLOBAL_BACKGROUND_COLOR$1;
var uiGlobalErrorColor$1 = UI_GLOBAL_ERROR_COLOR$1;
var uiGlobalFocusColor$1 = UI_GLOBAL_FOCUS_COLOR$1;
var uiGlobalFocusErrorColor$1 = UI_GLOBAL_FOCUS_ERROR_COLOR$1;
var uiGlobalDisabledColor$1 = UI_GLOBAL_DISABLED_COLOR$1;
var uiGlobalBorderColor$1 = UI_GLOBAL_BORDER_COLOR$1;
var uiGlobalInteractiveColor$1 = UI_GLOBAL_INTERACTIVE_COLOR$1;
var uiFormInputsBackgroundPassiveColor$1 = UI_FORM_INPUTS_BACKGROUND_PASSIVE_COLOR$1;
var uiFormInputsBackgroundActiveColor$1 = UI_FORM_INPUTS_BACKGROUND_ACTIVE_COLOR$1;
var supportingGenderWomenColor$1 = SUPPORTING_GENDER_WOMEN_COLOR$1;
var supportingGenderMenColor$1 = SUPPORTING_GENDER_MEN_COLOR$1;
var supportingGenderKidsColor$1 = SUPPORTING_GENDER_KIDS_COLOR$1;
var supportingGenderBabyColor$1 = SUPPORTING_GENDER_BABY_COLOR$1;
var supportingGenderGirlsColor$1 = SUPPORTING_GENDER_GIRLS_COLOR$1;
var supportingGenderBoysColor$1 = SUPPORTING_GENDER_BOYS_COLOR$1;
/* Start OLD color variables, UXDS-1981 To be removed once transition to new variables is done. */

var COLOR_YELLOW$1 = '#ebbe00';
var colorYellow$1 = COLOR_YELLOW$1;
/* End OLD color variables */

var color$1 = {
  textPrimaryDarkColor: textPrimaryDarkColor$1,
  textPrimaryLightColor: textPrimaryLightColor$1,
  textSecondaryColor: textSecondaryColor$1,
  textDisabledColor: textDisabledColor$1,
  textPromotionalColor: textPromotionalColor$1,
  textErrorColor: textErrorColor$1,
  textPlaceholderColor: textPlaceholderColor$1,
  uiAttentionDefaultColor: uiAttentionDefaultColor$1,
  uiAttentionHoverColor: uiAttentionHoverColor$1,
  uiPrimaryDefaultColor: uiPrimaryDefaultColor$1,
  uiPrimaryHoverColor: uiPrimaryHoverColor$1,
  uiSecondaryDefaultOutlineColor: uiSecondaryDefaultOutlineColor$1,
  uiSecondaryDefaultBackgroundColor: uiSecondaryDefaultBackgroundColor$1,
  uiSecondaryDefaultHoverColor: uiSecondaryDefaultHoverColor$1,
  uiGlobalBackgroundColor: uiGlobalBackgroundColor$1,
  uiGlobalErrorColor: uiGlobalErrorColor$1,
  uiGlobalFocusColor: uiGlobalFocusColor$1,
  uiGlobalFocusErrorColor: uiGlobalFocusErrorColor$1,
  uiGlobalDisabledColor: uiGlobalDisabledColor$1,
  uiGlobalBorderColor: uiGlobalBorderColor$1,
  uiGlobalInteractiveColor: uiGlobalInteractiveColor$1,
  uiFormInputsBackgroundPassiveColor: uiFormInputsBackgroundPassiveColor$1,
  uiFormInputsBackgroundActiveColor: uiFormInputsBackgroundActiveColor$1,
  supportingGenderWomenColor: supportingGenderWomenColor$1,
  supportingGenderMenColor: supportingGenderMenColor$1,
  supportingGenderKidsColor: supportingGenderKidsColor$1,
  supportingGenderBabyColor: supportingGenderBabyColor$1,
  supportingGenderGirlsColor: supportingGenderGirlsColor$1,
  supportingGenderBoysColor: supportingGenderBoysColor$1,
  colorYellow: colorYellow$1
};

var DISPLAY1_COLOR_DISABLED$1 = color$1.textDisabledColor;
var DISPLAY1_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var DISPLAY2_COLOR_DISABLED$1 = color$1.textDisabledColor;
var DISPLAY2_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var DISPLAY3_COLOR_DISABLED$1 = color$1.textDisabledColor;
var DISPLAY3_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var DISPLAY4_COLOR_DISABLED$1 = color$1.textDisabledColor;
var DISPLAY4_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var TITLE_COLOR_DISABLED$1 = color$1.textDisabledColor;
var TITLE_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var TITLE_COLOR_PROMOTIONAL$1 = color$1.textPromotionalColor;
var FLAG_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var BADGE_LARGE_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var BADGE_SMALL_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var BADGE_LARGE_COLOR_PRIMARY_LIGHT$1 = color$1.textPrimaryLightColor;
var BADGE_SMALL_COLOR_PRIMARY_LIGHT$1 = color$1.textPrimaryLightColor;
var CAPTION_STANDARD_COLOR_DISABLED$1 = color$1.textDisabledColor;
var CAPTION_STANDARD_COLOR_ERROR$1 = color$1.textErrorColor;
var CAPTION_STANDARD_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var CAPTION_STANDARD_COLOR_PRIMARY_LIGHT$1 = color$1.textPrimaryLightColor;
var CAPTION_STANDARD_COLOR_PROMOTIONAL$1 = color$1.textPromotionalColor;
var CAPTION_STANDARD_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var CAPTION_EMPHASIZED_COLOR_DISABLED$1 = color$1.textDisabledColor;
var CAPTION_EMPHASIZED_COLOR_ERROR$1 = color$1.textErrorColor;
var CAPTION_EMPHASIZED_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var CAPTION_EMPHASIZED_COLOR_PRIMARY_LIGHT$1 = color$1.textPrimaryLightColor;
var CAPTION_EMPHASIZED_COLOR_PROMOTIONAL$1 = color$1.textPromotionalColor;
var CAPTION_EMPHASIZED_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var LABEL_PRIMARY_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var LABEL_PRIMARY_COLOR_PRIMARY_LIGHT$1 = color$1.textPrimaryLightColor;
var LABEL_PRIMARY_COLOR_DISABLED$1 = color$1.textDisabledColor;
var LABEL_PRIMARY_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var LABEL_PRIMARY_COLOR_PRIMARY_HOVER$1 = color$1.uiPrimaryHoverColor;
var LABEL_PRIMARY_COLOR_INTERACTIVE$1 = color$1.uiGlobalInteractiveColor;
var LABEL_SECONDARY_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var LABEL_SECONDARY_COLOR_PRIMARY_LIGHT$1 = color$1.textPrimaryLightColor;
var LABEL_SECONDARY_COLOR_DISABLED$1 = color$1.textDisabledColor;
var LABEL_SECONDARY_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var LABEL_SECONDARY_COLOR_PRIMARY_HOVER$1 = color$1.uiPrimaryHoverColor;
var LABEL_SECONDARY_COLOR_INTERACTIVE$1 = color$1.uiGlobalInteractiveColor;
var LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_LIGHT$1 = color$1.textPrimaryLightColor;
var LABEL_TERTIARY_STANDARD_COLOR_DISABLED$1 = color$1.textDisabledColor;
var LABEL_TERTIARY_STANDARD_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_HOVER$1 = color$1.uiPrimaryHoverColor;
var LABEL_TERTIARY_STANDARD_COLOR_INTERACTIVE$1 = color$1.uiGlobalInteractiveColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_LIGHT$1 = color$1.textPrimaryLightColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_DISABLED$1 = color$1.textDisabledColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_HOVER$1 = color$1.uiPrimaryHoverColor;
var LABEL_TERTIARY_EMPHASIZED_COLOR_INTERACTIVE$1 = color$1.uiGlobalInteractiveColor;
var LABEL_SUPPORTIVE_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var LABEL_SUPPORTIVE_COLOR_PRIMARY_LIGHT$1 = color$1.textPrimaryLightColor;
var LABEL_SUPPORTIVE_COLOR_DISABLED$1 = color$1.textDisabledColor;
var LABEL_SUPPORTIVE_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var LABEL_SUPPORTIVE_COLOR_PRIMARY_HOVER$1 = color$1.uiPrimaryHoverColor;
var LABEL_SUPPORTIVE_COLOR_INTERACTIVE$1 = color$1.uiGlobalInteractiveColor;
var BODY_STANDARD_COLOR_PLACEHOLDER$1 = color$1.textPlaceholderColor;
var BODY_STANDARD_COLOR_DISABLED$1 = color$1.textDisabledColor;
var BODY_STANDARD_COLOR_ERROR$1 = color$1.textErrorColor;
var BODY_STANDARD_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var BODY_STANDARD_COLOR_PROMOTIONAL$1 = color$1.textPromotionalColor;
var BODY_STANDARD_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var BODY_STANDARD_COLOR_PRIMARY_HOVER$1 = color$1.uiPrimaryHoverColor;
var BODY_EMPHASIZED_COLOR_PLACEHOLDER$1 = color$1.textPlaceholderColor;
var BODY_EMPHASIZED_COLOR_DISABLED$1 = color$1.textDisabledColor;
var BODY_EMPHASIZED_COLOR_ERROR$1 = color$1.textErrorColor;
var BODY_EMPHASIZED_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var BODY_EMPHASIZED_COLOR_PROMOTIONAL$1 = color$1.textPromotionalColor;
var BODY_EMPHASIZED_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var BODY_EMPHASIZED_COLOR_PRIMARY_HOVER$1 = color$1.uiPrimaryHoverColor;
var PRICE_SMALL_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var PRICE_SMALL_COLOR_PROMOTIONAL$1 = color$1.textPromotionalColor;
var PRICE_MEDIUM_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var PRICE_MEDIUM_COLOR_PROMOTIONAL$1 = color$1.textPromotionalColor;
var PRICE_LARGE_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var PRICE_LARGE_COLOR_PROMOTIONAL$1 = color$1.textPromotionalColor;
var HINT_COLOR_PRIMARY_DARK$1 = color$1.textPrimaryDarkColor;
var HINT_COLOR_SECONDARY$1 = color$1.textSecondaryColor;
var HINT_COLOR_DISABLED$1 = color$1.textDisabledColor;
var HINT_COLOR_ERROR$1 = color$1.textErrorColor;
var display1_ColorDisabled$1 = DISPLAY1_COLOR_DISABLED$1;
var display1_ColorPrimaryDark$1 = DISPLAY1_COLOR_PRIMARY_DARK$1;
var display2_ColorDisabled$1 = DISPLAY2_COLOR_DISABLED$1;
var display2_ColorPrimaryDark$1 = DISPLAY2_COLOR_PRIMARY_DARK$1;
var display3_ColorDisabled$1 = DISPLAY3_COLOR_DISABLED$1;
var display3_ColorPrimaryDark$1 = DISPLAY3_COLOR_PRIMARY_DARK$1;
var display4_ColorDisabled$1 = DISPLAY4_COLOR_DISABLED$1;
var display4_ColorPrimaryDark$1 = DISPLAY4_COLOR_PRIMARY_DARK$1;
var titleColorDisabled$1 = TITLE_COLOR_DISABLED$1;
var titleColorPrimaryDark$1 = TITLE_COLOR_PRIMARY_DARK$1;
var titleColorPromotional$1 = TITLE_COLOR_PROMOTIONAL$1;
var flagColorSecondary$1 = FLAG_COLOR_SECONDARY$1;
var badgeLargeColorPrimaryDark$1 = BADGE_LARGE_COLOR_PRIMARY_DARK$1;
var badgeSmallColorPrimaryDark$1 = BADGE_SMALL_COLOR_PRIMARY_DARK$1;
var badgeLargeColorPrimaryLight$1 = BADGE_LARGE_COLOR_PRIMARY_LIGHT$1;
var badgeSmallColorPrimaryLight$1 = BADGE_SMALL_COLOR_PRIMARY_LIGHT$1;
var captionStandardColorDisabled$1 = CAPTION_STANDARD_COLOR_DISABLED$1;
var captionStandardColorError$1 = CAPTION_STANDARD_COLOR_ERROR$1;
var captionStandardColorPrimaryDark$1 = CAPTION_STANDARD_COLOR_PRIMARY_DARK$1;
var captionStandardColorPrimaryLight$1 = CAPTION_STANDARD_COLOR_PRIMARY_LIGHT$1;
var captionStandardColorPromotional$1 = CAPTION_STANDARD_COLOR_PROMOTIONAL$1;
var captionStandardColorSecondary$1 = CAPTION_STANDARD_COLOR_SECONDARY$1;
var captionEmphasizedColorDisabled$1 = CAPTION_EMPHASIZED_COLOR_DISABLED$1;
var captionEmphasizedColorError$1 = CAPTION_EMPHASIZED_COLOR_ERROR$1;
var captionEmphasizedColorPrimaryDark$1 = CAPTION_EMPHASIZED_COLOR_PRIMARY_DARK$1;
var captionEmphasizedColorPrimaryLight$1 = CAPTION_EMPHASIZED_COLOR_PRIMARY_LIGHT$1;
var captionEmphasizedColorPromotional$1 = CAPTION_EMPHASIZED_COLOR_PROMOTIONAL$1;
var captionEmphasizedColorSecondary$1 = CAPTION_EMPHASIZED_COLOR_SECONDARY$1;
var labelPrimaryColorPrimaryDark$1 = LABEL_PRIMARY_COLOR_PRIMARY_DARK$1;
var labelPrimaryColorPrimaryLight$1 = LABEL_PRIMARY_COLOR_PRIMARY_LIGHT$1;
var labelPrimaryColorDisabled$1 = LABEL_PRIMARY_COLOR_DISABLED$1;
var labelPrimaryColorSecondary$1 = LABEL_PRIMARY_COLOR_SECONDARY$1;
var labelPrimaryColorPrimaryHover$1 = LABEL_PRIMARY_COLOR_PRIMARY_HOVER$1;
var labelPrimaryColorInteractive$1 = LABEL_PRIMARY_COLOR_INTERACTIVE$1;
var labelSecondaryColorPrimaryDark$1 = LABEL_SECONDARY_COLOR_PRIMARY_DARK$1;
var labelSecondaryColorPrimaryLight$1 = LABEL_SECONDARY_COLOR_PRIMARY_LIGHT$1;
var labelSecondaryColorDisabled$1 = LABEL_SECONDARY_COLOR_DISABLED$1;
var labelSecondaryColorSecondary$1 = LABEL_SECONDARY_COLOR_SECONDARY$1;
var labelSecondaryColorPrimaryHover$1 = LABEL_SECONDARY_COLOR_PRIMARY_HOVER$1;
var labelSecondaryColorInteractive$1 = LABEL_SECONDARY_COLOR_INTERACTIVE$1;
var labelTertiaryStandardColorPrimaryDark$1 = LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_DARK$1;
var labelTertiaryStandardColorPrimaryLight$1 = LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_LIGHT$1;
var labelTertiaryStandardColorDisabled$1 = LABEL_TERTIARY_STANDARD_COLOR_DISABLED$1;
var labelTertiaryStandardColorSecondary$1 = LABEL_TERTIARY_STANDARD_COLOR_SECONDARY$1;
var labelTertiaryStandardColorPrimaryHover$1 = LABEL_TERTIARY_STANDARD_COLOR_PRIMARY_HOVER$1;
var labelTertiaryStandardColorInteractive$1 = LABEL_TERTIARY_STANDARD_COLOR_INTERACTIVE$1;
var labelTertiaryEmphasizedColorPrimaryDark$1 = LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_DARK$1;
var labelTertiaryEmphasizedColorPrimaryLight$1 = LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_LIGHT$1;
var labelTertiaryEmphasizedColorDisabled$1 = LABEL_TERTIARY_EMPHASIZED_COLOR_DISABLED$1;
var labelTertiaryEmphasizedColorSecondary$1 = LABEL_TERTIARY_EMPHASIZED_COLOR_SECONDARY$1;
var labelTertiaryEmphasizedColorPrimaryHover$1 = LABEL_TERTIARY_EMPHASIZED_COLOR_PRIMARY_HOVER$1;
var labelTertiaryEmphasizedColorInteractive$1 = LABEL_TERTIARY_EMPHASIZED_COLOR_INTERACTIVE$1;
var labelSupportiveColorPrimaryDark$1 = LABEL_SUPPORTIVE_COLOR_PRIMARY_DARK$1;
var labelSupportiveColorPrimaryLight$1 = LABEL_SUPPORTIVE_COLOR_PRIMARY_LIGHT$1;
var labelSupportiveColorDisabled$1 = LABEL_SUPPORTIVE_COLOR_DISABLED$1;
var labelSupportiveColorSecondary$1 = LABEL_SUPPORTIVE_COLOR_SECONDARY$1;
var labelSupportiveColorPrimaryHover$1 = LABEL_SUPPORTIVE_COLOR_PRIMARY_HOVER$1;
var labelSupportiveColorInteractive$1 = LABEL_SUPPORTIVE_COLOR_INTERACTIVE$1;
var bodyStandardColorPlaceholder$1 = BODY_STANDARD_COLOR_PLACEHOLDER$1;
var bodyStandardColorDisabled$1 = BODY_STANDARD_COLOR_DISABLED$1;
var bodyStandardColorError$1 = BODY_STANDARD_COLOR_ERROR$1;
var bodyStandardColorPrimaryDark$1 = BODY_STANDARD_COLOR_PRIMARY_DARK$1;
var bodyStandardColorPromotional$1 = BODY_STANDARD_COLOR_PROMOTIONAL$1;
var bodyStandardColorSecondary$1 = BODY_STANDARD_COLOR_SECONDARY$1;
var bodyStandardColorPrimaryHover$1 = BODY_STANDARD_COLOR_PRIMARY_HOVER$1;
var bodyEmphasizedColorPlaceholder$1 = BODY_EMPHASIZED_COLOR_PLACEHOLDER$1;
var bodyEmphasizedColorDisabled$1 = BODY_EMPHASIZED_COLOR_DISABLED$1;
var bodyEmphasizedColorError$1 = BODY_EMPHASIZED_COLOR_ERROR$1;
var bodyEmphasizedColorPrimaryDark$1 = BODY_EMPHASIZED_COLOR_PRIMARY_DARK$1;
var bodyEmphasizedColorPromotional$1 = BODY_EMPHASIZED_COLOR_PROMOTIONAL$1;
var bodyEmphasizedColorSecondary$1 = BODY_EMPHASIZED_COLOR_SECONDARY$1;
var bodyEmphasizedColorPrimaryHover$1 = BODY_EMPHASIZED_COLOR_PRIMARY_HOVER$1;
var priceSmallColorPrimaryDark$1 = PRICE_SMALL_COLOR_PRIMARY_DARK$1;
var priceSmallColorPromotional$1 = PRICE_SMALL_COLOR_PROMOTIONAL$1;
var priceMediumColorPrimaryDark$1 = PRICE_MEDIUM_COLOR_PRIMARY_DARK$1;
var priceMediumColorPromotional$1 = PRICE_MEDIUM_COLOR_PROMOTIONAL$1;
var priceLargeColorPrimaryDark$1 = PRICE_LARGE_COLOR_PRIMARY_DARK$1;
var priceLargeColorPromotional$1 = PRICE_LARGE_COLOR_PROMOTIONAL$1;
var hintColorPrimaryDark$1 = HINT_COLOR_PRIMARY_DARK$1;
var hintColorSecondary$1 = HINT_COLOR_SECONDARY$1;
var hintColorDisabled$1 = HINT_COLOR_DISABLED$1;
var hintColorError$1 = HINT_COLOR_ERROR$1;
var typographyColor$1 = {
  display1_ColorDisabled: display1_ColorDisabled$1,
  display1_ColorPrimaryDark: display1_ColorPrimaryDark$1,
  display2_ColorDisabled: display2_ColorDisabled$1,
  display2_ColorPrimaryDark: display2_ColorPrimaryDark$1,
  display3_ColorDisabled: display3_ColorDisabled$1,
  display3_ColorPrimaryDark: display3_ColorPrimaryDark$1,
  display4_ColorDisabled: display4_ColorDisabled$1,
  display4_ColorPrimaryDark: display4_ColorPrimaryDark$1,
  titleColorDisabled: titleColorDisabled$1,
  titleColorPrimaryDark: titleColorPrimaryDark$1,
  titleColorPromotional: titleColorPromotional$1,
  flagColorSecondary: flagColorSecondary$1,
  badgeLargeColorPrimaryDark: badgeLargeColorPrimaryDark$1,
  badgeSmallColorPrimaryDark: badgeSmallColorPrimaryDark$1,
  badgeLargeColorPrimaryLight: badgeLargeColorPrimaryLight$1,
  badgeSmallColorPrimaryLight: badgeSmallColorPrimaryLight$1,
  captionStandardColorDisabled: captionStandardColorDisabled$1,
  captionStandardColorError: captionStandardColorError$1,
  captionStandardColorPrimaryDark: captionStandardColorPrimaryDark$1,
  captionStandardColorPrimaryLight: captionStandardColorPrimaryLight$1,
  captionStandardColorPromotional: captionStandardColorPromotional$1,
  captionStandardColorSecondary: captionStandardColorSecondary$1,
  captionEmphasizedColorDisabled: captionEmphasizedColorDisabled$1,
  captionEmphasizedColorError: captionEmphasizedColorError$1,
  captionEmphasizedColorPrimaryDark: captionEmphasizedColorPrimaryDark$1,
  captionEmphasizedColorPrimaryLight: captionEmphasizedColorPrimaryLight$1,
  captionEmphasizedColorPromotional: captionEmphasizedColorPromotional$1,
  captionEmphasizedColorSecondary: captionEmphasizedColorSecondary$1,
  labelPrimaryColorPrimaryDark: labelPrimaryColorPrimaryDark$1,
  labelPrimaryColorPrimaryLight: labelPrimaryColorPrimaryLight$1,
  labelPrimaryColorDisabled: labelPrimaryColorDisabled$1,
  labelPrimaryColorSecondary: labelPrimaryColorSecondary$1,
  labelPrimaryColorPrimaryHover: labelPrimaryColorPrimaryHover$1,
  labelPrimaryColorInteractive: labelPrimaryColorInteractive$1,
  labelSecondaryColorPrimaryDark: labelSecondaryColorPrimaryDark$1,
  labelSecondaryColorPrimaryLight: labelSecondaryColorPrimaryLight$1,
  labelSecondaryColorDisabled: labelSecondaryColorDisabled$1,
  labelSecondaryColorSecondary: labelSecondaryColorSecondary$1,
  labelSecondaryColorPrimaryHover: labelSecondaryColorPrimaryHover$1,
  labelSecondaryColorInteractive: labelSecondaryColorInteractive$1,
  labelTertiaryStandardColorPrimaryDark: labelTertiaryStandardColorPrimaryDark$1,
  labelTertiaryStandardColorPrimaryLight: labelTertiaryStandardColorPrimaryLight$1,
  labelTertiaryStandardColorDisabled: labelTertiaryStandardColorDisabled$1,
  labelTertiaryStandardColorSecondary: labelTertiaryStandardColorSecondary$1,
  labelTertiaryStandardColorPrimaryHover: labelTertiaryStandardColorPrimaryHover$1,
  labelTertiaryStandardColorInteractive: labelTertiaryStandardColorInteractive$1,
  labelTertiaryEmphasizedColorPrimaryDark: labelTertiaryEmphasizedColorPrimaryDark$1,
  labelTertiaryEmphasizedColorPrimaryLight: labelTertiaryEmphasizedColorPrimaryLight$1,
  labelTertiaryEmphasizedColorDisabled: labelTertiaryEmphasizedColorDisabled$1,
  labelTertiaryEmphasizedColorSecondary: labelTertiaryEmphasizedColorSecondary$1,
  labelTertiaryEmphasizedColorPrimaryHover: labelTertiaryEmphasizedColorPrimaryHover$1,
  labelTertiaryEmphasizedColorInteractive: labelTertiaryEmphasizedColorInteractive$1,
  labelSupportiveColorPrimaryDark: labelSupportiveColorPrimaryDark$1,
  labelSupportiveColorPrimaryLight: labelSupportiveColorPrimaryLight$1,
  labelSupportiveColorDisabled: labelSupportiveColorDisabled$1,
  labelSupportiveColorSecondary: labelSupportiveColorSecondary$1,
  labelSupportiveColorPrimaryHover: labelSupportiveColorPrimaryHover$1,
  labelSupportiveColorInteractive: labelSupportiveColorInteractive$1,
  bodyStandardColorPlaceholder: bodyStandardColorPlaceholder$1,
  bodyStandardColorDisabled: bodyStandardColorDisabled$1,
  bodyStandardColorError: bodyStandardColorError$1,
  bodyStandardColorPrimaryDark: bodyStandardColorPrimaryDark$1,
  bodyStandardColorPromotional: bodyStandardColorPromotional$1,
  bodyStandardColorSecondary: bodyStandardColorSecondary$1,
  bodyStandardColorPrimaryHover: bodyStandardColorPrimaryHover$1,
  bodyEmphasizedColorPlaceholder: bodyEmphasizedColorPlaceholder$1,
  bodyEmphasizedColorDisabled: bodyEmphasizedColorDisabled$1,
  bodyEmphasizedColorError: bodyEmphasizedColorError$1,
  bodyEmphasizedColorPrimaryDark: bodyEmphasizedColorPrimaryDark$1,
  bodyEmphasizedColorPromotional: bodyEmphasizedColorPromotional$1,
  bodyEmphasizedColorSecondary: bodyEmphasizedColorSecondary$1,
  bodyEmphasizedColorPrimaryHover: bodyEmphasizedColorPrimaryHover$1,
  priceSmallColorPrimaryDark: priceSmallColorPrimaryDark$1,
  priceSmallColorPromotional: priceSmallColorPromotional$1,
  priceMediumColorPrimaryDark: priceMediumColorPrimaryDark$1,
  priceMediumColorPromotional: priceMediumColorPromotional$1,
  priceLargeColorPrimaryDark: priceLargeColorPrimaryDark$1,
  priceLargeColorPromotional: priceLargeColorPromotional$1,
  hintColorPrimaryDark: hintColorPrimaryDark$1,
  hintColorSecondary: hintColorSecondary$1,
  hintColorDisabled: hintColorDisabled$1,
  hintColorError: hintColorError$1
};

var jsEnvVariables = {
  color: color$1,
  typographyColor: typographyColor$1
};
var jsEnvVariables_1 = jsEnvVariables.color;

var styles$3 = {"graph":"fr-ec-graph","graph__headings":"fr-ec-graph__headings","graphHeadings":"fr-ec-graph__headings","graph-indicator":"fr-ec-graph-indicator","graphIndicator":"fr-ec-graph-indicator","graph-item__bar":"fr-ec-graph-item__bar","graphItemBar":"fr-ec-graph-item__bar","graph-item__icon":"fr-ec-graph-item__icon","graphItemIcon":"fr-ec-graph-item__icon","graph-item__col":"fr-ec-graph-item__col","graphItemCol":"fr-ec-graph-item__col","graph-item__first-of-type":"fr-ec-graph-item__first-of-type","graphItemFirstOfType":"fr-ec-graph-item__first-of-type","graph-item__last-of-type":"fr-ec-graph-item__last-of-type","graphItemLastOfType":"fr-ec-graph-item__last-of-type","graph-item__label":"fr-ec-graph-item__label","graphItemLabel":"fr-ec-graph-item__label","graph-item__indicator":"fr-ec-graph-item__indicator","graphItemIndicator":"fr-ec-graph-item__indicator","graph-item__value":"fr-ec-graph-item__value","graphItemValue":"fr-ec-graph-item__value","graph-item__label-padding":"fr-ec-graph-item__label-padding","graphItemLabelPadding":"fr-ec-graph-item__label-padding"};

var GraphIndicator = function GraphIndicator(_a) {
  var _b = _a.value,
      value = _b === void 0 ? 0 : _b;
  var percentage = (value * 100).toFixed(2) + "%";
  var barColor = value ? jsEnvVariables_1.textPrimaryDarkColor : 'transparent';
  return /*#__PURE__*/createElement("div", {
    "aria-label": percentage,
    className: styles$3.graphIndicator,
    style: {
      backgroundImage: "linear-gradient(90deg, " + barColor + " " + percentage + ", transparent " + percentage + ")"
    }
  });
};
GraphIndicator.displayName = 'CoreGraphIndicator';

var styles$4 = {"actionable-content":"fr-ec-actionable-content","actionableContent":"fr-ec-actionable-content","actionable-content--with-link-text":"fr-ec-actionable-content--with-link-text","actionableContentWithLinkText":"fr-ec-actionable-content--with-link-text","actionable-content__content--default":"fr-ec-actionable-content__content--default","actionableContentContentDefault":"fr-ec-actionable-content__content--default","actionable-content__content--button-icon":"fr-ec-actionable-content__content--button-icon","actionableContentContentButtonIcon":"fr-ec-actionable-content__content--button-icon","actionable-content__content--link-text":"fr-ec-actionable-content__content--link-text","actionableContentContentLinkText":"fr-ec-actionable-content__content--link-text","actionable-content__actions--default":"fr-ec-actionable-content__actions--default","actionableContentActionsDefault":"fr-ec-actionable-content__actions--default","actionable-content__actions--button-icon":"fr-ec-actionable-content__actions--button-icon","actionableContentActionsButtonIcon":"fr-ec-actionable-content__actions--button-icon","actionable-content__actions--link-text":"fr-ec-actionable-content__actions--link-text","actionableContentActionsLinkText":"fr-ec-actionable-content__actions--link-text","product-tile__horizontal_spacing":"fr-ec-product-tile__horizontal_spacing","productTileHorizontalSpacing":"fr-ec-product-tile__horizontal_spacing","product-tile__image":"fr-ec-product-tile__image","productTileImage":"fr-ec-product-tile__image","actionable-content__actions--right-default":"fr-ec-actionable-content__actions--right-default","actionableContentActionsRightDefault":"fr-ec-actionable-content__actions--right-default"};

var ActionableContent = function ActionableContent(_a) {
  var className = _a.className,
      content = _a.content,
      actions = _a.actions,
      _b = _a.actionsPosition,
      actionsPosition = _b === void 0 ? 'right' : _b,
      _c = _a.variant,
      variant = _c === void 0 ? 'default' : _c,
      props = __rest(_a, ["className", "content", "actions", "actionsPosition", "variant"]);

  var actionChild = actions;
  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$4.actionableContent, variant === 'link-text' && styles$4.actionableContentWithLinkText, className)
  }, props), /*#__PURE__*/createElement("div", {
    className: styles$4["actionable-content__content--" + variant]
  }, content), variant === 'default' || variant === 'link-text' && (actionChild === null || actionChild === void 0 ? void 0 : actionChild.type.displayName) === 'CoreLinkText' || variant === 'link-text' && (actionChild === null || actionChild === void 0 ? void 0 : actionChild.type.displayName) === 'LinkText' || variant === 'button-icon' && (actionChild === null || actionChild === void 0 ? void 0 : actionChild.type.displayName) === 'CoreButtonIcon' || variant === 'button-icon' && (actionChild === null || actionChild === void 0 ? void 0 : actionChild.type.displayName) === 'ButtonIcon' ? /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$4["actionable-content__actions--" + variant], actionsPosition === 'right' && variant === 'default' ? styles$4.actionableContentActionsRightDefault : '')
  }, actions) : null);
};
ActionableContent.displayName = 'CoreActionableContent';

var spacingStyles = {"mb-spacing-01":"fr-ec-mb-spacing-01","mbSpacing01":"fr-ec-mb-spacing-01","mb-spacing-02":"fr-ec-mb-spacing-02","mbSpacing02":"fr-ec-mb-spacing-02","mb-spacing-03":"fr-ec-mb-spacing-03","mbSpacing03":"fr-ec-mb-spacing-03","mb-spacing-04":"fr-ec-mb-spacing-04","mbSpacing04":"fr-ec-mb-spacing-04","mb-spacing-05":"fr-ec-mb-spacing-05","mbSpacing05":"fr-ec-mb-spacing-05","mb-spacing-06":"fr-ec-mb-spacing-06","mbSpacing06":"fr-ec-mb-spacing-06","mb-spacing-07":"fr-ec-mb-spacing-07","mbSpacing07":"fr-ec-mb-spacing-07","mb-spacing-08":"fr-ec-mb-spacing-08","mbSpacing08":"fr-ec-mb-spacing-08","mb-spacing-01-sm":"fr-ec-mb-spacing-01-sm","mbSpacing01Sm":"fr-ec-mb-spacing-01-sm","mb-spacing-02-sm":"fr-ec-mb-spacing-02-sm","mbSpacing02Sm":"fr-ec-mb-spacing-02-sm","mb-spacing-03-sm":"fr-ec-mb-spacing-03-sm","mbSpacing03Sm":"fr-ec-mb-spacing-03-sm","mb-spacing-04-sm":"fr-ec-mb-spacing-04-sm","mbSpacing04Sm":"fr-ec-mb-spacing-04-sm","mb-spacing-05-sm":"fr-ec-mb-spacing-05-sm","mbSpacing05Sm":"fr-ec-mb-spacing-05-sm","mb-spacing-06-sm":"fr-ec-mb-spacing-06-sm","mbSpacing06Sm":"fr-ec-mb-spacing-06-sm","mb-spacing-07-sm":"fr-ec-mb-spacing-07-sm","mbSpacing07Sm":"fr-ec-mb-spacing-07-sm","mb-spacing-08-sm":"fr-ec-mb-spacing-08-sm","mbSpacing08Sm":"fr-ec-mb-spacing-08-sm","mb-spacing-01-md":"fr-ec-mb-spacing-01-md","mbSpacing01Md":"fr-ec-mb-spacing-01-md","mb-spacing-02-md":"fr-ec-mb-spacing-02-md","mbSpacing02Md":"fr-ec-mb-spacing-02-md","mb-spacing-03-md":"fr-ec-mb-spacing-03-md","mbSpacing03Md":"fr-ec-mb-spacing-03-md","mb-spacing-04-md":"fr-ec-mb-spacing-04-md","mbSpacing04Md":"fr-ec-mb-spacing-04-md","mb-spacing-05-md":"fr-ec-mb-spacing-05-md","mbSpacing05Md":"fr-ec-mb-spacing-05-md","mb-spacing-06-md":"fr-ec-mb-spacing-06-md","mbSpacing06Md":"fr-ec-mb-spacing-06-md","mb-spacing-07-md":"fr-ec-mb-spacing-07-md","mbSpacing07Md":"fr-ec-mb-spacing-07-md","mb-spacing-08-md":"fr-ec-mb-spacing-08-md","mbSpacing08Md":"fr-ec-mb-spacing-08-md","mb-spacing-01-lg":"fr-ec-mb-spacing-01-lg","mbSpacing01Lg":"fr-ec-mb-spacing-01-lg","mb-spacing-02-lg":"fr-ec-mb-spacing-02-lg","mbSpacing02Lg":"fr-ec-mb-spacing-02-lg","mb-spacing-03-lg":"fr-ec-mb-spacing-03-lg","mbSpacing03Lg":"fr-ec-mb-spacing-03-lg","mb-spacing-04-lg":"fr-ec-mb-spacing-04-lg","mbSpacing04Lg":"fr-ec-mb-spacing-04-lg","mb-spacing-05-lg":"fr-ec-mb-spacing-05-lg","mbSpacing05Lg":"fr-ec-mb-spacing-05-lg","mb-spacing-06-lg":"fr-ec-mb-spacing-06-lg","mbSpacing06Lg":"fr-ec-mb-spacing-06-lg","mb-spacing-07-lg":"fr-ec-mb-spacing-07-lg","mbSpacing07Lg":"fr-ec-mb-spacing-07-lg","mb-spacing-08-lg":"fr-ec-mb-spacing-08-lg","mbSpacing08Lg":"fr-ec-mb-spacing-08-lg","mt-spacing-01":"fr-ec-mt-spacing-01","mtSpacing01":"fr-ec-mt-spacing-01","mt-spacing-02":"fr-ec-mt-spacing-02","mtSpacing02":"fr-ec-mt-spacing-02","mt-spacing-03":"fr-ec-mt-spacing-03","mtSpacing03":"fr-ec-mt-spacing-03","mt-spacing-04":"fr-ec-mt-spacing-04","mtSpacing04":"fr-ec-mt-spacing-04","mt-spacing-05":"fr-ec-mt-spacing-05","mtSpacing05":"fr-ec-mt-spacing-05","mt-spacing-06":"fr-ec-mt-spacing-06","mtSpacing06":"fr-ec-mt-spacing-06","mt-spacing-07":"fr-ec-mt-spacing-07","mtSpacing07":"fr-ec-mt-spacing-07","mt-spacing-08":"fr-ec-mt-spacing-08","mtSpacing08":"fr-ec-mt-spacing-08","mt-spacing-01-sm":"fr-ec-mt-spacing-01-sm","mtSpacing01Sm":"fr-ec-mt-spacing-01-sm","mt-spacing-02-sm":"fr-ec-mt-spacing-02-sm","mtSpacing02Sm":"fr-ec-mt-spacing-02-sm","mt-spacing-03-sm":"fr-ec-mt-spacing-03-sm","mtSpacing03Sm":"fr-ec-mt-spacing-03-sm","mt-spacing-04-sm":"fr-ec-mt-spacing-04-sm","mtSpacing04Sm":"fr-ec-mt-spacing-04-sm","mt-spacing-05-sm":"fr-ec-mt-spacing-05-sm","mtSpacing05Sm":"fr-ec-mt-spacing-05-sm","mt-spacing-06-sm":"fr-ec-mt-spacing-06-sm","mtSpacing06Sm":"fr-ec-mt-spacing-06-sm","mt-spacing-07-sm":"fr-ec-mt-spacing-07-sm","mtSpacing07Sm":"fr-ec-mt-spacing-07-sm","mt-spacing-08-sm":"fr-ec-mt-spacing-08-sm","mtSpacing08Sm":"fr-ec-mt-spacing-08-sm","mt-spacing-01-md":"fr-ec-mt-spacing-01-md","mtSpacing01Md":"fr-ec-mt-spacing-01-md","mt-spacing-02-md":"fr-ec-mt-spacing-02-md","mtSpacing02Md":"fr-ec-mt-spacing-02-md","mt-spacing-03-md":"fr-ec-mt-spacing-03-md","mtSpacing03Md":"fr-ec-mt-spacing-03-md","mt-spacing-04-md":"fr-ec-mt-spacing-04-md","mtSpacing04Md":"fr-ec-mt-spacing-04-md","mt-spacing-05-md":"fr-ec-mt-spacing-05-md","mtSpacing05Md":"fr-ec-mt-spacing-05-md","mt-spacing-06-md":"fr-ec-mt-spacing-06-md","mtSpacing06Md":"fr-ec-mt-spacing-06-md","mt-spacing-07-md":"fr-ec-mt-spacing-07-md","mtSpacing07Md":"fr-ec-mt-spacing-07-md","mt-spacing-08-md":"fr-ec-mt-spacing-08-md","mtSpacing08Md":"fr-ec-mt-spacing-08-md","mt-spacing-01-lg":"fr-ec-mt-spacing-01-lg","mtSpacing01Lg":"fr-ec-mt-spacing-01-lg","mt-spacing-02-lg":"fr-ec-mt-spacing-02-lg","mtSpacing02Lg":"fr-ec-mt-spacing-02-lg","mt-spacing-03-lg":"fr-ec-mt-spacing-03-lg","mtSpacing03Lg":"fr-ec-mt-spacing-03-lg","mt-spacing-04-lg":"fr-ec-mt-spacing-04-lg","mtSpacing04Lg":"fr-ec-mt-spacing-04-lg","mt-spacing-05-lg":"fr-ec-mt-spacing-05-lg","mtSpacing05Lg":"fr-ec-mt-spacing-05-lg","mt-spacing-06-lg":"fr-ec-mt-spacing-06-lg","mtSpacing06Lg":"fr-ec-mt-spacing-06-lg","mt-spacing-07-lg":"fr-ec-mt-spacing-07-lg","mtSpacing07Lg":"fr-ec-mt-spacing-07-lg","mt-spacing-08-lg":"fr-ec-mt-spacing-08-lg","mtSpacing08Lg":"fr-ec-mt-spacing-08-lg"};

var styles$5 = {"content-alignment":"fr-ec-content-alignment","contentAlignment":"fr-ec-content-alignment","content-alignment--direction-row":"fr-ec-content-alignment--direction-row","contentAlignmentDirectionRow":"fr-ec-content-alignment--direction-row","content-alignment--direction-column":"fr-ec-content-alignment--direction-column","contentAlignmentDirectionColumn":"fr-ec-content-alignment--direction-column","content-alignment--content-flex-start":"fr-ec-content-alignment--content-flex-start","contentAlignmentContentFlexStart":"fr-ec-content-alignment--content-flex-start","content-alignment--content-flex-end":"fr-ec-content-alignment--content-flex-end","contentAlignmentContentFlexEnd":"fr-ec-content-alignment--content-flex-end","content-alignment--content-space-between":"fr-ec-content-alignment--content-space-between","contentAlignmentContentSpaceBetween":"fr-ec-content-alignment--content-space-between","content-alignment--content-center":"fr-ec-content-alignment--content-center","contentAlignmentContentCenter":"fr-ec-content-alignment--content-center","content-alignment--alignment-flex-start":"fr-ec-content-alignment--alignment-flex-start","contentAlignmentAlignmentFlexStart":"fr-ec-content-alignment--alignment-flex-start","content-alignment--alignment-flex-end":"fr-ec-content-alignment--alignment-flex-end","contentAlignmentAlignmentFlexEnd":"fr-ec-content-alignment--alignment-flex-end","content-alignment--alignment-center":"fr-ec-content-alignment--alignment-center","contentAlignmentAlignmentCenter":"fr-ec-content-alignment--alignment-center","content-alignment--alignment-stretch":"fr-ec-content-alignment--alignment-stretch","contentAlignmentAlignmentStretch":"fr-ec-content-alignment--alignment-stretch","content-alignment--alignment-baseline":"fr-ec-content-alignment--alignment-baseline","contentAlignmentAlignmentBaseline":"fr-ec-content-alignment--alignment-baseline","content-alignment--fluid-height":"fr-ec-content-alignment--fluid-height","contentAlignmentFluidHeight":"fr-ec-content-alignment--fluid-height","content-alignment--gap-4":"fr-ec-content-alignment--gap-4","contentAlignmentGap4":"fr-ec-content-alignment--gap-4","content-alignment--gap-8":"fr-ec-content-alignment--gap-8","contentAlignmentGap8":"fr-ec-content-alignment--gap-8","content-alignment--gap-16":"fr-ec-content-alignment--gap-16","contentAlignmentGap16":"fr-ec-content-alignment--gap-16","content-alignment--gap-32":"fr-ec-content-alignment--gap-32","contentAlignmentGap32":"fr-ec-content-alignment--gap-32"};

var ContentAlignment = function ContentAlignment(_a) {
  var Element = _a.element,
      direction = _a.direction,
      _b = _a.justifyContent,
      justifyContent = _b === void 0 ? 'flex-start' : _b,
      _c = _a.alignment,
      alignment = _c === void 0 ? 'stretch' : _c,
      className = _a.className,
      children = _a.children,
      _d = _a.fluidHeight,
      fluidHeight = _d === void 0 ? false : _d,
      gap = _a.gap,
      props = __rest(_a, ["element", "direction", "justifyContent", "alignment", "className", "children", "fluidHeight", "gap"]);

  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign({
      className: joinClasses(styles$5.contentAlignment, styles$5["content-alignment--direction-" + direction], styles$5["content-alignment--content-" + justifyContent], styles$5["content-alignment--alignment-" + alignment], fluidHeight && styles$5.contentAlignmentFluidHeight, gap && styles$5["content-alignment--gap-" + gap], className)
    }, props), children)
  );
};
ContentAlignment.displayName = 'CoreContentAlignment';
ContentAlignment.defaultProps = {
  alignment: 'stretch',
  fluidHeight: false,
  justifyContent: 'flex-start'
};

var textAlignStyles = {"text-align-center":"fr-ec-text-align-center","textAlignCenter":"fr-ec-text-align-center","text-align-left":"fr-ec-text-align-left","textAlignLeft":"fr-ec-text-align-left","text-align-right":"fr-ec-text-align-right","textAlignRight":"fr-ec-text-align-right"};

var textTransformStyles = {"text-transform-all-caps":"fr-ec-text-transform-all-caps","textTransformAllCaps":"fr-ec-text-transform-all-caps","text-transform-normal":"fr-ec-text-transform-normal","textTransformNormal":"fr-ec-text-transform-normal"};

var typographyStyles = {"body--standard":"fr-ec-body--standard","bodyStandard":"fr-ec-body--standard","body--standard-emphasized":"fr-ec-body--standard-emphasized","bodyStandardEmphasized":"fr-ec-body--standard-emphasized","body--small":"fr-ec-body--small","bodySmall":"fr-ec-body--small","body--small-underlined":"fr-ec-body--small-underlined","bodySmallUnderlined":"fr-ec-body--small-underlined","body--small-emphasized":"fr-ec-body--small-emphasized","bodySmallEmphasized":"fr-ec-body--small-emphasized","body--underlined":"fr-ec-body--underlined","bodyUnderlined":"fr-ec-body--underlined","display--display1":"fr-ec-display--display1","displayDisplay1":"fr-ec-display--display1","display--display2":"fr-ec-display--display2","displayDisplay2":"fr-ec-display--display2","display--display3":"fr-ec-display--display3","displayDisplay3":"fr-ec-display--display3","display--display4":"fr-ec-display--display4","displayDisplay4":"fr-ec-display--display4","display--display5":"fr-ec-display--display5","displayDisplay5":"fr-ec-display--display5","display--display1-er":"fr-ec-display--display1-er","displayDisplay1Er":"fr-ec-display--display1-er","label--large":"fr-ec-label--large","labelLarge":"fr-ec-label--large","label--standard":"fr-ec-label--standard","labelStandard":"fr-ec-label--standard","label--standard-emphasized":"fr-ec-label--standard-emphasized","labelStandardEmphasized":"fr-ec-label--standard-emphasized","label--small":"fr-ec-label--small","labelSmall":"fr-ec-label--small","label--small-emphasized":"fr-ec-label--small-emphasized","labelSmallEmphasized":"fr-ec-label--small-emphasized","label--extra-small":"fr-ec-label--extra-small","labelExtraSmall":"fr-ec-label--extra-small","strikethrough":"fr-ec-strikethrough","title--large":"fr-ec-title--large","titleLarge":"fr-ec-title--large","title--large-underlined":"fr-ec-title--large-underlined","titleLargeUnderlined":"fr-ec-title--large-underlined","title--large-emphasized":"fr-ec-title--large-emphasized","titleLargeEmphasized":"fr-ec-title--large-emphasized","title--standard":"fr-ec-title--standard","titleStandard":"fr-ec-title--standard","title--standard-emphasized":"fr-ec-title--standard-emphasized","titleStandardEmphasized":"fr-ec-title--standard-emphasized","title--small":"fr-ec-title--small","titleSmall":"fr-ec-title--small","title--small-emphasized":"fr-ec-title--small-emphasized","titleSmallEmphasized":"fr-ec-title--small-emphasized","title--media-banner-product-name":"fr-ec-title--media-banner-product-name","titleMediaBannerProductName":"fr-ec-title--media-banner-product-name","title--media-banner-category-name":"fr-ec-title--media-banner-category-name","titleMediaBannerCategoryName":"fr-ec-title--media-banner-category-name","flag--large":"fr-ec-flag--large","flagLarge":"fr-ec-flag--large","flag--standard":"fr-ec-flag--standard","flagStandard":"fr-ec-flag--standard","caption--standard":"fr-ec-caption--standard","captionStandard":"fr-ec-caption--standard","caption--emphasized":"fr-ec-caption--emphasized","captionEmphasized":"fr-ec-caption--emphasized","caption--media-banner-copyright":"fr-ec-caption--media-banner-copyright","captionMediaBannerCopyright":"fr-ec-caption--media-banner-copyright","caption--small":"fr-ec-caption--small","captionSmall":"fr-ec-caption--small","caption--extra-small":"fr-ec-caption--extra-small","captionExtraSmall":"fr-ec-caption--extra-small","caption--large":"fr-ec-caption--large","captionLarge":"fr-ec-caption--large","button--large":"fr-ec-button--large","buttonLarge":"fr-ec-button--large","button--small":"fr-ec-button--small","buttonSmall":"fr-ec-button--small","button--emphasized":"fr-ec-button--emphasized","buttonEmphasized":"fr-ec-button--emphasized","button--small-emphasized":"fr-ec-button--small-emphasized","buttonSmallEmphasized":"fr-ec-button--small-emphasized","breadcrumb--standard":"fr-ec-breadcrumb--standard","breadcrumbStandard":"fr-ec-breadcrumb--standard","breadcrumb--underlined":"fr-ec-breadcrumb--underlined","breadcrumbUnderlined":"fr-ec-breadcrumb--underlined","hint-text--standard":"fr-ec-hint-text--standard","hintTextStandard":"fr-ec-hint-text--standard","tab--standard":"fr-ec-tab--standard","tabStandard":"fr-ec-tab--standard","tab--small":"fr-ec-tab--small","tabSmall":"fr-ec-tab--small","form--text":"fr-ec-form--text","formText":"fr-ec-form--text","gender--standard":"fr-ec-gender--standard","genderStandard":"fr-ec-gender--standard","gender--small":"fr-ec-gender--small","genderSmall":"fr-ec-gender--small","chip--standard":"fr-ec-chip--standard","chipStandard":"fr-ec-chip--standard","rating-average":"fr-ec-rating-average","ratingAverage":"fr-ec-rating-average"};

var styles$6 = {"show-for-sr":"fr-ec-show-for-sr","showForSr":"fr-ec-show-for-sr","add-word-break":"fr-ec-add-word-break","addWordBreak":"fr-ec-add-word-break","page-wrapper":"fr-ec-page-wrapper","pageWrapper":"fr-ec-page-wrapper","page-wrapper__first-child":"fr-ec-page-wrapper__first-child","pageWrapperFirstChild":"fr-ec-page-wrapper__first-child"};

var addWordBreak = function addWordBreak(isTrue) {
  return isTrue ? styles$6.addWordBreak : '';
};

var bodyStyles = {"body":"fr-ec-body","body--underlined":"fr-ec-body--underlined","bodyUnderlined":"fr-ec-body--underlined","body--small-underlined":"fr-ec-body--small-underlined","bodySmallUnderlined":"fr-ec-body--small-underlined","body--color-placeholder":"fr-ec-body--color-placeholder","bodyColorPlaceholder":"fr-ec-body--color-placeholder","body--color-disabled":"fr-ec-body--color-disabled","bodyColorDisabled":"fr-ec-body--color-disabled","body--color-error":"fr-ec-body--color-error","bodyColorError":"fr-ec-body--color-error","body--color-primary-dark":"fr-ec-body--color-primary-dark","bodyColorPrimaryDark":"fr-ec-body--color-primary-dark","body--color-promotional":"fr-ec-body--color-promotional","bodyColorPromotional":"fr-ec-body--color-promotional","body--color-secondary":"fr-ec-body--color-secondary","bodyColorSecondary":"fr-ec-body--color-secondary"};

var testId = {
  'data-testid': 'CoreBody'
};
var bodyStyles$1 = {
  small: 'bodySmall',
  'small-emphasized': 'bodySmallEmphasized',
  'small-underlined': 'bodySmallUnderlined',
  standard: 'bodyStandard',
  'standard-emphasized': 'bodyStandardEmphasized',
  underlined: 'bodyUnderlined'
};
var alignmentClass = {
  center: 'textAlignCenter',
  left: 'textAlignLeft',
  right: 'textAlignRight'
};
var Body = function Body(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'standard' : _b,
      _c = _a.color,
      color = _c === void 0 ? 'primary-dark' : _c,
      Element = _a.element,
      _d = _a.textAlign,
      textAlign = _d === void 0 ? 'left' : _d,
      className = _a.className,
      _e = _a.textTransform,
      textTransform = _e === void 0 ? 'normal' : _e,
      _f = _a.wordBreak,
      wordBreak = _f === void 0 ? 'none' : _f,
      strikethrough = _a.strikethrough,
      props = __rest(_a, ["variant", "color", "element", "textAlign", "className", "textTransform", "wordBreak", "strikethrough"]);

  return /*#__PURE__*/createElement(Element, __assign({
    className: joinClasses(bodyStyles.body, bodyStyles["body--color-" + color], variant === 'underlined' && bodyStyles.bodyUnderlined, variant === 'small-underlined' && bodyStyles.bodySmallUnderlined, typographyStyles[bodyStyles$1[variant]], textAlignStyles[alignmentClass[textAlign]], textTransformStyles["text-transform-" + textTransform], addWordBreak(wordBreak === 'break-word'), strikethrough && typographyStyles.strikethrough, className)
  }, props, testId));
};
Body.displayName = 'CoreBody';

var styles$7 = {"caption":"fr-ec-caption","caption--color-primary-dark":"fr-ec-caption--color-primary-dark","captionColorPrimaryDark":"fr-ec-caption--color-primary-dark","caption--color-primary-light":"fr-ec-caption--color-primary-light","captionColorPrimaryLight":"fr-ec-caption--color-primary-light","caption--color-secondary":"fr-ec-caption--color-secondary","captionColorSecondary":"fr-ec-caption--color-secondary","caption--color-error":"fr-ec-caption--color-error","captionColorError":"fr-ec-caption--color-error","caption--color-disabled":"fr-ec-caption--color-disabled","captionColorDisabled":"fr-ec-caption--color-disabled"};

var alignmentClass$1 = {
  center: 'textAlignCenter',
  left: 'textAlignLeft',
  right: 'textAlignRight'
};
var Caption = function Caption(_a) {
  var Element = _a.element,
      _b = _a.variant,
      variant = _b === void 0 ? 'standard' : _b,
      _c = _a.color,
      color = _c === void 0 ? 'primary-dark' : _c,
      _d = _a.textAlign,
      textAlign = _d === void 0 ? 'left' : _d,
      _e = _a.textTransform,
      textTransform = _e === void 0 ? 'normal' : _e,
      className = _a.className,
      _f = _a.wordBreak,
      wordBreak = _f === void 0 ? 'none' : _f,
      strikethrough = _a.strikethrough,
      props = __rest(_a, ["element", "variant", "color", "textAlign", "textTransform", "className", "wordBreak", "strikethrough"]);

  return /*#__PURE__*/createElement(Element, __assign({
    className: joinClasses(styles$7.caption, color === 'disabled' ? styles$7['caption--color-disabled'] : styles$7["caption--color-" + color], textAlignStyles[alignmentClass$1[textAlign]], className, typographyStyles["caption--" + variant], textTransformStyles["text-transform-" + textTransform], addWordBreak(wordBreak === 'break-word'), strikethrough && typographyStyles.strikethrough)
  }, props));
};
Caption.displayName = 'CoreCaption';

var styles$8 = {"title":"fr-ec-title","title--color-primary-dark":"fr-ec-title--color-primary-dark","titleColorPrimaryDark":"fr-ec-title--color-primary-dark","title--color-primary-light":"fr-ec-title--color-primary-light","titleColorPrimaryLight":"fr-ec-title--color-primary-light","title--color-disabled":"fr-ec-title--color-disabled","titleColorDisabled":"fr-ec-title--color-disabled","title--color-promotional":"fr-ec-title--color-promotional","titleColorPromotional":"fr-ec-title--color-promotional"};

var testId$1 = {
  'data-testid': 'CoreTitle'
};
var alignmentClass$2 = {
  center: 'textAlignCenter',
  left: 'textAlignLeft',
  right: 'textAlignRight'
};
var Title = function Title(_a) {
  var Element = _a.element,
      _b = _a.color,
      color = _b === void 0 ? 'primary-dark' : _b,
      _c = _a.variant,
      variant = _c === void 0 ? 'standard' : _c,
      _d = _a.textAlign,
      textAlign = _d === void 0 ? 'left' : _d,
      className = _a.className,
      _e = _a.textTransform,
      textTransform = _e === void 0 ? 'normal' : _e,
      _f = _a.wordBreak,
      wordBreak = _f === void 0 ? 'none' : _f,
      strikethrough = _a.strikethrough,
      props = __rest(_a, ["element", "color", "variant", "textAlign", "className", "textTransform", "wordBreak", "strikethrough"]);

  return /*#__PURE__*/createElement(Element, __assign({
    className: joinClasses(styles$8.title, styles$8["title--color-" + color], typographyStyles["title--" + variant], textAlignStyles[alignmentClass$2[textAlign]], textTransformStyles["text-transform-" + textTransform], addWordBreak(wordBreak === 'break-word'), strikethrough && typographyStyles.strikethrough, className)
  }, props, testId$1));
};
Title.displayName = 'CoreTitle';

var STAR_SIZE = '14px';
var STAR_SIZE_LARGE = '24px';

var styles$9 = {"star--full":"fr-ec-star--full","starFull":"fr-ec-star--full","star--empty":"fr-ec-star--empty","starEmpty":"fr-ec-star--empty","star--half":"fr-ec-star--half","starHalf":"fr-ec-star--half"};

// ★1.0 : ave 0.8-1.2
// ★1.5 : ave 1.3-1.7
// ★2.0 : ave 1.8-2.2
// ★2.5 : ave 2.3-2.7
// ★3.0 : ave 2.8-3.2
// ★3.5 : ave 3.3-3.7
// ★4.0 : ave 3.8-4.2
// ★4.5 : ave 4.3-4.7
// ★5.0 : ave 4.8-5.0

var Star = function Star(_a) {
  var position = _a.position,
      value = _a.value,
      _b = _a.size,
      size = _b === void 0 ? 'small' : _b,
      className = _a.className,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["position", "value", "size", "className", "iconBrand"]);

  var starSize = size === 'large' ? STAR_SIZE_LARGE : STAR_SIZE;
  var emptyStarIcon = /*#__PURE__*/createElement(Icon, __assign({
    name: iconBrand ? iconBrand + "star-filled" : 'star-filled',
    size: starSize,
    className: joinClasses(styles$9.starEmpty, className)
  }, props));
  var halfStarIcon = /*#__PURE__*/createElement(Icon, __assign({
    name: iconBrand ? iconBrand + "star-half-filled" : 'star-half-filled',
    size: starSize,
    className: joinClasses(styles$9.starHalf, className)
  }, props));
  var fullStarIcon = /*#__PURE__*/createElement(Icon, __assign({
    name: iconBrand ? iconBrand + "star-filled" : 'star-filled',
    size: starSize,
    className: joinClasses(styles$9.starFull, className)
  }, props));
  var fixedValue = Number(value.toFixed(1));

  if (position === 0 && fixedValue === 0) {
    return emptyStarIcon;
  }

  if (position === 0 && fixedValue < 0.7) {
    return halfStarIcon;
  }

  if (fixedValue < position + 0.3) {
    return emptyStarIcon;
  }

  if (fixedValue <= position + 0.7) {
    return halfStarIcon;
  }

  return fullStarIcon;
};
Star.defaultProps = {
  size: 'small'
};

var styles$a = {"rating-static":"fr-ec-rating-static","ratingStatic":"fr-ec-rating-static","rating-static__item--small":"fr-ec-rating-static__item--small","ratingStaticItemSmall":"fr-ec-rating-static__item--small","rating-static__item--large":"fr-ec-rating-static__item--large","ratingStaticItemLarge":"fr-ec-rating-static__item--large","rating-static__reviews":"fr-ec-rating-static__reviews","ratingStaticReviews":"fr-ec-rating-static__reviews","rating-static__average-value":"fr-ec-rating-static__average-value","ratingStaticAverageValue":"fr-ec-rating-static__average-value"};

var renderFiveStars = function renderFiveStars(value, variant, iconBrand) {
  if (variant === void 0) {
    variant = 'small';
  }

  return count(5).map(function (i) {
    return /*#__PURE__*/createElement(Star, {
      key: i,
      position: i,
      size: variant,
      value: value,
      iconBrand: iconBrand,
      className: styles$a["rating-static__item--" + variant]
    });
  });
};

var RatingStatic = function RatingStatic(_a) {
  var value = _a.value,
      ariaLabel = _a.ariaLabel,
      children = _a.children,
      className = _a.className,
      _b = _a.variant,
      variant = _b === void 0 ? 'small' : _b,
      iconBrand = _a.iconBrand,
      averageValue = _a.averageValue,
      props = __rest(_a, ["value", "ariaLabel", "children", "className", "variant", "iconBrand", "averageValue"]);

  return /*#__PURE__*/createElement(Fragment, null, typeof value === 'number' && /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$a.ratingStatic, className),
    "aria-label": ariaLabel || value + " out of 5 stars"
  }, props), renderFiveStars(value, variant, iconBrand), averageValue !== undefined && /*#__PURE__*/createElement("div", {
    className: joinClasses(typographyStyles.ratingAverage, styles$a.ratingStaticAverageValue)
  }, averageValue), children && /*#__PURE__*/createElement("div", {
    className: styles$a.ratingStaticReviews
  }, children)));
};
RatingStatic.defaultProps = {
  variant: 'small'
};
RatingStatic.displayName = 'CoreRatingStatic';

var styles$b = {"review":"fr-ec-review","review__grey-text":"fr-ec-review__grey-text","reviewGreyText":"fr-ec-review__grey-text","review__header":"fr-ec-review__header","reviewHeader":"fr-ec-review__header","review__purchase--information":"fr-ec-review__purchase--information","reviewPurchaseInformation":"fr-ec-review__purchase--information","review__user-nickname":"fr-ec-review__user-nickname","reviewUserNickname":"fr-ec-review__user-nickname","review__user-info":"fr-ec-review__user-info","reviewUserInfo":"fr-ec-review__user-info","review__title":"fr-ec-review__title","reviewTitle":"fr-ec-review__title","review__content":"fr-ec-review__content","reviewContent":"fr-ec-review__content","actionable-content":"fr-ec-actionable-content","actionableContent":"fr-ec-actionable-content","review__date":"fr-ec-review__date","reviewDate":"fr-ec-review__date","rating":"fr-ec-rating","actionable-content__actions--default":"fr-ec-actionable-content__actions--default","actionableContentActionsDefault":"fr-ec-actionable-content__actions--default"};

var Review = function Review(_a) {
  var title = _a.title,
      date = _a.date,
      rating = _a.rating,
      purchaseInformation = _a.purchaseInformation,
      content = _a.content,
      customerInformation = _a.customerInformation,
      reviewFeedbackSection = _a.reviewFeedbackSection,
      className = _a.className,
      header = _a.header,
      reviewDetailsSection = _a.reviewDetailsSection,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["title", "date", "rating", "purchaseInformation", "content", "customerInformation", "reviewFeedbackSection", "className", "header", "reviewDetailsSection", "iconBrand"]);

  return /*#__PURE__*/createElement("section", __assign({
    className: joinClasses(styles$b.review, className)
  }, props), /*#__PURE__*/createElement(ActionableContent, {
    actionsPosition: "left",
    content: /*#__PURE__*/createElement(Fragment, null, header && /*#__PURE__*/createElement(Title, {
      element: "h1",
      className: joinClasses(styles$b.reviewHeader, typeof rating === 'number' && spacingStyles.mbSpacing02)
    }, header)),
    actions: /*#__PURE__*/createElement(Caption, {
      element: "span",
      className: joinClasses(styles$b.reviewGreyText, styles$b.reviewDate)
    }, date)
  }), /*#__PURE__*/createElement(RatingStatic, {
    value: rating,
    iconBrand: iconBrand,
    ariaLabel: "rating",
    className: styles$b.rating
  }), purchaseInformation && purchaseInformation.length > 0 && purchaseInformation.map(function (purchaseInfo, index) {
    return purchaseInformation.length === index + 1 ? /*#__PURE__*/createElement(Caption, {
      element: "p",
      key: index,
      className: joinClasses(styles$b.reviewPurchaseInformation, spacingStyles.mbSpacing04)
    }, purchaseInfo.term + ": " + purchaseInfo.description) : /*#__PURE__*/createElement(Caption, {
      element: "p",
      key: index,
      className: styles$b.reviewPurchaseInformation
    }, purchaseInfo.term + ": " + purchaseInfo.description);
  }), title && /*#__PURE__*/createElement(Title, {
    element: "h1",
    className: joinClasses(styles$b.reviewTitle, spacingStyles.mbSpacing02)
  }, title), /*#__PURE__*/createElement(Body, {
    className: joinClasses(styles$b.reviewContent, spacingStyles.mbSpacing04),
    element: "p",
    wordBreak: "break-word"
  }, content), /*#__PURE__*/createElement("div", {
    className: spacingStyles.mbSpacing04
  }, (customerInformation === null || customerInformation === void 0 ? void 0 : customerInformation.nickname) && /*#__PURE__*/createElement(Caption, {
    className: styles$b.reviewUserNickname,
    element: "span",
    variant: "standard",
    color: "secondary"
  }, customerInformation === null || customerInformation === void 0 ? void 0 : customerInformation.nickname), customerInformation.spec.map(function (data, index) {
    return /*#__PURE__*/createElement(Caption, {
      key: index,
      className: joinClasses(styles$b.reviewUserInfo, styles$b.reviewGreyText),
      element: "span"
    }, data);
  })), reviewDetailsSection, /*#__PURE__*/createElement(ContentAlignment, {
    element: "div",
    direction: "row",
    justifyContent: "flex-end"
  }, reviewFeedbackSection));
};
Review.displayName = 'CoreReview';

var styles$c = {"badge-ranking":"fr-ec-badge-ranking","badgeRanking":"fr-ec-badge-ranking"};

var BadgeRanking = function BadgeRanking(_a) {
  var rank = _a.rank,
      _b = _a.ariaLabel,
      ariaLabel = _b === void 0 ? "Rank " + rank : _b,
      className = _a.className,
      props = __rest(_a, ["rank", "ariaLabel", "className"]);

  return /*#__PURE__*/createElement(ContentAlignment, __assign({
    element: 'div',
    justifyContent: 'center',
    direction: 'row',
    alignment: 'center',
    className: joinClasses(styles$c.badgeRanking, spacingStyles.mbSpacing03, className),
    "aria-label": ariaLabel
  }, props), rank);
};
BadgeRanking.displayName = 'CoreBadgeRanking';

var styles$d = {"breadcrumb":"fr-ec-breadcrumb","breadcrumb--underlined":"fr-ec-breadcrumb--underlined","breadcrumbUnderlined":"fr-ec-breadcrumb--underlined","breadcrumb--disabled":"fr-ec-breadcrumb--disabled","breadcrumbDisabled":"fr-ec-breadcrumb--disabled"};

var Breadcrumb = function Breadcrumb(_a) {
  var Element = _a.element,
      _b = _a.variant,
      variant = _b === void 0 ? 'underlined' : _b,
      className = _a.className,
      children = _a.children,
      disabled = _a.disabled,
      ariaLabel = _a.ariaLabel,
      href = _a.href,
      to = _a.to,
      _c = _a.textTransform,
      textTransform = _c === void 0 ? 'normal' : _c,
      _d = _a.gaCategory,
      gaCategory = _d === void 0 ? '' : _d,
      _e = _a.gaLabel,
      gaLabel = _e === void 0 ? '' : _e,
      gaAction = _a.gaAction,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      _f = _a.wordBreak,
      wordBreak = _f === void 0 ? 'none' : _f,
      props = __rest(_a, ["element", "variant", "className", "children", "disabled", "ariaLabel", "href", "to", "textTransform", "gaCategory", "gaLabel", "gaAction", "gaValue", "gaCallback", "wordBreak"]);

  var gaProps = null;

  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };

    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }

  var onClickHandler = function onClickHandler(e) {
    // For event tracking
    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    }
  };

  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign({
      className: joinClasses(styles$d.breadcrumb, typographyStyles["breadcrumb--" + variant], disabled && styles$d.breadcrumbDisabled, interactionsStyles.cursorPointer, Element === 'button' && resetStyles.buttonReset, textTransformStyles["text-transform-" + textTransform], addWordBreak(wordBreak === 'break-word'), className),
      onClick: onClickHandler,
      role: "link",
      "aria-label": ariaLabel || children,
      "aria-disabled": disabled,
      disabled: disabled
    }, !disabled ? {
      href: href,
      to: to
    } : {}, props, gaProps), children)
  );
};
Breadcrumb.displayName = 'CoreBreadcrumb';
Breadcrumb.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var styles$e = {"breadcrumb-group":"fr-ec-breadcrumb-group","breadcrumbGroup":"fr-ec-breadcrumb-group","breadcrumb-group__item":"fr-ec-breadcrumb-group__item","breadcrumbGroupItem":"fr-ec-breadcrumb-group__item","breadcrumb-group-overlay":"fr-ec-breadcrumb-group-overlay","breadcrumbGroupOverlay":"fr-ec-breadcrumb-group-overlay"};

var BreadcrumbGroup = function BreadcrumbGroup(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  var _b = useState(true),
      showOverlay = _b[0],
      setShowOverlay = _b[1];

  var _c = useState(0),
      parentWidth = _c[0],
      setParentWidth = _c[1];

  var _d = useState(false),
      isScrollEnable = _d[0],
      setIsScrollEnable = _d[1];

  var olElement = useRef(null);
  var childLength = React__default.Children.toArray(children).length;
  useEffect(function () {
    var element = olElement.current;
    setIsScrollEnable(element.scrollWidth > element.clientWidth);

    if (element.scrollLeft + element.offsetWidth >= element.scrollWidth - 10) {
      setShowOverlay(false);
    } else {
      setShowOverlay(true);
    }
  }, [parentWidth]);

  var onScroll = function onScroll(event) {
    var target = event.target.closest("." + styles$e.breadcrumbGroup);

    if (target) {
      if (target.scrollLeft + target.offsetWidth >= target.scrollWidth - 10) {
        setShowOverlay(false);
      } else {
        setShowOverlay(true);
      }
    }
  };

  var showOverlayElement = isScrollEnable && showOverlay && parentWidth < designTokens_3.mqMediumScreenMaxWidthLimit;
  return /*#__PURE__*/React__default.createElement(Measure, {
    bounds: true,
    onResize: function onResize(contentRect) {
      if (contentRect.bounds) {
        setParentWidth(contentRect.bounds.width);
      }
    }
  }, function (_a) {
    var measureRef = _a.measureRef;
    return /*#__PURE__*/React__default.createElement("nav", __assign({}, props, {
      ref: measureRef
    }), showOverlayElement && /*#__PURE__*/React__default.createElement("div", {
      className: styles$e.breadcrumbGroupOverlay
    }), /*#__PURE__*/React__default.createElement("ol", {
      ref: olElement,
      className: styles$e.breadcrumbGroup,
      onTouchMove: onScroll
    }, React__default.Children.map(children, function (child, i) {
      return /*#__PURE__*/React__default.createElement("li", {
        className: styles$e.breadcrumbGroupItem,
        key: i
      }, /*#__PURE__*/React__default.cloneElement(child, __assign({}, i === childLength - 1 ? {
        disabled: true,
        element: 'a'
      } : {})));
    })));
  });
};
BreadcrumbGroup.displayName = 'CoreBreadcrumbGroup';

var CmsBreadcrumbs = function CmsBreadcrumbs(_a) {
  var items = _a.items,
      className = _a.className,
      props = __rest(_a, ["items", "className"]);

  return /*#__PURE__*/createElement(BreadcrumbGroup, __assign({
    className: className
  }, props), items);
};
CmsBreadcrumbs.displayName = 'CoreCmsBreadcrumbs';

var buttonStyles = {"button":"fr-ec-button","collection-list-horizontal":"fr-ec-collection-list-horizontal","collectionListHorizontal":"fr-ec-collection-list-horizontal","button--media-position-left":"fr-ec-button--media-position-left","buttonMediaPositionLeft":"fr-ec-button--media-position-left","button--media-position-right":"fr-ec-button--media-position-right","buttonMediaPositionRight":"fr-ec-button--media-position-right","button--media-position-left-en":"fr-ec-button--media-position-left-en","buttonMediaPositionLeftEn":"fr-ec-button--media-position-left-en","button--media-position-right-en":"fr-ec-button--media-position-right-en","buttonMediaPositionRightEn":"fr-ec-button--media-position-right-en","button--media-position-right-ja":"fr-ec-button--media-position-right-ja","buttonMediaPositionRightJa":"fr-ec-button--media-position-right-ja","button--media-position-left-ja":"fr-ec-button--media-position-left-ja","buttonMediaPositionLeftJa":"fr-ec-button--media-position-left-ja","collection-list-horizontal__item":"fr-ec-collection-list-horizontal__item","collectionListHorizontalItem":"fr-ec-collection-list-horizontal__item","collection-list-horizontal--normal":"fr-ec-collection-list-horizontal--normal","collectionListHorizontalNormal":"fr-ec-collection-list-horizontal--normal","image--fixed-height":"fr-ec-image--fixed-height","imageFixedHeight":"fr-ec-image--fixed-height","button--small":"fr-ec-button--small","buttonSmall":"fr-ec-button--small","button--variant-primary":"fr-ec-button--variant-primary","buttonVariantPrimary":"fr-ec-button--variant-primary","label--standard-emphasized-color-primary-dark":"fr-ec-label--standard-emphasized-color-primary-dark","labelStandardEmphasizedColorPrimaryDark":"fr-ec-label--standard-emphasized-color-primary-dark","label--standard-color-primary-dark":"fr-ec-label--standard-color-primary-dark","labelStandardColorPrimaryDark":"fr-ec-label--standard-color-primary-dark","button--fit-to-content":"fr-ec-button--fit-to-content","buttonFitToContent":"fr-ec-button--fit-to-content","button--fit-to-content-small":"fr-ec-button--fit-to-content-small","buttonFitToContentSmall":"fr-ec-button--fit-to-content-small","button--half-width":"fr-ec-button--half-width","buttonHalfWidth":"fr-ec-button--half-width","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn","button--variant-transactional":"fr-ec-button--variant-transactional","buttonVariantTransactional":"fr-ec-button--variant-transactional","button--variant-secondary":"fr-ec-button--variant-secondary","buttonVariantSecondary":"fr-ec-button--variant-secondary","label":"fr-ec-label","icon":"fr-ec-icon","button--variant-third-party":"fr-ec-button--variant-third-party","buttonVariantThirdParty":"fr-ec-button--variant-third-party","button__icon":"fr-ec-button__icon","buttonIcon":"fr-ec-button__icon","button-max-width-reset":"fr-ec-button-max-width-reset","buttonMaxWidthReset":"fr-ec-button-max-width-reset","button--double-text":"fr-ec-button--double-text","buttonDoubleText":"fr-ec-button--double-text"};

var variantToStyle = {
  primary: buttonStyles.buttonVariantPrimary,
  secondary: buttonStyles.buttonVariantSecondary,
  thirdParty: buttonStyles.buttonVariantThirdParty,
  transactional: buttonStyles.buttonVariantTransactional
};
var Button = function Button(_a) {
  var element = _a.element,
      _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      children = _a.children,
      className = _a.className,
      isSmall = _a.isSmall,
      icon = _a.icon,
      width = _a.width,
      href = _a.href,
      _c = _a.target,
      target = _c === void 0 ? '_self' : _c,
      to = _a.to,
      disabled = _a.disabled,
      _d = _a.textTransform,
      textTransform = _d === void 0 ? 'all-caps' : _d,
      _e = _a.gaCategory,
      gaCategory = _e === void 0 ? '' : _e,
      _f = _a.gaLabel,
      gaLabel = _f === void 0 ? '' : _f,
      gaAction = _a.gaAction,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      emphasized = _a.emphasized,
      mediaPosition = _a.mediaPosition,
      _g = _a.wordBreak,
      wordBreak = _g === void 0 ? 'none' : _g,
      isDoubleText = _a.isDoubleText,
      iconBrand = _a.iconBrand,
      thirdPartyBackground = _a.thirdPartyBackground,
      props = __rest(_a, ["element", "variant", "children", "className", "isSmall", "icon", "width", "href", "target", "to", "disabled", "textTransform", "gaCategory", "gaLabel", "gaAction", "gaValue", "gaCallback", "emphasized", "mediaPosition", "wordBreak", "isDoubleText", "iconBrand", "thirdPartyBackground"]);

  var Element = element;
  var buttonStyles$1 = isSmall ? joinClasses(buttonStyles.buttonSmall, typographyStyles.buttonSmall) : typographyStyles.buttonLarge;
  var buttonWidthStyles = width === 'fitContent' ? joinClasses(buttonStyles.buttonFitToContent, isSmall && buttonStyles.buttonFitToContentSmall) : width === 'halfWidth' ? buttonStyles.buttonHalfWidth : '';
  var thirdPartyButtonStyles = variant === 'thirdParty' ? {
    backgroundColor: "#" + thirdPartyBackground
  } : '';

  var getPositionClasses = function getPositionClasses(mediaPositionProp) {
    if (_typeof(mediaPositionProp) === 'object') {
      return joinClasses.apply(void 0, Object.keys(mediaPositionProp).reduce(function (acc, language) {
        var positionClassName = buttonStyles["button--media-position-" + mediaPositionProp[language] + "-" + language];
        return __spreadArrays(acc, [positionClassName]);
      }, []));
    }

    return buttonStyles["button--media-position-" + mediaPositionProp];
  };

  var gaProps = null;

  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };

    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }

  var onClickHandler = function onClickHandler(e) {
    // For event tracking
    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    }
  };

  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign({
      className: joinClasses(buttonStyles.button, mediaPosition && getPositionClasses(mediaPosition), buttonStyles$1, variantToStyle[variant], buttonWidthStyles, interactionsStyles.cursorPointer, buttonStyles.buttonMaxWidthReset, textTransformStyles["text-transform-" + textTransform], emphasized && typographyStyles.buttonEmphasized, addWordBreak(wordBreak === 'break-word'), isDoubleText && buttonStyles.buttonDoubleText, className),
      style: __assign({}, thirdPartyButtonStyles),
      onClick: onClickHandler
    }, !disabled ? {
      href: href,
      target: target,
      to: to
    } : {}, {
      disabled: disabled
    }, gaProps, props), icon && /*#__PURE__*/createElement(Icon, {
      name: iconBrand ? "" + iconBrand + icon : icon,
      variant: "inline",
      className: buttonStyles.buttonIcon
    }), children)
  );
};
Button.displayName = 'CoreButton';
Button.defaultProps = {
  emphasized: false,
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null,
  isSmall: false,
  variant: 'primary',
  width: 'fullWidth'
};

var styles$f = {"button-floating":"fr-ec-button-floating","buttonFloating":"fr-ec-button-floating","button-floating__icon":"fr-ec-button-floating__icon","buttonFloatingIcon":"fr-ec-button-floating__icon","button-floating__label":"fr-ec-button-floating__label","buttonFloatingLabel":"fr-ec-button-floating__label","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn","button-floating__icon-container":"fr-ec-button-floating__icon-container","buttonFloatingIconContainer":"fr-ec-button-floating__icon-container"};

var ButtonFloating = function ButtonFloating(_a) {
  var ariaLabel = _a.ariaLabel,
      children = _a.children,
      className = _a.className,
      Element = _a.element,
      icon = _a.icon,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["ariaLabel", "children", "className", "element", "icon", "iconBrand"]);

  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign({
      className: joinClasses(styles$f.buttonFloating, interactionsStyles.cursorPointer, className)
    }, props), /*#__PURE__*/createElement("div", {
      className: styles$f.buttonFloatingIconContainer
    }, /*#__PURE__*/createElement(Icon, {
      name: iconBrand ? "" + iconBrand + icon : icon,
      className: styles$f.buttonFloatingIcon
    })), /*#__PURE__*/createElement(Caption, {
      element: "span",
      textTransform: "all-caps",
      variant: "small",
      className: styles$f.buttonFloatingLabel,
      "aria-label": ariaLabel
    }, children))
  );
};
ButtonFloating.displayName = 'CoreButtonFloating';

var styles$g = {"label":"fr-ec-label","label--color-primary-dark":"fr-ec-label--color-primary-dark","labelColorPrimaryDark":"fr-ec-label--color-primary-dark","label--color-primary-light":"fr-ec-label--color-primary-light","labelColorPrimaryLight":"fr-ec-label--color-primary-light","label--color-disabled":"fr-ec-label--color-disabled","labelColorDisabled":"fr-ec-label--color-disabled","label--color-secondary":"fr-ec-label--color-secondary","labelColorSecondary":"fr-ec-label--color-secondary"};

var labelStyles = {
  'extra-small': 'labelExtraSmall',
  large: 'labelLarge',
  small: 'labelSmall',
  'small-emphasized': 'labelSmallEmphasized',
  standard: 'labelStandard',
  'standard-emphasized': 'labelStandardEmphasized'
};
var alignmentClass$3 = {
  center: 'textAlignCenter',
  left: 'textAlignLeft',
  right: 'textAlignRight'
};
var Label = function Label(_a) {
  var Element = _a.element,
      _b = _a.variant,
      variant = _b === void 0 ? 'standard' : _b,
      _c = _a.color,
      color = _c === void 0 ? 'primary-dark' : _c,
      _d = _a.textAlign,
      textAlign = _d === void 0 ? 'left' : _d,
      className = _a.className,
      _e = _a.textTransform,
      textTransform = _e === void 0 ? 'normal' : _e,
      _f = _a.wordBreak,
      wordBreak = _f === void 0 ? 'none' : _f,
      strikethrough = _a.strikethrough,
      props = __rest(_a, ["element", "variant", "color", "textAlign", "className", "textTransform", "wordBreak", "strikethrough"]);

  return /*#__PURE__*/createElement(Element, __assign({
    className: joinClasses(styles$g.label, styles$g["label--color-" + color], typographyStyles[labelStyles[variant]], textAlignStyles[alignmentClass$3[textAlign]], textTransformStyles["text-transform-" + textTransform], addWordBreak(wordBreak === 'break-word'), strikethrough && typographyStyles.strikethrough, className)
  }, props));
};
Label.displayName = 'CoreLabel';

var styles$h = {"button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon","button-icon--dark":"fr-ec-button-icon--dark","buttonIconDark":"fr-ec-button-icon--dark","button-icon--light":"fr-ec-button-icon--light","buttonIconLight":"fr-ec-button-icon--light","button-icon--with-label":"fr-ec-button-icon--with-label","buttonIconWithLabel":"fr-ec-button-icon--with-label","button-icon__icon":"fr-ec-button-icon__icon","buttonIconIcon":"fr-ec-button-icon__icon","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn","button-icon__icon-container":"fr-ec-button-icon__icon-container","buttonIconIconContainer":"fr-ec-button-icon__icon-container","button-icon__badge":"fr-ec-button-icon__badge","buttonIconBadge":"fr-ec-button-icon__badge","button-icon--disabled":"fr-ec-button-icon--disabled","buttonIconDisabled":"fr-ec-button-icon--disabled","button-icon__label":"fr-ec-button-icon__label","buttonIconLabel":"fr-ec-button-icon__label"};

var ButtonIcon = function ButtonIcon(_a) {
  var Element = _a.element,
      label = _a.label,
      icon = _a.icon,
      badge = _a.badge,
      _b = _a.variant,
      variant = _b === void 0 ? 'dark' : _b,
      hideLabel = _a.hideLabel,
      title = _a.title,
      disabled = _a.disabled,
      className = _a.className,
      iconSize = _a.iconSize,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["element", "label", "icon", "badge", "variant", "hideLabel", "title", "disabled", "className", "iconSize", "iconBrand"]);

  var showBadge = !disabled && badge;
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign({
      className: joinClasses(styles$h.buttonIcon, styles$h["button-icon--" + variant], interactionsStyles.cursorPointer, disabled ? styles$h.buttonIconDisabled : '', hideLabel ? '' : styles$h.buttonIconWithLabel, className),
      title: title,
      "aria-label": hideLabel ? label : undefined,
      disabled: disabled
    }, props), /*#__PURE__*/createElement("div", {
      className: styles$h.buttonIconIconContainer
    }, /*#__PURE__*/createElement(Icon, {
      name: iconBrand ? "" + iconBrand + icon : icon,
      className: styles$h.buttonIconIcon,
      title: title,
      size: iconSize
    }), Boolean(showBadge) &&
    /*#__PURE__*/
    // @ts-ignore
    createElement(Badge, {
      content: badge,
      iconBrand: iconBrand,
      className: styles$h.buttonIconBadge
    })), !hideLabel && /*#__PURE__*/createElement(Label, {
      element: "span",
      variant: "extra-small",
      color: disabled ? 'disabled' : variant === 'light' ? 'primary-light' : 'primary-dark',
      className: styles$h.buttonIconLabel
    }, label))
  );
};
ButtonIcon.displayName = 'CoreButtonIcon';
ButtonIcon.defaultProps = {
  disabled: false,
  hideLabel: false,
  title: '',
  variant: 'dark'
};

var styles$i = {"button-layout":"fr-ec-button-layout","buttonLayout":"fr-ec-button-layout","button-layout--small":"fr-ec-button-layout--small","buttonLayoutSmall":"fr-ec-button-layout--small","button-layout--button-plus-toggle":"fr-ec-button-layout--button-plus-toggle","buttonLayoutButtonPlusToggle":"fr-ec-button-layout--button-plus-toggle","button-layout--fluid":"fr-ec-button-layout--fluid","buttonLayoutFluid":"fr-ec-button-layout--fluid","button-layout--vertical":"fr-ec-button-layout--vertical","buttonLayoutVertical":"fr-ec-button-layout--vertical","button":"fr-ec-button","button-layout--horizontal":"fr-ec-button-layout--horizontal","buttonLayoutHorizontal":"fr-ec-button-layout--horizontal","button-layout--with-single-button":"fr-ec-button-layout--with-single-button","buttonLayoutWithSingleButton":"fr-ec-button-layout--with-single-button","button-layout--alignment-center":"fr-ec-button-layout--alignment-center","buttonLayoutAlignmentCenter":"fr-ec-button-layout--alignment-center","button-layout--alignment-left":"fr-ec-button-layout--alignment-left","buttonLayoutAlignmentLeft":"fr-ec-button-layout--alignment-left"};

var ButtonLayout = function ButtonLayout(_a) {
  var children = _a.children,
      _b = _a.variant,
      variant = _b === void 0 ? 'fluid' : _b,
      _c = _a.reverseOnVertical,
      reverseOnVertical = _c === void 0 ? false : _c,
      _d = _a.alignment,
      alignment = _d === void 0 ? 'center' : _d,
      className = _a.className,
      props = __rest(_a, ["children", "variant", "reverseOnVertical", "alignment", "className"]);

  var smallButtons = Children.toArray(children).filter(isValidElement).some(function (child) {
    return Boolean(child && child.props.isSmall);
  });

  var _e = useState(0),
      parentWidth = _e[0],
      setParentWidth = _e[1];

  return /*#__PURE__*/createElement(Measure, {
    bounds: true,
    onResize: function onResize(contentRect) {
      if (contentRect.bounds) {
        setParentWidth(contentRect.bounds.width);
      }
    }
  }, function (_a) {
    var measureRef = _a.measureRef;
    return /*#__PURE__*/createElement("div", __assign({}, props, {
      ref: measureRef
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$i.buttonLayout, styles$i["button-layout--" + (variant !== 'buttonPlusToggle' ? variant : 'button-plus-toggle')], styles$i["button-layout--alignment-" + alignment], smallButtons ? styles$i.buttonLayoutSmall : '', parentWidth < 504 && styles$i.buttonLayoutWithSingleButton, className)
    }, reverseOnVertical ? Children.toArray(children).reverse() : children));
  });
};
ButtonLayout.displayName = 'CoreButtonLayout';
ButtonLayout.defaultProps = {
  alignment: 'center',
  reverseOnVertical: false,
  variant: 'fluid'
};

var CmsLinkButtonContainer = function CmsLinkButtonContainer(_a) {
  var children = _a.children,
      className = _a.className,
      props = __rest(_a, ["children", "className"]);

  return /*#__PURE__*/createElement(ButtonLayout, __assign({
    className: className
  }, props), children);
};
CmsLinkButtonContainer.displayName = 'CoreCmsLinkButtonContainer';

var styles$j = {"icon-toggle":"fr-ec-icon-toggle","iconToggle":"fr-ec-icon-toggle","icon-toggle--heart-filled":"fr-ec-icon-toggle--heart-filled","iconToggleHeartFilled":"fr-ec-icon-toggle--heart-filled","icon-state--on":"fr-ec-icon-state--on","iconStateOn":"fr-ec-icon-state--on","icon-toggle-heart":"fr-ec-icon-toggle-heart","iconToggleHeart":"fr-ec-icon-toggle-heart","icon-state--disabled":"fr-ec-icon-state--disabled","iconStateDisabled":"fr-ec-icon-state--disabled","icon-toggle--heart-toggle":"fr-ec-icon-toggle--heart-toggle","iconToggleHeartToggle":"fr-ec-icon-toggle--heart-toggle","icon-toggle--thumbs-up-toggle":"fr-ec-icon-toggle--thumbs-up-toggle","iconToggleThumbsUpToggle":"fr-ec-icon-toggle--thumbs-up-toggle"};

var IconToggle = function IconToggle(_a) {
  var name = _a.name,
      className = _a.className,
      _b = _a.disabled,
      disabled = _b === void 0 ? false : _b,
      _c = _a.isToggled,
      isToggled = _c === void 0 ? false : _c,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["name", "className", "disabled", "isToggled", "iconBrand"]);

  var icon = name === 'heart' ? isToggled ? 'heart-filled' : name : name;
  var iconClassName = styles$j["icon-toggle--" + icon];
  var classNames = joinClasses(styles$j.iconToggle, iconClassName, disabled ? styles$j.iconStateDisabled : '', isToggled ? styles$j.iconStateOn : '', className);
  return /*#__PURE__*/createElement(Icon, __assign({
    name: iconBrand ? "" + iconBrand + icon : icon,
    className: classNames
  }, props));
};

var styles$k = {"button-toggle":"fr-ec-button-toggle","buttonToggle":"fr-ec-button-toggle","button--variant-secondary":"fr-ec-button--variant-secondary","buttonVariantSecondary":"fr-ec-button--variant-secondary","button-toggle--with-icon-wrapper":"fr-ec-button-toggle--with-icon-wrapper","buttonToggleWithIconWrapper":"fr-ec-button-toggle--with-icon-wrapper","button-toggle--with-icon":"fr-ec-button-toggle--with-icon","buttonToggleWithIcon":"fr-ec-button-toggle--with-icon","button-toggle--with--count-center":"fr-ec-button-toggle--with--count-center","buttonToggleWithCountCenter":"fr-ec-button-toggle--with--count-center","button-toggle--icon":"fr-ec-button-toggle--icon","buttonToggleIcon":"fr-ec-button-toggle--icon","button-toggle--with-label":"fr-ec-button-toggle--with-label","buttonToggleWithLabel":"fr-ec-button-toggle--with-label","button-toggle--text":"fr-ec-button-toggle--text","buttonToggleText":"fr-ec-button-toggle--text","button-tooggle--on-state":"fr-ec-button-tooggle--on-state","buttonTooggleOnState":"fr-ec-button-tooggle--on-state","button-toggle__count-text":"fr-ec-button-toggle__count-text","buttonToggleCountText":"fr-ec-button-toggle__count-text","button-toggle--icon-only":"fr-ec-button-toggle--icon-only","buttonToggleIconOnly":"fr-ec-button-toggle--icon-only","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","button-toggle--label-text":"fr-ec-button-toggle--label-text","buttonToggleLabelText":"fr-ec-button-toggle--label-text","label":"fr-ec-label","borderIn":"fr-ec-borderIn","button-toggle__count-text--bottom":"fr-ec-button-toggle__count-text--bottom","buttonToggleCountTextBottom":"fr-ec-button-toggle__count-text--bottom","button-toggle--label-with-icon":"fr-ec-button-toggle--label-with-icon","buttonToggleLabelWithIcon":"fr-ec-button-toggle--label-with-icon","button-toggle--label-with-icon-label":"fr-ec-button-toggle--label-with-icon-label","buttonToggleLabelWithIconLabel":"fr-ec-button-toggle--label-with-icon-label","button-toggle--label-with-icon-icon":"fr-ec-button-toggle--label-with-icon-icon","buttonToggleLabelWithIconIcon":"fr-ec-button-toggle--label-with-icon-icon","button-toogle--icon-toggle-all":"fr-ec-button-toogle--icon-toggle-all","buttonToogleIconToggleAll":"fr-ec-button-toogle--icon-toggle-all","button-toggle__alignment-center":"fr-ec-button-toggle__alignment-center","buttonToggleAlignmentCenter":"fr-ec-button-toggle__alignment-center","button-layout":"fr-ec-button-layout","buttonLayout":"fr-ec-button-layout","icon-toggle":"fr-ec-icon-toggle","iconToggle":"fr-ec-icon-toggle","icon-state--disabled":"fr-ec-icon-state--disabled","iconStateDisabled":"fr-ec-icon-state--disabled","icon-toggle--heart-filled":"fr-ec-icon-toggle--heart-filled","iconToggleHeartFilled":"fr-ec-icon-toggle--heart-filled","icon":"fr-ec-icon"};

var iconVariation = function iconVariation(_a, hasLabel, iconWithCount) {
  var className = _a.className,
      icon = _a.icon,
      text = _a.text,
      isToggled = _a.isToggled,
      iconTitle = _a.iconTitle,
      ariaLabel = _a.ariaLabel,
      count = _a.count,
      _b = _a.alignment,
      alignment = _b === void 0 ? 'none' : _b,
      props = __rest(_a, ["className", "icon", "text", "isToggled", "children", "iconTitle", "ariaLabel", "count", "alignment"]);

  return /*#__PURE__*/createElement("button", __assign({
    className: joinClasses(styles$k.buttonToggle, styles$k.buttonToggleWithIcon, !hasLabel && styles$k.buttonToggleIconOnly, interactionsStyles.cursorPointer, count && styles$k.buttonToogleIconToggleAll, alignment === 'center' && styles$k.buttonToggleAlignmentCenter, iconWithCount && styles$k.buttonToggleWithCountCenter, className)
  }, props, {
    "aria-label": ariaLabel || text,
    "aria-pressed": isToggled
  }), /*#__PURE__*/createElement(IconToggle, {
    name: icon,
    disabled: props.disabled,
    isToggled: isToggled,
    title: iconTitle,
    className: styles$k.buttonToggleIcon,
    iconBrand: props.iconBrand
  }), hasLabel && text && /*#__PURE__*/createElement(Label, {
    element: "span",
    variant: isToggled ? 'small-emphasized' : 'small',
    className: styles$k.buttonToggleLabelText,
    title: typeof text === 'string' ? text : ''
  }, text), count && /*#__PURE__*/createElement(Label, {
    element: "span",
    variant: iconWithCount ? 'extra-small' : 'small',
    className: joinClasses(styles$k.buttonToggleCountText, iconWithCount && styles$k.buttonToggleCountTextBottom)
  }, count));
};

var buttonVariation = function buttonVariation(_a, hasLabel) {
  var className = _a.className,
      icon = _a.icon,
      text = _a.text,
      isToggled = _a.isToggled,
      iconTitle = _a.iconTitle,
      ariaLabel = _a.ariaLabel,
      id = _a.id,
      props = __rest(_a, ["className", "icon", "text", "isToggled", "children", "iconTitle", "ariaLabel", "id"]);

  var labelId = id ? id + "-label" : 'button-toggle-label';
  return /*#__PURE__*/createElement("button", __assign({
    className: joinClasses(styles$k.buttonToggle, buttonStyles.button, buttonStyles.buttonVariantSecondary, interactionsStyles.cursorPointer, !hasLabel && styles$k.buttonToggleWithIconWrapper, className),
    id: id
  }, props, {
    "aria-pressed": isToggled
  }, Boolean(ariaLabel) && {
    'aria-label': ariaLabel
  } || {
    'aria-labelledby': labelId
  }), /*#__PURE__*/createElement(IconToggle, {
    name: icon,
    disabled: props.disabled,
    isToggled: isToggled,
    title: iconTitle,
    className: styles$k.buttonToggleWithIcon,
    iconBrand: props.iconBrand
  }), text && hasLabel && /*#__PURE__*/createElement(Label, {
    element: "span",
    variant: "large",
    className: styles$k.buttonToggleText,
    id: labelId
  }, text));
};

var getVariant = {
  button: function button(props) {
    return buttonVariation(props, true);
  },
  buttonSquare: function buttonSquare(props) {
    return buttonVariation(props, false);
  },
  icon: function icon(props) {
    return iconVariation(props, false, true);
  },
  iconToggleAll: function iconToggleAll(props) {
    return iconVariation(props, true, false);
  },
  iconWithLabel: function iconWithLabel(props) {
    return iconVariation(props, true, false);
  },
  labelWithIcon: function labelWithIcon(_a) {
    var className = _a.className,
        text = _a.text,
        icon = _a.icon,
        iconTitle = _a.iconTitle,
        isToggled = _a.isToggled,
        ariaLabel = _a.ariaLabel,
        props = __rest(_a, ["className", "text", "icon", "iconTitle", "isToggled", "ariaLabel", "id"]);

    return /*#__PURE__*/createElement("button", __assign({
      className: joinClasses(styles$k.buttonToggle, styles$k.buttonToggleWithIcon, interactionsStyles.cursorPointer, styles$k.buttonToggleLabelWithIcon, className)
    }, props, {
      "aria-label": ariaLabel || text,
      "aria-pressed": isToggled
    }), /*#__PURE__*/createElement("span", {
      className: joinClasses(styles$k.buttonToggleLabelWithIconLabel, typographyStyles.buttonLarge)
    }, typeof text === 'string' ? text : ''), /*#__PURE__*/createElement(IconToggle, {
      name: icon,
      disabled: props.disabled,
      isToggled: isToggled,
      title: iconTitle,
      className: styles$k.buttonToggleLabelWithIconIcon,
      iconBrand: props.iconBrand
    }));
  },
  toggleWithOnlyLabel: function toggleWithOnlyLabel(_a) {
    var className = _a.className,
        text = _a.text,
        isToggled = _a.isToggled,
        ariaLabel = _a.ariaLabel,
        count = _a.count,
        id = _a.id,
        props = __rest(_a, ["className", "text", "isToggled", "children", "ariaLabel", "count", "id"]);

    var labelId = id ? id + "-label" : 'button-toggle-label';
    return /*#__PURE__*/createElement("button", __assign({
      className: joinClasses(styles$k.buttonToggle, styles$k.buttonToggleWithLabel, isToggled && styles$k.buttonTooggleOnState, buttonStyles.button, !isToggled && buttonStyles.buttonVariantSecondary, isToggled && buttonStyles.buttonVariantPrimary, interactionsStyles.cursorPointer, className),
      id: id
    }, props, {
      "aria-pressed": isToggled
    }, Boolean(ariaLabel) && {
      'aria-label': ariaLabel
    } || {
      'aria-labelledby': labelId
    }), text && /*#__PURE__*/createElement(Label, {
      element: "span",
      variant: "small-emphasized",
      className: styles$k.buttonToggleText,
      id: labelId
    }, text), count && /*#__PURE__*/createElement(Label, {
      element: "span",
      variant: "small",
      className: styles$k.buttonToggleCountText
    }, count));
  }
};
var ButtonToggle = function ButtonToggle(_a) {
  var variant = _a.variant,
      props = __rest(_a, ["variant"]);

  return getVariant[variant](props);
};
ButtonToggle.displayName = 'CoreButtonToggle';
ButtonToggle.defaultProps = {
  variant: 'button'
};

var styles$l = {"card":"fr-ec-card","card--border-normal":"fr-ec-card--border-normal","cardBorderNormal":"fr-ec-card--border-normal","card--border-strong":"fr-ec-card--border-strong","cardBorderStrong":"fr-ec-card--border-strong","card--background":"fr-ec-card--background","cardBackground":"fr-ec-card--background"};

var Card = function Card(_a) {
  var className = _a.className,
      Element = _a.element,
      children = _a.children,
      variant = _a.variant,
      _b = _a.borderColor,
      borderColor = _b === void 0 ? 'normal' : _b,
      props = __rest(_a, ["className", "element", "children", "variant", "borderColor"]);

  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign({}, props, {
      className: joinClasses(styles$l.card, variant === 'background' ? styles$l.cardBackground : styles$l["card--border-" + borderColor], className)
    }), children)
  );
};
Card.displayName = 'CoreCard';
Card.defaultProps = {
  variant: 'border'
};

var styles$m = {"icon-typography__icon--attention":"fr-ec-icon-typography__icon--attention","iconTypographyIconAttention":"fr-ec-icon-typography__icon--attention","icon-typography__icon--start":"fr-ec-icon-typography__icon--start","iconTypographyIconStart":"fr-ec-icon-typography__icon--start","icon-typography__icon--end":"fr-ec-icon-typography__icon--end","iconTypographyIconEnd":"fr-ec-icon-typography__icon--end","icon-typography__content-spacing--with-tooltip":"fr-ec-icon-typography__content-spacing--with-tooltip","iconTypographyContentSpacingWithTooltip":"fr-ec-icon-typography__content-spacing--with-tooltip"};

var IconTypography = function IconTypography(_a) {
  var icon = _a.icon,
      _b = _a.iconPosition,
      iconPosition = _b === void 0 ? 'start' : _b,
      _c = _a.iconColor,
      iconColor = _c === void 0 ? 'standard' : _c,
      children = _a.children,
      toolTip = _a.toolTip,
      className = _a.className,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["icon", "iconPosition", "iconColor", "children", "toolTip", "className", "iconBrand"]);

  var iconTemplate = icon ? /*#__PURE__*/createElement(Icon, {
    name: iconBrand ? "" + iconBrand + icon : icon,
    size: "24",
    className: joinClasses(styles$m["icon-typography__icon--" + iconPosition], iconColor === 'attention' && styles$m.iconTypographyIconAttention)
  }) : toolTip;
  var renderChildren = /*#__PURE__*/createElement("div", {
    className: icon ? '' : styles$m.iconTypographyContentSpacingWithTooltip
  }, children);
  var renderedItems = iconPosition === 'end' ? /*#__PURE__*/createElement(Fragment, null, renderChildren, " ", iconTemplate) : /*#__PURE__*/createElement(Fragment, null, iconTemplate, " ", renderChildren);
  var iconTypography = toolTip ? /*#__PURE__*/createElement(ContentAlignment, __assign({
    className: className,
    element: "span",
    direction: "row",
    alignment: "center"
  }, props), renderedItems) : /*#__PURE__*/createElement(ContentAlignment, __assign({
    className: className,
    element: "span",
    direction: "row",
    alignment: "flex-start"
  }, props), renderedItems);
  return iconTypography;
};
IconTypography.displayName = 'CoreIconTypography';
IconTypography.defaultProps = {
  iconColor: 'standard',
  iconPosition: 'start'
};

var styles$n = {"store-bar":"fr-ec-store-bar","storeBar":"fr-ec-store-bar","store-bar__wrapper":"fr-ec-store-bar__wrapper","storeBarWrapper":"fr-ec-store-bar__wrapper","store-bar__search":"fr-ec-store-bar__search","storeBarSearch":"fr-ec-store-bar__search","store-bar__icon-typography":"fr-ec-store-bar__icon-typography","storeBarIconTypography":"fr-ec-store-bar__icon-typography","store-bar__store-name":"fr-ec-store-bar__store-name","storeBarStoreName":"fr-ec-store-bar__store-name"};

var StoreBar = function StoreBar(_a) {
  var searchLabel = _a.searchLabel,
      placeholder = _a.placeholder,
      icon = _a.icon,
      storeName = _a.storeName,
      onClick = _a.onClick,
      iconBrand = _a.iconBrand;
  return /*#__PURE__*/createElement("div", {
    className: styles$n.storeBar
  }, /*#__PURE__*/createElement(Card, {
    element: "div",
    variant: "background",
    borderColor: "normal",
    className: styles$n.storeBarWrapper
  }, /*#__PURE__*/createElement(ContentAlignment, {
    element: "div",
    direction: "row",
    justifyContent: "space-between"
  }, storeName && /*#__PURE__*/createElement(IconTypography, {
    icon: icon,
    iconBrand: iconBrand,
    iconPosition: "start",
    className: styles$n.storeBarIconTypography
  }, storeName && /*#__PURE__*/createElement(Caption, {
    color: "primary-dark",
    element: "p",
    textAlign: "left",
    textTransform: "normal",
    variant: "standard",
    className: styles$n.storeBarStoreName
  }, storeName)), !storeName && placeholder && /*#__PURE__*/createElement(Caption, {
    color: "secondary",
    element: "p",
    textAlign: "left",
    textTransform: "normal",
    variant: "standard"
  }, placeholder), /*#__PURE__*/createElement(Body, {
    variant: "small-underlined",
    element: "h5",
    onClick: onClick,
    className: styles$n.storeBarSearch
  }, searchLabel))));
};
StoreBar.displayName = 'CoreStoreBar';

var id = 0;
var genId = function genId() {
  return ++id;
};
var useId = function useId(componentName) {
  if (componentName === void 0) {
    componentName = '_';
  }

  var uniqueId = useState(genId())[0];
  return componentName + "-" + uniqueId;
};

var isInBrowser$1 = function isInBrowser() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
};

var styles$o = {"visibility--show-sm":"fr-ec-visibility--show-sm","visibilityShowSm":"fr-ec-visibility--show-sm","visibility--hide-sm":"fr-ec-visibility--hide-sm","visibilityHideSm":"fr-ec-visibility--hide-sm","visibility--show-md":"fr-ec-visibility--show-md","visibilityShowMd":"fr-ec-visibility--show-md","visibility--hide-md":"fr-ec-visibility--hide-md","visibilityHideMd":"fr-ec-visibility--hide-md","visibility--show-lg":"fr-ec-visibility--show-lg","visibilityShowLg":"fr-ec-visibility--show-lg","visibility--hide-lg":"fr-ec-visibility--hide-lg","visibilityHideLg":"fr-ec-visibility--hide-lg"};

var withVisibility = function withVisibility(component) {
  var Component = component;

  var WrapperComponent = function WrapperComponent(_a) {
    var _b = _a.visible,
        visible = _b === void 0 ? true : _b,
        className = _a.className,
        props = __rest(_a, ["visible", "className"]);

    var getVisibleClasses = function getVisibleClasses(visibleProp) {
      if (typeof visibleProp === 'boolean') {
        if (visibleProp) {
          return joinClasses(styles$o.visibilityShowSm, styles$o.visibilityShowMd, styles$o.visibilityShowLg);
        } else {
          return joinClasses(styles$o.visibilityHideSm, styles$o.visibilityHideMd, styles$o.visibilityHideLg);
        }
      }

      return joinClasses.apply(void 0, Object.keys(visibleProp).reduce(function (acc, size) {
        var visibilityClassName = visibleProp[size] ? styles$o["visibility--show-" + size] : styles$o["visibility--hide-" + size];
        return __spreadArrays(acc, [visibilityClassName]);
      }, []));
    };

    var visibilityClasses = getVisibleClasses(visible);
    /**
     * Have to do this to allow props to be spread on `Component` because TypeScript 3.2^ has an issue
     * with spreading generics - https://github.com/Microsoft/TypeScript/issues/28938
     */

    return /*#__PURE__*/createElement(Component, __assign({
      className: joinClasses(className, visibilityClasses)
    }, props));
  };

  WrapperComponent.displayName = Component.displayName;
  return WrapperComponent;
};

var BP_SMALL = 'sm';
var BP_MEDIUM = 'md';
var BP_LARGE = 'lg';
var getCurrentMediaQueryBreakpoint = function getCurrentMediaQueryBreakpoint() {
  if (typeof window === 'undefined' && typeof document === 'undefined') {
    return BP_SMALL;
  }

  var width = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

  if (width < designTokens_3.mqMediumScreenMinWidthLimit) {
    return BP_SMALL;
  } else if (width < designTokens_3.mqLargeScreenMinWidthLimit) {
    return BP_MEDIUM;
  }

  return BP_LARGE;
};

var DIRECTION_TOP = 'top';
var DIRECTION_BOTTOM = 'bottom';
var DIRECTION_START = 'start';
var DIRECTION_END = 'end';
var DIRECTION_START_TOP = 'startTop';
var DIRECTION_END_TOP = 'endTop';
var DIRECTION_TOP_LEFT = 'topLeft';
var DIRECTION_BOTTOM_LEFT = 'bottomLeft';
var DIRECTION_START_BOTTOM = 'startBottom';
var DIRECTION_END_BOTTOM = 'endBottom';
var DIRECTION_TOP_RIGHT = 'topRight';
var DIRECTION_BOTTOM_RIGHT = 'bottomRight';

var getBrowser = function getBrowser() {
  if (typeof navigator !== 'undefined' && navigator.userAgent.indexOf('Firefox') !== -1) {
    return 'firefox';
  } else {
    return 'none';
  }
};

var styles$1$2 = {"tooltip-clone":"fr-ec-tooltip-clone","tooltipClone":"fr-ec-tooltip-clone","button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon","with-clone--wrapper":"fr-ec-with-clone--wrapper","withCloneWrapper":"fr-ec-with-clone--wrapper"};

var WithClonedTooltip = function WithClonedTooltip(component) {
  var _a;

  var Component = component;
  var cloneAnchor;

  if (isInBrowser$1()) {
    cloneAnchor = document.body.appendChild(document.createElement('div'));
  }

  return _a =
  /** @class */
  function (_super) {
    __extends(WrapperComponent, _super);

    function WrapperComponent(props) {
      var _this = _super.call(this, props) || this;

      _this.onResize = function () {
        if (_this.props.isPopper && isInBrowser$1() && _this.originalRef.current) {
          var rect = _this.originalRef.current.getBoundingClientRect();

          _this.setState({
            clonePosition: {
              left: rect.left + window.scrollX,
              top: rect.top + window.scrollY
            }
          });
        }
      };

      _this.getClonePortal = function () {
        var clonePosition = _this.state.clonePosition;
        var clone = /*#__PURE__*/React__default.createElement("div", {
          style: {
            display: 'inline-block',
            left: clonePosition.left,
            position: 'fixed',
            top: clonePosition.top,
            zIndex: 700
          },
          "aria-hidden": true,
          tabIndex: -1
        }, /*#__PURE__*/React__default.createElement(Component, __assign({
          className: joinClasses(_this.props.className, styles$1$2.tooltipClone)
        }, _this.props, {
          id: _this.props.id + "-clone"
        })));
        return /*#__PURE__*/ReactDOM.createPortal(clone, cloneAnchor);
      };

      _this.originalRef = /*#__PURE__*/createRef();
      _this.state = {
        clonePosition: {
          top: 0,
          left: 0
        }
      };
      return _this;
    }

    WrapperComponent.prototype.componentDidMount = function () {
      this.onResize();
    };

    WrapperComponent.prototype.componentDidUpdate = function (prevProps) {
      var isPopper = this.props.isPopper;

      if (prevProps.isPopper !== isPopper) {
        this.onResize();
        var originalBubbleEl_1 = document.getElementById(this.props.id + "-bubble");
        var cloneBubbleEl_1 = document.getElementById(this.props.id + "-clone-bubble");
        var originalButtonEl = document.getElementById(this.props.id);
        var clonebuttonEl = document.getElementById(this.props.id + "-clone");

        if (clonebuttonEl) {
          clonebuttonEl.setAttribute('tabIndex', '-1');
        }

        var handleFocus = function handleFocus() {
          if (cloneBubbleEl_1 && originalBubbleEl_1) {
            cloneBubbleEl_1.classList.remove('uq-uikit-tooltip__bubble--hidden');
            var originalBubbleStyles = originalBubbleEl_1.getAttribute('style');
            var originalBubbleClass = originalBubbleEl_1.getAttribute('class');

            if (originalBubbleStyles && originalBubbleClass) {
              cloneBubbleEl_1.setAttribute('style', originalBubbleStyles);
              cloneBubbleEl_1.setAttribute('class', originalBubbleClass);
            }
          }
        };

        var handleBlur = function handleBlur() {
          if (cloneBubbleEl_1) {
            cloneBubbleEl_1.classList.add('uq-uikit-tooltip__bubble--hidden');
          }
        };

        if (originalButtonEl) {
          originalButtonEl.addEventListener('focus', handleFocus);
          originalButtonEl.addEventListener('blur', handleBlur);
        }
      }
    };

    WrapperComponent.prototype.componentWillUnmount = function () {
      if (isInBrowser$1() && this.props.isPopper && cloneAnchor && document.body.contains(cloneAnchor)) {
        document.body.removeChild(cloneAnchor);
      }
    };

    WrapperComponent.prototype.render = function () {
      var _this = this;

      var isPopper = this.props.isPopper;
      return isPopper ? /*#__PURE__*/React__default.createElement(Measure, {
        onResize: debounce(100, this.onResize)
      }, function (_a) {
        var measureRef = _a.measureRef;
        return /*#__PURE__*/React__default.createElement("div", {
          ref: measureRef
        }, /*#__PURE__*/React__default.createElement("div", {
          className: styles$1$2.withCloneWrapper,
          ref: _this.originalRef
        }, /*#__PURE__*/React__default.createElement(Component, __assign({}, _this.props))), _this.getClonePortal());
      }) : /*#__PURE__*/React__default.createElement(Component, __assign({}, this.props));
    };

    return WrapperComponent;
  }(React__default.Component), _a.displayName = Component.displayName, _a;
};

var DeviceType;

(function (DeviceType) {
  DeviceType["Mobile"] = "Mobile";
  DeviceType["Tablet"] = "Tablet";
  DeviceType["Desktop"] = "Desktop";
})(DeviceType || (DeviceType = {}));

var DeviceTypeContext = /*#__PURE__*/createContext(DeviceType.Mobile);

var isViewport = function isViewport(component) {
  var Component = component;

  var WrapperComponent = function WrapperComponent(_a) {
    var _b = _a.visible,
        visible = _b === void 0 ? {
      sm: true,
      md: true,
      lg: true
    } : _b,
        className = _a.className,
        props = __rest(_a, ["visible", "className"]);

    var deviceType = useContext(DeviceTypeContext);

    var getWindowWidth = function getWindowWidth() {
      if (isInBrowser$1()) {
        return window.innerWidth;
      } else {
        return deviceType === DeviceType.Desktop ? 1199 : deviceType === DeviceType.Tablet ? 959 : 599;
      }
    };

    var _c = useState(getWindowWidth()),
        viewportWidth = _c[0],
        setViewportWidth = _c[1];

    var shouldRender = function shouldRender(visibility, width) {
      if (_typeof(visibility) === 'object' && width !== null) {
        if (visibility.sm && width < designTokens_3.mqMediumScreenMinWidthLimit) {
          return true;
        }

        if (visibility.md && width > designTokens_3.mqSmallScreenMaxWidthLimit && width < designTokens_3.mqLargeScreenMinWidthLimit) {
          return true;
        }

        if (visibility.lg && width > designTokens_3.mqMediumScreenMaxWidthLimit) {
          return true;
        }
      }

      return false;
    };

    useEffect(function () {
      function handleResize() {
        var getWidth = getWindowWidth();
        setViewportWidth(getWidth);
      }

      window.addEventListener('resize', debounce(100, handleResize));
      return function () {
        return window.removeEventListener('resize', handleResize);
      };
    }, []);
    var shouldRenderChildren = shouldRender(visible, viewportWidth);
    /**
     * Have to do this to allow props to be spread on `Component` because TypeScript 3.2^ has an issue
     * with spreading generics - https://github.com/Microsoft/TypeScript/issues/28938
     */

    return shouldRenderChildren ? /*#__PURE__*/createElement(Component, __assign({
      className: joinClasses(className)
    }, props)) : null;
  };

  WrapperComponent.displayName = Component.displayName;
  return WrapperComponent;
};

var getViewportWidth = function getViewportWidth() {
  var deviceType = useContext(DeviceTypeContext);

  var getWindowWidth = function getWindowWidth() {
    if (isInBrowser$1()) {
      return window.innerWidth || 0;
    } else {
      return deviceType === DeviceType.Desktop ? 1199 : deviceType === DeviceType.Tablet ? 959 : 599;
    }
  };

  var _a = useState(getWindowWidth()),
      width = _a[0],
      setWidth = _a[1];

  useEffect(function () {
    var handleWindowResize = function handleWindowResize() {
      return setWidth(getWindowWidth());
    };

    window.addEventListener('resize', handleWindowResize);
    return function () {
      return window.removeEventListener('resize', handleWindowResize);
    };
  }, []);
  return width;
};

var isTouchDevice = function isTouchDevice(method) {
  if (method === 'touchPoints') {
    return typeof window !== 'undefined' ? 'ontouchstart' in window || navigator.maxTouchPoints > 0 : true;
  } else if (method === 'userAgent') {
    var userAgent = typeof window === 'undefined' ? '' : navigator.userAgent;
    return Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i) || userAgent.includes('Mac') && 'ontouchend' in document);
  } else {
    return false;
  }
};

var isAbsoluteUrl = function isAbsoluteUrl(url) {
  var absoluteUrlPattern = /^((https?:)?\/\/|#)/;
  return absoluteUrlPattern.test(url) ? true : false;
};

var getOS = function getOS() {
  var userAgent = typeof window === 'undefined' ? '' : navigator.userAgent;

  if (Boolean(userAgent.match(/Android/i))) {
    return 'android';
  } else if (Boolean(userAgent.match(/iPhone|iPad|iPod/i))) {
    return 'iOS';
  } else {
    return 'none';
  }
};

var isKeyboardOpen = function isKeyboardOpen() {
  var minKeyboardHeight = 300;

  var _a = useState(undefined),
      isKeyboardOpenState = _a[0],
      setIsKeyboardOpenState = _a[1];

  useEffect(function () {
    var listener = function listener() {
      var newState = window.screen.height - minKeyboardHeight > window.visualViewport.height;

      if (isKeyboardOpenState !== newState) {
        setIsKeyboardOpenState(newState);
      }
    };

    if (isInBrowser$1()) {
      if (typeof window.visualViewport !== 'undefined') {
        window.visualViewport.addEventListener('resize', listener);
      }
    }

    return function () {
      if (isInBrowser$1()) {
        if (typeof window.visualViewport !== 'undefined') {
          window.visualViewport.removeEventListener('resize', listener);
        }
      }
    };
  }, []);
  return isKeyboardOpenState;
};

var swiper = createCommonjsModule(function (module, exports) {
  /**
   * Swiper 4.5.1
   * Most modern mobile touch slider and framework with hardware accelerated transitions
   * http://www.idangero.us/swiper/
   *
   * Copyright 2014-2019 Vladimir Kharlampidi
   *
   * Released under the MIT License
   *
   * Released on: September 13, 2019
   */
  (function (global, factory) {
     module.exports = factory() ;
  })(commonjsGlobal, function () {
    /**
     * SSR Window 1.0.1
     * Better handling for window object in SSR environment
     * https://github.com/nolimits4web/ssr-window
     *
     * Copyright 2018, Vladimir Kharlampidi
     *
     * Licensed under MIT
     *
     * Released on: July 18, 2018
     */

    var doc = typeof document === 'undefined' ? {
      body: {},
      addEventListener: function addEventListener() {},
      removeEventListener: function removeEventListener() {},
      activeElement: {
        blur: function blur() {},
        nodeName: ''
      },
      querySelector: function querySelector() {
        return null;
      },
      querySelectorAll: function querySelectorAll() {
        return [];
      },
      getElementById: function getElementById() {
        return null;
      },
      createEvent: function createEvent() {
        return {
          initEvent: function initEvent() {}
        };
      },
      createElement: function createElement() {
        return {
          children: [],
          childNodes: [],
          style: {},
          setAttribute: function setAttribute() {},
          getElementsByTagName: function getElementsByTagName() {
            return [];
          }
        };
      },
      location: {
        hash: ''
      }
    } : document; // eslint-disable-line

    var win = typeof window === 'undefined' ? {
      document: doc,
      navigator: {
        userAgent: ''
      },
      location: {},
      history: {},
      CustomEvent: function CustomEvent() {
        return this;
      },
      addEventListener: function addEventListener() {},
      removeEventListener: function removeEventListener() {},
      getComputedStyle: function getComputedStyle() {
        return {
          getPropertyValue: function getPropertyValue() {
            return '';
          }
        };
      },
      Image: function Image() {},
      Date: function Date() {},
      screen: {},
      setTimeout: function setTimeout() {},
      clearTimeout: function clearTimeout() {}
    } : window; // eslint-disable-line

    /**
     * Dom7 2.1.3
     * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
     * http://framework7.io/docs/dom.html
     *
     * Copyright 2019, Vladimir Kharlampidi
     * The iDangero.us
     * http://www.idangero.us/
     *
     * Licensed under MIT
     *
     * Released on: February 11, 2019
     */

    var Dom7 = function Dom7(arr) {
      var self = this; // Create array-like object

      for (var i = 0; i < arr.length; i += 1) {
        self[i] = arr[i];
      }

      self.length = arr.length; // Return collection with methods

      return this;
    };

    function $(selector, context) {
      var arr = [];
      var i = 0;

      if (selector && !context) {
        if (selector instanceof Dom7) {
          return selector;
        }
      }

      if (selector) {
        // String
        if (typeof selector === 'string') {
          var els;
          var tempParent;
          var html = selector.trim();

          if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
            var toCreate = 'div';

            if (html.indexOf('<li') === 0) {
              toCreate = 'ul';
            }

            if (html.indexOf('<tr') === 0) {
              toCreate = 'tbody';
            }

            if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) {
              toCreate = 'tr';
            }

            if (html.indexOf('<tbody') === 0) {
              toCreate = 'table';
            }

            if (html.indexOf('<option') === 0) {
              toCreate = 'select';
            }

            tempParent = doc.createElement(toCreate);
            tempParent.innerHTML = html;

            for (i = 0; i < tempParent.childNodes.length; i += 1) {
              arr.push(tempParent.childNodes[i]);
            }
          } else {
            if (!context && selector[0] === '#' && !selector.match(/[ .<>:~]/)) {
              // Pure ID selector
              els = [doc.getElementById(selector.trim().split('#')[1])];
            } else {
              // Other selectors
              els = (context || doc).querySelectorAll(selector.trim());
            }

            for (i = 0; i < els.length; i += 1) {
              if (els[i]) {
                arr.push(els[i]);
              }
            }
          }
        } else if (selector.nodeType || selector === win || selector === doc) {
          // Node/element
          arr.push(selector);
        } else if (selector.length > 0 && selector[0].nodeType) {
          // Array of elements or instance of Dom
          for (i = 0; i < selector.length; i += 1) {
            arr.push(selector[i]);
          }
        }
      }

      return new Dom7(arr);
    }

    $.fn = Dom7.prototype;
    $.Class = Dom7;
    $.Dom7 = Dom7;

    function unique(arr) {
      var uniqueArray = [];

      for (var i = 0; i < arr.length; i += 1) {
        if (uniqueArray.indexOf(arr[i]) === -1) {
          uniqueArray.push(arr[i]);
        }
      }

      return uniqueArray;
    } // Classes and attributes


    function addClass(className) {
      if (typeof className === 'undefined') {
        return this;
      }

      var classes = className.split(' ');

      for (var i = 0; i < classes.length; i += 1) {
        for (var j = 0; j < this.length; j += 1) {
          if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') {
            this[j].classList.add(classes[i]);
          }
        }
      }

      return this;
    }

    function removeClass(className) {
      var classes = className.split(' ');

      for (var i = 0; i < classes.length; i += 1) {
        for (var j = 0; j < this.length; j += 1) {
          if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') {
            this[j].classList.remove(classes[i]);
          }
        }
      }

      return this;
    }

    function hasClass(className) {
      if (!this[0]) {
        return false;
      }

      return this[0].classList.contains(className);
    }

    function toggleClass(className) {
      var classes = className.split(' ');

      for (var i = 0; i < classes.length; i += 1) {
        for (var j = 0; j < this.length; j += 1) {
          if (typeof this[j] !== 'undefined' && typeof this[j].classList !== 'undefined') {
            this[j].classList.toggle(classes[i]);
          }
        }
      }

      return this;
    }

    function attr(attrs, value) {
      var arguments$1 = arguments;

      if (arguments.length === 1 && typeof attrs === 'string') {
        // Get attr
        if (this[0]) {
          return this[0].getAttribute(attrs);
        }

        return undefined;
      } // Set attrs


      for (var i = 0; i < this.length; i += 1) {
        if (arguments$1.length === 2) {
          // String
          this[i].setAttribute(attrs, value);
        } else {
          // Object
          // eslint-disable-next-line
          for (var attrName in attrs) {
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
          }
        }
      }

      return this;
    } // eslint-disable-next-line


    function removeAttr(attr) {
      for (var i = 0; i < this.length; i += 1) {
        this[i].removeAttribute(attr);
      }

      return this;
    }

    function data(key, value) {
      var el;

      if (typeof value === 'undefined') {
        el = this[0]; // Get value

        if (el) {
          if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
            return el.dom7ElementDataStorage[key];
          }

          var dataKey = el.getAttribute("data-" + key);

          if (dataKey) {
            return dataKey;
          }

          return undefined;
        }

        return undefined;
      } // Set value


      for (var i = 0; i < this.length; i += 1) {
        el = this[i];

        if (!el.dom7ElementDataStorage) {
          el.dom7ElementDataStorage = {};
        }

        el.dom7ElementDataStorage[key] = value;
      }

      return this;
    } // Transforms
    // eslint-disable-next-line


    function transform(transform) {
      for (var i = 0; i < this.length; i += 1) {
        var elStyle = this[i].style;
        elStyle.webkitTransform = transform;
        elStyle.transform = transform;
      }

      return this;
    }

    function transition(duration) {
      if (typeof duration !== 'string') {
        duration = duration + "ms"; // eslint-disable-line
      }

      for (var i = 0; i < this.length; i += 1) {
        var elStyle = this[i].style;
        elStyle.webkitTransitionDuration = duration;
        elStyle.transitionDuration = duration;
      }

      return this;
    } // Events


    function on() {
      var assign;
      var args = [],
          len = arguments.length;

      while (len--) args[len] = arguments[len];

      var eventType = args[0];
      var targetSelector = args[1];
      var listener = args[2];
      var capture = args[3];

      if (typeof args[1] === 'function') {
        assign = args, eventType = assign[0], listener = assign[1], capture = assign[2];
        targetSelector = undefined;
      }

      if (!capture) {
        capture = false;
      }

      function handleLiveEvent(e) {
        var target = e.target;

        if (!target) {
          return;
        }

        var eventData = e.target.dom7EventData || [];

        if (eventData.indexOf(e) < 0) {
          eventData.unshift(e);
        }

        if ($(target).is(targetSelector)) {
          listener.apply(target, eventData);
        } else {
          var parents = $(target).parents(); // eslint-disable-line

          for (var k = 0; k < parents.length; k += 1) {
            if ($(parents[k]).is(targetSelector)) {
              listener.apply(parents[k], eventData);
            }
          }
        }
      }

      function handleEvent(e) {
        var eventData = e && e.target ? e.target.dom7EventData || [] : [];

        if (eventData.indexOf(e) < 0) {
          eventData.unshift(e);
        }

        listener.apply(this, eventData);
      }

      var events = eventType.split(' ');
      var j;

      for (var i = 0; i < this.length; i += 1) {
        var el = this[i];

        if (!targetSelector) {
          for (j = 0; j < events.length; j += 1) {
            var event = events[j];

            if (!el.dom7Listeners) {
              el.dom7Listeners = {};
            }

            if (!el.dom7Listeners[event]) {
              el.dom7Listeners[event] = [];
            }

            el.dom7Listeners[event].push({
              listener: listener,
              proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
          }
        } else {
          // Live events
          for (j = 0; j < events.length; j += 1) {
            var event$1 = events[j];

            if (!el.dom7LiveListeners) {
              el.dom7LiveListeners = {};
            }

            if (!el.dom7LiveListeners[event$1]) {
              el.dom7LiveListeners[event$1] = [];
            }

            el.dom7LiveListeners[event$1].push({
              listener: listener,
              proxyListener: handleLiveEvent
            });
            el.addEventListener(event$1, handleLiveEvent, capture);
          }
        }
      }

      return this;
    }

    function off() {
      var assign;
      var args = [],
          len = arguments.length;

      while (len--) args[len] = arguments[len];

      var eventType = args[0];
      var targetSelector = args[1];
      var listener = args[2];
      var capture = args[3];

      if (typeof args[1] === 'function') {
        assign = args, eventType = assign[0], listener = assign[1], capture = assign[2];
        targetSelector = undefined;
      }

      if (!capture) {
        capture = false;
      }

      var events = eventType.split(' ');

      for (var i = 0; i < events.length; i += 1) {
        var event = events[i];

        for (var j = 0; j < this.length; j += 1) {
          var el = this[j];
          var handlers = void 0;

          if (!targetSelector && el.dom7Listeners) {
            handlers = el.dom7Listeners[event];
          } else if (targetSelector && el.dom7LiveListeners) {
            handlers = el.dom7LiveListeners[event];
          }

          if (handlers && handlers.length) {
            for (var k = handlers.length - 1; k >= 0; k -= 1) {
              var handler = handlers[k];

              if (listener && handler.listener === listener) {
                el.removeEventListener(event, handler.proxyListener, capture);
                handlers.splice(k, 1);
              } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                el.removeEventListener(event, handler.proxyListener, capture);
                handlers.splice(k, 1);
              } else if (!listener) {
                el.removeEventListener(event, handler.proxyListener, capture);
                handlers.splice(k, 1);
              }
            }
          }
        }
      }

      return this;
    }

    function trigger() {
      var args = [],
          len = arguments.length;

      while (len--) args[len] = arguments[len];

      var events = args[0].split(' ');
      var eventData = args[1];

      for (var i = 0; i < events.length; i += 1) {
        var event = events[i];

        for (var j = 0; j < this.length; j += 1) {
          var el = this[j];
          var evt = void 0;

          try {
            evt = new win.CustomEvent(event, {
              detail: eventData,
              bubbles: true,
              cancelable: true
            });
          } catch (e) {
            evt = doc.createEvent('Event');
            evt.initEvent(event, true, true);
            evt.detail = eventData;
          } // eslint-disable-next-line


          el.dom7EventData = args.filter(function (data, dataIndex) {
            return dataIndex > 0;
          });
          el.dispatchEvent(evt);
          el.dom7EventData = [];
          delete el.dom7EventData;
        }
      }

      return this;
    }

    function transitionEnd(callback) {
      var events = ['webkitTransitionEnd', 'transitionend'];
      var dom = this;
      var i;

      function fireCallBack(e) {
        /* jshint validthis:true */
        if (e.target !== this) {
          return;
        }

        callback.call(this, e);

        for (i = 0; i < events.length; i += 1) {
          dom.off(events[i], fireCallBack);
        }
      }

      if (callback) {
        for (i = 0; i < events.length; i += 1) {
          dom.on(events[i], fireCallBack);
        }
      }

      return this;
    }

    function outerWidth(includeMargins) {
      if (this.length > 0) {
        if (includeMargins) {
          // eslint-disable-next-line
          var styles = this.styles();
          return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
        }

        return this[0].offsetWidth;
      }

      return null;
    }

    function outerHeight(includeMargins) {
      if (this.length > 0) {
        if (includeMargins) {
          // eslint-disable-next-line
          var styles = this.styles();
          return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
        }

        return this[0].offsetHeight;
      }

      return null;
    }

    function offset() {
      if (this.length > 0) {
        var el = this[0];
        var box = el.getBoundingClientRect();
        var body = doc.body;
        var clientTop = el.clientTop || body.clientTop || 0;
        var clientLeft = el.clientLeft || body.clientLeft || 0;
        var scrollTop = el === win ? win.scrollY : el.scrollTop;
        var scrollLeft = el === win ? win.scrollX : el.scrollLeft;
        return {
          top: box.top + scrollTop - clientTop,
          left: box.left + scrollLeft - clientLeft
        };
      }

      return null;
    }

    function styles() {
      if (this[0]) {
        return win.getComputedStyle(this[0], null);
      }

      return {};
    }

    function css(props, value) {
      var i;

      if (arguments.length === 1) {
        if (typeof props === 'string') {
          if (this[0]) {
            return win.getComputedStyle(this[0], null).getPropertyValue(props);
          }
        } else {
          for (i = 0; i < this.length; i += 1) {
            // eslint-disable-next-line
            for (var prop in props) {
              this[i].style[prop] = props[prop];
            }
          }

          return this;
        }
      }

      if (arguments.length === 2 && typeof props === 'string') {
        for (i = 0; i < this.length; i += 1) {
          this[i].style[props] = value;
        }

        return this;
      }

      return this;
    } // Iterate over the collection passing elements to `callback`


    function each(callback) {
      // Don't bother continuing without a callback
      if (!callback) {
        return this;
      } // Iterate over the current collection


      for (var i = 0; i < this.length; i += 1) {
        // If the callback returns false
        if (callback.call(this[i], i, this[i]) === false) {
          // End the loop early
          return this;
        }
      } // Return `this` to allow chained DOM operations


      return this;
    } // eslint-disable-next-line


    function html(html) {
      if (typeof html === 'undefined') {
        return this[0] ? this[0].innerHTML : undefined;
      }

      for (var i = 0; i < this.length; i += 1) {
        this[i].innerHTML = html;
      }

      return this;
    } // eslint-disable-next-line


    function text(text) {
      if (typeof text === 'undefined') {
        if (this[0]) {
          return this[0].textContent.trim();
        }

        return null;
      }

      for (var i = 0; i < this.length; i += 1) {
        this[i].textContent = text;
      }

      return this;
    }

    function is(selector) {
      var el = this[0];
      var compareWith;
      var i;

      if (!el || typeof selector === 'undefined') {
        return false;
      }

      if (typeof selector === 'string') {
        if (el.matches) {
          return el.matches(selector);
        } else if (el.webkitMatchesSelector) {
          return el.webkitMatchesSelector(selector);
        } else if (el.msMatchesSelector) {
          return el.msMatchesSelector(selector);
        }

        compareWith = $(selector);

        for (i = 0; i < compareWith.length; i += 1) {
          if (compareWith[i] === el) {
            return true;
          }
        }

        return false;
      } else if (selector === doc) {
        return el === doc;
      } else if (selector === win) {
        return el === win;
      }

      if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [selector] : selector;

        for (i = 0; i < compareWith.length; i += 1) {
          if (compareWith[i] === el) {
            return true;
          }
        }

        return false;
      }

      return false;
    }

    function index() {
      var child = this[0];
      var i;

      if (child) {
        i = 0; // eslint-disable-next-line

        while ((child = child.previousSibling) !== null) {
          if (child.nodeType === 1) {
            i += 1;
          }
        }

        return i;
      }

      return undefined;
    } // eslint-disable-next-line


    function eq(index) {
      if (typeof index === 'undefined') {
        return this;
      }

      var length = this.length;
      var returnIndex;

      if (index > length - 1) {
        return new Dom7([]);
      }

      if (index < 0) {
        returnIndex = length + index;

        if (returnIndex < 0) {
          return new Dom7([]);
        }

        return new Dom7([this[returnIndex]]);
      }

      return new Dom7([this[index]]);
    }

    function append() {
      var args = [],
          len = arguments.length;

      while (len--) args[len] = arguments[len];

      var newChild;

      for (var k = 0; k < args.length; k += 1) {
        newChild = args[k];

        for (var i = 0; i < this.length; i += 1) {
          if (typeof newChild === 'string') {
            var tempDiv = doc.createElement('div');
            tempDiv.innerHTML = newChild;

            while (tempDiv.firstChild) {
              this[i].appendChild(tempDiv.firstChild);
            }
          } else if (newChild instanceof Dom7) {
            for (var j = 0; j < newChild.length; j += 1) {
              this[i].appendChild(newChild[j]);
            }
          } else {
            this[i].appendChild(newChild);
          }
        }
      }

      return this;
    }

    function prepend(newChild) {
      var i;
      var j;

      for (i = 0; i < this.length; i += 1) {
        if (typeof newChild === 'string') {
          var tempDiv = doc.createElement('div');
          tempDiv.innerHTML = newChild;

          for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
            this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
          }
        } else if (newChild instanceof Dom7) {
          for (j = 0; j < newChild.length; j += 1) {
            this[i].insertBefore(newChild[j], this[i].childNodes[0]);
          }
        } else {
          this[i].insertBefore(newChild, this[i].childNodes[0]);
        }
      }

      return this;
    }

    function next(selector) {
      if (this.length > 0) {
        if (selector) {
          if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
            return new Dom7([this[0].nextElementSibling]);
          }

          return new Dom7([]);
        }

        if (this[0].nextElementSibling) {
          return new Dom7([this[0].nextElementSibling]);
        }

        return new Dom7([]);
      }

      return new Dom7([]);
    }

    function nextAll(selector) {
      var nextEls = [];
      var el = this[0];

      if (!el) {
        return new Dom7([]);
      }

      while (el.nextElementSibling) {
        var next = el.nextElementSibling; // eslint-disable-line

        if (selector) {
          if ($(next).is(selector)) {
            nextEls.push(next);
          }
        } else {
          nextEls.push(next);
        }

        el = next;
      }

      return new Dom7(nextEls);
    }

    function prev(selector) {
      if (this.length > 0) {
        var el = this[0];

        if (selector) {
          if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
            return new Dom7([el.previousElementSibling]);
          }

          return new Dom7([]);
        }

        if (el.previousElementSibling) {
          return new Dom7([el.previousElementSibling]);
        }

        return new Dom7([]);
      }

      return new Dom7([]);
    }

    function prevAll(selector) {
      var prevEls = [];
      var el = this[0];

      if (!el) {
        return new Dom7([]);
      }

      while (el.previousElementSibling) {
        var prev = el.previousElementSibling; // eslint-disable-line

        if (selector) {
          if ($(prev).is(selector)) {
            prevEls.push(prev);
          }
        } else {
          prevEls.push(prev);
        }

        el = prev;
      }

      return new Dom7(prevEls);
    }

    function parent(selector) {
      var parents = []; // eslint-disable-line

      for (var i = 0; i < this.length; i += 1) {
        if (this[i].parentNode !== null) {
          if (selector) {
            if ($(this[i].parentNode).is(selector)) {
              parents.push(this[i].parentNode);
            }
          } else {
            parents.push(this[i].parentNode);
          }
        }
      }

      return $(unique(parents));
    }

    function parents(selector) {
      var parents = []; // eslint-disable-line

      for (var i = 0; i < this.length; i += 1) {
        var parent = this[i].parentNode; // eslint-disable-line

        while (parent) {
          if (selector) {
            if ($(parent).is(selector)) {
              parents.push(parent);
            }
          } else {
            parents.push(parent);
          }

          parent = parent.parentNode;
        }
      }

      return $(unique(parents));
    }

    function closest(selector) {
      var closest = this; // eslint-disable-line

      if (typeof selector === 'undefined') {
        return new Dom7([]);
      }

      if (!closest.is(selector)) {
        closest = closest.parents(selector).eq(0);
      }

      return closest;
    }

    function find(selector) {
      var foundElements = [];

      for (var i = 0; i < this.length; i += 1) {
        var found = this[i].querySelectorAll(selector);

        for (var j = 0; j < found.length; j += 1) {
          foundElements.push(found[j]);
        }
      }

      return new Dom7(foundElements);
    }

    function children(selector) {
      var children = []; // eslint-disable-line

      for (var i = 0; i < this.length; i += 1) {
        var childNodes = this[i].childNodes;

        for (var j = 0; j < childNodes.length; j += 1) {
          if (!selector) {
            if (childNodes[j].nodeType === 1) {
              children.push(childNodes[j]);
            }
          } else if (childNodes[j].nodeType === 1 && $(childNodes[j]).is(selector)) {
            children.push(childNodes[j]);
          }
        }
      }

      return new Dom7(unique(children));
    }

    function remove() {
      for (var i = 0; i < this.length; i += 1) {
        if (this[i].parentNode) {
          this[i].parentNode.removeChild(this[i]);
        }
      }

      return this;
    }

    function add() {
      var args = [],
          len = arguments.length;

      while (len--) args[len] = arguments[len];

      var dom = this;
      var i;
      var j;

      for (i = 0; i < args.length; i += 1) {
        var toAdd = $(args[i]);

        for (j = 0; j < toAdd.length; j += 1) {
          dom[dom.length] = toAdd[j];
          dom.length += 1;
        }
      }

      return dom;
    }

    var Methods = {
      addClass: addClass,
      removeClass: removeClass,
      hasClass: hasClass,
      toggleClass: toggleClass,
      attr: attr,
      removeAttr: removeAttr,
      data: data,
      transform: transform,
      transition: transition,
      on: on,
      off: off,
      trigger: trigger,
      transitionEnd: transitionEnd,
      outerWidth: outerWidth,
      outerHeight: outerHeight,
      offset: offset,
      css: css,
      each: each,
      html: html,
      text: text,
      is: is,
      index: index,
      eq: eq,
      append: append,
      prepend: prepend,
      next: next,
      nextAll: nextAll,
      prev: prev,
      prevAll: prevAll,
      parent: parent,
      parents: parents,
      closest: closest,
      find: find,
      children: children,
      remove: remove,
      add: add,
      styles: styles
    };
    Object.keys(Methods).forEach(function (methodName) {
      $.fn[methodName] = $.fn[methodName] || Methods[methodName];
    });
    var Utils = {
      deleteProps: function deleteProps(obj) {
        var object = obj;
        Object.keys(object).forEach(function (key) {
          try {
            object[key] = null;
          } catch (e) {// no getter for object
          }

          try {
            delete object[key];
          } catch (e) {// something got wrong
          }
        });
      },
      nextTick: function nextTick(callback, delay) {
        if (delay === void 0) delay = 0;
        return setTimeout(callback, delay);
      },
      now: function now() {
        return Date.now();
      },
      getTranslate: function getTranslate(el, axis) {
        if (axis === void 0) axis = 'x';
        var matrix;
        var curTransform;
        var transformMatrix;
        var curStyle = win.getComputedStyle(el, null);

        if (win.WebKitCSSMatrix) {
          curTransform = curStyle.transform || curStyle.webkitTransform;

          if (curTransform.split(',').length > 6) {
            curTransform = curTransform.split(', ').map(function (a) {
              return a.replace(',', '.');
            }).join(', ');
          } // Some old versions of Webkit choke when 'none' is passed; pass
          // empty string instead in this case


          transformMatrix = new win.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
        } else {
          transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
          matrix = transformMatrix.toString().split(',');
        }

        if (axis === 'x') {
          // Latest Chrome and webkits Fix
          if (win.WebKitCSSMatrix) {
            curTransform = transformMatrix.m41;
          } // Crazy IE10 Matrix
          else if (matrix.length === 16) {
              curTransform = parseFloat(matrix[12]);
            } // Normal Browsers
            else {
                curTransform = parseFloat(matrix[4]);
              }
        }

        if (axis === 'y') {
          // Latest Chrome and webkits Fix
          if (win.WebKitCSSMatrix) {
            curTransform = transformMatrix.m42;
          } // Crazy IE10 Matrix
          else if (matrix.length === 16) {
              curTransform = parseFloat(matrix[13]);
            } // Normal Browsers
            else {
                curTransform = parseFloat(matrix[5]);
              }
        }

        return curTransform || 0;
      },
      parseUrlQuery: function parseUrlQuery(url) {
        var query = {};
        var urlToParse = url || win.location.href;
        var i;
        var params;
        var param;
        var length;

        if (typeof urlToParse === 'string' && urlToParse.length) {
          urlToParse = urlToParse.indexOf('?') > -1 ? urlToParse.replace(/\S*\?/, '') : '';
          params = urlToParse.split('&').filter(function (paramsPart) {
            return paramsPart !== '';
          });
          length = params.length;

          for (i = 0; i < length; i += 1) {
            param = params[i].replace(/#\S+/g, '').split('=');
            query[decodeURIComponent(param[0])] = typeof param[1] === 'undefined' ? undefined : decodeURIComponent(param[1]) || '';
          }
        }

        return query;
      },
      isObject: function isObject(o) {
        return _typeof(o) === 'object' && o !== null && o.constructor && o.constructor === Object;
      },
      extend: function extend() {
        var args = [],
            len$1 = arguments.length;

        while (len$1--) args[len$1] = arguments[len$1];

        var to = Object(args[0]);

        for (var i = 1; i < args.length; i += 1) {
          var nextSource = args[i];

          if (nextSource !== undefined && nextSource !== null) {
            var keysArray = Object.keys(Object(nextSource));

            for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
              var nextKey = keysArray[nextIndex];
              var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

              if (desc !== undefined && desc.enumerable) {
                if (Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                  Utils.extend(to[nextKey], nextSource[nextKey]);
                } else if (!Utils.isObject(to[nextKey]) && Utils.isObject(nextSource[nextKey])) {
                  to[nextKey] = {};
                  Utils.extend(to[nextKey], nextSource[nextKey]);
                } else {
                  to[nextKey] = nextSource[nextKey];
                }
              }
            }
          }
        }

        return to;
      }
    };

    var Support = function Support() {
      var testDiv = doc.createElement('div');
      return {
        touch: win.Modernizr && win.Modernizr.touch === true || function checkTouch() {
          return !!(win.navigator.maxTouchPoints > 0 || 'ontouchstart' in win || win.DocumentTouch && doc instanceof win.DocumentTouch);
        }(),
        pointerEvents: !!(win.navigator.pointerEnabled || win.PointerEvent || 'maxTouchPoints' in win.navigator && win.navigator.maxTouchPoints > 0),
        prefixedPointerEvents: !!win.navigator.msPointerEnabled,
        transition: function checkTransition() {
          var style = testDiv.style;
          return 'transition' in style || 'webkitTransition' in style || 'MozTransition' in style;
        }(),
        transforms3d: win.Modernizr && win.Modernizr.csstransforms3d === true || function checkTransforms3d() {
          var style = testDiv.style;
          return 'webkitPerspective' in style || 'MozPerspective' in style || 'OPerspective' in style || 'MsPerspective' in style || 'perspective' in style;
        }(),
        flexbox: function checkFlexbox() {
          var style = testDiv.style;
          var styles = 'alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient'.split(' ');

          for (var i = 0; i < styles.length; i += 1) {
            if (styles[i] in style) {
              return true;
            }
          }

          return false;
        }(),
        observer: function checkObserver() {
          return 'MutationObserver' in win || 'WebkitMutationObserver' in win;
        }(),
        passiveListener: function checkPassiveListener() {
          var supportsPassive = false;

          try {
            var opts = Object.defineProperty({}, 'passive', {
              // eslint-disable-next-line
              get: function get() {
                supportsPassive = true;
              }
            });
            win.addEventListener('testPassiveListener', null, opts);
          } catch (e) {// No support
          }

          return supportsPassive;
        }(),
        gestures: function checkGestures() {
          return 'ongesturestart' in win;
        }()
      };
    }();

    var Browser = function Browser() {
      function isSafari() {
        var ua = win.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
      }

      return {
        isIE: !!win.navigator.userAgent.match(/Trident/g) || !!win.navigator.userAgent.match(/MSIE/g),
        isEdge: !!win.navigator.userAgent.match(/Edge/g),
        isSafari: isSafari(),
        isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(win.navigator.userAgent)
      };
    }();

    var SwiperClass = function SwiperClass(params) {
      if (params === void 0) params = {};
      var self = this;
      self.params = params; // Events

      self.eventsListeners = {};

      if (self.params && self.params.on) {
        Object.keys(self.params.on).forEach(function (eventName) {
          self.on(eventName, self.params.on[eventName]);
        });
      }
    };

    var staticAccessors = {
      components: {
        configurable: true
      }
    };

    SwiperClass.prototype.on = function on(events, handler, priority) {
      var self = this;

      if (typeof handler !== 'function') {
        return self;
      }

      var method = priority ? 'unshift' : 'push';
      events.split(' ').forEach(function (event) {
        if (!self.eventsListeners[event]) {
          self.eventsListeners[event] = [];
        }

        self.eventsListeners[event][method](handler);
      });
      return self;
    };

    SwiperClass.prototype.once = function once(events, handler, priority) {
      var self = this;

      if (typeof handler !== 'function') {
        return self;
      }

      function onceHandler() {
        var args = [],
            len = arguments.length;

        while (len--) args[len] = arguments[len];

        handler.apply(self, args);
        self.off(events, onceHandler);

        if (onceHandler.f7proxy) {
          delete onceHandler.f7proxy;
        }
      }

      onceHandler.f7proxy = handler;
      return self.on(events, onceHandler, priority);
    };

    SwiperClass.prototype.off = function off(events, handler) {
      var self = this;

      if (!self.eventsListeners) {
        return self;
      }

      events.split(' ').forEach(function (event) {
        if (typeof handler === 'undefined') {
          self.eventsListeners[event] = [];
        } else if (self.eventsListeners[event] && self.eventsListeners[event].length) {
          self.eventsListeners[event].forEach(function (eventHandler, index) {
            if (eventHandler === handler || eventHandler.f7proxy && eventHandler.f7proxy === handler) {
              self.eventsListeners[event].splice(index, 1);
            }
          });
        }
      });
      return self;
    };

    SwiperClass.prototype.emit = function emit() {
      var args = [],
          len = arguments.length;

      while (len--) args[len] = arguments[len];

      var self = this;

      if (!self.eventsListeners) {
        return self;
      }

      var events;
      var data;
      var context;

      if (typeof args[0] === 'string' || Array.isArray(args[0])) {
        events = args[0];
        data = args.slice(1, args.length);
        context = self;
      } else {
        events = args[0].events;
        data = args[0].data;
        context = args[0].context || self;
      }

      var eventsArray = Array.isArray(events) ? events : events.split(' ');
      eventsArray.forEach(function (event) {
        if (self.eventsListeners && self.eventsListeners[event]) {
          var handlers = [];
          self.eventsListeners[event].forEach(function (eventHandler) {
            handlers.push(eventHandler);
          });
          handlers.forEach(function (eventHandler) {
            eventHandler.apply(context, data);
          });
        }
      });
      return self;
    };

    SwiperClass.prototype.useModulesParams = function useModulesParams(instanceParams) {
      var instance = this;

      if (!instance.modules) {
        return;
      }

      Object.keys(instance.modules).forEach(function (moduleName) {
        var module = instance.modules[moduleName]; // Extend params

        if (module.params) {
          Utils.extend(instanceParams, module.params);
        }
      });
    };

    SwiperClass.prototype.useModules = function useModules(modulesParams) {
      if (modulesParams === void 0) modulesParams = {};
      var instance = this;

      if (!instance.modules) {
        return;
      }

      Object.keys(instance.modules).forEach(function (moduleName) {
        var module = instance.modules[moduleName];
        var moduleParams = modulesParams[moduleName] || {}; // Extend instance methods and props

        if (module.instance) {
          Object.keys(module.instance).forEach(function (modulePropName) {
            var moduleProp = module.instance[modulePropName];

            if (typeof moduleProp === 'function') {
              instance[modulePropName] = moduleProp.bind(instance);
            } else {
              instance[modulePropName] = moduleProp;
            }
          });
        } // Add event listeners


        if (module.on && instance.on) {
          Object.keys(module.on).forEach(function (moduleEventName) {
            instance.on(moduleEventName, module.on[moduleEventName]);
          });
        } // Module create callback


        if (module.create) {
          module.create.bind(instance)(moduleParams);
        }
      });
    };

    staticAccessors.components.set = function (components) {
      var Class = this;

      if (!Class.use) {
        return;
      }

      Class.use(components);
    };

    SwiperClass.installModule = function installModule(module) {
      var params = [],
          len = arguments.length - 1;

      while (len-- > 0) params[len] = arguments[len + 1];

      var Class = this;

      if (!Class.prototype.modules) {
        Class.prototype.modules = {};
      }

      var name = module.name || Object.keys(Class.prototype.modules).length + "_" + Utils.now();
      Class.prototype.modules[name] = module; // Prototype

      if (module.proto) {
        Object.keys(module.proto).forEach(function (key) {
          Class.prototype[key] = module.proto[key];
        });
      } // Class


      if (module["static"]) {
        Object.keys(module["static"]).forEach(function (key) {
          Class[key] = module["static"][key];
        });
      } // Callback


      if (module.install) {
        module.install.apply(Class, params);
      }

      return Class;
    };

    SwiperClass.use = function use(module) {
      var params = [],
          len = arguments.length - 1;

      while (len-- > 0) params[len] = arguments[len + 1];

      var Class = this;

      if (Array.isArray(module)) {
        module.forEach(function (m) {
          return Class.installModule(m);
        });
        return Class;
      }

      return Class.installModule.apply(Class, [module].concat(params));
    };

    Object.defineProperties(SwiperClass, staticAccessors);

    function updateSize() {
      var swiper = this;
      var width;
      var height;
      var $el = swiper.$el;

      if (typeof swiper.params.width !== 'undefined') {
        width = swiper.params.width;
      } else {
        width = $el[0].clientWidth;
      }

      if (typeof swiper.params.height !== 'undefined') {
        height = swiper.params.height;
      } else {
        height = $el[0].clientHeight;
      }

      if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
        return;
      } // Subtract paddings


      width = width - parseInt($el.css('padding-left'), 10) - parseInt($el.css('padding-right'), 10);
      height = height - parseInt($el.css('padding-top'), 10) - parseInt($el.css('padding-bottom'), 10);
      Utils.extend(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
      });
    }

    function updateSlides() {
      var swiper = this;
      var params = swiper.params;
      var $wrapperEl = swiper.$wrapperEl;
      var swiperSize = swiper.size;
      var rtl = swiper.rtlTranslate;
      var wrongRTL = swiper.wrongRTL;
      var isVirtual = swiper.virtual && params.virtual.enabled;
      var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
      var slides = $wrapperEl.children("." + swiper.params.slideClass);
      var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
      var snapGrid = [];
      var slidesGrid = [];
      var slidesSizesGrid = [];
      var offsetBefore = params.slidesOffsetBefore;

      if (typeof offsetBefore === 'function') {
        offsetBefore = params.slidesOffsetBefore.call(swiper);
      }

      var offsetAfter = params.slidesOffsetAfter;

      if (typeof offsetAfter === 'function') {
        offsetAfter = params.slidesOffsetAfter.call(swiper);
      }

      var previousSnapGridLength = swiper.snapGrid.length;
      var previousSlidesGridLength = swiper.snapGrid.length;
      var spaceBetween = params.spaceBetween;
      var slidePosition = -offsetBefore;
      var prevSlideSize = 0;
      var index = 0;

      if (typeof swiperSize === 'undefined') {
        return;
      }

      if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
        spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
      }

      swiper.virtualSize = -spaceBetween; // reset margins

      if (rtl) {
        slides.css({
          marginLeft: '',
          marginTop: ''
        });
      } else {
        slides.css({
          marginRight: '',
          marginBottom: ''
        });
      }

      var slidesNumberEvenToRows;

      if (params.slidesPerColumn > 1) {
        if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
          slidesNumberEvenToRows = slidesLength;
        } else {
          slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
        }

        if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
          slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
        }
      } // Calc slides


      var slideSize;
      var slidesPerColumn = params.slidesPerColumn;
      var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
      var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);

      for (var i = 0; i < slidesLength; i += 1) {
        slideSize = 0;
        var slide = slides.eq(i);

        if (params.slidesPerColumn > 1) {
          // Set slides order
          var newSlideOrderIndex = void 0;
          var column = void 0;
          var row = void 0;

          if (params.slidesPerColumnFill === 'column' || params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
            if (params.slidesPerColumnFill === 'column') {
              column = Math.floor(i / slidesPerColumn);
              row = i - column * slidesPerColumn;

              if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
                row += 1;

                if (row >= slidesPerColumn) {
                  row = 0;
                  column += 1;
                }
              }
            } else {
              var groupIndex = Math.floor(i / params.slidesPerGroup);
              row = Math.floor(i / params.slidesPerView) - groupIndex * params.slidesPerColumn;
              column = i - row * params.slidesPerView - groupIndex * params.slidesPerView;
            }

            newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
            slide.css({
              '-webkit-box-ordinal-group': newSlideOrderIndex,
              '-moz-box-ordinal-group': newSlideOrderIndex,
              '-ms-flex-order': newSlideOrderIndex,
              '-webkit-order': newSlideOrderIndex,
              order: newSlideOrderIndex
            });
          } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
          }

          slide.css("margin-" + (swiper.isHorizontal() ? 'top' : 'left'), row !== 0 && params.spaceBetween && params.spaceBetween + "px").attr('data-swiper-column', column).attr('data-swiper-row', row);
        }

        if (slide.css('display') === 'none') {
          continue;
        } // eslint-disable-line


        if (params.slidesPerView === 'auto') {
          var slideStyles = win.getComputedStyle(slide[0], null);
          var currentTransform = slide[0].style.transform;
          var currentWebKitTransform = slide[0].style.webkitTransform;

          if (currentTransform) {
            slide[0].style.transform = 'none';
          }

          if (currentWebKitTransform) {
            slide[0].style.webkitTransform = 'none';
          }

          if (params.roundLengths) {
            slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
          } else {
            // eslint-disable-next-line
            if (swiper.isHorizontal()) {
              var width = parseFloat(slideStyles.getPropertyValue('width'));
              var paddingLeft = parseFloat(slideStyles.getPropertyValue('padding-left'));
              var paddingRight = parseFloat(slideStyles.getPropertyValue('padding-right'));
              var marginLeft = parseFloat(slideStyles.getPropertyValue('margin-left'));
              var marginRight = parseFloat(slideStyles.getPropertyValue('margin-right'));
              var boxSizing = slideStyles.getPropertyValue('box-sizing');

              if (boxSizing && boxSizing === 'border-box' && !Browser.isIE) {
                slideSize = width + marginLeft + marginRight;
              } else {
                slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight;
              }
            } else {
              var height = parseFloat(slideStyles.getPropertyValue('height'));
              var paddingTop = parseFloat(slideStyles.getPropertyValue('padding-top'));
              var paddingBottom = parseFloat(slideStyles.getPropertyValue('padding-bottom'));
              var marginTop = parseFloat(slideStyles.getPropertyValue('margin-top'));
              var marginBottom = parseFloat(slideStyles.getPropertyValue('margin-bottom'));
              var boxSizing$1 = slideStyles.getPropertyValue('box-sizing');

              if (boxSizing$1 && boxSizing$1 === 'border-box' && !Browser.isIE) {
                slideSize = height + marginTop + marginBottom;
              } else {
                slideSize = height + paddingTop + paddingBottom + marginTop + marginBottom;
              }
            }
          }

          if (currentTransform) {
            slide[0].style.transform = currentTransform;
          }

          if (currentWebKitTransform) {
            slide[0].style.webkitTransform = currentWebKitTransform;
          }

          if (params.roundLengths) {
            slideSize = Math.floor(slideSize);
          }
        } else {
          slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;

          if (params.roundLengths) {
            slideSize = Math.floor(slideSize);
          }

          if (slides[i]) {
            if (swiper.isHorizontal()) {
              slides[i].style.width = slideSize + "px";
            } else {
              slides[i].style.height = slideSize + "px";
            }
          }
        }

        if (slides[i]) {
          slides[i].swiperSlideSize = slideSize;
        }

        slidesSizesGrid.push(slideSize);

        if (params.centeredSlides) {
          slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;

          if (prevSlideSize === 0 && i !== 0) {
            slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
          }

          if (i === 0) {
            slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
          }

          if (Math.abs(slidePosition) < 1 / 1000) {
            slidePosition = 0;
          }

          if (params.roundLengths) {
            slidePosition = Math.floor(slidePosition);
          }

          if (index % params.slidesPerGroup === 0) {
            snapGrid.push(slidePosition);
          }

          slidesGrid.push(slidePosition);
        } else {
          if (params.roundLengths) {
            slidePosition = Math.floor(slidePosition);
          }

          if (index % params.slidesPerGroup === 0) {
            snapGrid.push(slidePosition);
          }

          slidesGrid.push(slidePosition);
          slidePosition = slidePosition + slideSize + spaceBetween;
        }

        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
      }

      swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
      var newSlidesGrid;

      if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
        $wrapperEl.css({
          width: swiper.virtualSize + params.spaceBetween + "px"
        });
      }

      if (!Support.flexbox || params.setWrapperSize) {
        if (swiper.isHorizontal()) {
          $wrapperEl.css({
            width: swiper.virtualSize + params.spaceBetween + "px"
          });
        } else {
          $wrapperEl.css({
            height: swiper.virtualSize + params.spaceBetween + "px"
          });
        }
      }

      if (params.slidesPerColumn > 1) {
        swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;

        if (swiper.isHorizontal()) {
          $wrapperEl.css({
            width: swiper.virtualSize + params.spaceBetween + "px"
          });
        } else {
          $wrapperEl.css({
            height: swiper.virtualSize + params.spaceBetween + "px"
          });
        }

        if (params.centeredSlides) {
          newSlidesGrid = [];

          for (var i$1 = 0; i$1 < snapGrid.length; i$1 += 1) {
            var slidesGridItem = snapGrid[i$1];

            if (params.roundLengths) {
              slidesGridItem = Math.floor(slidesGridItem);
            }

            if (snapGrid[i$1] < swiper.virtualSize + snapGrid[0]) {
              newSlidesGrid.push(slidesGridItem);
            }
          }

          snapGrid = newSlidesGrid;
        }
      } // Remove last grid elements depending on width


      if (!params.centeredSlides) {
        newSlidesGrid = [];

        for (var i$2 = 0; i$2 < snapGrid.length; i$2 += 1) {
          var slidesGridItem$1 = snapGrid[i$2];

          if (params.roundLengths) {
            slidesGridItem$1 = Math.floor(slidesGridItem$1);
          }

          if (snapGrid[i$2] <= swiper.virtualSize - swiperSize) {
            newSlidesGrid.push(slidesGridItem$1);
          }
        }

        snapGrid = newSlidesGrid;

        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
          snapGrid.push(swiper.virtualSize - swiperSize);
        }
      }

      if (snapGrid.length === 0) {
        snapGrid = [0];
      }

      if (params.spaceBetween !== 0) {
        if (swiper.isHorizontal()) {
          if (rtl) {
            slides.css({
              marginLeft: spaceBetween + "px"
            });
          } else {
            slides.css({
              marginRight: spaceBetween + "px"
            });
          }
        } else {
          slides.css({
            marginBottom: spaceBetween + "px"
          });
        }
      }

      if (params.centerInsufficientSlides) {
        var allSlidesSize = 0;
        slidesSizesGrid.forEach(function (slideSizeValue) {
          allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;

        if (allSlidesSize < swiperSize) {
          var allSlidesOffset = (swiperSize - allSlidesSize) / 2;
          snapGrid.forEach(function (snap, snapIndex) {
            snapGrid[snapIndex] = snap - allSlidesOffset;
          });
          slidesGrid.forEach(function (snap, snapIndex) {
            slidesGrid[snapIndex] = snap + allSlidesOffset;
          });
        }
      }

      Utils.extend(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
      });

      if (slidesLength !== previousSlidesLength) {
        swiper.emit('slidesLengthChange');
      }

      if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) {
          swiper.checkOverflow();
        }

        swiper.emit('snapGridLengthChange');
      }

      if (slidesGrid.length !== previousSlidesGridLength) {
        swiper.emit('slidesGridLengthChange');
      }

      if (params.watchSlidesProgress || params.watchSlidesVisibility) {
        swiper.updateSlidesOffset();
      }
    }

    function updateAutoHeight(speed) {
      var swiper = this;
      var activeSlides = [];
      var newHeight = 0;
      var i;

      if (typeof speed === 'number') {
        swiper.setTransition(speed);
      } else if (speed === true) {
        swiper.setTransition(swiper.params.speed);
      } // Find slides currently in view


      if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
          var index = swiper.activeIndex + i;

          if (index > swiper.slides.length) {
            break;
          }

          activeSlides.push(swiper.slides.eq(index)[0]);
        }
      } else {
        activeSlides.push(swiper.slides.eq(swiper.activeIndex)[0]);
      } // Find new height from highest slide in view


      for (i = 0; i < activeSlides.length; i += 1) {
        if (typeof activeSlides[i] !== 'undefined') {
          var height = activeSlides[i].offsetHeight;
          newHeight = height > newHeight ? height : newHeight;
        }
      } // Update Height


      if (newHeight) {
        swiper.$wrapperEl.css('height', newHeight + "px");
      }
    }

    function updateSlidesOffset() {
      var swiper = this;
      var slides = swiper.slides;

      for (var i = 0; i < slides.length; i += 1) {
        slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
      }
    }

    function updateSlidesProgress(translate) {
      if (translate === void 0) translate = this && this.translate || 0;
      var swiper = this;
      var params = swiper.params;
      var slides = swiper.slides;
      var rtl = swiper.rtlTranslate;

      if (slides.length === 0) {
        return;
      }

      if (typeof slides[0].swiperSlideOffset === 'undefined') {
        swiper.updateSlidesOffset();
      }

      var offsetCenter = -translate;

      if (rtl) {
        offsetCenter = translate;
      } // Visible Slides


      slides.removeClass(params.slideVisibleClass);
      swiper.visibleSlidesIndexes = [];
      swiper.visibleSlides = [];

      for (var i = 0; i < slides.length; i += 1) {
        var slide = slides[i];
        var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);

        if (params.watchSlidesVisibility) {
          var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
          var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
          var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

          if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
          }
        }

        slide.progress = rtl ? -slideProgress : slideProgress;
      }

      swiper.visibleSlides = $(swiper.visibleSlides);
    }

    function updateProgress(translate) {
      if (translate === void 0) translate = this && this.translate || 0;
      var swiper = this;
      var params = swiper.params;
      var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
      var progress = swiper.progress;
      var isBeginning = swiper.isBeginning;
      var isEnd = swiper.isEnd;
      var wasBeginning = isBeginning;
      var wasEnd = isEnd;

      if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
      } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
      }

      Utils.extend(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
      });

      if (params.watchSlidesProgress || params.watchSlidesVisibility) {
        swiper.updateSlidesProgress(translate);
      }

      if (isBeginning && !wasBeginning) {
        swiper.emit('reachBeginning toEdge');
      }

      if (isEnd && !wasEnd) {
        swiper.emit('reachEnd toEdge');
      }

      if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
        swiper.emit('fromEdge');
      }

      swiper.emit('progress', progress);
    }

    function updateSlidesClasses() {
      var swiper = this;
      var slides = swiper.slides;
      var params = swiper.params;
      var $wrapperEl = swiper.$wrapperEl;
      var activeIndex = swiper.activeIndex;
      var realIndex = swiper.realIndex;
      var isVirtual = swiper.virtual && params.virtual.enabled;
      slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
      var activeSlide;

      if (isVirtual) {
        activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
      } else {
        activeSlide = slides.eq(activeIndex);
      } // Active classes


      activeSlide.addClass(params.slideActiveClass);

      if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) {
          $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
        } else {
          $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
        }
      } // Next Slide


      var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);

      if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
      } // Prev Slide


      var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);

      if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
      }

      if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) {
          $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
        } else {
          $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
        }

        if (prevSlide.hasClass(params.slideDuplicateClass)) {
          $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
        } else {
          $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
        }
      }
    }

    function updateActiveIndex(newActiveIndex) {
      var swiper = this;
      var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
      var slidesGrid = swiper.slidesGrid;
      var snapGrid = swiper.snapGrid;
      var params = swiper.params;
      var previousIndex = swiper.activeIndex;
      var previousRealIndex = swiper.realIndex;
      var previousSnapIndex = swiper.snapIndex;
      var activeIndex = newActiveIndex;
      var snapIndex;

      if (typeof activeIndex === 'undefined') {
        for (var i = 0; i < slidesGrid.length; i += 1) {
          if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
              activeIndex = i;
            } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
              activeIndex = i + 1;
            }
          } else if (translate >= slidesGrid[i]) {
            activeIndex = i;
          }
        } // Normalize slideIndex


        if (params.normalizeSlideIndex) {
          if (activeIndex < 0 || typeof activeIndex === 'undefined') {
            activeIndex = 0;
          }
        }
      }

      if (snapGrid.indexOf(translate) >= 0) {
        snapIndex = snapGrid.indexOf(translate);
      } else {
        snapIndex = Math.floor(activeIndex / params.slidesPerGroup);
      }

      if (snapIndex >= snapGrid.length) {
        snapIndex = snapGrid.length - 1;
      }

      if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
          swiper.snapIndex = snapIndex;
          swiper.emit('snapIndexChange');
        }

        return;
      } // Get real index


      var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
      Utils.extend(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
      });
      swiper.emit('activeIndexChange');
      swiper.emit('snapIndexChange');

      if (previousRealIndex !== realIndex) {
        swiper.emit('realIndexChange');
      }

      if (swiper.initialized || swiper.runCallbacksOnInit) {
        swiper.emit('slideChange');
      }
    }

    function updateClickedSlide(e) {
      var swiper = this;
      var params = swiper.params;
      var slide = $(e.target).closest("." + params.slideClass)[0];
      var slideFound = false;

      if (slide) {
        for (var i = 0; i < swiper.slides.length; i += 1) {
          if (swiper.slides[i] === slide) {
            slideFound = true;
          }
        }
      }

      if (slide && slideFound) {
        swiper.clickedSlide = slide;

        if (swiper.virtual && swiper.params.virtual.enabled) {
          swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
        } else {
          swiper.clickedIndex = $(slide).index();
        }
      } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
      }

      if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
        swiper.slideToClickedSlide();
      }
    }

    var update = {
      updateSize: updateSize,
      updateSlides: updateSlides,
      updateAutoHeight: updateAutoHeight,
      updateSlidesOffset: updateSlidesOffset,
      updateSlidesProgress: updateSlidesProgress,
      updateProgress: updateProgress,
      updateSlidesClasses: updateSlidesClasses,
      updateActiveIndex: updateActiveIndex,
      updateClickedSlide: updateClickedSlide
    };

    function getTranslate(axis) {
      if (axis === void 0) axis = this.isHorizontal() ? 'x' : 'y';
      var swiper = this;
      var params = swiper.params;
      var rtl = swiper.rtlTranslate;
      var translate = swiper.translate;
      var $wrapperEl = swiper.$wrapperEl;

      if (params.virtualTranslate) {
        return rtl ? -translate : translate;
      }

      var currentTranslate = Utils.getTranslate($wrapperEl[0], axis);

      if (rtl) {
        currentTranslate = -currentTranslate;
      }

      return currentTranslate || 0;
    }

    function setTranslate(translate, byController) {
      var swiper = this;
      var rtl = swiper.rtlTranslate;
      var params = swiper.params;
      var $wrapperEl = swiper.$wrapperEl;
      var progress = swiper.progress;
      var x = 0;
      var y = 0;
      var z = 0;

      if (swiper.isHorizontal()) {
        x = rtl ? -translate : translate;
      } else {
        y = translate;
      }

      if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
      }

      if (!params.virtualTranslate) {
        if (Support.transforms3d) {
          $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
        } else {
          $wrapperEl.transform("translate(" + x + "px, " + y + "px)");
        }
      }

      swiper.previousTranslate = swiper.translate;
      swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

      var newProgress;
      var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

      if (translatesDiff === 0) {
        newProgress = 0;
      } else {
        newProgress = (translate - swiper.minTranslate()) / translatesDiff;
      }

      if (newProgress !== progress) {
        swiper.updateProgress(translate);
      }

      swiper.emit('setTranslate', swiper.translate, byController);
    }

    function minTranslate() {
      return -this.snapGrid[0];
    }

    function maxTranslate() {
      return -this.snapGrid[this.snapGrid.length - 1];
    }

    var translate = {
      getTranslate: getTranslate,
      setTranslate: setTranslate,
      minTranslate: minTranslate,
      maxTranslate: maxTranslate
    };

    function setTransition(duration, byController) {
      var swiper = this;
      swiper.$wrapperEl.transition(duration);
      swiper.emit('setTransition', duration, byController);
    }

    function transitionStart(runCallbacks, direction) {
      if (runCallbacks === void 0) runCallbacks = true;
      var swiper = this;
      var activeIndex = swiper.activeIndex;
      var params = swiper.params;
      var previousIndex = swiper.previousIndex;

      if (params.autoHeight) {
        swiper.updateAutoHeight();
      }

      var dir = direction;

      if (!dir) {
        if (activeIndex > previousIndex) {
          dir = 'next';
        } else if (activeIndex < previousIndex) {
          dir = 'prev';
        } else {
          dir = 'reset';
        }
      }

      swiper.emit('transitionStart');

      if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
          swiper.emit('slideResetTransitionStart');
          return;
        }

        swiper.emit('slideChangeTransitionStart');

        if (dir === 'next') {
          swiper.emit('slideNextTransitionStart');
        } else {
          swiper.emit('slidePrevTransitionStart');
        }
      }
    }

    function transitionEnd$1(runCallbacks, direction) {
      if (runCallbacks === void 0) runCallbacks = true;
      var swiper = this;
      var activeIndex = swiper.activeIndex;
      var previousIndex = swiper.previousIndex;
      swiper.animating = false;
      swiper.setTransition(0);
      var dir = direction;

      if (!dir) {
        if (activeIndex > previousIndex) {
          dir = 'next';
        } else if (activeIndex < previousIndex) {
          dir = 'prev';
        } else {
          dir = 'reset';
        }
      }

      swiper.emit('transitionEnd');

      if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
          swiper.emit('slideResetTransitionEnd');
          return;
        }

        swiper.emit('slideChangeTransitionEnd');

        if (dir === 'next') {
          swiper.emit('slideNextTransitionEnd');
        } else {
          swiper.emit('slidePrevTransitionEnd');
        }
      }
    }

    var transition$1 = {
      setTransition: setTransition,
      transitionStart: transitionStart,
      transitionEnd: transitionEnd$1
    };

    function slideTo(index, speed, runCallbacks, internal) {
      if (index === void 0) index = 0;
      if (speed === void 0) speed = this.params.speed;
      if (runCallbacks === void 0) runCallbacks = true;
      var swiper = this;
      var slideIndex = index;

      if (slideIndex < 0) {
        slideIndex = 0;
      }

      var params = swiper.params;
      var snapGrid = swiper.snapGrid;
      var slidesGrid = swiper.slidesGrid;
      var previousIndex = swiper.previousIndex;
      var activeIndex = swiper.activeIndex;
      var rtl = swiper.rtlTranslate;

      if (swiper.animating && params.preventInteractionOnTransition) {
        return false;
      }

      var snapIndex = Math.floor(slideIndex / params.slidesPerGroup);

      if (snapIndex >= snapGrid.length) {
        snapIndex = snapGrid.length - 1;
      }

      if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
        swiper.emit('beforeSlideChangeStart');
      }

      var translate = -snapGrid[snapIndex]; // Update progress

      swiper.updateProgress(translate); // Normalize slideIndex

      if (params.normalizeSlideIndex) {
        for (var i = 0; i < slidesGrid.length; i += 1) {
          if (-Math.floor(translate * 100) >= Math.floor(slidesGrid[i] * 100)) {
            slideIndex = i;
          }
        }
      } // Directions locks


      if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
          return false;
        }

        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
          if ((activeIndex || 0) !== slideIndex) {
            return false;
          }
        }
      }

      var direction;

      if (slideIndex > activeIndex) {
        direction = 'next';
      } else if (slideIndex < activeIndex) {
        direction = 'prev';
      } else {
        direction = 'reset';
      } // Update Index


      if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height

        if (params.autoHeight) {
          swiper.updateAutoHeight();
        }

        swiper.updateSlidesClasses();

        if (params.effect !== 'slide') {
          swiper.setTranslate(translate);
        }

        if (direction !== 'reset') {
          swiper.transitionStart(runCallbacks, direction);
          swiper.transitionEnd(runCallbacks, direction);
        }

        return false;
      }

      if (speed === 0 || !Support.transition) {
        swiper.setTransition(0);
        swiper.setTranslate(translate);
        swiper.updateActiveIndex(slideIndex);
        swiper.updateSlidesClasses();
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.transitionStart(runCallbacks, direction);
        swiper.transitionEnd(runCallbacks, direction);
      } else {
        swiper.setTransition(speed);
        swiper.setTranslate(translate);
        swiper.updateActiveIndex(slideIndex);
        swiper.updateSlidesClasses();
        swiper.emit('beforeTransitionStart', speed, internal);
        swiper.transitionStart(runCallbacks, direction);

        if (!swiper.animating) {
          swiper.animating = true;

          if (!swiper.onSlideToWrapperTransitionEnd) {
            swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
              if (!swiper || swiper.destroyed) {
                return;
              }

              if (e.target !== this) {
                return;
              }

              swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
              swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
              swiper.onSlideToWrapperTransitionEnd = null;
              delete swiper.onSlideToWrapperTransitionEnd;
              swiper.transitionEnd(runCallbacks, direction);
            };
          }

          swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
          swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
        }
      }

      return true;
    }

    function slideToLoop(index, speed, runCallbacks, internal) {
      if (index === void 0) index = 0;
      if (speed === void 0) speed = this.params.speed;
      if (runCallbacks === void 0) runCallbacks = true;
      var swiper = this;
      var newIndex = index;

      if (swiper.params.loop) {
        newIndex += swiper.loopedSlides;
      }

      return swiper.slideTo(newIndex, speed, runCallbacks, internal);
    }
    /* eslint no-unused-vars: "off" */


    function slideNext(speed, runCallbacks, internal) {
      if (speed === void 0) speed = this.params.speed;
      if (runCallbacks === void 0) runCallbacks = true;
      var swiper = this;
      var params = swiper.params;
      var animating = swiper.animating;

      if (params.loop) {
        if (animating) {
          return false;
        }

        swiper.loopFix(); // eslint-disable-next-line

        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
        return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
      }

      return swiper.slideTo(swiper.activeIndex + params.slidesPerGroup, speed, runCallbacks, internal);
    }
    /* eslint no-unused-vars: "off" */


    function slidePrev(speed, runCallbacks, internal) {
      if (speed === void 0) speed = this.params.speed;
      if (runCallbacks === void 0) runCallbacks = true;
      var swiper = this;
      var params = swiper.params;
      var animating = swiper.animating;
      var snapGrid = swiper.snapGrid;
      var slidesGrid = swiper.slidesGrid;
      var rtlTranslate = swiper.rtlTranslate;

      if (params.loop) {
        if (animating) {
          return false;
        }

        swiper.loopFix(); // eslint-disable-next-line

        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
      }

      var translate = rtlTranslate ? swiper.translate : -swiper.translate;

      function normalize(val) {
        if (val < 0) {
          return -Math.floor(Math.abs(val));
        }

        return Math.floor(val);
      }

      var normalizedTranslate = normalize(translate);
      var normalizedSnapGrid = snapGrid.map(function (val) {
        return normalize(val);
      });
      var normalizedSlidesGrid = slidesGrid.map(function (val) {
        return normalize(val);
      });
      var currentSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate)];
      var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
      var prevIndex;

      if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);

        if (prevIndex < 0) {
          prevIndex = swiper.activeIndex - 1;
        }
      }

      return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
    }
    /* eslint no-unused-vars: "off" */


    function slideReset(speed, runCallbacks, internal) {
      if (speed === void 0) speed = this.params.speed;
      if (runCallbacks === void 0) runCallbacks = true;
      var swiper = this;
      return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
    }
    /* eslint no-unused-vars: "off" */


    function slideToClosest(speed, runCallbacks, internal) {
      if (speed === void 0) speed = this.params.speed;
      if (runCallbacks === void 0) runCallbacks = true;
      var swiper = this;
      var index = swiper.activeIndex;
      var snapIndex = Math.floor(index / swiper.params.slidesPerGroup);

      if (snapIndex < swiper.snapGrid.length - 1) {
        var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
        var currentSnap = swiper.snapGrid[snapIndex];
        var nextSnap = swiper.snapGrid[snapIndex + 1];

        if (translate - currentSnap > (nextSnap - currentSnap) / 2) {
          index = swiper.params.slidesPerGroup;
        }
      }

      return swiper.slideTo(index, speed, runCallbacks, internal);
    }

    function slideToClickedSlide() {
      var swiper = this;
      var params = swiper.params;
      var $wrapperEl = swiper.$wrapperEl;
      var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
      var slideToIndex = swiper.clickedIndex;
      var realIndex;

      if (params.loop) {
        if (swiper.animating) {
          return;
        }

        realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

        if (params.centeredSlides) {
          if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
            Utils.nextTick(function () {
              swiper.slideTo(slideToIndex);
            });
          } else {
            swiper.slideTo(slideToIndex);
          }
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
          swiper.loopFix();
          slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
          Utils.nextTick(function () {
            swiper.slideTo(slideToIndex);
          });
        } else {
          swiper.slideTo(slideToIndex);
        }
      } else {
        swiper.slideTo(slideToIndex);
      }
    }

    var slide = {
      slideTo: slideTo,
      slideToLoop: slideToLoop,
      slideNext: slideNext,
      slidePrev: slidePrev,
      slideReset: slideReset,
      slideToClosest: slideToClosest,
      slideToClickedSlide: slideToClickedSlide
    };

    function loopCreate() {
      var swiper = this;
      var params = swiper.params;
      var $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides

      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
      var slides = $wrapperEl.children("." + params.slideClass);

      if (params.loopFillGroupWithBlank) {
        var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

        if (blankSlidesNum !== params.slidesPerGroup) {
          for (var i = 0; i < blankSlidesNum; i += 1) {
            var blankNode = $(doc.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
            $wrapperEl.append(blankNode);
          }

          slides = $wrapperEl.children("." + params.slideClass);
        }
      }

      if (params.slidesPerView === 'auto' && !params.loopedSlides) {
        params.loopedSlides = slides.length;
      }

      swiper.loopedSlides = parseInt(params.loopedSlides || params.slidesPerView, 10);
      swiper.loopedSlides += params.loopAdditionalSlides;

      if (swiper.loopedSlides > slides.length) {
        swiper.loopedSlides = slides.length;
      }

      var prependSlides = [];
      var appendSlides = [];
      slides.each(function (index, el) {
        var slide = $(el);

        if (index < swiper.loopedSlides) {
          appendSlides.push(el);
        }

        if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
          prependSlides.push(el);
        }

        slide.attr('data-swiper-slide-index', index);
      });

      for (var i$1 = 0; i$1 < appendSlides.length; i$1 += 1) {
        $wrapperEl.append($(appendSlides[i$1].cloneNode(true)).addClass(params.slideDuplicateClass));
      }

      for (var i$2 = prependSlides.length - 1; i$2 >= 0; i$2 -= 1) {
        $wrapperEl.prepend($(prependSlides[i$2].cloneNode(true)).addClass(params.slideDuplicateClass));
      }
    }

    function loopFix() {
      var swiper = this;
      var params = swiper.params;
      var activeIndex = swiper.activeIndex;
      var slides = swiper.slides;
      var loopedSlides = swiper.loopedSlides;
      var allowSlidePrev = swiper.allowSlidePrev;
      var allowSlideNext = swiper.allowSlideNext;
      var snapGrid = swiper.snapGrid;
      var rtl = swiper.rtlTranslate;
      var newIndex;
      swiper.allowSlidePrev = true;
      swiper.allowSlideNext = true;
      var snapTranslate = -snapGrid[activeIndex];
      var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

      if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        var slideChanged = swiper.slideTo(newIndex, 0, false, true);

        if (slideChanged && diff !== 0) {
          swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
        }
      } else if (params.slidesPerView === 'auto' && activeIndex >= loopedSlides * 2 || activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        var slideChanged$1 = swiper.slideTo(newIndex, 0, false, true);

        if (slideChanged$1 && diff !== 0) {
          swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
        }
      }

      swiper.allowSlidePrev = allowSlidePrev;
      swiper.allowSlideNext = allowSlideNext;
    }

    function loopDestroy() {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl;
      var params = swiper.params;
      var slides = swiper.slides;
      $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
      slides.removeAttr('data-swiper-slide-index');
    }

    var loop = {
      loopCreate: loopCreate,
      loopFix: loopFix,
      loopDestroy: loopDestroy
    };

    function setGrabCursor(moving) {
      var swiper = this;

      if (Support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked) {
        return;
      }

      var el = swiper.el;
      el.style.cursor = 'move';
      el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
      el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
      el.style.cursor = moving ? 'grabbing' : 'grab';
    }

    function unsetGrabCursor() {
      var swiper = this;

      if (Support.touch || swiper.params.watchOverflow && swiper.isLocked) {
        return;
      }

      swiper.el.style.cursor = '';
    }

    var grabCursor = {
      setGrabCursor: setGrabCursor,
      unsetGrabCursor: unsetGrabCursor
    };

    function appendSlide(slides) {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl;
      var params = swiper.params;

      if (params.loop) {
        swiper.loopDestroy();
      }

      if (_typeof(slides) === 'object' && 'length' in slides) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) {
            $wrapperEl.append(slides[i]);
          }
        }
      } else {
        $wrapperEl.append(slides);
      }

      if (params.loop) {
        swiper.loopCreate();
      }

      if (!(params.observer && Support.observer)) {
        swiper.update();
      }
    }

    function prependSlide(slides) {
      var swiper = this;
      var params = swiper.params;
      var $wrapperEl = swiper.$wrapperEl;
      var activeIndex = swiper.activeIndex;

      if (params.loop) {
        swiper.loopDestroy();
      }

      var newActiveIndex = activeIndex + 1;

      if (_typeof(slides) === 'object' && 'length' in slides) {
        for (var i = 0; i < slides.length; i += 1) {
          if (slides[i]) {
            $wrapperEl.prepend(slides[i]);
          }
        }

        newActiveIndex = activeIndex + slides.length;
      } else {
        $wrapperEl.prepend(slides);
      }

      if (params.loop) {
        swiper.loopCreate();
      }

      if (!(params.observer && Support.observer)) {
        swiper.update();
      }

      swiper.slideTo(newActiveIndex, 0, false);
    }

    function addSlide(index, slides) {
      var swiper = this;
      var $wrapperEl = swiper.$wrapperEl;
      var params = swiper.params;
      var activeIndex = swiper.activeIndex;
      var activeIndexBuffer = activeIndex;

      if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children("." + params.slideClass);
      }

      var baseLength = swiper.slides.length;

      if (index <= 0) {
        swiper.prependSlide(slides);
        return;
      }

      if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
      }

      var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
      var slidesBuffer = [];

      for (var i = baseLength - 1; i >= index; i -= 1) {
        var currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
      }

      if (_typeof(slides) === 'object' && 'length' in slides) {
        for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
          if (slides[i$1]) {
            $wrapperEl.append(slides[i$1]);
          }
        }

        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
      } else {
        $wrapperEl.append(slides);
      }

      for (var i$2 = 0; i$2 < slidesBuffer.length; i$2 += 1) {
        $wrapperEl.append(slidesBuffer[i$2]);
      }

      if (params.loop) {
        swiper.loopCreate();
      }

      if (!(params.observer && Support.observer)) {
        swiper.update();
      }

      if (params.loop) {
        swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
      } else {
        swiper.slideTo(newActiveIndex, 0, false);
      }
    }

    function removeSlide(slidesIndexes) {
      var swiper = this;
      var params = swiper.params;
      var $wrapperEl = swiper.$wrapperEl;
      var activeIndex = swiper.activeIndex;
      var activeIndexBuffer = activeIndex;

      if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children("." + params.slideClass);
      }

      var newActiveIndex = activeIndexBuffer;
      var indexToRemove;

      if (_typeof(slidesIndexes) === 'object' && 'length' in slidesIndexes) {
        for (var i = 0; i < slidesIndexes.length; i += 1) {
          indexToRemove = slidesIndexes[i];

          if (swiper.slides[indexToRemove]) {
            swiper.slides.eq(indexToRemove).remove();
          }

          if (indexToRemove < newActiveIndex) {
            newActiveIndex -= 1;
          }
        }

        newActiveIndex = Math.max(newActiveIndex, 0);
      } else {
        indexToRemove = slidesIndexes;

        if (swiper.slides[indexToRemove]) {
          swiper.slides.eq(indexToRemove).remove();
        }

        if (indexToRemove < newActiveIndex) {
          newActiveIndex -= 1;
        }

        newActiveIndex = Math.max(newActiveIndex, 0);
      }

      if (params.loop) {
        swiper.loopCreate();
      }

      if (!(params.observer && Support.observer)) {
        swiper.update();
      }

      if (params.loop) {
        swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
      } else {
        swiper.slideTo(newActiveIndex, 0, false);
      }
    }

    function removeAllSlides() {
      var swiper = this;
      var slidesIndexes = [];

      for (var i = 0; i < swiper.slides.length; i += 1) {
        slidesIndexes.push(i);
      }

      swiper.removeSlide(slidesIndexes);
    }

    var manipulation = {
      appendSlide: appendSlide,
      prependSlide: prependSlide,
      addSlide: addSlide,
      removeSlide: removeSlide,
      removeAllSlides: removeAllSlides
    };

    var Device = function Device() {
      var ua = win.navigator.userAgent;
      var device = {
        ios: false,
        android: false,
        androidChrome: false,
        desktop: false,
        windows: false,
        iphone: false,
        ipod: false,
        ipad: false,
        cordova: win.cordova || win.phonegap,
        phonegap: win.cordova || win.phonegap
      };
      var windows = ua.match(/(Windows Phone);?[\s\/]+([\d.]+)?/); // eslint-disable-line

      var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

      var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
      var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
      var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/); // Windows

      if (windows) {
        device.os = 'windows';
        device.osVersion = windows[2];
        device.windows = true;
      } // Android


      if (android && !windows) {
        device.os = 'android';
        device.osVersion = android[2];
        device.android = true;
        device.androidChrome = ua.toLowerCase().indexOf('chrome') >= 0;
      }

      if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
      } // iOS


      if (iphone && !ipod) {
        device.osVersion = iphone[2].replace(/_/g, '.');
        device.iphone = true;
      }

      if (ipad) {
        device.osVersion = ipad[2].replace(/_/g, '.');
        device.ipad = true;
      }

      if (ipod) {
        device.osVersion = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
        device.iphone = true;
      } // iOS 8+ changed UA


      if (device.ios && device.osVersion && ua.indexOf('Version/') >= 0) {
        if (device.osVersion.split('.')[0] === '10') {
          device.osVersion = ua.toLowerCase().split('version/')[1].split(' ')[0];
        }
      } // Desktop


      device.desktop = !(device.os || device.android || device.webView); // Webview

      device.webView = (iphone || ipad || ipod) && ua.match(/.*AppleWebKit(?!.*Safari)/i); // Minimal UI

      if (device.os && device.os === 'ios') {
        var osVersionArr = device.osVersion.split('.');
        var metaViewport = doc.querySelector('meta[name="viewport"]');
        device.minimalUi = !device.webView && (ipod || iphone) && (osVersionArr[0] * 1 === 7 ? osVersionArr[1] * 1 >= 1 : osVersionArr[0] * 1 > 7) && metaViewport && metaViewport.getAttribute('content').indexOf('minimal-ui') >= 0;
      } // Pixel Ratio


      device.pixelRatio = win.devicePixelRatio || 1; // Export object

      return device;
    }();

    function onTouchStart(event) {
      var swiper = this;
      var data = swiper.touchEventsData;
      var params = swiper.params;
      var touches = swiper.touches;

      if (swiper.animating && params.preventInteractionOnTransition) {
        return;
      }

      var e = event;

      if (e.originalEvent) {
        e = e.originalEvent;
      }

      data.isTouchEvent = e.type === 'touchstart';

      if (!data.isTouchEvent && 'which' in e && e.which === 3) {
        return;
      }

      if (!data.isTouchEvent && 'button' in e && e.button > 0) {
        return;
      }

      if (data.isTouched && data.isMoved) {
        return;
      }

      if (params.noSwiping && $(e.target).closest(params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass)[0]) {
        swiper.allowClick = true;
        return;
      }

      if (params.swipeHandler) {
        if (!$(e).closest(params.swipeHandler)[0]) {
          return;
        }
      }

      touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
      touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
      var startX = touches.currentX;
      var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app (UIWebView) cannot swipe-to-go-back anymore

      var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
      var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

      if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= win.screen.width - edgeSwipeThreshold)) {
        return;
      }

      Utils.extend(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
      });
      touches.startX = startX;
      touches.startY = startY;
      data.touchStartTime = Utils.now();
      swiper.allowClick = true;
      swiper.updateSize();
      swiper.swipeDirection = undefined;

      if (params.threshold > 0) {
        data.allowThresholdMove = false;
      }

      if (e.type !== 'touchstart') {
        var preventDefault = true;

        if ($(e.target).is(data.formElements)) {
          preventDefault = false;
        }

        if (doc.activeElement && $(doc.activeElement).is(data.formElements) && doc.activeElement !== e.target) {
          doc.activeElement.blur();
        }

        var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

        if (params.touchStartForcePreventDefault || shouldPreventDefault) {
          e.preventDefault();
        }
      }

      swiper.emit('touchStart', e);
    }

    function onTouchMove(event) {
      var swiper = this;
      var data = swiper.touchEventsData;
      var params = swiper.params;
      var touches = swiper.touches;
      var rtl = swiper.rtlTranslate;
      var e = event;

      if (e.originalEvent) {
        e = e.originalEvent;
      }

      if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) {
          swiper.emit('touchMoveOpposite', e);
        }

        return;
      }

      if (data.isTouchEvent && e.type === 'mousemove') {
        return;
      }

      var pageX = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
      var pageY = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

      if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
      }

      if (!swiper.allowTouchMove) {
        // isMoved = true;
        swiper.allowClick = false;

        if (data.isTouched) {
          Utils.extend(touches, {
            startX: pageX,
            startY: pageY,
            currentX: pageX,
            currentY: pageY
          });
          data.touchStartTime = Utils.now();
        }

        return;
      }

      if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) {
          // Vertical
          if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
            data.isTouched = false;
            data.isMoved = false;
            return;
          }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
          return;
        }
      }

      if (data.isTouchEvent && doc.activeElement) {
        if (e.target === doc.activeElement && $(e.target).is(data.formElements)) {
          data.isMoved = true;
          swiper.allowClick = false;
          return;
        }
      }

      if (data.allowTouchCallbacks) {
        swiper.emit('touchMove', e);
      }

      if (e.targetTouches && e.targetTouches.length > 1) {
        return;
      }

      touches.currentX = pageX;
      touches.currentY = pageY;
      var diffX = touches.currentX - touches.startX;
      var diffY = touches.currentY - touches.startY;

      if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) {
        return;
      }

      if (typeof data.isScrolling === 'undefined') {
        var touchAngle;

        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
          data.isScrolling = false;
        } else {
          // eslint-disable-next-line
          if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
          }
        }
      }

      if (data.isScrolling) {
        swiper.emit('touchMoveOpposite', e);
      }

      if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
          data.startMoving = true;
        }
      }

      if (data.isScrolling) {
        data.isTouched = false;
        return;
      }

      if (!data.startMoving) {
        return;
      }

      swiper.allowClick = false;
      e.preventDefault();

      if (params.touchMoveStopPropagation && !params.nested) {
        e.stopPropagation();
      }

      if (!data.isMoved) {
        if (params.loop) {
          swiper.loopFix();
        }

        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);

        if (swiper.animating) {
          swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
        }

        data.allowMomentumBounce = false; // Grab Cursor

        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
          swiper.setGrabCursor(true);
        }

        swiper.emit('sliderFirstMove', e);
      }

      swiper.emit('sliderMove', e);
      data.isMoved = true;
      var diff = swiper.isHorizontal() ? diffX : diffY;
      touches.diff = diff;
      diff *= params.touchRatio;

      if (rtl) {
        diff = -diff;
      }

      swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
      data.currentTranslate = diff + data.startTranslate;
      var disableParentSwiper = true;
      var resistanceRatio = params.resistanceRatio;

      if (params.touchReleaseOnEdges) {
        resistanceRatio = 0;
      }

      if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;

        if (params.resistance) {
          data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
        }
      } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;

        if (params.resistance) {
          data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
        }
      }

      if (disableParentSwiper) {
        e.preventedByNestedSwiper = true;
      } // Directions locks


      if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
        data.currentTranslate = data.startTranslate;
      }

      if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
        data.currentTranslate = data.startTranslate;
      } // Threshold


      if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
          if (!data.allowThresholdMove) {
            data.allowThresholdMove = true;
            touches.startX = touches.currentX;
            touches.startY = touches.currentY;
            data.currentTranslate = data.startTranslate;
            touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
            return;
          }
        } else {
          data.currentTranslate = data.startTranslate;
          return;
        }
      }

      if (!params.followFinger) {
        return;
      } // Update active index in free mode


      if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }

      if (params.freeMode) {
        // Velocity
        if (data.velocities.length === 0) {
          data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
          });
        }

        data.velocities.push({
          position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
          time: Utils.now()
        });
      } // Update progress


      swiper.updateProgress(data.currentTranslate); // Update translate

      swiper.setTranslate(data.currentTranslate);
    }

    function onTouchEnd(event) {
      var swiper = this;
      var data = swiper.touchEventsData;
      var params = swiper.params;
      var touches = swiper.touches;
      var rtl = swiper.rtlTranslate;
      var $wrapperEl = swiper.$wrapperEl;
      var slidesGrid = swiper.slidesGrid;
      var snapGrid = swiper.snapGrid;
      var e = event;

      if (e.originalEvent) {
        e = e.originalEvent;
      }

      if (data.allowTouchCallbacks) {
        swiper.emit('touchEnd', e);
      }

      data.allowTouchCallbacks = false;

      if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) {
          swiper.setGrabCursor(false);
        }

        data.isMoved = false;
        data.startMoving = false;
        return;
      } // Return Grab Cursor


      if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
        swiper.setGrabCursor(false);
      } // Time diff


      var touchEndTime = Utils.now();
      var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

      if (swiper.allowClick) {
        swiper.updateClickedSlide(e);
        swiper.emit('tap', e);

        if (timeDiff < 300 && touchEndTime - data.lastClickTime > 300) {
          if (data.clickTimeout) {
            clearTimeout(data.clickTimeout);
          }

          data.clickTimeout = Utils.nextTick(function () {
            if (!swiper || swiper.destroyed) {
              return;
            }

            swiper.emit('click', e);
          }, 300);
        }

        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
          if (data.clickTimeout) {
            clearTimeout(data.clickTimeout);
          }

          swiper.emit('doubleTap', e);
        }
      }

      data.lastClickTime = Utils.now();
      Utils.nextTick(function () {
        if (!swiper.destroyed) {
          swiper.allowClick = true;
        }
      });

      if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
      }

      data.isTouched = false;
      data.isMoved = false;
      data.startMoving = false;
      var currentPos;

      if (params.followFinger) {
        currentPos = rtl ? swiper.translate : -swiper.translate;
      } else {
        currentPos = -data.currentTranslate;
      }

      if (params.freeMode) {
        if (currentPos < -swiper.minTranslate()) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }

        if (currentPos > -swiper.maxTranslate()) {
          if (swiper.slides.length < snapGrid.length) {
            swiper.slideTo(snapGrid.length - 1);
          } else {
            swiper.slideTo(swiper.slides.length - 1);
          }

          return;
        }

        if (params.freeModeMomentum) {
          if (data.velocities.length > 1) {
            var lastMoveEvent = data.velocities.pop();
            var velocityEvent = data.velocities.pop();
            var distance = lastMoveEvent.position - velocityEvent.position;
            var time = lastMoveEvent.time - velocityEvent.time;
            swiper.velocity = distance / time;
            swiper.velocity /= 2;

            if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
              swiper.velocity = 0;
            } // this implies that the user stopped moving a finger then released.
            // There would be no events with distance zero, so the last event is stale.


            if (time > 150 || Utils.now() - lastMoveEvent.time > 300) {
              swiper.velocity = 0;
            }
          } else {
            swiper.velocity = 0;
          }

          swiper.velocity *= params.freeModeMomentumVelocityRatio;
          data.velocities.length = 0;
          var momentumDuration = 1000 * params.freeModeMomentumRatio;
          var momentumDistance = swiper.velocity * momentumDuration;
          var newPosition = swiper.translate + momentumDistance;

          if (rtl) {
            newPosition = -newPosition;
          }

          var doBounce = false;
          var afterBouncePosition;
          var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
          var needsLoopFix;

          if (newPosition < swiper.maxTranslate()) {
            if (params.freeModeMomentumBounce) {
              if (newPosition + swiper.maxTranslate() < -bounceAmount) {
                newPosition = swiper.maxTranslate() - bounceAmount;
              }

              afterBouncePosition = swiper.maxTranslate();
              doBounce = true;
              data.allowMomentumBounce = true;
            } else {
              newPosition = swiper.maxTranslate();
            }

            if (params.loop && params.centeredSlides) {
              needsLoopFix = true;
            }
          } else if (newPosition > swiper.minTranslate()) {
            if (params.freeModeMomentumBounce) {
              if (newPosition - swiper.minTranslate() > bounceAmount) {
                newPosition = swiper.minTranslate() + bounceAmount;
              }

              afterBouncePosition = swiper.minTranslate();
              doBounce = true;
              data.allowMomentumBounce = true;
            } else {
              newPosition = swiper.minTranslate();
            }

            if (params.loop && params.centeredSlides) {
              needsLoopFix = true;
            }
          } else if (params.freeModeSticky) {
            var nextSlide;

            for (var j = 0; j < snapGrid.length; j += 1) {
              if (snapGrid[j] > -newPosition) {
                nextSlide = j;
                break;
              }
            }

            if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
              newPosition = snapGrid[nextSlide];
            } else {
              newPosition = snapGrid[nextSlide - 1];
            }

            newPosition = -newPosition;
          }

          if (needsLoopFix) {
            swiper.once('transitionEnd', function () {
              swiper.loopFix();
            });
          } // Fix duration


          if (swiper.velocity !== 0) {
            if (rtl) {
              momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
            } else {
              momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
            }
          } else if (params.freeModeSticky) {
            swiper.slideToClosest();
            return;
          }

          if (params.freeModeMomentumBounce && doBounce) {
            swiper.updateProgress(afterBouncePosition);
            swiper.setTransition(momentumDuration);
            swiper.setTranslate(newPosition);
            swiper.transitionStart(true, swiper.swipeDirection);
            swiper.animating = true;
            $wrapperEl.transitionEnd(function () {
              if (!swiper || swiper.destroyed || !data.allowMomentumBounce) {
                return;
              }

              swiper.emit('momentumBounce');
              swiper.setTransition(params.speed);
              swiper.setTranslate(afterBouncePosition);
              $wrapperEl.transitionEnd(function () {
                if (!swiper || swiper.destroyed) {
                  return;
                }

                swiper.transitionEnd();
              });
            });
          } else if (swiper.velocity) {
            swiper.updateProgress(newPosition);
            swiper.setTransition(momentumDuration);
            swiper.setTranslate(newPosition);
            swiper.transitionStart(true, swiper.swipeDirection);

            if (!swiper.animating) {
              swiper.animating = true;
              $wrapperEl.transitionEnd(function () {
                if (!swiper || swiper.destroyed) {
                  return;
                }

                swiper.transitionEnd();
              });
            }
          } else {
            swiper.updateProgress(newPosition);
          }

          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        } else if (params.freeModeSticky) {
          swiper.slideToClosest();
          return;
        }

        if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
          swiper.updateProgress();
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        }

        return;
      } // Find current slide


      var stopIndex = 0;
      var groupSize = swiper.slidesSizesGrid[0];

      for (var i = 0; i < slidesGrid.length; i += params.slidesPerGroup) {
        if (typeof slidesGrid[i + params.slidesPerGroup] !== 'undefined') {
          if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + params.slidesPerGroup]) {
            stopIndex = i;
            groupSize = slidesGrid[i + params.slidesPerGroup] - slidesGrid[i];
          }
        } else if (currentPos >= slidesGrid[i]) {
          stopIndex = i;
          groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
      } // Find current slide size


      var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;

      if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }

        if (swiper.swipeDirection === 'next') {
          if (ratio >= params.longSwipesRatio) {
            swiper.slideTo(stopIndex + params.slidesPerGroup);
          } else {
            swiper.slideTo(stopIndex);
          }
        }

        if (swiper.swipeDirection === 'prev') {
          if (ratio > 1 - params.longSwipesRatio) {
            swiper.slideTo(stopIndex + params.slidesPerGroup);
          } else {
            swiper.slideTo(stopIndex);
          }
        }
      } else {
        // Short swipes
        if (!params.shortSwipes) {
          swiper.slideTo(swiper.activeIndex);
          return;
        }

        if (swiper.swipeDirection === 'next') {
          swiper.slideTo(stopIndex + params.slidesPerGroup);
        }

        if (swiper.swipeDirection === 'prev') {
          swiper.slideTo(stopIndex);
        }
      }
    }

    function onResize() {
      var swiper = this;
      var params = swiper.params;
      var el = swiper.el;

      if (el && el.offsetWidth === 0) {
        return;
      } // Breakpoints


      if (params.breakpoints) {
        swiper.setBreakpoint();
      } // Save locks


      var allowSlideNext = swiper.allowSlideNext;
      var allowSlidePrev = swiper.allowSlidePrev;
      var snapGrid = swiper.snapGrid; // Disable locks on resize

      swiper.allowSlideNext = true;
      swiper.allowSlidePrev = true;
      swiper.updateSize();
      swiper.updateSlides();

      if (params.freeMode) {
        var newTranslate = Math.min(Math.max(swiper.translate, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if (params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        swiper.updateSlidesClasses();

        if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
          swiper.slideTo(swiper.slides.length - 1, 0, false, true);
        } else {
          swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
      }

      if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        swiper.autoplay.run();
      } // Return locks after resize


      swiper.allowSlidePrev = allowSlidePrev;
      swiper.allowSlideNext = allowSlideNext;

      if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
    }

    function onClick(e) {
      var swiper = this;

      if (!swiper.allowClick) {
        if (swiper.params.preventClicks) {
          e.preventDefault();
        }

        if (swiper.params.preventClicksPropagation && swiper.animating) {
          e.stopPropagation();
          e.stopImmediatePropagation();
        }
      }
    }

    function attachEvents() {
      var swiper = this;
      var params = swiper.params;
      var touchEvents = swiper.touchEvents;
      var el = swiper.el;
      var wrapperEl = swiper.wrapperEl;
      {
        swiper.onTouchStart = onTouchStart.bind(swiper);
        swiper.onTouchMove = onTouchMove.bind(swiper);
        swiper.onTouchEnd = onTouchEnd.bind(swiper);
      }
      swiper.onClick = onClick.bind(swiper);
      var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
      var capture = !!params.nested; // Touch Events

      {
        if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
          target.addEventListener(touchEvents.start, swiper.onTouchStart, false);
          doc.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
          doc.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
        } else {
          if (Support.touch) {
            var passiveListener = touchEvents.start === 'touchstart' && Support.passiveListener && params.passiveListeners ? {
              passive: true,
              capture: false
            } : false;
            target.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
            target.addEventListener(touchEvents.move, swiper.onTouchMove, Support.passiveListener ? {
              passive: false,
              capture: capture
            } : capture);
            target.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
          }

          if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
            target.addEventListener('mousedown', swiper.onTouchStart, false);
            doc.addEventListener('mousemove', swiper.onTouchMove, capture);
            doc.addEventListener('mouseup', swiper.onTouchEnd, false);
          }
        } // Prevent Links Clicks


        if (params.preventClicks || params.preventClicksPropagation) {
          target.addEventListener('click', swiper.onClick, true);
        }
      } // Resize handler

      swiper.on(Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
    }

    function detachEvents() {
      var swiper = this;
      var params = swiper.params;
      var touchEvents = swiper.touchEvents;
      var el = swiper.el;
      var wrapperEl = swiper.wrapperEl;
      var target = params.touchEventsTarget === 'container' ? el : wrapperEl;
      var capture = !!params.nested; // Touch Events

      {
        if (!Support.touch && (Support.pointerEvents || Support.prefixedPointerEvents)) {
          target.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
          doc.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
          doc.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
        } else {
          if (Support.touch) {
            var passiveListener = touchEvents.start === 'onTouchStart' && Support.passiveListener && params.passiveListeners ? {
              passive: true,
              capture: false
            } : false;
            target.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
            target.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
            target.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);
          }

          if (params.simulateTouch && !Device.ios && !Device.android || params.simulateTouch && !Support.touch && Device.ios) {
            target.removeEventListener('mousedown', swiper.onTouchStart, false);
            doc.removeEventListener('mousemove', swiper.onTouchMove, capture);
            doc.removeEventListener('mouseup', swiper.onTouchEnd, false);
          }
        } // Prevent Links Clicks


        if (params.preventClicks || params.preventClicksPropagation) {
          target.removeEventListener('click', swiper.onClick, true);
        }
      } // Resize handler

      swiper.off(Device.ios || Device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
    }

    var events = {
      attachEvents: attachEvents,
      detachEvents: detachEvents
    };

    function setBreakpoint() {
      var swiper = this;
      var activeIndex = swiper.activeIndex;
      var initialized = swiper.initialized;
      var loopedSlides = swiper.loopedSlides;
      if (loopedSlides === void 0) loopedSlides = 0;
      var params = swiper.params;
      var breakpoints = params.breakpoints;

      if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) {
        return;
      } // Set breakpoint for window width and update parameters


      var breakpoint = swiper.getBreakpoint(breakpoints);

      if (breakpoint && swiper.currentBreakpoint !== breakpoint) {
        var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;

        if (breakpointOnlyParams) {
          ['slidesPerView', 'spaceBetween', 'slidesPerGroup'].forEach(function (param) {
            var paramValue = breakpointOnlyParams[param];

            if (typeof paramValue === 'undefined') {
              return;
            }

            if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
              breakpointOnlyParams[param] = 'auto';
            } else if (param === 'slidesPerView') {
              breakpointOnlyParams[param] = parseFloat(paramValue);
            } else {
              breakpointOnlyParams[param] = parseInt(paramValue, 10);
            }
          });
        }

        var breakpointParams = breakpointOnlyParams || swiper.originalParams;
        var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
        var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

        if (directionChanged && initialized) {
          swiper.changeDirection();
        }

        Utils.extend(swiper.params, breakpointParams);
        Utils.extend(swiper, {
          allowTouchMove: swiper.params.allowTouchMove,
          allowSlideNext: swiper.params.allowSlideNext,
          allowSlidePrev: swiper.params.allowSlidePrev
        });
        swiper.currentBreakpoint = breakpoint;

        if (needsReLoop && initialized) {
          swiper.loopDestroy();
          swiper.loopCreate();
          swiper.updateSlides();
          swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
        }

        swiper.emit('breakpoint', breakpointParams);
      }
    }

    function getBreakpoint(breakpoints) {
      var swiper = this; // Get breakpoint for window width

      if (!breakpoints) {
        return undefined;
      }

      var breakpoint = false;
      var points = [];
      Object.keys(breakpoints).forEach(function (point) {
        points.push(point);
      });
      points.sort(function (a, b) {
        return parseInt(a, 10) - parseInt(b, 10);
      });

      for (var i = 0; i < points.length; i += 1) {
        var point = points[i];

        if (swiper.params.breakpointsInverse) {
          if (point <= win.innerWidth) {
            breakpoint = point;
          }
        } else if (point >= win.innerWidth && !breakpoint) {
          breakpoint = point;
        }
      }

      return breakpoint || 'max';
    }

    var breakpoints = {
      setBreakpoint: setBreakpoint,
      getBreakpoint: getBreakpoint
    };

    function addClasses() {
      var swiper = this;
      var classNames = swiper.classNames;
      var params = swiper.params;
      var rtl = swiper.rtl;
      var $el = swiper.$el;
      var suffixes = [];
      suffixes.push('initialized');
      suffixes.push(params.direction);

      if (params.freeMode) {
        suffixes.push('free-mode');
      }

      if (!Support.flexbox) {
        suffixes.push('no-flexbox');
      }

      if (params.autoHeight) {
        suffixes.push('autoheight');
      }

      if (rtl) {
        suffixes.push('rtl');
      }

      if (params.slidesPerColumn > 1) {
        suffixes.push('multirow');
      }

      if (Device.android) {
        suffixes.push('android');
      }

      if (Device.ios) {
        suffixes.push('ios');
      } // WP8 Touch Events Fix


      if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
        suffixes.push("wp8-" + params.direction);
      }

      suffixes.forEach(function (suffix) {
        classNames.push(params.containerModifierClass + suffix);
      });
      $el.addClass(classNames.join(' '));
    }

    function removeClasses() {
      var swiper = this;
      var $el = swiper.$el;
      var classNames = swiper.classNames;
      $el.removeClass(classNames.join(' '));
    }

    var classes = {
      addClasses: addClasses,
      removeClasses: removeClasses
    };

    function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
      var image;

      function onReady() {
        if (callback) {
          callback();
        }
      }

      if (!imageEl.complete || !checkForComplete) {
        if (src) {
          image = new win.Image();
          image.onload = onReady;
          image.onerror = onReady;

          if (sizes) {
            image.sizes = sizes;
          }

          if (srcset) {
            image.srcset = srcset;
          }

          if (src) {
            image.src = src;
          }
        } else {
          onReady();
        }
      } else {
        // image already loaded...
        onReady();
      }
    }

    function preloadImages() {
      var swiper = this;
      swiper.imagesToLoad = swiper.$el.find('img');

      function onReady() {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) {
          return;
        }

        if (swiper.imagesLoaded !== undefined) {
          swiper.imagesLoaded += 1;
        }

        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
          if (swiper.params.updateOnImagesReady) {
            swiper.update();
          }

          swiper.emit('imagesReady');
        }
      }

      for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
        var imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
      }
    }

    var images = {
      loadImage: loadImage,
      preloadImages: preloadImages
    };

    function checkOverflow() {
      var swiper = this;
      var wasLocked = swiper.isLocked;
      swiper.isLocked = swiper.snapGrid.length === 1;
      swiper.allowSlideNext = !swiper.isLocked;
      swiper.allowSlidePrev = !swiper.isLocked; // events

      if (wasLocked !== swiper.isLocked) {
        swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
      }

      if (wasLocked && wasLocked !== swiper.isLocked) {
        swiper.isEnd = false;
        swiper.navigation.update();
      }
    }

    var checkOverflow$1 = {
      checkOverflow: checkOverflow
    };
    var defaults = {
      init: true,
      direction: 'horizontal',
      touchEventsTarget: 'container',
      initialSlide: 0,
      speed: 300,
      //
      preventInteractionOnTransition: false,
      // To support iOS's swipe-to-go-back gesture (when being used in-app, with UIWebView).
      edgeSwipeDetection: false,
      edgeSwipeThreshold: 20,
      // Free mode
      freeMode: false,
      freeModeMomentum: true,
      freeModeMomentumRatio: 1,
      freeModeMomentumBounce: true,
      freeModeMomentumBounceRatio: 1,
      freeModeMomentumVelocityRatio: 1,
      freeModeSticky: false,
      freeModeMinimumVelocity: 0.02,
      // Autoheight
      autoHeight: false,
      // Set wrapper width
      setWrapperSize: false,
      // Virtual Translate
      virtualTranslate: false,
      // Effects
      effect: 'slide',
      // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
      // Breakpoints
      breakpoints: undefined,
      breakpointsInverse: false,
      // Slides grid
      spaceBetween: 0,
      slidesPerView: 1,
      slidesPerColumn: 1,
      slidesPerColumnFill: 'column',
      slidesPerGroup: 1,
      centeredSlides: false,
      slidesOffsetBefore: 0,
      // in px
      slidesOffsetAfter: 0,
      // in px
      normalizeSlideIndex: true,
      centerInsufficientSlides: false,
      // Disable swiper and hide navigation when container not overflow
      watchOverflow: false,
      // Round length
      roundLengths: false,
      // Touches
      touchRatio: 1,
      touchAngle: 45,
      simulateTouch: true,
      shortSwipes: true,
      longSwipes: true,
      longSwipesRatio: 0.5,
      longSwipesMs: 300,
      followFinger: true,
      allowTouchMove: true,
      threshold: 0,
      touchMoveStopPropagation: true,
      touchStartPreventDefault: true,
      touchStartForcePreventDefault: false,
      touchReleaseOnEdges: false,
      // Unique Navigation Elements
      uniqueNavElements: true,
      // Resistance
      resistance: true,
      resistanceRatio: 0.85,
      // Progress
      watchSlidesProgress: false,
      watchSlidesVisibility: false,
      // Cursor
      grabCursor: false,
      // Clicks
      preventClicks: true,
      preventClicksPropagation: true,
      slideToClickedSlide: false,
      // Images
      preloadImages: true,
      updateOnImagesReady: true,
      // loop
      loop: false,
      loopAdditionalSlides: 0,
      loopedSlides: null,
      loopFillGroupWithBlank: false,
      // Swiping/no swiping
      allowSlidePrev: true,
      allowSlideNext: true,
      swipeHandler: null,
      // '.swipe-handler',
      noSwiping: true,
      noSwipingClass: 'swiper-no-swiping',
      noSwipingSelector: null,
      // Passive Listeners
      passiveListeners: true,
      // NS
      containerModifierClass: 'swiper-container-',
      // NEW
      slideClass: 'swiper-slide',
      slideBlankClass: 'swiper-slide-invisible-blank',
      slideActiveClass: 'swiper-slide-active',
      slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
      slideVisibleClass: 'swiper-slide-visible',
      slideDuplicateClass: 'swiper-slide-duplicate',
      slideNextClass: 'swiper-slide-next',
      slideDuplicateNextClass: 'swiper-slide-duplicate-next',
      slidePrevClass: 'swiper-slide-prev',
      slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
      wrapperClass: 'swiper-wrapper',
      // Callbacks
      runCallbacksOnInit: true
    };
    /* eslint no-param-reassign: "off" */

    var prototypes = {
      update: update,
      translate: translate,
      transition: transition$1,
      slide: slide,
      loop: loop,
      grabCursor: grabCursor,
      manipulation: manipulation,
      events: events,
      breakpoints: breakpoints,
      checkOverflow: checkOverflow$1,
      classes: classes,
      images: images
    };
    var extendedDefaults = {};

    var Swiper = /*@__PURE__*/function (SwiperClass) {
      function Swiper() {
        var assign;
        var args = [],
            len = arguments.length;

        while (len--) args[len] = arguments[len];

        var el;
        var params;

        if (args.length === 1 && args[0].constructor && args[0].constructor === Object) {
          params = args[0];
        } else {
          assign = args, el = assign[0], params = assign[1];
        }

        if (!params) {
          params = {};
        }

        params = Utils.extend({}, params);

        if (el && !params.el) {
          params.el = el;
        }

        SwiperClass.call(this, params);
        Object.keys(prototypes).forEach(function (prototypeGroup) {
          Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
            if (!Swiper.prototype[protoMethod]) {
              Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
            }
          });
        }); // Swiper Instance

        var swiper = this;

        if (typeof swiper.modules === 'undefined') {
          swiper.modules = {};
        }

        Object.keys(swiper.modules).forEach(function (moduleName) {
          var module = swiper.modules[moduleName];

          if (module.params) {
            var moduleParamName = Object.keys(module.params)[0];
            var moduleParams = module.params[moduleParamName];

            if (_typeof(moduleParams) !== 'object' || moduleParams === null) {
              return;
            }

            if (!(moduleParamName in params && 'enabled' in moduleParams)) {
              return;
            }

            if (params[moduleParamName] === true) {
              params[moduleParamName] = {
                enabled: true
              };
            }

            if (_typeof(params[moduleParamName]) === 'object' && !('enabled' in params[moduleParamName])) {
              params[moduleParamName].enabled = true;
            }

            if (!params[moduleParamName]) {
              params[moduleParamName] = {
                enabled: false
              };
            }
          }
        }); // Extend defaults with modules params

        var swiperParams = Utils.extend({}, defaults);
        swiper.useModulesParams(swiperParams); // Extend defaults with passed params

        swiper.params = Utils.extend({}, swiperParams, extendedDefaults, params);
        swiper.originalParams = Utils.extend({}, swiper.params);
        swiper.passedParams = Utils.extend({}, params); // Save Dom lib

        swiper.$ = $; // Find el

        var $el = $(swiper.params.el);
        el = $el[0];

        if (!el) {
          return undefined;
        }

        if ($el.length > 1) {
          var swipers = [];
          $el.each(function (index, containerEl) {
            var newParams = Utils.extend({}, params, {
              el: containerEl
            });
            swipers.push(new Swiper(newParams));
          });
          return swipers;
        }

        el.swiper = swiper;
        $el.data('swiper', swiper); // Find Wrapper

        var $wrapperEl = $el.children("." + swiper.params.wrapperClass); // Extend Swiper

        Utils.extend(swiper, {
          $el: $el,
          el: el,
          $wrapperEl: $wrapperEl,
          wrapperEl: $wrapperEl[0],
          // Classes
          classNames: [],
          // Slides
          slides: $(),
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],
          // isDirection
          isHorizontal: function isHorizontal() {
            return swiper.params.direction === 'horizontal';
          },
          isVertical: function isVertical() {
            return swiper.params.direction === 'vertical';
          },
          // RTL
          rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
          rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
          wrongRTL: $wrapperEl.css('display') === '-webkit-box',
          // Indexes
          activeIndex: 0,
          realIndex: 0,
          //
          isBeginning: true,
          isEnd: false,
          // Props
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: false,
          // Locks
          allowSlideNext: swiper.params.allowSlideNext,
          allowSlidePrev: swiper.params.allowSlidePrev,
          // Touch Events
          touchEvents: function touchEvents() {
            var touch = ['touchstart', 'touchmove', 'touchend'];
            var desktop = ['mousedown', 'mousemove', 'mouseup'];

            if (Support.pointerEvents) {
              desktop = ['pointerdown', 'pointermove', 'pointerup'];
            } else if (Support.prefixedPointerEvents) {
              desktop = ['MSPointerDown', 'MSPointerMove', 'MSPointerUp'];
            }

            swiper.touchEventsTouch = {
              start: touch[0],
              move: touch[1],
              end: touch[2]
            };
            swiper.touchEventsDesktop = {
              start: desktop[0],
              move: desktop[1],
              end: desktop[2]
            };
            return Support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
          }(),
          touchEventsData: {
            isTouched: undefined,
            isMoved: undefined,
            allowTouchCallbacks: undefined,
            touchStartTime: undefined,
            isScrolling: undefined,
            currentTranslate: undefined,
            startTranslate: undefined,
            allowThresholdMove: undefined,
            // Form elements to match
            formElements: 'input, select, option, textarea, button, video',
            // Last click time
            lastClickTime: Utils.now(),
            clickTimeout: undefined,
            // Velocities
            velocities: [],
            allowMomentumBounce: undefined,
            isTouchEvent: undefined,
            startMoving: undefined
          },
          // Clicks
          allowClick: true,
          // Touches
          allowTouchMove: swiper.params.allowTouchMove,
          touches: {
            startX: 0,
            startY: 0,
            currentX: 0,
            currentY: 0,
            diff: 0
          },
          // Images
          imagesToLoad: [],
          imagesLoaded: 0
        }); // Install Modules

        swiper.useModules(); // Init

        if (swiper.params.init) {
          swiper.init();
        } // Return app instance


        return swiper;
      }

      if (SwiperClass) Swiper.__proto__ = SwiperClass;
      Swiper.prototype = Object.create(SwiperClass && SwiperClass.prototype);
      Swiper.prototype.constructor = Swiper;
      var staticAccessors = {
        extendedDefaults: {
          configurable: true
        },
        defaults: {
          configurable: true
        },
        Class: {
          configurable: true
        },
        $: {
          configurable: true
        }
      };

      Swiper.prototype.slidesPerViewDynamic = function slidesPerViewDynamic() {
        var swiper = this;
        var params = swiper.params;
        var slides = swiper.slides;
        var slidesGrid = swiper.slidesGrid;
        var swiperSize = swiper.size;
        var activeIndex = swiper.activeIndex;
        var spv = 1;

        if (params.centeredSlides) {
          var slideSize = slides[activeIndex].swiperSlideSize;
          var breakLoop;

          for (var i = activeIndex + 1; i < slides.length; i += 1) {
            if (slides[i] && !breakLoop) {
              slideSize += slides[i].swiperSlideSize;
              spv += 1;

              if (slideSize > swiperSize) {
                breakLoop = true;
              }
            }
          }

          for (var i$1 = activeIndex - 1; i$1 >= 0; i$1 -= 1) {
            if (slides[i$1] && !breakLoop) {
              slideSize += slides[i$1].swiperSlideSize;
              spv += 1;

              if (slideSize > swiperSize) {
                breakLoop = true;
              }
            }
          }
        } else {
          for (var i$2 = activeIndex + 1; i$2 < slides.length; i$2 += 1) {
            if (slidesGrid[i$2] - slidesGrid[activeIndex] < swiperSize) {
              spv += 1;
            }
          }
        }

        return spv;
      };

      Swiper.prototype.update = function update() {
        var swiper = this;

        if (!swiper || swiper.destroyed) {
          return;
        }

        var snapGrid = swiper.snapGrid;
        var params = swiper.params; // Breakpoints

        if (params.breakpoints) {
          swiper.setBreakpoint();
        }

        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();

        function setTranslate() {
          var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
          var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
          swiper.setTranslate(newTranslate);
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();
        }

        var translated;

        if (swiper.params.freeMode) {
          setTranslate();

          if (swiper.params.autoHeight) {
            swiper.updateAutoHeight();
          }
        } else {
          if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
            translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
          } else {
            translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
          }

          if (!translated) {
            setTranslate();
          }
        }

        if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
          swiper.checkOverflow();
        }

        swiper.emit('update');
      };

      Swiper.prototype.changeDirection = function changeDirection(newDirection, needUpdate) {
        if (needUpdate === void 0) needUpdate = true;
        var swiper = this;
        var currentDirection = swiper.params.direction;

        if (!newDirection) {
          // eslint-disable-next-line
          newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        }

        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
          return swiper;
        }

        swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection + " wp8-" + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);

        if ((Browser.isIE || Browser.isEdge) && (Support.pointerEvents || Support.prefixedPointerEvents)) {
          swiper.$el.addClass(swiper.params.containerModifierClass + "wp8-" + newDirection);
        }

        swiper.params.direction = newDirection;
        swiper.slides.each(function (slideIndex, slideEl) {
          if (newDirection === 'vertical') {
            slideEl.style.width = '';
          } else {
            slideEl.style.height = '';
          }
        });
        swiper.emit('changeDirection');

        if (needUpdate) {
          swiper.update();
        }

        return swiper;
      };

      Swiper.prototype.init = function init() {
        var swiper = this;

        if (swiper.initialized) {
          return;
        }

        swiper.emit('beforeInit'); // Set breakpoint

        if (swiper.params.breakpoints) {
          swiper.setBreakpoint();
        } // Add Classes


        swiper.addClasses(); // Create loop

        if (swiper.params.loop) {
          swiper.loopCreate();
        } // Update size


        swiper.updateSize(); // Update slides

        swiper.updateSlides();

        if (swiper.params.watchOverflow) {
          swiper.checkOverflow();
        } // Set Grab Cursor


        if (swiper.params.grabCursor) {
          swiper.setGrabCursor();
        }

        if (swiper.params.preloadImages) {
          swiper.preloadImages();
        } // Slide To Initial Slide


        if (swiper.params.loop) {
          swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit);
        } else {
          swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit);
        } // Attach events


        swiper.attachEvents(); // Init Flag

        swiper.initialized = true; // Emit

        swiper.emit('init');
      };

      Swiper.prototype.destroy = function destroy(deleteInstance, cleanStyles) {
        if (deleteInstance === void 0) deleteInstance = true;
        if (cleanStyles === void 0) cleanStyles = true;
        var swiper = this;
        var params = swiper.params;
        var $el = swiper.$el;
        var $wrapperEl = swiper.$wrapperEl;
        var slides = swiper.slides;

        if (typeof swiper.params === 'undefined' || swiper.destroyed) {
          return null;
        }

        swiper.emit('beforeDestroy'); // Init Flag

        swiper.initialized = false; // Detach events

        swiper.detachEvents(); // Destroy loop

        if (params.loop) {
          swiper.loopDestroy();
        } // Cleanup styles


        if (cleanStyles) {
          swiper.removeClasses();
          $el.removeAttr('style');
          $wrapperEl.removeAttr('style');

          if (slides && slides.length) {
            slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index').removeAttr('data-swiper-column').removeAttr('data-swiper-row');
          }
        }

        swiper.emit('destroy'); // Detach emitter events

        Object.keys(swiper.eventsListeners).forEach(function (eventName) {
          swiper.off(eventName);
        });

        if (deleteInstance !== false) {
          swiper.$el[0].swiper = null;
          swiper.$el.data('swiper', null);
          Utils.deleteProps(swiper);
        }

        swiper.destroyed = true;
        return null;
      };

      Swiper.extendDefaults = function extendDefaults(newDefaults) {
        Utils.extend(extendedDefaults, newDefaults);
      };

      staticAccessors.extendedDefaults.get = function () {
        return extendedDefaults;
      };

      staticAccessors.defaults.get = function () {
        return defaults;
      };

      staticAccessors.Class.get = function () {
        return SwiperClass;
      };

      staticAccessors.$.get = function () {
        return $;
      };

      Object.defineProperties(Swiper, staticAccessors);
      return Swiper;
    }(SwiperClass);

    var Device$1 = {
      name: 'device',
      proto: {
        device: Device
      },
      "static": {
        device: Device
      }
    };
    var Support$1 = {
      name: 'support',
      proto: {
        support: Support
      },
      "static": {
        support: Support
      }
    };
    var Browser$1 = {
      name: 'browser',
      proto: {
        browser: Browser
      },
      "static": {
        browser: Browser
      }
    };
    var Resize = {
      name: 'resize',
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          resize: {
            resizeHandler: function resizeHandler() {
              if (!swiper || swiper.destroyed || !swiper.initialized) {
                return;
              }

              swiper.emit('beforeResize');
              swiper.emit('resize');
            },
            orientationChangeHandler: function orientationChangeHandler() {
              if (!swiper || swiper.destroyed || !swiper.initialized) {
                return;
              }

              swiper.emit('orientationchange');
            }
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this; // Emit resize

          win.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange

          win.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
        },
        destroy: function destroy() {
          var swiper = this;
          win.removeEventListener('resize', swiper.resize.resizeHandler);
          win.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
        }
      }
    };
    var Observer = {
      func: win.MutationObserver || win.WebkitMutationObserver,
      attach: function attach(target, options) {
        if (options === void 0) options = {};
        var swiper = this;
        var ObserverFunc = Observer.func;
        var observer = new ObserverFunc(function (mutations) {
          // The observerUpdate event should only be triggered
          // once despite the number of mutations.  Additional
          // triggers are redundant and are very costly
          if (mutations.length === 1) {
            swiper.emit('observerUpdate', mutations[0]);
            return;
          }

          var observerUpdate = function observerUpdate() {
            swiper.emit('observerUpdate', mutations[0]);
          };

          if (win.requestAnimationFrame) {
            win.requestAnimationFrame(observerUpdate);
          } else {
            win.setTimeout(observerUpdate, 0);
          }
        });
        observer.observe(target, {
          attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
          childList: typeof options.childList === 'undefined' ? true : options.childList,
          characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        swiper.observer.observers.push(observer);
      },
      init: function init() {
        var swiper = this;

        if (!Support.observer || !swiper.params.observer) {
          return;
        }

        if (swiper.params.observeParents) {
          var containerParents = swiper.$el.parents();

          for (var i = 0; i < containerParents.length; i += 1) {
            swiper.observer.attach(containerParents[i]);
          }
        } // Observe container


        swiper.observer.attach(swiper.$el[0], {
          childList: swiper.params.observeSlideChildren
        }); // Observe wrapper

        swiper.observer.attach(swiper.$wrapperEl[0], {
          attributes: false
        });
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.observer.observers.forEach(function (observer) {
          observer.disconnect();
        });
        swiper.observer.observers = [];
      }
    };
    var Observer$1 = {
      name: 'observer',
      params: {
        observer: false,
        observeParents: false,
        observeSlideChildren: false
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          observer: {
            init: Observer.init.bind(swiper),
            attach: Observer.attach.bind(swiper),
            destroy: Observer.destroy.bind(swiper),
            observers: []
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;
          swiper.observer.init();
        },
        destroy: function destroy() {
          var swiper = this;
          swiper.observer.destroy();
        }
      }
    };
    var Virtual = {
      update: function update(force) {
        var swiper = this;
        var ref = swiper.params;
        var slidesPerView = ref.slidesPerView;
        var slidesPerGroup = ref.slidesPerGroup;
        var centeredSlides = ref.centeredSlides;
        var ref$1 = swiper.params.virtual;
        var addSlidesBefore = ref$1.addSlidesBefore;
        var addSlidesAfter = ref$1.addSlidesAfter;
        var ref$2 = swiper.virtual;
        var previousFrom = ref$2.from;
        var previousTo = ref$2.to;
        var slides = ref$2.slides;
        var previousSlidesGrid = ref$2.slidesGrid;
        var renderSlide = ref$2.renderSlide;
        var previousOffset = ref$2.offset;
        swiper.updateActiveIndex();
        var activeIndex = swiper.activeIndex || 0;
        var offsetProp;

        if (swiper.rtlTranslate) {
          offsetProp = 'right';
        } else {
          offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        }

        var slidesAfter;
        var slidesBefore;

        if (centeredSlides) {
          slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
          slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
        } else {
          slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesBefore;
          slidesBefore = slidesPerGroup + addSlidesAfter;
        }

        var from = Math.max((activeIndex || 0) - slidesBefore, 0);
        var to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Utils.extend(swiper.virtual, {
          from: from,
          to: to,
          offset: offset,
          slidesGrid: swiper.slidesGrid
        });

        function onRendered() {
          swiper.updateSlides();
          swiper.updateProgress();
          swiper.updateSlidesClasses();

          if (swiper.lazy && swiper.params.lazy.enabled) {
            swiper.lazy.load();
          }
        }

        if (previousFrom === from && previousTo === to && !force) {
          if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) {
            swiper.slides.css(offsetProp, offset + "px");
          }

          swiper.updateProgress();
          return;
        }

        if (swiper.params.virtual.renderExternal) {
          swiper.params.virtual.renderExternal.call(swiper, {
            offset: offset,
            from: from,
            to: to,
            slides: function getSlides() {
              var slidesToRender = [];

              for (var i = from; i <= to; i += 1) {
                slidesToRender.push(slides[i]);
              }

              return slidesToRender;
            }()
          });
          onRendered();
          return;
        }

        var prependIndexes = [];
        var appendIndexes = [];

        if (force) {
          swiper.$wrapperEl.find("." + swiper.params.slideClass).remove();
        } else {
          for (var i = previousFrom; i <= previousTo; i += 1) {
            if (i < from || i > to) {
              swiper.$wrapperEl.find("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + i + "\"]").remove();
            }
          }
        }

        for (var i$1 = 0; i$1 < slides.length; i$1 += 1) {
          if (i$1 >= from && i$1 <= to) {
            if (typeof previousTo === 'undefined' || force) {
              appendIndexes.push(i$1);
            } else {
              if (i$1 > previousTo) {
                appendIndexes.push(i$1);
              }

              if (i$1 < previousFrom) {
                prependIndexes.push(i$1);
              }
            }
          }
        }

        appendIndexes.forEach(function (index) {
          swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort(function (a, b) {
          return b - a;
        }).forEach(function (index) {
          swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, offset + "px");
        onRendered();
      },
      renderSlide: function renderSlide(slide, index) {
        var swiper = this;
        var params = swiper.params.virtual;

        if (params.cache && swiper.virtual.cache[index]) {
          return swiper.virtual.cache[index];
        }

        var $slideEl = params.renderSlide ? $(params.renderSlide.call(swiper, slide, index)) : $("<div class=\"" + swiper.params.slideClass + "\" data-swiper-slide-index=\"" + index + "\">" + slide + "</div>");

        if (!$slideEl.attr('data-swiper-slide-index')) {
          $slideEl.attr('data-swiper-slide-index', index);
        }

        if (params.cache) {
          swiper.virtual.cache[index] = $slideEl;
        }

        return $slideEl;
      },
      appendSlide: function appendSlide(slides) {
        var swiper = this;

        if (_typeof(slides) === 'object' && 'length' in slides) {
          for (var i = 0; i < slides.length; i += 1) {
            if (slides[i]) {
              swiper.virtual.slides.push(slides[i]);
            }
          }
        } else {
          swiper.virtual.slides.push(slides);
        }

        swiper.virtual.update(true);
      },
      prependSlide: function prependSlide(slides) {
        var swiper = this;
        var activeIndex = swiper.activeIndex;
        var newActiveIndex = activeIndex + 1;
        var numberOfNewSlides = 1;

        if (Array.isArray(slides)) {
          for (var i = 0; i < slides.length; i += 1) {
            if (slides[i]) {
              swiper.virtual.slides.unshift(slides[i]);
            }
          }

          newActiveIndex = activeIndex + slides.length;
          numberOfNewSlides = slides.length;
        } else {
          swiper.virtual.slides.unshift(slides);
        }

        if (swiper.params.virtual.cache) {
          var cache = swiper.virtual.cache;
          var newCache = {};
          Object.keys(cache).forEach(function (cachedIndex) {
            newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cache[cachedIndex];
          });
          swiper.virtual.cache = newCache;
        }

        swiper.virtual.update(true);
        swiper.slideTo(newActiveIndex, 0);
      },
      removeSlide: function removeSlide(slidesIndexes) {
        var swiper = this;

        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) {
          return;
        }

        var activeIndex = swiper.activeIndex;

        if (Array.isArray(slidesIndexes)) {
          for (var i = slidesIndexes.length - 1; i >= 0; i -= 1) {
            swiper.virtual.slides.splice(slidesIndexes[i], 1);

            if (swiper.params.virtual.cache) {
              delete swiper.virtual.cache[slidesIndexes[i]];
            }

            if (slidesIndexes[i] < activeIndex) {
              activeIndex -= 1;
            }

            activeIndex = Math.max(activeIndex, 0);
          }
        } else {
          swiper.virtual.slides.splice(slidesIndexes, 1);

          if (swiper.params.virtual.cache) {
            delete swiper.virtual.cache[slidesIndexes];
          }

          if (slidesIndexes < activeIndex) {
            activeIndex -= 1;
          }

          activeIndex = Math.max(activeIndex, 0);
        }

        swiper.virtual.update(true);
        swiper.slideTo(activeIndex, 0);
      },
      removeAllSlides: function removeAllSlides() {
        var swiper = this;
        swiper.virtual.slides = [];

        if (swiper.params.virtual.cache) {
          swiper.virtual.cache = {};
        }

        swiper.virtual.update(true);
        swiper.slideTo(0, 0);
      }
    };
    var Virtual$1 = {
      name: 'virtual',
      params: {
        virtual: {
          enabled: false,
          slides: [],
          cache: true,
          renderSlide: null,
          renderExternal: null,
          addSlidesBefore: 0,
          addSlidesAfter: 0
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          virtual: {
            update: Virtual.update.bind(swiper),
            appendSlide: Virtual.appendSlide.bind(swiper),
            prependSlide: Virtual.prependSlide.bind(swiper),
            removeSlide: Virtual.removeSlide.bind(swiper),
            removeAllSlides: Virtual.removeAllSlides.bind(swiper),
            renderSlide: Virtual.renderSlide.bind(swiper),
            slides: swiper.params.virtual.slides,
            cache: {}
          }
        });
      },
      on: {
        beforeInit: function beforeInit() {
          var swiper = this;

          if (!swiper.params.virtual.enabled) {
            return;
          }

          swiper.classNames.push(swiper.params.containerModifierClass + "virtual");
          var overwriteParams = {
            watchSlidesProgress: true
          };
          Utils.extend(swiper.params, overwriteParams);
          Utils.extend(swiper.originalParams, overwriteParams);

          if (!swiper.params.initialSlide) {
            swiper.virtual.update();
          }
        },
        setTranslate: function setTranslate() {
          var swiper = this;

          if (!swiper.params.virtual.enabled) {
            return;
          }

          swiper.virtual.update();
        }
      }
    };
    var Keyboard = {
      handle: function handle(event) {
        var swiper = this;
        var rtl = swiper.rtlTranslate;
        var e = event;

        if (e.originalEvent) {
          e = e.originalEvent;
        } // jquery fix


        var kc = e.keyCode || e.charCode; // Directions locks

        if (!swiper.allowSlideNext && (swiper.isHorizontal() && kc === 39 || swiper.isVertical() && kc === 40 || kc === 34)) {
          return false;
        }

        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && kc === 37 || swiper.isVertical() && kc === 38 || kc === 33)) {
          return false;
        }

        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
          return undefined;
        }

        if (doc.activeElement && doc.activeElement.nodeName && (doc.activeElement.nodeName.toLowerCase() === 'input' || doc.activeElement.nodeName.toLowerCase() === 'textarea')) {
          return undefined;
        }

        if (swiper.params.keyboard.onlyInViewport && (kc === 33 || kc === 34 || kc === 37 || kc === 39 || kc === 38 || kc === 40)) {
          var inView = false; // Check that swiper should be inside of visible area of window

          if (swiper.$el.parents("." + swiper.params.slideClass).length > 0 && swiper.$el.parents("." + swiper.params.slideActiveClass).length === 0) {
            return undefined;
          }

          var windowWidth = win.innerWidth;
          var windowHeight = win.innerHeight;
          var swiperOffset = swiper.$el.offset();

          if (rtl) {
            swiperOffset.left -= swiper.$el[0].scrollLeft;
          }

          var swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];

          for (var i = 0; i < swiperCoord.length; i += 1) {
            var point = swiperCoord[i];

            if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
              inView = true;
            }
          }

          if (!inView) {
            return undefined;
          }
        }

        if (swiper.isHorizontal()) {
          if (kc === 33 || kc === 34 || kc === 37 || kc === 39) {
            if (e.preventDefault) {
              e.preventDefault();
            } else {
              e.returnValue = false;
            }
          }

          if ((kc === 34 || kc === 39) && !rtl || (kc === 33 || kc === 37) && rtl) {
            swiper.slideNext();
          }

          if ((kc === 33 || kc === 37) && !rtl || (kc === 34 || kc === 39) && rtl) {
            swiper.slidePrev();
          }
        } else {
          if (kc === 33 || kc === 34 || kc === 38 || kc === 40) {
            if (e.preventDefault) {
              e.preventDefault();
            } else {
              e.returnValue = false;
            }
          }

          if (kc === 34 || kc === 40) {
            swiper.slideNext();
          }

          if (kc === 33 || kc === 38) {
            swiper.slidePrev();
          }
        }

        swiper.emit('keyPress', kc);
        return undefined;
      },
      enable: function enable() {
        var swiper = this;

        if (swiper.keyboard.enabled) {
          return;
        }

        $(doc).on('keydown', swiper.keyboard.handle);
        swiper.keyboard.enabled = true;
      },
      disable: function disable() {
        var swiper = this;

        if (!swiper.keyboard.enabled) {
          return;
        }

        $(doc).off('keydown', swiper.keyboard.handle);
        swiper.keyboard.enabled = false;
      }
    };
    var Keyboard$1 = {
      name: 'keyboard',
      params: {
        keyboard: {
          enabled: false,
          onlyInViewport: true
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          keyboard: {
            enabled: false,
            enable: Keyboard.enable.bind(swiper),
            disable: Keyboard.disable.bind(swiper),
            handle: Keyboard.handle.bind(swiper)
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;

          if (swiper.params.keyboard.enabled) {
            swiper.keyboard.enable();
          }
        },
        destroy: function destroy() {
          var swiper = this;

          if (swiper.keyboard.enabled) {
            swiper.keyboard.disable();
          }
        }
      }
    };

    function isEventSupported() {
      var eventName = 'onwheel';
      var isSupported = (eventName in doc);

      if (!isSupported) {
        var element = doc.createElement('div');
        element.setAttribute(eventName, 'return;');
        isSupported = typeof element[eventName] === 'function';
      }

      if (!isSupported && doc.implementation && doc.implementation.hasFeature // always returns true in newer browsers as per the standard.
      // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
      && doc.implementation.hasFeature('', '') !== true) {
        // This is the only way to test support for the `wheel` event in IE9+.
        isSupported = doc.implementation.hasFeature('Events.wheel', '3.0');
      }

      return isSupported;
    }

    var Mousewheel = {
      lastScrollTime: Utils.now(),
      event: function getEvent() {
        if (win.navigator.userAgent.indexOf('firefox') > -1) {
          return 'DOMMouseScroll';
        }

        return isEventSupported() ? 'wheel' : 'mousewheel';
      }(),
      normalize: function normalize(e) {
        // Reasonable defaults
        var PIXEL_STEP = 10;
        var LINE_HEIGHT = 40;
        var PAGE_HEIGHT = 800;
        var sX = 0;
        var sY = 0; // spinX, spinY

        var pX = 0;
        var pY = 0; // pixelX, pixelY
        // Legacy

        if ('detail' in e) {
          sY = e.detail;
        }

        if ('wheelDelta' in e) {
          sY = -e.wheelDelta / 120;
        }

        if ('wheelDeltaY' in e) {
          sY = -e.wheelDeltaY / 120;
        }

        if ('wheelDeltaX' in e) {
          sX = -e.wheelDeltaX / 120;
        } // side scrolling on FF with DOMMouseScroll


        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
          sX = sY;
          sY = 0;
        }

        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;

        if ('deltaY' in e) {
          pY = e.deltaY;
        }

        if ('deltaX' in e) {
          pX = e.deltaX;
        }

        if ((pX || pY) && e.deltaMode) {
          if (e.deltaMode === 1) {
            // delta in LINE units
            pX *= LINE_HEIGHT;
            pY *= LINE_HEIGHT;
          } else {
            // delta in PAGE units
            pX *= PAGE_HEIGHT;
            pY *= PAGE_HEIGHT;
          }
        } // Fall-back if spin cannot be determined


        if (pX && !sX) {
          sX = pX < 1 ? -1 : 1;
        }

        if (pY && !sY) {
          sY = pY < 1 ? -1 : 1;
        }

        return {
          spinX: sX,
          spinY: sY,
          pixelX: pX,
          pixelY: pY
        };
      },
      handleMouseEnter: function handleMouseEnter() {
        var swiper = this;
        swiper.mouseEntered = true;
      },
      handleMouseLeave: function handleMouseLeave() {
        var swiper = this;
        swiper.mouseEntered = false;
      },
      handle: function handle(event) {
        var e = event;
        var swiper = this;
        var params = swiper.params.mousewheel;

        if (!swiper.mouseEntered && !params.releaseOnEdges) {
          return true;
        }

        if (e.originalEvent) {
          e = e.originalEvent;
        } // jquery fix


        var delta = 0;
        var rtlFactor = swiper.rtlTranslate ? -1 : 1;
        var data = Mousewheel.normalize(e);

        if (params.forceToAxis) {
          if (swiper.isHorizontal()) {
            if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) {
              delta = data.pixelX * rtlFactor;
            } else {
              return true;
            }
          } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) {
            delta = data.pixelY;
          } else {
            return true;
          }
        } else {
          delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        }

        if (delta === 0) {
          return true;
        }

        if (params.invert) {
          delta = -delta;
        }

        if (!swiper.params.freeMode) {
          if (Utils.now() - swiper.mousewheel.lastScrollTime > 60) {
            if (delta < 0) {
              if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                swiper.emit('scroll', e);
              } else if (params.releaseOnEdges) {
                return true;
              }
            } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
              swiper.slidePrev();
              swiper.emit('scroll', e);
            } else if (params.releaseOnEdges) {
              return true;
            }
          }

          swiper.mousewheel.lastScrollTime = new win.Date().getTime();
        } else {
          // Freemode or scrollContainer:
          if (swiper.params.loop) {
            swiper.loopFix();
          }

          var position = swiper.getTranslate() + delta * params.sensitivity;
          var wasBeginning = swiper.isBeginning;
          var wasEnd = swiper.isEnd;

          if (position >= swiper.minTranslate()) {
            position = swiper.minTranslate();
          }

          if (position <= swiper.maxTranslate()) {
            position = swiper.maxTranslate();
          }

          swiper.setTransition(0);
          swiper.setTranslate(position);
          swiper.updateProgress();
          swiper.updateActiveIndex();
          swiper.updateSlidesClasses();

          if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
            swiper.updateSlidesClasses();
          }

          if (swiper.params.freeModeSticky) {
            clearTimeout(swiper.mousewheel.timeout);
            swiper.mousewheel.timeout = Utils.nextTick(function () {
              swiper.slideToClosest();
            }, 300);
          } // Emit event


          swiper.emit('scroll', e); // Stop autoplay

          if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) {
            swiper.autoplay.stop();
          } // Return page scroll on edge positions


          if (position === swiper.minTranslate() || position === swiper.maxTranslate()) {
            return true;
          }
        }

        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }

        return false;
      },
      enable: function enable() {
        var swiper = this;

        if (!Mousewheel.event) {
          return false;
        }

        if (swiper.mousewheel.enabled) {
          return false;
        }

        var target = swiper.$el;

        if (swiper.params.mousewheel.eventsTarged !== 'container') {
          target = $(swiper.params.mousewheel.eventsTarged);
        }

        target.on('mouseenter', swiper.mousewheel.handleMouseEnter);
        target.on('mouseleave', swiper.mousewheel.handleMouseLeave);
        target.on(Mousewheel.event, swiper.mousewheel.handle);
        swiper.mousewheel.enabled = true;
        return true;
      },
      disable: function disable() {
        var swiper = this;

        if (!Mousewheel.event) {
          return false;
        }

        if (!swiper.mousewheel.enabled) {
          return false;
        }

        var target = swiper.$el;

        if (swiper.params.mousewheel.eventsTarged !== 'container') {
          target = $(swiper.params.mousewheel.eventsTarged);
        }

        target.off(Mousewheel.event, swiper.mousewheel.handle);
        swiper.mousewheel.enabled = false;
        return true;
      }
    };
    var Mousewheel$1 = {
      name: 'mousewheel',
      params: {
        mousewheel: {
          enabled: false,
          releaseOnEdges: false,
          invert: false,
          forceToAxis: false,
          sensitivity: 1,
          eventsTarged: 'container'
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          mousewheel: {
            enabled: false,
            enable: Mousewheel.enable.bind(swiper),
            disable: Mousewheel.disable.bind(swiper),
            handle: Mousewheel.handle.bind(swiper),
            handleMouseEnter: Mousewheel.handleMouseEnter.bind(swiper),
            handleMouseLeave: Mousewheel.handleMouseLeave.bind(swiper),
            lastScrollTime: Utils.now()
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;

          if (swiper.params.mousewheel.enabled) {
            swiper.mousewheel.enable();
          }
        },
        destroy: function destroy() {
          var swiper = this;

          if (swiper.mousewheel.enabled) {
            swiper.mousewheel.disable();
          }
        }
      }
    };
    var Navigation = {
      update: function update() {
        // Update Navigation Buttons
        var swiper = this;
        var params = swiper.params.navigation;

        if (swiper.params.loop) {
          return;
        }

        var ref = swiper.navigation;
        var $nextEl = ref.$nextEl;
        var $prevEl = ref.$prevEl;

        if ($prevEl && $prevEl.length > 0) {
          if (swiper.isBeginning) {
            $prevEl.addClass(params.disabledClass);
          } else {
            $prevEl.removeClass(params.disabledClass);
          }

          $prevEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }

        if ($nextEl && $nextEl.length > 0) {
          if (swiper.isEnd) {
            $nextEl.addClass(params.disabledClass);
          } else {
            $nextEl.removeClass(params.disabledClass);
          }

          $nextEl[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
      },
      onPrevClick: function onPrevClick(e) {
        var swiper = this;
        e.preventDefault();

        if (swiper.isBeginning && !swiper.params.loop) {
          return;
        }

        swiper.slidePrev();
      },
      onNextClick: function onNextClick(e) {
        var swiper = this;
        e.preventDefault();

        if (swiper.isEnd && !swiper.params.loop) {
          return;
        }

        swiper.slideNext();
      },
      init: function init() {
        var swiper = this;
        var params = swiper.params.navigation;

        if (!(params.nextEl || params.prevEl)) {
          return;
        }

        var $nextEl;
        var $prevEl;

        if (params.nextEl) {
          $nextEl = $(params.nextEl);

          if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
            $nextEl = swiper.$el.find(params.nextEl);
          }
        }

        if (params.prevEl) {
          $prevEl = $(params.prevEl);

          if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
            $prevEl = swiper.$el.find(params.prevEl);
          }
        }

        if ($nextEl && $nextEl.length > 0) {
          $nextEl.on('click', swiper.navigation.onNextClick);
        }

        if ($prevEl && $prevEl.length > 0) {
          $prevEl.on('click', swiper.navigation.onPrevClick);
        }

        Utils.extend(swiper.navigation, {
          $nextEl: $nextEl,
          nextEl: $nextEl && $nextEl[0],
          $prevEl: $prevEl,
          prevEl: $prevEl && $prevEl[0]
        });
      },
      destroy: function destroy() {
        var swiper = this;
        var ref = swiper.navigation;
        var $nextEl = ref.$nextEl;
        var $prevEl = ref.$prevEl;

        if ($nextEl && $nextEl.length) {
          $nextEl.off('click', swiper.navigation.onNextClick);
          $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }

        if ($prevEl && $prevEl.length) {
          $prevEl.off('click', swiper.navigation.onPrevClick);
          $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
      }
    };
    var Navigation$1 = {
      name: 'navigation',
      params: {
        navigation: {
          nextEl: null,
          prevEl: null,
          hideOnClick: false,
          disabledClass: 'swiper-button-disabled',
          hiddenClass: 'swiper-button-hidden',
          lockClass: 'swiper-button-lock'
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          navigation: {
            init: Navigation.init.bind(swiper),
            update: Navigation.update.bind(swiper),
            destroy: Navigation.destroy.bind(swiper),
            onNextClick: Navigation.onNextClick.bind(swiper),
            onPrevClick: Navigation.onPrevClick.bind(swiper)
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;
          swiper.navigation.init();
          swiper.navigation.update();
        },
        toEdge: function toEdge() {
          var swiper = this;
          swiper.navigation.update();
        },
        fromEdge: function fromEdge() {
          var swiper = this;
          swiper.navigation.update();
        },
        destroy: function destroy() {
          var swiper = this;
          swiper.navigation.destroy();
        },
        click: function click(e) {
          var swiper = this;
          var ref = swiper.navigation;
          var $nextEl = ref.$nextEl;
          var $prevEl = ref.$prevEl;

          if (swiper.params.navigation.hideOnClick && !$(e.target).is($prevEl) && !$(e.target).is($nextEl)) {
            var isHidden;

            if ($nextEl) {
              isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            } else if ($prevEl) {
              isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            }

            if (isHidden === true) {
              swiper.emit('navigationShow', swiper);
            } else {
              swiper.emit('navigationHide', swiper);
            }

            if ($nextEl) {
              $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            }

            if ($prevEl) {
              $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
            }
          }
        }
      }
    };
    var Pagination = {
      update: function update() {
        // Render || Update Pagination bullets/items
        var swiper = this;
        var rtl = swiper.rtl;
        var params = swiper.params.pagination;

        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) {
          return;
        }

        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el; // Current/Total

        var current;
        var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

        if (swiper.params.loop) {
          current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

          if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
            current -= slidesLength - swiper.loopedSlides * 2;
          }

          if (current > total - 1) {
            current -= total;
          }

          if (current < 0 && swiper.params.paginationType !== 'bullets') {
            current = total + current;
          }
        } else if (typeof swiper.snapIndex !== 'undefined') {
          current = swiper.snapIndex;
        } else {
          current = swiper.activeIndex || 0;
        } // Types


        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
          var bullets = swiper.pagination.bullets;
          var firstIndex;
          var lastIndex;
          var midIndex;

          if (params.dynamicBullets) {
            swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
            $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");

            if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
              swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;

              if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
                swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
              } else if (swiper.pagination.dynamicBulletIndex < 0) {
                swiper.pagination.dynamicBulletIndex = 0;
              }
            }

            firstIndex = current - swiper.pagination.dynamicBulletIndex;
            lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
            midIndex = (lastIndex + firstIndex) / 2;
          }

          bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");

          if ($el.length > 1) {
            bullets.each(function (index, bullet) {
              var $bullet = $(bullet);
              var bulletIndex = $bullet.index();

              if (bulletIndex === current) {
                $bullet.addClass(params.bulletActiveClass);
              }

              if (params.dynamicBullets) {
                if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                  $bullet.addClass(params.bulletActiveClass + "-main");
                }

                if (bulletIndex === firstIndex) {
                  $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                }

                if (bulletIndex === lastIndex) {
                  $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
                }
              }
            });
          } else {
            var $bullet = bullets.eq(current);
            $bullet.addClass(params.bulletActiveClass);

            if (params.dynamicBullets) {
              var $firstDisplayedBullet = bullets.eq(firstIndex);
              var $lastDisplayedBullet = bullets.eq(lastIndex);

              for (var i = firstIndex; i <= lastIndex; i += 1) {
                bullets.eq(i).addClass(params.bulletActiveClass + "-main");
              }

              $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
              $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
            }
          }

          if (params.dynamicBullets) {
            var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
            var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
            var offsetProp = rtl ? 'right' : 'left';
            bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
          }
        }

        if (params.type === 'fraction') {
          $el.find("." + params.currentClass).text(params.formatFractionCurrent(current + 1));
          $el.find("." + params.totalClass).text(params.formatFractionTotal(total));
        }

        if (params.type === 'progressbar') {
          var progressbarDirection;

          if (params.progressbarOpposite) {
            progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
          } else {
            progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
          }

          var scale = (current + 1) / total;
          var scaleX = 1;
          var scaleY = 1;

          if (progressbarDirection === 'horizontal') {
            scaleX = scale;
          } else {
            scaleY = scale;
          }

          $el.find("." + params.progressbarFillClass).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
        }

        if (params.type === 'custom' && params.renderCustom) {
          $el.html(params.renderCustom(swiper, current + 1, total));
          swiper.emit('paginationRender', swiper, $el[0]);
        } else {
          swiper.emit('paginationUpdate', swiper, $el[0]);
        }

        $el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      },
      render: function render() {
        // Render Container
        var swiper = this;
        var params = swiper.params.pagination;

        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) {
          return;
        }

        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var $el = swiper.pagination.$el;
        var paginationHTML = '';

        if (params.type === 'bullets') {
          var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

          for (var i = 0; i < numberOfBullets; i += 1) {
            if (params.renderBullet) {
              paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            } else {
              paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
            }
          }

          $el.html(paginationHTML);
          swiper.pagination.bullets = $el.find("." + params.bulletClass);
        }

        if (params.type === 'fraction') {
          if (params.renderFraction) {
            paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
          } else {
            paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + "<span class=\"" + params.totalClass + "\"></span>";
          }

          $el.html(paginationHTML);
        }

        if (params.type === 'progressbar') {
          if (params.renderProgressbar) {
            paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
          } else {
            paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
          }

          $el.html(paginationHTML);
        }

        if (params.type !== 'custom') {
          swiper.emit('paginationRender', swiper.pagination.$el[0]);
        }
      },
      init: function init() {
        var swiper = this;
        var params = swiper.params.pagination;

        if (!params.el) {
          return;
        }

        var $el = $(params.el);

        if ($el.length === 0) {
          return;
        }

        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && swiper.$el.find(params.el).length === 1) {
          $el = swiper.$el.find(params.el);
        }

        if (params.type === 'bullets' && params.clickable) {
          $el.addClass(params.clickableClass);
        }

        $el.addClass(params.modifierClass + params.type);

        if (params.type === 'bullets' && params.dynamicBullets) {
          $el.addClass("" + params.modifierClass + params.type + "-dynamic");
          swiper.pagination.dynamicBulletIndex = 0;

          if (params.dynamicMainBullets < 1) {
            params.dynamicMainBullets = 1;
          }
        }

        if (params.type === 'progressbar' && params.progressbarOpposite) {
          $el.addClass(params.progressbarOppositeClass);
        }

        if (params.clickable) {
          $el.on('click', "." + params.bulletClass, function onClick(e) {
            e.preventDefault();
            var index = $(this).index() * swiper.params.slidesPerGroup;

            if (swiper.params.loop) {
              index += swiper.loopedSlides;
            }

            swiper.slideTo(index);
          });
        }

        Utils.extend(swiper.pagination, {
          $el: $el,
          el: $el[0]
        });
      },
      destroy: function destroy() {
        var swiper = this;
        var params = swiper.params.pagination;

        if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) {
          return;
        }

        var $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);

        if (swiper.pagination.bullets) {
          swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        }

        if (params.clickable) {
          $el.off('click', "." + params.bulletClass);
        }
      }
    };
    var Pagination$1 = {
      name: 'pagination',
      params: {
        pagination: {
          el: null,
          bulletElement: 'span',
          clickable: false,
          hideOnClick: false,
          renderBullet: null,
          renderProgressbar: null,
          renderFraction: null,
          renderCustom: null,
          progressbarOpposite: false,
          type: 'bullets',
          // 'bullets' or 'progressbar' or 'fraction' or 'custom'
          dynamicBullets: false,
          dynamicMainBullets: 1,
          formatFractionCurrent: function formatFractionCurrent(number) {
            return number;
          },
          formatFractionTotal: function formatFractionTotal(number) {
            return number;
          },
          bulletClass: 'swiper-pagination-bullet',
          bulletActiveClass: 'swiper-pagination-bullet-active',
          modifierClass: 'swiper-pagination-',
          // NEW
          currentClass: 'swiper-pagination-current',
          totalClass: 'swiper-pagination-total',
          hiddenClass: 'swiper-pagination-hidden',
          progressbarFillClass: 'swiper-pagination-progressbar-fill',
          progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
          clickableClass: 'swiper-pagination-clickable',
          // NEW
          lockClass: 'swiper-pagination-lock'
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          pagination: {
            init: Pagination.init.bind(swiper),
            render: Pagination.render.bind(swiper),
            update: Pagination.update.bind(swiper),
            destroy: Pagination.destroy.bind(swiper),
            dynamicBulletIndex: 0
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;
          swiper.pagination.init();
          swiper.pagination.render();
          swiper.pagination.update();
        },
        activeIndexChange: function activeIndexChange() {
          var swiper = this;

          if (swiper.params.loop) {
            swiper.pagination.update();
          } else if (typeof swiper.snapIndex === 'undefined') {
            swiper.pagination.update();
          }
        },
        snapIndexChange: function snapIndexChange() {
          var swiper = this;

          if (!swiper.params.loop) {
            swiper.pagination.update();
          }
        },
        slidesLengthChange: function slidesLengthChange() {
          var swiper = this;

          if (swiper.params.loop) {
            swiper.pagination.render();
            swiper.pagination.update();
          }
        },
        snapGridLengthChange: function snapGridLengthChange() {
          var swiper = this;

          if (!swiper.params.loop) {
            swiper.pagination.render();
            swiper.pagination.update();
          }
        },
        destroy: function destroy() {
          var swiper = this;
          swiper.pagination.destroy();
        },
        click: function click(e) {
          var swiper = this;

          if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !$(e.target).hasClass(swiper.params.pagination.bulletClass)) {
            var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);

            if (isHidden === true) {
              swiper.emit('paginationShow', swiper);
            } else {
              swiper.emit('paginationHide', swiper);
            }

            swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
          }
        }
      }
    };
    var Scrollbar = {
      setTranslate: function setTranslate() {
        var swiper = this;

        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) {
          return;
        }

        var scrollbar = swiper.scrollbar;
        var rtl = swiper.rtlTranslate;
        var progress = swiper.progress;
        var dragSize = scrollbar.dragSize;
        var trackSize = scrollbar.trackSize;
        var $dragEl = scrollbar.$dragEl;
        var $el = scrollbar.$el;
        var params = swiper.params.scrollbar;
        var newSize = dragSize;
        var newPos = (trackSize - dragSize) * progress;

        if (rtl) {
          newPos = -newPos;

          if (newPos > 0) {
            newSize = dragSize - newPos;
            newPos = 0;
          } else if (-newPos + dragSize > trackSize) {
            newSize = trackSize + newPos;
          }
        } else if (newPos < 0) {
          newSize = dragSize + newPos;
          newPos = 0;
        } else if (newPos + dragSize > trackSize) {
          newSize = trackSize - newPos;
        }

        if (swiper.isHorizontal()) {
          if (Support.transforms3d) {
            $dragEl.transform("translate3d(" + newPos + "px, 0, 0)");
          } else {
            $dragEl.transform("translateX(" + newPos + "px)");
          }

          $dragEl[0].style.width = newSize + "px";
        } else {
          if (Support.transforms3d) {
            $dragEl.transform("translate3d(0px, " + newPos + "px, 0)");
          } else {
            $dragEl.transform("translateY(" + newPos + "px)");
          }

          $dragEl[0].style.height = newSize + "px";
        }

        if (params.hide) {
          clearTimeout(swiper.scrollbar.timeout);
          $el[0].style.opacity = 1;
          swiper.scrollbar.timeout = setTimeout(function () {
            $el[0].style.opacity = 0;
            $el.transition(400);
          }, 1000);
        }
      },
      setTransition: function setTransition(duration) {
        var swiper = this;

        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) {
          return;
        }

        swiper.scrollbar.$dragEl.transition(duration);
      },
      updateSize: function updateSize() {
        var swiper = this;

        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) {
          return;
        }

        var scrollbar = swiper.scrollbar;
        var $dragEl = scrollbar.$dragEl;
        var $el = scrollbar.$el;
        $dragEl[0].style.width = '';
        $dragEl[0].style.height = '';
        var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        var divider = swiper.size / swiper.virtualSize;
        var moveDivider = divider * (trackSize / swiper.size);
        var dragSize;

        if (swiper.params.scrollbar.dragSize === 'auto') {
          dragSize = trackSize * divider;
        } else {
          dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        }

        if (swiper.isHorizontal()) {
          $dragEl[0].style.width = dragSize + "px";
        } else {
          $dragEl[0].style.height = dragSize + "px";
        }

        if (divider >= 1) {
          $el[0].style.display = 'none';
        } else {
          $el[0].style.display = '';
        }

        if (swiper.params.scrollbar.hide) {
          $el[0].style.opacity = 0;
        }

        Utils.extend(scrollbar, {
          trackSize: trackSize,
          divider: divider,
          moveDivider: moveDivider,
          dragSize: dragSize
        });
        scrollbar.$el[swiper.params.watchOverflow && swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
      },
      getPointerPosition: function getPointerPosition(e) {
        var swiper = this;

        if (swiper.isHorizontal()) {
          return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX || e.clientX;
        }

        return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY || e.clientY;
      },
      setDragPosition: function setDragPosition(e) {
        var swiper = this;
        var scrollbar = swiper.scrollbar;
        var rtl = swiper.rtlTranslate;
        var $el = scrollbar.$el;
        var dragSize = scrollbar.dragSize;
        var trackSize = scrollbar.trackSize;
        var dragStartPos = scrollbar.dragStartPos;
        var positionRatio;
        positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);

        if (rtl) {
          positionRatio = 1 - positionRatio;
        }

        var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      },
      onDragStart: function onDragStart(e) {
        var swiper = this;
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar;
        var $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el;
        var $dragEl = scrollbar.$dragEl;
        swiper.scrollbar.isTouched = true;
        swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        scrollbar.setDragPosition(e);
        clearTimeout(swiper.scrollbar.dragTimeout);
        $el.transition(0);

        if (params.hide) {
          $el.css('opacity', 1);
        }

        swiper.emit('scrollbarDragStart', e);
      },
      onDragMove: function onDragMove(e) {
        var swiper = this;
        var scrollbar = swiper.scrollbar;
        var $wrapperEl = swiper.$wrapperEl;
        var $el = scrollbar.$el;
        var $dragEl = scrollbar.$dragEl;

        if (!swiper.scrollbar.isTouched) {
          return;
        }

        if (e.preventDefault) {
          e.preventDefault();
        } else {
          e.returnValue = false;
        }

        scrollbar.setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        swiper.emit('scrollbarDragMove', e);
      },
      onDragEnd: function onDragEnd(e) {
        var swiper = this;
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar;
        var $el = scrollbar.$el;

        if (!swiper.scrollbar.isTouched) {
          return;
        }

        swiper.scrollbar.isTouched = false;

        if (params.hide) {
          clearTimeout(swiper.scrollbar.dragTimeout);
          swiper.scrollbar.dragTimeout = Utils.nextTick(function () {
            $el.css('opacity', 0);
            $el.transition(400);
          }, 1000);
        }

        swiper.emit('scrollbarDragEnd', e);

        if (params.snapOnRelease) {
          swiper.slideToClosest();
        }
      },
      enableDraggable: function enableDraggable() {
        var swiper = this;

        if (!swiper.params.scrollbar.el) {
          return;
        }

        var scrollbar = swiper.scrollbar;
        var touchEventsTouch = swiper.touchEventsTouch;
        var touchEventsDesktop = swiper.touchEventsDesktop;
        var params = swiper.params;
        var $el = scrollbar.$el;
        var target = $el[0];
        var activeListener = Support.passiveListener && params.passiveListeners ? {
          passive: false,
          capture: false
        } : false;
        var passiveListener = Support.passiveListener && params.passiveListeners ? {
          passive: true,
          capture: false
        } : false;

        if (!Support.touch) {
          target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
          doc.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
          doc.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
        } else {
          target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
          target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
          target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
        }
      },
      disableDraggable: function disableDraggable() {
        var swiper = this;

        if (!swiper.params.scrollbar.el) {
          return;
        }

        var scrollbar = swiper.scrollbar;
        var touchEventsTouch = swiper.touchEventsTouch;
        var touchEventsDesktop = swiper.touchEventsDesktop;
        var params = swiper.params;
        var $el = scrollbar.$el;
        var target = $el[0];
        var activeListener = Support.passiveListener && params.passiveListeners ? {
          passive: false,
          capture: false
        } : false;
        var passiveListener = Support.passiveListener && params.passiveListeners ? {
          passive: true,
          capture: false
        } : false;

        if (!Support.touch) {
          target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
          doc.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
          doc.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
        } else {
          target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
          target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
          target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
        }
      },
      init: function init() {
        var swiper = this;

        if (!swiper.params.scrollbar.el) {
          return;
        }

        var scrollbar = swiper.scrollbar;
        var $swiperEl = swiper.$el;
        var params = swiper.params.scrollbar;
        var $el = $(params.el);

        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
          $el = $swiperEl.find(params.el);
        }

        var $dragEl = $el.find("." + swiper.params.scrollbar.dragClass);

        if ($dragEl.length === 0) {
          $dragEl = $("<div class=\"" + swiper.params.scrollbar.dragClass + "\"></div>");
          $el.append($dragEl);
        }

        Utils.extend(scrollbar, {
          $el: $el,
          el: $el[0],
          $dragEl: $dragEl,
          dragEl: $dragEl[0]
        });

        if (params.draggable) {
          scrollbar.enableDraggable();
        }
      },
      destroy: function destroy() {
        var swiper = this;
        swiper.scrollbar.disableDraggable();
      }
    };
    var Scrollbar$1 = {
      name: 'scrollbar',
      params: {
        scrollbar: {
          el: null,
          dragSize: 'auto',
          hide: false,
          draggable: false,
          snapOnRelease: true,
          lockClass: 'swiper-scrollbar-lock',
          dragClass: 'swiper-scrollbar-drag'
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          scrollbar: {
            init: Scrollbar.init.bind(swiper),
            destroy: Scrollbar.destroy.bind(swiper),
            updateSize: Scrollbar.updateSize.bind(swiper),
            setTranslate: Scrollbar.setTranslate.bind(swiper),
            setTransition: Scrollbar.setTransition.bind(swiper),
            enableDraggable: Scrollbar.enableDraggable.bind(swiper),
            disableDraggable: Scrollbar.disableDraggable.bind(swiper),
            setDragPosition: Scrollbar.setDragPosition.bind(swiper),
            getPointerPosition: Scrollbar.getPointerPosition.bind(swiper),
            onDragStart: Scrollbar.onDragStart.bind(swiper),
            onDragMove: Scrollbar.onDragMove.bind(swiper),
            onDragEnd: Scrollbar.onDragEnd.bind(swiper),
            isTouched: false,
            timeout: null,
            dragTimeout: null
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;
          swiper.scrollbar.init();
          swiper.scrollbar.updateSize();
          swiper.scrollbar.setTranslate();
        },
        update: function update() {
          var swiper = this;
          swiper.scrollbar.updateSize();
        },
        resize: function resize() {
          var swiper = this;
          swiper.scrollbar.updateSize();
        },
        observerUpdate: function observerUpdate() {
          var swiper = this;
          swiper.scrollbar.updateSize();
        },
        setTranslate: function setTranslate() {
          var swiper = this;
          swiper.scrollbar.setTranslate();
        },
        setTransition: function setTransition(duration) {
          var swiper = this;
          swiper.scrollbar.setTransition(duration);
        },
        destroy: function destroy() {
          var swiper = this;
          swiper.scrollbar.destroy();
        }
      }
    };
    var Parallax = {
      setTransform: function setTransform(el, progress) {
        var swiper = this;
        var rtl = swiper.rtl;
        var $el = $(el);
        var rtlFactor = rtl ? -1 : 1;
        var p = $el.attr('data-swiper-parallax') || '0';
        var x = $el.attr('data-swiper-parallax-x');
        var y = $el.attr('data-swiper-parallax-y');
        var scale = $el.attr('data-swiper-parallax-scale');
        var opacity = $el.attr('data-swiper-parallax-opacity');

        if (x || y) {
          x = x || '0';
          y = y || '0';
        } else if (swiper.isHorizontal()) {
          x = p;
          y = '0';
        } else {
          y = p;
          x = '0';
        }

        if (x.indexOf('%') >= 0) {
          x = parseInt(x, 10) * progress * rtlFactor + "%";
        } else {
          x = x * progress * rtlFactor + "px";
        }

        if (y.indexOf('%') >= 0) {
          y = parseInt(y, 10) * progress + "%";
        } else {
          y = y * progress + "px";
        }

        if (typeof opacity !== 'undefined' && opacity !== null) {
          var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
          $el[0].style.opacity = currentOpacity;
        }

        if (typeof scale === 'undefined' || scale === null) {
          $el.transform("translate3d(" + x + ", " + y + ", 0px)");
        } else {
          var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
          $el.transform("translate3d(" + x + ", " + y + ", 0px) scale(" + currentScale + ")");
        }
      },
      setTranslate: function setTranslate() {
        var swiper = this;
        var $el = swiper.$el;
        var slides = swiper.slides;
        var progress = swiper.progress;
        var snapGrid = swiper.snapGrid;
        $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, el) {
          swiper.parallax.setTransform(el, progress);
        });
        slides.each(function (slideIndex, slideEl) {
          var slideProgress = slideEl.progress;

          if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
            slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
          }

          slideProgress = Math.min(Math.max(slideProgress, -1), 1);
          $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, el) {
            swiper.parallax.setTransform(el, slideProgress);
          });
        });
      },
      setTransition: function setTransition(duration) {
        if (duration === void 0) duration = this.params.speed;
        var swiper = this;
        var $el = swiper.$el;
        $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(function (index, parallaxEl) {
          var $parallaxEl = $(parallaxEl);
          var parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;

          if (duration === 0) {
            parallaxDuration = 0;
          }

          $parallaxEl.transition(parallaxDuration);
        });
      }
    };
    var Parallax$1 = {
      name: 'parallax',
      params: {
        parallax: {
          enabled: false
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          parallax: {
            setTransform: Parallax.setTransform.bind(swiper),
            setTranslate: Parallax.setTranslate.bind(swiper),
            setTransition: Parallax.setTransition.bind(swiper)
          }
        });
      },
      on: {
        beforeInit: function beforeInit() {
          var swiper = this;

          if (!swiper.params.parallax.enabled) {
            return;
          }

          swiper.params.watchSlidesProgress = true;
          swiper.originalParams.watchSlidesProgress = true;
        },
        init: function init() {
          var swiper = this;

          if (!swiper.params.parallax.enabled) {
            return;
          }

          swiper.parallax.setTranslate();
        },
        setTranslate: function setTranslate() {
          var swiper = this;

          if (!swiper.params.parallax.enabled) {
            return;
          }

          swiper.parallax.setTranslate();
        },
        setTransition: function setTransition(duration) {
          var swiper = this;

          if (!swiper.params.parallax.enabled) {
            return;
          }

          swiper.parallax.setTransition(duration);
        }
      }
    };
    var Zoom = {
      // Calc Scale From Multi-touches
      getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) {
          return 1;
        }

        var x1 = e.targetTouches[0].pageX;
        var y1 = e.targetTouches[0].pageY;
        var x2 = e.targetTouches[1].pageX;
        var y2 = e.targetTouches[1].pageY;
        var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        return distance;
      },
      // Events
      onGestureStart: function onGestureStart(e) {
        var swiper = this;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        zoom.fakeGestureTouched = false;
        zoom.fakeGestureMoved = false;

        if (!Support.gestures) {
          if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) {
            return;
          }

          zoom.fakeGestureTouched = true;
          gesture.scaleStart = Zoom.getDistanceBetweenTouches(e);
        }

        if (!gesture.$slideEl || !gesture.$slideEl.length) {
          gesture.$slideEl = $(e.target).closest('.swiper-slide');

          if (gesture.$slideEl.length === 0) {
            gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
          }

          gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
          gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
          gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

          if (gesture.$imageWrapEl.length === 0) {
            gesture.$imageEl = undefined;
            return;
          }
        }

        gesture.$imageEl.transition(0);
        swiper.zoom.isScaling = true;
      },
      onGestureChange: function onGestureChange(e) {
        var swiper = this;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;

        if (!Support.gestures) {
          if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) {
            return;
          }

          zoom.fakeGestureMoved = true;
          gesture.scaleMove = Zoom.getDistanceBetweenTouches(e);
        }

        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
          return;
        }

        if (Support.gestures) {
          zoom.scale = e.scale * zoom.currentScale;
        } else {
          zoom.scale = gesture.scaleMove / gesture.scaleStart * zoom.currentScale;
        }

        if (zoom.scale > gesture.maxRatio) {
          zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
        }

        if (zoom.scale < params.minRatio) {
          zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
        }

        gesture.$imageEl.transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
      },
      onGestureEnd: function onGestureEnd(e) {
        var swiper = this;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;

        if (!Support.gestures) {
          if (!zoom.fakeGestureTouched || !zoom.fakeGestureMoved) {
            return;
          }

          if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !Device.android) {
            return;
          }

          zoom.fakeGestureTouched = false;
          zoom.fakeGestureMoved = false;
        }

        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
          return;
        }

        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
        zoom.currentScale = zoom.scale;
        zoom.isScaling = false;

        if (zoom.scale === 1) {
          gesture.$slideEl = undefined;
        }
      },
      onTouchStart: function onTouchStart(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        var image = zoom.image;

        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
          return;
        }

        if (image.isTouched) {
          return;
        }

        if (Device.android) {
          e.preventDefault();
        }

        image.isTouched = true;
        image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
      },
      onTouchMove: function onTouchMove(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        var image = zoom.image;
        var velocity = zoom.velocity;

        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
          return;
        }

        swiper.allowClick = false;

        if (!image.isTouched || !gesture.$slideEl) {
          return;
        }

        if (!image.isMoved) {
          image.width = gesture.$imageEl[0].offsetWidth;
          image.height = gesture.$imageEl[0].offsetHeight;
          image.startX = Utils.getTranslate(gesture.$imageWrapEl[0], 'x') || 0;
          image.startY = Utils.getTranslate(gesture.$imageWrapEl[0], 'y') || 0;
          gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
          gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
          gesture.$imageWrapEl.transition(0);

          if (swiper.rtl) {
            image.startX = -image.startX;
            image.startY = -image.startY;
          }
        } // Define if we need image drag


        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;

        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) {
          return;
        }

        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;

        if (!image.isMoved && !zoom.isScaling) {
          if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
            image.isTouched = false;
            return;
          }

          if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
            image.isTouched = false;
            return;
          }
        }

        e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;

        if (image.currentX < image.minX) {
          image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
        }

        if (image.currentX > image.maxX) {
          image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
        }

        if (image.currentY < image.minY) {
          image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
        }

        if (image.currentY > image.maxY) {
          image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
        } // Velocity


        if (!velocity.prevPositionX) {
          velocity.prevPositionX = image.touchesCurrent.x;
        }

        if (!velocity.prevPositionY) {
          velocity.prevPositionY = image.touchesCurrent.y;
        }

        if (!velocity.prevTime) {
          velocity.prevTime = Date.now();
        }

        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;

        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) {
          velocity.x = 0;
        }

        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) {
          velocity.y = 0;
        }

        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
      },
      onTouchEnd: function onTouchEnd() {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;
        var image = zoom.image;
        var velocity = zoom.velocity;

        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
          return;
        }

        if (!image.isTouched || !image.isMoved) {
          image.isTouched = false;
          image.isMoved = false;
          return;
        }

        image.isTouched = false;
        image.isMoved = false;
        var momentumDurationX = 300;
        var momentumDurationY = 300;
        var momentumDistanceX = velocity.x * momentumDurationX;
        var newPositionX = image.currentX + momentumDistanceX;
        var momentumDistanceY = velocity.y * momentumDurationY;
        var newPositionY = image.currentY + momentumDistanceY; // Fix duration

        if (velocity.x !== 0) {
          momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        }

        if (velocity.y !== 0) {
          momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        }

        var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag

        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform("translate3d(" + image.currentX + "px, " + image.currentY + "px,0)");
      },
      onTransitionEnd: function onTransitionEnd() {
        var swiper = this;
        var zoom = swiper.zoom;
        var gesture = zoom.gesture;

        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
          gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
          gesture.$imageWrapEl.transform('translate3d(0,0,0)');
          zoom.scale = 1;
          zoom.currentScale = 1;
          gesture.$slideEl = undefined;
          gesture.$imageEl = undefined;
          gesture.$imageWrapEl = undefined;
        }
      },
      // Toggle Zoom
      toggle: function toggle(e) {
        var swiper = this;
        var zoom = swiper.zoom;

        if (zoom.scale && zoom.scale !== 1) {
          // Zoom Out
          zoom.out();
        } else {
          // Zoom In
          zoom["in"](e);
        }
      },
      "in": function in$1(e) {
        var swiper = this;
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        var gesture = zoom.gesture;
        var image = zoom.image;

        if (!gesture.$slideEl) {
          gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
          gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
          gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
        }

        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
          return;
        }

        gesture.$slideEl.addClass("" + params.zoomedSlideClass);
        var touchX;
        var touchY;
        var offsetX;
        var offsetY;
        var diffX;
        var diffY;
        var translateX;
        var translateY;
        var imageWidth;
        var imageHeight;
        var scaledWidth;
        var scaledHeight;
        var translateMinX;
        var translateMinY;
        var translateMaxX;
        var translateMaxY;
        var slideWidth;
        var slideHeight;

        if (typeof image.touchesStart.x === 'undefined' && e) {
          touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
          touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
        } else {
          touchX = image.touchesStart.x;
          touchY = image.touchesStart.y;
        }

        zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        zoom.currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;

        if (e) {
          slideWidth = gesture.$slideEl[0].offsetWidth;
          slideHeight = gesture.$slideEl[0].offsetHeight;
          offsetX = gesture.$slideEl.offset().left;
          offsetY = gesture.$slideEl.offset().top;
          diffX = offsetX + slideWidth / 2 - touchX;
          diffY = offsetY + slideHeight / 2 - touchY;
          imageWidth = gesture.$imageEl[0].offsetWidth;
          imageHeight = gesture.$imageEl[0].offsetHeight;
          scaledWidth = imageWidth * zoom.scale;
          scaledHeight = imageHeight * zoom.scale;
          translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
          translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
          translateMaxX = -translateMinX;
          translateMaxY = -translateMinY;
          translateX = diffX * zoom.scale;
          translateY = diffY * zoom.scale;

          if (translateX < translateMinX) {
            translateX = translateMinX;
          }

          if (translateX > translateMaxX) {
            translateX = translateMaxX;
          }

          if (translateY < translateMinY) {
            translateY = translateMinY;
          }

          if (translateY > translateMaxY) {
            translateY = translateMaxY;
          }
        } else {
          translateX = 0;
          translateY = 0;
        }

        gesture.$imageWrapEl.transition(300).transform("translate3d(" + translateX + "px, " + translateY + "px,0)");
        gesture.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + zoom.scale + ")");
      },
      out: function out() {
        var swiper = this;
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        var gesture = zoom.gesture;

        if (!gesture.$slideEl) {
          gesture.$slideEl = swiper.clickedSlide ? $(swiper.clickedSlide) : swiper.slides.eq(swiper.activeIndex);
          gesture.$imageEl = gesture.$slideEl.find('img, svg, canvas');
          gesture.$imageWrapEl = gesture.$imageEl.parent("." + params.containerClass);
        }

        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
          return;
        }

        zoom.scale = 1;
        zoom.currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
        gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
        gesture.$slideEl.removeClass("" + params.zoomedSlideClass);
        gesture.$slideEl = undefined;
      },
      // Attach/Detach Events
      enable: function enable() {
        var swiper = this;
        var zoom = swiper.zoom;

        if (zoom.enabled) {
          return;
        }

        zoom.enabled = true;
        var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? {
          passive: true,
          capture: false
        } : false; // Scale image

        if (Support.gestures) {
          swiper.$wrapperEl.on('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
          swiper.$wrapperEl.on('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
          swiper.$wrapperEl.on('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
          swiper.$wrapperEl.on(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
          swiper.$wrapperEl.on(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
          swiper.$wrapperEl.on(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
        } // Move image


        swiper.$wrapperEl.on(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove);
      },
      disable: function disable() {
        var swiper = this;
        var zoom = swiper.zoom;

        if (!zoom.enabled) {
          return;
        }

        swiper.zoom.enabled = false;
        var passiveListener = swiper.touchEvents.start === 'touchstart' && Support.passiveListener && swiper.params.passiveListeners ? {
          passive: true,
          capture: false
        } : false; // Scale image

        if (Support.gestures) {
          swiper.$wrapperEl.off('gesturestart', '.swiper-slide', zoom.onGestureStart, passiveListener);
          swiper.$wrapperEl.off('gesturechange', '.swiper-slide', zoom.onGestureChange, passiveListener);
          swiper.$wrapperEl.off('gestureend', '.swiper-slide', zoom.onGestureEnd, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
          swiper.$wrapperEl.off(swiper.touchEvents.start, '.swiper-slide', zoom.onGestureStart, passiveListener);
          swiper.$wrapperEl.off(swiper.touchEvents.move, '.swiper-slide', zoom.onGestureChange, passiveListener);
          swiper.$wrapperEl.off(swiper.touchEvents.end, '.swiper-slide', zoom.onGestureEnd, passiveListener);
        } // Move image


        swiper.$wrapperEl.off(swiper.touchEvents.move, "." + swiper.params.zoom.containerClass, zoom.onTouchMove);
      }
    };
    var Zoom$1 = {
      name: 'zoom',
      params: {
        zoom: {
          enabled: false,
          maxRatio: 3,
          minRatio: 1,
          toggle: true,
          containerClass: 'swiper-zoom-container',
          zoomedSlideClass: 'swiper-slide-zoomed'
        }
      },
      create: function create() {
        var swiper = this;
        var zoom = {
          enabled: false,
          scale: 1,
          currentScale: 1,
          isScaling: false,
          gesture: {
            $slideEl: undefined,
            slideWidth: undefined,
            slideHeight: undefined,
            $imageEl: undefined,
            $imageWrapEl: undefined,
            maxRatio: 3
          },
          image: {
            isTouched: undefined,
            isMoved: undefined,
            currentX: undefined,
            currentY: undefined,
            minX: undefined,
            minY: undefined,
            maxX: undefined,
            maxY: undefined,
            width: undefined,
            height: undefined,
            startX: undefined,
            startY: undefined,
            touchesStart: {},
            touchesCurrent: {}
          },
          velocity: {
            x: undefined,
            y: undefined,
            prevPositionX: undefined,
            prevPositionY: undefined,
            prevTime: undefined
          }
        };
        'onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out'.split(' ').forEach(function (methodName) {
          zoom[methodName] = Zoom[methodName].bind(swiper);
        });
        Utils.extend(swiper, {
          zoom: zoom
        });
        var scale = 1;
        Object.defineProperty(swiper.zoom, 'scale', {
          get: function get() {
            return scale;
          },
          set: function set(value) {
            if (scale !== value) {
              var imageEl = swiper.zoom.gesture.$imageEl ? swiper.zoom.gesture.$imageEl[0] : undefined;
              var slideEl = swiper.zoom.gesture.$slideEl ? swiper.zoom.gesture.$slideEl[0] : undefined;
              swiper.emit('zoomChange', value, imageEl, slideEl);
            }

            scale = value;
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;

          if (swiper.params.zoom.enabled) {
            swiper.zoom.enable();
          }
        },
        destroy: function destroy() {
          var swiper = this;
          swiper.zoom.disable();
        },
        touchStart: function touchStart(e) {
          var swiper = this;

          if (!swiper.zoom.enabled) {
            return;
          }

          swiper.zoom.onTouchStart(e);
        },
        touchEnd: function touchEnd(e) {
          var swiper = this;

          if (!swiper.zoom.enabled) {
            return;
          }

          swiper.zoom.onTouchEnd(e);
        },
        doubleTap: function doubleTap(e) {
          var swiper = this;

          if (swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) {
            swiper.zoom.toggle(e);
          }
        },
        transitionEnd: function transitionEnd() {
          var swiper = this;

          if (swiper.zoom.enabled && swiper.params.zoom.enabled) {
            swiper.zoom.onTransitionEnd();
          }
        }
      }
    };
    var Lazy = {
      loadInSlide: function loadInSlide(index, loadInDuplicate) {
        if (loadInDuplicate === void 0) loadInDuplicate = true;
        var swiper = this;
        var params = swiper.params.lazy;

        if (typeof index === 'undefined') {
          return;
        }

        if (swiper.slides.length === 0) {
          return;
        }

        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var $slideEl = isVirtual ? swiper.$wrapperEl.children("." + swiper.params.slideClass + "[data-swiper-slide-index=\"" + index + "\"]") : swiper.slides.eq(index);
        var $images = $slideEl.find("." + params.elementClass + ":not(." + params.loadedClass + "):not(." + params.loadingClass + ")");

        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
          $images = $images.add($slideEl[0]);
        }

        if ($images.length === 0) {
          return;
        }

        $images.each(function (imageIndex, imageEl) {
          var $imageEl = $(imageEl);
          $imageEl.addClass(params.loadingClass);
          var background = $imageEl.attr('data-background');
          var src = $imageEl.attr('data-src');
          var srcset = $imageEl.attr('data-srcset');
          var sizes = $imageEl.attr('data-sizes');
          swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, function () {
            if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) {
              return;
            }

            if (background) {
              $imageEl.css('background-image', "url(\"" + background + "\")");
              $imageEl.removeAttr('data-background');
            } else {
              if (srcset) {
                $imageEl.attr('srcset', srcset);
                $imageEl.removeAttr('data-srcset');
              }

              if (sizes) {
                $imageEl.attr('sizes', sizes);
                $imageEl.removeAttr('data-sizes');
              }

              if (src) {
                $imageEl.attr('src', src);
                $imageEl.removeAttr('data-src');
              }
            }

            $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
            $slideEl.find("." + params.preloaderClass).remove();

            if (swiper.params.loop && loadInDuplicate) {
              var slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');

              if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                var originalSlide = swiper.$wrapperEl.children("[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]:not(." + swiper.params.slideDuplicateClass + ")");
                swiper.lazy.loadInSlide(originalSlide.index(), false);
              } else {
                var duplicatedSlide = swiper.$wrapperEl.children("." + swiper.params.slideDuplicateClass + "[data-swiper-slide-index=\"" + slideOriginalIndex + "\"]");
                swiper.lazy.loadInSlide(duplicatedSlide.index(), false);
              }
            }

            swiper.emit('lazyImageReady', $slideEl[0], $imageEl[0]);
          });
          swiper.emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
        });
      },
      load: function load() {
        var swiper = this;
        var $wrapperEl = swiper.$wrapperEl;
        var swiperParams = swiper.params;
        var slides = swiper.slides;
        var activeIndex = swiper.activeIndex;
        var isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        var params = swiperParams.lazy;
        var slidesPerView = swiperParams.slidesPerView;

        if (slidesPerView === 'auto') {
          slidesPerView = 0;
        }

        function slideExist(index) {
          if (isVirtual) {
            if ($wrapperEl.children("." + swiperParams.slideClass + "[data-swiper-slide-index=\"" + index + "\"]").length) {
              return true;
            }
          } else if (slides[index]) {
            return true;
          }

          return false;
        }

        function slideIndex(slideEl) {
          if (isVirtual) {
            return $(slideEl).attr('data-swiper-slide-index');
          }

          return $(slideEl).index();
        }

        if (!swiper.lazy.initialImageLoaded) {
          swiper.lazy.initialImageLoaded = true;
        }

        if (swiper.params.watchSlidesVisibility) {
          $wrapperEl.children("." + swiperParams.slideVisibleClass).each(function (elIndex, slideEl) {
            var index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
            swiper.lazy.loadInSlide(index);
          });
        } else if (slidesPerView > 1) {
          for (var i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
            if (slideExist(i)) {
              swiper.lazy.loadInSlide(i);
            }
          }
        } else {
          swiper.lazy.loadInSlide(activeIndex);
        }

        if (params.loadPrevNext) {
          if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
            var amount = params.loadPrevNextAmount;
            var spv = slidesPerView;
            var maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
            var minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides

            for (var i$1 = activeIndex + slidesPerView; i$1 < maxIndex; i$1 += 1) {
              if (slideExist(i$1)) {
                swiper.lazy.loadInSlide(i$1);
              }
            } // Prev Slides


            for (var i$2 = minIndex; i$2 < activeIndex; i$2 += 1) {
              if (slideExist(i$2)) {
                swiper.lazy.loadInSlide(i$2);
              }
            }
          } else {
            var nextSlide = $wrapperEl.children("." + swiperParams.slideNextClass);

            if (nextSlide.length > 0) {
              swiper.lazy.loadInSlide(slideIndex(nextSlide));
            }

            var prevSlide = $wrapperEl.children("." + swiperParams.slidePrevClass);

            if (prevSlide.length > 0) {
              swiper.lazy.loadInSlide(slideIndex(prevSlide));
            }
          }
        }
      }
    };
    var Lazy$1 = {
      name: 'lazy',
      params: {
        lazy: {
          enabled: false,
          loadPrevNext: false,
          loadPrevNextAmount: 1,
          loadOnTransitionStart: false,
          elementClass: 'swiper-lazy',
          loadingClass: 'swiper-lazy-loading',
          loadedClass: 'swiper-lazy-loaded',
          preloaderClass: 'swiper-lazy-preloader'
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          lazy: {
            initialImageLoaded: false,
            load: Lazy.load.bind(swiper),
            loadInSlide: Lazy.loadInSlide.bind(swiper)
          }
        });
      },
      on: {
        beforeInit: function beforeInit() {
          var swiper = this;

          if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
            swiper.params.preloadImages = false;
          }
        },
        init: function init() {
          var swiper = this;

          if (swiper.params.lazy.enabled && !swiper.params.loop && swiper.params.initialSlide === 0) {
            swiper.lazy.load();
          }
        },
        scroll: function scroll() {
          var swiper = this;

          if (swiper.params.freeMode && !swiper.params.freeModeSticky) {
            swiper.lazy.load();
          }
        },
        resize: function resize() {
          var swiper = this;

          if (swiper.params.lazy.enabled) {
            swiper.lazy.load();
          }
        },
        scrollbarDragMove: function scrollbarDragMove() {
          var swiper = this;

          if (swiper.params.lazy.enabled) {
            swiper.lazy.load();
          }
        },
        transitionStart: function transitionStart() {
          var swiper = this;

          if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !swiper.lazy.initialImageLoaded) {
              swiper.lazy.load();
            }
          }
        },
        transitionEnd: function transitionEnd() {
          var swiper = this;

          if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            swiper.lazy.load();
          }
        }
      }
    };
    /* eslint no-bitwise: ["error", { "allow": [">>"] }] */

    var Controller = {
      LinearSpline: function LinearSpline(x, y) {
        var binarySearch = function search() {
          var maxIndex;
          var minIndex;
          var guess;
          return function (array, val) {
            minIndex = -1;
            maxIndex = array.length;

            while (maxIndex - minIndex > 1) {
              guess = maxIndex + minIndex >> 1;

              if (array[guess] <= val) {
                minIndex = guess;
              } else {
                maxIndex = guess;
              }
            }

            return maxIndex;
          };
        }();

        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.

        var i1;
        var i3;

        this.interpolate = function interpolate(x2) {
          if (!x2) {
            return 0;
          } // Get the indexes of x1 and x3 (the array indexes before and after given x2):


          i3 = binarySearch(this.x, x2);
          i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
          // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1

          return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };

        return this;
      },
      // xxx: for now i will just save one spline function to to
      getInterpolateFunction: function getInterpolateFunction(c) {
        var swiper = this;

        if (!swiper.controller.spline) {
          swiper.controller.spline = swiper.params.loop ? new Controller.LinearSpline(swiper.slidesGrid, c.slidesGrid) : new Controller.LinearSpline(swiper.snapGrid, c.snapGrid);
        }
      },
      setTranslate: function setTranslate(setTranslate$1, byController) {
        var swiper = this;
        var controlled = swiper.controller.control;
        var multiplier;
        var controlledTranslate;

        function setControlledTranslate(c) {
          // this will create an Interpolate function based on the snapGrids
          // x is the Grid of the scrolled scroller and y will be the controlled scroller
          // it makes sense to create this only once and recall it for the interpolation
          // the function does a lot of value caching for performance
          var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;

          if (swiper.params.controller.by === 'slide') {
            swiper.controller.getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
            // but it did not work out

            controlledTranslate = -swiper.controller.spline.interpolate(-translate);
          }

          if (!controlledTranslate || swiper.params.controller.by === 'container') {
            multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
            controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
          }

          if (swiper.params.controller.inverse) {
            controlledTranslate = c.maxTranslate() - controlledTranslate;
          }

          c.updateProgress(controlledTranslate);
          c.setTranslate(controlledTranslate, swiper);
          c.updateActiveIndex();
          c.updateSlidesClasses();
        }

        if (Array.isArray(controlled)) {
          for (var i = 0; i < controlled.length; i += 1) {
            if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
              setControlledTranslate(controlled[i]);
            }
          }
        } else if (controlled instanceof Swiper && byController !== controlled) {
          setControlledTranslate(controlled);
        }
      },
      setTransition: function setTransition(duration, byController) {
        var swiper = this;
        var controlled = swiper.controller.control;
        var i;

        function setControlledTransition(c) {
          c.setTransition(duration, swiper);

          if (duration !== 0) {
            c.transitionStart();

            if (c.params.autoHeight) {
              Utils.nextTick(function () {
                c.updateAutoHeight();
              });
            }

            c.$wrapperEl.transitionEnd(function () {
              if (!controlled) {
                return;
              }

              if (c.params.loop && swiper.params.controller.by === 'slide') {
                c.loopFix();
              }

              c.transitionEnd();
            });
          }
        }

        if (Array.isArray(controlled)) {
          for (i = 0; i < controlled.length; i += 1) {
            if (controlled[i] !== byController && controlled[i] instanceof Swiper) {
              setControlledTransition(controlled[i]);
            }
          }
        } else if (controlled instanceof Swiper && byController !== controlled) {
          setControlledTransition(controlled);
        }
      }
    };
    var Controller$1 = {
      name: 'controller',
      params: {
        controller: {
          control: undefined,
          inverse: false,
          by: 'slide' // or 'container'

        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          controller: {
            control: swiper.params.controller.control,
            getInterpolateFunction: Controller.getInterpolateFunction.bind(swiper),
            setTranslate: Controller.setTranslate.bind(swiper),
            setTransition: Controller.setTransition.bind(swiper)
          }
        });
      },
      on: {
        update: function update() {
          var swiper = this;

          if (!swiper.controller.control) {
            return;
          }

          if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
          }
        },
        resize: function resize() {
          var swiper = this;

          if (!swiper.controller.control) {
            return;
          }

          if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
          }
        },
        observerUpdate: function observerUpdate() {
          var swiper = this;

          if (!swiper.controller.control) {
            return;
          }

          if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
          }
        },
        setTranslate: function setTranslate(translate, byController) {
          var swiper = this;

          if (!swiper.controller.control) {
            return;
          }

          swiper.controller.setTranslate(translate, byController);
        },
        setTransition: function setTransition(duration, byController) {
          var swiper = this;

          if (!swiper.controller.control) {
            return;
          }

          swiper.controller.setTransition(duration, byController);
        }
      }
    };
    var a11y = {
      makeElFocusable: function makeElFocusable($el) {
        $el.attr('tabIndex', '0');
        return $el;
      },
      addElRole: function addElRole($el, role) {
        $el.attr('role', role);
        return $el;
      },
      addElLabel: function addElLabel($el, label) {
        $el.attr('aria-label', label);
        return $el;
      },
      disableEl: function disableEl($el) {
        $el.attr('aria-disabled', true);
        return $el;
      },
      enableEl: function enableEl($el) {
        $el.attr('aria-disabled', false);
        return $el;
      },
      onEnterKey: function onEnterKey(e) {
        var swiper = this;
        var params = swiper.params.a11y;

        if (e.keyCode !== 13) {
          return;
        }

        var $targetEl = $(e.target);

        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
          if (!(swiper.isEnd && !swiper.params.loop)) {
            swiper.slideNext();
          }

          if (swiper.isEnd) {
            swiper.a11y.notify(params.lastSlideMessage);
          } else {
            swiper.a11y.notify(params.nextSlideMessage);
          }
        }

        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
          if (!(swiper.isBeginning && !swiper.params.loop)) {
            swiper.slidePrev();
          }

          if (swiper.isBeginning) {
            swiper.a11y.notify(params.firstSlideMessage);
          } else {
            swiper.a11y.notify(params.prevSlideMessage);
          }
        }

        if (swiper.pagination && $targetEl.is("." + swiper.params.pagination.bulletClass)) {
          $targetEl[0].click();
        }
      },
      notify: function notify(message) {
        var swiper = this;
        var notification = swiper.a11y.liveRegion;

        if (notification.length === 0) {
          return;
        }

        notification.html('');
        notification.html(message);
      },
      updateNavigation: function updateNavigation() {
        var swiper = this;

        if (swiper.params.loop) {
          return;
        }

        var ref = swiper.navigation;
        var $nextEl = ref.$nextEl;
        var $prevEl = ref.$prevEl;

        if ($prevEl && $prevEl.length > 0) {
          if (swiper.isBeginning) {
            swiper.a11y.disableEl($prevEl);
          } else {
            swiper.a11y.enableEl($prevEl);
          }
        }

        if ($nextEl && $nextEl.length > 0) {
          if (swiper.isEnd) {
            swiper.a11y.disableEl($nextEl);
          } else {
            swiper.a11y.enableEl($nextEl);
          }
        }
      },
      updatePagination: function updatePagination() {
        var swiper = this;
        var params = swiper.params.a11y;

        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
          swiper.pagination.bullets.each(function (bulletIndex, bulletEl) {
            var $bulletEl = $(bulletEl);
            swiper.a11y.makeElFocusable($bulletEl);
            swiper.a11y.addElRole($bulletEl, 'button');
            swiper.a11y.addElLabel($bulletEl, params.paginationBulletMessage.replace(/{{index}}/, $bulletEl.index() + 1));
          });
        }
      },
      init: function init() {
        var swiper = this;
        swiper.$el.append(swiper.a11y.liveRegion); // Navigation

        var params = swiper.params.a11y;
        var $nextEl;
        var $prevEl;

        if (swiper.navigation && swiper.navigation.$nextEl) {
          $nextEl = swiper.navigation.$nextEl;
        }

        if (swiper.navigation && swiper.navigation.$prevEl) {
          $prevEl = swiper.navigation.$prevEl;
        }

        if ($nextEl) {
          swiper.a11y.makeElFocusable($nextEl);
          swiper.a11y.addElRole($nextEl, 'button');
          swiper.a11y.addElLabel($nextEl, params.nextSlideMessage);
          $nextEl.on('keydown', swiper.a11y.onEnterKey);
        }

        if ($prevEl) {
          swiper.a11y.makeElFocusable($prevEl);
          swiper.a11y.addElRole($prevEl, 'button');
          swiper.a11y.addElLabel($prevEl, params.prevSlideMessage);
          $prevEl.on('keydown', swiper.a11y.onEnterKey);
        } // Pagination


        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
          swiper.pagination.$el.on('keydown', "." + swiper.params.pagination.bulletClass, swiper.a11y.onEnterKey);
        }
      },
      destroy: function destroy() {
        var swiper = this;

        if (swiper.a11y.liveRegion && swiper.a11y.liveRegion.length > 0) {
          swiper.a11y.liveRegion.remove();
        }

        var $nextEl;
        var $prevEl;

        if (swiper.navigation && swiper.navigation.$nextEl) {
          $nextEl = swiper.navigation.$nextEl;
        }

        if (swiper.navigation && swiper.navigation.$prevEl) {
          $prevEl = swiper.navigation.$prevEl;
        }

        if ($nextEl) {
          $nextEl.off('keydown', swiper.a11y.onEnterKey);
        }

        if ($prevEl) {
          $prevEl.off('keydown', swiper.a11y.onEnterKey);
        } // Pagination


        if (swiper.pagination && swiper.params.pagination.clickable && swiper.pagination.bullets && swiper.pagination.bullets.length) {
          swiper.pagination.$el.off('keydown', "." + swiper.params.pagination.bulletClass, swiper.a11y.onEnterKey);
        }
      }
    };
    var A11y = {
      name: 'a11y',
      params: {
        a11y: {
          enabled: true,
          notificationClass: 'swiper-notification',
          prevSlideMessage: 'Previous slide',
          nextSlideMessage: 'Next slide',
          firstSlideMessage: 'This is the first slide',
          lastSlideMessage: 'This is the last slide',
          paginationBulletMessage: 'Go to slide {{index}}'
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          a11y: {
            liveRegion: $("<span class=\"" + swiper.params.a11y.notificationClass + "\" aria-live=\"assertive\" aria-atomic=\"true\"></span>")
          }
        });
        Object.keys(a11y).forEach(function (methodName) {
          swiper.a11y[methodName] = a11y[methodName].bind(swiper);
        });
      },
      on: {
        init: function init() {
          var swiper = this;

          if (!swiper.params.a11y.enabled) {
            return;
          }

          swiper.a11y.init();
          swiper.a11y.updateNavigation();
        },
        toEdge: function toEdge() {
          var swiper = this;

          if (!swiper.params.a11y.enabled) {
            return;
          }

          swiper.a11y.updateNavigation();
        },
        fromEdge: function fromEdge() {
          var swiper = this;

          if (!swiper.params.a11y.enabled) {
            return;
          }

          swiper.a11y.updateNavigation();
        },
        paginationUpdate: function paginationUpdate() {
          var swiper = this;

          if (!swiper.params.a11y.enabled) {
            return;
          }

          swiper.a11y.updatePagination();
        },
        destroy: function destroy() {
          var swiper = this;

          if (!swiper.params.a11y.enabled) {
            return;
          }

          swiper.a11y.destroy();
        }
      }
    };
    var History = {
      init: function init() {
        var swiper = this;

        if (!swiper.params.history) {
          return;
        }

        if (!win.history || !win.history.pushState) {
          swiper.params.history.enabled = false;
          swiper.params.hashNavigation.enabled = true;
          return;
        }

        var history = swiper.history;
        history.initialized = true;
        history.paths = History.getPathValues();

        if (!history.paths.key && !history.paths.value) {
          return;
        }

        history.scrollToSlide(0, history.paths.value, swiper.params.runCallbacksOnInit);

        if (!swiper.params.history.replaceState) {
          win.addEventListener('popstate', swiper.history.setHistoryPopState);
        }
      },
      destroy: function destroy() {
        var swiper = this;

        if (!swiper.params.history.replaceState) {
          win.removeEventListener('popstate', swiper.history.setHistoryPopState);
        }
      },
      setHistoryPopState: function setHistoryPopState() {
        var swiper = this;
        swiper.history.paths = History.getPathValues();
        swiper.history.scrollToSlide(swiper.params.speed, swiper.history.paths.value, false);
      },
      getPathValues: function getPathValues() {
        var pathArray = win.location.pathname.slice(1).split('/').filter(function (part) {
          return part !== '';
        });
        var total = pathArray.length;
        var key = pathArray[total - 2];
        var value = pathArray[total - 1];
        return {
          key: key,
          value: value
        };
      },
      setHistory: function setHistory(key, index) {
        var swiper = this;

        if (!swiper.history.initialized || !swiper.params.history.enabled) {
          return;
        }

        var slide = swiper.slides.eq(index);
        var value = History.slugify(slide.attr('data-history'));

        if (!win.location.pathname.includes(key)) {
          value = key + "/" + value;
        }

        var currentState = win.history.state;

        if (currentState && currentState.value === value) {
          return;
        }

        if (swiper.params.history.replaceState) {
          win.history.replaceState({
            value: value
          }, null, value);
        } else {
          win.history.pushState({
            value: value
          }, null, value);
        }
      },
      slugify: function slugify(text) {
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
      },
      scrollToSlide: function scrollToSlide(speed, value, runCallbacks) {
        var swiper = this;

        if (value) {
          for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
            var slide = swiper.slides.eq(i);
            var slideHistory = History.slugify(slide.attr('data-history'));

            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
              var index = slide.index();
              swiper.slideTo(index, speed, runCallbacks);
            }
          }
        } else {
          swiper.slideTo(0, speed, runCallbacks);
        }
      }
    };
    var History$1 = {
      name: 'history',
      params: {
        history: {
          enabled: false,
          replaceState: false,
          key: 'slides'
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          history: {
            init: History.init.bind(swiper),
            setHistory: History.setHistory.bind(swiper),
            setHistoryPopState: History.setHistoryPopState.bind(swiper),
            scrollToSlide: History.scrollToSlide.bind(swiper),
            destroy: History.destroy.bind(swiper)
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;

          if (swiper.params.history.enabled) {
            swiper.history.init();
          }
        },
        destroy: function destroy() {
          var swiper = this;

          if (swiper.params.history.enabled) {
            swiper.history.destroy();
          }
        },
        transitionEnd: function transitionEnd() {
          var swiper = this;

          if (swiper.history.initialized) {
            swiper.history.setHistory(swiper.params.history.key, swiper.activeIndex);
          }
        }
      }
    };
    var HashNavigation = {
      onHashCange: function onHashCange() {
        var swiper = this;
        var newHash = doc.location.hash.replace('#', '');
        var activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');

        if (newHash !== activeSlideHash) {
          var newIndex = swiper.$wrapperEl.children("." + swiper.params.slideClass + "[data-hash=\"" + newHash + "\"]").index();

          if (typeof newIndex === 'undefined') {
            return;
          }

          swiper.slideTo(newIndex);
        }
      },
      setHash: function setHash() {
        var swiper = this;

        if (!swiper.hashNavigation.initialized || !swiper.params.hashNavigation.enabled) {
          return;
        }

        if (swiper.params.hashNavigation.replaceState && win.history && win.history.replaceState) {
          win.history.replaceState(null, null, "#" + swiper.slides.eq(swiper.activeIndex).attr('data-hash') || '');
        } else {
          var slide = swiper.slides.eq(swiper.activeIndex);
          var hash = slide.attr('data-hash') || slide.attr('data-history');
          doc.location.hash = hash || '';
        }
      },
      init: function init() {
        var swiper = this;

        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) {
          return;
        }

        swiper.hashNavigation.initialized = true;
        var hash = doc.location.hash.replace('#', '');

        if (hash) {
          var speed = 0;

          for (var i = 0, length = swiper.slides.length; i < length; i += 1) {
            var slide = swiper.slides.eq(i);
            var slideHash = slide.attr('data-hash') || slide.attr('data-history');

            if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
              var index = slide.index();
              swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
            }
          }
        }

        if (swiper.params.hashNavigation.watchState) {
          $(win).on('hashchange', swiper.hashNavigation.onHashCange);
        }
      },
      destroy: function destroy() {
        var swiper = this;

        if (swiper.params.hashNavigation.watchState) {
          $(win).off('hashchange', swiper.hashNavigation.onHashCange);
        }
      }
    };
    var HashNavigation$1 = {
      name: 'hash-navigation',
      params: {
        hashNavigation: {
          enabled: false,
          replaceState: false,
          watchState: false
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          hashNavigation: {
            initialized: false,
            init: HashNavigation.init.bind(swiper),
            destroy: HashNavigation.destroy.bind(swiper),
            setHash: HashNavigation.setHash.bind(swiper),
            onHashCange: HashNavigation.onHashCange.bind(swiper)
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;

          if (swiper.params.hashNavigation.enabled) {
            swiper.hashNavigation.init();
          }
        },
        destroy: function destroy() {
          var swiper = this;

          if (swiper.params.hashNavigation.enabled) {
            swiper.hashNavigation.destroy();
          }
        },
        transitionEnd: function transitionEnd() {
          var swiper = this;

          if (swiper.hashNavigation.initialized) {
            swiper.hashNavigation.setHash();
          }
        }
      }
    };
    /* eslint no-underscore-dangle: "off" */

    var Autoplay = {
      run: function run() {
        var swiper = this;
        var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        var delay = swiper.params.autoplay.delay;

        if ($activeSlideEl.attr('data-swiper-autoplay')) {
          delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
        }

        clearTimeout(swiper.autoplay.timeout);
        swiper.autoplay.timeout = Utils.nextTick(function () {
          if (swiper.params.autoplay.reverseDirection) {
            if (swiper.params.loop) {
              swiper.loopFix();
              swiper.slidePrev(swiper.params.speed, true, true);
              swiper.emit('autoplay');
            } else if (!swiper.isBeginning) {
              swiper.slidePrev(swiper.params.speed, true, true);
              swiper.emit('autoplay');
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
              swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
              swiper.emit('autoplay');
            } else {
              swiper.autoplay.stop();
            }
          } else if (swiper.params.loop) {
            swiper.loopFix();
            swiper.slideNext(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.isEnd) {
            swiper.slideNext(swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else if (!swiper.params.autoplay.stopOnLastSlide) {
            swiper.slideTo(0, swiper.params.speed, true, true);
            swiper.emit('autoplay');
          } else {
            swiper.autoplay.stop();
          }
        }, delay);
      },
      start: function start() {
        var swiper = this;

        if (typeof swiper.autoplay.timeout !== 'undefined') {
          return false;
        }

        if (swiper.autoplay.running) {
          return false;
        }

        swiper.autoplay.running = true;
        swiper.emit('autoplayStart');
        swiper.autoplay.run();
        return true;
      },
      stop: function stop() {
        var swiper = this;

        if (!swiper.autoplay.running) {
          return false;
        }

        if (typeof swiper.autoplay.timeout === 'undefined') {
          return false;
        }

        if (swiper.autoplay.timeout) {
          clearTimeout(swiper.autoplay.timeout);
          swiper.autoplay.timeout = undefined;
        }

        swiper.autoplay.running = false;
        swiper.emit('autoplayStop');
        return true;
      },
      pause: function pause(speed) {
        var swiper = this;

        if (!swiper.autoplay.running) {
          return;
        }

        if (swiper.autoplay.paused) {
          return;
        }

        if (swiper.autoplay.timeout) {
          clearTimeout(swiper.autoplay.timeout);
        }

        swiper.autoplay.paused = true;

        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
          swiper.autoplay.paused = false;
          swiper.autoplay.run();
        } else {
          swiper.$wrapperEl[0].addEventListener('transitionend', swiper.autoplay.onTransitionEnd);
          swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
        }
      }
    };
    var Autoplay$1 = {
      name: 'autoplay',
      params: {
        autoplay: {
          enabled: false,
          delay: 3000,
          waitForTransition: true,
          disableOnInteraction: true,
          stopOnLastSlide: false,
          reverseDirection: false
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          autoplay: {
            running: false,
            paused: false,
            run: Autoplay.run.bind(swiper),
            start: Autoplay.start.bind(swiper),
            stop: Autoplay.stop.bind(swiper),
            pause: Autoplay.pause.bind(swiper),
            onTransitionEnd: function onTransitionEnd(e) {
              if (!swiper || swiper.destroyed || !swiper.$wrapperEl) {
                return;
              }

              if (e.target !== this) {
                return;
              }

              swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.autoplay.onTransitionEnd);
              swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.autoplay.onTransitionEnd);
              swiper.autoplay.paused = false;

              if (!swiper.autoplay.running) {
                swiper.autoplay.stop();
              } else {
                swiper.autoplay.run();
              }
            }
          }
        });
      },
      on: {
        init: function init() {
          var swiper = this;

          if (swiper.params.autoplay.enabled) {
            swiper.autoplay.start();
          }
        },
        beforeTransitionStart: function beforeTransitionStart(speed, internal) {
          var swiper = this;

          if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) {
              swiper.autoplay.pause(speed);
            } else {
              swiper.autoplay.stop();
            }
          }
        },
        sliderFirstMove: function sliderFirstMove() {
          var swiper = this;

          if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) {
              swiper.autoplay.stop();
            } else {
              swiper.autoplay.pause();
            }
          }
        },
        destroy: function destroy() {
          var swiper = this;

          if (swiper.autoplay.running) {
            swiper.autoplay.stop();
          }
        }
      }
    };
    var Fade = {
      setTranslate: function setTranslate() {
        var swiper = this;
        var slides = swiper.slides;

        for (var i = 0; i < slides.length; i += 1) {
          var $slideEl = swiper.slides.eq(i);
          var offset = $slideEl[0].swiperSlideOffset;
          var tx = -offset;

          if (!swiper.params.virtualTranslate) {
            tx -= swiper.translate;
          }

          var ty = 0;

          if (!swiper.isHorizontal()) {
            ty = tx;
            tx = 0;
          }

          var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
          $slideEl.css({
            opacity: slideOpacity
          }).transform("translate3d(" + tx + "px, " + ty + "px, 0px)");
        }
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var slides = swiper.slides;
        var $wrapperEl = swiper.$wrapperEl;
        slides.transition(duration);

        if (swiper.params.virtualTranslate && duration !== 0) {
          var eventTriggered = false;
          slides.transitionEnd(function () {
            if (eventTriggered) {
              return;
            }

            if (!swiper || swiper.destroyed) {
              return;
            }

            eventTriggered = true;
            swiper.animating = false;
            var triggerEvents = ['webkitTransitionEnd', 'transitionend'];

            for (var i = 0; i < triggerEvents.length; i += 1) {
              $wrapperEl.trigger(triggerEvents[i]);
            }
          });
        }
      }
    };
    var EffectFade = {
      name: 'effect-fade',
      params: {
        fadeEffect: {
          crossFade: false
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          fadeEffect: {
            setTranslate: Fade.setTranslate.bind(swiper),
            setTransition: Fade.setTransition.bind(swiper)
          }
        });
      },
      on: {
        beforeInit: function beforeInit() {
          var swiper = this;

          if (swiper.params.effect !== 'fade') {
            return;
          }

          swiper.classNames.push(swiper.params.containerModifierClass + "fade");
          var overwriteParams = {
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            spaceBetween: 0,
            virtualTranslate: true
          };
          Utils.extend(swiper.params, overwriteParams);
          Utils.extend(swiper.originalParams, overwriteParams);
        },
        setTranslate: function setTranslate() {
          var swiper = this;

          if (swiper.params.effect !== 'fade') {
            return;
          }

          swiper.fadeEffect.setTranslate();
        },
        setTransition: function setTransition(duration) {
          var swiper = this;

          if (swiper.params.effect !== 'fade') {
            return;
          }

          swiper.fadeEffect.setTransition(duration);
        }
      }
    };
    var Cube = {
      setTranslate: function setTranslate() {
        var swiper = this;
        var $el = swiper.$el;
        var $wrapperEl = swiper.$wrapperEl;
        var slides = swiper.slides;
        var swiperWidth = swiper.width;
        var swiperHeight = swiper.height;
        var rtl = swiper.rtlTranslate;
        var swiperSize = swiper.size;
        var params = swiper.params.cubeEffect;
        var isHorizontal = swiper.isHorizontal();
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var wrapperRotate = 0;
        var $cubeShadowEl;

        if (params.shadow) {
          if (isHorizontal) {
            $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');

            if ($cubeShadowEl.length === 0) {
              $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
              $wrapperEl.append($cubeShadowEl);
            }

            $cubeShadowEl.css({
              height: swiperWidth + "px"
            });
          } else {
            $cubeShadowEl = $el.find('.swiper-cube-shadow');

            if ($cubeShadowEl.length === 0) {
              $cubeShadowEl = $('<div class="swiper-cube-shadow"></div>');
              $el.append($cubeShadowEl);
            }
          }
        }

        for (var i = 0; i < slides.length; i += 1) {
          var $slideEl = slides.eq(i);
          var slideIndex = i;

          if (isVirtual) {
            slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
          }

          var slideAngle = slideIndex * 90;
          var round = Math.floor(slideAngle / 360);

          if (rtl) {
            slideAngle = -slideAngle;
            round = Math.floor(-slideAngle / 360);
          }

          var progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
          var tx = 0;
          var ty = 0;
          var tz = 0;

          if (slideIndex % 4 === 0) {
            tx = -round * 4 * swiperSize;
            tz = 0;
          } else if ((slideIndex - 1) % 4 === 0) {
            tx = 0;
            tz = -round * 4 * swiperSize;
          } else if ((slideIndex - 2) % 4 === 0) {
            tx = swiperSize + round * 4 * swiperSize;
            tz = swiperSize;
          } else if ((slideIndex - 3) % 4 === 0) {
            tx = -swiperSize;
            tz = 3 * swiperSize + swiperSize * 4 * round;
          }

          if (rtl) {
            tx = -tx;
          }

          if (!isHorizontal) {
            ty = tx;
            tx = 0;
          }

          var transform = "rotateX(" + (isHorizontal ? 0 : -slideAngle) + "deg) rotateY(" + (isHorizontal ? slideAngle : 0) + "deg) translate3d(" + tx + "px, " + ty + "px, " + tz + "px)";

          if (progress <= 1 && progress > -1) {
            wrapperRotate = slideIndex * 90 + progress * 90;

            if (rtl) {
              wrapperRotate = -slideIndex * 90 - progress * 90;
            }
          }

          $slideEl.transform(transform);

          if (params.slideShadows) {
            // Set shadows
            var shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
            var shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

            if (shadowBefore.length === 0) {
              shadowBefore = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>");
              $slideEl.append(shadowBefore);
            }

            if (shadowAfter.length === 0) {
              shadowAfter = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>");
              $slideEl.append(shadowAfter);
            }

            if (shadowBefore.length) {
              shadowBefore[0].style.opacity = Math.max(-progress, 0);
            }

            if (shadowAfter.length) {
              shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
          }
        }

        $wrapperEl.css({
          '-webkit-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
          '-moz-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
          '-ms-transform-origin': "50% 50% -" + swiperSize / 2 + "px",
          'transform-origin': "50% 50% -" + swiperSize / 2 + "px"
        });

        if (params.shadow) {
          if (isHorizontal) {
            $cubeShadowEl.transform("translate3d(0px, " + (swiperWidth / 2 + params.shadowOffset) + "px, " + -swiperWidth / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + params.shadowScale + ")");
          } else {
            var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
            var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
            var scale1 = params.shadowScale;
            var scale2 = params.shadowScale / multiplier;
            var offset = params.shadowOffset;
            $cubeShadowEl.transform("scale3d(" + scale1 + ", 1, " + scale2 + ") translate3d(0px, " + (swiperHeight / 2 + offset) + "px, " + -swiperHeight / 2 / scale2 + "px) rotateX(-90deg)");
          }
        }

        var zFactor = Browser.isSafari || Browser.isUiWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform("translate3d(0px,0," + zFactor + "px) rotateX(" + (swiper.isHorizontal() ? 0 : wrapperRotate) + "deg) rotateY(" + (swiper.isHorizontal() ? -wrapperRotate : 0) + "deg)");
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var $el = swiper.$el;
        var slides = swiper.slides;
        slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);

        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
          $el.find('.swiper-cube-shadow').transition(duration);
        }
      }
    };
    var EffectCube = {
      name: 'effect-cube',
      params: {
        cubeEffect: {
          slideShadows: true,
          shadow: true,
          shadowOffset: 20,
          shadowScale: 0.94
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          cubeEffect: {
            setTranslate: Cube.setTranslate.bind(swiper),
            setTransition: Cube.setTransition.bind(swiper)
          }
        });
      },
      on: {
        beforeInit: function beforeInit() {
          var swiper = this;

          if (swiper.params.effect !== 'cube') {
            return;
          }

          swiper.classNames.push(swiper.params.containerModifierClass + "cube");
          swiper.classNames.push(swiper.params.containerModifierClass + "3d");
          var overwriteParams = {
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            resistanceRatio: 0,
            spaceBetween: 0,
            centeredSlides: false,
            virtualTranslate: true
          };
          Utils.extend(swiper.params, overwriteParams);
          Utils.extend(swiper.originalParams, overwriteParams);
        },
        setTranslate: function setTranslate() {
          var swiper = this;

          if (swiper.params.effect !== 'cube') {
            return;
          }

          swiper.cubeEffect.setTranslate();
        },
        setTransition: function setTransition(duration) {
          var swiper = this;

          if (swiper.params.effect !== 'cube') {
            return;
          }

          swiper.cubeEffect.setTransition(duration);
        }
      }
    };
    var Flip = {
      setTranslate: function setTranslate() {
        var swiper = this;
        var slides = swiper.slides;
        var rtl = swiper.rtlTranslate;

        for (var i = 0; i < slides.length; i += 1) {
          var $slideEl = slides.eq(i);
          var progress = $slideEl[0].progress;

          if (swiper.params.flipEffect.limitRotation) {
            progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
          }

          var offset = $slideEl[0].swiperSlideOffset;
          var rotate = -180 * progress;
          var rotateY = rotate;
          var rotateX = 0;
          var tx = -offset;
          var ty = 0;

          if (!swiper.isHorizontal()) {
            ty = tx;
            tx = 0;
            rotateX = -rotateY;
            rotateY = 0;
          } else if (rtl) {
            rotateY = -rotateY;
          }

          $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;

          if (swiper.params.flipEffect.slideShadows) {
            // Set shadows
            var shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
            var shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

            if (shadowBefore.length === 0) {
              shadowBefore = $("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'left' : 'top') + "\"></div>");
              $slideEl.append(shadowBefore);
            }

            if (shadowAfter.length === 0) {
              shadowAfter = $("<div class=\"swiper-slide-shadow-" + (swiper.isHorizontal() ? 'right' : 'bottom') + "\"></div>");
              $slideEl.append(shadowAfter);
            }

            if (shadowBefore.length) {
              shadowBefore[0].style.opacity = Math.max(-progress, 0);
            }

            if (shadowAfter.length) {
              shadowAfter[0].style.opacity = Math.max(progress, 0);
            }
          }

          $slideEl.transform("translate3d(" + tx + "px, " + ty + "px, 0px) rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)");
        }
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        var slides = swiper.slides;
        var activeIndex = swiper.activeIndex;
        var $wrapperEl = swiper.$wrapperEl;
        slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);

        if (swiper.params.virtualTranslate && duration !== 0) {
          var eventTriggered = false; // eslint-disable-next-line

          slides.eq(activeIndex).transitionEnd(function onTransitionEnd() {
            if (eventTriggered) {
              return;
            }

            if (!swiper || swiper.destroyed) {
              return;
            } // if (!$(this).hasClass(swiper.params.slideActiveClass)) return;


            eventTriggered = true;
            swiper.animating = false;
            var triggerEvents = ['webkitTransitionEnd', 'transitionend'];

            for (var i = 0; i < triggerEvents.length; i += 1) {
              $wrapperEl.trigger(triggerEvents[i]);
            }
          });
        }
      }
    };
    var EffectFlip = {
      name: 'effect-flip',
      params: {
        flipEffect: {
          slideShadows: true,
          limitRotation: true
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          flipEffect: {
            setTranslate: Flip.setTranslate.bind(swiper),
            setTransition: Flip.setTransition.bind(swiper)
          }
        });
      },
      on: {
        beforeInit: function beforeInit() {
          var swiper = this;

          if (swiper.params.effect !== 'flip') {
            return;
          }

          swiper.classNames.push(swiper.params.containerModifierClass + "flip");
          swiper.classNames.push(swiper.params.containerModifierClass + "3d");
          var overwriteParams = {
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: true,
            spaceBetween: 0,
            virtualTranslate: true
          };
          Utils.extend(swiper.params, overwriteParams);
          Utils.extend(swiper.originalParams, overwriteParams);
        },
        setTranslate: function setTranslate() {
          var swiper = this;

          if (swiper.params.effect !== 'flip') {
            return;
          }

          swiper.flipEffect.setTranslate();
        },
        setTransition: function setTransition(duration) {
          var swiper = this;

          if (swiper.params.effect !== 'flip') {
            return;
          }

          swiper.flipEffect.setTransition(duration);
        }
      }
    };
    var Coverflow = {
      setTranslate: function setTranslate() {
        var swiper = this;
        var swiperWidth = swiper.width;
        var swiperHeight = swiper.height;
        var slides = swiper.slides;
        var $wrapperEl = swiper.$wrapperEl;
        var slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.coverflowEffect;
        var isHorizontal = swiper.isHorizontal();
        var transform = swiper.translate;
        var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        var rotate = isHorizontal ? params.rotate : -params.rotate;
        var translate = params.depth; // Each slide offset from center

        for (var i = 0, length = slides.length; i < length; i += 1) {
          var $slideEl = slides.eq(i);
          var slideSize = slidesSizesGrid[i];
          var slideOffset = $slideEl[0].swiperSlideOffset;
          var offsetMultiplier = (center - slideOffset - slideSize / 2) / slideSize * params.modifier;
          var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
          var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0

          var translateZ = -translate * Math.abs(offsetMultiplier);
          var translateY = isHorizontal ? 0 : params.stretch * offsetMultiplier;
          var translateX = isHorizontal ? params.stretch * offsetMultiplier : 0; // Fix for ultra small values

          if (Math.abs(translateX) < 0.001) {
            translateX = 0;
          }

          if (Math.abs(translateY) < 0.001) {
            translateY = 0;
          }

          if (Math.abs(translateZ) < 0.001) {
            translateZ = 0;
          }

          if (Math.abs(rotateY) < 0.001) {
            rotateY = 0;
          }

          if (Math.abs(rotateX) < 0.001) {
            rotateX = 0;
          }

          var slideTransform = "translate3d(" + translateX + "px," + translateY + "px," + translateZ + "px)  rotateX(" + rotateX + "deg) rotateY(" + rotateY + "deg)";
          $slideEl.transform(slideTransform);
          $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;

          if (params.slideShadows) {
            // Set shadows
            var $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
            var $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');

            if ($shadowBeforeEl.length === 0) {
              $shadowBeforeEl = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'left' : 'top') + "\"></div>");
              $slideEl.append($shadowBeforeEl);
            }

            if ($shadowAfterEl.length === 0) {
              $shadowAfterEl = $("<div class=\"swiper-slide-shadow-" + (isHorizontal ? 'right' : 'bottom') + "\"></div>");
              $slideEl.append($shadowAfterEl);
            }

            if ($shadowBeforeEl.length) {
              $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
            }

            if ($shadowAfterEl.length) {
              $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
          }
        } // Set correct perspective for IE10


        if (Support.pointerEvents || Support.prefixedPointerEvents) {
          var ws = $wrapperEl[0].style;
          ws.perspectiveOrigin = center + "px 50%";
        }
      },
      setTransition: function setTransition(duration) {
        var swiper = this;
        swiper.slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
      }
    };
    var EffectCoverflow = {
      name: 'effect-coverflow',
      params: {
        coverflowEffect: {
          rotate: 50,
          stretch: 0,
          depth: 100,
          modifier: 1,
          slideShadows: true
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          coverflowEffect: {
            setTranslate: Coverflow.setTranslate.bind(swiper),
            setTransition: Coverflow.setTransition.bind(swiper)
          }
        });
      },
      on: {
        beforeInit: function beforeInit() {
          var swiper = this;

          if (swiper.params.effect !== 'coverflow') {
            return;
          }

          swiper.classNames.push(swiper.params.containerModifierClass + "coverflow");
          swiper.classNames.push(swiper.params.containerModifierClass + "3d");
          swiper.params.watchSlidesProgress = true;
          swiper.originalParams.watchSlidesProgress = true;
        },
        setTranslate: function setTranslate() {
          var swiper = this;

          if (swiper.params.effect !== 'coverflow') {
            return;
          }

          swiper.coverflowEffect.setTranslate();
        },
        setTransition: function setTransition(duration) {
          var swiper = this;

          if (swiper.params.effect !== 'coverflow') {
            return;
          }

          swiper.coverflowEffect.setTransition(duration);
        }
      }
    };
    var Thumbs = {
      init: function init() {
        var swiper = this;
        var ref = swiper.params;
        var thumbsParams = ref.thumbs;
        var SwiperClass = swiper.constructor;

        if (thumbsParams.swiper instanceof SwiperClass) {
          swiper.thumbs.swiper = thumbsParams.swiper;
          Utils.extend(swiper.thumbs.swiper.originalParams, {
            watchSlidesProgress: true,
            slideToClickedSlide: false
          });
          Utils.extend(swiper.thumbs.swiper.params, {
            watchSlidesProgress: true,
            slideToClickedSlide: false
          });
        } else if (Utils.isObject(thumbsParams.swiper)) {
          swiper.thumbs.swiper = new SwiperClass(Utils.extend({}, thumbsParams.swiper, {
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            slideToClickedSlide: false
          }));
          swiper.thumbs.swiperCreated = true;
        }

        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', swiper.thumbs.onThumbClick);
      },
      onThumbClick: function onThumbClick() {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;

        if (!thumbsSwiper) {
          return;
        }

        var clickedIndex = thumbsSwiper.clickedIndex;
        var clickedSlide = thumbsSwiper.clickedSlide;

        if (clickedSlide && $(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) {
          return;
        }

        if (typeof clickedIndex === 'undefined' || clickedIndex === null) {
          return;
        }

        var slideToIndex;

        if (thumbsSwiper.params.loop) {
          slideToIndex = parseInt($(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        } else {
          slideToIndex = clickedIndex;
        }

        if (swiper.params.loop) {
          var currentIndex = swiper.activeIndex;

          if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
            swiper.loopFix(); // eslint-disable-next-line

            swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
            currentIndex = swiper.activeIndex;
          }

          var prevIndex = swiper.slides.eq(currentIndex).prevAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();
          var nextIndex = swiper.slides.eq(currentIndex).nextAll("[data-swiper-slide-index=\"" + slideToIndex + "\"]").eq(0).index();

          if (typeof prevIndex === 'undefined') {
            slideToIndex = nextIndex;
          } else if (typeof nextIndex === 'undefined') {
            slideToIndex = prevIndex;
          } else if (nextIndex - currentIndex < currentIndex - prevIndex) {
            slideToIndex = nextIndex;
          } else {
            slideToIndex = prevIndex;
          }
        }

        swiper.slideTo(slideToIndex);
      },
      update: function update(initial) {
        var swiper = this;
        var thumbsSwiper = swiper.thumbs.swiper;

        if (!thumbsSwiper) {
          return;
        }

        var slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;

        if (swiper.realIndex !== thumbsSwiper.realIndex) {
          var currentThumbsIndex = thumbsSwiper.activeIndex;
          var newThumbsIndex;

          if (thumbsSwiper.params.loop) {
            if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
              thumbsSwiper.loopFix(); // eslint-disable-next-line

              thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
              currentThumbsIndex = thumbsSwiper.activeIndex;
            } // Find actual thumbs index to slide to


            var prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();
            var nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll("[data-swiper-slide-index=\"" + swiper.realIndex + "\"]").eq(0).index();

            if (typeof prevThumbsIndex === 'undefined') {
              newThumbsIndex = nextThumbsIndex;
            } else if (typeof nextThumbsIndex === 'undefined') {
              newThumbsIndex = prevThumbsIndex;
            } else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) {
              newThumbsIndex = currentThumbsIndex;
            } else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) {
              newThumbsIndex = nextThumbsIndex;
            } else {
              newThumbsIndex = prevThumbsIndex;
            }
          } else {
            newThumbsIndex = swiper.realIndex;
          }

          if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
            if (thumbsSwiper.params.centeredSlides) {
              if (newThumbsIndex > currentThumbsIndex) {
                newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
              } else {
                newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
              }
            } else if (newThumbsIndex > currentThumbsIndex) {
              newThumbsIndex = newThumbsIndex - slidesPerView + 1;
            }

            thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
          }
        } // Activate thumbs


        var thumbsToActivate = 1;
        var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;

        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) {
          thumbsToActivate = swiper.params.slidesPerView;
        }

        thumbsSwiper.slides.removeClass(thumbActiveClass);

        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual) {
          for (var i = 0; i < thumbsToActivate; i += 1) {
            thumbsSwiper.$wrapperEl.children("[data-swiper-slide-index=\"" + (swiper.realIndex + i) + "\"]").addClass(thumbActiveClass);
          }
        } else {
          for (var i$1 = 0; i$1 < thumbsToActivate; i$1 += 1) {
            thumbsSwiper.slides.eq(swiper.realIndex + i$1).addClass(thumbActiveClass);
          }
        }
      }
    };
    var Thumbs$1 = {
      name: 'thumbs',
      params: {
        thumbs: {
          swiper: null,
          slideThumbActiveClass: 'swiper-slide-thumb-active',
          thumbsContainerClass: 'swiper-container-thumbs'
        }
      },
      create: function create() {
        var swiper = this;
        Utils.extend(swiper, {
          thumbs: {
            swiper: null,
            init: Thumbs.init.bind(swiper),
            update: Thumbs.update.bind(swiper),
            onThumbClick: Thumbs.onThumbClick.bind(swiper)
          }
        });
      },
      on: {
        beforeInit: function beforeInit() {
          var swiper = this;
          var ref = swiper.params;
          var thumbs = ref.thumbs;

          if (!thumbs || !thumbs.swiper) {
            return;
          }

          swiper.thumbs.init();
          swiper.thumbs.update(true);
        },
        slideChange: function slideChange() {
          var swiper = this;

          if (!swiper.thumbs.swiper) {
            return;
          }

          swiper.thumbs.update();
        },
        update: function update() {
          var swiper = this;

          if (!swiper.thumbs.swiper) {
            return;
          }

          swiper.thumbs.update();
        },
        resize: function resize() {
          var swiper = this;

          if (!swiper.thumbs.swiper) {
            return;
          }

          swiper.thumbs.update();
        },
        observerUpdate: function observerUpdate() {
          var swiper = this;

          if (!swiper.thumbs.swiper) {
            return;
          }

          swiper.thumbs.update();
        },
        setTransition: function setTransition(duration) {
          var swiper = this;
          var thumbsSwiper = swiper.thumbs.swiper;

          if (!thumbsSwiper) {
            return;
          }

          thumbsSwiper.setTransition(duration);
        },
        beforeDestroy: function beforeDestroy() {
          var swiper = this;
          var thumbsSwiper = swiper.thumbs.swiper;

          if (!thumbsSwiper) {
            return;
          }

          if (swiper.thumbs.swiperCreated && thumbsSwiper) {
            thumbsSwiper.destroy();
          }
        }
      }
    }; // Swiper Class

    var components = [Device$1, Support$1, Browser$1, Resize, Observer$1, Virtual$1, Keyboard$1, Mousewheel$1, Navigation$1, Pagination$1, Scrollbar$1, Parallax$1, Zoom$1, Lazy$1, Controller$1, A11y, History$1, HashNavigation$1, Autoplay$1, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Thumbs$1];

    if (typeof Swiper.use === 'undefined') {
      Swiper.use = Swiper.Class.use;
      Swiper.installModule = Swiper.Class.installModule;
    }

    Swiper.use(components);
    return Swiper;
  });
});

var styles$p = {"collection-list-horizontal":"fr-ec-collection-list-horizontal","collectionListHorizontal":"fr-ec-collection-list-horizontal","collection-list-horizontal__item":"fr-ec-collection-list-horizontal__item","collectionListHorizontalItem":"fr-ec-collection-list-horizontal__item","collection-list-horizontal--divider":"fr-ec-collection-list-horizontal--divider","collectionListHorizontalDivider":"fr-ec-collection-list-horizontal--divider","collection-list-horizontal--divider-normal":"fr-ec-collection-list-horizontal--divider-normal","collectionListHorizontalDividerNormal":"fr-ec-collection-list-horizontal--divider-normal","collection-list-horizontal--divider-mid":"fr-ec-collection-list-horizontal--divider-mid","collectionListHorizontalDividerMid":"fr-ec-collection-list-horizontal--divider-mid","collection-list-horizontal--divider-large":"fr-ec-collection-list-horizontal--divider-large","collectionListHorizontalDividerLarge":"fr-ec-collection-list-horizontal--divider-large","collection-list-horizontal--divider-x-large":"fr-ec-collection-list-horizontal--divider-x-large","collectionListHorizontalDividerXLarge":"fr-ec-collection-list-horizontal--divider-x-large","collection-list-horizontal--normal":"fr-ec-collection-list-horizontal--normal","collectionListHorizontalNormal":"fr-ec-collection-list-horizontal--normal","collection-list-horizontal--mid":"fr-ec-collection-list-horizontal--mid","collectionListHorizontalMid":"fr-ec-collection-list-horizontal--mid","collection-list-horizontal--large":"fr-ec-collection-list-horizontal--large","collectionListHorizontalLarge":"fr-ec-collection-list-horizontal--large","collection-list-horizontal--x-large":"fr-ec-collection-list-horizontal--x-large","collectionListHorizontalXLarge":"fr-ec-collection-list-horizontal--x-large"};

var CollectionListHorizontal = function CollectionListHorizontal(_a) {
  var alignment = _a.alignment,
      children = _a.children,
      _b = _a.divider,
      divider = _b === void 0 ? false : _b,
      _c = _a.spacingValue,
      spacingValue = _c === void 0 ? '8' : _c,
      className = _a.className,
      props = __rest(_a, ["alignment", "children", "divider", "spacingValue", "className"]);

  var _d = useState(''),
      breakpoint = _d[0],
      setBreakPoint = _d[1];

  var handleResize = debounce(100, function (_) {
    setBreakPoint(getCurrentMediaQueryBreakpoint());
  });
  useEffect(function () {
    setBreakPoint(getCurrentMediaQueryBreakpoint());

    if (isInBrowser$1()) {
      window.addEventListener('resize', handleResize);
    }
  }, []); // @ts-ignore

  var getClassName = function getClassName(spacing) {
    var spacingVal = typeof spacing !== 'string' ? spacing[breakpoint] : spacing;

    switch (spacingVal) {
      case '8':
        return 'normal';

      case '12':
        return 'mid';

      case '16':
        return 'large';

      case '24':
        return 'x-large';
    }
  };

  return /*#__PURE__*/createElement(ContentAlignment, __assign({
    element: "ul",
    direction: "row",
    alignment: alignment,
    className: joinClasses(styles$p.collectionListHorizontal, divider && styles$p.collectionListHorizontalDivider, divider && styles$p.collectionListHorizontalDivider + "-" + getClassName(spacingValue), !divider && styles$p.collectionListHorizontal + "--" + getClassName(spacingValue), className)
  }, props), Children.toArray(children).filter(isValidElement).map(function (child, i) {
    return /*#__PURE__*/createElement("li", {
      className: styles$p.collectionListHorizontalItem,
      key: child.key || i
    }, child);
  }));
};
CollectionListHorizontal.displayName = 'CoreCollectionListHorizontal';
CollectionListHorizontal.defaultProps = {
  alignment: 'stretch',
  divider: false,
  spacingValue: '8'
};

var keylineStyles = {"keyline-bottom":"fr-ec-keyline-bottom","keylineBottom":"fr-ec-keyline-bottom"};

var styles$q = {"flyout-select":"fr-ec-flyout-select","flyoutSelect":"fr-ec-flyout-select","flyout-select__list":"fr-ec-flyout-select__list","flyoutSelectList":"fr-ec-flyout-select__list","flyout-select__list-item":"fr-ec-flyout-select__list-item","flyoutSelectListItem":"fr-ec-flyout-select__list-item","flyout-select__list-item--hover":"fr-ec-flyout-select__list-item--hover","flyoutSelectListItemHover":"fr-ec-flyout-select__list-item--hover","flyout-select__list-item--active":"fr-ec-flyout-select__list-item--active","flyoutSelectListItemActive":"fr-ec-flyout-select__list-item--active","flyout-select__list-item-selected-icon":"fr-ec-flyout-select__list-item-selected-icon","flyoutSelectListItemSelectedIcon":"fr-ec-flyout-select__list-item-selected-icon"};

var KEYCODE;

(function (KEYCODE) {
  KEYCODE[KEYCODE["DOWN"] = 40] = "DOWN";
  KEYCODE[KEYCODE["ENTER"] = 13] = "ENTER";
  KEYCODE[KEYCODE["ESC"] = 27] = "ESC";
  KEYCODE[KEYCODE["TAB"] = 9] = "TAB";
  KEYCODE[KEYCODE["UP"] = 38] = "UP";
})(KEYCODE || (KEYCODE = {}));

var FlyoutSelect = function FlyoutSelect(_a) {
  var className = _a.className,
      onHideVisibility = _a.onHideVisibility,
      visible = _a.visible,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["className", "onHideVisibility", "visible", "iconBrand"]);

  var getSelectedValue = function getSelectedValue() {
    var _a = props.value,
        value = _a === void 0 ? '' : _a,
        _b = props.options,
        options = _b === void 0 ? [] : _b;

    if (value) {
      var selectedOption = options.find(function (item) {
        return item.value === value;
      });
      return selectedOption || {
        label: '',
        value: ''
      };
    }

    return {
      label: '',
      value: ''
    };
  };

  var _b = useState(getSelectedValue()),
      selected = _b[0],
      setSelected = _b[1];

  var _c = useState(getSelectedValue()),
      hoverItem = _c[0],
      setHoverItem = _c[1];

  var onEscClick = function onEscClick(event) {
    if (event.keyCode === 27) {
      if (onHideVisibility) {
        onHideVisibility();
      }
    }
  };

  useEffect(function () {
    document.addEventListener('keydown', onEscClick, false);
    return function () {
      document.removeEventListener('keydown', onEscClick, false);
    };
  }, []);
  useEffect(function () {
    setHoverItem(getSelectedValue());
    setSelected(getSelectedValue());
  }, [props.value]);
  useEffect(function () {
    setHoverItem(getSelectedValue());
    setSelected(getSelectedValue());
  }, [props.options]);

  var handleFlyoutChange = function handleFlyoutChange(option) {
    return function (event) {
      event.preventDefault();
      setSelected(option);
      setHoverItem(option);
      onHideVisibility();

      if (props.onSelect) {
        props.onSelect(event, option.value);
      }
    };
  };

  var handleKeyPress = function handleKeyPress(event) {
    var _a, _b;

    var options = props.options;
    event.stopPropagation();
    var renderOptions = options;
    var hoverIndex = renderOptions.findIndex(function (option) {
      return option.value === hoverItem.value;
    });

    if (event.keyCode === KEYCODE.TAB) {
      event.preventDefault();
    }

    if (event.keyCode === KEYCODE.ESC) {
      setHoverItem(selected);
      onHideVisibility();
    }

    if (event.keyCode === KEYCODE.ENTER) {
      setSelected(hoverItem);
      onHideVisibility();

      if (props.onSelect) {
        props.onSelect(event, hoverItem.value);
      }
    }

    if (event.keyCode === KEYCODE.DOWN) {
      if (hoverIndex + 1 < renderOptions.length) {
        setHoverItem(renderOptions[hoverIndex + 1]);
        (_a = document.querySelector("#option-" + (hoverIndex + 1))) === null || _a === void 0 ? void 0 : _a.focus();
      }
    }

    if (event.keyCode === KEYCODE.UP && hoverIndex - 1 >= 0) {
      setHoverItem(renderOptions[hoverIndex - 1]);
      (_b = document.querySelector("#option-" + (hoverIndex - 1))) === null || _b === void 0 ? void 0 : _b.focus();
    }

    return true;
  };

  return /*#__PURE__*/createElement(Fragment, null, visible ? /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$q.flyoutSelect, className)
  }, /*#__PURE__*/createElement("ul", {
    role: "listbox",
    className: joinClasses(styles$q.flyoutSelectList)
  }, props.options.map(function (item, index) {
    return /*#__PURE__*/createElement("li", {
      className: joinClasses(styles$q.flyoutSelectListItem, selected.label === item.label && selected.value === item.value && styles$q.flyoutSelectListItemActive, hoverItem.label === item.label && hoverItem.value === item.value && styles$q.flyoutSelectListItemHover),
      onMouseDown: handleFlyoutChange(item),
      onClick: handleFlyoutChange(item),
      role: "option",
      "aria-selected": selected.label === item.label,
      key: item.value,
      value: item.value,
      tabIndex: 0,
      id: "option-" + index,
      onKeyDown: handleKeyPress
    }, /*#__PURE__*/createElement(Icon, {
      className: styles$q.flyoutSelectListItemSelectedIcon,
      name: iconBrand ? iconBrand + "check-large" : 'check-large',
      size: "24",
      variant: "default"
    }), /*#__PURE__*/createElement(Body, {
      element: "span",
      variant: selected.label === item.label && selected.value === item.value ? 'standard-emphasized' : 'standard'
    }, item.label));
  }))) : null);
};
FlyoutSelect.displayName = 'CoreFlyoutSelect';

var styles$r = {"gutter-container":"fr-ec-gutter-container","gutterContainer":"fr-ec-gutter-container"};

var GutterContainer = function GutterContainer(_a) {
  var _b = _a.element,
      Element = _b === void 0 ? 'div' : _b,
      className = _a.className,
      props = __rest(_a, ["element", "className"]);

  return /*#__PURE__*/createElement(Element, __assign({
    className: joinClasses(styles$r.gutterContainer, className)
  }, props));
};
GutterContainer.displayName = 'CoreGutterContainer';

var styles$s = {"overlay-content":"fr-ec-overlay-content","overlayContent":"fr-ec-overlay-content"};

var OverlayContent = function OverlayContent(_a) {
  var className = _a.className,
      props = __rest(_a, ["className"]);

  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$s.overlayContent, className)
  }, props));
};
OverlayContent.displayName = 'CoreOverlayContent';

var styles$t = {"overlay-body":"fr-ec-overlay-body","overlayBody":"fr-ec-overlay-body","overlay-body__footer":"fr-ec-overlay-body__footer","overlayBodyFooter":"fr-ec-overlay-body__footer","overlay-body__hide-footer":"fr-ec-overlay-body__hide-footer","overlayBodyHideFooter":"fr-ec-overlay-body__hide-footer","overlay-body__display-footer":"fr-ec-overlay-body__display-footer","overlayBodyDisplayFooter":"fr-ec-overlay-body__display-footer"};

var OverlayBody = /*#__PURE__*/forwardRef(function (_a, ref) {
  var className = _a.className,
      children = _a.children,
      footer = _a.footer,
      onHeightChange = _a.onHeightChange,
      _b = _a.isModal,
      isModal = _b === void 0 ? false : _b,
      props = __rest(_a, ["className", "children", "footer", "onHeightChange", "isModal"]);

  var isKeyboardOpenState;
  var isAndroidMobile;
  var footerRef = useRef(null);

  if (isInBrowser$1()) {
    isKeyboardOpenState = isKeyboardOpen();
    isAndroidMobile = getOS() === 'android' && getCurrentMediaQueryBreakpoint() === 'sm';
  }

  useEffect(function () {
    if (onHeightChange && footerRef.current) {
      if (footerRef.current) {
        onHeightChange(footerRef.current.clientHeight);
      }
    }
  }, []);
  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$t.overlayBody, className)
  }, props, {
    ref: ref
  }), /*#__PURE__*/createElement(OverlayContent, null, children), footer && /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$t.overlayBodyFooter, isAndroidMobile && isModal ? isKeyboardOpenState !== true || isKeyboardOpenState === undefined ? styles$t.overlayBodyDisplayFooter : styles$t.overlayBodyHideFooter : ''),
    ref: footerRef
  }, footer));
});
OverlayBody.displayName = 'CoreOverlayBody';

var styles$u = {"overlay-wrapper":"fr-ec-overlay-wrapper","overlayWrapper":"fr-ec-overlay-wrapper"};

var OverlayWrapper = /*#__PURE__*/forwardRef(function (_a, ref) {
  var className = _a.className,
      props = __rest(_a, ["className"]);

  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$u.overlayWrapper, className)
  }, props, {
    ref: ref
  }));
});
OverlayWrapper.displayName = 'CoreOverlayWrapper';

var styles$v = {"sticky-container":"fr-ec-sticky-container","stickyContainer":"fr-ec-sticky-container","sticky-empty-div--with-block":"fr-ec-sticky-empty-div--with-block","stickyEmptyDivWithBlock":"fr-ec-sticky-empty-div--with-block","sticky-extra-wrapper":"fr-ec-sticky-extra-wrapper","stickyExtraWrapper":"fr-ec-sticky-extra-wrapper","sticky-container--without-nav-header":"fr-ec-sticky-container--without-nav-header","stickyContainerWithoutNavHeader":"fr-ec-sticky-container--without-nav-header","sticky-container--with-sticky-tab-without-nav-header":"fr-ec-sticky-container--with-sticky-tab-without-nav-header","stickyContainerWithStickyTabWithoutNavHeader":"fr-ec-sticky-container--with-sticky-tab-without-nav-header","sticky-container--with-sticky-tab":"fr-ec-sticky-container--with-sticky-tab","stickyContainerWithStickyTab":"fr-ec-sticky-container--with-sticky-tab","sticky-container--with-sticky-utility-bar":"fr-ec-sticky-container--with-sticky-utility-bar","stickyContainerWithStickyUtilityBar":"fr-ec-sticky-container--with-sticky-utility-bar","utility-bar--overlay":"fr-ec-utility-bar--overlay","utilityBarOverlay":"fr-ec-utility-bar--overlay"};

var ThemeContext = /*#__PURE__*/createContext({
  isNavHeader: true,
  scrollValue: 0
});
var StickyContainer = function StickyContainer(_a) {
  var children = _a.children,
      className = _a.className,
      _b = _a.stickySection,
      stickySection = _b === void 0 ? 'utilityBar' : _b,
      _c = _a.isNavHeader,
      isNavHeader = _c === void 0 ? true : _c,
      onSticky = _a.onSticky,
      stickOnLargeDevice = _a.stickOnLargeDevice,
      _d = _a.stickyHidingOffset,
      stickyHidingOffset = _d === void 0 ? 0 : _d,
      props = __rest(_a, ["children", "className", "stickySection", "isNavHeader", "onSticky", "stickOnLargeDevice", "stickyHidingOffset"]);

  var _e = useState(0),
      scrollValue = _e[0],
      setScrollValue = _e[1];

  var stickyRef = useRef(null);
  var stickyExtraRef = useRef(null);

  var handleScroll = function handleScroll() {
    var _a, _b;

    var screenSize = getCurrentMediaQueryBreakpoint();
    var shouldActiveScrollHandler = screenSize === 'lg' ? stickOnLargeDevice : true; // setHeight is used to add a dummy height to avoid jumping of the content while making Tab or UtilityBar fixed at top.

    var scrollPageYOffset = window.pageYOffset;

    if (stickyRef.current) {
      var hasNotReachedBottom = stickyHidingOffset ? scrollPageYOffset < stickyHidingOffset + scrollValue : true;

      if (scrollPageYOffset >= scrollValue && scrollValue && scrollPageYOffset !== 0 && hasNotReachedBottom && shouldActiveScrollHandler) {
        if (stickyExtraRef.current) {
          stickyExtraRef.current.style.height = ((_a = stickyRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) + "px";
        }

        stickySection === 'utilityBar' ? isNavHeader ? stickyRef.current.classList.add('fr-ec-sticky-container--with-sticky-tab') : stickyRef.current.classList.add('fr-ec-sticky-container--with-sticky-tab', 'fr-ec-sticky-container--without-nav-header') : isNavHeader ? stickyRef.current.classList.add('fr-ec-sticky-container--with-sticky-utility-bar') : stickyRef.current.classList.add('fr-ec-sticky-container--with-sticky-utility-bar', 'fr-ec-sticky-container--with-sticky-tab-without-nav-header');

        if (stickyRef.current && stickyExtraRef.current && stickOnLargeDevice) {
          stickyRef.current.style.width = ((_b = stickyExtraRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect().width) + "px" || "inherit";
        }
      } else {
        if (stickyExtraRef.current) {
          stickyExtraRef.current.style.height = "0px";
        }

        stickySection === 'utilityBar' ? stickyRef.current.classList.remove('fr-ec-sticky-container--with-sticky-tab', 'fr-ec-sticky-container--without-nav-header') : stickyRef.current.classList.remove('fr-ec-sticky-container--with-sticky-utility-bar', 'fr-ec-sticky-container--with-sticky-tab-without-nav-header');
      }
    }
  };

  var handleResize = function handleResize() {
    var _a;

    if (stickyRef.current && stickyExtraRef.current && stickOnLargeDevice) {
      stickyRef.current.style.width = ((_a = stickyExtraRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect().width) + "px" || "inherit";
    }

    handleScroll();
  };

  useEffect(function () {
    var _a, _b, _c, _d, _e, _f, _g;

    var screenSize = getCurrentMediaQueryBreakpoint();

    if (isInBrowser$1()) {
      window.addEventListener('scroll', handleScroll);
      window.addEventListener('resize', handleResize);
    }

    var scrollPageYOffset = window.pageYOffset;
    var stickyTopPosition; // stickyTopPosition is used to findout howmuch scroll need to make the stickyContainer to be fixed
    // stickyTopPosition 73 means margin top value for making the first content(TabGroup) to be sticky inside Tablet view.
    // The value 73 is the height of Navigation Header in Tablet view.
    // stickyTopPosition 139 means margin top value for making the second content(UtlityBar) to be sticky inside Tab view.
    // The value 139 is the sum of height of Navigation Header and the first sticky Content(TabGroup) height in Tablet view.
    // stickyTopPosition values 73 and 139 will be replaced by 65 and 131 respectively for mobile view.

    stickyTopPosition = isNavHeader ? stickySection === 'utilityBar' ? screenSize === 'md' || screenSize === 'lg' ? 73 : 65 : screenSize === 'md' ? 126 : 118 : stickySection === 'utilityBar' ? 0 : 53;

    if (stickyRef.current) {
      var hasNotReachedBottom = stickyHidingOffset ? scrollPageYOffset < stickyHidingOffset : true;

      if (scrollPageYOffset >= scrollValue && scrollPageYOffset !== 0 && scrollValue !== 0 && hasNotReachedBottom) {
        if (stickyRef.current.offsetTop && stickyRef.current.offsetTop <= scrollPageYOffset + stickyTopPosition) {
          if (onSticky) {
            onSticky(true);
          }

          handleResize();
          stickySection === 'utilityBar' ? isNavHeader ? stickyRef.current.classList.add('fr-ec-sticky-container--with-sticky-tab') : stickyRef.current.classList.add('fr-ec-sticky-container--with-sticky-tab', 'fr-ec-sticky-container--without-nav-header') : isNavHeader ? stickyRef.current.classList.add('fr-ec-sticky-container--with-sticky-utility-bar') : stickyRef.current.classList.add('fr-ec-sticky-container--with-sticky-utility-bar', 'fr-ec-sticky-container--with-sticky-tab-without-nav-header');
        }
      } else {
        if (stickyRef.current.offsetTop && stickyRef.current.offsetTop > scrollPageYOffset + stickyTopPosition) {
          if (onSticky) {
            onSticky(false);
          }

          if (stickyExtraRef.current) {
            stickyExtraRef.current.style.height = "0px";
          }

          stickySection === 'utilityBar' ? stickyRef.current.classList.remove('fr-ec-sticky-container--with-sticky-tab', 'fr-ec-sticky-container--without-nav-header') : stickyRef.current.classList.remove('fr-ec-sticky-container--with-sticky-utility-bar', 'fr-ec-sticky-container--with-sticky-tab-without-nav-header');
        }
      } // To handle if the sticky container is opening in some other position other than relative position in the screen


      if (((_a = stickyRef.current) === null || _a === void 0 ? void 0 : _a.offsetTop) === stickyTopPosition && ((_c = (_b = stickyRef.current) === null || _b === void 0 ? void 0 : _b.parentElement) === null || _c === void 0 ? void 0 : _c.offsetTop)) {
        setScrollValue(((_e = (_d = stickyRef.current) === null || _d === void 0 ? void 0 : _d.parentElement) === null || _e === void 0 ? void 0 : _e.offsetTop) - stickyTopPosition);
      } else if (stickyRef.current.getBoundingClientRect().top) {
        setScrollValue(stickyRef.current.getBoundingClientRect().top - stickyTopPosition);
      } else if ((_f = stickyRef.current) === null || _f === void 0 ? void 0 : _f.offsetTop) {
        setScrollValue(((_g = stickyRef.current) === null || _g === void 0 ? void 0 : _g.offsetTop) - stickyTopPosition);
      }
    }

    return function () {
      if (isInBrowser$1()) {
        window.removeEventListener('scroll', handleScroll);
        window.removeEventListener('resize', handleResize);
      }
    };
  }, [scrollValue, isNavHeader, stickyRef, stickyExtraRef]);
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$v.stickyContainer, className),
    ref: stickyRef
  }, /*#__PURE__*/createElement(ThemeContext.Provider, {
    value: {
      isNavHeader: isNavHeader,
      scrollValue: scrollValue
    }
  }, children)), /*#__PURE__*/createElement("div", {
    className: styles$v.stickyExtraWrapper,
    ref: stickyExtraRef
  }));
};
StickyContainer.displayName = 'CoreStickyContainer';

var styles$w = {"filter-bar":"fr-ec-filter-bar","filterBar":"fr-ec-filter-bar","filter-bar--pills":"fr-ec-filter-bar--pills","filterBarPills":"fr-ec-filter-bar--pills","filter-pill":"fr-ec-filter-pill","filterPill":"fr-ec-filter-pill","filter-bar--swipeable__overlay-right":"fr-ec-filter-bar--swipeable__overlay-right","filterBarSwipeableOverlayRight":"fr-ec-filter-bar--swipeable__overlay-right","filter-bar--swipeable__overlay-left":"fr-ec-filter-bar--swipeable__overlay-left","filterBarSwipeableOverlayLeft":"fr-ec-filter-bar--swipeable__overlay-left","filter-bar--swipeable__navigation-btn-left":"fr-ec-filter-bar--swipeable__navigation-btn-left","filterBarSwipeableNavigationBtnLeft":"fr-ec-filter-bar--swipeable__navigation-btn-left","filter-bar--swiper-button-disabled":"fr-ec-filter-bar--swiper-button-disabled","filterBarSwiperButtonDisabled":"fr-ec-filter-bar--swiper-button-disabled","filter-bar--swipeable__navigation-btn":"fr-ec-filter-bar--swipeable__navigation-btn","filterBarSwipeableNavigationBtn":"fr-ec-filter-bar--swipeable__navigation-btn","filter-bar--swipeable__navigation-btn-right":"fr-ec-filter-bar--swipeable__navigation-btn-right","filterBarSwipeableNavigationBtnRight":"fr-ec-filter-bar--swipeable__navigation-btn-right"};

var FilterBar =
/** @class */
function (_super) {
  __extends(FilterBar, _super);

  function FilterBar(props) {
    var _this = _super.call(this, props) || this;

    _this.componentWillUnmount = function () {
      if (isInBrowser$1()) {
        window.removeEventListener('resize', _this.onTouchMove);
      }
    };

    _this.onTouchMove = function () {
      if (_this.swiperInstance && _this.swiperInstance.update) {
        _this.swiperInstance.update();

        _this.setState({
          isBeginning: _this.swiperInstance.isBeginning,
          isEnd: _this.swiperInstance.isEnd
        });
      }
    };

    _this.controlNavigation = function (direction) {
      if (_this.swiperInstance) {
        var slides = _this.swiperInstance.slides || 0;
        var _a = _this.swiperInstance,
            activeIndex = _a.activeIndex,
            isBeginning = _a.isBeginning,
            isEnd = _a.isEnd;
        var nextSlide = direction === 'NEXT' ? isEnd ? slides.length : activeIndex + 1 : isBeginning ? 0 : activeIndex - 1;

        if (direction === 'NEXT') {
          _this.swiperInstance.slideTo(nextSlide);
        } else {
          _this.swiperInstance.slideTo(nextSlide);
        }

        _this.swiperInstance.update();

        _this.setState({
          isBeginning: _this.swiperInstance.isBeginning,
          isEnd: _this.swiperInstance.isEnd
        });
      }
    };

    _this.onClick = function (pillOnclick) {
      return function (event) {
        var ActivePillIndex = event.currentTarget.getAttribute('id');

        if (_this.swiperInstance) {
          _this.swiperInstance.slideTo(Number(ActivePillIndex));

          _this.swiperInstance.update();
        }

        if (pillOnclick) {
          pillOnclick(event);
        }

        _this.onTouchMove();
      };
    };

    _this.state = {
      isBeginning: true,
      isEnd: false
    };
    _this.swiperRef = /*#__PURE__*/createRef();
    _this.swiperInstance = null;
    return _this;
  }

  FilterBar.prototype.componentDidMount = function () {
    var _this = this;

    this.swiperInstance = new swiper(this.swiperRef.current, {
      freeMode: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      observeParents: true,
      observer: true,
      on: {
        sliderMove: function sliderMove() {
          return _this.onTouchMove();
        }
      },
      slidesPerView: 'auto',
      spaceBetween: 0
    });
    this.setState({
      isBeginning: this.swiperInstance.isBeginning,
      isEnd: this.swiperInstance.isEnd
    });

    if (isInBrowser$1()) {
      window.addEventListener('resize', this.onTouchMove);
    }
  };

  FilterBar.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        _b = _a.isOverlay,
        isOverlay = _b === void 0 ? false : _b,
        iconBrand = _a.iconBrand;
    var breakpoint = getCurrentMediaQueryBreakpoint();
    return /*#__PURE__*/createElement("div", {
      className: joinClasses('swiper-container', styles$w.filterBar),
      ref: this.swiperRef
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses('swiper-wrapper', styles$w.filterBarPills)
    }, Children.map(children, function (child, i) {
      return /*#__PURE__*/createElement("div", {
        key: i,
        className: joinClasses('swiper-slide')
      }, /*#__PURE__*/cloneElement(child, {
        id: String(i),
        onClick: _this.onClick(child.props.onClick)
      }));
    })), breakpoint === 'lg' ? /*#__PURE__*/createElement(Fragment, null, !this.state.isEnd && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
      className: styles$w.filterBarSwipeableOverlayRight
    }), /*#__PURE__*/createElement(ButtonIcon, {
      element: "button",
      icon: "chevron-right",
      iconBrand: iconBrand,
      label: "",
      className: joinClasses('swiper-button-next', styles$w.filterBarSwipeableNavigationBtn, styles$w.filterBarSwipeableNavigationBtnRight),
      onClick: function onClick() {
        return _this.controlNavigation('NEXT');
      }
    })), !this.state.isBeginning && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
      className: styles$w.filterBarSwipeableOverlayLeft
    }), /*#__PURE__*/createElement(ButtonIcon, {
      element: "button",
      icon: "chevron-left",
      iconBrand: iconBrand,
      label: "",
      className: joinClasses('swiper-button-prev', styles$w.filterBarSwipeableNavigationBtn, styles$w.filterBarSwipeableNavigationBtnLeft),
      onClick: function onClick() {
        return _this.controlNavigation('PREV');
      }
    }))) : isOverlay ? /*#__PURE__*/createElement(Fragment, null, !this.state.isEnd && /*#__PURE__*/createElement("div", {
      className: styles$w.filterBarSwipeableOverlayRight
    }), !this.state.isBeginning && /*#__PURE__*/createElement("div", {
      className: styles$w.filterBarSwipeableOverlayLeft
    })) : null);
  };

  return FilterBar;
}(Component);

var styles$x = {"filter-pill":"fr-ec-filter-pill","filterPill":"fr-ec-filter-pill","filter-pill--icon":"fr-ec-filter-pill--icon","filterPillIcon":"fr-ec-filter-pill--icon","filter-pill--selected":"fr-ec-filter-pill--selected","filterPillSelected":"fr-ec-filter-pill--selected","body":"fr-ec-body","filter-pill--modal":"fr-ec-filter-pill--modal","filterPillModal":"fr-ec-filter-pill--modal","filter-pill-ellipsis":"fr-ec-filter-pill-ellipsis","filterPillEllipsis":"fr-ec-filter-pill-ellipsis"};

var FilterPill = function FilterPill(_a) {
  var label = _a.label,
      isSelected = _a.isSelected,
      isOpen = _a.isOpen,
      onClick = _a.onClick,
      className = _a.className,
      gender = _a.gender,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["label", "isSelected", "isOpen", "onClick", "className", "gender", "iconBrand"]);

  var _b = useState(isOpen || false),
      isToggledOpen = _b[0],
      setIsToggled = _b[1];

  var handleClick = function handleClick(e) {
    setIsToggled(!isToggledOpen);

    if (onClick) {
      onClick(e);
    }
  };

  useEffect(function () {
    setIsToggled(isOpen || false);
  }, [isOpen]);
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", __assign({
    role: "cell",
    onClick: handleClick,
    className: joinClasses(styles$x.filterPill, isSelected && styles$x.filterPillSelected, className)
  }, props), /*#__PURE__*/createElement(Body, {
    variant: isOpen ? 'small-emphasized' : 'small',
    element: "h4",
    title: typeof label === 'string' ? gender ? gender + " > " + label : label : label
  }, gender ? gender + " > " + label : label), /*#__PURE__*/createElement(Icon, {
    name: isOpen ? iconBrand ? iconBrand + "chevron-up" : 'chevron-up' : iconBrand ? iconBrand + "chevron-down" : 'chevron-down',
    className: styles$x.filterPillIcon
  })));
};
FilterPill.displayName = 'CoreFilterPill';

var styles$y = {"utility-bar":"fr-ec-utility-bar","utilityBar":"fr-ec-utility-bar","utility-bar-wrapper":"fr-ec-utility-bar-wrapper","utilityBarWrapper":"fr-ec-utility-bar-wrapper","utility-bar--keyline-top":"fr-ec-utility-bar--keyline-top","utilityBarKeylineTop":"fr-ec-utility-bar--keyline-top","utility-bar__filter-badge-count":"fr-ec-utility-bar__filter-badge-count","utilityBarFilterBadgeCount":"fr-ec-utility-bar__filter-badge-count","utility-bar__flyout-select-card":"fr-ec-utility-bar__flyout-select-card","utilityBarFlyoutSelectCard":"fr-ec-utility-bar__flyout-select-card","utility-bar__flyout-select-card-show":"fr-ec-utility-bar__flyout-select-card-show","utilityBarFlyoutSelectCardShow":"fr-ec-utility-bar__flyout-select-card-show","utility-bar__flyout-select":"fr-ec-utility-bar__flyout-select","utilityBarFlyoutSelect":"fr-ec-utility-bar__flyout-select","flyout-select__list":"fr-ec-flyout-select__list","flyoutSelectList":"fr-ec-flyout-select__list","utility-bar__collection-list-horizontal":"fr-ec-utility-bar__collection-list-horizontal","utilityBarCollectionListHorizontal":"fr-ec-utility-bar__collection-list-horizontal","collection-list-horizontal__item":"fr-ec-collection-list-horizontal__item","collectionListHorizontalItem":"fr-ec-collection-list-horizontal__item","button-toggle":"fr-ec-button-toggle","buttonToggle":"fr-ec-button-toggle","label":"fr-ec-label","utility-bar--filter-bar--label":"fr-ec-utility-bar--filter-bar--label","utilityBarFilterBarLabel":"fr-ec-utility-bar--filter-bar--label","utility-bar--filter-bar":"fr-ec-utility-bar--filter-bar","utilityBarFilterBar":"fr-ec-utility-bar--filter-bar","sticky-container--with-sticky-tab":"fr-ec-sticky-container--with-sticky-tab","stickyContainerWithStickyTab":"fr-ec-sticky-container--with-sticky-tab","utility-bar--keyline":"fr-ec-utility-bar--keyline","utilityBarKeyline":"fr-ec-utility-bar--keyline","utility-bar--filter-panel":"fr-ec-utility-bar--filter-panel","utilityBarFilterPanel":"fr-ec-utility-bar--filter-panel","utility-bar--modal":"fr-ec-utility-bar--modal","utilityBarModal":"fr-ec-utility-bar--modal","utility-bar__modal__close-icon":"fr-ec-utility-bar__modal__close-icon","utilityBarModalCloseIcon":"fr-ec-utility-bar__modal__close-icon","utility-bar--body":"fr-ec-utility-bar--body","utilityBarBody":"fr-ec-utility-bar--body","dropdown__list":"fr-ec-dropdown__list","dropdownList":"fr-ec-dropdown__list","modal-open":"fr-ec-modal-open","modalOpen":"fr-ec-modal-open","utility-bar--filter-panel--modal-open":"fr-ec-utility-bar--filter-panel--modal-open","utilityBarFilterPanelModalOpen":"fr-ec-utility-bar--filter-panel--modal-open","utility-bar--modal-backdrop":"fr-ec-utility-bar--modal-backdrop","utilityBarModalBackdrop":"fr-ec-utility-bar--modal-backdrop","utility-bar--overlay":"fr-ec-utility-bar--overlay","utilityBarOverlay":"fr-ec-utility-bar--overlay","utility-bar--extra-wrapper":"fr-ec-utility-bar--extra-wrapper","utilityBarExtraWrapper":"fr-ec-utility-bar--extra-wrapper","utility-bar--overlay--visibility-hide":"fr-ec-utility-bar--overlay--visibility-hide","utilityBarOverlayVisibilityHide":"fr-ec-utility-bar--overlay--visibility-hide","overlay-content":"fr-ec-overlay-content","overlayContent":"fr-ec-overlay-content","utility-bar--filter-bar--modal":"fr-ec-utility-bar--filter-bar--modal","utilityBarFilterBarModal":"fr-ec-utility-bar--filter-bar--modal","radio-group":"fr-ec-radio-group","radioGroup":"fr-ec-radio-group","dropdown__container":"fr-ec-dropdown__container","dropdownContainer":"fr-ec-dropdown__container","hint-text":"fr-ec-hint-text","hintText":"fr-ec-hint-text","filter-bar":"fr-ec-filter-bar","filterBar":"fr-ec-filter-bar"};

var DropDownContext = /*#__PURE__*/createContext(false);
var filterPillLabelVal = [];
var UtilityBar = function UtilityBar(_a) {
  var className = _a.className,
      resultDetailsSection = _a.resultDetailsSection,
      collapseFilterLabel = _a.collapseFilterLabel,
      sortLabel = _a.sortLabel,
      _b = _a.toggleFilter,
      toggleFilter = _b === void 0 ? false : _b,
      onToggleFilter = _a.onToggleFilter,
      handleChangeSort = _a.handleChangeSort,
      currentSortValue = _a.currentSortValue,
      sortOptions = _a.sortOptions,
      filterBadgeCount = _a.filterBadgeCount,
      _c = _a.toggleSort,
      sortEnable = _c === void 0 ? true : _c,
      _d = _a.keyline,
      keyline = _d === void 0 ? 'none' : _d,
      badgeCount = _a.badgeCount,
      filterPillContent = _a.filterPillContent,
      closeLabel = _a.closeLabel,
      storeIcon = _a.storeIcon,
      storeBarPlaceholder = _a.storeBarPlaceholder,
      storeSearchLabel = _a.storeSearchLabel,
      storeName = _a.storeName,
      _e = _a.withFilterCount,
      withFilterCount = _e === void 0 ? true : _e,
      _f = _a.isNavHeader,
      isNavHeader = _f === void 0 ? true : _f,
      _g = _a.stickOnLargeDevice,
      stickOnLargeDevice = _g === void 0 ? false : _g,
      onClickStoreSearch = _a.onClickStoreSearch,
      _h = _a.stickOnSmallDevice,
      stickOnSmallDevice = _h === void 0 ? true : _h,
      _j = _a.stickOnClick,
      stickOnClick = _j === void 0 ? true : _j,
      iconBrand = _a.iconBrand;
  var containerRef = useRef(null);
  var extraContainerRef = useRef(null);
  var modalRef = useRef(null);
  var filterBarRef = useRef(null);

  var _k = useState(false),
      toggleSort = _k[0],
      setToggleSort = _k[1];

  var _l = useState(currentSortValue || '1'),
      flyoutSelectValue = _l[0],
      setFlyoutSelectValue = _l[1];

  var _m = useState(-1),
      activeIndex = _m[0],
      setActiveIndex = _m[1];

  var _o = useState(false),
      isOpen = _o[0],
      setOpenState = _o[1];

  var value = useContext(ThemeContext);
  var screenSize = getCurrentMediaQueryBreakpoint();
  var stickyTopPosition = isNavHeader ? screenSize === 'md' || screenSize === 'lg' ? 73 : 65 : 0;
  var isSticky = screenSize === 'md' || screenSize === 'lg' ? stickOnLargeDevice : stickOnSmallDevice;

  var onToggleSort = function onToggleSort(event) {
    event.stopPropagation();
    setToggleSort(!toggleSort);
  };

  var onHideSort = function onHideSort() {
    return setToggleSort(false);
  };

  var sortFlyoutRef = useRef(null);

  var handleResize = function handleResize() {
    if (modalRef.current) {
      modalRef.current.style.maxHeight = "calc(100vh - (" + modalRef.current.getBoundingClientRect().top + "px + 1px))";
    }
  };

  var initializeLabelVal = function initializeLabelVal(content) {
    if (content) {
      content.map(function (_a) {
        var label = _a.label;

        if (label) {
          filterPillLabelVal.push(label);
        }
      });
    }
  };

  var scrollUtiltiybarToTop = function scrollUtiltiybarToTop() {
    if (containerRef && containerRef.current && stickOnClick) {
      var scrollVal = containerRef.current.offsetTop + containerRef.current.offsetHeight - (stickyTopPosition + 52);

      if (scrollVal < 0) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      } else {
        window.scrollTo({
          top: scrollVal,
          behavior: 'smooth'
        });
      }
    }
  };

  useEffect(function () {
    if (isInBrowser$1()) {
      window.addEventListener('resize', handleResize);
      window.addEventListener('scroll', handleResize);
    }

    var handleClickOutside = function handleClickOutside(event) {
      if (sortFlyoutRef.current && !sortFlyoutRef.current.contains(event.target)) {
        setToggleSort(false);
      }

      if (event.target !== modalRef.current && modalRef.current && !modalRef.current.contains(event.target) && filterBarRef.current && !filterBarRef.current.contains(event.target)) {
        setOpenState(false);
      }
    };

    document.addEventListener('click', handleClickOutside, true);
    handleResize();

    if (!filterPillLabelVal.length) {
      initializeLabelVal(filterPillContent);
    }

    if (filterPillContent && filterPillContent[activeIndex]) {
      if (filterPillLabelVal[activeIndex] && filterPillLabelVal[activeIndex] !== filterPillContent[activeIndex].label) {
        scrollUtiltiybarToTop();
        filterPillLabelVal[activeIndex] = filterPillContent[activeIndex].label;
      }
    }

    return function () {
      document.removeEventListener('click', handleClickOutside, true);

      if (isInBrowser$1()) {
        window.removeEventListener('resize', handleResize);
        window.removeEventListener('scroll', handleResize);
      }
    };
  }, [sortFlyoutRef, isOpen, modalRef, filterBarRef, filterPillContent]);

  var setModalStatus = function setModalStatus(index) {
    scrollUtiltiybarToTop();

    if (index === activeIndex) {
      setOpenState(!isOpen);
    } else {
      setOpenState(true);
    }

    setActiveIndex(index);

    if (filterBarRef && filterBarRef.current && modalRef && modalRef.current) {
      modalRef.current.style.top = filterBarRef.current.getBoundingClientRect().bottom + "px";
    }
  };

  var toggleFilterContent = function toggleFilterContent() {
    setOpenState(false);

    if (onToggleFilter) {
      onToggleFilter();
    }
  };

  var handleChangeSortHandler = function handleChangeSortHandler(event, selectValue) {
    setFlyoutSelectValue(selectValue);

    if (handleChangeSort) {
      handleChangeSort(event, selectValue);
    }
  };

  var width = getViewportWidth();
  var toggleButtonFilter = width > designTokens_3.mqMediumScreenMaxWidthLimit ? toggleFilter || filterBadgeCount : false;
  var utilityBarContent = /*#__PURE__*/createElement(GutterContainer, {
    className: joinClasses(styles$y.utilityBarWrapper, keyline !== 'none' && keylineStyles.keylineBottom, keyline === 'bottom-top' && styles$y.utilityBarKeylineTop, className)
  }, /*#__PURE__*/createElement(ContentAlignment, {
    direction: "row",
    justifyContent: "space-between",
    alignment: "center",
    element: "section",
    className: styles$y.utilityBar
  }, filterPillContent ? withFilterCount && resultDetailsSection : resultDetailsSection, (sortEnable || collapseFilterLabel) && /*#__PURE__*/createElement(CollectionListHorizontal, {
    divider: false,
    spacingValue: "16",
    className: styles$y.utilityBarCollectionListHorizontal
  }, sortEnable && /*#__PURE__*/createElement("div", {
    ref: sortFlyoutRef
  }, /*#__PURE__*/createElement(ContentAlignment, {
    direction: "row",
    element: "div",
    alignment: "center"
  }, /*#__PURE__*/createElement(ButtonToggle, {
    icon: "sort",
    variant: 'iconWithLabel',
    text: sortLabel,
    onClick: onToggleSort,
    isToggled: toggleSort,
    alignment: "center",
    iconBrand: iconBrand
  }), sortOptions && /*#__PURE__*/createElement(Card, {
    element: "div",
    className: joinClasses(styles$y.utilityBarFlyoutSelectCard, toggleSort && styles$y.utilityBarFlyoutSelectCardShow)
  }, /*#__PURE__*/createElement(FlyoutSelect, {
    visible: true,
    onHideVisibility: onHideSort,
    value: currentSortValue || flyoutSelectValue,
    onSelect: handleChangeSortHandler,
    options: sortOptions,
    className: styles$y.utilityBarFlyoutSelect,
    iconBrand: iconBrand
  })))), collapseFilterLabel && !filterPillContent && /*#__PURE__*/createElement(ContentAlignment, {
    direction: "row",
    element: "div",
    alignment: "center"
  }, /*#__PURE__*/createElement(ButtonToggle, {
    icon: toggleButtonFilter ? 'filter-opened' : 'filter',
    variant: 'iconWithLabel',
    text: collapseFilterLabel,
    onClick: onToggleFilter,
    isToggled: toggleButtonFilter ? true : false,
    alignment: "center",
    iconBrand: iconBrand
  }), filterBadgeCount && /*#__PURE__*/createElement(Badge, {
    content: filterBadgeCount,
    className: styles$y.utilityBarFilterBadgeCount
  })))));

  var getFilterBarSection = function getFilterBarSection() {
    return filterPillContent && /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
      className: styles$y.utilityBarFilterBar,
      ref: filterBarRef
    }, collapseFilterLabel && /*#__PURE__*/createElement(CollectionListHorizontal, {
      alignment: "center",
      divider: false,
      spacingValue: "8",
      className: styles$y.utilityBarFilterBarLabel
    }, /*#__PURE__*/createElement(Body, {
      variant: "small-underlined",
      element: "h5",
      onClick: toggleFilterContent
    }, collapseFilterLabel), badgeCount && /*#__PURE__*/createElement(Badge, {
      content: badgeCount
    })), /*#__PURE__*/createElement(FilterBar, {
      iconBrand: iconBrand
    }, filterPillContent && filterPillContent.map(function (_a, i) {
      var props = __rest(_a, []);

      return /*#__PURE__*/createElement(FilterPill, __assign({
        key: i,
        iconBrand: iconBrand
      }, props, {
        isOpen: i === activeIndex ? isOpen : false,
        onClick: function onClick() {
          return setModalStatus(i);
        }
      }));
    }))), /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(OverlayWrapper, {
      role: "dialog",
      "aria-modal": true,
      tabIndex: -1,
      "aria-labelledby": 'titleId',
      className: joinClasses(styles$y.utilityBarOverlay, !isOpen && styles$y.utilityBarOverlayVisibilityHide)
    }, /*#__PURE__*/createElement("header", {
      className: styles$y.utilityBarModal
    }, resultDetailsSection, closeLabel && /*#__PURE__*/createElement(ButtonIcon, {
      element: "button",
      icon: "close-big",
      iconBrand: iconBrand,
      label: closeLabel,
      className: styles$y.utilityBarModalCloseIcon,
      variant: "dark",
      onClick: function onClick() {
        return setOpenState(false);
      }
    })), /*#__PURE__*/createElement(OverlayBody, {
      isModal: false,
      className: styles$y.utilityBarBody
    }, /*#__PURE__*/createElement("div", {
      ref: modalRef,
      className: styles$y.utilityBarFilterBarModal
    }, /*#__PURE__*/createElement(DropDownContext.Provider, {
      value: true
    }, filterPillContent[activeIndex] && filterPillContent[activeIndex].children))))), /*#__PURE__*/createElement("div", {
      className: styles$y.utilityBarKeyline
    }));
  };

  return filterPillContent ? /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$y.utilityBarFilterPanel, isOpen && styles$y.utilityBarFilterPanelModalOpen),
    ref: containerRef
  }, (sortEnable || collapseFilterLabel || withFilterCount && resultDetailsSection) && utilityBarContent, storeSearchLabel && /*#__PURE__*/createElement(StoreBar, {
    icon: storeIcon,
    iconBrand: iconBrand,
    placeholder: storeBarPlaceholder,
    searchLabel: storeSearchLabel,
    storeName: storeName,
    onClick: onClickStoreSearch
  }), isSticky ? /*#__PURE__*/createElement(StickyContainer, {
    isNavHeader: isNavHeader,
    stickOnLargeDevice: stickOnLargeDevice
  }, getFilterBarSection()) : /*#__PURE__*/createElement(Fragment, null, getFilterBarSection())), /*#__PURE__*/createElement("div", {
    className: styles$y.utilityBarExtraWrapper,
    ref: extraContainerRef
  })) : utilityBarContent;
};
UtilityBar.displayName = 'CoreUtilityBar';

var styles$z = {"carousel-arrow":"fr-ec-carousel-arrow","carouselArrow":"fr-ec-carousel-arrow","carousel-arrow--left":"fr-ec-carousel-arrow--left","carouselArrowLeft":"fr-ec-carousel-arrow--left","carousel-arrow--right":"fr-ec-carousel-arrow--right","carouselArrowRight":"fr-ec-carousel-arrow--right","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn"};

var ARROW_DIRECTION_PREV = 'prev';
var ARROW_DIRECTION_NEXT = 'next';

var CarouselArrow = function CarouselArrow(_a) {
  var _b, _c;

  var direction = _a.direction,
      onClick = _a.onClick,
      topOffset = _a.topOffset,
      keyboardNavigation = _a.keyboardNavigation,
      onArrowTrigger = _a.onArrowTrigger,
      carouselVariant = _a.carouselVariant,
      displayCount = _a.displayCount,
      iconBrand = _a.iconBrand;
  var arrowStyles = (_b = {}, _b[ARROW_DIRECTION_NEXT] = joinClasses(styles$z.carouselArrow, styles$z.carouselArrowRight), _b[ARROW_DIRECTION_PREV] = joinClasses(styles$z.carouselArrow, styles$z.carouselArrowLeft), _b);
  var arrowIcon = (_c = {}, _c[ARROW_DIRECTION_NEXT] = 'chevron-right', _c[ARROW_DIRECTION_PREV] = 'chevron-left', _c);
  var offsetStyles = topOffset !== undefined ? {
    top: topOffset + 'px'
  } : undefined;

  var handleClick = function handleClick(event) {
    onClick(direction);

    if (onArrowTrigger) {
      onArrowTrigger(event);
    }
  };

  var handleClickButton = function handleClickButton(e) {
    if (e.keyCode === 37 || e.keyCode === 39) {
      onClick(direction);
    }
  };

  var displayCountCheck = displayCount === 1;
  var isMediaGallerySP = carouselVariant && carouselVariant === 'media-gallery' ? true : false;
  var enableArrows = Number(getViewportWidth()) < designTokens_3.mqMediumScreenMinWidthLimit ? !isMediaGallerySP && displayCountCheck : true;
  return enableArrows ? /*#__PURE__*/createElement("button", {
    tabIndex: keyboardNavigation === 'item' ? -1 : 0,
    "aria-hidden": true,
    className: carouselVariant && carouselVariant === 'media-gallery' ? arrowStyles[direction] : joinClasses(arrowStyles[direction]),
    onClick: handleClick,
    style: offsetStyles,
    onKeyDown: handleClickButton
  }, /*#__PURE__*/createElement(Icon, {
    name: iconBrand ? "" + iconBrand + arrowIcon[direction] : arrowIcon[direction]
  })) : /*#__PURE__*/createElement("span", null);
};
CarouselArrow.displayName = 'CoreCarouselArrow';

var styles$A = {"hint-text":"fr-ec-hint-text","hintText":"fr-ec-hint-text","hint-text--color-primary-dark":"fr-ec-hint-text--color-primary-dark","hintTextColorPrimaryDark":"fr-ec-hint-text--color-primary-dark","hint-text--color-primary-light":"fr-ec-hint-text--color-primary-light","hintTextColorPrimaryLight":"fr-ec-hint-text--color-primary-light","hint-text--color-secondary":"fr-ec-hint-text--color-secondary","hintTextColorSecondary":"fr-ec-hint-text--color-secondary","hint-text--color-disabled":"fr-ec-hint-text--color-disabled","hintTextColorDisabled":"fr-ec-hint-text--color-disabled","hint-text--color-error":"fr-ec-hint-text--color-error","hintTextColorError":"fr-ec-hint-text--color-error"};

var alignmentClass$4 = {
  center: 'textAlignCenter',
  left: 'textAlignLeft',
  right: 'textAlignRight'
};
var HintText = function HintText(_a) {
  var Element = _a.element,
      children = _a.children,
      _b = _a.color,
      color = _b === void 0 ? 'secondary' : _b,
      _c = _a.variant,
      variant = _c === void 0 ? 'standard' : _c,
      _d = _a.textAlign,
      textAlign = _d === void 0 ? 'left' : _d,
      id = _a.id,
      className = _a.className,
      _e = _a.textTransform,
      textTransform = _e === void 0 ? 'normal' : _e,
      _f = _a.wordBreak,
      wordBreak = _f === void 0 ? 'none' : _f,
      strikethrough = _a.strikethrough,
      props = __rest(_a, ["element", "children", "color", "variant", "textAlign", "id", "className", "textTransform", "wordBreak", "strikethrough"]);

  return /*#__PURE__*/createElement(Element, __assign({
    id: id,
    "aria-live": color === 'error' ? 'polite' : undefined,
    className: joinClasses(styles$A.hintText, variant === 'standard' ? typographyStyles.hintTextStandard : '', styles$A["hint-text--color-" + color], textAlignStyles[alignmentClass$4[textAlign]], textTransformStyles["text-transform-" + textTransform], addWordBreak(wordBreak === 'break-word'), strikethrough && typographyStyles.strikethrough, className)
  }, props), children);
};
HintText.displayName = 'CoreHintText';

var styles$B = {"carousel-page":"fr-ec-carousel-page","carouselPage":"fr-ec-carousel-page","carousel-page--current":"fr-ec-carousel-page--current","carouselPageCurrent":"fr-ec-carousel-page--current","carousel-pagination-number":"fr-ec-carousel-pagination-number","carouselPaginationNumber":"fr-ec-carousel-pagination-number","carousel-pagination-number-count":"fr-ec-carousel-pagination-number-count","carouselPaginationNumberCount":"fr-ec-carousel-pagination-number-count","carousel-pagination-number-divider":"fr-ec-carousel-pagination-number-divider","carouselPaginationNumberDivider":"fr-ec-carousel-pagination-number-divider"};

var CarouselPagination = function CarouselPagination(_a) {
  var currentIndex = _a.currentIndex,
      total = _a.total,
      itemsPerPage = _a.itemsPerPage,
      indicatorType = _a.indicatorType,
      _b = _a.forceLast,
      forceLast = _b === void 0 ? false : _b,
      autoSlide = _a.autoSlide,
      carouselVariant = _a.carouselVariant;
  var pageCount = Math.ceil(total / itemsPerPage);
  var currentPage = forceLast ? pageCount - 1 : Math.ceil(currentIndex / itemsPerPage);
  currentPage = currentPage < 0 && autoSlide ? Math.floor(currentIndex % total) + total : currentPage;

  if (indicatorType === 'pages') {
    if (pageCount <= 1) {
      return null;
    }

    var pageButtons = count(pageCount).map(function (_, i) {
      return /*#__PURE__*/createElement("div", {
        key: i,
        tabIndex: -1,
        className: i === currentPage % total ? styles$B.carouselPageCurrent : styles$B.carouselPage,
        "aria-hidden": true
      });
    });

    if (currentPage > pageCount) {
      currentPage = 0;
    }

    return /*#__PURE__*/createElement("div", null, pageButtons);
  }

  if (indicatorType === 'number') {
    var numberIndicator = currentIndex >= 0 ? currentPage % total + 1 : Math.floor(currentIndex % total) + total + 1;
    numberIndicator = currentIndex % total === 0 && currentIndex < 0 ? 1 : numberIndicator;
    return carouselVariant && carouselVariant === 'media-gallery' ? /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(HintText, {
      element: "span",
      color: "primary-light",
      className: joinClasses(!autoSlide && styles$B.carouselPaginationNumber, styles$B.carouselPaginationNumberCount)
    }, autoSlide ? numberIndicator : currentIndex + 1), /*#__PURE__*/createElement(HintText, {
      element: "span",
      color: "primary-light",
      className: joinClasses(!autoSlide && styles$B.carouselPaginationNumber, styles$B.carouselPaginationNumberDivider)
    }, "|"), /*#__PURE__*/createElement(HintText, {
      element: "span",
      color: "primary-light",
      className: joinClasses(!autoSlide && styles$B.carouselPaginationNumber, styles$B.carouselPaginationNumberCount)
    }, total)) : /*#__PURE__*/createElement(Body, {
      element: "span",
      className: joinClasses(!autoSlide && styles$B.carouselPaginationNumber)
    }, autoSlide ? numberIndicator : currentIndex + 1, "/", total);
  }

  return null;
};
CarouselPagination.displayName = 'CoreCarouselPagination';

var styles$C = {"carousel-slide":"fr-ec-carousel-slide","carouselSlide":"fr-ec-carousel-slide","carousel-slide--padded":"fr-ec-carousel-slide--padded","carouselSlidePadded":"fr-ec-carousel-slide--padded","carousel-slide__container":"fr-ec-carousel-slide__container","carouselSlideContainer":"fr-ec-carousel-slide__container","carousel-slide--styling-variant-sm":"fr-ec-carousel-slide--styling-variant-sm","carouselSlideStylingVariantSm":"fr-ec-carousel-slide--styling-variant-sm"};

var MIN_LIMIT = 5;
var PADDING_MOBILE = 20;
var PADDING_IPAD = 24;
var CarouselSlides = function CarouselSlides(_a) {
  var children = _a.children,
      displayCount = _a.displayCount,
      currentIndex = _a.currentIndex,
      placeholder = _a.placeholder,
      noPadding = _a.noPadding,
      slideWidth = _a.slideWidth,
      isMobile = _a.isMobile,
      isMedium = _a.isMedium,
      carouselVariant = _a.carouselVariant,
      getClickedSlideIndex = _a.getClickedSlideIndex,
      enablePinchZoom = _a.enablePinchZoom;
  var validChildren = Children.toArray(children);
  var limit = placeholder ? Math.max(MIN_LIMIT, Math.ceil(displayCount) * 2) : -1;
  var lowerBound = limit >= 0 ? currentIndex - limit : 0;
  var upperBound = limit >= 0 ? currentIndex + Math.ceil(displayCount) + limit : validChildren.length;
  var slideStyle = {
    width: isInBrowser$1() ? slideWidth + 'px' : '100%'
  };
  var firstSlide = {
    width: slideWidth + (noPadding ? 0 : PADDING_MOBILE) + 'px'
  };
  var firstSlideImagePlusText = {
    paddingLeft: isMedium ? PADDING_IPAD : PADDING_MOBILE + 'px',
    width: slideWidth + (isMedium ? PADDING_IPAD : PADDING_MOBILE) + 'px'
  };

  var handleClick = function handleClick(index) {
    if (getClickedSlideIndex) {
      getClickedSlideIndex(index);
    }
  };

  var slides = validChildren.map(function (child, index) {
    var key = isOfType(child, 'key') && child.key;
    return /*#__PURE__*/createElement("li", __assign({
      key: key || index,
      style: carouselVariant && carouselVariant === 'media-gallery' ? slideStyle : index === 0 && displayCount !== 1 && isMobile && carouselVariant !== 'image-plus-text' ? firstSlide : index === 0 && carouselVariant === 'image-plus-text' ? firstSlideImagePlusText : slideStyle,
      className: joinClasses(noPadding ? styles$C.carouselSlide : styles$C.carouselSlidePadded, carouselVariant === 'styling' && styles$C.carouselSlideStylingVariantSm)
    }, enablePinchZoom && {
      onClick: function onClick() {
        return handleClick(index);
      }
    }), /*#__PURE__*/createElement("div", {
      className: styles$C.carouselSlideContainer
    }, index >= lowerBound && index <= upperBound ? child : placeholder));
  });
  return /*#__PURE__*/createElement(Fragment, null, slides);
};
CarouselSlides.displayName = 'CoreCarouselSlides';

var HintError = function HintError(_a) {
  var _b = _a.element,
      element = _b === void 0 ? 'p' : _b,
      errorProp = _a.error,
      hint = _a.hint,
      className = _a.className,
      _c = _a.disabled,
      disabled = _c === void 0 ? false : _c,
      _d = _a.textAlign,
      textAlign = _d === void 0 ? 'left' : _d,
      _e = _a.wordBreak,
      wordBreak = _e === void 0 ? 'none' : _e,
      props = __rest(_a, ["element", "error", "hint", "className", "disabled", "textAlign", "wordBreak"]);

  var error = disabled ? undefined : errorProp;
  var color = error ? 'error' : 'secondary';
  return /*#__PURE__*/createElement(HintText, __assign({
    element: element,
    className: joinClasses(addWordBreak(wordBreak === 'break-word'), className)
  }, props, {
    color: disabled ? 'disabled' : color,
    textAlign: textAlign
  }), error ? error : hint);
};
HintError.displayName = 'CoreHintError';

var styles$D = {"checkbox-group":"fr-ec-checkbox-group","checkboxGroup":"fr-ec-checkbox-group","checkbox-group__legend":"fr-ec-checkbox-group__legend","checkboxGroupLegend":"fr-ec-checkbox-group__legend","checkbox-group__checkbox-wrapper":"fr-ec-checkbox-group__checkbox-wrapper","checkboxGroupCheckboxWrapper":"fr-ec-checkbox-group__checkbox-wrapper","checkbox-group__checkbox-wrapper_margin-bottom":"fr-ec-checkbox-group__checkbox-wrapper_margin-bottom","checkboxGroupCheckboxWrapperMarginBottom":"fr-ec-checkbox-group__checkbox-wrapper_margin-bottom","checkbox-group__checkboxes":"fr-ec-checkbox-group__checkboxes","checkboxGroupCheckboxes":"fr-ec-checkbox-group__checkboxes","checkbox-group__required-badge":"fr-ec-checkbox-group__required-badge","checkboxGroupRequiredBadge":"fr-ec-checkbox-group__required-badge","lang-ja":"fr-ec-lang-ja","langJa":"fr-ec-lang-ja"};

var CheckboxGroup = function CheckboxGroup(_a) {
  var id = _a.id,
      legend = _a.legend,
      error = _a.error,
      hint = _a.hint,
      children = _a.children,
      required = _a.required,
      className = _a.className,
      _b = _a.columnCount,
      columnCount = _b === void 0 ? 1 : _b,
      props = __rest(_a, ["id", "legend", "error", "hint", "children", "required", "className", "columnCount"]);

  var _c = useState(getCurrentMediaQueryBreakpoint()),
      breakpoint = _c[0],
      setBreakPointValue = _c[1];

  var hintErrorId = error || hint ? id + "-hint-error" : undefined;
  var checkboxes = React__default.Children.map(children, function (child) {
    if (child.props !== undefined) {
      return /*#__PURE__*/React__default.createElement("div", {
        key: "checkbox-" + child.props.id,
        className: joinClasses(styles$D.checkboxGroupCheckboxWrapper, !(hint || error) && styles$D.checkboxGroupCheckboxWrapperMarginBottom)
      }, child);
    }

    return null;
  });
  var onWindowSize = debounce(100, function (_) {
    setBreakPointValue(getCurrentMediaQueryBreakpoint());
  });
  useEffect(function () {
    if (isInBrowser$1()) {
      window.addEventListener('resize', onWindowSize);
    }

    return function () {
      if (isInBrowser$1()) {
        window.removeEventListener('scroll', onWindowSize);
      }
    };
  }, []);
  var columnCountProp = Math.max(typeof columnCount === 'number' ? columnCount : columnCount[breakpoint], 1);
  return /*#__PURE__*/React__default.createElement("fieldset", __assign({
    id: id,
    className: joinClasses(styles$D.checkboxGroup, resetStyles.fieldsetReset, className),
    "aria-describedby": hintErrorId
  }, props), legend && /*#__PURE__*/React__default.createElement(Title, {
    element: "legend",
    variant: "standard",
    className: styles$D.checkboxGroupLegend
  }, legend, required && /*#__PURE__*/React__default.createElement("span", {
    className: styles$D.checkboxGroupRequiredBadge
  })), columnCountProp === 1 ? checkboxes : /*#__PURE__*/React__default.createElement("div", {
    className: styles$D.checkboxGroupCheckboxes
  }, checkboxes), hint || error ? /*#__PURE__*/React__default.createElement(HintError, {
    error: error,
    hint: hint,
    id: hintErrorId
  }) : null);
};
CheckboxGroup.displayName = 'CoreCheckboxGroup';
CheckboxGroup.defaultProps = {
  error: '',
  hint: '',
  required: false
};

var _line, _line2;

var _excluded = ["title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgStrikethrough = function SvgStrikethrough(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React__default.createElement("svg", _extends({
    width: 16,
    height: 16
  }, props), title ? /*#__PURE__*/React__default.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React__default.createElement("line", {
    y1: "100%",
    x2: "100%",
    stroke: "#DADADA"
  })), _line2 || (_line2 = /*#__PURE__*/React__default.createElement("line", {
    y1: "100%",
    x2: "100%",
    stroke: "#1B1B1B",
    strokeOpacity: 0.6,
    transform: "translate(.5 .5)"
  })));
};

var styles$E = {"chip":"fr-ec-chip","chip__default-image":"fr-ec-chip__default-image","chipDefaultImage":"fr-ec-chip__default-image","chip--short":"fr-ec-chip--short","chipShort":"fr-ec-chip--short","chip--default":"fr-ec-chip--default","chipDefault":"fr-ec-chip--default","chip--long-text":"fr-ec-chip--long-text","chipLongText":"fr-ec-chip--long-text","chip--long":"fr-ec-chip--long","chipLong":"fr-ec-chip--long","chip--product-tile":"fr-ec-chip--product-tile","chipProductTile":"fr-ec-chip--product-tile","chip__label-text":"fr-ec-chip__label-text","chipLabelText":"fr-ec-chip__label-text","chip__input":"fr-ec-chip__input","chipInput":"fr-ec-chip__input","chip__input--product-tile":"fr-ec-chip__input--product-tile","chipInputProductTile":"fr-ec-chip__input--product-tile","chip__label":"fr-ec-chip__label","chipLabel":"fr-ec-chip__label","chip__label--long-text":"fr-ec-chip__label--long-text","chipLabelLongText":"fr-ec-chip__label--long-text","chip__label--long":"fr-ec-chip__label--long","chipLabelLong":"fr-ec-chip__label--long","chip__label--product-tile":"fr-ec-chip__label--product-tile","chipLabelProductTile":"fr-ec-chip__label--product-tile","chip__label--default":"fr-ec-chip__label--default","chipLabelDefault":"fr-ec-chip__label--default","chip__input--with-icon":"fr-ec-chip__input--with-icon","chipInputWithIcon":"fr-ec-chip__input--with-icon","chip__label--short":"fr-ec-chip__label--short","chipLabelShort":"fr-ec-chip__label--short","chip__input--disabled":"fr-ec-chip__input--disabled","chipInputDisabled":"fr-ec-chip__input--disabled","chip__label--with-image":"fr-ec-chip__label--with-image","chipLabelWithImage":"fr-ec-chip__label--with-image","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","chip__input--product-tile-selected":"fr-ec-chip__input--product-tile-selected","chipInputProductTileSelected":"fr-ec-chip__input--product-tile-selected","chip__strikethrough":"fr-ec-chip__strikethrough","chipStrikethrough":"fr-ec-chip__strikethrough","chip__strikethrough--default":"fr-ec-chip__strikethrough--default","chipStrikethroughDefault":"fr-ec-chip__strikethrough--default","chip__strikethrough--short":"fr-ec-chip__strikethrough--short","chipStrikethroughShort":"fr-ec-chip__strikethrough--short","chip__strikethrough--long":"fr-ec-chip__strikethrough--long","chipStrikethroughLong":"fr-ec-chip__strikethrough--long","chip__strikethrough--product-tile":"fr-ec-chip__strikethrough--product-tile","chipStrikethroughProductTile":"fr-ec-chip__strikethrough--product-tile","chip__default-icon-container":"fr-ec-chip__default-icon-container","chipDefaultIconContainer":"fr-ec-chip__default-icon-container"};

var Chip =
/** @class */
function (_super) {
  __extends(Chip, _super);

  function Chip(props) {
    var _this = _super.call(this, props) || this;

    _this.handleImageErrored = function (event) {
      var noImage = _this.props.noImage;

      if (noImage && event.currentTarget.src !== noImage) {
        _this.setState({
          imageUrl: noImage
        });
      } else {
        _this.setState({
          bgColor: true
        });
      }
    };

    _this.state = {
      bgColor: false,
      imageUrl: props.image
    };
    return _this;
  }

  Chip.prototype.render = function () {
    var _a = this.props,
        image = _a.image,
        _b = _a.variant,
        variant = _b === void 0 ? "default" : _b,
        label = _a.label,
        _c = _a.unavailable,
        unavailable = _c === void 0 ? false : _c,
        type = _a.type,
        name = _a.name,
        _d = _a.className,
        className = _d === void 0 ? '' : _d,
        _e = _a.disabled,
        disabled = _e === void 0 ? false : _e,
        icon = _a.icon,
        onChange = _a.onChange,
        gaCategory = _a.gaCategory,
        gaLabel = _a.gaLabel,
        gaValue = _a.gaValue,
        selected = _a.selected,
        onMouseEnter = _a.onMouseEnter,
        onMouseLeave = _a.onMouseLeave,
        iconBrand = _a.iconBrand,
        props = __rest(_a, ["image", "variant", "noImage", "label", "unavailable", "type", "name", "id", "className", "disabled", "icon", "onChange", "gaCategory", "gaLabel", "gaValue", "selected", "onMouseEnter", "onMouseLeave", "iconBrand"]);

    var isDisabled = disabled || !label && !image && !icon;
    var withImageClassName = this.props.image ? styles$E.chipLabelWithImage : '';
    var disabledStyles = isDisabled ? styles$E.chipInputDisabled : '';
    var productTileStyles = variant === 'product-tile' ? styles$E.chipInputProductTile : '';
    var isCheckedProductTile = !isDisabled && variant === 'product-tile' && this.props.checked ? styles$E.chipInputProductTileSelected : "";
    var inputId = this.props.id;
    var labelId = inputId + "-label";
    var chipLabel = this.props.unavailable ? this.props.label + " (unavailable)" : this.props.label;
    var gaProps = null;
    var isLongText = !icon && variant === "default" && label.length > 3;

    if (gaCategory && gaLabel) {
      gaProps = {
        'data-category': gaCategory,
        'data-label': gaLabel
      };

      if (gaValue) {
        gaProps['data-value'] = gaValue;
      }
    }

    return /*#__PURE__*/React__default.createElement("div", __assign({
      className: joinClasses(styles$E.chip, styles$E["chip--" + variant], isLongText && styles$E.chipLongText, className)
    }, gaProps), image ? /*#__PURE__*/React__default.createElement("img", {
      className: styles$E.chipDefaultImage,
      src: this.state.imageUrl,
      onError: this.handleImageErrored,
      alt: "default image"
    }) : null, /*#__PURE__*/React__default.createElement("input", __assign({
      className: joinClasses(styles$E.chipInput, icon && styles$E.chipInputWithIcon, disabledStyles, interactionsStyles.cursorPointer, productTileStyles, isCheckedProductTile),
      id: inputId,
      type: type,
      name: name,
      "aria-label": chipLabel,
      disabled: isDisabled,
      onChange: onChange,
      checked: selected,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave
    }, props)), /*#__PURE__*/React__default.createElement(Label, {
      element: "label",
      variant: "standard",
      id: labelId,
      color: "secondary",
      className: joinClasses(styles$E.chipLabel, styles$E["chip__label--" + variant], withImageClassName, typographyStyles.chipStandard, isLongText && styles$E.chipLabelLongText),
      style: this.state.bgColor ? {
        backgroundColor: '#DADADA'
      } : {
        backgroundImage: image ? "url(" + this.state.imageUrl + ")" : undefined
      }
    }, /*#__PURE__*/React__default.createElement("div", {
      className: joinClasses(styles$E.chipStrikethrough, styles$E["chip__strikethrough--" + variant]),
      hidden: !unavailable
    }, /*#__PURE__*/React__default.createElement(SvgStrikethrough, {
      width: "100%",
      height: "100%"
    })), icon ? /*#__PURE__*/React__default.createElement("div", {
      className: styles$E.chipDefaultIconContainer
    }, /*#__PURE__*/React__default.createElement(Icon, {
      name: iconBrand ? "" + iconBrand + icon : icon
    })) : image ? null : /*#__PURE__*/React__default.createElement("p", {
      className: styles$E.chipLabelText
    }, label)));
  };

  Chip.displayName = 'CoreChip';
  Chip.defaultProps = {
    disabled: false,
    unavailable: false
  };
  return Chip;
}(Component);

var styles$F = {"chip-group":"fr-ec-chip-group","chipGroup":"fr-ec-chip-group","chip-group__legend":"fr-ec-chip-group__legend","chipGroupLegend":"fr-ec-chip-group__legend","chip-group__value":"fr-ec-chip-group__value","chipGroupValue":"fr-ec-chip-group__value","chip-group__chips":"fr-ec-chip-group__chips","chipGroupChips":"fr-ec-chip-group__chips","chip":"fr-ec-chip","chip-group__extra":"fr-ec-chip-group__extra","chipGroupExtra":"fr-ec-chip-group__extra"};

var ChipGroup = function ChipGroup(_a) {
  var legend = _a.legend,
      value = _a.value,
      hoverValue = _a.hoverValue,
      error = _a.error,
      id = _a.id,
      children = _a.children,
      className = _a.className,
      topRightContent = _a.topRightContent,
      gaCategory = _a.gaCategory,
      gaLabel = _a.gaLabel,
      gaValue = _a.gaValue,
      props = __rest(_a, ["legend", "value", "hoverValue", "error", "id", "children", "className", "topRightContent", "gaCategory", "gaLabel", "gaValue"]);

  var hintErrorId = id + "-hint-error";
  var gaProps = null;

  if (gaCategory && gaLabel) {
    gaProps = {
      'data-category': gaCategory,
      'data-label': gaLabel
    };

    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }

  var curValue = hoverValue || value;
  return /*#__PURE__*/createElement("fieldset", __assign({
    id: id,
    className: joinClasses(styles$F.chipGroup, resetStyles.fieldsetReset, className),
    "aria-describedby": hintErrorId
  }, gaProps, props), /*#__PURE__*/createElement(ContentAlignment, {
    element: "div",
    justifyContent: "space-between",
    direction: "row",
    alignment: "center"
  }, /*#__PURE__*/createElement("legend", {
    className: styles$F.chipGroupLegend
  }, /*#__PURE__*/createElement(Label, {
    element: "label",
    variant: "large"
  }, legend, ":"), /*#__PURE__*/createElement(Label, {
    element: "label",
    variant: "large",
    className: styles$F.chipGroupValue
  }, curValue)), topRightContent && /*#__PURE__*/createElement("div", {
    className: styles$F.chipGroupExtra
  }, topRightContent)), /*#__PURE__*/createElement("div", {
    className: styles$F.chipGroupChips
  }, children), /*#__PURE__*/createElement(HintError, {
    error: error,
    id: hintErrorId
  }));
};
ChipGroup.displayName = 'CoreChipGroup';

var styles$G = {"collection-grid-item":"fr-ec-collection-grid-item","collectionGridItem":"fr-ec-collection-grid-item","collection-grid-item--with-keyline":"fr-ec-collection-grid-item--with-keyline","collectionGridItemWithKeyline":"fr-ec-collection-grid-item--with-keyline","collection-grid-item--with-keyline-left":"fr-ec-collection-grid-item--with-keyline-left","collectionGridItemWithKeylineLeft":"fr-ec-collection-grid-item--with-keyline-left","collection-grid-item--with-keyline-top":"fr-ec-collection-grid-item--with-keyline-top","collectionGridItemWithKeylineTop":"fr-ec-collection-grid-item--with-keyline-top","collection-grid-item--with-keyline-right":"fr-ec-collection-grid-item--with-keyline-right","collectionGridItemWithKeylineRight":"fr-ec-collection-grid-item--with-keyline-right","collection-grid-item--with-keyline-bottom":"fr-ec-collection-grid-item--with-keyline-bottom","collectionGridItemWithKeylineBottom":"fr-ec-collection-grid-item--with-keyline-bottom","collection-grid-item-contents":"fr-ec-collection-grid-item-contents","collectionGridItemContents":"fr-ec-collection-grid-item-contents"};

var getBorderClasses = function getBorderClasses(rowIndex, colIndex) {
  return joinClasses(styles$G.collectionGridItemWithKeyline, colIndex > 0 && styles$G.collectionGridItemWithKeylineLeft, rowIndex > 0 && styles$G.collectionGridItemWithKeylineTop);
};

var CollectionGridItem = function CollectionGridItem(_a) {
  var children = _a.children,
      rowIndex = _a.rowIndex,
      colIndex = _a.colIndex,
      inlineStyles = _a.inlineStyles,
      margin = _a.margin,
      withKeyline = _a.withKeyline;
  return /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$G.collectionGridItem),
    style: __assign({}, inlineStyles)
  }, /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$G.collectionGridItemContents, withKeyline && getBorderClasses(rowIndex, colIndex)),
    style: {
      margin: margin
    }
  }, children));
};
CollectionGridItem.displayName = 'CoreCollectionGridItem';

var styles$H = {"collection-grid":"fr-ec-collection-grid","collectionGrid":"fr-ec-collection-grid"};

var CollectionGridItemManager =
/** @class */
function () {
  function CollectionGridItemManager(columns, rowHeightDecimal, spacingInfo) {
    var _this = this; // Create a new empty row with length = columns


    this.getNewRow = function () {
      return new Array(_this.columns).fill(-1);
    }; // Add the specified number of empty rows to the row matrix


    this.addRows = function (amount) {
      _this.rows = __spreadArrays(_this.rows, count(amount).map(function (_) {
        return _this.getNewRow();
      }));
    }; // Updates the row matrix with the slots taken up by the new item


    this.updateRows = function (columnIndex, rowIndex, colSpan, rowSpan) {
      _this.rows = _this.rows.map(function (row, index) {
        var startRow = index === rowIndex;
        var spannedRow = rowSpan > 1 && index > rowIndex && index < rowIndex + rowSpan;
        return startRow || spannedRow ? __spreadArrays(row.fill(1, columnIndex, columnIndex + colSpan)) : __spreadArrays(row);
      });
    };
    /**
     * Determines where the item can fit, given its row- and col-span
     * This method will iterate through the row matrix to find a row with
     * a slot >= colSpan.
     * Then it checks how many new rows must be added to the row matrix
     * to accomodate the item, adds the required number of rows, and marks
     * the required slots as filled.
     */


    this.positionItem = function (colSpan, rowSpan) {
      var freeSlotIndex = 0; // Find first existing row with a slot big enough for the items colSpan

      var rowIndex = _this.rows.findIndex(function (row, index) {
        var _a = _this.findLongestFreeSlot(row),
            localFreeSlotIndex = _a.freeSlotIndex,
            globalSum = _a.globalSum;

        freeSlotIndex = localFreeSlotIndex;
        var isRowSpanFree = true;

        if (globalSum >= colSpan && rowSpan > 1) {
          isRowSpanFree = __spreadArrays(_this.rows.slice(index + 1, index + rowSpan)).map(function (nextRow) {
            return __spreadArrays(nextRow.slice(freeSlotIndex, freeSlotIndex + colSpan)).every(function (item) {
              return item < 0;
            });
          }).every(function (rowHasFreeSlot) {
            return rowHasFreeSlot === true;
          });
        }

        return globalSum >= colSpan && isRowSpanFree;
      });

      var remainingRowCount = _this.rows.length - rowIndex; // If no existing row found, add the required number of rows (as per rowSpan)

      if (rowIndex < 0) {
        rowIndex = _this.rows.length;

        _this.addRows(rowSpan);

        freeSlotIndex = 0;
      } else if (rowSpan > remainingRowCount) {
        // If there is space in an exisiting make sure there are enough rows to accommodate the items rowSpan
        _this.addRows(rowSpan - remainingRowCount);
      } // Update the row matrix


      _this.updateRows(freeSlotIndex, rowIndex, colSpan, rowSpan);

      return {
        rowIndex: rowIndex,
        freeSlotIndex: freeSlotIndex
      };
    }; // Iterate through the row to find the longest, consecutive run of empty slots


    this.findLongestFreeSlot = function (row) {
      return row.reduce(function (_a, item, index) {
        var freeSlotIndex = _a.freeSlotIndex,
            localSum = _a.localSum,
            globalSum = _a.globalSum;
        return item < 0 ? {
          freeSlotIndex: localSum + 1 > globalSum ? index - localSum : freeSlotIndex,
          globalSum: Math.max(globalSum, localSum + 1),
          localSum: localSum + 1
        } : {
          freeSlotIndex: freeSlotIndex,
          localSum: 0,
          globalSum: globalSum
        };
      }, {
        freeSlotIndex: -1,
        globalSum: 0,
        localSum: 0
      });
    };
    /**
     * Calculates the position and size of a grid item given it's row- and col-span, starting
     * col index, and starting row index
     */


    this.calculateItemStyles = function (colSpan, rowSpan, colIndex, rowIndex) {
      var _a = _this.spacingInfo,
          spacingValue = _a.spacingValue,
          spacingUnits = _a.spacingUnits;
      return {
        left: _this.calculateLeftValue(colIndex, spacingValue, spacingUnits),
        marginTop: _this.calculateMarginTopValue(rowIndex, spacingValue, spacingUnits),
        paddingTop: _this.calculatePaddingTopValue(rowSpan),
        width: _this.calculateWidthValue(colSpan, spacingValue, spacingUnits)
      };
    };
    /**
     * Calculates the left value for a grid item given it's col index.
     * Optionally takes spacing in to account.
     */


    this.calculateLeftValue = function (colIndex, spacingValue, spacingUnits) {
      return spacingValue && spacingValue > 0 ? "calc(" + _this.calculateBaseLeftValue(colIndex) + " - " + spacingValue / 2 + spacingUnits + " + " + spacingValue / _this.columns * colIndex + spacingUnits + ")" : _this.calculateBaseLeftValue(colIndex);
    };
    /**
     * Calculates the margin-top for a grid item given it's row index.
     */


    this.calculateBaseMarginTopValue = function (rowIndex) {
      return rowIndex / _this.columns * _this.rowHeightDecimal * 100 + "%";
    };
    /**
     * Calculates the width of a grid item given it's col-span.
     */


    this.calculateBaseWidthValue = function (colSpan) {
      return colSpan / _this.columns * 100 + "%";
    };
    /**
     * Calculates the left value for a grid item given it's col index.
     */


    this.calculateBaseLeftValue = function (colIndex) {
      return colIndex / _this.columns * 100 + "%";
    };
    /**
     * Calculates the width of a grid item given it's col-span.
     * Optionally takes spacing in to account.
     */


    this.calculateWidthValue = function (colSpan, spacingValue, spacingUnits) {
      return spacingValue && spacingValue > 0 ? "calc(" + _this.calculateBaseWidthValue(colSpan) + " + " + spacingValue / _this.columns * colSpan + spacingUnits + ")" : _this.calculateBaseWidthValue(colSpan);
    };
    /**
     * Calculates the padding-top (i.e. height) of a grid item given it's row-span.
     */


    this.calculatePaddingTopValue = function (rowSpan) {
      return rowSpan / _this.columns * _this.rowHeightDecimal * 100 + "%";
    };
    /**
     * Calculates the margin-top for a grid item given it's row index.
     * Optionally takes spacing in to account.
     */


    this.calculateMarginTopValue = function (rowIndex, spacingValue, spacingUnits) {
      return spacingValue && spacingValue > 0 ? "calc(" + _this.calculateBaseMarginTopValue(rowIndex) + " - " + spacingValue / 2 + spacingUnits + ")" : _this.calculateBaseMarginTopValue(rowIndex);
    };

    this.columns = columns;
    this.rowHeightDecimal = rowHeightDecimal;
    this.spacingInfo = spacingInfo; // Create the first row of the CollectionGrid

    this.rows = [this.getNewRow()];
  }

  return CollectionGridItemManager;
}();

var parseBreakPointProps = function parseBreakPointProps(gridItems, screenSize) {
  return gridItems.map(function (item) {
    return Object.keys(item).filter(function (key) {
      return key !== 'children';
    }).reduce(function (acc, key) {
      var _a, _b;

      return isOfType(item[key], 'toExponential') ? __assign(__assign({}, acc), (_a = {}, _a[key] = item[key], _a)) : __assign(__assign({}, acc), (_b = {}, _b[key] = item[key][screenSize], _b));
    }, {
      children: item.children,
      colSpan: 0,
      rowSpan: 0
    });
  });
};

var STARTING_NUMBER_REGEXP = '^[0-9.]*';
var ENDING_NUMBER_REGEXP = '[0-9.]*$';
var parseRatio = function parseRatio(ratioString) {
  return [ratioString.match(new RegExp(STARTING_NUMBER_REGEXP)), ratioString.match(new RegExp(ENDING_NUMBER_REGEXP))].map(function (item) {
    return Number(item);
  });
};

var ENDING_STRING_REGEXP = '[a-z%]*$';
var parseSpacingProp = function parseSpacingProp(spacingProp) {
  var unitRegExp = spacingProp.match(new RegExp(ENDING_STRING_REGEXP));
  var spacingRegExp = spacingProp.match(new RegExp(STARTING_NUMBER_REGEXP));
  return {
    spacingUnits: unitRegExp ? unitRegExp[0] : undefined,
    spacingValue: spacingRegExp ? Number(spacingRegExp[0]) : undefined
  };
};

var sortGridItems = function sortGridItems(items) {
  return items.map(function (item, index) {
    return {
      index: index,
      item: item
    };
  }).sort(function (_a, _b) {
    var aIndex = _a.index,
        aOrderProp = _a.item.order;
    var bIndex = _b.index,
        bOrderProp = _b.item.order;
    var aOrder = typeof aOrderProp !== 'undefined' ? aOrderProp : aIndex + 0.1;
    var bOrder = typeof bOrderProp !== 'undefined' ? bOrderProp : bIndex + 0.1;
    return aOrder - bOrder;
  }).map(function (indexedItem) {
    return indexedItem.item;
  });
};

var ROW_HEIGHT_FORMAT = '[0-9]:[0-9]';

var createCollectionGridItem = function createCollectionGridItem(_a, rowMonitor, withKeyline) {
  var colSpan = _a.colSpan,
      rowSpan = _a.rowSpan,
      children = _a.children;

  var _b = rowMonitor.positionItem(colSpan, rowSpan),
      rowIndex = _b.rowIndex,
      colIndex = _b.freeSlotIndex;

  var gridItemStyles = rowMonitor.calculateItemStyles(colSpan, rowSpan, colIndex, rowIndex);
  var _c = rowMonitor.spacingInfo,
      spacingValue = _c.spacingValue,
      spacingUnits = _c.spacingUnits;
  var margin = spacingValue && spacingValue > 0 ? "" + spacingValue / 2 + spacingUnits : undefined;
  var gridItemComponent = /*#__PURE__*/createElement(CollectionGridItem, {
    key: "row-" + rowIndex + "-col-" + colIndex,
    rowIndex: rowIndex,
    colIndex: colIndex,
    inlineStyles: gridItemStyles,
    margin: margin,
    withKeyline: withKeyline
  }, children);
  return gridItemComponent;
};

var CollectionGrid = function CollectionGrid(_a) {
  var className = _a.className,
      columns = _a.columns,
      gridItems = _a.gridItems,
      _b = _a.spacing,
      spacing = _b === void 0 ? '' : _b,
      withKeyline = _a.withKeyline,
      _c = _a.rowHeight,
      rowHeight = _c === void 0 ? '1:1' : _c,
      props = __rest(_a, ["className", "columns", "gridItems", "spacing", "withKeyline", "rowHeight"]);

  var screenSize = getCurrentMediaQueryBreakpoint();
  var parsedColumns = typeof columns === 'number' ? columns : columns[screenSize];
  var parsedGridItems = parseBreakPointProps(gridItems, screenSize);
  var sortedGridItems = sortGridItems(parsedGridItems);
  var spacingParsed = typeof spacing === 'string' ? spacing : spacing[screenSize];
  var rowHeightParsed = typeof rowHeight === 'string' ? rowHeight : rowHeight[screenSize];
  var withKeylineParsed = typeof withKeyline === 'boolean' ? withKeyline : withKeyline && withKeyline[screenSize]; // Check if colSpan > columns, throw error if true

  if (sortedGridItems.some(function (item) {
    return item.colSpan > columns;
  })) {
    throw new Error('CollectionGridItem.colSpan cannot be > CollectionGrid columns');
  }

  if (rowHeightParsed.match(new RegExp(ROW_HEIGHT_FORMAT)) === null) {
    throw new Error("CollectrionGrid.rowHeight must be in format " + ROW_HEIGHT_FORMAT + ", width:height");
  }

  var spacingInfo = parseSpacingProp(spacingParsed);
  var spacingValue = spacingInfo.spacingValue,
      spacingUnits = spacingInfo.spacingUnits;

  var _d = parseRatio(rowHeightParsed),
      ratioDenominator = _d[0],
      ratioNumerator = _d[1];

  var rowHeightDecimal = ratioNumerator / ratioDenominator;
  var rowMonitor = new CollectionGridItemManager(parsedColumns, rowHeightDecimal, spacingInfo);
  var children = sortedGridItems.map(function (item) {
    return createCollectionGridItem(item, rowMonitor, withKeylineParsed);
  });
  var collectionGridHeight = spacingValue && spacingValue > 0 ? "calc(" + rowMonitor.rows.length / parsedColumns * rowHeightDecimal * 100 + "% - " + spacingValue + spacingUnits + ")" : rowMonitor.rows.length / parsedColumns * rowHeightDecimal * 100 + "%";
  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$H.collectionGrid, className),
    style: {
      paddingBottom: collectionGridHeight
    }
  }, props), children);
};
CollectionGrid.displayName = 'CoreCollectionGrid';
CollectionGrid.defaultProps = {
  rowHeight: '1:1',
  spacing: ''
};

var styles$I = {"collection-list":"fr-ec-collection-list","collectionList":"fr-ec-collection-list","collection-list__item":"fr-ec-collection-list__item","collectionListItem":"fr-ec-collection-list__item","collection-list__item--spacing":"fr-ec-collection-list__item--spacing","collectionListItemSpacing":"fr-ec-collection-list__item--spacing","collection-list__item-spacing-16":"fr-ec-collection-list__item-spacing-16","collectionListItemSpacing16":"fr-ec-collection-list__item-spacing-16","collection-list__item-spacing-24":"fr-ec-collection-list__item-spacing-24","collectionListItemSpacing24":"fr-ec-collection-list__item-spacing-24","collection-list__item-spacing-32":"fr-ec-collection-list__item-spacing-32","collectionListItemSpacing32":"fr-ec-collection-list__item-spacing-32","collection-list__item--no-keylines-spacing-16":"fr-ec-collection-list__item--no-keylines-spacing-16","collectionListItemNoKeylinesSpacing16":"fr-ec-collection-list__item--no-keylines-spacing-16","collection-list__item--no-keylines-spacing-24":"fr-ec-collection-list__item--no-keylines-spacing-24","collectionListItemNoKeylinesSpacing24":"fr-ec-collection-list__item--no-keylines-spacing-24","collection-list__item--no-keylines-spacing-32":"fr-ec-collection-list__item--no-keylines-spacing-32","collectionListItemNoKeylinesSpacing32":"fr-ec-collection-list__item--no-keylines-spacing-32","collection-list__item--no-keylines-spacing":"fr-ec-collection-list__item--no-keylines-spacing","collectionListItemNoKeylinesSpacing":"fr-ec-collection-list__item--no-keylines-spacing","collection-list__item--keylines-top":"fr-ec-collection-list__item--keylines-top","collectionListItemKeylinesTop":"fr-ec-collection-list__item--keylines-top","collection-list__item--keylines-bottom":"fr-ec-collection-list__item--keylines-bottom","collectionListItemKeylinesBottom":"fr-ec-collection-list__item--keylines-bottom","collection-list__item--keylines-bottom-top":"fr-ec-collection-list__item--keylines-bottom-top","collectionListItemKeylinesBottomTop":"fr-ec-collection-list__item--keylines-bottom-top","collection-list__item--keylines-between-items":"fr-ec-collection-list__item--keylines-between-items","collectionListItemKeylinesBetweenItems":"fr-ec-collection-list__item--keylines-between-items","collection-list__item--remove-edge-padding":"fr-ec-collection-list__item--remove-edge-padding","collectionListItemRemoveEdgePadding":"fr-ec-collection-list__item--remove-edge-padding"};

var _a;
var MB_SPACING_04 = '16';
var MB_SPACING_05 = '24';
var MB_SPACING_06 = '32';
var variantSpacing = (_a = {}, _a[MB_SPACING_04] = spacingStyles.mbSpacing04, _a[MB_SPACING_05] = spacingStyles.mbSpacing05, _a[MB_SPACING_06] = spacingStyles.mbSpacing06, _a);
var CollectionList = function CollectionList(_a) {
  var children = _a.children,
      id = _a.id,
      _b = _a.keylines,
      keylines = _b === void 0 ? 'none' : _b,
      spacing = _a.spacing,
      _c = _a.removeEdgePadding,
      removeEdgePadding = _c === void 0 ? false : _c,
      className = _a.className,
      props = __rest(_a, ["children", "id", "keylines", "spacing", "removeEdgePadding", "className"]);

  return /*#__PURE__*/createElement("ul", __assign({
    id: id,
    className: joinClasses(styles$I.collectionList, className)
  }, props), Children.toArray(children).filter(isValidElement).map(function (child, i) {
    return /*#__PURE__*/createElement("li", {
      className: joinClasses(styles$I.collectionListItem, styles$I["collection-list__item--spacing-" + spacing], keylines === 'none' && spacing !== 'none' && styles$I["collection-list__item--no-keylines-spacing-" + spacing], keylines === 'none' && spacing !== 'none' && styles$I.collectionListItemNoKeylinesSpacing, spacing !== 'none' && styles$I["collection-list__item-spacing-" + spacing], styles$I["collection-list__item--keylines-" + keylines], keylines !== 'none' && removeEdgePadding && styles$I.collectionListItemRemoveEdgePadding),
      key: child.key || i
    }, child);
  }));
};
CollectionList.displayName = 'CoreCollectionList';
CollectionList.defaultProps = {
  keylines: 'none',
  removeEdgePadding: false,
  spacing: 'none'
};

var styles$J = {"layout":"fr-ec-layout","layout--gutter-sm":"fr-ec-layout--gutter-sm","layoutGutterSm":"fr-ec-layout--gutter-sm","layout--inset-left-sm":"fr-ec-layout--inset-left-sm","layoutInsetLeftSm":"fr-ec-layout--inset-left-sm","layout--inset-right-sm":"fr-ec-layout--inset-right-sm","layoutInsetRightSm":"fr-ec-layout--inset-right-sm","layout--span-1-sm":"fr-ec-layout--span-1-sm","layoutSpan1Sm":"fr-ec-layout--span-1-sm","layout--span-2-sm":"fr-ec-layout--span-2-sm","layoutSpan2Sm":"fr-ec-layout--span-2-sm","layout--span-3-sm":"fr-ec-layout--span-3-sm","layoutSpan3Sm":"fr-ec-layout--span-3-sm","layout--span-4-sm":"fr-ec-layout--span-4-sm","layoutSpan4Sm":"fr-ec-layout--span-4-sm","layout--gutter-md":"fr-ec-layout--gutter-md","layoutGutterMd":"fr-ec-layout--gutter-md","layout--inset-left-md":"fr-ec-layout--inset-left-md","layoutInsetLeftMd":"fr-ec-layout--inset-left-md","layout--inset-right-md":"fr-ec-layout--inset-right-md","layoutInsetRightMd":"fr-ec-layout--inset-right-md","layout--span-1-md":"fr-ec-layout--span-1-md","layoutSpan1Md":"fr-ec-layout--span-1-md","layout--span-2-md":"fr-ec-layout--span-2-md","layoutSpan2Md":"fr-ec-layout--span-2-md","layout--span-3-md":"fr-ec-layout--span-3-md","layoutSpan3Md":"fr-ec-layout--span-3-md","layout--span-4-md":"fr-ec-layout--span-4-md","layoutSpan4Md":"fr-ec-layout--span-4-md","layout--span-5-md":"fr-ec-layout--span-5-md","layoutSpan5Md":"fr-ec-layout--span-5-md","layout--span-6-md":"fr-ec-layout--span-6-md","layoutSpan6Md":"fr-ec-layout--span-6-md","layout--span-7-md":"fr-ec-layout--span-7-md","layoutSpan7Md":"fr-ec-layout--span-7-md","layout--span-8-md":"fr-ec-layout--span-8-md","layoutSpan8Md":"fr-ec-layout--span-8-md","layout--span-9-md":"fr-ec-layout--span-9-md","layoutSpan9Md":"fr-ec-layout--span-9-md","layout--span-10-md":"fr-ec-layout--span-10-md","layoutSpan10Md":"fr-ec-layout--span-10-md","layout--span-11-md":"fr-ec-layout--span-11-md","layoutSpan11Md":"fr-ec-layout--span-11-md","layout--span-12-md":"fr-ec-layout--span-12-md","layoutSpan12Md":"fr-ec-layout--span-12-md","layout--gutter-lg":"fr-ec-layout--gutter-lg","layoutGutterLg":"fr-ec-layout--gutter-lg","layout--inset-left-lg":"fr-ec-layout--inset-left-lg","layoutInsetLeftLg":"fr-ec-layout--inset-left-lg","layout--inset-right-lg":"fr-ec-layout--inset-right-lg","layoutInsetRightLg":"fr-ec-layout--inset-right-lg","layout--span-1-lg":"fr-ec-layout--span-1-lg","layoutSpan1Lg":"fr-ec-layout--span-1-lg","layout--span-2-lg":"fr-ec-layout--span-2-lg","layoutSpan2Lg":"fr-ec-layout--span-2-lg","layout--span-3-lg":"fr-ec-layout--span-3-lg","layoutSpan3Lg":"fr-ec-layout--span-3-lg","layout--span-4-lg":"fr-ec-layout--span-4-lg","layoutSpan4Lg":"fr-ec-layout--span-4-lg","layout--span-5-lg":"fr-ec-layout--span-5-lg","layoutSpan5Lg":"fr-ec-layout--span-5-lg","layout--span-6-lg":"fr-ec-layout--span-6-lg","layoutSpan6Lg":"fr-ec-layout--span-6-lg","layout--span-7-lg":"fr-ec-layout--span-7-lg","layoutSpan7Lg":"fr-ec-layout--span-7-lg","layout--span-8-lg":"fr-ec-layout--span-8-lg","layoutSpan8Lg":"fr-ec-layout--span-8-lg","layout--span-9-lg":"fr-ec-layout--span-9-lg","layoutSpan9Lg":"fr-ec-layout--span-9-lg","layout--span-10-lg":"fr-ec-layout--span-10-lg","layoutSpan10Lg":"fr-ec-layout--span-10-lg","layout--span-11-lg":"fr-ec-layout--span-11-lg","layoutSpan11Lg":"fr-ec-layout--span-11-lg","layout--span-12-lg":"fr-ec-layout--span-12-lg","layoutSpan12Lg":"fr-ec-layout--span-12-lg"};

var getGutterClasses = function getGutterClasses(gutterProp) {
  if (typeof gutterProp === 'boolean') {
    if (gutterProp) {
      return joinClasses(styles$J.layoutGutterSm, styles$J.layoutGutterMd, styles$J.layoutGutterLg);
    } else {
      return '';
    }
  }

  return joinClasses.apply(void 0, Object.keys(gutterProp).reduce(function (acc, size) {
    return gutterProp[size] ? __spreadArrays(acc, [styles$J["layout--gutter-" + size]]) : acc;
  }, []));
};

var getSpanClasses = function getSpanClasses(colSpanProp) {
  if (typeof colSpanProp === 'boolean' && !colSpanProp) {
    return '';
  }

  return joinClasses.apply(void 0, Object.keys(colSpanProp).reduce(function (acc, size) {
    return _typeof(colSpanProp[size]) !== undefined ? __spreadArrays(acc, [styles$J["layout--span-" + colSpanProp[size] + "-" + size]]) : acc;
  }, []));
};

var getInsetClass = function getInsetClass(insetProp) {
  if (typeof insetProp === 'boolean') {
    if (insetProp) {
      return joinClasses(styles$J.layoutInsetLeftSm, styles$J.layoutInsetRightSm, styles$J.layoutInsetLeftMd, styles$J.layoutInsetRightMd, styles$J.layoutInsetLeftLg, styles$J.layoutInsetRightLg);
    } else {
      return '';
    }
  }

  return joinClasses.apply(void 0, Object.keys(insetProp).map(function (side) {
    var insetSide = insetProp[side];

    if (typeof insetSide === 'boolean' && insetSide) {
      return joinClasses(styles$J["layout--inset-" + side + "-sm"], styles$J["layout--inset-" + side + "-md"], styles$J["layout--inset-" + side + "-lg"]);
    }

    return Object.keys(insetSide).reduce(function (acc, breakpoint) {
      if (insetSide[breakpoint]) {
        return __spreadArrays(acc, [styles$J["layout--inset-" + side + "-" + breakpoint]]);
      }

      return acc;
    }, []).join(' ');
  }));
};

var LayoutComponent = function LayoutComponent(_a) {
  var _b = _a.element,
      Element = _b === void 0 ? 'div' : _b,
      _c = _a.gutter,
      gutter = _c === void 0 ? false : _c,
      _d = _a.colSpan,
      colSpan = _d === void 0 ? {
    sm: 4,
    md: 12,
    lg: 12
  } : _d,
      _e = _a.inset,
      inset = _e === void 0 ? false : _e,
      className = _a.className,
      props = __rest(_a, ["element", "gutter", "colSpan", "inset", "className"]);

  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign({
      className: joinClasses(styles$J.layout, getGutterClasses(gutter), getSpanClasses(colSpan), getInsetClass(inset), className)
    }, props))
  );
};

LayoutComponent.displayName = 'CoreLayout';
LayoutComponent.defaultProps = {
  colSpan: {
    sm: 4,
    md: 12,
    lg: 12
  },
  element: 'div',
  gutter: false,
  inset: false
};
var Layout = isViewport(LayoutComponent);

var styles$K = {"contents-card":"fr-ec-contents-card","contentsCard":"fr-ec-contents-card","contents-card-contained":"fr-ec-contents-card-contained","contentsCardContained":"fr-ec-contents-card-contained"};

var ContentsCard = function ContentsCard(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'navigation-fullscreen' : _b,
      content = _a.content,
      className = _a.className,
      props = __rest(_a, ["variant", "content", "className"]);

  return /*#__PURE__*/createElement(ContentAlignment, __assign({
    justifyContent: "center",
    direction: "row",
    className: joinClasses(className, styles$K.contentsCard),
    element: "div"
  }, props), /*#__PURE__*/createElement(Layout, {
    colSpan: {
      lg: 10,
      md: 12,
      sm: 4
    },
    className: joinClasses(styles$K.contentsCard, variant === "navigation-contained" && styles$K.contentsCardContained)
  }, content));
};
ContentsCard.displayName = 'CoreContentsCard';

var styles$L = {"description-list-item-dt":"fr-ec-description-list-item-dt","descriptionListItemDt":"fr-ec-description-list-item-dt","description-list-item-dd":"fr-ec-description-list-item-dd","descriptionListItemDd":"fr-ec-description-list-item-dd","description-list-item-dd__max-width":"fr-ec-description-list-item-dd__max-width","descriptionListItemDdMaxWidth":"fr-ec-description-list-item-dd__max-width"};

var DescriptionListItem = function DescriptionListItem(_a) {
  var title = _a.title,
      content = _a.content,
      className = _a.className;
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("dt", {
    className: joinClasses(styles$L.descriptionListItemDt, className)
  }, /*#__PURE__*/createElement(Label, {
    element: "p",
    variant: "large"
  }, title)), /*#__PURE__*/createElement("dd", {
    className: styles$L.descriptionListItemDd
  }, typeof content === 'string' ? /*#__PURE__*/createElement(Body, {
    element: "p",
    variant: "standard",
    className: styles$L.descriptionListItemDdMaxWidth
  }, content) : content.map(function (item) {
    return /*#__PURE__*/createElement(Body, {
      key: item,
      element: "p",
      variant: "standard",
      className: styles$L.descriptionListItemDdMaxWidth
    }, item);
  })));
};

var styles$M = {"description-list":"fr-ec-description-list","descriptionList":"fr-ec-description-list"};

var DescriptionList = function DescriptionList(_a) {
  var items = _a.items,
      className = _a.className,
      props = __rest(_a, ["items", "className"]);

  return /*#__PURE__*/createElement("dl", __assign({
    className: joinClasses(styles$M.descriptionList, className)
  }, props), items.map(function (item, index) {
    return /*#__PURE__*/createElement(DescriptionListItem, {
      key: index,
      title: item.title,
      content: item.content
    });
  }));
};
DescriptionList.displayName = 'CoreDescriptionList';

var styles$N = {"display":"fr-ec-display","display--display4":"fr-ec-display--display4","displayDisplay4":"fr-ec-display--display4","display--color-primary-dark":"fr-ec-display--color-primary-dark","displayColorPrimaryDark":"fr-ec-display--color-primary-dark","display--color-primary-light":"fr-ec-display--color-primary-light","displayColorPrimaryLight":"fr-ec-display--color-primary-light","display--color-disabled":"fr-ec-display--color-disabled","displayColorDisabled":"fr-ec-display--color-disabled"};

var alignmentClass$5 = {
  center: 'textAlignCenter',
  left: 'textAlignLeft',
  right: 'textAlignRight'
};
var Display = function Display(_a) {
  var Element = _a.element,
      _b = _a.variant,
      variant = _b === void 0 ? 'display1' : _b,
      _c = _a.color,
      color = _c === void 0 ? 'primary-dark' : _c,
      _d = _a.textAlign,
      textAlign = _d === void 0 ? 'left' : _d,
      className = _a.className,
      _e = _a.textTransform,
      textTransform = _e === void 0 ? 'normal' : _e,
      _f = _a.wordBreak,
      wordBreak = _f === void 0 ? 'none' : _f,
      _g = _a.maxLinesEllipsis,
      maxLinesEllipsis = _g === void 0 ? 0 : _g,
      strikethrough = _a.strikethrough,
      props = __rest(_a, ["element", "variant", "color", "textAlign", "className", "textTransform", "wordBreak", "maxLinesEllipsis", "strikethrough"]);

  var width = getViewportWidth();
  var isWidthLessthanMediumDevicewidth = width <= designTokens_3.mqSmallScreenMaxWidthLimit;
  var dynamicVariantClassName = isWidthLessthanMediumDevicewidth ? typographyStyles.displayDisplay5 : typographyStyles.displayDisplay3;
  return /*#__PURE__*/createElement(Element, __assign({
    style: {
      WebkitLineClamp: maxLinesEllipsis
    },
    className: joinClasses(styles$N.display, styles$N["display--color-" + color], variant === 'display1' ? typographyStyles.displayDisplay1 : '', variant === 'display2' ? typographyStyles.displayDisplay2 : '', variant === 'display3' ? typographyStyles.displayDisplay3 : '', variant === 'display4' ? typographyStyles.displayDisplay4 : '', variant === 'display5' ? typographyStyles.displayDisplay5 : '', variant === 'dynamic' ? dynamicVariantClassName : '', variant === 'display1-ER' ? typographyStyles.displayDisplay1Er : '', textAlignStyles[alignmentClass$5[textAlign]], textTransformStyles["text-transform-" + textTransform], addWordBreak(wordBreak === 'break-word'), strikethrough && typographyStyles.strikethrough, className)
  }, props));
};
Display.displayName = 'CoreDisplay';

var styles$O = {"header-overlay":"fr-ec-header-overlay","headerOverlay":"fr-ec-header-overlay","header-overlay__title":"fr-ec-header-overlay__title","headerOverlayTitle":"fr-ec-header-overlay__title","header-overlay__item-count":"fr-ec-header-overlay__item-count","headerOverlayItemCount":"fr-ec-header-overlay__item-count","header-overlay__sub-title":"fr-ec-header-overlay__sub-title","headerOverlaySubTitle":"fr-ec-header-overlay__sub-title","header-overlay__error":"fr-ec-header-overlay__error","headerOverlayError":"fr-ec-header-overlay__error","header-overlay__button":"fr-ec-header-overlay__button","headerOverlayButton":"fr-ec-header-overlay__button","header-overlay--hide":"fr-ec-header-overlay--hide","headerOverlayHide":"fr-ec-header-overlay--hide","header-overlay--display":"fr-ec-header-overlay--display","headerOverlayDisplay":"fr-ec-header-overlay--display"};

var HeaderOverlay = /*#__PURE__*/forwardRef(function (_a, ref) {
  var errors = _a.errors,
      title = _a.title,
      titleId = _a.titleId,
      subtitle = _a.subtitle,
      subtitleExtra = _a.subtitleExtra,
      closeLabel = _a.closeLabel,
      closeTitle = _a.closeTitle,
      onRequestClose = _a.onRequestClose,
      hideKeyline = _a.hideKeyline,
      _b = _a.labelElement,
      labelElement = _b === void 0 ? 'h5' : _b,
      _c = _a.isModal,
      isModal = _c === void 0 ? false : _c,
      className = _a.className,
      itemCount = _a.itemCount,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["errors", "title", "titleId", "subtitle", "subtitleExtra", "closeLabel", "closeTitle", "onRequestClose", "hideKeyline", "labelElement", "isModal", "className", "itemCount", "iconBrand"]);

  var isKeyboardOpenState;
  var isAndroidMobile;

  if (isInBrowser$1()) {
    isKeyboardOpenState = isKeyboardOpen();
    isAndroidMobile = getOS() === 'android' && getCurrentMediaQueryBreakpoint() === 'sm';
  }

  return /*#__PURE__*/createElement("header", __assign({
    className: joinClasses(styles$O.headerOverlay, isAndroidMobile && isModal ? isKeyboardOpenState !== true || isKeyboardOpenState === undefined ? styles$O.headerOverlayDisplay : styles$O.headerOverlayHide : '', !hideKeyline && keylineStyles.keylineBottom, className),
    ref: ref
  }, props), /*#__PURE__*/createElement("div", {
    id: titleId
  }, /*#__PURE__*/createElement("div", {
    className: styles$O.headerOverlayTitle
  }, /*#__PURE__*/createElement(Display, {
    element: labelElement,
    variant: "display4"
  }, title), itemCount && /*#__PURE__*/createElement(Body, {
    element: "span",
    variant: "standard",
    className: styles$O.headerOverlayItemCount
  }, itemCount)), subtitle && /*#__PURE__*/createElement("div", {
    className: styles$O.headerOverlaySubTitle
  }, /*#__PURE__*/createElement(Label, {
    element: "span",
    variant: "standard"
  }, subtitle, ' '), /*#__PURE__*/createElement(Caption, {
    element: "span"
  }, subtitleExtra)), errors && Array.isArray(errors) && errors.length > 0 && errors.map(function (error) {
    return error && /*#__PURE__*/createElement(Caption, {
      key: error,
      className: styles$O.headerOverlayError,
      element: "p",
      variant: "standard",
      color: "error"
    }, error);
  })), onRequestClose && closeLabel && /*#__PURE__*/createElement(ButtonIcon, {
    element: "button",
    icon: "close-big",
    label: closeLabel,
    title: closeTitle || closeLabel,
    variant: "dark",
    onClick: onRequestClose,
    className: styles$O.headerOverlayButton,
    iconBrand: iconBrand
  }));
});
HeaderOverlay.displayName = 'CoreHeaderOverlay';
HeaderOverlay.defaultProps = {
  hideKeyline: false,
  labelElement: 'h5'
};

var styles$P = {"keyline":"fr-ec-keyline"};

var Keyline = function Keyline(_a) {
  var className = _a.className;
  return /*#__PURE__*/createElement("hr", {
    className: joinClasses(styles$P.keyline, keylineStyles.keylineBottom, className)
  });
};
Keyline.displayName = 'CoreKeyline';

var styles$Q = {"overlay-backdrop":"fr-ec-overlay-backdrop","overlayBackdrop":"fr-ec-overlay-backdrop","overlayEase":"fr-ec-overlayEase","overlay-wrapper":"fr-ec-overlay-wrapper","overlayWrapper":"fr-ec-overlay-wrapper"};

var OverlayBackdrop = /*#__PURE__*/forwardRef(function (_a, ref) {
  var className = _a.className,
      props = __rest(_a, ["className"]);

  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$Q.overlayBackdrop, className)
  }, props, {
    ref: ref
  }));
});
OverlayBackdrop.displayName = 'CoreOverlayBackdrop';

var styles$R = {"pinned-container":"fr-ec-pinned-container","pinnedContainer":"fr-ec-pinned-container","pinned-container--top":"fr-ec-pinned-container--top","pinnedContainerTop":"fr-ec-pinned-container--top","pinned-container--end":"fr-ec-pinned-container--end","pinnedContainerEnd":"fr-ec-pinned-container--end","pinned-container--bottom":"fr-ec-pinned-container--bottom","pinnedContainerBottom":"fr-ec-pinned-container--bottom","pinned-container--start":"fr-ec-pinned-container--start","pinnedContainerStart":"fr-ec-pinned-container--start","pinned-container--top-sm":"fr-ec-pinned-container--top-sm","pinnedContainerTopSm":"fr-ec-pinned-container--top-sm","pinned-container--end-sm":"fr-ec-pinned-container--end-sm","pinnedContainerEndSm":"fr-ec-pinned-container--end-sm","pinned-container--bottom-sm":"fr-ec-pinned-container--bottom-sm","pinnedContainerBottomSm":"fr-ec-pinned-container--bottom-sm","pinned-container--start-sm":"fr-ec-pinned-container--start-sm","pinnedContainerStartSm":"fr-ec-pinned-container--start-sm","pinned-container--top-md":"fr-ec-pinned-container--top-md","pinnedContainerTopMd":"fr-ec-pinned-container--top-md","pinned-container--end-md":"fr-ec-pinned-container--end-md","pinnedContainerEndMd":"fr-ec-pinned-container--end-md","pinned-container--bottom-md":"fr-ec-pinned-container--bottom-md","pinnedContainerBottomMd":"fr-ec-pinned-container--bottom-md","pinned-container--start-md":"fr-ec-pinned-container--start-md","pinnedContainerStartMd":"fr-ec-pinned-container--start-md","pinned-container--top-lg":"fr-ec-pinned-container--top-lg","pinnedContainerTopLg":"fr-ec-pinned-container--top-lg","pinned-container--end-lg":"fr-ec-pinned-container--end-lg","pinnedContainerEndLg":"fr-ec-pinned-container--end-lg","pinned-container--bottom-lg":"fr-ec-pinned-container--bottom-lg","pinnedContainerBottomLg":"fr-ec-pinned-container--bottom-lg","pinned-container--start-lg":"fr-ec-pinned-container--start-lg","pinnedContainerStartLg":"fr-ec-pinned-container--start-lg"};

var getPositionClasses = function getPositionClasses(positionProp) {
  if (_typeof(positionProp) === 'object') {
    return joinClasses.apply(void 0, Object.keys(positionProp).reduce(function (acc, size) {
      var positionClassName = styles$R["pinned-container--" + positionProp[size] + "-" + size];
      return __spreadArrays(acc, [positionClassName]);
    }, []));
  }

  return styles$R["pinned-container--" + positionProp];
};

var PinnedContainerComponent = function PinnedContainerComponent(_a) {
  var _b = _a.element,
      Element = _b === void 0 ? 'div' : _b,
      position = _a.position,
      className = _a.className,
      props = __rest(_a, ["element", "position", "visible", "className"]);

  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign({
      className: joinClasses(styles$R.pinnedContainer, className, getPositionClasses(position))
    }, props))
  );
};

PinnedContainerComponent.displayName = 'CorePinnedContainer';
PinnedContainerComponent.defaultProps = {
  element: 'div'
};
var PinnedContainer = withVisibility(PinnedContainerComponent);

var styles$S = {"drawer":"fr-ec-drawer","drawer__body":"fr-ec-drawer__body","drawerBody":"fr-ec-drawer__body","drawer__content":"fr-ec-drawer__content","drawerContent":"fr-ec-drawer__content","drawer__footer":"fr-ec-drawer__footer","drawerFooter":"fr-ec-drawer__footer","drawer--start":"fr-ec-drawer--start","drawerStart":"fr-ec-drawer--start","drawer--end":"fr-ec-drawer--end","drawerEnd":"fr-ec-drawer--end","drawer--open":"fr-ec-drawer--open","drawerOpen":"fr-ec-drawer--open","drawer--full-width":"fr-ec-drawer--full-width","drawerFullWidth":"fr-ec-drawer--full-width","drawer--close":"fr-ec-drawer--close","drawerClose":"fr-ec-drawer--close","slideInFromLeft":"fr-ec-slideInFromLeft"};

var Drawer =
/** @class */
function (_super) {
  __extends(Drawer, _super);

  function Drawer(props) {
    var _this = _super.call(this, props) || this;

    _this.currentPosition = 0;

    _this.componentWillUnmount = function () {
      if (isInBrowser$1()) {
        _this.handleRemoveEventListeners();
      }

      if (!_this.props.backgroundScroll) {
        _this.scrollRemoval(false);
      }
    };

    _this.handleAddEventListeners = function () {
      document.addEventListener('keydown', _this.handleKeydown);
    };

    _this.handleRemoveEventListeners = function () {
      document.removeEventListener('keydown', _this.handleKeydown);
    };

    _this.handleKeydown = function (event) {
      if (event.keyCode === 27) {
        if (typeof _this.props.onBackdropClick === 'function') {
          _this.props.onBackdropClick(event);
        } else {
          _this.handleCloseDrawer(event);
        }
      }
    };

    _this.handleSwipe = function (_a) {
      var event = _a.event;
      var isOpen = _this.props.isOpen;

      if (isOpen) {
        _this.handleCloseDrawer(event);
      }
    };

    _this.handleBackdropClick = function (event) {
      if (event.target === event.currentTarget) {
        _this.setState({
          isClosing: true
        }, function () {
          setTimeout(function () {
            if (typeof _this.props.onBackdropClick === 'function') {
              _this.props.onBackdropClick(event);
            } else {
              _this.handleCloseDrawer(event);
            }
          }, 315);
        });
      } else {
        _this.handleCloseDrawer(event);
      }
    };

    _this.handleCloseDrawer = function (event) {
      _this.handleRemoveEventListeners();

      var _a = _this.props,
          onRequestClose = _a.onRequestClose,
          backgroundScroll = _a.backgroundScroll;

      if (!backgroundScroll) {
        _this.scrollRemoval(false);
      }

      _this.setState({
        isClosing: true
      }, function () {
        return setTimeout(function () {
          return onRequestClose(event);
        }, 315);
      });
    };

    _this.handleFallbackFocus = function () {
      var element = document.activeElement;
      return element;
    };

    _this.scrollRemoval = function (disable) {
      if (isInBrowser$1()) {
        if (typeof document === 'undefined') {
          return;
        }

        var docElement = document.querySelector(_this.props.scrollDisableElement || 'body');

        if (disable) {
          _this.currentPosition = window.pageYOffset;
          docElement.classList.add(interactionsStyles.scrollDisabled);
          docElement.style.top = -_this.currentPosition + "px";
        } else {
          docElement.classList.remove(interactionsStyles.scrollDisabled);
          docElement.style.top = '';
          window.scrollTo(0, _this.currentPosition);
        }
      }
    };

    _this.state = {
      isClosing: false
    };
    return _this;
  }

  Drawer.prototype.componentDidMount = function () {
    var _a = this.props,
        isOpen = _a.isOpen,
        backgroundScroll = _a.backgroundScroll;

    if (isOpen && isInBrowser$1()) {
      this.handleAddEventListeners();

      if (!backgroundScroll) {
        this.scrollRemoval(true);
      }
    }
  };

  Drawer.prototype.componentDidUpdate = function (prevProps) {
    var _a = this.props,
        isOpen = _a.isOpen,
        backgroundScroll = _a.backgroundScroll;

    if (isInBrowser$1()) {
      if (isOpen && !prevProps.isOpen) {
        this.handleAddEventListeners();

        if (!backgroundScroll) {
          this.scrollRemoval(true);
        }
      } else if (!isOpen && prevProps.isOpen) {
        this.handleRemoveEventListeners();

        if (!backgroundScroll) {
          this.scrollRemoval(false);
        }
      }
    }
  };

  Drawer.prototype.render = function () {
    var _a = this.props,
        isOpen = _a.isOpen,
        children = _a.children,
        title = _a.title,
        subtitle = _a.subtitle,
        subtitleExtra = _a.subtitleExtra,
        closeLabel = _a.closeLabel,
        closeTitle = _a.closeTitle,
        footer = _a.footer,
        _b = _a.titleId,
        titleId = _b === void 0 ? 'drawer-title' : _b,
        _c = _a.trapFocus,
        trapFocus = _c === void 0 ? true : _c,
        _d = _a.visible,
        visible = _d === void 0 ? {
      sm: true,
      md: true,
      lg: false
    } : _d,
        _e = _a.position,
        position = _e === void 0 ? 'start' : _e,
        className = _a.className,
        _f = _a.labelElement,
        labelElement = _f === void 0 ? 'h5' : _f,
        itemCount = _a.itemCount,
        _g = _a.variant,
        variant = _g === void 0 ? 'default' : _g,
        iconBrand = _a.iconBrand,
        props = __rest(_a, ["isOpen", "children", "title", "subtitle", "subtitleExtra", "closeLabel", "closeTitle", "footer", "titleId", "trapFocus", "onRequestClose", "onBackdropClick", "visible", "position", "backgroundScroll", "className", "scrollDisableElement", "labelElement", "itemCount", "variant", "iconBrand"]);

    var drawerStyle = joinClasses(styles$S.drawer, variant === 'fullWidth' && styles$S.drawerFullWidth, styles$S["drawer--" + position], isOpen && styles$S.drawerOpen, variant === 'default' && this.state.isClosing && styles$S.drawerClose, className);
    var swipeHandlers = {
      end: {
        onSwipedRight: this.handleSwipe
      },
      start: {
        onSwipedLeft: this.handleSwipe
      }
    };
    return /*#__PURE__*/createElement(PinnedContainer, {
      element: "div",
      visible: visible,
      position: position
    }, /*#__PURE__*/createElement(Swipeable, __assign({}, swipeHandlers[position]), /*#__PURE__*/createElement(OverlayBackdrop, {
      hidden: !isOpen,
      tabIndex: -1,
      onClick: this.handleBackdropClick
    }), /*#__PURE__*/createElement(FocusTrap, {
      active: trapFocus && isOpen,
      focusTrapOptions: {
        clickOutsideDeactivates: true,
        escapeDeactivates: false,
        fallbackFocus: this.handleFallbackFocus,
        returnFocusOnDeactivate: true
      }
    }, /*#__PURE__*/createElement("nav", __assign({
      className: drawerStyle,
      tabIndex: -1,
      "aria-labelledby": titleId
    }, props), /*#__PURE__*/createElement(HeaderOverlay, {
      title: title,
      subtitle: subtitle,
      subtitleExtra: subtitleExtra,
      closeLabel: closeLabel,
      onRequestClose: this.handleCloseDrawer,
      titleId: titleId,
      closeTitle: closeTitle,
      labelElement: labelElement,
      itemCount: itemCount,
      iconBrand: iconBrand
    }), /*#__PURE__*/createElement("div", {
      className: styles$S.drawerBody
    }, /*#__PURE__*/createElement("div", {
      className: styles$S.drawerContent
    }, children), footer && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Keyline, null), /*#__PURE__*/createElement("div", {
      className: styles$S.drawerFooter
    }, footer)))))));
  };

  Drawer.displayName = 'CoreDrawer';
  Drawer.defaultProps = {
    backgroundScroll: false,
    labelElement: 'h5',
    position: 'start',
    scrollDisableElement: 'body',
    titleId: 'drawer-title',
    trapFocus: true,
    visible: {
      sm: true,
      md: true,
      lg: false
    }
  };
  return Drawer;
}(Component);

var styles$T = {"expand-utility__alpha-gradient":"fr-ec-expand-utility__alpha-gradient","expandUtilityAlphaGradient":"fr-ec-expand-utility__alpha-gradient","expand-utility__alpha-gradient-overlay":"fr-ec-expand-utility__alpha-gradient-overlay","expandUtilityAlphaGradientOverlay":"fr-ec-expand-utility__alpha-gradient-overlay"};

var ExpandUtility = function ExpandUtility(_a) {
  var children = _a.children,
      isExpanded = _a.isExpanded,
      _b = _a.collapsedHeight,
      collapsedHeight = _b === void 0 ? 0 : _b,
      className = _a.className,
      _c = _a.alphaGradient,
      alphaGradient = _c === void 0 ? false : _c;
  var height = isExpanded === true ? 'auto' : collapsedHeight;
  return /*#__PURE__*/createElement("div", {
    style: {
      'position': 'relative'
    }
  }, alphaGradient && !isExpanded && /*#__PURE__*/createElement("div", {
    className: styles$T.expandUtilityAlphaGradientOverlay
  }), /*#__PURE__*/createElement(AnimateHeight, {
    className: joinClasses(alphaGradient && styles$T.expandUtilityAlphaGradient, className),
    easing: designTokens_2.animateEaseInOut,
    duration: 400,
    height: height
  }, children));
};
ExpandUtility.displayName = 'CoreExpandUtility';
ExpandUtility.defaultProps = {
  collapsedHeight: 0,
  isExpanded: false
};

var styles$U = {"accordion__heading":"fr-ec-accordion__heading","accordionHeading":"fr-ec-accordion__heading","accordion__control":"fr-ec-accordion__control","accordionControl":"fr-ec-accordion__control","accordion__label":"fr-ec-accordion__label","accordionLabel":"fr-ec-accordion__label","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn","accordion__icon":"fr-ec-accordion__icon","accordionIcon":"fr-ec-accordion__icon","accordion__label-main":"fr-ec-accordion__label-main","accordionLabelMain":"fr-ec-accordion__label-main","accordion__label-children":"fr-ec-accordion__label-children","accordionLabelChildren":"fr-ec-accordion__label-children","accordion--variant-large":"fr-ec-accordion--variant-large","accordionVariantLarge":"fr-ec-accordion--variant-large","accordion--variant-small":"fr-ec-accordion--variant-small","accordionVariantSmall":"fr-ec-accordion--variant-small","accordion--variant-dynamic":"fr-ec-accordion--variant-dynamic","accordionVariantDynamic":"fr-ec-accordion--variant-dynamic","accordion__expand-close-icon":"fr-ec-accordion__expand-close-icon","accordionExpandCloseIcon":"fr-ec-accordion__expand-close-icon","accordion__content--large":"fr-ec-accordion__content--large","accordionContentLarge":"fr-ec-accordion__content--large"};

var variantStyles = {
  dynamic: styles$U.accordionVariantDynamic,
  large: styles$U.accordionVariantLarge,
  small: styles$U.accordionVariantSmall
};

var Accordion =
/** @class */
function (_super) {
  __extends(Accordion, _super);

  function Accordion(props) {
    var _this = _super.call(this, props) || this;

    _this.onClick = function (event) {
      var _a = _this.props,
          expanded = _a.expanded,
          onExpand = _a.onExpand,
          onClose = _a.onClose,
          gaCallback = _a.gaCallback,
          gaLabel = _a.gaLabel;

      if (gaCallback) {
        gaCallback(event.currentTarget, gaLabel);
      }

      if (expanded || _this.state.isExpanded) {
        if (onClose !== undefined) {
          onClose(event);
        }
      } else {
        if (onExpand !== undefined) {
          onExpand(event);
        }
      }

      if (expanded === undefined) {
        _this.setState({
          isExpanded: !_this.state.isExpanded
        });
      }
    };

    _this.state = {
      isExpanded: _this.props.defaultExpanded || false
    };
    return _this;
  }

  Accordion.prototype.render = function () {
    var _a = this.props,
        disabled = _a.disabled,
        Element = _a.element,
        _b = _a.variant,
        variant = _b === void 0 ? 'large' : _b,
        LabelElement = _a.labelElement,
        icon = _a.icon,
        label = _a.label,
        labelChildren = _a.labelChildren,
        expanded = _a.expanded,
        children = _a.children,
        id = _a.id,
        className = _a.className,
        ariaLabel = _a.ariaLabel,
        _c = _a.gaAction,
        gaAction = _c === void 0 ? 'click' : _c,
        _d = _a.gaCategory,
        gaCategory = _d === void 0 ? '' : _d,
        _e = _a.gaLabel,
        gaLabel = _e === void 0 ? '' : _e,
        _f = _a.gaValue,
        gaValue = _f === void 0 ? '' : _f,
        iconBrand = _a.iconBrand,
        props = __rest(_a, ["disabled", "element", "variant", "labelElement", "icon", "label", "labelChildren", "expanded", "children", "id", "className", "ariaLabel", "gaAction", "gaCategory", "gaLabel", "gaValue", "iconBrand"]);

    var gaProps = null;

    if (gaCategory && gaAction && gaLabel) {
      gaProps = {
        'data-action': gaAction,
        'data-category': gaCategory,
        'data-label': gaLabel
      };

      if (gaValue) {
        gaProps['data-value'] = gaValue;
      }
    }

    var isExpanded = expanded === undefined ? this.state.isExpanded : expanded;
    var expandCloseIcon = isExpanded ? iconBrand ? iconBrand + "minus" : 'minus' : iconBrand ? iconBrand + "plus" : 'plus';
    return /*#__PURE__*/createElement(Element, __assign({
      className: joinClasses(className, Element === 'fieldset' && resetStyles.fieldsetReset)
    }, gaProps, props), /*#__PURE__*/createElement(LabelElement, {
      className: joinClasses(styles$U.accordionHeading, variantStyles[variant])
    }, /*#__PURE__*/createElement("button", {
      className: joinClasses(styles$U.accordionControl, interactionsStyles.cursorPointer),
      disabled: disabled,
      id: id,
      "aria-expanded": isExpanded,
      "aria-controls": id + "-content",
      onClick: this.onClick,
      "aria-label": ariaLabel || undefined
    }, /*#__PURE__*/createElement("div", {
      className: styles$U.accordionLabel
    }, icon ? /*#__PURE__*/createElement(Icon, {
      className: styles$U.accordionIcon,
      name: iconBrand ? "" + iconBrand + icon : icon
    }) : '', /*#__PURE__*/createElement(Body, {
      element: "span",
      variant: isExpanded ? 'standard-emphasized' : 'standard',
      className: styles$U.accordionLabelMain
    }, label), labelChildren && /*#__PURE__*/createElement(Body, {
      element: "span",
      className: styles$U.accordionLabelChildren
    }, labelChildren)), /*#__PURE__*/createElement(Icon, {
      name: expandCloseIcon,
      className: styles$U.accordionExpandCloseIcon
    }))), /*#__PURE__*/createElement(ExpandUtility, {
      isExpanded: isExpanded,
      "aria-hidden": !isExpanded
    }, /*#__PURE__*/createElement("div", {
      id: id + "-content",
      className: styles$U["accordion__content--" + variant]
    }, children)));
  };

  Accordion.displayName = 'CoreAccordion';
  Accordion.defaultProps = {
    disabled: false,
    variant: 'large'
  };
  return Accordion;
}(Component);

var styles$V = {"flag-text":"fr-ec-flag-text","flagText":"fr-ec-flag-text","flag-text--color-secondary":"fr-ec-flag-text--color-secondary","flagTextColorSecondary":"fr-ec-flag-text--color-secondary","flag-text--color-promotional":"fr-ec-flag-text--color-promotional","flagTextColorPromotional":"fr-ec-flag-text--color-promotional","flag-text--color-placeholder":"fr-ec-flag-text--color-placeholder","flagTextColorPlaceholder":"fr-ec-flag-text--color-placeholder","flag-text--color-primary-dark":"fr-ec-flag-text--color-primary-dark","flagTextColorPrimaryDark":"fr-ec-flag-text--color-primary-dark","flag-text--color-primary-light":"fr-ec-flag-text--color-primary-light","flagTextColorPrimaryLight":"fr-ec-flag-text--color-primary-light"};

var alignmentClass$6 = {
  center: 'textAlignCenter',
  left: 'textAlignLeft',
  right: 'textAlignRight'
};
var FlagText = function FlagText(_a) {
  var Element = _a.element,
      className = _a.className,
      _b = _a.variant,
      variant = _b === void 0 ? 'standard' : _b,
      _c = _a.textAlign,
      textAlign = _c === void 0 ? 'left' : _c,
      _d = _a.color,
      color = _d === void 0 ? 'secondary' : _d,
      _e = _a.textTransform,
      textTransform = _e === void 0 ? 'normal' : _e,
      _f = _a.wordBreak,
      wordBreak = _f === void 0 ? 'none' : _f,
      strikethrough = _a.strikethrough,
      props = __rest(_a, ["element", "className", "variant", "textAlign", "color", "textTransform", "wordBreak", "strikethrough"]);

  return /*#__PURE__*/createElement(Element, __assign({
    className: joinClasses(styles$V.flagText, typographyStyles["flag--" + variant], textAlignStyles[alignmentClass$6[textAlign]], color && styles$V["flag-text--color-" + color], textTransformStyles["text-transform-" + textTransform], addWordBreak(wordBreak === 'break-word'), strikethrough && typographyStyles.strikethrough, className)
  }, props));
};
FlagText.displayName = 'CoreFlagText';

var styles$W = {"ticker":"fr-ec-ticker","ticker--attention":"fr-ec-ticker--attention","tickerAttention":"fr-ec-ticker--attention","ticker__body--attention":"fr-ec-ticker__body--attention","tickerBodyAttention":"fr-ec-ticker__body--attention","ticker__body":"fr-ec-ticker__body","tickerBody":"fr-ec-ticker__body","ticker__body--primary":"fr-ec-ticker__body--primary","tickerBodyPrimary":"fr-ec-ticker__body--primary","ticker__button":"fr-ec-ticker__button","tickerButton":"fr-ec-ticker__button"};

var Ticker = function Ticker(_a) {
  var variant = _a.variant,
      children = _a.children,
      onDismiss = _a.onDismiss,
      closeButton = _a.closeButton,
      _b = _a.gaAction,
      gaAction = _b === void 0 ? 'click' : _b,
      _c = _a.gaCategory,
      gaCategory = _c === void 0 ? '' : _c,
      _d = _a.gaLabel,
      gaLabel = _d === void 0 ? '' : _d,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      className = _a.className,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["variant", "children", "onDismiss", "closeButton", "gaAction", "gaCategory", "gaLabel", "gaValue", "gaCallback", "className", "iconBrand"]);

  var role = 'status';
  var tickerAttentionClass = '';

  if (variant === 'attention') {
    role = 'alert';
    tickerAttentionClass = styles$W.tickerAttention;
  }

  var gaProps = null;

  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };

    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }

  var onClickHandler = function onClickHandler(e) {
    // For callback
    if (onDismiss) {
      onDismiss(e);
    } // For event tracking


    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    }
  };

  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$W.ticker, tickerAttentionClass, className)
  }, gaProps, props), /*#__PURE__*/createElement(Caption, {
    element: "p",
    className: joinClasses(styles$W.tickerBody, styles$W["ticker__body--" + variant], resetStyles.maxWidthReset),
    role: role
  }, children), closeButton && /*#__PURE__*/createElement(ButtonIcon, {
    element: "button",
    icon: "close",
    label: "Dismiss",
    variant: variant === 'attention' ? 'light' : 'dark',
    hideLabel: true,
    onClick: onClickHandler,
    className: styles$W.tickerButton,
    iconBrand: iconBrand
  }));
};
Ticker.displayName = 'CoreTicker';
Ticker.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var styles$X = {"layout-wrapper":"fr-ec-layout-wrapper","layoutWrapper":"fr-ec-layout-wrapper"};

var LayoutWrapper = function LayoutWrapper(_a) {
  var Element = _a.element,
      className = _a.className,
      props = __rest(_a, ["element", "className"]);

  return /*#__PURE__*/createElement(Element, __assign({
    className: joinClasses(styles$X.layoutWrapper, className)
  }, props));
};
LayoutWrapper.displayName = 'CoreLayoutWrapper';

var styles$Y = {"flyout":"fr-ec-flyout","flyout__column-layout":"fr-ec-flyout__column-layout","flyoutColumnLayout":"fr-ec-flyout__column-layout","flyout__collection-list":"fr-ec-flyout__collection-list","flyoutCollectionList":"fr-ec-flyout__collection-list","collection-list__item":"fr-ec-collection-list__item","collectionListItem":"fr-ec-collection-list__item","link-navigation":"fr-ec-link-navigation","linkNavigation":"fr-ec-link-navigation"};

var Flyout = function Flyout(_a) {
  var _b = _a.element,
      Element = _b === void 0 ? 'div' : _b,
      _c = _a.colSpan,
      colSpan = _c === void 0 ? {
    md: 4,
    lg: 4
  } : _c,
      children = _a.children,
      className = _a.className,
      props = __rest(_a, ["element", "colSpan", "children", "className"]);

  var layoutColSpan = __assign(__assign({}, colSpan), {
    sm: 4
  });

  var width = getViewportWidth();
  return /*#__PURE__*/createElement(LayoutWrapper, {
    element: "section",
    className: styles$Y.flyout
  }, /*#__PURE__*/createElement(Layout, __assign({
    element: Element,
    colSpan: layoutColSpan,
    className: joinClasses(styles$Y.flyoutColumnLayout, className)
  }, props), /*#__PURE__*/createElement(CollectionList, {
    spacing: "16",
    keylines: width < designTokens_3.mqLargeScreenMinWidthLimit ? 'top' : 'none',
    className: styles$Y.flyoutCollectionList
  }, children)));
};
Flyout.displayName = 'CoreFlyout';
Flyout.defaultProps = {
  colSpan: {
    md: 4,
    lg: 4
  },
  element: 'div'
};

var styles$Z = {"link-navigation-group__list":"fr-ec-link-navigation-group__list","linkNavigationGroupList":"fr-ec-link-navigation-group__list","link-navigation-group__list--horizontal":"fr-ec-link-navigation-group__list--horizontal","linkNavigationGroupListHorizontal":"fr-ec-link-navigation-group__list--horizontal","link-navigation-group__list--indented":"fr-ec-link-navigation-group__list--indented","linkNavigationGroupListIndented":"fr-ec-link-navigation-group__list--indented","link-navigation-group__item--vertical":"fr-ec-link-navigation-group__item--vertical","linkNavigationGroupItemVertical":"fr-ec-link-navigation-group__item--vertical","link-navigation-group__item--vertical-large":"fr-ec-link-navigation-group__item--vertical-large","linkNavigationGroupItemVerticalLarge":"fr-ec-link-navigation-group__item--vertical-large","link-navigation-group__legend-vertical":"fr-ec-link-navigation-group__legend-vertical","linkNavigationGroupLegendVertical":"fr-ec-link-navigation-group__legend-vertical","link-navigation-group__legend-vertical-large":"fr-ec-link-navigation-group__legend-vertical-large","linkNavigationGroupLegendVerticalLarge":"fr-ec-link-navigation-group__legend-vertical-large","link-navigation-group__legend-dynamic":"fr-ec-link-navigation-group__legend-dynamic","linkNavigationGroupLegendDynamic":"fr-ec-link-navigation-group__legend-dynamic","link-navigation-group__legend-horizontal":"fr-ec-link-navigation-group__legend-horizontal","linkNavigationGroupLegendHorizontal":"fr-ec-link-navigation-group__legend-horizontal","link-navigation-group__item--horizontal":"fr-ec-link-navigation-group__item--horizontal","linkNavigationGroupItemHorizontal":"fr-ec-link-navigation-group__item--horizontal","link-navigation-group__list--horizontal-small":"fr-ec-link-navigation-group__list--horizontal-small","linkNavigationGroupListHorizontalSmall":"fr-ec-link-navigation-group__list--horizontal-small","link-navigation-group__item--dynamic":"fr-ec-link-navigation-group__item--dynamic","linkNavigationGroupItemDynamic":"fr-ec-link-navigation-group__item--dynamic","link-navigation-group__list--dynamic":"fr-ec-link-navigation-group__list--dynamic","linkNavigationGroupListDynamic":"fr-ec-link-navigation-group__list--dynamic"};

var LinkNavigationGroup = function LinkNavigationGroup(_a) {
  var children = _a.children,
      legend = _a.legend,
      indented = _a.indented,
      _b = _a.variant,
      variant = _b === void 0 ? 'vertical' : _b,
      className = _a.className,
      labelId = _a.labelId,
      props = __rest(_a, ["children", "legend", "indented", "variant", "className", "labelId"]);

  return /*#__PURE__*/createElement(Fragment, null, legend && /*#__PURE__*/createElement(Title, {
    element: "h5",
    variant: "large",
    id: labelId,
    className: styles$Z["link-navigation-group__legend-" + variant]
  }, legend), /*#__PURE__*/createElement("ul", __assign({
    className: joinClasses(styles$Z.linkNavigationGroupList, (variant === 'vertical' || variant === 'vertical-large') && indented && styles$Z.linkNavigationGroupListIndented, styles$Z["link-navigation-group__list--" + variant], className)
  }, legend && {
    'aria-labelledby': labelId
  }, props), Children.map(children, function (child, i) {
    var variantType = variant === 'vertical-large' ? 'TitleStandard' : 'TitleSmall';
    return /*#__PURE__*/createElement("li", {
      key: child.key || i,
      className: joinClasses(styles$Z["link-navigation-group__item--" + variant])
    }, /*#__PURE__*/cloneElement(child, {
      variant: variantType
    }));
  })));
};
LinkNavigationGroup.displayName = 'CoreLinkNavigationGroup';
LinkNavigationGroup.defaultProps = {
  indented: false
};

var styles$_ = {"footer":"fr-ec-footer","footer--copyrights-only-border":"fr-ec-footer--copyrights-only-border","footerCopyrightsOnlyBorder":"fr-ec-footer--copyrights-only-border","footer--default":"fr-ec-footer--default","footerDefault":"fr-ec-footer--default","keyline":"fr-ec-keyline","footer-margin-bottom":"fr-ec-footer-margin-bottom","footerMarginBottom":"fr-ec-footer-margin-bottom","footer--content-wrapper":"fr-ec-footer--content-wrapper","footerContentWrapper":"fr-ec-footer--content-wrapper","brand-title":"fr-ec-brand-title","brandTitle":"fr-ec-brand-title","footer-brand--container":"fr-ec-footer-brand--container","footerBrandContainer":"fr-ec-footer-brand--container","caption":"fr-ec-caption","footer--contents":"fr-ec-footer--contents","footerContents":"fr-ec-footer--contents","footer-copyrights-text":"fr-ec-footer-copyrights-text","footerCopyrightsText":"fr-ec-footer--copyrights-text","collection-list-horizontal__item":"fr-ec-collection-list-horizontal__item","collectionListHorizontalItem":"fr-ec-collection-list-horizontal__item","footer__right-aligned":"fr-ec-footer__right-aligned","footerRightAligned":"fr-ec-footer__right-aligned","footer--copy-right-contents":"fr-ec-footer--copy-right-contents","footerCopyRightContents":"fr-ec-footer--copy-right-contents","footer--copyrights-text":"fr-ec-footer--copyrights-text","footer-legal-with-language-container":"fr-ec-footer-legal-with-language-container","footerLegalWithLanguageContainer":"fr-ec-footer-legal-with-language-container","link-navigation-group__item--horizontal":"fr-ec-link-navigation-group__item--horizontal","linkNavigationGroupItemHorizontal":"fr-ec-link-navigation-group__item--horizontal","link-navigation":"fr-ec-link-navigation","linkNavigation":"fr-ec-link-navigation","footer--language-container":"fr-ec-footer--language-container","footerLanguageContainer":"fr-ec-footer--language-container","overlay-backdrop":"fr-ec-overlay-backdrop","overlayBackdrop":"fr-ec-overlay-backdrop","footer-sns-container":"fr-ec-footer-sns-container","footerSnsContainer":"fr-ec-footer-sns-container","footer--flex-content-wrapper":"fr-ec-footer--flex-content-wrapper","footerFlexContentWrapper":"fr-ec-footer--flex-content-wrapper","footer--key-line":"fr-ec-footer--key-line","footerKeyLine":"fr-ec-footer--key-line"};

var renderFooterContainer = function renderFooterContainer(copyrightRow, isMedium, footerSNSContainer) {
  var copyrightRowType = _typeof(copyrightRow);

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LayoutWrapper, {
    element: "div"
  }, /*#__PURE__*/React__default.createElement(Layout, {
    gutter: {
      sm: true,
      md: false,
      lg: true
    }
  }, /*#__PURE__*/React__default.createElement(ContentAlignment, {
    alignment: "center",
    direction: "row",
    element: "div",
    justifyContent: "space-between",
    className: styles$_.footerCopyRightContents
  }, !Array.isArray(copyrightRow) && copyrightRowType !== 'string' && copyrightRow, Array.isArray(copyrightRow) && /*#__PURE__*/React__default.createElement(ContentAlignment, {
    element: "ul",
    direction: "row",
    className: styles$_.footerCopyrightsText
  }, copyrightRow.map(function (item) {
    return /*#__PURE__*/React__default.createElement("li", {
      key: item
    }, /*#__PURE__*/React__default.createElement(Caption, {
      color: "secondary",
      element: "span"
    }, item));
  })), copyrightRowType === 'string' && /*#__PURE__*/React__default.createElement(CollectionListHorizontal, {
    divider: true,
    spacingValue: "16",
    className: styles$_.footerCopyrightsText
  }, /*#__PURE__*/React__default.createElement(Caption, {
    variant: "standard",
    color: "secondary",
    element: "span"
  }, copyrightRow)), footerSNSContainer && /*#__PURE__*/React__default.createElement(ContentAlignment, {
    direction: "row",
    justifyContent: "flex-end",
    element: "div",
    className: styles$_.footerSnsContainer
  }, footerSNSContainer)))));
};

var Footer = function Footer(_a) {
  var _b = _a.element,
      Element = _b === void 0 ? 'footer' : _b,
      footerLinksContainer = _a.footerLinksContainer,
      footerBrandsContainer = _a.footerBrandsContainer,
      footerItemsContainer = _a.footerItemsContainer,
      footerLegalContainer = _a.footerLegalContainer,
      footerSNSContainer = _a.footerSNSContainer,
      languageContainer = _a.languageContainer,
      copyrightRow = _a.copyrightRow,
      className = _a.className,
      marginBottom = _a.marginBottom,
      props = __rest(_a, ["element", "footerLinksContainer", "footerBrandsContainer", "footerItemsContainer", "footerLegalContainer", "footerSNSContainer", "languageContainer", "copyrightRow", "className", "marginBottom"]);

  var _c = useState(false),
      isMedium = _c[0];

  var renderlanguageContainer = function renderlanguageContainer(footerLanguageContainer) {
    var languageContainerId = useId('Footer');
    return footerLanguageContainer ? /*#__PURE__*/React__default.createElement(LinkNavigationGroup, {
      className: joinClasses(styles$_.footerLanguageContainer, footerLegalContainer ? styles$_.footerLegalWithLanguageContainer : ''),
      labelId: languageContainerId,
      variant: "horizontal",
      children: footerLanguageContainer
    }) : undefined;
  };

  var isFirstContentsPresent = footerBrandsContainer || footerItemsContainer || footerLegalContainer;
  var copyrightRowOnly = !(footerLinksContainer || languageContainer || isFirstContentsPresent);
  return /*#__PURE__*/React__default.createElement(Element, __assign({
    className: joinClasses(className, styles$_.footer, styles$_.footerDefault, copyrightRowOnly && styles$_.footerCopyrightsOnlyBorder, marginBottom && styles$_.footerMarginBottom)
  }, props), (isFirstContentsPresent || footerLinksContainer || languageContainer) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LayoutWrapper, {
    element: "div"
  }, /*#__PURE__*/React__default.createElement(Layout, {
    gutter: {
      sm: true,
      md: false,
      lg: true
    }
  }, /*#__PURE__*/React__default.createElement(ContentAlignment, {
    alignment: "flex-start",
    direction: "column",
    element: "div",
    justifyContent: "space-between",
    className: styles$_.footerFlexContentWrapper
  }, footerLinksContainer, (isFirstContentsPresent || languageContainer) && /*#__PURE__*/React__default.createElement(ContentAlignment, {
    alignment: "flex-end",
    direction: "row",
    element: "div",
    justifyContent: "space-between",
    className: styles$_.footerContentWrapper
  }, isFirstContentsPresent && /*#__PURE__*/React__default.createElement(ContentAlignment, {
    alignment: "flex-start",
    direction: "column",
    element: "div",
    justifyContent: "space-between",
    className: styles$_.footerContents
  }, footerBrandsContainer, footerItemsContainer, footerLegalContainer), renderlanguageContainer(languageContainer))))), /*#__PURE__*/React__default.createElement(Keyline, {
    className: styles$_.footerKeyLine
  })), renderFooterContainer(copyrightRow, isMedium, footerSNSContainer));
};
Footer.displayName = 'CoreFooter';
Footer.defaultProps = {
  variant: 'default'
};

var styles$$ = {"link-image":"fr-ec-link-image","linkImage":"fr-ec-link-image","link-image--with-image":"fr-ec-link-image--with-image","linkImageWithImage":"fr-ec-link-image--with-image","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn","link-image__image":"fr-ec-link-image__image","linkImageImage":"fr-ec-link-image__image"};

var LinkImage = function LinkImage(_a) {
  var Element = _a.element,
      className = _a.className,
      src = _a.src,
      alt = _a.alt,
      children = _a.children,
      gaCategory = _a.gaCategory,
      gaAction = _a.gaAction,
      gaLabel = _a.gaLabel,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      onClick = _a.onClick,
      props = __rest(_a, ["element", "className", "src", "alt", "children", "gaCategory", "gaAction", "gaLabel", "gaValue", "gaCallback", "onClick"]);

  var gaProps = null;

  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };

    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }

  var handleClick = function handleClick(e) {
    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    }

    if (onClick) {
      onClick(e);
    }
  };

  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign({
      onClick: handleClick,
      className: joinClasses(styles$$.linkImage, src && styles$$.linkImageWithImage, className)
    }, props, gaProps), src && /*#__PURE__*/createElement("img", {
      className: styles$$.linkImageImage,
      src: src,
      alt: alt
    }), children)
  );
};
LinkImage.displayName = 'CoreLinkImage';
LinkImage.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var CmsFooter = function CmsFooter(_a) {
  var facebookUrl = _a.facebookUrl,
      twitterUrl = _a.twitterUrl,
      youtubeUrl = _a.youtubeUrl,
      instagramUrl = _a.instagramUrl,
      tiktokUrl = _a.tiktokUrl,
      lineUrl = _a.lineUrl,
      pinterestUrl = _a.pinterestUrl,
      naverUrl = _a.naverUrl,
      kakaoUrl = _a.kakaoUrl,
      footerLinksContainer = _a.footerLinksContainer,
      footerBrandsContainer = _a.footerBrandsContainer,
      footerItemsContainer = _a.footerItemsContainer,
      copyrightRow = _a.copyrightRow,
      languageContainer = _a.languageContainer,
      footerLegalContainer = _a.footerLegalContainer,
      className = _a.className,
      gaLabel = _a.gaLabel,
      gaCategory = _a.gaCategory,
      gaValue = _a.gaValue,
      gaAction = _a.gaAction,
      gaCallback = _a.gaCallback,
      marginBottom = _a.marginBottom,
      props = __rest(_a, ["facebookUrl", "twitterUrl", "youtubeUrl", "instagramUrl", "tiktokUrl", "lineUrl", "pinterestUrl", "naverUrl", "kakaoUrl", "footerLinksContainer", "footerBrandsContainer", "footerItemsContainer", "copyrightRow", "languageContainer", "footerLegalContainer", "className", "gaLabel", "gaCategory", "gaValue", "gaAction", "gaCallback", "marginBottom"]);

  var socialLinks = [{
    name: 'facebook',
    url: facebookUrl,
    src: 'https://asset.uniqlo.com/g/icons/facebook_v2.svg'
  }, {
    name: 'twitter',
    url: twitterUrl,
    src: 'https://asset.uniqlo.com/g/icons/twitter_v2.svg'
  }, {
    name: 'line',
    url: lineUrl,
    src: 'https://asset.uniqlo.com/g/icons/line_v2.svg'
  }, {
    name: 'instagram',
    url: instagramUrl,
    src: 'https://asset.uniqlo.com/g/icons/instagram_v2.svg'
  }, {
    name: 'youtube',
    url: youtubeUrl,
    src: 'https://asset.uniqlo.com/g/icons/youtube_v2.svg'
  }, {
    name: 'tiktok',
    url: tiktokUrl,
    src: 'https://asset.uniqlo.com/g/icons/tiktok.svg'
  }, {
    name: 'pinterest',
    url: pinterestUrl,
    src: 'https://asset.uniqlo.com/g/icons/pinterest.svg'
  }, {
    name: 'naver',
    url: naverUrl,
    src: 'https://asset.uniqlo.com/g/icons/naver.svg'
  }, {
    name: 'kakao',
    url: kakaoUrl,
    src: 'https://asset.uniqlo.com/g/icons/kakao.svg'
  }];

  var getSocialLinks = function getSocialLinks() {
    var socialLinkElements = socialLinks.filter(function (linkInfo) {
      return linkInfo.url;
    }).map(function (item, index) {
      return /*#__PURE__*/createElement(LinkImage, {
        gaValue: gaValue,
        src: item.src,
        alt: item.name,
        element: "a",
        href: item.url,
        key: item.name + "-" + index,
        gaAction: gaAction,
        gaLabel: gaLabel,
        gaCategory: gaCategory,
        gaCallback: gaCallback
      });
    });
    return /*#__PURE__*/createElement(CollectionListHorizontal, {
      alignment: "center",
      divider: false,
      spacingValue: "8"
    }, socialLinkElements);
  };

  var childFooterLinksContainer = Children.toArray(footerLinksContainer).filter(isValidElement).map(function (child) {
    return /*#__PURE__*/cloneElement(child, {
      variant: 'dynamic'
    });
  }); // @ts-ignore */

  return /*#__PURE__*/createElement(Footer, __assign({
    copyrightRow: copyrightRow,
    footerLinksContainer: childFooterLinksContainer,
    footerBrandsContainer: footerBrandsContainer,
    footerItemsContainer: footerItemsContainer,
    footerSNSContainer: getSocialLinks(),
    languageContainer: languageContainer,
    footerLegalContainer: footerLegalContainer,
    className: className,
    marginBottom: marginBottom
  }, props));
};
CmsFooter.displayName = 'CoreCmsFooter';
CmsFooter.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: 'navi',
  gaLabel: 'SNS_official',
  gaValue: null
};

var styles$10 = {"form-row":"fr-ec-form-row","formRow":"fr-ec-form-row","form-row__margin-bottom-32":"fr-ec-form-row__margin-bottom-32","formRowMarginBottom32":"fr-ec-form-row__margin-bottom-32","form-row__margin-bottom-24":"fr-ec-form-row__margin-bottom-24","formRowMarginBottom24":"fr-ec-form-row__margin-bottom-24","form-row--hint-error-hide-label":"fr-ec-form-row--hint-error-hide-label","formRowHintErrorHideLabel":"fr-ec-form-row--hint-error-hide-label","hint-text":"fr-ec-hint-text","hintText":"fr-ec-hint-text","dropdown__container":"fr-ec-dropdown__container","dropdownContainer":"fr-ec-dropdown__container","form-row--variant-fluid":"fr-ec-form-row--variant-fluid","formRowVariantFluid":"fr-ec-form-row--variant-fluid","form-row__field":"fr-ec-form-row__field","formRowField":"fr-ec-form-row__field","form-row__field--width-3-field":"fr-ec-form-row__field--width-3-field","formRowFieldWidth3Field":"fr-ec-form-row__field--width-3-field","form-row__field--width-2-field":"fr-ec-form-row__field--width-2-field","formRowFieldWidth2Field":"fr-ec-form-row__field--width-2-field","form-row__field--width-1-field":"fr-ec-form-row__field--width-1-field","formRowFieldWidth1Field":"fr-ec-form-row__field--width-1-field","form-row__hint-error":"fr-ec-form-row__hint-error","formRowHintError":"fr-ec-form-row__hint-error","form-row--two-field-small-viewPort-horizontal":"fr-ec-form-row--two-field-small-viewPort-horizontal","formRowTwoFieldSmallViewPortHorizontal":"fr-ec-form-row--two-field-small-viewPort-horizontal","form-row--two-field-small-viewPort-vertical":"fr-ec-form-row--two-field-small-viewPort-vertical","formRowTwoFieldSmallViewPortVertical":"fr-ec-form-row--two-field-small-viewPort-vertical"};

var getChildrens = function getChildrens(items, count) {
  if (items.length === count) {
    return items;
  }

  return items.concat(Array(count - items.length)).fill( /*#__PURE__*/createElement(Fragment, null), items.length, count);
};

var FormRow = function FormRow(_a) {
  var children = _a.children,
      className = _a.className,
      _b = _a.fieldCount,
      fieldCount = _b === void 0 ? 1 : _b,
      _c = _a.fluid,
      fluid = _c === void 0 ? false : _c,
      _d = _a.twoFieldSmallViewport,
      twoFieldSmallViewport = _d === void 0 ? 'horizontal' : _d,
      helptext = _a.helptext,
      error = _a.error,
      _e = _a.marginBottom,
      marginBottom = _e === void 0 ? '32px' : _e,
      props = __rest(_a, ["children", "className", "fieldCount", "fluid", "twoFieldSmallViewport", "helptext", "error", "marginBottom"]);

  var formRowValidChildrens = Children.toArray(children).filter(isValidElement).slice(0, fieldCount);
  var formRowChild = getChildrens(formRowValidChildrens, fieldCount).map(function (child, index) {
    return /*#__PURE__*/createElement("div", {
      key: index,
      className: joinClasses(styles$10.formRowField, !fluid && styles$10["form-row__field--width-" + fieldCount + "-field"])
    }, child);
  });
  var hintErrorFlag = error || helptext ? true : '';
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$10.formRow, fluid ? styles$10.formRowVariantFluid : '', twoFieldSmallViewport === 'horizontal' ? styles$10.formRowTwoFieldSmallViewPortHorizontal : styles$10.formRowTwoFieldSmallViewPortVertical, hintErrorFlag ? styles$10.formRowHintErrorHideLabel : '', marginBottom === '32px' ? styles$10.formRowMarginBottom32 : styles$10.formRowMarginBottom24, className)
  }, props), formRowChild), hintErrorFlag && /*#__PURE__*/createElement(HintError, {
    error: error,
    hint: helptext,
    className: styles$10.formRowHintError
  }));
};
FormRow.displayName = 'CoreFormRow';
FormRow.defaultProps = {
  fieldCount: 1,
  fluid: false,
  marginBottom: '32px'
};

var styles$11 = {"form-row-group":"fr-ec-form-row-group","formRowGroup":"fr-ec-form-row-group"};

var FormRowGroup = function FormRowGroup(_a) {
  var className = _a.className,
      children = _a.children,
      props = __rest(_a, ["className", "children"]);

  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$11.formRowGroup, className)
  }, props), children);
};
FormRowGroup.displayName = 'CoreFormRowGroup';

var renderFiveStars$1 = function renderFiveStars(value, reviewStarValue, iconClass, iconBrand) {
  return count(5).map(function (i) {
    return /*#__PURE__*/createElement(Star, {
      key: i,
      position: i,
      value: reviewStarValue,
      iconBrand: iconBrand,
      className: joinClasses(styles$3.graphItemIcon, iconClass)
    });
  });
};

var GraphItem = function GraphItem(_a) {
  var icon = _a.icon,
      iconClass = _a.iconClass,
      label = _a.label,
      formattedValue = _a.formattedValue,
      _b = _a.value,
      value = _b === void 0 ? 0 : _b,
      total = _a.total,
      _c = _a.reviewStarValue,
      reviewStarValue = _c === void 0 ? 0 : _c,
      iconBrand = _a.iconBrand;
  return /*#__PURE__*/createElement("tr", null, /*#__PURE__*/createElement("td", {
    className: joinClasses(styles$3.graphItemLabel, styles$3.graphItemCol)
  }, icon && renderFiveStars$1(value, reviewStarValue, iconClass, iconBrand), /*#__PURE__*/createElement(Label, {
    element: "span",
    variant: "standard",
    className: icon ? styles$3.graphItemLabelPadding : styles$3.graphItemLabel
  }, label)), /*#__PURE__*/createElement("td", {
    className: joinClasses(styles$3.graphItemCol, styles$3.graphItemIndicator)
  }, /*#__PURE__*/createElement(GraphIndicator, {
    value: value / total
  })), /*#__PURE__*/createElement("td", {
    className: joinClasses(styles$3.graphItemValue, styles$3.graphItemCol)
  }, /*#__PURE__*/createElement(Label, {
    element: "span",
    variant: "standard"
  }, formattedValue || value.toLocaleString())));
};
GraphItem.displayName = 'CoreGraphItem';

var Graph = function Graph(_a) {
  var labelHeading = _a.labelHeading,
      barHeading = _a.barHeading,
      countHeading = _a.countHeading,
      _b = _a.withIcon,
      withIcon = _b === void 0 ? false : _b,
      iconClass = _a.iconClass,
      _c = _a.data,
      data = _c === void 0 ? [] : _c,
      className = _a.className,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["labelHeading", "barHeading", "countHeading", "withIcon", "iconClass", "data", "className", "iconBrand"]);

  var isDataArray = Array.isArray(data);
  var total = isDataArray ? data.reduce(function (sum, _a) {
    var _b = _a.value,
        value = _b === void 0 ? 0 : _b;
    return sum + value;
  }, 0) : 0;
  return /*#__PURE__*/createElement("table", __assign({
    className: joinClasses(styles$3.graph, className)
  }, props), /*#__PURE__*/createElement("thead", {
    className: styles$3.graphHeadings
  }, /*#__PURE__*/createElement("tr", null, /*#__PURE__*/createElement("th", {
    scope: "col"
  }, labelHeading), /*#__PURE__*/createElement("th", {
    scope: "col"
  }, barHeading), /*#__PURE__*/createElement("th", {
    scope: "col"
  }, countHeading))), /*#__PURE__*/createElement("tbody", null, data.map(function (dataProps, i) {
    return /*#__PURE__*/createElement(GraphItem, __assign({
      key: i
    }, dataProps, {
      icon: withIcon,
      iconClass: iconClass,
      total: total,
      iconBrand: iconBrand
    }));
  })));
};
Graph.displayName = 'CoreGraph';
Graph.defaultProps = {
  withIcon: false
};

var styles$12 = {"grid":"fr-ec-grid","column":"fr-ec-column","grid-wrapper":"fr-ec-grid-wrapper","gridWrapper":"fr-ec-grid-wrapper"};

var Grid = function Grid(_a) {
  var children = _a.children,
      element = _a.element,
      className = _a.className,
      props = __rest(_a, ["children", "element", "className"]);

  var Element = element;
  return /*#__PURE__*/createElement(Element, __assign({
    className: joinClasses(styles$12.grid, className)
  }, props), children);
};
Grid.displayName = 'CoreGrid';

var styles$13 = {"header-page":"fr-ec-header-page","headerPage":"fr-ec-header-page","header-page__title-container":"fr-ec-header-page__title-container","headerPageTitleContainer":"fr-ec-header-page__title-container","header-page__title-container-label":"fr-ec-header-page__title-container-label","headerPageTitleContainerLabel":"fr-ec-header-page__title-container-label","header-page__caption":"fr-ec-header-page__caption","headerPageCaption":"fr-ec-header-page__caption","header-page__margin-top":"fr-ec-header-page__margin-top","headerPageMarginTop":"fr-ec-header-page__margin-top","header-page__tooltip":"fr-ec-header-page__tooltip","headerPageTooltip":"fr-ec-header-page__tooltip","header-page__textlink":"fr-ec-header-page__textlink","headerPageTextlink":"fr-ec-header-page__textlink","header-page__textlink-container":"fr-ec-header-page__textlink-container","headerPageTextlinkContainer":"fr-ec-header-page__textlink-container","header-page__caption-container":"fr-ec-header-page__caption-container","headerPageCaptionContainer":"fr-ec-header-page__caption-container","header-page__error-container":"fr-ec-header-page__error-container","headerPageErrorContainer":"fr-ec-header-page__error-container"};

var HeaderPage = function HeaderPage(_a) {
  var title = _a.title,
      captions = _a.captions,
      hideKeyline = _a.hideKeyline,
      className = _a.className,
      errors = _a.errors,
      textLink = _a.textLink,
      toolTip = _a.toolTip,
      _b = _a.labelElement,
      labelElement = _b === void 0 ? 'h5' : _b,
      marginTop = _a.marginTop,
      props = __rest(_a, ["title", "captions", "hideKeyline", "className", "errors", "textLink", "toolTip", "labelElement", "marginTop"]);

  return /*#__PURE__*/createElement("header", __assign({
    className: joinClasses(styles$13.headerPage, !hideKeyline && keylineStyles.keylineBottom, marginTop && styles$13.headerPageMarginTop, className)
  }, props), /*#__PURE__*/createElement(ContentAlignment, {
    className: styles$13.headerPageTitleContainer,
    element: "div",
    direction: "row",
    justifyContent: "space-between",
    alignment: "center"
  }, title && /*#__PURE__*/createElement(Display, {
    element: labelElement,
    variant: "display2",
    className: styles$13.headerPageTitleContainerLabel
  }, title), toolTip && /*#__PURE__*/createElement("div", {
    className: styles$13.headerPageTooltip
  }, toolTip)), Array.isArray(errors) && (errors === null || errors === void 0 ? void 0 : errors.length) > 0 && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
    className: styles$13.headerPageErrorContainer
  }, errors.map(function (error) {
    return /*#__PURE__*/createElement(Caption, {
      key: error,
      element: "p",
      variant: "standard",
      color: "error"
    }, error);
  }))), Array.isArray(captions) && (captions === null || captions === void 0 ? void 0 : captions.length) > 0 && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
    className: styles$13.headerPageCaptionContainer
  }, captions.map(function (caption) {
    return /*#__PURE__*/createElement(Body, {
      key: caption,
      element: "p",
      className: styles$13.headerPageCaption
    }, caption);
  }))), textLink && /*#__PURE__*/createElement("div", {
    className: styles$13.headerPageTextlinkContainer
  }, textLink));
};
HeaderPage.displayName = 'CoreHeaderPage';
HeaderPage.defaultProps = {
  hideKeyline: false,
  labelElement: 'h5'
};

var styles$14 = {"header-section":"fr-ec-header-section","headerSection":"fr-ec-header-section","header-section__icon":"fr-ec-header-section__icon","headerSectionIcon":"fr-ec-header-section__icon","header-section__icon--check-large":"fr-ec-header-section__icon--check-large","headerSectionIconCheckLarge":"fr-ec-header-section__icon--check-large","header-section--with-keyline":"fr-ec-header-section--with-keyline","headerSectionWithKeyline":"fr-ec-header-section--with-keyline","header-section__extra":"fr-ec-header-section__extra","headerSectionExtra":"fr-ec-header-section__extra"};

var HeaderSection = function HeaderSection(_a) {
  var element = _a.element,
      title = _a.title,
      _b = _a.titleMaxLineEllipsis,
      titleMaxLineEllipsis = _b === void 0 ? 1 : _b,
      subTitle = _a.subTitle,
      _c = _a.subTitleMaxLineEllipsis,
      subTitleMaxLineEllipsis = _c === void 0 ? 1 : _c,
      variant = _a.variant,
      className = _a.className,
      children = _a.children,
      _d = _a.hideKeyline,
      hideKeyline = _d === void 0 ? false : _d,
      icon = _a.icon,
      toolTip = _a.toolTip,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["element", "title", "titleMaxLineEllipsis", "subTitle", "subTitleMaxLineEllipsis", "variant", "className", "children", "hideKeyline", "icon", "toolTip", "iconBrand"]);

  var wrapperClasses = joinClasses(styles$14.headerSection, !hideKeyline && joinClasses(styles$14.headerSectionWithKeyline, keylineStyles.keylineBottom), className);
  var iconTemplate = icon ? /*#__PURE__*/createElement(Icon, {
    name: iconBrand ? "" + iconBrand + icon : icon,
    size: "24",
    className: joinClasses(styles$14.headerSectionIcon, icon === 'check-large' && styles$14.headerSectionIconCheckLarge)
  }) : toolTip;

  var titleType = _typeof(title);

  return /*#__PURE__*/createElement("header", __assign({
    className: wrapperClasses
  }, props), /*#__PURE__*/createElement(ContentAlignment, {
    element: "div",
    direction: "row",
    alignment: "center"
  }, subTitle ? /*#__PURE__*/createElement("div", null, titleType === 'string' ? /*#__PURE__*/createElement(Display, {
    element: element,
    variant: variant,
    style: {
      WebkitLineClamp: titleMaxLineEllipsis,
      lineClamp: titleMaxLineEllipsis
    }
  }, title) : title, /*#__PURE__*/createElement(Display, {
    element: element,
    variant: variant,
    style: {
      WebkitLineClamp: subTitleMaxLineEllipsis,
      lineClamp: subTitleMaxLineEllipsis
    }
  }, subTitle)) : titleType === 'string' ? /*#__PURE__*/createElement(Display, {
    element: element,
    variant: variant,
    style: {
      WebkitLineClamp: titleMaxLineEllipsis,
      lineClamp: titleMaxLineEllipsis
    }
  }, title) : title, iconTemplate), children && /*#__PURE__*/createElement("div", {
    className: styles$14.headerSectionExtra
  }, children));
};
HeaderSection.displayName = 'CoreHeaderSection';
HeaderSection.defaultProps = {
  hideKeyline: false
};

var styles$15 = {"image-enhancements":"fr-ec-image-enhancements","imageEnhancements":"fr-ec-image-enhancements","image-enhancements__content-row":"fr-ec-image-enhancements__content-row","imageEnhancementsContentRow":"fr-ec-image-enhancements__content-row","image-enhancements__content-row--padding-reset":"fr-ec-image-enhancements__content-row--padding-reset","imageEnhancementsContentRowPaddingReset":"fr-ec-image-enhancements__content-row--padding-reset","image-enhancements__content-row--bottom":"fr-ec-image-enhancements__content-row--bottom","imageEnhancementsContentRowBottom":"fr-ec-image-enhancements__content-row--bottom","image-enhancements__content-row--top":"fr-ec-image-enhancements__content-row--top","imageEnhancementsContentRowTop":"fr-ec-image-enhancements__content-row--top","image-enhancements__content":"fr-ec-image-enhancements__content","imageEnhancementsContent":"fr-ec-image-enhancements__content","image-enhancements__content--right":"fr-ec-image-enhancements__content--right","imageEnhancementsContentRight":"fr-ec-image-enhancements__content--right","image-enhancements__content--left":"fr-ec-image-enhancements__content--left","imageEnhancementsContentLeft":"fr-ec-image-enhancements__content--left","image-enhancements__content--text":"fr-ec-image-enhancements__content--text","imageEnhancementsContentText":"fr-ec-image-enhancements__content--text","body":"fr-ec-body","image-enhancements__content--text-white":"fr-ec-image-enhancements__content--text-white","imageEnhancementsContentTextWhite":"fr-ec-image-enhancements__content--text-white","image-enhancements__content--prioritized":"fr-ec-image-enhancements__content--prioritized","imageEnhancementsContentPrioritized":"fr-ec-image-enhancements__content--prioritized","image-enhancements__botton-center-content":"fr-ec-image-enhancements__botton-center-content","imageEnhancementsBottonCenterContent":"fr-ec-image-enhancements__botton-center-content"};

var prioritizedContentMap = {
  bottomLeft: 0,
  bottomRight: 1,
  topLeft: 0,
  topRight: 1
};

var contentGroup = function contentGroup(contentLeft, contentRight, textColor, prioritizedContent) {
  if (textColor === void 0) {
    textColor = {};
  }

  if (prioritizedContent === void 0) {
    prioritizedContent = [];
  }

  var isLeftContentString = contentLeft && contentLeft.type && ( // @ts-ignore
  contentLeft.type.displayName === 'CoreBody' || contentLeft.type.displayName === 'Body');
  var isRightContentString = contentRight && contentRight.type && ( // @ts-ignore
  contentRight.type.displayName === 'CoreBody' || contentRight.type.displayName === 'Body');
  var isPrioritizedLeft = prioritizedContent.some(function (item) {
    return prioritizedContentMap[item] === 0;
  });
  var isPrioritizedRight = prioritizedContent.some(function (item) {
    return prioritizedContentMap[item] === 1;
  });
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, contentLeft && /*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(styles$15.imageEnhancementsContent, styles$15.imageEnhancementsContentLeft, isPrioritizedLeft && styles$15.imageEnhancementsContentPrioritized, isLeftContentString && [styles$15.imageEnhancementsContentText, styles$15["image-enhancements__content--text-" + (textColor.left || 'Black')]].join(' '))
  }, contentLeft), contentRight && /*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(styles$15.imageEnhancementsContent, styles$15.imageEnhancementsContentRight, isPrioritizedRight && styles$15.imageEnhancementsContentPrioritized, isRightContentString && [styles$15.imageEnhancementsContentText, styles$15["image-enhancements__content--text-" + (textColor.right || 'Black')]].join(' '))
  }, contentRight));
};

var ImageEnhancements = function ImageEnhancements(_a) {
  var className = _a.className,
      children = _a.children,
      topLeftContent = _a.topLeftContent,
      topRightContent = _a.topRightContent,
      bottomLeftContent = _a.bottomLeftContent,
      bottomRightContent = _a.bottomRightContent,
      prioritizedContent = _a.prioritizedContent,
      topTextColor = _a.topTextColor,
      bottomTextColor = _a.bottomTextColor,
      _b = _a.padding,
      padding = _b === void 0 ? true : _b,
      absolutePositionContent = _a.absolutePositionContent,
      bottomCenterContent = _a.bottomCenterContent,
      props = __rest(_a, ["className", "children", "topLeftContent", "topRightContent", "bottomLeftContent", "bottomRightContent", "prioritizedContent", "topTextColor", "bottomTextColor", "padding", "absolutePositionContent", "bottomCenterContent"]);

  var _c = useState(0),
      minHeight = _c[0],
      updateMinHeight = _c[1];

  var imageEnhancementContentsRef = React__default.useRef(null);
  useEffect(function () {
    var contentsElement = imageEnhancementContentsRef === null || imageEnhancementContentsRef === void 0 ? void 0 : imageEnhancementContentsRef.current;

    if (contentsElement) {
      var contentMinHeight = contentsElement.clientHeight - contentsElement.clientWidth;
      updateMinHeight(contentMinHeight);
    }
  }, []);

  var onResize = function onResize(contentRect) {
    var contentsElement = imageEnhancementContentsRef === null || imageEnhancementContentsRef === void 0 ? void 0 : imageEnhancementContentsRef.current;

    if (contentRect.bounds && contentsElement) {
      var contentMinHeight = contentsElement.clientHeight - contentsElement.clientWidth;
      updateMinHeight(contentMinHeight);
    }
  };

  return /*#__PURE__*/React__default.createElement(Measure, {
    bounds: true,
    onResize: debounce(100, onResize)
  }, function (_a) {
    var measureRef = _a.measureRef;
    return /*#__PURE__*/React__default.createElement("div", __assign({
      ref: measureRef,
      className: joinClasses(styles$15.imageEnhancements, className)
    }, props), /*#__PURE__*/React__default.createElement("div", {
      ref: imageEnhancementContentsRef
    }, children, absolutePositionContent, (topLeftContent || topRightContent) && /*#__PURE__*/React__default.createElement("div", {
      className: joinClasses(styles$15.imageEnhancementsContentRow, styles$15.imageEnhancementsContentRowTop, !padding && styles$15.imageEnhancementsContentRowPaddingReset)
    }, contentGroup(topLeftContent, topRightContent, topTextColor, prioritizedContent)), (bottomLeftContent || bottomRightContent) && /*#__PURE__*/React__default.createElement("div", {
      className: joinClasses(styles$15.imageEnhancementsContentRow, styles$15.imageEnhancementsContentRowBottom, !padding && styles$15.imageEnhancementsContentRowPaddingReset)
    }, contentGroup(bottomLeftContent, bottomRightContent, bottomTextColor, prioritizedContent))), bottomCenterContent && /*#__PURE__*/React__default.createElement("div", {
      className: styles$15.imageEnhancementsBottonCenterContent,
      style: {
        minHeight: minHeight + "px"
      }
    }, bottomCenterContent));
  });
};
ImageEnhancements.displayName = 'CoreImageEnhancements';
ImageEnhancements.defaultProps = {
  bottomTextColor: {
    left: 'black',
    right: 'black'
  },
  padding: true,
  topTextColor: {
    left: 'black',
    right: 'black'
  }
};

var styles$16 = {"image-overlay":"fr-ec-image-overlay","imageOverlay":"fr-ec-image-overlay","image-overlay__content":"fr-ec-image-overlay__content","imageOverlayContent":"fr-ec-image-overlay__content","image-overlay__content-light":"fr-ec-image-overlay__content-light","imageOverlayContentLight":"fr-ec-image-overlay__content-light","image-overlay--element-div":"fr-ec-image-overlay--element-div","imageOverlayElementDiv":"fr-ec-image-overlay--element-div","image-overlay__label":"fr-ec-image-overlay__label","imageOverlayLabel":"fr-ec-image-overlay__label","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","image-overlay__label-light":"fr-ec-image-overlay__label-light","imageOverlayLabelLight":"fr-ec-image-overlay__label-light","image-overlay__label--text-align-left":"fr-ec-image-overlay__label--text-align-left","imageOverlayLabelTextAlignLeft":"fr-ec-image-overlay__label--text-align-left","image-overlay__label--text-align-center":"fr-ec-image-overlay__label--text-align-center","imageOverlayLabelTextAlignCenter":"fr-ec-image-overlay__label--text-align-center","image-overlay__label--text-align-right":"fr-ec-image-overlay__label--text-align-right","imageOverlayLabelTextAlignRight":"fr-ec-image-overlay__label--text-align-right"};

var ImageOverlay = function ImageOverlay(_a) {
  var Element = _a.element,
      children = _a.children,
      className = _a.className,
      content = _a.content,
      _b = _a.textAlign,
      textAlign = _b === void 0 ? 'left' : _b,
      _c = _a.typography,
      typography = _c === void 0 ? 'title' : _c,
      _d = _a.imageOverlayType,
      imageOverlayType = _d === void 0 ? 'default' : _d,
      props = __rest(_a, ["element", "children", "className", "content", "textAlign", "typography", "imageOverlayType"]);

  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign({
      className: joinClasses(styles$16.imageOverlay, Element === 'button' && resetStyles.buttonReset, Element === 'div' && styles$16.imageOverlayElementDiv, className)
    }, props), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$16.imageOverlayContent, imageOverlayType === 'light' && styles$16.imageOverlayContentLight),
      tabIndex: 0
    }, typography === 'caption' ? /*#__PURE__*/createElement(Caption, {
      className: joinClasses(styles$16.imageOverlayLabel, imageOverlayType === 'light' && styles$16.imageOverlayLabelLight, styles$16["image-overlay__label--text-align-" + textAlign]),
      element: "span",
      variant: "standard"
    }, content) : /*#__PURE__*/createElement(Title, {
      className: joinClasses(styles$16.imageOverlayLabel, imageOverlayType === 'light' && styles$16.imageOverlayLabelLight, styles$16["image-overlay__label--text-align-" + textAlign]),
      element: "span",
      variant: "standard"
    }, content)), children)
  );
};
ImageOverlay.displayName = 'CoreImageOverlay';

var styles$17 = {"image-typography__image-wrapper":"fr-ec-image-typography__image-wrapper","imageTypographyImageWrapper":"fr-ec-image-typography__image-wrapper","image-typography__image-wrapper--8":"fr-ec-image-typography__image-wrapper--8","imageTypographyImageWrapper8":"fr-ec-image-typography__image-wrapper--8","image-typography__image-wrapper--12":"fr-ec-image-typography__image-wrapper--12","imageTypographyImageWrapper12":"fr-ec-image-typography__image-wrapper--12","image-typography__image-wrapper--16":"fr-ec-image-typography__image-wrapper--16","imageTypographyImageWrapper16":"fr-ec-image-typography__image-wrapper--16","image-typography__image--20":"fr-ec-image-typography__image--20","imageTypographyImage20":"fr-ec-image-typography__image--20","image-typography__image--24":"fr-ec-image-typography__image--24","imageTypographyImage24":"fr-ec-image-typography__image--24","image-typography__image--48":"fr-ec-image-typography__image--48","imageTypographyImage48":"fr-ec-image-typography__image--48","image-typography__image--68":"fr-ec-image-typography__image--68","imageTypographyImage68":"fr-ec-image-typography__image--68"};

var ImageTypography = function ImageTypography(_a) {
  var src = _a.src,
      alt = _a.alt,
      _b = _a.spacing,
      spacing = _b === void 0 ? '8' : _b,
      _c = _a.imageHeight,
      imageHeight = _c === void 0 ? '20' : _c,
      _d = _a.alignment,
      alignment = _d === void 0 ? 'flex-start' : _d,
      children = _a.children,
      props = __rest(_a, ["src", "alt", "spacing", "imageHeight", "alignment", "children"]);

  return /*#__PURE__*/createElement(ContentAlignment, __assign({
    element: "span",
    direction: "row",
    alignment: alignment
  }, props), /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$17.imageTypographyImageWrapper, styles$17["image-typography__image-wrapper--" + spacing])
  }, src && /*#__PURE__*/createElement("img", {
    className: styles$17["image-typography__image--" + imageHeight],
    src: src,
    alt: alt
  })), children));
};
ImageTypography.displayName = 'CoreImageTypography';

var styles$18 = {"link-cell":"fr-ec-link-cell","linkCell":"fr-ec-link-cell","link-cell__variant-small":"fr-ec-link-cell__variant-small","linkCellVariantSmall":"fr-ec-link-cell__variant-small","link-cell__variant-large":"fr-ec-link-cell__variant-large","linkCellVariantLarge":"fr-ec-link-cell__variant-large","link-cell__variant-noPadding":"fr-ec-link-cell__variant-noPadding","linkCellVariantNoPadding":"fr-ec-link-cell__variant-noPadding","link-cell__label-wrapper":"fr-ec-link-cell__label-wrapper","linkCellLabelWrapper":"fr-ec-link-cell__label-wrapper","link-cell__no-padding-wrapper":"fr-ec-link-cell__no-padding-wrapper","linkCellNoPaddingWrapper":"fr-ec-link-cell__no-padding-wrapper","link-cell__icon--start":"fr-ec-link-cell__icon--start","linkCellIconStart":"fr-ec-link-cell__icon--start","link-cell__icon--end":"fr-ec-link-cell__icon--end","linkCellIconEnd":"fr-ec-link-cell__icon--end","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn","link-cell__chevron-icon":"fr-ec-link-cell__chevron-icon","linkCellChevronIcon":"fr-ec-link-cell__chevron-icon","link-cell__label":"fr-ec-link-cell__label","linkCellLabel":"fr-ec-link-cell__label"};

var LinkCell = function LinkCell(_a) {
  var _b = _a.chevron,
      chevron = _b === void 0 ? false : _b,
      label = _a.label,
      element = _a.element,
      _c = _a.iconPosition,
      iconPosition = _c === void 0 ? 'start' : _c,
      className = _a.className,
      icon = _a.icon,
      href = _a.href,
      to = _a.to,
      _d = _a.wordBreak,
      wordBreak = _d === void 0 ? 'none' : _d,
      _e = _a.isGenderTypography,
      isGenderTypography = _e === void 0 ? false : _e,
      gaCategory = _a.gaCategory,
      gaAction = _a.gaAction,
      gaLabel = _a.gaLabel,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      _f = _a.variant,
      variant = _f === void 0 ? 'large' : _f,
      iconBrand = _a.iconBrand,
      onClick = _a.onClick,
      contentWithNoPadding = _a.contentWithNoPadding,
      props = __rest(_a, ["chevron", "label", "element", "iconPosition", "className", "icon", "href", "to", "wordBreak", "isGenderTypography", "gaCategory", "gaAction", "gaLabel", "gaValue", "gaCallback", "variant", "iconBrand", "onClick", "contentWithNoPadding"]);

  var Element = element;
  var gaProps = null;

  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };

    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }

  var handleClick = function handleClick(e) {
    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    } // For callback


    if (onClick) {
      onClick(e);
    }
  };

  var iconTemplate = icon ? /*#__PURE__*/createElement(Icon, {
    className: iconPosition === 'start' ? styles$18.linkCellIconStart : styles$18.linkCellIconEnd,
    name: iconBrand ? "" + iconBrand + icon : icon,
    key: "icon-key"
  }) : '';
  var content = contentWithNoPadding ? contentWithNoPadding : /*#__PURE__*/createElement(Body, {
    className: styles$18.linkCellLabel,
    element: "p"
  }, label);
  var renderChildren = !isGenderTypography ? iconPosition === 'end' ? /*#__PURE__*/createElement(Fragment, null, content, iconTemplate) : /*#__PURE__*/createElement(Fragment, null, iconTemplate, content) : iconPosition === 'end' ? /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("span", {
    className: joinClasses(typographyStyles.genderStandard, styles$18.linkCellLabel, textTransformStyles.textTransformAllCaps)
  }, label), iconTemplate) : /*#__PURE__*/createElement(Fragment, null, iconTemplate, /*#__PURE__*/createElement("span", {
    className: joinClasses(typographyStyles.genderStandard, styles$18.linkCellLabel, textTransformStyles.textTransformAllCaps)
  }, label));
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign({
      className: joinClasses(styles$18.linkCell, styles$18["link-cell__variant-" + variant], interactionsStyles.cursorPointer, addWordBreak(wordBreak === 'break-word'), className),
      onClick: handleClick
    }, !props.disabled ? {
      href: href,
      to: to
    } : {}, gaProps, props), /*#__PURE__*/createElement("div", {
      className: contentWithNoPadding ? styles$18.linkCellNoPaddingWrapper : styles$18.linkCellLabelWrapper
    }, renderChildren), chevron && /*#__PURE__*/createElement(Icon, {
      name: iconBrand ? iconBrand + "chevron-right" : 'chevron-right',
      className: styles$18.linkCellChevronIcon
    }))
  );
};
LinkCell.displayName = 'CoreLinkCell';
LinkCell.defaultProps = {
  disabled: false,
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var LinkImageGroup = function LinkImageGroup(_a) {
  var children = _a.children,
      className = _a.className,
      props = __rest(_a, ["children", "className"]);

  return /*#__PURE__*/createElement(CollectionListHorizontal, __assign({
    children: children,
    spacingValue: "16",
    className: className
  }, props));
};
LinkImageGroup.displayName = 'CoreLinkImageGroup';

var styles$19 = {"cms-sns-buttons":"fr-ec-cms-sns-buttons","cmsSnsButtons":"fr-ec-cms-sns-buttons","collection-list-horizontal--large":"fr-ec-collection-list-horizontal--large","collectionListHorizontalLarge":"fr-ec-collection-list-horizontal--large","collection-list-horizontal__item":"fr-ec-collection-list-horizontal__item","collectionListHorizontalItem":"fr-ec-collection-list-horizontal__item"};

var CmsSnsButtons = function CmsSnsButtons(_a) {
  var items = _a.items,
      className = _a.className,
      props = __rest(_a, ["items", "className"]);

  return /*#__PURE__*/createElement(LinkImageGroup, __assign({
    className: joinClasses(className, styles$19.cmsSnsButtons)
  }, props), items);
};
CmsSnsButtons.displayName = 'CoreCmsSnsButtons';

var styles$1a = {"link-navigation":"fr-ec-link-navigation","linkNavigation":"fr-ec-link-navigation","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn","link-navigation__icon--start":"fr-ec-link-navigation__icon--start","linkNavigationIconStart":"fr-ec-link-navigation__icon--start","link-navigation__icon--end":"fr-ec-link-navigation__icon--end","linkNavigationIconEnd":"fr-ec-link-navigation__icon--end","link-navigation__icon--alignment":"fr-ec-link-navigation__icon--alignment","linkNavigationIconAlignment":"fr-ec-link-navigation__icon--alignment"};

var LinkNavigation = function LinkNavigation(_a) {
  var Element = _a.element,
      _b = _a.selected,
      selected = _b === void 0 ? false : _b,
      className = _a.className,
      children = _a.children,
      icon = _a.icon,
      _c = _a.iconPosition,
      iconPosition = _c === void 0 ? 'end' : _c,
      gaCategory = _a.gaCategory,
      gaAction = _a.gaAction,
      gaLabel = _a.gaLabel,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      onClick = _a.onClick,
      _d = _a.variant,
      variant = _d === void 0 ? 'TitleStandard' : _d,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["element", "selected", "className", "children", "icon", "iconPosition", "gaCategory", "gaAction", "gaLabel", "gaValue", "gaCallback", "onClick", "variant", "iconBrand"]);

  var gaProps = null;

  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };

    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }

  var titleVariant = {
    TitleSmall: selected ? 'small-emphasized' : 'small',
    TitleStandard: selected ? 'standard-emphasized' : 'standard'
  };
  var iconTemplate = icon && /*#__PURE__*/createElement(Icon, {
    name: iconBrand ? "" + iconBrand + icon : icon,
    className: joinClasses(styles$1a["link-navigation__icon--" + iconPosition], styles$1a["link-navigation__icon--alignment"]),
    key: "icon-key"
  });
  var renderChildren = /*#__PURE__*/createElement(Title, {
    element: "p",
    variant: titleVariant[variant],
    key: "child-key"
  }, children);
  var childrenWithIcon = /*#__PURE__*/createElement(Title, {
    element: "p",
    variant: selected ? 'standard-emphasized' : 'standard'
  }, iconPosition === 'end' ? [children, iconTemplate] : [iconTemplate, children]);

  var handleClick = function handleClick(e) {
    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    }

    if (onClick) {
      onClick(e);
    }
  };

  return (
    /*#__PURE__*/
    // @ts-ignore-next-line
    createElement(Element, __assign({
      className: joinClasses(styles$1a.linkNavigation, Element === 'button' && resetStyles.buttonReset, interactionsStyles.cursorPointer, className),
      // @ts-ignore-next-line
      onClick: handleClick
    }, gaProps, props), icon ? /*#__PURE__*/createElement(ContentAlignment, {
      element: "span",
      direction: "row",
      alignment: "center"
    }, childrenWithIcon) : renderChildren)
  );
};
LinkNavigation.displayName = 'CoreLinkNavigation';
LinkNavigation.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null,
  iconPosition: 'end',
  selected: false,
  variant: 'TitleStandard'
};

var styles$1b = {"link-primary-nav":"fr-ec-link-primary-nav","linkPrimaryNav":"fr-ec-link-primary-nav","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn","link-primary-nav__text-wrapper":"fr-ec-link-primary-nav__text-wrapper","linkPrimaryNavTextWrapper":"fr-ec-link-primary-nav__text-wrapper","label":"fr-ec-label"};

var LinkPrimaryNav = function LinkPrimaryNav(_a) {
  var Element = _a.element,
      children = _a.children,
      className = _a.className,
      onClick = _a.onClick,
      onMouseEnter = _a.onMouseEnter,
      onMouseLeave = _a.onMouseLeave,
      _b = _a.isHeader,
      isHeader = _b === void 0 ? false : _b,
      props = __rest(_a, ["element", "children", "className", "onClick", "onMouseEnter", "onMouseLeave", "isHeader"]);

  var isTouchDevices = isTouchDevice('touchPoints');
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign({
      className: joinClasses(resetStyles.buttonReset, styles$1b.linkPrimaryNav, className)
    }, isHeader ? !isTouchDevices ? {
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onClick: onClick
    } : {
      onClick: onClick
    } : {
      onClick: onClick
    }, props), /*#__PURE__*/createElement(Label, {
      element: "span",
      className: joinClasses(styles$1b.linkPrimaryNavTextWrapper, typographyStyles.genderStandard)
    }, children))
  );
};
LinkPrimaryNav.displayName = 'CoreLinkPrimaryNav';

var styles$1c = {"collection-list-horizontal--large":"fr-ec-collection-list-horizontal--large","collectionListHorizontalLarge":"fr-ec-collection-list-horizontal--large","link-text-group":"fr-ec-link-text-group","linkTextGroup":"fr-ec-link-text-group","collection-list-horizontal__item":"fr-ec-collection-list-horizontal__item","collectionListHorizontalItem":"fr-ec-collection-list-horizontal__item","collection-list-horizontal--divider":"fr-ec-collection-list-horizontal--divider","collectionListHorizontalDivider":"fr-ec-collection-list-horizontal--divider"};

var LinkTextGroup = function LinkTextGroup(_a) {
  var children = _a.children,
      className = _a.className,
      _b = _a.variant,
      variant = _b === void 0 ? 'horizontal' : _b,
      props = __rest(_a, ["children", "className", "variant"]);

  return /*#__PURE__*/createElement(CollectionListHorizontal, __assign({
    children: children,
    divider: variant === 'divided',
    spacingValue: variant === 'divided' ? '8' : '16',
    className: joinClasses(styles$1c.linkTextGroup, className)
  }, props));
};
LinkTextGroup.displayName = 'CoreLinkTextGroup';
LinkTextGroup.defaultProps = {
  variant: 'horizontal'
};

var styles$1d = {"list":"fr-ec-list","list--secondary":"fr-ec-list--secondary","listSecondary":"fr-ec-list--secondary","list--has-spacing":"fr-ec-list--has-spacing","listHasSpacing":"fr-ec-list--has-spacing"};

var List = function List(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'primary' : _b,
      Element = _a.element,
      className = _a.className,
      children = _a.children,
      _c = _a.start,
      start = _c === void 0 ? 1 : _c,
      _d = _a.spacing,
      spacing = _d === void 0 ? true : _d,
      props = __rest(_a, ["variant", "element", "className", "children", "start", "spacing"]);

  var childElement = Children.map(children, function (listItem, i) {
    return /*#__PURE__*/cloneElement(listItem, {
      className: listItem.type === 'li' ? typographyStyles.bodyStandard : ''
    });
  });
  return /*#__PURE__*/createElement(Element, __assign({
    className: joinClasses(styles$1d.list, bodyStyles.body, variant === 'secondary' && styles$1d.listSecondary, spacing && styles$1d.listHasSpacing, className),
    style: Element === 'ol' ? {
      '--li-counter': start - 1
    } : {}
  }, props), childElement);
};
List.displayName = 'CoreList';
List.defaultProps = {
  start: 1,
  variant: 'primary'
};

var styles$1e = {"tile":"fr-ec-tile","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","tile--default":"fr-ec-tile--default","tileDefault":"fr-ec-tile--default","tile--fill":"fr-ec-tile--fill","tileFill":"fr-ec-tile--fill"};

var Tile = function Tile(_a) {
  var _b = _a.element,
      Element = _b === void 0 ? 'a' : _b,
      className = _a.className,
      _c = _a.variant,
      variant = _c === void 0 ? 'default' : _c,
      gaAction = _a.gaAction,
      gaCategory = _a.gaCategory,
      gaLabel = _a.gaLabel,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      onClick = _a.onClick,
      _d = _a.activeTabName,
      activeTabName = _d === void 0 ? '' : _d,
      props = __rest(_a, ["element", "className", "variant", "gaAction", "gaCategory", "gaLabel", "gaValue", "gaCallback", "onClick", "activeTabName"]);

  var gaProps = null;

  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };

    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }

  var onClickHandler = function onClickHandler(e) {
    // For callback
    if (onClick) {
      onClick(e, activeTabName);
    } // For event tracking


    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel, gaAction);
    }
  };

  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign({
      tabIndex: 0,
      className: joinClasses(styles$1e.tile, Element === 'button' && resetStyles.buttonReset, styles$1e["tile--" + variant], interactionsStyles.cursorPointer, className),
      onClick: onClickHandler
    }, gaProps, props))
  );
};
Tile.displayName = 'CoreTile';
Tile.defaultProps = {
  activeTabName: '',
  element: 'a',
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null,
  variant: 'default'
};

var styles$1f = {"loading-indicator":"fr-ec-loading-indicator","loadingIndicator":"fr-ec-loading-indicator","loading-indicator--normal":"fr-ec-loading-indicator--normal","loadingIndicatorNormal":"fr-ec-loading-indicator--normal","loading-indicator__spinner-container":"fr-ec-loading-indicator__spinner-container","loadingIndicatorSpinnerContainer":"fr-ec-loading-indicator__spinner-container","loading-indicator--first-logo":"fr-ec-loading-indicator--first-logo","loadingIndicatorFirstLogo":"fr-ec-loading-indicator--first-logo","loading-indicator--jp-logo-third":"fr-ec-loading-indicator--jp-logo-third","loadingIndicatorJpLogoThird":"fr-ec-loading-indicator--jp-logo-third","logo-translate":"fr-ec-logo-translate","logoTranslate":"fr-ec-logo-translate","loading-indicator--jp-logo-first":"fr-ec-loading-indicator--jp-logo-first","loadingIndicatorJpLogoFirst":"fr-ec-loading-indicator--jp-logo-first","logo-translate-down":"fr-ec-logo-translate-down","logoTranslateDown":"fr-ec-logo-translate-down","loading-indicator--jp-logo-second":"fr-ec-loading-indicator--jp-logo-second","loadingIndicatorJpLogoSecond":"fr-ec-loading-indicator--jp-logo-second","loading-indicator__container":"fr-ec-loading-indicator__container","loadingIndicatorContainer":"fr-ec-loading-indicator__container","loading-indicator__container-uq-logos":"fr-ec-loading-indicator__container-uq-logos","loadingIndicatorContainerUqLogos":"fr-ec-loading-indicator__container-uq-logos","loading-indicator--full-screen":"fr-ec-loading-indicator--full-screen","loadingIndicatorFullScreen":"fr-ec-loading-indicator--full-screen","loading-indicator--overlay":"fr-ec-loading-indicator--overlay","loadingIndicatorOverlay":"fr-ec-loading-indicator--overlay","loading-indicator--overlay-l1":"fr-ec-loading-indicator--overlay-l1","loadingIndicatorOverlayL1":"fr-ec-loading-indicator--overlay-l1","loading-indicator__spinner":"fr-ec-loading-indicator__spinner","loadingIndicatorSpinner":"fr-ec-loading-indicator__spinner","loader-spin":"fr-ec-loader-spin","loaderSpin":"fr-ec-loader-spin","loading-indicator__spinner-2":"fr-ec-loading-indicator__spinner-2","loadingIndicatorSpinner2":"fr-ec-loading-indicator__spinner-2","loading-indicator--l1-single-logo":"fr-ec-loading-indicator--l1-single-logo","loadingIndicatorL1SingleLogo":"fr-ec-loading-indicator--l1-single-logo","logo-opacity":"fr-ec-logo-opacity","logoOpacity":"fr-ec-logo-opacity"};

var UNIQLO_LOGO_JP = /*#__PURE__*/React__default.createElement("svg", {
  id: 'loading-indicator-jp-logo',
  width: "45",
  height: "45",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("rect", {
  width: "40",
  height: "40",
  fill: "#FF0000"
}), /*#__PURE__*/React__default.createElement("path", {
  id: 'loading-indicator-jp-logo-path',
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.7399 5.47021H7.14988V8.00021H12.2099V15.1602H5.89988V17.6802H17.2599V15.1602H14.7399V5.47021ZM32.8399 5.47021H23.9999V8.00021H32.8399V5.47021ZM34.0999 15.1602H22.7399V17.6802H34.0999V15.1602ZM22.7399 34.5302V22.3102H34.0999V34.5302H22.7399ZM31.5699 32.0002H25.2599V24.8402H31.5699V32.0002ZM5.86988 28.4302L7.14988 22.3102H17.2599L14.7399 34.5302H4.62988L5.13988 32.0002H12.7299L14.2199 24.8402H9.14988L8.38988 28.4302H5.86988Z",
  fill: "white"
}));
var UNIQLO_LOGO_EN = /*#__PURE__*/React__default.createElement("svg", {
  id: 'loading-indicator-en-logo',
  width: "45",
  height: "45",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("rect", {
  width: "40",
  height: "40",
  fill: "#FF0000"
}), /*#__PURE__*/React__default.createElement("path", {
  id: 'loading-indicator-en-logo-path',
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.21001 18.1061C11.5335 18.1061 13.4177 16.2237 13.42 13.9002V5.47021H10.89V13.9002C10.89 14.828 10.1378 15.5802 9.21001 15.5802C8.28221 15.5802 7.53001 14.828 7.53001 13.9002V5.47021H5.00001V13.9002C5.00231 16.2237 6.88651 18.1061 9.21001 18.1061ZM31.96 5.47021H29.43V18.1102H31.96V5.47021ZM25.21 34.5302H16.79V21.8902H19.32V32.0002H25.21V34.5302ZM22.68 18.1102H25.21V5.47021H22.68V12.6902L19.32 5.47021H16.79V18.1102H19.32V10.8902L22.68 18.1102ZM9.21001 21.8902C8.09171 21.8902 7.01941 22.3351 6.22951 23.1268C5.43971 23.9185 4.99731 24.9919 5.00001 26.1102V30.3202C5.00001 32.6453 6.88491 34.5302 9.21001 34.5302C9.48491 34.5329 9.75951 34.5095 10.03 34.4602L10.89 37.0602H13.42L12.17 33.3102C12.9724 32.5185 13.4228 31.4374 13.42 30.3102V26.1102C13.4227 24.9919 12.9803 23.9185 12.1905 23.1268C11.4006 22.3351 10.3283 21.8902 9.21001 21.8902ZM9.21001 32.0002C10.1378 32.0002 10.89 31.248 10.89 30.3202V26.1102C10.89 25.1824 10.1378 24.4302 9.21001 24.4302C8.28221 24.4302 7.53001 25.1824 7.53001 26.1102V30.3202C7.53001 31.248 8.28221 32.0002 9.21001 32.0002ZM30.685 21.8902C28.3567 21.8929 26.47 23.7813 26.47 26.1102V30.3202C26.47 32.6453 28.3549 34.5302 30.68 34.5302C33.0051 34.5302 34.89 32.6453 34.89 30.3202V26.1102C34.8926 24.9919 34.4503 23.9185 33.6605 23.1268C32.8718 22.3363 31.8015 21.8915 30.685 21.8902ZM30.685 21.8902L30.68 21.8902H30.69L30.685 21.8902ZM30.675 32.0052C31.6056 32.0052 32.36 31.2508 32.36 30.3202V26.1102C32.36 25.1796 31.6056 24.4252 30.675 24.4252C29.7444 24.4252 28.99 25.1796 28.99 26.1102V30.3202C28.99 31.2508 29.7444 32.0052 30.675 32.0052Z",
  fill: "white"
}));
var LIFE_WEAR_LOGO = /*#__PURE__*/React__default.createElement("svg", {
  id: 'loading-indicator-LW-logo',
  width: "70",
  height: "14",
  viewBox: "0 0 70 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("rect", {
  width: "70",
  height: "14",
  fill: "#fff"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M1.43816 0V11.4891H8.67768V12.9175H0V0H1.43816Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M12.2591 1.55828H10.6846V0H12.2591V1.55828ZM12.126 12.9207H10.7982V3.76585H12.126V12.9207Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M17.1194 12.9177H15.7884V5.37951H14.7041V4.06147H15.7884V2.39281C15.787 2.07022 15.8522 1.75082 15.9799 1.45459C16.0972 1.168 16.2717 0.908391 16.4929 0.691688C16.7179 0.468618 16.985 0.292587 17.2788 0.173864C17.5725 0.0551418 17.8869 -0.00389612 18.2037 0.000199376H19.2913V1.31824H18.2102C18.0673 1.31333 17.925 1.33769 17.7918 1.38982C17.6587 1.44196 17.5376 1.52077 17.4361 1.62141C17.3345 1.72206 17.2546 1.84241 17.2013 1.97506C17.1479 2.10772 17.1223 2.24988 17.1259 2.39281V4.06147H18.9959V5.37951H17.1259L17.1194 12.9177Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M22.2462 9.50225C22.2453 9.79585 22.3084 10.0861 22.4312 10.3528C22.5431 10.6121 22.7015 10.8486 22.8987 11.0508C23.1056 11.2611 23.3531 11.4271 23.6263 11.5386C23.8994 11.6501 24.1924 11.7048 24.4874 11.6994C24.7824 11.6939 25.0731 11.6284 25.342 11.5068C25.6108 11.3853 25.852 11.2102 26.051 10.9924L26.9892 11.9436C26.6629 12.2909 26.2668 12.5653 25.827 12.7487C25.3882 12.9285 24.9182 13.0201 24.444 13.0181C23.9708 13.0206 23.5023 12.9255 23.0675 12.7389C22.6493 12.562 22.2691 12.3063 21.9475 11.9858C21.6211 11.6615 21.3625 11.2754 21.1869 10.8501C21.0114 10.4249 20.9223 9.96884 20.9249 9.50874V7.18755C20.9281 6.60782 21.0743 6.03784 21.3504 5.52808C21.6265 5.01832 22.024 4.58452 22.5078 4.26509C22.9916 3.94566 23.5467 3.75046 24.124 3.69679C24.7012 3.64311 25.2828 3.73261 25.8172 3.95736C26.2362 4.13458 26.6174 4.39022 26.9405 4.71053C27.256 5.02687 27.5103 5.39891 27.6904 5.80782C27.8793 6.23858 27.9755 6.70423 27.9728 7.17456V8.49585H22.2462V9.50225ZM26.645 7.22975C26.6467 6.92418 26.586 6.62148 26.4665 6.34023C26.3556 6.07559 26.1972 5.83352 25.999 5.62602C25.8047 5.41932 25.5676 5.25756 25.3043 5.15204C25.0346 5.04087 24.7454 4.98459 24.4537 4.98648C24.1638 4.97627 23.8751 5.02705 23.6061 5.13554C23.3371 5.24403 23.0939 5.40782 22.8922 5.61628C22.4774 6.05519 22.2452 6.63558 22.2429 7.23949L26.645 7.22975Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M39.7425 10.4697L42.661 0H44.1024L40.3983 12.9175H38.9764L36.5837 2.70751L34.1879 12.9175H32.7627L29.0391 0H30.4805L33.399 10.4697L35.8695 0H37.2915L39.7425 10.4697Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M46.5339 9.50271C46.5319 9.79364 46.5928 10.0816 46.7124 10.3468C46.8243 10.606 46.9828 10.8426 47.1799 11.0448C47.5882 11.456 48.1425 11.6894 48.722 11.694C49.0276 11.7003 49.3309 11.6403 49.6112 11.5181C49.8914 11.3959 50.1418 11.2145 50.3452 10.9863L51.2802 11.9375C50.9557 12.2855 50.5605 12.56 50.1212 12.7426C49.6813 12.9228 49.2103 13.0143 48.735 13.0121C48.2629 13.0146 47.7954 12.9195 47.3617 12.7329C46.9387 12.5564 46.5539 12.2996 46.2287 11.9765C45.9023 11.6522 45.6438 11.2662 45.4682 10.8409C45.2926 10.4156 45.2035 9.95956 45.2061 9.49946V7.17827C45.2094 6.59854 45.3555 6.02856 45.6316 5.5188C45.9077 5.00904 46.3053 4.57524 46.7891 4.25581C47.2729 3.93638 47.828 3.74118 48.4052 3.68751C48.9825 3.63383 49.5641 3.72333 50.0985 3.94808C50.5178 4.12459 50.8992 4.38032 51.2217 4.70125C51.5393 5.02036 51.7947 5.39576 51.9749 5.80828C52.1612 6.23974 52.2562 6.70507 52.2541 7.17503V8.49632H46.5339V9.50271ZM50.9328 7.23021C50.9361 6.92449 50.8753 6.62147 50.7542 6.34069C50.6422 6.07669 50.4839 5.83482 50.2868 5.62648C50.0922 5.42156 49.8566 5.26004 49.5953 5.1525C49.3243 5.04166 49.0342 4.98539 48.7415 4.98694C48.4516 4.97673 48.1628 5.02751 47.8938 5.136C47.6248 5.2445 47.3816 5.40828 47.1799 5.61674C46.7651 6.05565 46.533 6.63604 46.5306 7.23995L50.9328 7.23021Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M59.8943 7.1815C59.8952 6.89034 59.8332 6.60243 59.7125 6.33744C59.5979 6.07809 59.4374 5.84162 59.2386 5.63945C59.0347 5.44126 58.7973 5.28079 58.5373 5.16548C58.2668 5.05249 57.9767 4.99402 57.6835 4.99342C57.2541 4.9905 56.834 5.11846 56.4791 5.36026C56.1184 5.59852 55.8351 5.93705 55.6643 6.33419L54.4306 5.83424C54.7026 5.18333 55.1612 4.62754 55.7487 4.237C56.3254 3.85387 57.0042 3.65361 57.6965 3.66239C58.1664 3.65817 58.6319 3.75217 59.0633 3.93833C59.4784 4.11739 59.8561 4.37288 60.1768 4.6915C60.4969 5.0104 60.7536 5.38716 60.9332 5.80177C61.1221 6.23254 61.2183 6.69818 61.2156 7.16852V12.9179H59.8684V11.7882C59.6221 12.1439 59.2917 12.4333 58.9065 12.6304C58.5214 12.8275 58.0934 12.9263 57.6608 12.9179H56.8752C56.5102 12.9219 56.1485 12.8489 55.8136 12.7037C55.4935 12.5693 55.2024 12.3741 54.9565 12.129C54.7088 11.8852 54.5114 11.5951 54.3754 11.2752C54.2324 10.9454 54.1595 10.5894 54.1612 10.2299C54.1592 9.86719 54.2321 9.50799 54.3754 9.1748C54.5131 8.85679 54.7103 8.56807 54.9565 8.32424C55.2041 8.08124 55.4948 7.88638 55.8136 7.74963C56.1485 7.6044 56.5102 7.5314 56.8752 7.53537H59.8879L59.8943 7.1815ZM56.8817 8.85666C56.7009 8.85308 56.5214 8.88636 56.3539 8.95445C56.1865 9.02254 56.0347 9.12403 55.9077 9.25272C55.65 9.51133 55.5053 9.86155 55.5053 10.2266C55.5053 10.5917 55.65 10.942 55.9077 11.2006C56.035 11.3291 56.1868 11.4307 56.3541 11.4993C56.5214 11.5679 56.7008 11.6021 56.8817 11.5999H57.6673C57.9731 11.5996 58.2745 11.5273 58.5471 11.3889C58.8207 11.2476 59.0617 11.0508 59.2548 10.811C59.4633 10.5544 59.6229 10.2617 59.7255 9.94745C59.8401 9.59529 59.8971 9.22697 59.8943 8.85666H56.8817Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M63.9502 3.76599H65.2812V4.6198C65.8721 4.05994 66.6586 3.7535 67.4726 3.76599C68.4193 3.76482 69.3278 4.13965 69.9983 4.80809L69.0438 5.78202C68.8464 5.56206 68.6038 5.38729 68.3326 5.26964C68.0614 5.15198 67.7681 5.09422 67.4726 5.10027C67.1791 5.09772 66.8883 5.15632 66.6188 5.27233C66.3615 5.38582 66.1272 5.54534 65.9273 5.74306C65.7325 5.94717 65.5744 6.18327 65.4598 6.44104C65.3405 6.7075 65.2796 6.99641 65.2812 7.28835V12.9176H63.9502V3.76599Z",
  fill: "black"
}));
var UNIQLO_LOGO_SINGLE_EN = /*#__PURE__*/React__default.createElement("svg", {
  width: "60",
  height: "60",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("rect", {
  width: "40",
  height: "40",
  fill: "#FF0000"
}), /*#__PURE__*/React__default.createElement("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.21001 18.1061C11.5335 18.1061 13.4177 16.2237 13.42 13.9002V5.47021H10.89V13.9002C10.89 14.828 10.1378 15.5802 9.21001 15.5802C8.28221 15.5802 7.53001 14.828 7.53001 13.9002V5.47021H5.00001V13.9002C5.00231 16.2237 6.88651 18.1061 9.21001 18.1061ZM31.96 5.47021H29.43V18.1102H31.96V5.47021ZM25.21 34.5302H16.79V21.8902H19.32V32.0002H25.21V34.5302ZM22.68 18.1102H25.21V5.47021H22.68V12.6902L19.32 5.47021H16.79V18.1102H19.32V10.8902L22.68 18.1102ZM9.21001 21.8902C8.09171 21.8902 7.01941 22.3351 6.22951 23.1268C5.43971 23.9185 4.99731 24.9919 5.00001 26.1102V30.3202C5.00001 32.6453 6.88491 34.5302 9.21001 34.5302C9.48491 34.5329 9.75951 34.5095 10.03 34.4602L10.89 37.0602H13.42L12.17 33.3102C12.9724 32.5185 13.4228 31.4374 13.42 30.3102V26.1102C13.4227 24.9919 12.9803 23.9185 12.1905 23.1268C11.4006 22.3351 10.3283 21.8902 9.21001 21.8902ZM9.21001 32.0002C10.1378 32.0002 10.89 31.248 10.89 30.3202V26.1102C10.89 25.1824 10.1378 24.4302 9.21001 24.4302C8.28221 24.4302 7.53001 25.1824 7.53001 26.1102V30.3202C7.53001 31.248 8.28221 32.0002 9.21001 32.0002ZM30.685 21.8902C28.3567 21.8929 26.47 23.7813 26.47 26.1102V30.3202C26.47 32.6453 28.3549 34.5302 30.68 34.5302C33.0051 34.5302 34.89 32.6453 34.89 30.3202V26.1102C34.8926 24.9919 34.4503 23.9185 33.6605 23.1268C32.8718 22.3363 31.8015 21.8915 30.685 21.8902ZM30.685 21.8902L30.68 21.8902H30.69L30.685 21.8902ZM30.675 32.0052C31.6056 32.0052 32.36 31.2508 32.36 30.3202V26.1102C32.36 25.1796 31.6056 24.4252 30.675 24.4252C29.7444 24.4252 28.99 25.1796 28.99 26.1102V30.3202C28.99 31.2508 29.7444 32.0052 30.675 32.0052Z",
  fill: "white"
}));
var LIFE_WEAR_SINGLE_LOGO = /*#__PURE__*/React__default.createElement("svg", {
  width: "60",
  height: "12",
  viewBox: "0 0 70 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React__default.createElement("rect", {
  width: "70",
  height: "14",
  fill: "#fff"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M1.43816 0V11.4891H8.67768V12.9175H0V0H1.43816Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M12.2591 1.55828H10.6846V0H12.2591V1.55828ZM12.126 12.9207H10.7982V3.76585H12.126V12.9207Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M17.1194 12.9177H15.7884V5.37951H14.7041V4.06147H15.7884V2.39281C15.787 2.07022 15.8522 1.75082 15.9799 1.45459C16.0972 1.168 16.2717 0.908391 16.4929 0.691688C16.7179 0.468618 16.985 0.292587 17.2788 0.173864C17.5725 0.0551418 17.8869 -0.00389612 18.2037 0.000199376H19.2913V1.31824H18.2102C18.0673 1.31333 17.925 1.33769 17.7918 1.38982C17.6587 1.44196 17.5376 1.52077 17.4361 1.62141C17.3345 1.72206 17.2546 1.84241 17.2013 1.97506C17.1479 2.10772 17.1223 2.24988 17.1259 2.39281V4.06147H18.9959V5.37951H17.1259L17.1194 12.9177Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M22.2462 9.50225C22.2453 9.79585 22.3084 10.0861 22.4312 10.3528C22.5431 10.6121 22.7015 10.8486 22.8987 11.0508C23.1056 11.2611 23.3531 11.4271 23.6263 11.5386C23.8994 11.6501 24.1924 11.7048 24.4874 11.6994C24.7824 11.6939 25.0731 11.6284 25.342 11.5068C25.6108 11.3853 25.852 11.2102 26.051 10.9924L26.9892 11.9436C26.6629 12.2909 26.2668 12.5653 25.827 12.7487C25.3882 12.9285 24.9182 13.0201 24.444 13.0181C23.9708 13.0206 23.5023 12.9255 23.0675 12.7389C22.6493 12.562 22.2691 12.3063 21.9475 11.9858C21.6211 11.6615 21.3625 11.2754 21.1869 10.8501C21.0114 10.4249 20.9223 9.96884 20.9249 9.50874V7.18755C20.9281 6.60782 21.0743 6.03784 21.3504 5.52808C21.6265 5.01832 22.024 4.58452 22.5078 4.26509C22.9916 3.94566 23.5467 3.75046 24.124 3.69679C24.7012 3.64311 25.2828 3.73261 25.8172 3.95736C26.2362 4.13458 26.6174 4.39022 26.9405 4.71053C27.256 5.02687 27.5103 5.39891 27.6904 5.80782C27.8793 6.23858 27.9755 6.70423 27.9728 7.17456V8.49585H22.2462V9.50225ZM26.645 7.22975C26.6467 6.92418 26.586 6.62148 26.4665 6.34023C26.3556 6.07559 26.1972 5.83352 25.999 5.62602C25.8047 5.41932 25.5676 5.25756 25.3043 5.15204C25.0346 5.04087 24.7454 4.98459 24.4537 4.98648C24.1638 4.97627 23.8751 5.02705 23.6061 5.13554C23.3371 5.24403 23.0939 5.40782 22.8922 5.61628C22.4774 6.05519 22.2452 6.63558 22.2429 7.23949L26.645 7.22975Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M39.7425 10.4697L42.661 0H44.1024L40.3983 12.9175H38.9764L36.5837 2.70751L34.1879 12.9175H32.7627L29.0391 0H30.4805L33.399 10.4697L35.8695 0H37.2915L39.7425 10.4697Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M46.5339 9.50271C46.5319 9.79364 46.5928 10.0816 46.7124 10.3468C46.8243 10.606 46.9828 10.8426 47.1799 11.0448C47.5882 11.456 48.1425 11.6894 48.722 11.694C49.0276 11.7003 49.3309 11.6403 49.6112 11.5181C49.8914 11.3959 50.1418 11.2145 50.3452 10.9863L51.2802 11.9375C50.9557 12.2855 50.5605 12.56 50.1212 12.7426C49.6813 12.9228 49.2103 13.0143 48.735 13.0121C48.2629 13.0146 47.7954 12.9195 47.3617 12.7329C46.9387 12.5564 46.5539 12.2996 46.2287 11.9765C45.9023 11.6522 45.6438 11.2662 45.4682 10.8409C45.2926 10.4156 45.2035 9.95956 45.2061 9.49946V7.17827C45.2094 6.59854 45.3555 6.02856 45.6316 5.5188C45.9077 5.00904 46.3053 4.57524 46.7891 4.25581C47.2729 3.93638 47.828 3.74118 48.4052 3.68751C48.9825 3.63383 49.5641 3.72333 50.0985 3.94808C50.5178 4.12459 50.8992 4.38032 51.2217 4.70125C51.5393 5.02036 51.7947 5.39576 51.9749 5.80828C52.1612 6.23974 52.2562 6.70507 52.2541 7.17503V8.49632H46.5339V9.50271ZM50.9328 7.23021C50.9361 6.92449 50.8753 6.62147 50.7542 6.34069C50.6422 6.07669 50.4839 5.83482 50.2868 5.62648C50.0922 5.42156 49.8566 5.26004 49.5953 5.1525C49.3243 5.04166 49.0342 4.98539 48.7415 4.98694C48.4516 4.97673 48.1628 5.02751 47.8938 5.136C47.6248 5.2445 47.3816 5.40828 47.1799 5.61674C46.7651 6.05565 46.533 6.63604 46.5306 7.23995L50.9328 7.23021Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M59.8943 7.1815C59.8952 6.89034 59.8332 6.60243 59.7125 6.33744C59.5979 6.07809 59.4374 5.84162 59.2386 5.63945C59.0347 5.44126 58.7973 5.28079 58.5373 5.16548C58.2668 5.05249 57.9767 4.99402 57.6835 4.99342C57.2541 4.9905 56.834 5.11846 56.4791 5.36026C56.1184 5.59852 55.8351 5.93705 55.6643 6.33419L54.4306 5.83424C54.7026 5.18333 55.1612 4.62754 55.7487 4.237C56.3254 3.85387 57.0042 3.65361 57.6965 3.66239C58.1664 3.65817 58.6319 3.75217 59.0633 3.93833C59.4784 4.11739 59.8561 4.37288 60.1768 4.6915C60.4969 5.0104 60.7536 5.38716 60.9332 5.80177C61.1221 6.23254 61.2183 6.69818 61.2156 7.16852V12.9179H59.8684V11.7882C59.6221 12.1439 59.2917 12.4333 58.9065 12.6304C58.5214 12.8275 58.0934 12.9263 57.6608 12.9179H56.8752C56.5102 12.9219 56.1485 12.8489 55.8136 12.7037C55.4935 12.5693 55.2024 12.3741 54.9565 12.129C54.7088 11.8852 54.5114 11.5951 54.3754 11.2752C54.2324 10.9454 54.1595 10.5894 54.1612 10.2299C54.1592 9.86719 54.2321 9.50799 54.3754 9.1748C54.5131 8.85679 54.7103 8.56807 54.9565 8.32424C55.2041 8.08124 55.4948 7.88638 55.8136 7.74963C56.1485 7.6044 56.5102 7.5314 56.8752 7.53537H59.8879L59.8943 7.1815ZM56.8817 8.85666C56.7009 8.85308 56.5214 8.88636 56.3539 8.95445C56.1865 9.02254 56.0347 9.12403 55.9077 9.25272C55.65 9.51133 55.5053 9.86155 55.5053 10.2266C55.5053 10.5917 55.65 10.942 55.9077 11.2006C56.035 11.3291 56.1868 11.4307 56.3541 11.4993C56.5214 11.5679 56.7008 11.6021 56.8817 11.5999H57.6673C57.9731 11.5996 58.2745 11.5273 58.5471 11.3889C58.8207 11.2476 59.0617 11.0508 59.2548 10.811C59.4633 10.5544 59.6229 10.2617 59.7255 9.94745C59.8401 9.59529 59.8971 9.22697 59.8943 8.85666H56.8817Z",
  fill: "black"
}), /*#__PURE__*/React__default.createElement("path", {
  d: "M63.9502 3.76599H65.2812V4.6198C65.8721 4.05994 66.6586 3.7535 67.4726 3.76599C68.4193 3.76482 69.3278 4.13965 69.9983 4.80809L69.0438 5.78202C68.8464 5.56206 68.6038 5.38729 68.3326 5.26964C68.0614 5.15198 67.7681 5.09422 67.4726 5.10027C67.1791 5.09772 66.8883 5.15632 66.6188 5.27233C66.3615 5.38582 66.1272 5.54534 65.9273 5.74306C65.7325 5.94717 65.5744 6.18327 65.4598 6.44104C65.3405 6.7075 65.2796 6.99641 65.2812 7.28835V12.9176H63.9502V3.76599Z",
  fill: "black"
}));
var LoadingIndicator = function LoadingIndicator(_a) {
  var variant = _a.variant,
      override = _a.override,
      _b = _a.iconBrand,
      iconBrand = _b === void 0 ? 'uq-ec-' : _b,
      props = __rest(_a, ["variant", "override", "iconBrand"]);

  var width = getViewportWidth();

  var getOverrideVariant = function getOverrideVariant(breakpoint) {
    return override && override.hasOwnProperty(breakpoint) && override[breakpoint];
  };

  var activeFullScreen = function activeFullScreen() {
    if (typeof override !== 'undefined') {
      if (width >= designTokens_3.mqLargeScreenMinWidthLimit) {
        return getOverrideVariant(BP_LARGE);
      } else if (width >= designTokens_3.mqMediumScreenMinWidthLimit && width <= designTokens_3.mqMediumScreenMaxWidthLimit) {
        return getOverrideVariant(BP_MEDIUM);
      } else if (width <= designTokens_3.mqSmallScreenMaxWidthLimit) {
        return getOverrideVariant(BP_SMALL);
      }
    }

    return false;
  };

  var currentVariant = activeFullScreen() || variant;
  var hasOverlay = currentVariant === 'full-screen' || currentVariant === 'L1' || currentVariant === 'L1-single';
  var spinningLoader = /*#__PURE__*/React__default.createElement("div", {
    className: styles$1f.loadingIndicatorSpinnerContainer
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$1f.loadingIndicatorSpinner
  }), /*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(styles$1f.loadingIndicatorSpinner, styles$1f.loadingIndicatorSpinner2)
  }));

  var getLoader = function getLoader() {
    if (variant === 'L1') {
      return /*#__PURE__*/React__default.createElement(ContentAlignment, {
        element: 'div',
        direction: 'column',
        className: styles$1f.loadingIndicatorContainer,
        alignment: 'center'
      }, /*#__PURE__*/React__default.createElement(ContentAlignment, {
        element: 'div',
        direction: 'row',
        className: styles$1f.loadingIndicatorContainerUqLogos,
        alignment: 'stretch'
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorFirstLogo
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorJpLogoFirst
      }, UNIQLO_LOGO_JP), /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorJpLogoSecond
      }, UNIQLO_LOGO_EN), /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorJpLogoThird
      }, UNIQLO_LOGO_JP)), /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorFirstLogo
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorJpLogoFirst
      }, UNIQLO_LOGO_EN), /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorJpLogoSecond
      }, UNIQLO_LOGO_JP), /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorJpLogoThird
      }, UNIQLO_LOGO_EN))), LIFE_WEAR_LOGO);
    } else if (variant === 'L1-single') {
      return /*#__PURE__*/React__default.createElement(ContentAlignment, {
        element: 'div',
        direction: 'column',
        className: styles$1f.loadingIndicatorContainer,
        alignment: 'center'
      }, iconBrand === 'uq-ec-' ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorL1SingleLogo
      }, /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorJpLogoFirst
      }, UNIQLO_LOGO_SINGLE_EN), /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorJpLogoSecond
      }, UNIQLO_LOGO_SINGLE_EN), /*#__PURE__*/React__default.createElement("div", {
        className: styles$1f.loadingIndicatorJpLogoThird
      }, UNIQLO_LOGO_SINGLE_EN)), LIFE_WEAR_SINGLE_LOGO) : spinningLoader);
    }

    return spinningLoader;
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", __assign({
    className: joinClasses(styles$1f.loadingIndicator, styles$1f["loading-indicator--" + currentVariant])
  }, props), getLoader()), hasOverlay && /*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(styles$1f.loadingIndicatorOverlay, (currentVariant === 'L1' || currentVariant === 'L1-single') && styles$1f.loadingIndicatorOverlayL1)
  }));
};
LoadingIndicator.displayName = 'CoreLoadingIndicator';

var priceTextStyles = {"price-text--small":"fr-ec-price-text--small","priceTextSmall":"fr-ec-price-text--small","price-text--large":"fr-ec-price-text--large","priceTextLarge":"fr-ec-price-text--large","price-text--l1":"fr-ec-price-text--l1","priceTextL1":"fr-ec-price-text--l1","price-text--extra-small":"fr-ec-price-text--extra-small","priceTextExtraSmall":"fr-ec-price-text--extra-small"};

var styles$1g = {"price-text":"fr-ec-price-text","priceText":"fr-ec-price-text","price-text--color-primary-dark":"fr-ec-price-text--color-primary-dark","priceTextColorPrimaryDark":"fr-ec-price-text--color-primary-dark","price-text--color-primary-light":"fr-ec-price-text--color-primary-light","priceTextColorPrimaryLight":"fr-ec-price-text--color-primary-light","price-text--color-promotional":"fr-ec-price-text--color-promotional","priceTextColorPromotional":"fr-ec-price-text--color-promotional"};

var variants = {
  extraSmall: 'extra-small',
  l1: 'l1',
  large: 'large',
  small: 'small'
};
var PriceText = function PriceText(_a) {
  var Element = _a.element,
      _b = _a.variant,
      variant = _b === void 0 ? 'small' : _b,
      _c = _a.color,
      color = _c === void 0 ? 'primary-dark' : _c,
      className = _a.className,
      _d = _a.textTransform,
      textTransform = _d === void 0 ? 'normal' : _d,
      props = __rest(_a, ["element", "variant", "color", "className", "textTransform"]);

  return /*#__PURE__*/createElement(Element, __assign({
    className: joinClasses(styles$1g.priceText, priceTextStyles["price-text--" + variants[variant]], styles$1g["price-text--color-" + color], textTransformStyles["text-transform-" + textTransform], className)
  }, props));
};
PriceText.displayName = 'CorePriceText';

var styles$1h = {"price":"fr-ec-price","price__amount":"fr-ec-price__amount","priceAmount":"fr-ec-price__amount","price__tax":"fr-ec-price__tax","priceTax":"fr-ec-price__tax","price__strike-through":"fr-ec-price__strike-through","priceStrikeThrough":"fr-ec-price__strike-through","price__discount":"fr-ec-price__discount","priceDiscount":"fr-ec-price__discount","price__amount--large":"fr-ec-price__amount--large","priceAmountLarge":"fr-ec-price__amount--large"};

var Price = function Price(_a) {
  var element = _a.element,
      _b = _a.variant,
      variant = _b === void 0 ? 'standard' : _b,
      size = _a.size,
      className = _a.className,
      children = _a.children,
      tax = _a.tax,
      _c = _a.ariaLabel,
      ariaLabel = _c === void 0 ? "price is " + children + (tax ? ' plus tax' : '') : _c,
      _d = _a.wordBreak,
      wordBreak = _d === void 0 ? 'none' : _d,
      _e = _a.strikeThrough,
      strikeThrough = _e === void 0 ? false : _e,
      discount = _a.discount,
      props = __rest(_a, ["element", "variant", "size", "className", "children", "tax", "ariaLabel", "wordBreak", "strikeThrough", "discount"]);

  var color = {
    light: 'primary-light',
    promotional: 'promotional',
    standard: 'primary-dark'
  }[variant];
  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$1h.price, addWordBreak(wordBreak === 'break-word'), className),
    "aria-label": ariaLabel
  }, props), /*#__PURE__*/createElement(ContentAlignment, {
    direction: "row",
    className: joinClasses(styles$1h.priceAmount, styles$1h["price__amount--" + size]),
    element: "div",
    alignment: "baseline"
  }, /*#__PURE__*/createElement(PriceText, {
    element: element,
    variant: size,
    color: color,
    className: joinClasses(strikeThrough && styles$1h.priceStrikeThrough, discount && styles$1h.priceDiscount)
  }, children), discount && /*#__PURE__*/createElement(Caption, {
    variant: "small",
    element: 'div'
  }, discount), tax && /*#__PURE__*/createElement(HintError, {
    className: styles$1h.priceTax,
    hint: tax,
    key: "tax"
  })));
};
Price.displayName = 'CorePrice';

var styles$1i = {"media-banner":"fr-ec-media-banner","mediaBanner":"fr-ec-media-banner","media-banner__children":"fr-ec-media-banner__children","mediaBannerChildren":"fr-ec-media-banner__children","image":"fr-ec-image","video-inline":"fr-ec-video-inline","videoInline":"fr-ec-video-inline","video-inline__video":"fr-ec-video-inline__video","videoInlineVideo":"fr-ec-video-inline__video","media-banner__text-wrapper":"fr-ec-media-banner__text-wrapper","mediaBannerTextWrapper":"fr-ec-media-banner__text-wrapper","media-banner__title":"fr-ec-media-banner__title","mediaBannerTitle":"fr-ec-media-banner__title","media-banner__description":"fr-ec-media-banner__description","mediaBannerDescription":"fr-ec-media-banner__description","media-banner__copy-right-text":"fr-ec-media-banner__copy-right-text","mediaBannerCopyRightText":"fr-ec-media-banner__copy-right-text","media-banner__flag-text":"fr-ec-media-banner__flag-text","mediaBannerFlagText":"fr-ec-media-banner__flag-text","media-banner__logo-container":"fr-ec-media-banner__logo-container","mediaBannerLogoContainer":"fr-ec-media-banner__logo-container","media-banner__model-name":"fr-ec-media-banner__model-name","mediaBannerModelName":"fr-ec-media-banner__model-name","image__img":"fr-ec-image__img","imageImg":"fr-ec-image__img","media-banner__logo":"fr-ec-media-banner__logo","mediaBannerLogo":"fr-ec-media-banner__logo","media-banner__price":"fr-ec-media-banner__price","mediaBannerPrice":"fr-ec-media-banner__price","price__amount":"fr-ec-price__amount","priceAmount":"fr-ec-price__amount","media-banner__text-shadow":"fr-ec-media-banner__text-shadow","mediaBannerTextShadow":"fr-ec-media-banner__text-shadow","media-banner__shadow":"fr-ec-media-banner__shadow","mediaBannerShadow":"fr-ec-media-banner__shadow"};

var MediaBanner = function MediaBanner(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'normal' : _b,
      description = _a.description,
      title = _a.title,
      _c = _a.textColor,
      textColor = _c === void 0 ? 'white' : _c,
      logoImage = _a.logoImage,
      priceText = _a.priceText,
      _d = _a.priceTextColor,
      priceTextColor = _d === void 0 ? 'white' : _d,
      priceLabel = _a.priceLabel,
      children = _a.children,
      className = _a.className,
      modelName = _a.modelName,
      _e = _a.modelNameColor,
      modelNameColor = _e === void 0 ? 'white' : _e,
      copyrightText = _a.copyrightText,
      _f = _a.copyrightTextColor,
      copyrightTextColor = _f === void 0 ? 'white' : _f,
      props = __rest(_a, ["variant", "description", "title", "textColor", "logoImage", "priceText", "priceTextColor", "priceLabel", "children", "className", "modelName", "modelNameColor", "copyrightText", "copyrightTextColor"]);

  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(className, styles$1i.mediaBanner)
  }, props), /*#__PURE__*/createElement("div", {
    className: styles$1i.mediaBannerChildren
  }, children), /*#__PURE__*/createElement("div", {
    className: styles$1i.mediaBannerShadow
  }), modelName && /*#__PURE__*/createElement(Caption, {
    element: "span",
    className: styles$1i.mediaBannerModelName,
    color: modelNameColor === 'black' ? 'primary-dark' : 'primary-light'
  }, modelName), /*#__PURE__*/createElement("div", {
    className: styles$1i.mediaBannerTextWrapper
  }, logoImage && /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$1i.mediaBannerLogoContainer)
  }, logoImage.map(function (logo, index) {
    return /*#__PURE__*/createElement(Fragment, {
      key: index
    }, logo);
  })), title && /*#__PURE__*/createElement(Display, {
    variant: "display1-ER",
    className: joinClasses(styles$1i.mediaBannerTitle, textColor === 'white' && styles$1i.mediaBannerTextShadow),
    element: "h1",
    children: title,
    color: textColor === 'black' ? 'primary-dark' : 'primary-light'
  }), description && /*#__PURE__*/createElement(Title, {
    className: joinClasses(spacingStyles.mbSpacing04, styles$1i.mediaBannerDescription, textColor === 'white' && styles$1i.mediaBannerTextShadow),
    element: "h2",
    variant: "large",
    color: textColor === 'black' ? 'primary-dark' : 'primary-light'
  }, description), variant === 'withPrice' && /*#__PURE__*/createElement(Fragment, null, priceText && /*#__PURE__*/createElement(Price, {
    element: "p",
    size: 'l1',
    children: priceText,
    variant: priceTextColor === 'red' ? 'promotional' : priceTextColor === 'white' ? 'light' : 'standard',
    className: styles$1i.mediaBannerPrice
  }), priceLabel && /*#__PURE__*/createElement(FlagText, {
    color: priceTextColor === 'red' ? 'promotional' : priceTextColor === 'white' ? 'primary-light' : 'primary-dark',
    textTransform: "normal",
    variant: "large",
    element: "p",
    className: joinClasses(styles$1i.mediaBannerFlagText, spacingStyles.mbSpacing04)
  }, priceLabel)), copyrightText && /*#__PURE__*/createElement(Caption, {
    element: "p",
    variant: "media-banner-copyright",
    color: copyrightTextColor === 'black' ? 'primary-dark' : 'primary-light',
    className: joinClasses(styles$1i.mediaBannerCopyRightText, copyrightTextColor === 'white' && styles$1i.mediaBannerTextShadow)
  }, copyrightText)));
};
MediaBanner.displayName = 'CoreMediaBanner';
MediaBanner.defaultProps = {
  copyrightTextColor: 'white',
  modelNameColor: 'white',
  priceTextColor: 'white',
  textColor: 'white',
  variant: 'normal'
};

var styles$1j = {"media-object":"fr-ec-media-object","mediaObject":"fr-ec-media-object","media-object__media":"fr-ec-media-object__media","mediaObjectMedia":"fr-ec-media-object__media","media-object__media--right":"fr-ec-media-object__media--right","mediaObjectMediaRight":"fr-ec-media-object__media--right","media-object__media--large":"fr-ec-media-object__media--large","mediaObjectMediaLarge":"fr-ec-media-object__media--large","media-object__media--small":"fr-ec-media-object__media--small","mediaObjectMediaSmall":"fr-ec-media-object__media--small","media-object__content":"fr-ec-media-object__content","mediaObjectContent":"fr-ec-media-object__content","media-object__small-container--vertical-wrapper":"fr-ec-media-object__small-container--vertical-wrapper","mediaObjectSmallContainerVerticalWrapper":"fr-ec-media-object__small-container--vertical-wrapper","media-object__small-container--vertical":"fr-ec-media-object__small-container--vertical","mediaObjectSmallContainerVertical":"fr-ec-media-object__small-container--vertical"};

var MediaObject = function MediaObject(_a) {
  var media = _a.media,
      children = _a.children,
      variation = _a.variation,
      _b = _a.mediaPosition,
      mediaPosition = _b === void 0 ? 'left' : _b,
      _c = _a.smallContainer,
      smallContainer = _c === void 0 ? 'horizontal' : _c,
      className = _a.className,
      props = __rest(_a, ["media", "children", "variation", "mediaPosition", "smallContainer", "className"]);

  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$1j.mediaObject, mediaPosition === 'right' && styles$1j.mediaObjectMediaRight, smallContainer === 'vertical' && styles$1j.mediaObjectSmallContainerVerticalWrapper, className)
  }, props), /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$1j.mediaObjectMedia, smallContainer !== 'vertical' ? styles$1j["media-object__media--" + variation] : styles$1j.mediaObjectSmallContainerVertical)
  }, media), /*#__PURE__*/createElement("div", {
    className: styles$1j.mediaObjectContent
  }, children));
};
MediaObject.displayName = 'CoreMediaObject';

var styles$1k = {"modal-backdrop":"fr-ec-modal-backdrop","modalBackdrop":"fr-ec-modal-backdrop","modal-backdrop--filter":"fr-ec-modal-backdrop--filter","modalBackdropFilter":"fr-ec-modal-backdrop--filter","modal-backdrop--modal":"fr-ec-modal-backdrop--modal","modalBackdropModal":"fr-ec-modal-backdrop--modal","modal--small":"fr-ec-modal--small","modalSmall":"fr-ec-modal--small","modal--large":"fr-ec-modal--large","modalLarge":"fr-ec-modal--large","modal--full-width":"fr-ec-modal--full-width","modalFullWidth":"fr-ec-modal--full-width","slideUp":"fr-ec-slideUp","overlay-content":"fr-ec-overlay-content","overlayContent":"fr-ec-overlay-content","overlay-wrapper":"fr-ec-overlay-wrapper","overlayWrapper":"fr-ec-overlay-wrapper","overlay-body":"fr-ec-overlay-body","overlayBody":"fr-ec-overlay-body","modal--overlay--full-width-top":"fr-ec-modal--overlay--full-width-top","modalOverlayFullWidthTop":"fr-ec-modal--overlay--full-width-top","modal--overlay--full-width":"fr-ec-modal--overlay--full-width","modalOverlayFullWidth":"fr-ec-modal--overlay--full-width","modal__overlay--footer-large":"fr-ec-modal__overlay--footer-large","modalOverlayFooterLarge":"fr-ec-modal__overlay--footer-large","overlay-body__footer":"fr-ec-overlay-body__footer","overlayBodyFooter":"fr-ec-overlay-body__footer","keyline":"fr-ec-keyline","modal__overlay--footer-large-relative":"fr-ec-modal__overlay--footer-large-relative","modalOverlayFooterLargeRelative":"fr-ec-modal__overlay--footer-large-relative","modal--large-relative":"fr-ec-modal--large-relative","modalLargeRelative":"fr-ec-modal--large-relative","modal--backdrop--large":"fr-ec-modal--backdrop--large","modalBackdropLarge":"fr-ec-modal--backdrop--large","modal__header--sticky":"fr-ec-modal__header--sticky","modalHeaderSticky":"fr-ec-modal__header--sticky","modal__container--with-sticky-header":"fr-ec-modal__container--with-sticky-header","modalContainerWithStickyHeader":"fr-ec-modal__container--with-sticky-header","header-overlay":"fr-ec-header-overlay","headerOverlay":"fr-ec-header-overlay","modal--filter":"fr-ec-modal--filter","modalFilter":"fr-ec-modal--filter","header-overlay__button":"fr-ec-header-overlay__button","headerOverlayButton":"fr-ec-header-overlay__button","flyout-select":"fr-ec-flyout-select","flyoutSelect":"fr-ec-flyout-select","flyout-select__list":"fr-ec-flyout-select__list","flyoutSelectList":"fr-ec-flyout-select__list"};

var variantStyles$1 = {
  filter: styles$1k.modalFilter,
  fullwidth: styles$1k.modalFullWidth,
  large: styles$1k.modalLarge,
  small: styles$1k.modalSmall
};

var Modal =
/** @class */
function (_super) {
  __extends(Modal, _super);

  function Modal(props) {
    var _this = _super.call(this, props) || this;

    _this.currentPosition = 0;
    _this.currentPositionVal = 0;

    _this.iterateOverChildren = function () {
      var _a, _b, _c, _d, _e, _f, _g, _h;

      var el = (_a = _this.swiperRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.fr-ec-toast');

      if (el) {
        var r1 = el.closest(".fr-ec-overlay-content");

        if (Boolean(r1)) {
          if ((_b = _this.bodyRef) === null || _b === void 0 ? void 0 : _b.current) {
            if ((_e = (_d = (_c = r1 === null || r1 === void 0 ? void 0 : r1.nextElementSibling) === null || _c === void 0 ? void 0 : _c.querySelector('.fr-ec-button')) === null || _d === void 0 ? void 0 : _d.getBoundingClientRect()) === null || _e === void 0 ? void 0 : _e.top) {
              var topMargin = 8;
              el.style.bottom = 'auto';
              el.style.top = (((_h = (_g = (_f = r1 === null || r1 === void 0 ? void 0 : r1.nextElementSibling) === null || _f === void 0 ? void 0 : _f.querySelector('.fr-ec-button')) === null || _g === void 0 ? void 0 : _g.getBoundingClientRect()) === null || _h === void 0 ? void 0 : _h.top) || 0) - el.clientHeight - topMargin + "px";
            }
          }
        }
      }
    };

    _this.onOpenModal = function () {
      if (isInBrowser$1()) {
        document.addEventListener('keydown', _this.handleDocumentKeyDown);
      }

      if (_this.swiperRef.current) {
        _this.swiperRef.current.addEventListener('scroll', _this.handleScroll);
      }
    };

    _this.handleScroll = function () {
      var _a, _b, _c;

      if (_this.swiperRef.current) {
        if (((_a = _this.swiperRef.current) === null || _a === void 0 ? void 0 : _a.scrollTop) >= window.innerHeight * 0.2) {
          (_b = _this.swiperRef.current) === null || _b === void 0 ? void 0 : _b.classList.add('fr-ec-modal__container--with-sticky-header');

          if (_this.headerRef.current && _this.bodyRef.current) {
            // tslint:disable-next-line: no-console
            _this.bodyRef.current.style.marginTop = _this.headerRef.current.getBoundingClientRect().height + "px";
          }
        } else {
          (_c = _this.swiperRef.current) === null || _c === void 0 ? void 0 : _c.classList.remove('fr-ec-modal__container--with-sticky-header');

          if (_this.bodyRef.current) {
            _this.bodyRef.current.style.marginTop = '0';
          }
        }
      }
    };

    _this.onCloseModal = function () {
      if (isInBrowser$1()) {
        document.removeEventListener('keydown', _this.handleDocumentKeyDown);
      }
    };

    _this.handleCloseModal = function (event) {
      var _a = _this.props,
          onRequestClose = _a.onRequestClose,
          backgroundScroll = _a.backgroundScroll;

      if (onRequestClose) {
        onRequestClose(event);
      }

      if (!backgroundScroll) {
        _this.scrollRemoval(false);
      }
    };

    _this.handleDocumentKeyDown = function (event) {
      if (event.keyCode === 27) {
        if (typeof _this.props.onBackdropClick === 'function') {
          _this.props.onBackdropClick(event);
        } else if (_this.props.onRequestClose) {
          _this.props.onRequestClose(event);
        }
      }
    };

    _this.backdropClick = function (event) {
      if (event.target === event.currentTarget) {
        if (typeof _this.props.onBackdropClick === 'function') {
          _this.props.onBackdropClick(event);
        } else if (_this.props.onRequestClose) {
          _this.props.onRequestClose(event);
        }
      }
    };

    _this.scrollRemoval = function (disable) {
      if (isInBrowser$1()) {
        if (typeof document === 'undefined') {
          return;
        }

        var docElement = document.querySelector(_this.props.scrollDisableElement || 'body');

        if (disable) {
          _this.currentPosition = window.pageYOffset;
          docElement.classList.add(interactionsStyles.scrollDisabled);
          docElement.style.top = -_this.currentPosition + "px";
        } else {
          docElement.classList.remove(interactionsStyles.scrollDisabled);
          docElement.style.top = '';
          window.scrollTo(0, _this.currentPosition);
        }
      }
    };

    _this.getFooterHeight = function (height) {
      if (_this.bodyExtraRef.current) {
        _this.bodyExtraRef.current.style.height = height + "px";
      }
    };

    _this.swiperRef = /*#__PURE__*/createRef();
    _this.headerRef = /*#__PURE__*/createRef();
    _this.bodyRef = /*#__PURE__*/createRef();
    _this.bodyExtraRef = /*#__PURE__*/createRef();
    return _this;
  }

  Modal.prototype.componentDidMount = function () {
    var _a = this.props,
        isOpen = _a.isOpen,
        backgroundScroll = _a.backgroundScroll;

    if (isOpen) {
      this.onOpenModal();

      if (!backgroundScroll) {
        this.scrollRemoval(true);
      }
    }
  };

  Modal.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      this.props.isOpen ? this.onOpenModal() : this.onCloseModal();

      if (!this.props.backgroundScroll) {
        this.scrollRemoval(this.props.isOpen);
      }
    }

    if (isInBrowser$1()) {
      var docElement = document.querySelector(this.props.scrollDisableElement || 'body');

      if (this.props.isOpen && !docElement.classList.contains(interactionsStyles.scrollDisabled)) {
        docElement.classList.add(interactionsStyles.scrollDisabled);
        docElement.style.top = -this.currentPosition + "px";
      }

      this.iterateOverChildren();
    }
  };

  Modal.prototype.componentWillUnmount = function () {
    if (isInBrowser$1()) {
      document.removeEventListener('keydown', this.handleDocumentKeyDown);
    }

    if (!this.props.backgroundScroll) {
      this.scrollRemoval(false);
    }
  };

  Modal.prototype.render = function () {
    var _a = this.props,
        errors = _a.errors,
        variant = _a.variant,
        _b = _a.titleId,
        titleId = _b === void 0 ? 'modal-title' : _b,
        closeLabel = _a.closeLabel,
        closeTitle = _a.closeTitle,
        title = _a.title,
        subtitle = _a.subtitle,
        subtitleExtra = _a.subtitleExtra,
        children = _a.children,
        isOpen = _a.isOpen,
        onRequestClose = _a.onRequestClose,
        _c = _a.trapFocus,
        trapFocus = _c === void 0 ? true : _c,
        footer = _a.footer,
        className = _a.className,
        _e = _a.labelElement,
        labelElement = _e === void 0 ? 'h5' : _e,
        itemCount = _a.itemCount,
        fullWidthContent = _a.fullWidthContent,
        iconBrand = _a.iconBrand,
        _f = _a.fullWidthContentPosition,
        fullWidthContentPosition = _f === void 0 ? 'bottom' : _f,
        _g = _a.fixedButtonLayout,
        fixedButtonLayout = _g === void 0 ? false : _g,
        props = __rest(_a, ["errors", "variant", "titleId", "closeLabel", "closeTitle", "title", "subtitle", "subtitleExtra", "children", "isOpen", "onRequestClose", "onBackdropClick", "trapFocus", "footer", "backgroundScroll", "className", "scrollDisableElement", "labelElement", "itemCount", "fullWidthContent", "iconBrand", "fullWidthContentPosition", "fixedButtonLayout"]);

    var backdropClass = variant === 'filter' ? styles$1k.modalBackdropFilter : joinClasses(styles$1k.modalBackdrop, styles$1k.modalBackdropModal, variant === 'large' && styles$1k.modalBackdropLarge);
    var isLarge = variant === 'large';
    var footerLayout = fixedButtonLayout ? /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Keyline, null), " ", footer) : footer;
    return isOpen && /*#__PURE__*/createElement(OverlayBackdrop, {
      className: backdropClass,
      hidden: false,
      "aria-hidden": false,
      role: 'presentation',
      onClick: this.backdropClick,
      ref: this.swiperRef
    }, /*#__PURE__*/createElement(FocusTrap, {
      active: trapFocus,
      focusTrapOptions: {
        clickOutsideDeactivates: true,
        escapeDeactivates: false,
        returnFocusOnDeactivate: true
      }
    }, /*#__PURE__*/createElement(OverlayWrapper, __assign({
      role: "dialog",
      "aria-modal": true,
      tabIndex: -1,
      "aria-labelledby": titleId,
      className: joinClasses(variantStyles$1[variant], isLarge && !fixedButtonLayout && styles$1k.modalLargeRelative, className)
    }, props), /*#__PURE__*/createElement(HeaderOverlay, {
      isModal: true,
      itemCount: itemCount,
      title: title,
      subtitle: subtitle,
      subtitleExtra: subtitleExtra,
      closeLabel: closeLabel,
      closeTitle: closeTitle,
      onRequestClose: onRequestClose,
      titleId: titleId,
      labelElement: labelElement,
      errors: errors,
      iconBrand: iconBrand,
      ref: this.headerRef
    }), /*#__PURE__*/createElement(OverlayBody, {
      className: joinClasses(isLarge && (fixedButtonLayout ? styles$1k.modalOverlayFooterLarge : styles$1k.modalOverlayFooterLargeRelative)),
      footer: footerLayout,
      isModal: true,
      ref: this.bodyRef,
      onHeightChange: this.getFooterHeight
    }, fullWidthContentPosition === 'top' && /*#__PURE__*/createElement("div", {
      className: styles$1k.modalOverlayFullWidthTop
    }, fullWidthContent), children, fullWidthContentPosition === 'bottom' && /*#__PURE__*/createElement("div", {
      className: styles$1k.modalOverlayFullWidth
    }, fullWidthContent), isLarge && fixedButtonLayout && /*#__PURE__*/createElement("div", {
      ref: this.bodyExtraRef
    })))));
  };

  Modal.displayName = 'CoreModal';
  Modal.defaultProps = {
    backgroundScroll: false,
    scrollDisableElement: 'body',
    titleId: 'modal-title',
    trapFocus: false
  };
  return Modal;
}(Component);
Modal.defaultProps = {
  labelElement: 'h5',
  titleId: 'modal-title',
  trapFocus: true
};

var LayoutHiddenAtSmallMedium = function LayoutHiddenAtSmallMedium(props) {
  return /*#__PURE__*/createElement(Layout, __assign({
    visible: {
      sm: false,
      md: false,
      lg: true
    }
  }, props));
};
LayoutHiddenAtSmallMedium.displayName = 'CoreLayoutHiddenAtSmallMedium';

var styles$1l = {"navigation-ribbon":"fr-ec-navigation-ribbon","navigationRibbon":"fr-ec-navigation-ribbon","navigation-ribbon__wrapper":"fr-ec-navigation-ribbon__wrapper","navigationRibbonWrapper":"fr-ec-navigation-ribbon__wrapper","navigation-ribbon__left":"fr-ec-navigation-ribbon__left","navigationRibbonLeft":"fr-ec-navigation-ribbon__left","navigation-ribbon__left-column":"fr-ec-navigation-ribbon__left-column","navigationRibbonLeftColumn":"fr-ec-navigation-ribbon__left-column","navigation-ribbon__right":"fr-ec-navigation-ribbon__right","navigationRibbonRight":"fr-ec-navigation-ribbon__right","navigation-ribbon__right-column":"fr-ec-navigation-ribbon__right-column","navigationRibbonRightColumn":"fr-ec-navigation-ribbon__right-column"};

var NavigationRibbon = function NavigationRibbon(_a) {
  var leftContent = _a.leftContent,
      rightContentOne = _a.rightContentOne,
      rightContentTwo = _a.rightContentTwo,
      className = _a.className,
      props = __rest(_a, ["leftContent", "rightContentOne", "rightContentTwo", "className"]);

  return /*#__PURE__*/createElement(LayoutHiddenAtSmallMedium, __assign({
    gutter: false,
    className: joinClasses(styles$1l.navigationRibbon, className)
  }, props), /*#__PURE__*/createElement(LayoutWrapper, {
    element: "div",
    className: styles$1l.navigationRibbonWrapper
  }, /*#__PURE__*/createElement("div", {
    className: styles$1l.navigationRibbonLeft
  }, /*#__PURE__*/createElement("div", {
    className: joinClasses(resetStyles.maxWidthReset, styles$1l.navigationRibbonLeftColumn)
  }, /*#__PURE__*/createElement(Caption, {
    element: "span"
  }, leftContent))), /*#__PURE__*/createElement("div", {
    className: styles$1l.navigationRibbonRight
  }, /*#__PURE__*/createElement("div", {
    className: styles$1l.navigationRibbonRightColumn
  }, rightContentOne), /*#__PURE__*/createElement("div", {
    className: styles$1l.navigationRibbonRightColumn
  }, rightContentTwo))));
};
NavigationRibbon.displayName = 'CoreNavigationRibbon';

var styles$1m = {"query-text":"fr-ec-query-text","queryText":"fr-ec-query-text"};

var Highlighter = require('react-highlight-words'); // ES6 import doesn't work properly. Using 'require' as recommended here - https://github.com/DefinitelyTyped/DefinitelyTyped/issues/33050
var QueryText = function QueryText(_a) {
  var queryWords = _a.queryWords,
      text = _a.text,
      className = _a.className,
      props = __rest(_a, ["queryWords", "text", "className"]);

  return /*#__PURE__*/createElement(Highlighter, __assign({
    className: joinClasses(bodyStyles.body, typographyStyles.bodyStandard, styles$1m.queryText, className),
    searchWords: queryWords,
    textToHighlight: text,
    highlightClassName: joinClasses(typographyStyles.bodyStandardEmphasized, resetStyles.markReset),
    autoEscape: true
  }, props));
};
QueryText.displayName = 'CoreQueryText';

var styles$1n = {"typeahead":"fr-ec-typeahead","typeahead--focus":"fr-ec-typeahead--focus","typeaheadFocus":"fr-ec-typeahead--focus","typeahead__query-text":"fr-ec-typeahead__query-text","typeaheadQueryText":"fr-ec-typeahead__query-text","typeahead__image":"fr-ec-typeahead__image","typeaheadImage":"fr-ec-typeahead__image","typeahead__icon":"fr-ec-typeahead__icon","typeaheadIcon":"fr-ec-typeahead__icon","typeahead__content":"fr-ec-typeahead__content","typeaheadContent":"fr-ec-typeahead__content","typeahead__text-content":"fr-ec-typeahead__text-content","typeaheadTextContent":"fr-ec-typeahead__text-content","typeahead__category":"fr-ec-typeahead__category","typeaheadCategory":"fr-ec-typeahead__category","typeahead__sub-title":"fr-ec-typeahead__sub-title","typeaheadSubTitle":"fr-ec-typeahead__sub-title"};

var Typeahead = function Typeahead(_a) {
  var title = _a.title,
      subtitle = _a.subtitle,
      queryWords = _a.queryWords,
      showIcon = _a.showIcon,
      _b = _a.icon,
      icon = _b === void 0 ? 'search' : _b,
      className = _a.className,
      iconBrand = _a.iconBrand,
      gaAction = _a.gaAction,
      gaCallback = _a.gaCallback,
      gaCategory = _a.gaCategory,
      gaLabel = _a.gaLabel,
      gaValue = _a.gaValue,
      activeTabName = _a.activeTabName,
      props = __rest(_a, ["title", "subtitle", "queryWords", "showIcon", "icon", "ariaLabel", "className", "iconBrand", "gaAction", "gaCallback", "gaCategory", "gaLabel", "gaValue", "activeTabName"]);

  return /*#__PURE__*/createElement(Tile, __assign({
    tabIndex: -1,
    gaLabel: gaLabel,
    gaCategory: gaCategory,
    gaAction: gaAction,
    gaValue: gaValue,
    gaCallback: gaCallback,
    activeTabName: activeTabName
  }, props), /*#__PURE__*/createElement(ContentAlignment, {
    element: "div",
    direction: "row",
    className: joinClasses(styles$1n.typeahead, className)
  }, /*#__PURE__*/createElement("div", {
    tabIndex: -1,
    className: joinClasses(styles$1n.typeaheadContent, styles$1n.typeahead)
  }, /*#__PURE__*/createElement("div", {
    tabIndex: 0,
    className: styles$1n.typeaheadFocus
  }, showIcon && /*#__PURE__*/createElement(Icon, {
    name: iconBrand ? "" + iconBrand + icon : icon,
    className: styles$1n.typeaheadIcon
  }), /*#__PURE__*/createElement("div", {
    className: styles$1n.typeaheadTextContent
  }, /*#__PURE__*/createElement(QueryText, {
    text: title,
    queryWords: queryWords,
    className: styles$1n.typeaheadQueryText
  }), subtitle && /*#__PURE__*/createElement(Caption, {
    variant: "small",
    className: styles$1n.typeaheadSubTitle,
    element: "div",
    color: "secondary"
  }, subtitle))))));
};
Typeahead.displayName = 'CoreTypeahead';

var styles$1o = {"radio":"fr-ec-radio","radio__wrapper":"fr-ec-radio__wrapper","radioWrapper":"fr-ec-radio__wrapper","radio--full-width":"fr-ec-radio--full-width","radioFullWidth":"fr-ec-radio--full-width","radio__label":"fr-ec-radio__label","radioLabel":"fr-ec-radio__label","radio__children":"fr-ec-radio__children","radioChildren":"fr-ec-radio__children","radio__rating":"fr-ec-radio__rating","radioRating":"fr-ec-radio__rating","radio__input":"fr-ec-radio__input","radioInput":"fr-ec-radio__input","radio__circle":"fr-ec-radio__circle","radioCircle":"fr-ec-radio__circle","radio__input-checked":"fr-ec-radio__input-checked","radioInputChecked":"fr-ec-radio__input-checked","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn","radio__image-container":"fr-ec-radio__image-container","radioImageContainer":"fr-ec-radio__image-container","radio__image":"fr-ec-radio__image","radioImage":"fr-ec-radio__image","radio__max-width-reset":"fr-ec-radio__max-width-reset","radioMaxWidthReset":"fr-ec-radio__max-width-reset"};

var Radio = /*#__PURE__*/forwardRef(function (_a, ref) {
  var _b;

  var label = _a.label,
      name = _a.name,
      onChange = _a.onChange,
      value = _a.value,
      id = _a.id,
      disabled = _a.disabled,
      children = _a.children,
      className = _a.className,
      _c = _a.hideLabel,
      hideLabel = _c === void 0 ? false : _c,
      image = _a.image,
      imageAlt = _a.imageAlt,
      _d = _a.labelVariant,
      labelVariant = _d === void 0 ? 'standard' : _d,
      _e = _a.width,
      width = _e === void 0 ? 'fitToContent' : _e,
      checked = _a.checked,
      props = __rest(_a, ["label", "name", "onChange", "value", "id", "disabled", "children", "className", "hideLabel", "image", "imageAlt", "labelVariant", "width", "checked"]);

  var hasChildren = Children.toArray(children).length > 0;
  var childrenId = hasChildren ? id + "__content" : '';
  var hasImage = image && image.length > 0;
  var imageAltText = Array.isArray(imageAlt) ? __spreadArrays(imageAlt) : [imageAlt || label];
  var renderImages = hasImage && (Array.isArray(image) ? image.map(function (img, index) {
    var _a;

    return /*#__PURE__*/createElement("img", {
      key: index,
      src: img,
      alt: typeof label === 'string' ? label : (_a = imageAltText[index]) === null || _a === void 0 ? void 0 : _a.toString(),
      className: joinClasses(styles$1o.radioImage)
    });
  }) : /*#__PURE__*/createElement("img", {
    src: image,
    alt: (_b = imageAltText[0]) === null || _b === void 0 ? void 0 : _b.toString(),
    className: joinClasses(styles$1o.radioImage)
  }));
  return /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$1o.radio, width === 'fullWidth' && styles$1o.radioFullWidth, className)
  }, /*#__PURE__*/createElement("div", {
    className: styles$1o.radioWrapper
  }, /*#__PURE__*/createElement("input", __assign({
    type: "radio",
    className: joinClasses(styles$1o.radioInput, checked && styles$1o.radioInputChecked, interactionsStyles.cursorPointer),
    value: value,
    name: name,
    onChange: onChange,
    id: id,
    disabled: disabled,
    "aria-describedby": childrenId,
    "aria-label": typeof label === 'string' ? !hideLabel ? label : undefined : undefined,
    ref: ref,
    checked: checked
  }, props)), /*#__PURE__*/createElement("label", {
    htmlFor: id,
    "aria-hidden": hideLabel,
    className: joinClasses(interactionsStyles.cursorPointer, typographyStyles.labelStandard)
  }, typeof label === 'string' && label), /*#__PURE__*/createElement("div", {
    className: styles$1o.radioCircle
  }), /*#__PURE__*/createElement("span", {
    className: joinClasses(styles$1o.radioLabel, resetStyles.maxWidthReset)
  }, /*#__PURE__*/createElement("div", {
    className: styles$1o.radioImageContainer
  }, renderImages), /*#__PURE__*/createElement(Label, {
    element: "span",
    variant: labelVariant,
    color: disabled ? 'disabled' : 'primary-dark',
    className: styles$1o.radioMaxWidthReset
  }, /*#__PURE__*/createElement("label", {
    htmlFor: id,
    className: styles$1o.radioRating
  }, label)))), hasChildren && /*#__PURE__*/createElement("label", {
    htmlFor: id
  }, /*#__PURE__*/createElement("div", {
    id: childrenId,
    className: styles$1o.radioChildren
  }, children)));
});
Radio.displayName = 'CoreRadio';
Radio.defaultProps = {
  hideLabel: false
};

var styles$1p = {"selector":"fr-ec-selector","selector__button":"fr-ec-selector__button","selectorButton":"fr-ec-selector__button","selector__tooltip":"fr-ec-selector__tooltip","selectorTooltip":"fr-ec-selector__tooltip","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","selector__button--is-selected":"fr-ec-selector__button--is-selected","selectorButtonIsSelected":"fr-ec-selector__button--is-selected","selector__label-container":"fr-ec-selector__label-container","selectorLabelContainer":"fr-ec-selector__label-container","selector__label-container--with-tooltip":"fr-ec-selector__label-container--with-tooltip","selectorLabelContainerWithTooltip":"fr-ec-selector__label-container--with-tooltip","selector__label-container--with-icon":"fr-ec-selector__label-container--with-icon","selectorLabelContainerWithIcon":"fr-ec-selector__label-container--with-icon","selector__label":"fr-ec-selector__label","selectorLabel":"fr-ec-selector__label","selector__logo-container":"fr-ec-selector__logo-container","selectorLogoContainer":"fr-ec-selector__logo-container","selector__caption":"fr-ec-selector__caption","selectorCaption":"fr-ec-selector__caption","selector__icon":"fr-ec-selector__icon","selectorIcon":"fr-ec-selector__icon"};

var Selector = function Selector(_a) {
  var selected = _a.selected,
      disabled = _a.disabled,
      label = _a.label,
      children = _a.children,
      icon = _a.icon,
      onClick = _a.onClick,
      className = _a.className,
      scrollTo = _a.scrollTo,
      onToolTipOpen = _a.onToolTipOpen,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["selected", "disabled", "label", "children", "icon", "onClick", "className", "scrollTo", "onToolTipOpen", "iconBrand"]);

  var showTooltip = // @ts-ignore
  icon && icon.type && (icon.type.displayName === 'CoreTooltip' || icon.type.displayName === 'Tooltip');
  var isValidSelection = !disabled && selected;
  var showIcon = icon && !disabled && !showTooltip;
  var isIconAnAsset = showIcon && typeof icon === 'string';

  var handleClick = function handleClick(event) {
    // Reduce the header height if the header element is present
    if (isInBrowser()) {
      var headerEl = document.getElementsByTagName('header')[0];
      var headerOffset = 0;
      var offsetVal = 16;

      if (headerEl) {
        headerOffset = headerEl.offsetHeight;
      }

      if (scrollTo) {
        event.preventDefault();
        var btn = document.getElementById(scrollTo);

        if (btn) {
          var offset = btn.offsetTop;
          window.scrollTo({
            behavior: 'smooth',
            left: 0,
            top: offset - (headerOffset + offsetVal)
          });
        }
      }
    }

    if (onClick) {
      onClick(event);
    }
  };

  return /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$1p.selector, className)
  }, /*#__PURE__*/createElement("button", __assign({
    type: "button",
    className: joinClasses(styles$1p.selectorButton, isValidSelection && styles$1p.selectorButtonIsSelected, interactionsStyles.cursorPointer),
    onClick: handleClick,
    "aria-pressed": isValidSelection
  }, props, {
    disabled: disabled
  }), /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$1p.selectorLabelContainer, showIcon && styles$1p.selectorLabelContainerWithIcon, showTooltip && styles$1p.selectorLabelContainerWithTooltip)
  }, /*#__PURE__*/createElement(Body, {
    variant: "standard",
    element: "p",
    className: styles$1p.selectorLabel
  }, label), children && /*#__PURE__*/createElement(Caption, {
    element: "p",
    className: styles$1p.selectorCaption
  }, children)), showIcon && /*#__PURE__*/createElement("div", {
    className: styles$1p.selectorLogoContainer,
    "aria-hidden": "true"
  }, isIconAnAsset ? /*#__PURE__*/createElement(Icon, {
    name: iconBrand ? "" + iconBrand + icon : icon,
    className: styles$1p.selectorIcon
  }) : icon)), /*#__PURE__*/createElement("span", {
    className: styles$1p.selectorTooltip
  }, showTooltip && /*#__PURE__*/isValidElement(icon) && /*#__PURE__*/cloneElement(icon, {
    icon: disabled ? 'help' : 'information',
    onClick: function onClick() {
      if (onToolTipOpen) {
        onToolTipOpen();
      }

      if (icon.props.onClick) {
        icon.props.onClick();
      }
    }
  })));
};
Selector.displayName = 'CoreSelector';
Selector.defaultProps = {
  disabled: false,
  selected: false
};

var styles$1q = {"selector-group":"fr-ec-selector-group","selectorGroup":"fr-ec-selector-group","selector":"fr-ec-selector","selector-group--active-tooltip":"fr-ec-selector-group--active-tooltip","selectorGroupActiveTooltip":"fr-ec-selector-group--active-tooltip","selector__tooltip":"fr-ec-selector__tooltip","selectorTooltip":"fr-ec-selector__tooltip"};

var SelectorGroup = function SelectorGroup(_a) {
  var children = _a.children,
      className = _a.className,
      props = __rest(_a, ["children", "className"]);

  var _b = useState(-1),
      activeToolTip = _b[0],
      updateVal = _b[1];

  var handleToolTipOpen = function handleToolTipOpen(index) {
    updateVal(index);
  };

  var childrenWithProps = Children.toArray(children).filter(isValidElement).map(function (child, index) {
    return /*#__PURE__*/cloneElement(child, {
      className: index === activeToolTip && styles$1q.selectorGroupActiveTooltip || "",
      onToolTipOpen: function onToolTipOpen() {
        handleToolTipOpen(index);
      }
    });
  });
  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$1q.selectorGroup, className)
  }, props), childrenWithProps);
};
SelectorGroup.displayName = 'CoreSelectorGroup';

var styles$1r = {"sheet":"fr-ec-sheet","sheet__inner":"fr-ec-sheet__inner","sheetInner":"fr-ec-sheet__inner"};

var Sheet = function Sheet(_a) {
  var children = _a.children,
      closeLabel = _a.closeLabel,
      closeTitle = _a.closeTitle,
      onRequestClose = _a.onRequestClose,
      title = _a.title,
      subtitle = _a.subtitle,
      subtitleExtra = _a.subtitleExtra,
      _b = _a.titleId,
      titleId = _b === void 0 ? 'sheet-title' : _b,
      className = _a.className,
      footer = _a.footer,
      _c = _a.labelElement,
      labelElement = _c === void 0 ? 'h5' : _c,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["children", "closeLabel", "closeTitle", "onRequestClose", "title", "subtitle", "subtitleExtra", "titleId", "className", "footer", "labelElement", "iconBrand"]);

  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$1r.sheet, className),
    role: "dialog"
  }, title && {
    'aria-labelledby': titleId
  }, props), /*#__PURE__*/createElement("div", {
    className: styles$1r.sheetInner
  }, /*#__PURE__*/createElement(OverlayWrapper, null, title && /*#__PURE__*/createElement(HeaderOverlay, {
    title: title,
    subtitle: subtitle,
    subtitleExtra: subtitleExtra,
    closeLabel: closeLabel,
    closeTitle: closeTitle,
    onRequestClose: onRequestClose,
    titleId: titleId,
    labelElement: labelElement,
    iconBrand: iconBrand
  }), /*#__PURE__*/createElement(OverlayBody, {
    footer: footer
  }, children))));
};
Sheet.displayName = 'CoreSheet';
Sheet.defaultProps = {
  labelElement: 'h5',
  titleId: 'sheet-title'
};

var styles$1s = {"show-more":"fr-ec-show-more","showMore":"fr-ec-show-more","show-more__icon":"fr-ec-show-more__icon","showMoreIcon":"fr-ec-show-more__icon"};

var ShowMore = function ShowMore(_a) {
  var element = _a.element,
      className = _a.className,
      label = _a.label,
      href = _a.href,
      to = _a.to,
      _b = _a.arrowDirection,
      arrowDirection = _b === void 0 ? 'bottom' : _b,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["element", "className", "label", "href", "to", "arrowDirection", "iconBrand"]);

  var Element = element;
  var showMoreContent = /*#__PURE__*/createElement(Fragment, null, label, /*#__PURE__*/createElement(Icon, {
    name: arrowDirection === 'bottom' ? iconBrand ? iconBrand + "chevron-down" : 'chevron-down' : iconBrand ? iconBrand + "chevron-up" : 'chevron-up',
    className: styles$1s.showMoreIcon
  }));
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign({}, {
      href: href,
      to: to
    }, {
      className: joinClasses(styles$1s.showMore, Element === 'button' && resetStyles.buttonReset, typographyStyles.buttonLarge, interactionsStyles.cursorPointer, className)
    }, props), /*#__PURE__*/createElement(ContentAlignment, {
      element: "span",
      direction: "row",
      alignment: "center"
    }, showMoreContent))
  );
};
ShowMore.displayName = 'CoreShowMore';

var styles$1t = {"mb-spacer-0":"fr-ec-mb-spacer-0","mbSpacer0":"fr-ec-mb-spacer-0","mb-spacer-4":"fr-ec-mb-spacer-4","mbSpacer4":"fr-ec-mb-spacer-4","mb-spacer-8":"fr-ec-mb-spacer-8","mbSpacer8":"fr-ec-mb-spacer-8","mb-spacer-12":"fr-ec-mb-spacer-12","mbSpacer12":"fr-ec-mb-spacer-12","mb-spacer-16":"fr-ec-mb-spacer-16","mbSpacer16":"fr-ec-mb-spacer-16","mb-spacer-24":"fr-ec-mb-spacer-24","mbSpacer24":"fr-ec-mb-spacer-24","mb-spacer-32":"fr-ec-mb-spacer-32","mbSpacer32":"fr-ec-mb-spacer-32","mb-spacer-52":"fr-ec-mb-spacer-52","mbSpacer52":"fr-ec-mb-spacer-52","mb-spacer-88":"fr-ec-mb-spacer-88","mbSpacer88":"fr-ec-mb-spacer-88","spacer-l--pc-0":"fr-ec-spacer-l--pc-0","spacerLPc0":"fr-ec-spacer-l--pc-0","spacer-l--pc-4":"fr-ec-spacer-l--pc-4","spacerLPc4":"fr-ec-spacer-l--pc-4","spacer-l--pc-8":"fr-ec-spacer-l--pc-8","spacerLPc8":"fr-ec-spacer-l--pc-8","spacer-l--pc-12":"fr-ec-spacer-l--pc-12","spacerLPc12":"fr-ec-spacer-l--pc-12","spacer-l--pc-16":"fr-ec-spacer-l--pc-16","spacerLPc16":"fr-ec-spacer-l--pc-16","spacer-l--pc-24":"fr-ec-spacer-l--pc-24","spacerLPc24":"fr-ec-spacer-l--pc-24","spacer-l--pc-32":"fr-ec-spacer-l--pc-32","spacerLPc32":"fr-ec-spacer-l--pc-32","spacer-l--pc-52":"fr-ec-spacer-l--pc-52","spacerLPc52":"fr-ec-spacer-l--pc-52","spacer-l--pc-88":"fr-ec-spacer-l--pc-88","spacerLPc88":"fr-ec-spacer-l--pc-88","spacer-m--tab-0":"fr-ec-spacer-m--tab-0","spacerMTab0":"fr-ec-spacer-m--tab-0","spacer-m--tab-4":"fr-ec-spacer-m--tab-4","spacerMTab4":"fr-ec-spacer-m--tab-4","spacer-m--tab-8":"fr-ec-spacer-m--tab-8","spacerMTab8":"fr-ec-spacer-m--tab-8","spacer-m--tab-12":"fr-ec-spacer-m--tab-12","spacerMTab12":"fr-ec-spacer-m--tab-12","spacer-m--tab-16":"fr-ec-spacer-m--tab-16","spacerMTab16":"fr-ec-spacer-m--tab-16","spacer-m--tab-24":"fr-ec-spacer-m--tab-24","spacerMTab24":"fr-ec-spacer-m--tab-24","spacer-m--tab-32":"fr-ec-spacer-m--tab-32","spacerMTab32":"fr-ec-spacer-m--tab-32","spacer-m--tab-52":"fr-ec-spacer-m--tab-52","spacerMTab52":"fr-ec-spacer-m--tab-52","spacer-m--tab-88":"fr-ec-spacer-m--tab-88","spacerMTab88":"fr-ec-spacer-m--tab-88","spacer-s--sp-0":"fr-ec-spacer-s--sp-0","spacerSSp0":"fr-ec-spacer-s--sp-0","spacer-s--sp-4":"fr-ec-spacer-s--sp-4","spacerSSp4":"fr-ec-spacer-s--sp-4","spacer-s--sp-8":"fr-ec-spacer-s--sp-8","spacerSSp8":"fr-ec-spacer-s--sp-8","spacer-s--sp-12":"fr-ec-spacer-s--sp-12","spacerSSp12":"fr-ec-spacer-s--sp-12","spacer-s--sp-16":"fr-ec-spacer-s--sp-16","spacerSSp16":"fr-ec-spacer-s--sp-16","spacer-s--sp-24":"fr-ec-spacer-s--sp-24","spacerSSp24":"fr-ec-spacer-s--sp-24","spacer-s--sp-32":"fr-ec-spacer-s--sp-32","spacerSSp32":"fr-ec-spacer-s--sp-32","spacer-s--sp-52":"fr-ec-spacer-s--sp-52","spacerSSp52":"fr-ec-spacer-s--sp-52","spacer-s--sp-88":"fr-ec-spacer-s--sp-88","spacerSSp88":"fr-ec-spacer-s--sp-88"};

var variantSpacing$1 = {
  'spacing-00': styles$1t.mbSpacer0,
  'spacing-01': styles$1t.mbSpacer4,
  'spacing-02': styles$1t.mbSpacer8,
  'spacing-03': styles$1t.mbSpacer12,
  'spacing-04': styles$1t.mbSpacer16,
  'spacing-05': styles$1t.mbSpacer24,
  'spacing-06': styles$1t.mbSpacer32,
  'spacing-07': styles$1t.mbSpacer52,
  'spacing-08': styles$1t.mbSpacer88
};
var pcSpacing = {
  'spacing-00': styles$1t.spacerLPc0,
  'spacing-01': styles$1t.spacerLPc4,
  'spacing-02': styles$1t.spacerLPc8,
  'spacing-03': styles$1t.spacerLPc12,
  'spacing-04': styles$1t.spacerLPc16,
  'spacing-05': styles$1t.spacerLPc24,
  'spacing-06': styles$1t.spacerLPc32,
  'spacing-07': styles$1t.spacerLPc52,
  'spacing-08': styles$1t.spacerLPc88
};
var tabSpacing = {
  'spacing-00': styles$1t.spacerMTab0,
  'spacing-01': styles$1t.spacerMTab4,
  'spacing-02': styles$1t.spacerMTab8,
  'spacing-03': styles$1t.spacerMTab12,
  'spacing-04': styles$1t.spacerMTab16,
  'spacing-05': styles$1t.spacerMTab24,
  'spacing-06': styles$1t.spacerMTab32,
  'spacing-07': styles$1t.spacerMTab52,
  'spacing-08': styles$1t.spacerMTab88
};
var spSpacing = {
  'spacing-00': styles$1t.spacerSSp0,
  'spacing-01': styles$1t.spacerSSp4,
  'spacing-02': styles$1t.spacerSSp8,
  'spacing-03': styles$1t.spacerSSp12,
  'spacing-04': styles$1t.spacerSSp16,
  'spacing-05': styles$1t.spacerSSp24,
  'spacing-06': styles$1t.spacerSSp32,
  'spacing-07': styles$1t.spacerSSp52,
  'spacing-08': styles$1t.spacerSSp88
};
var Spacer = function Spacer(_a) {
  var _b = _a.element,
      Element = _b === void 0 ? 'div' : _b,
      _c = _a.variant,
      variant = _c === void 0 ? 'spacing-04' : _c,
      children = _a.children,
      pc = _a.pc,
      sp = _a.sp,
      tab = _a.tab,
      className = _a.className,
      props = __rest(_a, ["element", "variant", "children", "pc", "sp", "tab", "className"]);

  return /*#__PURE__*/createElement(Element, __assign({
    className: joinClasses(variantSpacing$1[variant], pc && pcSpacing[pc], tab && tabSpacing[tab], sp && spSpacing[sp], className)
  }, props), children);
};
Spacer.displayName = 'CoreSpacer';

var styles$1u = {"stepper-group":"fr-ec-stepper-group","stepperGroup":"fr-ec-stepper-group","stepper-group__item":"fr-ec-stepper-group__item","stepperGroupItem":"fr-ec-stepper-group__item","stepper":"fr-ec-stepper"};

var StepperGroup = function StepperGroup(_a) {
  var children = _a.children,
      _b = _a.className,
      className = _b === void 0 ? '' : _b,
      props = __rest(_a, ["children", "className"]);

  return /*#__PURE__*/createElement("ul", __assign({
    className: joinClasses(styles$1u.stepperGroup, className)
  }, props), Children.map(children, function (child, i) {
    return /*#__PURE__*/createElement("li", {
      className: styles$1u.stepperGroupItem,
      key: i
    }, child);
  }));
};
StepperGroup.displayName = 'CoreStepperGroup';

var styles$1v = {"tab":"fr-ec-tab","tab--standard-boxed":"fr-ec-tab--standard-boxed","tabStandardBoxed":"fr-ec-tab--standard-boxed","tab--gender":"fr-ec-tab--gender","tabGender":"fr-ec-tab--gender","tab--type-gender":"fr-ec-tab--type-gender","tabTypeGender":"fr-ec-tab--type-gender","tab--small-height":"fr-ec-tab--small-height","tabSmallHeight":"fr-ec-tab--small-height","tab--white":"fr-ec-tab--white","tabWhite":"fr-ec-tab--white","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","tab--is-active":"fr-ec-tab--is-active","tabIsActive":"fr-ec-tab--is-active","tab__label":"fr-ec-tab__label","tabLabel":"fr-ec-tab__label","tab--disabled":"fr-ec-tab--disabled","tabDisabled":"fr-ec-tab--disabled"};

var Tab = function Tab(_a) {
  var children = _a.children,
      isActive = _a.isActive,
      onClick = _a.onClick,
      label = _a.label,
      className = _a.className,
      _b = _a.textTransform,
      textTransform = _b === void 0 ? 'normal' : _b,
      _c = _a.variant,
      variant = _c === void 0 ? 'standard' : _c,
      _d = _a.genderTypography,
      genderTypography = _d === void 0 ? false : _d,
      _e = _a.wordBreak,
      wordBreak = _e === void 0 ? 'none' : _e,
      _f = _a.disabled,
      disabled = _f === void 0 ? false : _f,
      url = _a.url,
      labelImage = _a.labelImage,
      target = _a.target,
      gaAction = _a.gaAction,
      gaCategory = _a.gaCategory,
      gaLabel = _a.gaLabel,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      _g = _a.labelElement,
      WrapperEl = _g === void 0 ? 'span' : _g,
      _h = _a.type,
      type = _h === void 0 ? 'black' : _h,
      props = __rest(_a, ["children", "isActive", "onClick", "label", "className", "textTransform", "variant", "genderTypography", "wordBreak", "disabled", "url", "labelImage", "target", "gaAction", "gaCategory", "gaLabel", "gaValue", "gaCallback", "labelElement", "type"]);

  var gaProps = null;

  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };

    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }

  var clickCallback = function clickCallback(e, index) {
    if (onClick) {
      onClick(e, label, index, children);
    }

    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    }
  };

  var Element = 'a';
  var absoluteUrlPattern = url && isAbsoluteUrl(url);
  var attributes = {};

  if (absoluteUrlPattern) {
    attributes = {
      href: url,
      target: target || '_blank'
    };
  } else if (url) {
    Element = Link$1; // Default target behaviour of Link is similar to that of '_self'.
    // But if you specify target property explicitly, it refreshes the page.
    // @ts-ignore

    attributes.to = url;

    if (target && target !== '_self') {
      // @ts-ignore
      attributes.target = target;
    }
  }

  var typography = {
    gender: typographyStyles.genderSmall,
    small: !genderTypography ? typographyStyles.tabSmall : typographyStyles.genderSmall,
    'small-swipeable': !genderTypography ? typographyStyles.tabSmall : typographyStyles.genderSmall,
    standard: !genderTypography ? typographyStyles.tabStandard : typographyStyles.genderStandard,
    'standard-boxed': !genderTypography ? typographyStyles.tabStandard : typographyStyles.genderStandard
  };
  return /*#__PURE__*/createElement(Element, __assign({
    className: joinClasses(styles$1v.tab, isActive ? styles$1v.tabIsActive : '', variant === 'standard-boxed' && styles$1v.tabStandardBoxed, (variant === 'small' || variant === 'small-swipeable' || variant === 'gender') && styles$1v.tabSmallHeight, variant === 'gender' && styles$1v.tabTypeGender, textTransformStyles["text-transform-" + textTransform], genderTypography && styles$1v.tabGender, addWordBreak(wordBreak === 'break-word'), disabled && styles$1v.tabDisabled, type === 'white' && styles$1v.tabWhite, className),
    role: "tab",
    "aria-selected": isActive,
    onClick: clickCallback
  }, props, gaProps, attributes), labelImage && variant === 'standard-boxed' ? isActive ? /*#__PURE__*/createElement(WrapperEl, null, /*#__PURE__*/createElement("img", {
    src: labelImage,
    alt: label
  })) : /*#__PURE__*/createElement("img", {
    src: labelImage,
    alt: label
  }) : isActive ? /*#__PURE__*/createElement(WrapperEl, {
    className: joinClasses(styles$1v.tabLabel, typography["" + variant])
  }, label) : /*#__PURE__*/createElement("span", {
    className: joinClasses(styles$1v.tabLabel, typography["" + variant])
  }, label));
};
Tab.displayName = 'CoreTab';
Tab.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var styles$1w = {"tab-group":"fr-ec-tab-group","tabGroup":"fr-ec-tab-group","tab-group__content":"fr-ec-tab-group__content","tabGroupContent":"fr-ec-tab-group__content","tab--standard-boxed":"fr-ec-tab--standard-boxed","tabStandardBoxed":"fr-ec-tab--standard-boxed","swipeable":"fr-ec-swipeable","tab-group-wrapper":"fr-ec-tab-group-wrapper","tabGroupWrapper":"fr-ec-tab-group-wrapper","swipeable__navigation-btn":"fr-ec-swipeable__navigation-btn","swipeableNavigationBtn":"fr-ec-swipeable__navigation-btn","swipeable__navigation-btn-right":"fr-ec-swipeable__navigation-btn-right","swipeableNavigationBtnRight":"fr-ec-swipeable__navigation-btn-right","swipeable__overlay-right":"fr-ec-swipeable__overlay-right","swipeableOverlayRight":"fr-ec-swipeable__overlay-right","swipeable__overlay-left":"fr-ec-swipeable__overlay-left","swipeableOverlayLeft":"fr-ec-swipeable__overlay-left","swipeable__navigation-btn-left":"fr-ec-swipeable__navigation-btn-left","swipeableNavigationBtnLeft":"fr-ec-swipeable__navigation-btn-left","swiper-button-disabled":"fr-ec-swiper-button-disabled","swiperButtonDisabled":"fr-ec-swiper-button-disabled"};

var TabGroup =
/** @class */
function (_super) {
  __extends(TabGroup, _super);

  function TabGroup(props) {
    var _this = _super.call(this, props) || this;

    _this.onTouchMove = function () {
      if (_this.swiperInstance) {
        _this.swiperInstance.update();

        _this.setState({
          isBeginning: _this.swiperInstance.isBeginning,
          isEnd: _this.swiperInstance.isEnd
        });
      }
    };

    _this.onClick = function (label, index, child, tabOnclick) {
      return function (event, activeTabLabel) {
        var swipeable = _this.props.variant === 'small-swipeable';
        var ActiveTabIndex = event.currentTarget.getAttribute('tabid');

        _this.setState({
          activeTabId: index,
          activeTabLabel: activeTabLabel
        }, function () {
          if (swipeable) {
            _this.swiperInstance.slideTo(Number(ActiveTabIndex));

            _this.swiperInstance.update();
          }

          if (_this.swiperInstance) {
            _this.setState({
              isBeginning: _this.swiperInstance.isBeginning,
              isEnd: _this.swiperInstance.isEnd
            });
          }
        });

        if (tabOnclick) {
          tabOnclick(event, label, index, child);
        }
      };
    };

    _this.onResize = function () {
      var breakpoint = getCurrentMediaQueryBreakpoint();
      var isDesktop = breakpoint === 'lg';

      _this.setState({
        isLargeScreenDevice: isDesktop
      });

      if (_this.swiperInstance) {
        _this.swiperInstance.update();

        _this.setState({
          isBeginning: _this.swiperInstance.isBeginning,
          isEnd: _this.swiperInstance.isEnd
        });
      }
    };

    _this.controlNavigation = function (direction) {
      if (_this.swiperInstance) {
        var slides = _this.swiperInstance.slides || 0;
        var _a = _this.swiperInstance,
            activeIndex = _a.activeIndex,
            isBeginning = _a.isBeginning,
            isEnd = _a.isEnd;
        var nextSlide = direction === 'NEXT' ? isEnd ? slides.length : activeIndex + 1 : isBeginning ? 0 : activeIndex - 1;

        if (direction === 'NEXT') {
          _this.swiperInstance.slideTo(nextSlide);
        } else {
          _this.swiperInstance.slideTo(nextSlide);
        }

        _this.swiperInstance.update();

        _this.setState({
          isBeginning: _this.swiperInstance.isBeginning,
          isEnd: _this.swiperInstance.isEnd
        });
      }
    };

    var tabChilds = Children.toArray(props.children).filter(isValidElement);
    var activeChildWithLabel = tabChilds.find(function (tabItem) {
      return Boolean(tabItem.props && tabItem.props.isActive);
    }) || tabChilds[0];
    var activeChildWithLabelProps = activeChildWithLabel ? activeChildWithLabel.props : {};
    _this.state = {
      activeTabId: _this.props.defaultIndex,
      activeTabLabel: activeChildWithLabelProps.label,
      isBeginning: false,
      isEnd: false,
      isLargeScreenDevice: false
    };
    _this.swiperRef = /*#__PURE__*/createRef();
    _this.swiperInstance = null;
    return _this;
  }

  TabGroup.prototype.componentDidMount = function () {
    var _this = this;

    var swipeable = this.props.variant === 'small-swipeable';

    if (swipeable) {
      this.swiperInstance = new swiper(this.swiperRef.current, {
        freeMode: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        observeParents: true,
        observer: true,
        on: {
          sliderMove: function sliderMove() {
            return _this.onTouchMove();
          }
        },
        slidesPerView: 'auto',
        spaceBetween: 0
      });
    }

    if (this.swiperInstance) {
      var activeTabElement = Children.toArray(this.props.children).findIndex(function (child, index) {
        return child.props.isActive !== undefined ? child.props.label === _this.state.activeTabLabel : index === _this.state.activeTabId;
      });

      if (swipeable) {
        this.swiperInstance.slideTo(Number(activeTabElement));
        this.swiperInstance.update();
      }

      this.setState({
        isBeginning: this.swiperInstance.isBeginning,
        isEnd: this.swiperInstance.isEnd
      });
    }
  };

  TabGroup.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.defaultIndex !== this.props.defaultIndex) {
      this.setState({
        activeTabId: this.props.defaultIndex
      });
    }
  };

  TabGroup.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        className = _a.className,
        sticky = _a.sticky,
        variant = _a.variant,
        genderTypography = _a.genderTypography,
        isNavHeader = _a.isNavHeader,
        iconBrand = _a.iconBrand,
        props = __rest(_a, ["children", "className", "sticky", "variant", "genderTypography", "isNavHeader", "iconBrand"]);

    var swipeable = variant === 'small-swipeable';
    var _b = this.state,
        activeTabId = _b.activeTabId,
        activeTabLabel = _b.activeTabLabel;
    var activeContent = null;
    var clonedChildren = Children.toArray(children).map(function (item, index) {
      return /*#__PURE__*/cloneElement(item, {
        index: index
      });
    });
    var childrenWithProps = clonedChildren.filter(isValidElement).map(function (child, index) {
      if (child.props.isActive !== undefined ? child.props.label === activeTabLabel : child.props.index === activeTabId) {
        activeContent = child.props.children;
      }

      if (swipeable) {
        return /*#__PURE__*/createElement("li", {
          key: index,
          className: "swiper-slide"
        }, /*#__PURE__*/cloneElement(child, {
          genderTypography: genderTypography,
          isActive: child.props.isActive !== undefined ? child.props.label === activeTabLabel : child.props.index === activeTabId,
          key: child.props.label,
          onClick: _this.onClick(child.props.label, child.props.index, child, child.props.onClick),
          tabid: index,
          variant: 'small-swipeable'
        }));
      }

      return /*#__PURE__*/cloneElement(child, {
        genderTypography: genderTypography,
        isActive: child.props.isActive !== undefined ? child.props.label === activeTabLabel : child.props.index === activeTabId,
        key: child.props.label,
        onClick: _this.onClick(child.props.label, child.props.index, child, child.props.onClick),
        variant: variant ? variant : 'standard'
      });
    });
    return /*#__PURE__*/createElement(Fragment, null, swipeable ? /*#__PURE__*/createElement(Measure, {
      onResize: this.onResize
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/createElement("div", {
        ref: measureRef
      }, /*#__PURE__*/createElement("div", __assign({
        className: joinClasses('swiper-container', styles$1w.swipeable, className),
        ref: _this.swiperRef
      }, props), !_this.state.isBeginning && /*#__PURE__*/createElement("div", {
        className: styles$1w.swipeableOverlayLeft
      }), /*#__PURE__*/createElement("ul", {
        role: "tablist",
        className: joinClasses('swiper-wrapper', styles$1w.tabGroupWrapper)
      }, childrenWithProps), !_this.state.isEnd && /*#__PURE__*/createElement("div", {
        className: styles$1w.swipeableOverlayRight
      }), _this.state.isLargeScreenDevice && /*#__PURE__*/createElement(Fragment, null, !_this.state.isBeginning && /*#__PURE__*/createElement(ButtonIcon, {
        element: "button",
        icon: "chevron-left",
        label: "",
        className: joinClasses('swiper-button-prev', styles$1w.swipeableNavigationBtn, styles$1w.swipeableNavigationBtnLeft),
        iconBrand: iconBrand,
        onClick: function onClick() {
          return _this.controlNavigation('PREV');
        }
      }), !_this.state.isEnd && /*#__PURE__*/createElement(ButtonIcon, {
        element: "button",
        icon: "chevron-right",
        label: "",
        iconBrand: iconBrand,
        className: joinClasses('swiper-button-next', styles$1w.swipeableNavigationBtn, styles$1w.swipeableNavigationBtnRight),
        onClick: function onClick() {
          return _this.controlNavigation('NEXT');
        }
      }))), /*#__PURE__*/createElement("div", {
        role: "tabpanel",
        className: styles$1w.tabGroupContent
      }, activeContent));
    }) : /*#__PURE__*/createElement(Fragment, null, sticky ? /*#__PURE__*/createElement(StickyContainer, {
      stickySection: "utilityBar",
      isNavHeader: isNavHeader
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$1w.tabGroup, className),
      role: "tablist"
    }, childrenWithProps)) : /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$1w.tabGroup, className),
      role: "tablist"
    }, childrenWithProps), /*#__PURE__*/createElement("div", {
      role: "tabpanel",
      className: styles$1w.tabGroupContent
    }, activeContent)));
  };

  TabGroup.displayName = 'CoreTabGroup';
  TabGroup.defaultProps = {
    defaultIndex: 0,
    genderTypography: false,
    isNavHeader: true,
    sticky: false,
    swipeable: false,
    variant: 'standard'
  };
  return TabGroup;
}(Component);

var TableCellStyles = {"table-cell":"fr-ec-table-cell","tableCell":"fr-ec-table-cell","table":"fr-ec-table","table-cell--accordion":"fr-ec-table-cell--accordion","tableCellAccordion":"fr-ec-table-cell--accordion","table-cell--text-align-start":"fr-ec-table-cell--text-align-start","tableCellTextAlignStart":"fr-ec-table-cell--text-align-start","table-cell--text-align-center":"fr-ec-table-cell--text-align-center","tableCellTextAlignCenter":"fr-ec-table-cell--text-align-center","table-cell--text-align-end":"fr-ec-table-cell--text-align-end","tableCellTextAlignEnd":"fr-ec-table-cell--text-align-end","table-cell__body--vertical-padding-4":"fr-ec-table-cell__body--vertical-padding-4","tableCellBodyVerticalPadding4":"fr-ec-table-cell__body--vertical-padding-4","table-cell__body--vertical-padding-default":"fr-ec-table-cell__body--vertical-padding-default","tableCellBodyVerticalPaddingDefault":"fr-ec-table-cell__body--vertical-padding-default","table-cell--border-bottom-default":"fr-ec-table-cell--border-bottom-default","tableCellBorderBottomDefault":"fr-ec-table-cell--border-bottom-default","table-cell--border-bottom":"fr-ec-table-cell--border-bottom","tableCellBorderBottom":"fr-ec-table-cell--border-bottom","table-row--with-border":"fr-ec-table-row--with-border","tableRowWithBorder":"fr-ec-table-row--with-border"};

var TableCell = function TableCell(_a) {
  var Element = _a.element,
      className = _a.className,
      _b = _a.alignment,
      alignment = _b === void 0 ? 'start' : _b,
      width = _a.width,
      props = __rest(_a, ["element", "className", "alignment", "width"]);

  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign({
      className: joinClasses(TableCellStyles.tableCell, TableCellStyles["table-cell--text-align-" + alignment], className),
      style: {
        width: width
      }
    }, props))
  );
};
TableCell.displayName = 'CoreTableCell';
TableCell.defaultProps = {
  alignment: 'start'
};

var TableRow = function TableRow(props) {
  return /*#__PURE__*/createElement("tr", __assign({}, props));
};
TableRow.displayName = 'CoreTableRow';

var styles$1x = {"comparison-table":"fr-ec-comparison-table","comparisonTable":"fr-ec-comparison-table","comparison-table-heading":"fr-ec-comparison-table-heading","comparisonTableHeading":"fr-ec-comparison-table-heading","comparison-table-content":"fr-ec-comparison-table-content","comparisonTableContent":"fr-ec-comparison-table-content","comparison-table-content-highlighted":"fr-ec-comparison-table-content-highlighted","comparisonTableContentHighlighted":"fr-ec-comparison-table-content-highlighted"};

var ComparisonTable = function ComparisonTable(_a) {
  var headings = _a.headings,
      contents = _a.contents;

  var _b;

  var tableRows = function tableRows() {
    var rowContents = headings || contents;

    if (headings && contents) {
      return headings === null || headings === void 0 ? void 0 : headings.map(function (_, index) {
        return [{
          heading: true,
          content: headings[index]
        }, {
          heading: false,
          content: contents[index]
        }];
      });
    }

    return rowContents === null || rowContents === void 0 ? void 0 : rowContents.map(function (item) {
      return [{
        content: item,
        heading: false
      }];
    });
  };

  return /*#__PURE__*/createElement("div", {
    className: styles$1x.comparisonTable
  }, /*#__PURE__*/createElement("table", null, /*#__PURE__*/createElement("tbody", null, (_b = tableRows()) === null || _b === void 0 ? void 0 : _b.map(function (row, i) {
    return /*#__PURE__*/createElement(TableRow, {
      key: i
    }, row.map(function (cell, j) {
      return /*#__PURE__*/createElement(TableCell, {
        key: j,
        element: "td",
        className: joinClasses(cell.heading ? styles$1x.comparisonTableHeading : styles$1x.comparisonTableContent, _typeof(cell.content) === 'object' && cell.content.common && styles$1x.comparisonTableContentHighlighted)
      }, /*#__PURE__*/createElement(Caption, {
        element: "span",
        variant: 'small'
      }, _typeof(cell.content) === 'object' ? cell.content.label : cell.content));
    }));
  }))));
};
ComparisonTable.displayName = 'CoreComparisonTable';

var styles$1y = {"tag":"fr-ec-tag","tag--gender":"fr-ec-tag--gender","tagGender":"fr-ec-tag--gender","tag--promotional":"fr-ec-tag--promotional","tagPromotional":"fr-ec-tag--promotional","tag--primary":"fr-ec-tag--primary","tagPrimary":"fr-ec-tag--primary","tag--secondary":"fr-ec-tag--secondary","tagSecondary":"fr-ec-tag--secondary","tag__caption":"fr-ec-tag__caption","tagCaption":"fr-ec-tag__caption"};

var variantStyles$2 = {
  gender: {
    tag: styles$1y.tagGender,
    color: 'primary-dark'
  },
  primary: {
    tag: styles$1y.tagPrimary,
    color: 'secondary'
  },
  promotional: {
    tag: styles$1y.tagPromotional,
    color: 'primary-light'
  },
  secondary: {
    tag: styles$1y.tagSecondary,
    color: 'primary-light'
  }
};
var Tag = function Tag(_a) {
  var value = _a.value,
      variant = _a.variant,
      _b = _a.className,
      className = _b === void 0 ? '' : _b,
      _c = _a.wordBreak,
      wordBreak = _c === void 0 ? 'none' : _c,
      props = __rest(_a, ["value", "variant", "className", "wordBreak"]);

  var variantStyle = variantStyles$2[variant];
  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$1y.tag, variantStyle.tag, addWordBreak(wordBreak === 'break-word'), className)
  }, props), /*#__PURE__*/createElement(Caption, {
    color: variantStyle.color,
    variant: "standard",
    element: "span",
    className: joinClasses(styles$1y.tagCaption)
  }, value));
};
Tag.displayName = 'CoreTag';

var styles$1z = {"template-fixed-panel--min-height":"fr-ec-template-fixed-panel--min-height","templateFixedPanelMinHeight":"fr-ec-template-fixed-panel--min-height"};

var LayoutGutter = function LayoutGutter(props) {
  return /*#__PURE__*/createElement(Layout, __assign({
    gutter: true
  }, props));
};
var TemplateFixedPanel = function TemplateFixedPanel(_a) {
  var navigationPath = _a.navigationPath,
      pageHeading = _a.pageHeading,
      sectionHeading = _a.sectionHeading,
      pageContent = _a.pageContent,
      sidePanel = _a.sidePanel,
      _b = _a.toggleMinHeight,
      toggleMinHeight = _b === void 0 ? true : _b,
      className = _a.className,
      props = __rest(_a, ["navigationPath", "pageHeading", "sectionHeading", "pageContent", "sidePanel", "toggleMinHeight", "className"]);

  var showSidePanel = sidePanel !== undefined;
  return /*#__PURE__*/createElement(LayoutWrapper, __assign({
    className: className,
    element: "section"
  }, props), navigationPath && /*#__PURE__*/createElement(Layout, {
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, navigationPath), pageHeading && /*#__PURE__*/createElement(Layout, {
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, pageHeading), sidePanel && /*#__PURE__*/createElement(LayoutGutter, {
    element: "div",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 0
    },
    visible: {
      sm: showSidePanel,
      md: showSidePanel,
      lg: false
    }
  }, sidePanel), /*#__PURE__*/createElement(Layout, {
    element: "section"
  }, /*#__PURE__*/createElement(LayoutGutter, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 8
    },
    inset: {
      right: {
        sm: false,
        md: false,
        lg: true
      }
    }
  }, sectionHeading, /*#__PURE__*/createElement("div", {
    className: toggleMinHeight ? styles$1z.templateFixedPanelMinHeight : ''
  }, pageContent)), sidePanel && /*#__PURE__*/createElement(LayoutGutter, {
    element: "div",
    colSpan: {
      sm: 0,
      md: 0,
      lg: 4
    },
    visible: {
      sm: false,
      md: false,
      lg: showSidePanel
    }
  }, sidePanel)));
};
TemplateFixedPanel.displayName = 'CoreTemplateFixedPanel';
TemplateFixedPanel.defaultProps = {
  toggleMinHeight: true
};

var styles$1A = {"template-information--min-height":"fr-ec-template-information--min-height","templateInformationMinHeight":"fr-ec-template-information--min-height"};

var SecondaryNav = function SecondaryNav(props) {
  return /*#__PURE__*/createElement(Layout, __assign({
    element: "nav",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 3
    },
    inset: {
      right: {
        sm: false,
        md: false,
        lg: true
      }
    },
    gutter: true
  }, props));
};

var TemplateInformation = function TemplateInformation(_a) {
  var navigationPath = _a.navigationPath,
      pageHeading = _a.pageHeading,
      mainContent = _a.mainContent,
      secondaryNavigation = _a.secondaryNavigation,
      tabContent = _a.tabContent,
      _b = _a.hideSecondaryNavigationOnSmall,
      hideSecondaryNavigationOnSmall = _b === void 0 ? true : _b,
      _c = _a.hideSecondaryNavigationOnMedium,
      hideSecondaryNavigationOnMedium = _c === void 0 ? true : _c,
      _d = _a.toggleMinHeight,
      toggleMinHeight = _d === void 0 ? true : _d,
      _e = _a.toggleMinHeightforTab,
      toggleMinHeightforTab = _e === void 0 ? true : _e,
      mainContentFullWidthonSmall = _a.mainContentFullWidthonSmall,
      props = __rest(_a, ["navigationPath", "pageHeading", "mainContent", "secondaryNavigation", "tabContent", "hideSecondaryNavigationOnSmall", "hideSecondaryNavigationOnMedium", "toggleMinHeight", "toggleMinHeightforTab", "mainContentFullWidthonSmall"]);

  return /*#__PURE__*/createElement(LayoutWrapper, __assign({
    element: "section"
  }, props), navigationPath && /*#__PURE__*/createElement(Layout, {
    element: "nav",
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, navigationPath), /*#__PURE__*/createElement(Layout, {
    element: "section"
  }, /*#__PURE__*/createElement(SecondaryNav, {
    visible: {
      sm: false,
      md: false,
      lg: true
    },
    inset: {
      right: {
        sm: false,
        md: false,
        lg: true
      }
    }
  }, secondaryNavigation), /*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 9
    }
  }, pageHeading && /*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 9
    },
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, pageHeading), tabContent && /*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 9
    },
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    className: toggleMinHeightforTab ? styles$1A.templateInformationMinHeight : ''
  }, tabContent), mainContent && /*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 9
    },
    gutter: {
      sm: !mainContentFullWidthonSmall,
      md: true,
      lg: true
    },
    className: toggleMinHeight ? styles$1A.templateInformationMinHeight : ''
  }, mainContent))), /*#__PURE__*/createElement(SecondaryNav, {
    visible: {
      sm: !hideSecondaryNavigationOnSmall,
      md: !hideSecondaryNavigationOnMedium,
      lg: false
    }
  }, secondaryNavigation));
};
TemplateInformation.displayName = 'CoreTemplateInformation';
TemplateInformation.defaultProps = {
  hideSecondaryNavigationOnMedium: true,
  hideSecondaryNavigationOnSmall: true,
  mainContentFullWidthonSmall: false,
  toggleMinHeight: true,
  toggleMinHeightforTab: true
};

var styles$1B = {"tooltip":"fr-ec-tooltip","tooltip__bubble":"fr-ec-tooltip__bubble","tooltipBubble":"fr-ec-tooltip__bubble","tooltip__image":"fr-ec-tooltip__image","tooltipImage":"fr-ec-tooltip__image","image":"fr-ec-image","no-image":"fr-ec-no-image","noImage":"fr-ec-no-image","tooltip__bubble__image":"fr-ec-tooltip__bubble__image","tooltipBubbleImage":"fr-ec-tooltip__bubble__image","tooltip__bubble--popup-size-small":"fr-ec-tooltip__bubble--popup-size-small","tooltipBubblePopupSizeSmall":"fr-ec-tooltip__bubble--popup-size-small","tooltip__bubble-content":"fr-ec-tooltip__bubble-content","tooltipBubbleContent":"fr-ec-tooltip__bubble-content","tooltip__bubble--hidden":"fr-ec-tooltip__bubble--hidden","tooltipBubbleHidden":"fr-ec-tooltip__bubble--hidden","tooltip__arrow":"fr-ec-tooltip__arrow","tooltipArrow":"fr-ec-tooltip__arrow","tooltip__bubble--variant-top":"fr-ec-tooltip__bubble--variant-top","tooltipBubbleVariantTop":"fr-ec-tooltip__bubble--variant-top","bounceToBottom":"fr-ec-bounceToBottom","tooltip__bubble--variant-bottom":"fr-ec-tooltip__bubble--variant-bottom","tooltipBubbleVariantBottom":"fr-ec-tooltip__bubble--variant-bottom","bounceToTop":"fr-ec-bounceToTop","tooltip__bubble--variant-left":"fr-ec-tooltip__bubble--variant-left","tooltipBubbleVariantLeft":"fr-ec-tooltip__bubble--variant-left","bounceStart":"fr-ec-bounceStart","tooltip__bubble--variant-right":"fr-ec-tooltip__bubble--variant-right","tooltipBubbleVariantRight":"fr-ec-tooltip__bubble--variant-right","bounceEnd":"fr-ec-bounceEnd"};

var variantStyles$3 = {
  bottom: styles$1B.tooltipBubbleVariantBottom,
  bottomLeft: styles$1B.tooltipBubbleVariantBottom,
  bottomRight: styles$1B.tooltipBubbleVariantBottom,
  end: styles$1B.tooltipBubbleVariantLeft,
  endBottom: styles$1B.tooltipBubbleVariantLeft,
  endTop: styles$1B.tooltipBubbleVariantLeft,
  start: styles$1B.tooltipBubbleVariantRight,
  startBottom: styles$1B.tooltipBubbleVariantRight,
  startTop: styles$1B.tooltipBubbleVariantRight,
  top: styles$1B.tooltipBubbleVariantTop,
  topLeft: styles$1B.tooltipBubbleVariantTop,
  topRight: styles$1B.tooltipBubbleVariantTop
};
var arrowSize = designTokens_15.spacing_02;
var windowMargins = {
  lg: designTokens_15.spacingGutterLg,
  md: designTokens_15.spacingGutterMd,
  sm: designTokens_15.spacingGutterSm / 2
};

var TooltipComponent =
/** @class */
function (_super) {
  __extends(TooltipComponent, _super);

  function TooltipComponent(props) {
    var _this = _super.call(this, props) || this;

    _this.componentWillUnmount = function () {
      if (isInBrowser$1()) {
        document.removeEventListener('touchend', _this.handleClickOutside);
        document.removeEventListener('mousedown', _this.handleClickOutside);
        document.removeEventListener('blur', _this.handleClickOutside);
        document.removeEventListener('scroll', _this.handleClickOutside);
      }
    };

    _this.handleClickOutside = function (event) {
      var tooltipOuterNode = _this.tooltipOuterRef.current;
      var target = event.target;

      if (tooltipOuterNode && target instanceof Node && _this.state.isOpen && !tooltipOuterNode.contains(target)) {
        setTimeout(function () {
          _this.hideTooltip();
        }, 200);
      }
    };

    _this.hideTooltip = function () {
      _this.setState(function (prevState) {
        return __assign(__assign({}, prevState), {
          isOpen: false
        });
      });
    };

    _this.hideTooltipWithTimeout = function () {
      if (_this.props.variant === 'icon') {
        _this.timeoutID = window.setTimeout(function () {
          _this.hideTooltip();
        }, _this.props.timeout || 1500);
      }
    };

    _this.cancelHideTooltip = function () {
      if (_this.props.variant === 'icon') {
        clearTimeout(_this.timeoutID);
      }
    };

    _this.onUpdateTooltip = function (event) {
      event.preventDefault();

      if (_this.props.onClick) {
        _this.props.onClick();
      }

      if (!_this.state.isOpen) {
        var tooltipBubbleNode = _this.tooltipBubbleRef.current;
        var tooltipOuterNode = _this.tooltipOuterRef.current;
        var breakpoint = getCurrentMediaQueryBreakpoint();
        var windowMargin = windowMargins[breakpoint];

        if (tooltipBubbleNode && tooltipOuterNode) {
          var fallback = _this.state.fallback;
          var fallbackArray = Array.isArray(fallback) ? fallback : fallback[breakpoint];
          positionTooltip(fallbackArray[0] || DIRECTION_TOP, tooltipBubbleNode, windowMargin, tooltipOuterNode.getBoundingClientRect());

          _this.setState({
            direction: fallbackArray[0] || DIRECTION_TOP,
            fallback: fallback,
            isOpen: true
          });
        }
      } else {
        _this.hideTooltip();
      }
    };

    _this.tooltipBubbleRef = /*#__PURE__*/createRef();
    _this.tooltipOuterRef = /*#__PURE__*/createRef();
    var fallback = getFallback(_this.props.direction);
    _this.state = {
      direction: fallback[0] || DIRECTION_TOP,
      fallback: fallback,
      isOpen: false
    };
    return _this;
  }

  TooltipComponent.getDerivedStateFromProps = function (props, state) {
    var breakpoint = getCurrentMediaQueryBreakpoint();
    var fallback = getFallback(props.direction);
    var fallbackArray = Array.isArray(fallback) ? fallback : fallback[breakpoint];
    var isUpdatedFallBack = JSON.stringify(state.fallback) !== JSON.stringify(fallback);

    if (state.direction !== fallbackArray[0] || isUpdatedFallBack) {
      return {
        direction: fallbackArray[0] || DIRECTION_TOP,
        fallback: fallback
      };
    }

    return null;
  };

  TooltipComponent.prototype.componentDidMount = function () {
    var tooltipBubbleNode = this.tooltipBubbleRef.current;
    var tooltipOuterNode = this.tooltipOuterRef.current;

    if (tooltipBubbleNode && tooltipOuterNode) {
      var breakpoint = getCurrentMediaQueryBreakpoint();
      var windowMargin = windowMargins[breakpoint];
      var fallback = this.state.fallback;
      var fallbackArray = Array.isArray(fallback) ? fallback : fallback[breakpoint];
      positionTooltip(fallbackArray[0] || DIRECTION_TOP, tooltipBubbleNode, windowMargin, tooltipBubbleNode.getBoundingClientRect());
    }

    if (isInBrowser$1()) {
      document.addEventListener('touchend', this.handleClickOutside);
      document.addEventListener('mousedown', this.handleClickOutside);
      document.addEventListener('blur', this.handleClickOutside);
      document.addEventListener('scroll', this.handleClickOutside);
    }
  };

  TooltipComponent.prototype.componentDidUpdate = function () {
    var tooltipBubbleNode = this.tooltipBubbleRef.current;
    var tooltipOuterNode = this.tooltipOuterRef.current;
    var breakpoint = getCurrentMediaQueryBreakpoint();
    var windowMargin = windowMargins[breakpoint];
    var fallback = this.state.fallback;
    var fallbackArray = Array.isArray(fallback) ? fallback : fallback[breakpoint];

    if (tooltipBubbleNode && tooltipOuterNode) {
      positionTooltip(fallbackArray[0] || DIRECTION_TOP, tooltipBubbleNode, windowMargin, tooltipOuterNode.getBoundingClientRect());
    }
  };

  TooltipComponent.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        content = _a.content,
        ariaLabel = _a.ariaLabel,
        id = _a.id,
        className = _a.className,
        _b = _a.icon,
        icon = _b === void 0 ? 'information' : _b,
        _c = _a.popupSize,
        popupSize = _c === void 0 ? 'default' : _c,
        iconBrand = _a.iconBrand,
        _d = _a.variant,
        variant = _d === void 0 ? 'icon' : _d,
        imageChild = _a.imageChild;
    var contentId = id + "-content";
    var bubbleId = id + "-bubble";
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$1B.tooltip, className),
      // tslint:disable:react-a11y-event-has-role
      onMouseLeave: this.hideTooltipWithTimeout,
      onMouseOver: this.cancelHideTooltip
    }, content && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$1B.tooltipBubble, variant === 'image' && styles$1B.tooltipBubbleImage, variantStyles$3[this.state.direction], !this.state.isOpen && styles$1B.tooltipBubbleHidden, popupSize === 'small' && styles$1B.tooltipBubblePopupSizeSmall),
      ref: this.tooltipBubbleRef,
      role: "tooltip",
      id: bubbleId
    }, /*#__PURE__*/createElement(Caption, {
      element: "div",
      id: contentId,
      className: styles$1B.tooltipBubbleContent
    }, content)), /*#__PURE__*/createElement("div", {
      className: styles$1B.tooltipArrow
    })), /*#__PURE__*/createElement("div", {
      ref: this.tooltipOuterRef,
      className: variant === 'image' && styles$1B.tooltipImage || ''
    }, variant === 'icon' ? /*#__PURE__*/createElement(ButtonIcon, {
      id: id,
      element: "button",
      type: "button",
      icon: icon,
      iconBrand: iconBrand,
      label: ariaLabel,
      hideLabel: true,
      onMouseDown: this.onUpdateTooltip,
      onFocus: this.onUpdateTooltip,
      onTouchEnd: this.onUpdateTooltip,
      "aria-describedby": contentId
    }) : Children.toArray(imageChild).filter(isValidElement).map(function (child) {
      return /*#__PURE__*/cloneElement(child, {
        onClick: _this.onUpdateTooltip
      });
    })));
  };

  TooltipComponent.displayName = 'CoreTooltip';
  TooltipComponent.defaultProps = {
    disable: false,
    timeout: 1500
  };
  return TooltipComponent;
}(Component);
var createFallbackArray = function createFallbackArray(direction) {
  var clockwiseFallback = [DIRECTION_TOP, DIRECTION_START, DIRECTION_BOTTOM, DIRECTION_END, DIRECTION_START_TOP, DIRECTION_END_TOP, DIRECTION_TOP_LEFT, DIRECTION_BOTTOM_LEFT, DIRECTION_START_BOTTOM, DIRECTION_END_BOTTOM, DIRECTION_TOP_RIGHT, DIRECTION_BOTTOM_RIGHT];
  var index = clockwiseFallback.indexOf(direction);
  return clockwiseFallback.slice(index).concat(clockwiseFallback.slice(0, index));
};
var getFallback = function getFallback(direction) {
  if (typeof direction === 'string') {
    return createFallbackArray(direction);
  }

  if (Array.isArray(direction)) {
    return direction;
  } // Breakpoint object


  Object.keys(direction).map(function (breakpoint) {
    var breakpointValue = direction[breakpoint];
    return direction[breakpoint] = typeof breakpointValue === 'string' ? createFallbackArray(breakpointValue) : breakpointValue;
  });
  return direction;
};
var positionTooltip = function positionTooltip(direction, tooltipBubbleNode, windowMargin, tooltipOuterNode) {
  // tooltip bubble width values
  var _a = [252, 296],
      smallTooltipBubbleWidth = _a[0],
      largeTooltipBubbleWidth = _a[1];
  var left = tooltipOuterNode.left,
      right = tooltipOuterNode.right;
  var bubblePlacementStyle = "calc(100% + " + arrowSize + "px)";
  Object.assign(tooltipBubbleNode.style, {
    bottom: '',
    top: '',
    left: '',
    right: '',
    transform: 'none'
  });

  if (direction === DIRECTION_START || direction === DIRECTION_END) {
    var bubblePositionMap = {
      centre: {
        top: '50%',
        transform: 'translateY(-50%)'
      }
    };
    Object.assign(tooltipBubbleNode.style, bubblePositionMap.centre);
    tooltipBubbleNode.style[direction === DIRECTION_END ? 'right' : 'left'] = bubblePlacementStyle;
  } else if (direction === DIRECTION_TOP || direction === DIRECTION_BOTTOM) {
    var bubblePositionMap = {
      centre: {
        left: '50%',
        transform: 'translateX(-50%)'
      }
    };
    Object.assign(tooltipBubbleNode.style, bubblePositionMap.centre);
    tooltipBubbleNode.style[direction === DIRECTION_TOP ? 'bottom' : 'top'] = bubblePlacementStyle;
  } else if (direction === DIRECTION_START_TOP || direction === DIRECTION_START_BOTTOM) {
    tooltipBubbleNode.style.left = bubblePlacementStyle;
    tooltipBubbleNode.style.bottom = direction === DIRECTION_START_BOTTOM ? '0' : '';
  } else if (direction === DIRECTION_END_TOP || direction === DIRECTION_END_BOTTOM) {
    tooltipBubbleNode.style.right = bubblePlacementStyle;
    tooltipBubbleNode.style.bottom = direction === DIRECTION_END_BOTTOM ? '0' : '';
  } else {
    var windowWidth = document.documentElement.clientWidth;
    var tooltipBubbleWidth = windowWidth <= 360 ? smallTooltipBubbleWidth : largeTooltipBubbleWidth;
    var position = direction === DIRECTION_BOTTOM_LEFT || direction === DIRECTION_BOTTOM_RIGHT ? 'top' : 'bottom';
    tooltipBubbleNode.style[position] = bubblePlacementStyle;

    if (direction === DIRECTION_BOTTOM_LEFT || direction === DIRECTION_TOP_LEFT) {
      if (windowWidth - (left + tooltipBubbleWidth + windowMargin) < 0) {
        var tooltipPosition = windowWidth - (left + tooltipBubbleWidth + windowMargin);
        tooltipBubbleNode.style.left = tooltipPosition + 'px';
      }
    } else if (right < tooltipBubbleWidth) {
      var tooltipPosition = right - (tooltipBubbleWidth + windowMargin);
      tooltipBubbleNode.style.right = tooltipPosition + 'px';
    } else {
      tooltipBubbleNode.style.right = '0px';
    }
  }
};
var Tooltip = WithClonedTooltip(TooltipComponent);

var styles$1C = {"cms-floating-tickers-wrapper":"fr-ec-cms-floating-tickers-wrapper","cmsFloatingTickersWrapper":"fr-ec-cms-floating-tickers-wrapper","cms-floating-tickers-container":"fr-ec-cms-floating-tickers-container","cmsFloatingTickersContainer":"fr-ec-cms-floating-tickers-container","collection-list__item":"fr-ec-collection-list__item","collectionListItem":"fr-ec-collection-list__item"};

var CmsFloatingTickers = function CmsFloatingTickers(_a) {
  var items = _a.items,
      className = _a.className,
      props = __rest(_a, ["items", "className"]);

  var childTickers = Children.toArray(items).map(function (ticker, index) {
    return /*#__PURE__*/cloneElement(ticker, {
      itemId: index,
      key: index
    });
  });
  return /*#__PURE__*/createElement(LayoutWrapper, __assign({
    className: className,
    element: "div"
  }, props), /*#__PURE__*/createElement(Layout, {
    element: "div",
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    className: joinClasses(styles$1C.cmsFloatingTickersWrapper)
  }, /*#__PURE__*/createElement(CollectionList, {
    className: joinClasses(styles$1C.cmsFloatingTickersContainer),
    keylines: "none",
    spacing: "none"
  }, childTickers)));
};
CmsFloatingTickers.displayName = 'CoreCmsFloatingTickers';

var styles$1D = {"cms-vertical-scroll":"fr-ec-cms-vertical-scroll","cmsVerticalScroll":"fr-ec-cms-vertical-scroll","cms-vertical-scroll--with-fixed-gender-tabs":"fr-ec-cms-vertical-scroll--with-fixed-gender-tabs","cmsVerticalScrollWithFixedGenderTabs":"fr-ec-cms-vertical-scroll--with-fixed-gender-tabs","media-carousel":"fr-ec-media-carousel","mediaCarousel":"fr-ec-media-carousel","media-banner--full-stretch":"fr-ec-media-banner--full-stretch","mediaBannerFullStretch":"fr-ec-media-banner--full-stretch","media-banner__full-stretch-container":"fr-ec-media-banner__full-stretch-container","mediaBannerFullStretchContainer":"fr-ec-media-banner__full-stretch-container","cms-vertical-container":"fr-ec-cms-vertical-container","cmsVerticalContainer":"fr-ec-cms-vertical-container","swiper-slide":"fr-ec-swiper-slide","swiperSlide":"fr-ec-swiper-slide","swiper-container-vertical":"fr-ec-swiper-container-vertical","swiperContainerVertical":"fr-ec-swiper-container-vertical","swiper-pagination-bullets":"fr-ec-swiper-pagination-bullets","swiperPaginationBullets":"fr-ec-swiper-pagination-bullets","swiper-vertical-pagination-bullet":"fr-ec-swiper-vertical-pagination-bullet","swiperVerticalPaginationBullet":"fr-ec-swiper-vertical-pagination-bullet","swiper-vertical-pagination-bullet-active":"fr-ec-swiper-vertical-pagination-bullet-active","swiperVerticalPaginationBulletActive":"fr-ec-swiper-vertical-pagination-bullet-active","swiper-slide-without-padding-top":"fr-ec-swiper-slide-without-padding-top","swiperSlideWithoutPaddingTop":"fr-ec-swiper-slide-without-padding-top","swiper-container":"fr-ec-swiper-container","swiperContainer":"fr-ec-swiper-container","gender-tabs--vertical-carousel":"fr-ec-gender-tabs--vertical-carousel","genderTabsVerticalCarousel":"fr-ec-gender-tabs--vertical-carousel","promotion-banner--vertical-carousel":"fr-ec-promotion-banner--vertical-carousel","promotionBannerVerticalCarousel":"fr-ec-promotion-banner--vertical-carousel","swiper-wrapper":"fr-ec-swiper-wrapper","swiperWrapper":"fr-ec-swiper-wrapper","swiper-slide-with-promotion-banner":"fr-ec-swiper-slide-with-promotion-banner","swiperSlideWithPromotionBanner":"fr-ec-swiper-slide-with-promotion-banner","cms-media-banner":"fr-ec-cms-media-banner","cmsMediaBanner":"fr-ec-cms-media-banner","cms-media-banner__logo-container--with-separate-full-screen":"fr-ec-cms-media-banner__logo-container--with-separate-full-screen","cmsMediaBannerLogoContainerWithSeparateFullScreen":"fr-ec-cms-media-banner__logo-container--with-separate-full-screen","cms-media-banner__separate-type-full-screen":"fr-ec-cms-media-banner__separate-type-full-screen","cmsMediaBannerSeparateTypeFullScreen":"fr-ec-cms-media-banner__separate-type-full-screen","cms-media-banner__model-name":"fr-ec-cms-media-banner__model-name","cmsMediaBannerModelName":"fr-ec-cms-media-banner__model-name","cms-media-banner__model-name--with-fullscreen":"fr-ec-cms-media-banner__model-name--with-fullscreen","cmsMediaBannerModelNameWithFullscreen":"fr-ec-cms-media-banner__model-name--with-fullscreen","cms-media-banner__logo-container--with-full-screen":"fr-ec-cms-media-banner__logo-container--with-full-screen","cmsMediaBannerLogoContainerWithFullScreen":"fr-ec-cms-media-banner__logo-container--with-full-screen","gender-tabs":"fr-ec-gender-tabs","genderTabs":"fr-ec-gender-tabs","promotion-banner--vertical-carousel-without-tabs":"fr-ec-promotion-banner--vertical-carousel-without-tabs","promotionBannerVerticalCarouselWithoutTabs":"fr-ec-promotion-banner--vertical-carousel-without-tabs","promotion-banner--vertical-carousel-without-tabs-and-header":"fr-ec-promotion-banner--vertical-carousel-without-tabs-and-header","promotionBannerVerticalCarouselWithoutTabsAndHeader":"fr-ec-promotion-banner--vertical-carousel-without-tabs-and-header","floating-tickers-vertical-carousel":"fr-ec-floating-tickers-vertical-carousel","floatingTickersVerticalCarousel":"fr-ec-floating-tickers-vertical-carousel","floating-tickers-vertical-carousel-with-fixed-tabs":"fr-ec-floating-tickers-vertical-carousel-with-fixed-tabs","floatingTickersVerticalCarouselWithFixedTabs":"fr-ec-floating-tickers-vertical-carousel-with-fixed-tabs","swiper-slide-with-toggle-gender-tabs":"fr-ec-swiper-slide-with-toggle-gender-tabs","swiperSlideWithToggleGenderTabs":"fr-ec-swiper-slide-with-toggle-gender-tabs","swiper-slide-with-padding-top":"fr-ec-swiper-slide-with-padding-top","swiperSlideWithPaddingTop":"fr-ec-swiper-slide-with-padding-top","cms-vertical-scroll-wrapper":"fr-ec-cms-vertical-scroll-wrapper","cmsVerticalScrollWrapper":"fr-ec-cms-vertical-scroll-wrapper","ticker-wraper":"fr-ec-ticker-wraper","tickerWraper":"fr-ec-ticker-wraper","ticker-container":"fr-ec-ticker-container","tickerContainer":"fr-ec-ticker-container","collection-list__item":"fr-ec-collection-list__item","collectionListItem":"fr-ec-collection-list__item","cms-vertical-scroll-with-overflow":"fr-ec-cms-vertical-scroll-with-overflow","cmsVerticalScrollWithOverflow":"fr-ec-cms-vertical-scroll-with-overflow","cms-vertical-scroll-without-overflow":"fr-ec-cms-vertical-scroll-without-overflow","cmsVerticalScrollWithoutOverflow":"fr-ec-cms-vertical-scroll-without-overflow"};

var CmsVerticalScroll =
/** @class */
function (_super) {
  __extends(CmsVerticalScroll, _super);

  function CmsVerticalScroll(props) {
    var _this = _super.call(this, props) || this;

    _this.enableSwiper = function () {
      _this.swiperInstance.mousewheel.enable();

      _this.swiperInstance.allowTouchMove = true;

      _this.swiperInstance.keyboard.enable();

      _this.scrollTopValue = window.pageYOffset;
    };

    _this.componentDidUpdate = function (prevProps) {
      if (_this.swiperInstance) {
        if (prevProps.resetTrigger !== _this.props.resetTrigger) {
          _this.swiperInstance.slideTo(0);

          _this.enableSwiper();
        }

        _this.swiperInstance.update();
      }
    };

    _this.componentWillUnmount = function () {
      if (isInBrowser$1()) {
        window.addEventListener('scroll', _this.detectScroll);
        document.getElementsByTagName('body')[0].style.overflow = '';
        document.getElementsByTagName('body')[0].classList.remove(styles$1D.cmsVerticalScrollWithOverflow, styles$1D.cmsVerticalScrollWithoutOverflow);
      }
    };

    _this.reSizeHandler = function () {
      if (_this.swiperRef.current) {
        var headerElem = document.querySelector(_this.headerClassName);

        _this.setState({
          headerHeight: headerElem && headerElem.offsetHeight || 0,
          isReRender: !_this.state.isReRender
        });

        _this.swiperInstance.update();
      }
    };

    _this.beforeResize = function () {
      if (getOS() === 'iOS' && getCurrentMediaQueryBreakpoint() === 'sm' && _this.swiperInstance.swipeDirection && _this.swiperInstance.swipeDirection === 'next') {
        _this.setState({
          isIosScrollResize: true
        });
      }
    };

    _this.onSlideTransitionEnd = function () {
      if (_this.state.isIosScrollResize) {
        _this.setState({
          isIosScrollResize: false
        });
      }
    };

    _this.detectScroll = function () {
      var headerHeight = _this.state.headerHeight;
      var wDelta = window.pageYOffset > _this.scrollTopValue ? 'down' : 'up';

      if (_this.swiperRef && _this.swiperRef.current) {
        if (wDelta === 'up' && _this.props.toggleGenderTabs) {
          var tabEle = _this.genderTabRef.current;
          var slideEle = _this.swiperSlideRef;
          var tickerEle = _this.floatingTickersRef.current;
          slideEle.forEach(function (item) {
            item.classList.add('swiper-slide-with-padding-top');
            item.classList.remove('swiper-slide-without-padding-top');
          });

          if (_this.genderTabRef.current) {
            tabEle.style.top = headerHeight + "px";
          }

          if (_this.promotionBannerRef.current && _this.swiperInstance.activeIndex === 0) {
            _this.promotionBannerRef.current.style.top = headerHeight + tabEle.clientHeight + "px";
          }

          if (tickerEle) {
            tickerEle.style.top = tabEle.clientHeight + "px";
          }
        } else if (wDelta === 'down' && _this.props.toggleGenderTabs) {
          var slideEle = _this.swiperSlideRef;
          var tabEle = _this.genderTabRef.current;
          slideEle.forEach(function (item) {
            item.classList.remove('swiper-slide-with-padding-top');
            item.classList.add('swiper-slide-without-padding-top');
          });

          if (_this.genderTabRef.current) {
            tabEle.style.top = headerHeight - tabEle.clientHeight + "px";
          }

          if (_this.promotionBannerRef.current) {
            _this.promotionBannerRef.current.style.top = headerHeight - _this.promotionBannerRef.current.clientHeight + "px";
          }
        }

        _this.scrollTopValue = window.pageYOffset;
      }

      if (_this.swiperRef.current) {
        if (_this.scrollTopValue <= 0 && wDelta === 'up' && !_this.swiperInstance.mousewheel.disabled && _this.swiperInstance.slides.length - 1 === _this.swiperInstance.activeIndex) {
          _this.enableSwiper();
        } else if (_this.scrollTopValue > 0 && wDelta === 'down' && !_this.swiperInstance.mousewheel.disabled && _this.swiperInstance.slides.length - 1 === _this.swiperInstance.activeIndex) {
          _this.swiperInstance.mousewheel.disable();

          _this.swiperInstance.allowTouchMove = false;

          _this.swiperInstance.keyboard.disable();

          document.getElementsByTagName('body')[0].style.overflow = 'auto';
          document.getElementsByTagName('body')[0].classList.remove(styles$1D.cmsVerticalScrollWithoutOverflow);
          document.getElementsByTagName('body')[0].classList.add(styles$1D.cmsVerticalScrollWithOverflow);
          _this.scrollTopValue = window.pageYOffset;
        }
      }
    };

    _this.onSlideChange = function () {
      var swiperInstance = _this.swiperInstance;

      if (swiperInstance) {
        var activeSlide_1 = swiperInstance.activeIndex;
        var prevSlide = swiperInstance.previousIndex;
        var slideWrapper = Array.from(swiperInstance.$wrapperEl)[0];
        var slides_1 = Array.from(swiperInstance.slides || []);
        var videos = Array.from(slideWrapper.getElementsByTagName('video') || []);

        _this.setState({
          activeSection: activeSlide_1
        });

        videos.forEach(function (video, index) {
          video.muted = true; // eslint-disable-line no-param-reassign

          var isVisible = slides_1[activeSlide_1].contains(video);

          if (video.readyState !== 0) {
            if (!isVisible) {
              video.pause();
            } else if (video.paused) {
              video.classList.remove('played');
              video.play();
            }
          }
        });

        if (_this.props.toggleGenderTabs) {
          var slideEle = _this.swiperSlideRef;

          if (prevSlide < activeSlide_1 && slideEle) {
            slideEle.forEach(function (item) {
              item.classList.remove('swiper-slide-with-padding-top');
              item.classList.add('swiper-slide-without-padding-top');
            });
          } else if (slideEle) {
            slideEle.forEach(function (item) {
              item.classList.add('swiper-slide-with-padding-top');
              item.classList.remove('swiper-slide-without-padding-top');
            });
          }
        }

        if (prevSlide === slides_1.length - 1) {
          setTimeout(function () {
            document.getElementsByTagName('body')[0].style.overflow = 'hidden';
            document.getElementsByTagName('body')[0].classList.remove(styles$1D.cmsVerticalScrollWithOverflow);
            document.getElementsByTagName('body')[0].classList.add(styles$1D.cmsVerticalScrollWithoutOverflow);
          }, 1000);
        }

        var wDelta = prevSlide < activeSlide_1 ? 'down' : 'up';

        if (wDelta === 'down' && window.innerHeight - _this.state.headerHeight > swiperInstance.height || wDelta === 'up' && swiperInstance.height > window.innerHeight - _this.state.headerHeight) {
          _this.setState({
            isReRender: !_this.state.isReRender
          });

          swiperInstance.update();
        }
      }
    };

    _this.reachEnd = function () {
      setTimeout(function () {
        document.getElementsByTagName('body')[0].style.overflow = 'auto';
        document.getElementsByTagName('body')[0].classList.remove(styles$1D.cmsVerticalScrollWithoutOverflow);
        document.getElementsByTagName('body')[0].classList.add(styles$1D.cmsVerticalScrollWithOverflow);
      }, 1000);
    };

    _this.onSlideNext = function () {
      // console.log('next...');
      var headerHeight = _this.state.headerHeight;
      var tabEle = _this.genderTabRef.current;
      var promotionBannerRef = _this.promotionBannerRef.current;
      var tickerEle = _this.floatingTickersRef.current;

      if (_this.genderTabRef.current && _this.props.toggleGenderTabs) {
        if (tabEle) {
          tabEle.style.top = headerHeight - tabEle.clientHeight + "px";
        }

        if (tickerEle) {
          tickerEle.style.top = "0px";
        }
      }

      if (promotionBannerRef) {
        promotionBannerRef.style.top = headerHeight - promotionBannerRef.clientHeight + "px";
      }
    };

    _this.onSlidePrev = function () {
      var tabEle = _this.genderTabRef.current;
      var promotionBannerRef = _this.promotionBannerRef.current;
      var tickerEle = _this.floatingTickersRef.current;

      if (_this.props.toggleGenderTabs) {
        if (tabEle) {
          tabEle.style.top = '';
        }

        if (tickerEle) {
          tickerEle.style.top = tabEle.clientHeight + "px";
        }
      }

      if (promotionBannerRef && _this.swiperInstance.activeIndex === 0) {
        promotionBannerRef.style.top = '';
      }
    };

    _this.swiperRef = /*#__PURE__*/createRef();
    _this.genderTabRef = /*#__PURE__*/createRef();
    _this.promotionBannerRef = /*#__PURE__*/createRef();
    _this.floatingTickersRef = /*#__PURE__*/createRef();
    _this.swiperSlideRef = [];
    _this.swiperInstance = null;
    _this.scrollTopValue = 0;
    _this.headerClassName = '.fr-ec-navigation-header';
    _this.state = {
      activeSection: 0,
      headerHeight: 0,
      isIosScrollResize: false,
      isReRender: false
    };
    return _this;
  }

  CmsVerticalScroll.prototype.componentDidMount = function () {
    var _this = this;

    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    document.getElementsByTagName('body')[0].classList.add(styles$1D.cmsVerticalScrollWithoutOverflow);
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 2000);
    var headerElem = document.querySelector(this.headerClassName);
    this.setState({
      headerHeight: headerElem && headerElem.offsetHeight || 0
    });
    this.swiperInstance = new swiper(this.swiperRef.current, {
      centeredSlides: true,
      direction: 'vertical',
      keyboard: {
        enabled: true,
        onlyInViewport: false
      },
      mousewheel: {
        forceToAxis: true,
        invert: true,
        releaseOnEdges: true
      },
      on: {
        beforeResize: function beforeResize() {
          return _this.beforeResize();
        },
        reachEnd: function reachEnd() {
          return _this.reachEnd();
        },
        slideChange: function slideChange() {
          return _this.onSlideChange();
        },
        slideNextTransitionEnd: function slideNextTransitionEnd() {
          return _this.onSlideTransitionEnd();
        },
        slideNextTransitionStart: function slideNextTransitionStart() {
          return _this.onSlideNext();
        },
        slidePrevTransitionEnd: function slidePrevTransitionEnd() {
          return _this.onSlideTransitionEnd();
        },
        slidePrevTransitionStart: function slidePrevTransitionStart() {
          return _this.onSlidePrev();
        }
      },
      pagination: {
        bulletActiveClass: 'swiper-vertical-pagination-bullet-active',
        bulletClass: 'swiper-vertical-pagination-bullet',
        bulletElement: 'span',
        clickable: false,
        el: '.swiper-pagination-v',
        type: 'bullets'
      },
      releaseOnEdges: true,
      slidesPerView: 1,
      speed: getCurrentMediaQueryBreakpoint() === 'lg' ? 800 : 400,
      touchReleaseOnEdges: true
    }); // initialise the overflow condition to hidden.

    if (isInBrowser$1()) {
      window.addEventListener('scroll', this.detectScroll);
      window.addEventListener('resize', this.reSizeHandler);
    }

    if (document.getElementsByTagName('body')[0] && this.swiperRef.current) {
      var element = this.swiperRef.current.getBoundingClientRect();

      if (Math.round(element.bottom) === window.innerHeight + (headerElem && Math.round(headerElem.offsetHeight) || 73) && this.scrollTopValue === 0) {
        this.swiperInstance.mousewheel.enable();
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
        document.getElementsByTagName('body')[0].classList.add(styles$1D.cmsVerticalScrollWithoutOverflow);
        this.swiperInstance.allowTouchMove = true;
        this.swiperInstance.keyboard.enable();
      }
    }
  };

  CmsVerticalScroll.prototype.render = function () {
    var _this = this;

    var _a;

    var _b = this.props,
        items = _b.items,
        className = _b.className,
        floatingTickers = _b.floatingTickers,
        genderTabs = _b.genderTabs,
        toggleGenderTabs = _b.toggleGenderTabs,
        gaLabel = _b.gaLabel,
        gaCategory = _b.gaCategory,
        _c = _b.showTicker,
        showTicker = _c === void 0 ? true : _c,
        onTickerClose = _b.onTickerClose,
        promotionBanner = _b.promotionBanner,
        props = __rest(_b, ["items", "className", "defaultIndex", "floatingTickers", "genderTabs", "toggleGenderTabs", "gaLabel", "gaCategory", "showTicker", "onTickerClose", "promotionBanner"]);

    var _d = this.state,
        headerHeight = _d.headerHeight,
        activeSection = _d.activeSection;
    var breakpoint = getCurrentMediaQueryBreakpoint();
    var styleWithWindow = {
      height: isInBrowser$1() ? this.props.toggleGenderTabs ? this.state.isIosScrollResize ? "calc(100vh - " + headerHeight + "px" : window.innerHeight - headerHeight + "px" : window.innerHeight - headerHeight - (genderTabs && breakpoint === 'sm' ? 44 : 0) + "px" : 0
    };
    var childTickers = floatingTickers && Array.isArray(floatingTickers) ? floatingTickers.length > 0 && floatingTickers.map(function (ticker, index) {
      return /*#__PURE__*/cloneElement(ticker, {
        itemId: index,
        key: index,
        onClose: onTickerClose
      });
    }) : floatingTickers && /*#__PURE__*/cloneElement(floatingTickers, {
      onClose: onTickerClose
    });
    var styleWithoutWindow = {
      height: "calc(100vh - " + headerHeight + "px)"
    };
    var isPromotionBannerRendered = promotionBanner && this.promotionBannerRef && this.promotionBannerRef.current && ((_a = this.promotionBannerRef.current.childNodes) === null || _a === void 0 ? void 0 : _a.length);
    var childrenWithProps = Children.toArray(items).filter(isValidElement).map(function (child, index) {
      return /*#__PURE__*/createElement("div", {
        key: index,
        className: joinClasses('swiper-slide', genderTabs && toggleGenderTabs ? 'swiper-slide-with-toggle-gender-tabs' : '', isPromotionBannerRendered && index === 0 ? 'swiper-slide-with-promotion-banner' : ''),
        ref: function ref(_ref) {
          return _this.swiperSlideRef[index] = _ref;
        }
      }, /*#__PURE__*/cloneElement(child, {
        parentActiveIndex: activeSection,
        parentGaCategory: 'L1'
      }));
    });
    var gaProps = null;

    if (gaCategory && gaLabel) {
      gaProps = {
        'data-category': gaCategory,
        'data-label': gaLabel
      };
    }

    return /*#__PURE__*/createElement("div", __assign({
      className: joinClasses(styles$1D.cmsVerticalScrollWrapper, className)
    }, gaProps, props), /*#__PURE__*/createElement("div", {
      ref: this.genderTabRef,
      className: styles$1D.genderTabsVerticalCarousel
    }, genderTabs && /*#__PURE__*/cloneElement(genderTabs[0], {
      enableAutoHide: false
    })), /*#__PURE__*/createElement("div", {
      ref: this.promotionBannerRef,
      className: joinClasses(styles$1D.promotionBannerVerticalCarousel, (!genderTabs || genderTabs.length === 0) && styles$1D.promotionBannerVerticalCarouselWithoutTabs, this.state.headerHeight === 0 && styles$1D.promotionBannerVerticalCarouselWithoutTabsAndHeader)
    }, promotionBanner), showTicker && floatingTickers && /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$1D.floatingTickersVerticalCarousel, (!genderTabs || !toggleGenderTabs) && styles$1D.floatingTickersVerticalCarouselWithFixedTabs),
      ref: this.floatingTickersRef
    }, /*#__PURE__*/createElement(CmsFloatingTickers, {
      items: childTickers
    })), /*#__PURE__*/createElement("div", {
      style: {
        position: 'relative'
      }
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$1D.cmsVerticalScroll, genderTabs && !toggleGenderTabs && styles$1D.cmsVerticalScrollWithFixedGenderTabs, className),
      style: isInBrowser$1() ? __assign({}, styleWithWindow) : __assign({}, styleWithoutWindow)
    }, /*#__PURE__*/createElement("div", {
      ref: this.swiperRef,
      className: joinClasses(styles$1D.cmsVerticalContainer, 'swiper-container-v', className)
    }, /*#__PURE__*/createElement("div", {
      className: "swiper-wrapper"
    }, childrenWithProps), /*#__PURE__*/createElement("div", {
      className: joinClasses('swiper-pagination', 'swiper-pagination-v')
    })))));
  };

  CmsVerticalScroll.displayName = 'CoreCmsVerticalScroll';
  CmsVerticalScroll.defaultProps = {
    toggleGenderTabs: true
  };
  return CmsVerticalScroll;
}(Component);

var styles$1E = {"styling-grid__container--5-column":"fr-ec-styling-grid__container--5-column","stylingGridContainer5Column":"fr-ec-styling-grid__container--5-column","styling-grid__container--4-column":"fr-ec-styling-grid__container--4-column","stylingGridContainer4Column":"fr-ec-styling-grid__container--4-column","styling-grid__container--3-column":"fr-ec-styling-grid__container--3-column","stylingGridContainer3Column":"fr-ec-styling-grid__container--3-column","styling-grid__container--2-column":"fr-ec-styling-grid__container--2-column","stylingGridContainer2Column":"fr-ec-styling-grid__container--2-column","styling-grid__items-has-user-info":"fr-ec-styling-grid__items-has-user-info","stylingGridItemsHasUserInfo":"fr-ec-styling-grid__items-has-user-info","styling-grid__item":"fr-ec-styling-grid__item","stylingGridItem":"fr-ec-styling-grid__item","cms-image-plus-text":"fr-ec-cms-image-plus-text","cmsImagePlusText":"fr-ec-cms-image-plus-text","cms-image-plus-text__media":"fr-ec-cms-image-plus-text__media","cmsImagePlusTextMedia":"fr-ec-cms-image-plus-text__media","cms-image-plus-text__content":"fr-ec-cms-image-plus-text__content","cmsImagePlusTextContent":"fr-ec-cms-image-plus-text__content"};

var StylingGrid = function StylingGrid(_a) {
  var gridItems = _a.gridItems,
      _b = _a.variant,
      variant = _b === void 0 ? 'default' : _b,
      specialItems = _a.specialItems,
      className = _a.className,
      itemHasUserInfo = _a.itemHasUserInfo;

  var _c = React__default.useState(2),
      gridColumns = _c[0],
      updateGridColumns = _c[1];

  var _d = useState(__spreadArrays(gridItems)),
      gridElements = _d[0],
      setGridElements = _d[1]; // viewport limits


  var twoColumnUpperLimit = 453;
  var threeColumnUpperLimit = 720;
  var fourColumnUpperLimit = 876; // const values for numbers. used to set special images grid-row attribute for grid items.

  var two = 2;
  var four = 4;

  var specialImageRowNoRight = 1;
  var specialImageRowNoLeft = 3;
  var specialImageIndex = 0;
  useEffect(function () {
    setGridElements(getGridItems(gridColumns));
  }, [gridColumns, gridItems, variant]);

  var onResize = function onResize(contentRect) {
    if (contentRect.bounds) {
      var width = contentRect.bounds.width;

      if (width <= twoColumnUpperLimit) {
        updateGridColumns(2);
      } else if (width > twoColumnUpperLimit && width <= threeColumnUpperLimit) {
        updateGridColumns(3);
      } else if (width > threeColumnUpperLimit && width <= fourColumnUpperLimit) {
        updateGridColumns(4);
      } else {
        updateGridColumns(5);
      }
    }
  };

  var addSpecialImage = function addSpecialImage(index, row, column) {
    var specialImages = specialItems;
    return /*#__PURE__*/React__default.createElement("div", {
      key: "specialItems-" + index,
      style: {
        gridColumn: column ? column + " / span " + two : 'auto',
        gridRow: row ? row + " / span " + two : 'auto'
      },
      className: styles$1E.stylingGridItem
    }, specialImages[index], ' ');
  };

  var isRenderSpecialImages = function isRenderSpecialImages(index, columns) {
    return index > 0 && (index + 1) % columns === 0 && (index + 1) / columns % two !== 0;
  };

  var getGridItems = function getGridItems(columns) {
    var items = gridItems.map(function (item, index) {
      return /*#__PURE__*/React__default.createElement("div", {
        className: styles$1E.stylingGridItem,
        key: index
      }, item);
    });

    if (variant !== 'default' && specialItems) {
      for (var index = 0; index < gridItems.length; index++) {
        if (specialImageIndex < specialItems.length) {
          var isLastItem = index === gridItems.length - 1;
          var isImagePlusText = variant === 'imagePlusText';

          if (columns === 2 && (index + 1) % four === 0) {
            var specialItem = addSpecialImage(specialImageIndex, isImagePlusText ? 'auto' : '', isImagePlusText ? 'auto' : '');
            items.splice(index + specialImageIndex + 1, 0, specialItem);
            specialImageIndex += 1;
          } else if (columns === 3 && (index === 1 || (index - 1) % four === 0)) {
            var specialItemRight = addSpecialImage(specialImageIndex, isImagePlusText ? index.toString() : '', isImagePlusText ? '2' : '');

            if (!isLastItem && specialImageIndex + 1 < specialItems.length) {
              var specialItemLeft = addSpecialImage(specialImageIndex + 1, isImagePlusText ? (index + two).toString() : '', isImagePlusText ? '1' : '');
              items.splice(index + specialImageIndex + 1, 0, specialItemRight, specialItemLeft);
              specialImageIndex += two;
            } else {
              items.splice(index + specialImageIndex + 1, 0, specialItemRight);
              specialImageIndex += 1;
            }
          } else if (columns === four && isRenderSpecialImages(index, four)) {
            var gridRow = (index + 1) / four * two - 1;
            var specialItemRight = addSpecialImage(specialImageIndex, gridRow.toString(), '3');

            if (!isLastItem && specialImageIndex + 1 < specialItems.length) {
              var specialItemLeft = addSpecialImage(specialImageIndex + 1, (gridRow + two).toString(), '1');
              items.splice(index + specialImageIndex + 1, 0, specialItemRight, specialItemLeft);
              specialImageIndex += two;
            } else {
              items.splice(index + specialImageIndex + 1, 0, specialItemRight);
              specialImageIndex += 1;
            }
          } else if (columns === 5 && isRenderSpecialImages(index, 6)) {
            var specialImageRight = addSpecialImage(specialImageIndex, specialImageRowNoRight.toString(), four.toString());

            if (!isLastItem && specialImageIndex + 1 < specialItems.length) {
              var specialImageLeft = addSpecialImage(specialImageIndex + 1, specialImageRowNoLeft.toString(), '1');
              items.splice(index + specialImageIndex + 1, 0, specialImageRight, specialImageLeft);
              specialImageRowNoRight += four;
              specialImageRowNoLeft += four;
              specialImageIndex += two;
            } else {
              items.splice(index + specialImageIndex + 1, 0, specialImageRight);
              specialImageIndex += 1;
            }
          }
        }
      }
    }

    return items;
  };

  return /*#__PURE__*/React__default.createElement(Measure, {
    bounds: true,
    onResize: onResize
  }, function (_a) {
    var measureRef = _a.measureRef;
    return /*#__PURE__*/React__default.createElement("div", {
      ref: measureRef,
      className: joinClasses(className, styles$1E["styling-grid__container--" + gridColumns + "-column"], gridColumns === 2 && itemHasUserInfo && styles$1E.stylingGridItemsHasUserInfo)
    }, gridElements);
  });
};
StylingGrid.displayName = 'CoreStylingGrid';

var styles$1F = {"filter-layout":"fr-ec-filter-layout","filterLayout":"fr-ec-filter-layout","filter-layout--utility-bar-container":"fr-ec-filter-layout--utility-bar-container","filterLayoutUtilityBarContainer":"fr-ec-filter-layout--utility-bar-container","filter-layout--utility-bar-visibility-hidden":"fr-ec-filter-layout--utility-bar-visibility-hidden","filterLayoutUtilityBarVisibilityHidden":"fr-ec-filter-layout--utility-bar-visibility-hidden","sticky-container--with-sticky-tab":"fr-ec-sticky-container--with-sticky-tab","stickyContainerWithStickyTab":"fr-ec-sticky-container--with-sticky-tab","utility-bar--keyline":"fr-ec-utility-bar--keyline","utilityBarKeyline":"fr-ec-utility-bar--keyline","utility-bar--overlay":"fr-ec-utility-bar--overlay","utilityBarOverlay":"fr-ec-utility-bar--overlay","dropdown__list":"fr-ec-dropdown__list","dropdownList":"fr-ec-dropdown__list","filter-layout--with-sticky-tab":"fr-ec-filter-layout--with-sticky-tab","filterLayoutWithStickyTab":"fr-ec-filter-layout--with-sticky-tab","filter-layout--sticky-container":"fr-ec-filter-layout--sticky-container","filterLayoutStickyContainer":"fr-ec-filter-layout--sticky-container","filter-layout__fixed-panel-fixed":"fr-ec-filter-layout__fixed-panel-fixed","filterLayoutFixedPanelFixed":"fr-ec-filter-layout__fixed-panel-fixed","filter-layout-utility-bar":"fr-ec-filter-layout-utility-bar","filterLayoutUtilityBar":"fr-ec-filter-layout-utility-bar","filter-layout-page-content":"fr-ec-filter-layout-page-content","filterLayoutPageContent":"fr-ec-filter-layout-page-content","filter-layout-utility-bar--wrapper":"fr-ec-filter-layout-utility-bar--wrapper","filterLayoutUtilityBarWrapper":"fr-ec-filter-layout-utility-bar--wrapper","filter-layout-margin":"fr-ec-filter-layout-margin","filterLayoutMargin":"fr-ec-filter-layout-margin","filter-layout__fixed-panel":"fr-ec-filter-layout__fixed-panel","filterLayoutFixedPanel":"fr-ec-filter-layout__fixed-panel","forwards":"fr-ec-forwards"};

var FilterLayout = function FilterLayout(_a) {
  var className = _a.className,
      filterPanel = _a.filterPanel,
      pageContent = _a.pageContent,
      utilityBarContent = _a.utilityBarContent,
      _b = _a.showFilterPanel,
      showFilterPanel = _b === void 0 ? true : _b,
      _c = _a.toggleMarginOnLarge,
      toggleMarginOnLarge = _c === void 0 ? true : _c,
      _d = _a.stickyFilterPanelOnLarge,
      stickyFilterPanelOnLarge = _d === void 0 ? false : _d;
  var stickyRef = useRef(null);
  var utilityRef = useRef(null);
  useEffect(function () {
    if (isInBrowser$1() && stickyFilterPanelOnLarge) {
      window.addEventListener('scroll', handleScroll);
    }

    return function () {
      if (isInBrowser$1() && stickyFilterPanelOnLarge) {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  }, [stickyRef === null || stickyRef === void 0 ? void 0 : stickyRef.current]);

  var handleScroll = function handleScroll() {
    if (stickyRef && stickyRef.current && utilityRef && utilityRef.current) {
      var rect = utilityRef.current.getBoundingClientRect();
      var isVisible = rect.top + rect.height >= 0;

      if (stickyRef.current.getBoundingClientRect().bottom + rect.height <= window.innerHeight && !isVisible) {
        utilityRef.current.classList.add('fr-ec-filter-layout--utility-bar-visibility-hidden');
      } else {
        utilityRef.current.classList.remove('fr-ec-filter-layout--utility-bar-visibility-hidden');
      }
    }
  };

  return /*#__PURE__*/createElement(LayoutWrapper, {
    element: "section",
    className: joinClasses(!toggleMarginOnLarge && styles$1F.filterLayoutMargin, styles$1F.filterLayout, className)
  }, showFilterPanel && !stickyFilterPanelOnLarge && filterPanel && /*#__PURE__*/createElement(Layout, {
    visible: {
      lg: true,
      md: false,
      sm: false
    },
    element: "div",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 3
    },
    className: styles$1F.filterLayoutFixedPanel
  }, filterPanel), /*#__PURE__*/createElement(Layout, {
    element: "div",
    colSpan: {
      sm: 4,
      md: 12,
      lg: showFilterPanel && !stickyFilterPanelOnLarge ? 9 : 12
    },
    className: styles$1F.filterLayoutUtilityBarWrapper
  }, /*#__PURE__*/createElement(Layout, {
    className: styles$1F.filterLayoutUtilityBar,
    element: "div",
    colSpan: {
      sm: 4,
      md: 12,
      lg: showFilterPanel && !stickyFilterPanelOnLarge ? 9 : 12
    }
  }, /*#__PURE__*/createElement("div", {
    ref: utilityRef
  }, utilityBarContent)), /*#__PURE__*/createElement("div", {
    ref: stickyRef
  }, /*#__PURE__*/createElement(Layout, {
    className: styles$1F.filterLayoutPageContent,
    element: "div",
    colSpan: {
      sm: 4,
      md: 12,
      lg: showFilterPanel && !stickyFilterPanelOnLarge ? 9 : 12
    }
  }, pageContent))));
};
FilterLayout.displayName = 'CoreFilterLayout';

var styles$1G = {"template-ilp__main-content-min-height":"fr-ec-template-ilp__main-content-min-height","templateIlpMainContentMinHeight":"fr-ec-template-ilp__main-content-min-height"};

var LayoutGutter$1 = function LayoutGutter(props) {
  return /*#__PURE__*/createElement(Layout, __assign({
    gutter: true
  }, props));
};

var TemplateILP = function TemplateILP(_a) {
  var navigationPath = _a.navigationPath,
      pageHeading = _a.pageHeading,
      mainContent = _a.mainContent,
      promotionalSection = _a.promotionalSection,
      _b = _a.toggleMinHeight,
      toggleMinHeight = _b === void 0 ? true : _b,
      className = _a.className,
      props = __rest(_a, ["navigationPath", "pageHeading", "mainContent", "promotionalSection", "toggleMinHeight", "className"]);

  return /*#__PURE__*/createElement(LayoutWrapper, __assign({
    element: "section",
    className: joinClasses(className, toggleMinHeight && styles$1G.templateIlpMainContentMinHeight)
  }, props), navigationPath && /*#__PURE__*/createElement(LayoutGutter$1, {
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, navigationPath), pageHeading && /*#__PURE__*/createElement(Layout, {
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, pageHeading), /*#__PURE__*/createElement(LayoutGutter$1, {
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, mainContent), promotionalSection && /*#__PURE__*/createElement(LayoutGutter$1, {
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, promotionalSection));
};
TemplateILP.displayName = 'CoreTemplateILP';

var styles$1H = {"tag-filter":"fr-ec-tag-filter","tagFilter":"fr-ec-tag-filter","tag-filter__max-width":"fr-ec-tag-filter__max-width","tagFilterMaxWidth":"fr-ec-tag-filter__max-width","tag-filter__label":"fr-ec-tag-filter__label","tagFilterLabel":"fr-ec-tag-filter__label","tag-filter__label--disabled":"fr-ec-tag-filter__label--disabled","tagFilterLabelDisabled":"fr-ec-tag-filter__label--disabled","tag-filter__icon":"fr-ec-tag-filter__icon","tagFilterIcon":"fr-ec-tag-filter__icon","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","tag-filter--on-touch":"fr-ec-tag-filter--on-touch","tagFilterOnTouch":"fr-ec-tag-filter--on-touch"};

var TagFilter = function TagFilter(_a) {
  var value = _a.value,
      onClick = _a.onClick,
      className = _a.className,
      _b = _a.ariaLabel,
      ariaLabel = _b === void 0 ? value + " filter tag" : _b,
      onDismiss = _a.onDismiss,
      _c = _a.disabled,
      disabled = _c === void 0 ? false : _c,
      _d = _a.dismissable,
      dismissable = _d === void 0 ? true : _d,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["value", "onClick", "className", "ariaLabel", "onDismiss", "disabled", "dismissable", "iconBrand"]);

  var onTouchStartHandler = function onTouchStartHandler(event) {
    var elm = event.currentTarget;
    var tagElements = document.getElementsByClassName(styles$1H.tagFilterOnTouch);
    [].forEach.call(tagElements, function (el) {
      el.classList.remove(styles$1H.tagFilterOnTouch);
    });

    if (elm) {
      elm.classList.add(styles$1H.tagFilterOnTouch);
    }
  };

  var onFocusOutHandler = function onFocusOutHandler(event) {
    var elm = event.currentTarget;
    elm.classList.remove(styles$1H.tagFilterOnTouch);
  };

  return /*#__PURE__*/createElement("button", __assign({
    className: joinClasses(styles$1H.tagFilter, dismissable && styles$1H.tagFilterMaxWidth, interactionsStyles.cursorPointer, className),
    "aria-label": ariaLabel,
    onClick: onClick,
    disabled: disabled,
    onTouchStart: onTouchStartHandler,
    onBlur: onFocusOutHandler
  }, props), /*#__PURE__*/createElement(Caption, {
    element: "span",
    variant: "standard",
    className: joinClasses(styles$1H.tagFilterLabel, (disabled || !dismissable) && styles$1H.tagFilterLabelDisabled)
  }, value), dismissable && /*#__PURE__*/createElement(ButtonIcon, {
    element: "button",
    icon: "close",
    label: "Dismiss",
    variant: "dark",
    hideLabel: true,
    onClick: onDismiss,
    className: styles$1H.tagFilterIcon,
    iconBrand: iconBrand
  }));
};
TagFilter.displayName = 'CoreTagFilter';
TagFilter.defaultProps = {
  disabled: false
};

var styles$1I = {"scale-static__legend":"fr-ec-scale-static__legend","scaleStaticLegend":"fr-ec-scale-static__legend","scale-static__children":"fr-ec-scale-static__children","scaleStaticChildren":"fr-ec-scale-static__children"};

var ScaleStatic = function ScaleStatic(_a) {
  var children = _a.children,
      legend = _a.legend,
      className = _a.className,
      props = __rest(_a, ["children", "legend", "className"]);

  return /*#__PURE__*/createElement("div", __assign({
    className: className
  }, props), legend ? /*#__PURE__*/createElement(Label, {
    className: styles$1I.scaleStaticLegend,
    element: "span",
    variant: "standard"
  }, legend) : null, /*#__PURE__*/createElement("div", {
    className: styles$1I.scaleStaticChildren
  }, children));
};
ScaleStatic.displayName = 'CoreScaleStatic';

var styles$1J = {"scale-static-item":"fr-ec-scale-static-item","scaleStaticItem":"fr-ec-scale-static-item","scale-static-item__span":"fr-ec-scale-static-item__span","scaleStaticItemSpan":"fr-ec-scale-static-item__span","scale-static-item__span--selected":"fr-ec-scale-static-item__span--selected","scaleStaticItemSpanSelected":"fr-ec-scale-static-item__span--selected","scale-static-item__text":"fr-ec-scale-static-item__text","scaleStaticItemText":"fr-ec-scale-static-item__text","scale-static-item__text--visible":"fr-ec-scale-static-item__text--visible","scaleStaticItemTextVisible":"fr-ec-scale-static-item__text--visible"};

var ScaleStaticItem = function ScaleStaticItem(_a) {
  var label = _a.label,
      isSelected = _a.isSelected,
      showLabel = _a.showLabel,
      className = _a.className,
      props = __rest(_a, ["label", "isSelected", "showLabel", "className"]);

  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$1J.scaleStaticItem, className)
  }, props), /*#__PURE__*/createElement("span", {
    className: joinClasses(styles$1J.scaleStaticItemSpan, isSelected ? styles$1J['scale-static-item__span--selected'] : '')
  }), /*#__PURE__*/createElement(Label, {
    element: "span",
    variant: "standard",
    "aria-hidden": !isSelected,
    className: joinClasses(styles$1J.scaleStaticItemText, showLabel ? styles$1J['scale-static-item__text--visible'] : '')
  }, label));
};
ScaleStaticItem.displayName = 'CoreScaleStaticItem';
ScaleStaticItem.defaultProps = {
  isSelected: false
};

var LayoutGutter$2 = function LayoutGutter(props) {
  return /*#__PURE__*/React__default.createElement(Layout, __assign({
    gutter: true
  }, props));
};

var navigationHeaderHeight = 73;
var TemplatePDP = function TemplatePDP(_a) {
  var navigationPath = _a.navigationPath,
      pageHeading = _a.pageHeading,
      mediaGallery = _a.mediaGallery,
      productSelector = _a.productSelector,
      bannerArea = _a.bannerArea,
      productDetails = _a.productDetails,
      relatedItems = _a.relatedItems,
      className = _a.className,
      stickySectionZIndex = _a.stickySectionZIndex;
  var scrollTop = isInBrowser$1() ? window.pageYOffset : 0;
  var isDesktopMedia = isInBrowser$1() ? window.matchMedia('(min-width: 960px)') : false;

  var _b = React__default.useState(getCurrentMediaQueryBreakpoint()),
      screenSize = _b[0],
      setScreenSize = _b[1];

  useEffect(function () {
    if (isDesktopMedia && isDesktopMedia.matches) {
      window.addEventListener('scroll', trackScroll);
    }
  });

  var onResize = function onResize() {
    var productSelectorContainerClasses = document.getElementsByClassName('fr-ec-template-pdp-product-selector-container');

    if (productSelectorContainerClasses.length > 0) {
      var productSelectorContainerClass = productSelectorContainerClasses[0];

      if (isDesktopMedia && !isDesktopMedia.matches) {
        productSelectorContainerClass.removeAttribute('style');
      }

      if (isDesktopMedia && isDesktopMedia.matches) {
        window.addEventListener('scroll', trackScroll);
      }
    }

    setScreenSize(getCurrentMediaQueryBreakpoint());
  };

  var trackScroll = function trackScroll() {
    var productSelectorContainerClasses = document.getElementsByClassName('fr-ec-template-pdp-product-selector-container');
    var productDetailsContainerClasses = document.getElementsByClassName('fr-ec-template-pdp-product-details-container');

    if (productSelectorContainerClasses.length > 0 && productDetailsContainerClasses.length > 0) {
      var productSelectorContainerClass = productSelectorContainerClasses[0];
      var productDetailsContainerClass = productDetailsContainerClasses[0];
      var productDetailsContainerHeight = productDetailsContainerClass.getBoundingClientRect().height;
      var productSelectorContainerHeight = productSelectorContainerClass.getBoundingClientRect().height;
      var combinedHeight = productSelectorContainerHeight + navigationHeaderHeight;

      if (isDesktopMedia && isDesktopMedia.matches && productDetailsContainerHeight > productSelectorContainerHeight) {
        if (combinedHeight >= window.innerHeight) {
          var currScroll = window.pageYOffset;

          if (currScroll > scrollTop) {
            if (window.innerHeight >= productDetailsContainerClass.getBoundingClientRect().bottom) {
              productSelectorContainerClass.style.position = 'relative';
              productSelectorContainerClass.style.top = productDetailsContainerHeight - productSelectorContainerHeight + "px";
            } else if (productSelectorContainerClass.getBoundingClientRect().bottom <= window.innerHeight) {
              productSelectorContainerClass.style.position = 'fixed';
              productSelectorContainerClass.style.top = 'auto';
              productSelectorContainerClass.style.bottom = 0 + "px";
            }
          } else {
            if (productDetailsContainerClass.getBoundingClientRect().top >= navigationHeaderHeight) {
              productSelectorContainerClass.style.position = 'relative';
              productSelectorContainerClass.style.top = '0';
            } else if (productDetailsContainerClass.getBoundingClientRect().top >= 0 || productSelectorContainerClass.getBoundingClientRect().top >= 0) {
              productSelectorContainerClass.style.position = 'fixed';
              productSelectorContainerClass.style.top = navigationHeaderHeight + "px";
            } else if (productSelectorContainerClass.style.position === 'fixed') {
              var top_1 = productDetailsContainerClass.getBoundingClientRect().top;
              var elemTop = productSelectorContainerClass.getBoundingClientRect().top;
              productSelectorContainerClass.style.position = 'relative';
              productSelectorContainerClass.style.top = -1 * top_1 + elemTop + "px";
            }
          }

          scrollTop = currScroll;
        } else {
          productSelectorContainerClass.style.position = 'sticky';
          productSelectorContainerClass.style.top = navigationHeaderHeight + "px";
        }
      }
    }
  };

  var templatePDP = /*#__PURE__*/React__default.createElement(LayoutWrapper, {
    element: "section"
  }, navigationPath && /*#__PURE__*/React__default.createElement(LayoutGutter$2, {
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, navigationPath), bannerArea && /*#__PURE__*/React__default.createElement(LayoutGutter$2, {
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, bannerArea), pageHeading && /*#__PURE__*/React__default.createElement(LayoutGutter$2, {
    gutter: true
  }, pageHeading), /*#__PURE__*/React__default.createElement(Layout, {
    colSpan: {
      sm: 4,
      md: 12,
      lg: 12
    },
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    visible: {
      sm: true,
      md: true,
      lg: true
    }
  }, /*#__PURE__*/React__default.createElement(Layout, {
    gutter: {
      sm: false,
      md: false,
      lg: true
    },
    inset: {
      right: {
        sm: false,
        md: false,
        lg: true
      }
    },
    colSpan: {
      sm: 4,
      md: 12,
      lg: 8
    },
    className: "fr-ec-template-pdp-product-details-container"
  }, mediaGallery, screenSize !== 'lg' && /*#__PURE__*/React__default.createElement("div", {
    className: joinClasses('fr-ec-layout--gutter-sm', 'fr-ec-template-pdp-product-selector-container')
  }, productSelector), productDetails), /*#__PURE__*/React__default.createElement(LayoutGutter$2, {
    visible: {
      sm: false,
      md: false,
      lg: true
    },
    gutter: {
      sm: false,
      md: false,
      lg: true
    },
    colSpan: {
      sm: 4,
      md: 12,
      lg: 4
    },
    className: "fr-ec-template-pdp-product-selector-container",
    style: {
      zIndex: stickySectionZIndex
    }
  }, productSelector)), relatedItems && /*#__PURE__*/React__default.createElement(LayoutGutter$2, {
    visible: {
      sm: true,
      md: true,
      lg: true
    },
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    colSpan: {
      sm: 4,
      md: 12,
      lg: 12
    }
  }, relatedItems));
  return /*#__PURE__*/React__default.createElement(Measure, {
    onResize: debounce(100, onResize)
  }, function (_a) {
    var measureRef = _a.measureRef;
    return /*#__PURE__*/React__default.createElement("div", {
      className: className,
      ref: measureRef
    }, templatePDP);
  });
};
TemplatePDP.displayName = 'CoreTemplatePDP';

var styles$1K = {"cms-spacer-xxs":"fr-ec-cms-spacer-xxs","cmsSpacerXxs":"fr-ec-cms-spacer-xxs","cms-spacer-xs":"fr-ec-cms-spacer-xs","cmsSpacerXs":"fr-ec-cms-spacer-xs","cms-spacer-s":"fr-ec-cms-spacer-s","cmsSpacerS":"fr-ec-cms-spacer-s","cms-spacer-m":"fr-ec-cms-spacer-m","cmsSpacerM":"fr-ec-cms-spacer-m","cms-spacer-l":"fr-ec-cms-spacer-l","cmsSpacerL":"fr-ec-cms-spacer-l","cms-spacer-xl":"fr-ec-cms-spacer-xl","cmsSpacerXl":"fr-ec-cms-spacer-xl","cms-spacer-xxl":"fr-ec-cms-spacer-xxl","cmsSpacerXxl":"fr-ec-cms-spacer-xxl","cms-spacer-xxxl":"fr-ec-cms-spacer-xxxl","cmsSpacerXxxl":"fr-ec-cms-spacer-xxxl"};

var CmsSpacer = function CmsSpacer(_a) {
  var spaces = _a.spaces,
      className = _a.className,
      props = __rest(_a, ["spaces", "className"]);

  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(className, styles$1K["cms-spacer-" + spaces])
  }, props));
};
CmsSpacer.displayName = 'CoreCmsSpacer';

var styles$1L = {"cms-link":"fr-ec-cms-link","cmsLink":"fr-ec-cms-link"};

var CmsLink = function CmsLink(_a) {
  var url = _a.url,
      _b = _a.gaCategory,
      gaCategory = _b === void 0 ? '' : _b,
      _c = _a.gaLabel,
      gaLabel = _c === void 0 ? '' : _c,
      gaAction = _a.gaAction,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      target = _a.target,
      className = _a.className,
      props = __rest(_a, ["url", "gaCategory", "gaLabel", "gaAction", "gaValue", "gaCallback", "target", "className"]);

  var rootTag = 'a';
  var absoluteUrlPattern = isAbsoluteUrl(url);
  var attributes = {};

  if (absoluteUrlPattern) {
    attributes = {
      href: url,
      target: target || '_blank'
    };
  } else if (url) {
    rootTag = Link$1; // Default target behaviour of Link is similar to that of '_self'.
    // But if you specify target property explicitly, it refreshes the page.
    // @ts-ignore

    attributes.to = url;

    if (target && target !== '_self') {
      // @ts-ignore
      attributes.target = target;
    }
  }

  return /*#__PURE__*/createElement(Tile, __assign({
    className: joinClasses(className, styles$1L.cmsLink),
    variant: "default",
    element: rootTag,
    href: url,
    gaCategory: gaCategory,
    gaAction: gaAction,
    gaLabel: gaLabel,
    gaValue: gaValue,
    gaCallback: gaCallback
  }, attributes, props));
};
CmsLink.displayName = 'CoreCmsLink';
CmsLink.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var CmsFooterLinkItem = function CmsFooterLinkItem(_a) {
  var label = _a.label,
      url = _a.url,
      target = _a.target,
      iconName = _a.iconName,
      iconPosition = _a.iconPosition,
      _b = _a.gaCategory,
      gaCategory = _b === void 0 ? '' : _b,
      _c = _a.gaLabel,
      gaLabel = _c === void 0 ? '' : _c,
      gaAction = _a.gaAction,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      className = _a.className,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["label", "url", "target", "iconName", "iconPosition", "gaCategory", "gaLabel", "gaAction", "gaValue", "gaCallback", "className", "iconBrand"]);

  var rootTag = 'a';
  var absoluteUrlPattern = isAbsoluteUrl(url);
  var attributes = {};

  if (absoluteUrlPattern) {
    attributes = {
      href: url,
      target: target || '_blank'
    };
  } else if (url) {
    rootTag = Link$1; // Default target behaviour of Link is similar to that of '_self'.
    // But if you specify target property explicitly, it refreshes the page.
    // @ts-ignore

    attributes.to = url;

    if (target && target !== '_self') {
      // @ts-ignore
      attributes.target = target;
    }
  }

  return /*#__PURE__*/createElement(LinkNavigation, __assign({
    className: className,
    element: rootTag,
    icon: iconName,
    iconPosition: iconPosition,
    href: url,
    gaCategory: gaCategory,
    gaLabel: gaLabel,
    gaAction: gaAction,
    gaValue: gaValue,
    gaCallback: gaCallback,
    iconBrand: iconBrand
  }, attributes, props), label);
};
CmsFooterLinkItem.displayName = 'CoreCmsFooterLinkItem';
CmsFooterLinkItem.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null,
  iconPosition: 'start'
};

var styles$1M = {"cms-footer--link-group-title":"fr-ec-cms-footer--link-group-title","cmsFooterLinkGroupTitle":"fr-ec-cms-footer--link-group-title"};

var CmsFooterLinkGroup = function CmsFooterLinkGroup(_a) {
  var title = _a.title,
      children = _a.children,
      variant = _a.variant,
      props = __rest(_a, ["title", "children", "variant"]);

  return /*#__PURE__*/createElement("div", __assign({}, props), title && /*#__PURE__*/createElement(Caption, {
    variant: "standard",
    color: "secondary",
    className: styles$1M.cmsFooterLinkGroupTitle,
    element: "p"
  }, title), /*#__PURE__*/createElement(LinkNavigationGroup, {
    labelId: useId('footer-link-group'),
    variant: variant === "dynamic" ? "dynamic" : 'horizontal'
  }, children));
};
CmsFooterLinkGroup.displayName = 'CoreCmsFooterLinkGroup';

var styles$1N = {"cms-image-plus-text-collection":"fr-ec-cms-image-plus-text-collection","cmsImagePlusTextCollection":"fr-ec-cms-image-plus-text-collection","cms-image-plus-text-collection--4-column":"fr-ec-cms-image-plus-text-collection--4-column","cmsImagePlusTextCollection4Column":"fr-ec-cms-image-plus-text-collection--4-column","cms-image-plus-text-collection--4-column-small":"fr-ec-cms-image-plus-text-collection--4-column-small","cmsImagePlusTextCollection4ColumnSmall":"fr-ec-cms-image-plus-text-collection--4-column-small","cms-image-plus-text-collection--4-column-vertical":"fr-ec-cms-image-plus-text-collection--4-column-vertical","cmsImagePlusTextCollection4ColumnVertical":"fr-ec-cms-image-plus-text-collection--4-column-vertical","cms-image-plus-text__media":"fr-ec-cms-image-plus-text__media","cmsImagePlusTextMedia":"fr-ec-cms-image-plus-text__media","cms-image-plus-text":"fr-ec-cms-image-plus-text","cmsImagePlusText":"fr-ec-cms-image-plus-text","cms-image-plus-text-collection--2-column":"fr-ec-cms-image-plus-text-collection--2-column","cmsImagePlusTextCollection2Column":"fr-ec-cms-image-plus-text-collection--2-column","cms-image-plus-text-collection--3-column":"fr-ec-cms-image-plus-text-collection--3-column","cmsImagePlusTextCollection3Column":"fr-ec-cms-image-plus-text-collection--3-column","cms-image-plus-text-collection--3-column-small":"fr-ec-cms-image-plus-text-collection--3-column-small","cmsImagePlusTextCollection3ColumnSmall":"fr-ec-cms-image-plus-text-collection--3-column-small","cms-image-plus-text-collection--with-product-collection":"fr-ec-cms-image-plus-text-collection--with-product-collection","cmsImagePlusTextCollectionWithProductCollection":"fr-ec-cms-image-plus-text-collection--with-product-collection","cms-image-plus-text-collection--single-media":"fr-ec-cms-image-plus-text-collection--single-media","cmsImagePlusTextCollectionSingleMedia":"fr-ec-cms-image-plus-text-collection--single-media","cms-image-plus-text__content":"fr-ec-cms-image-plus-text__content","cmsImagePlusTextContent":"fr-ec-cms-image-plus-text__content","tile":"fr-ec-tile","cms-image-plus-text-Wrapper":"fr-ec-cms-image-plus-text-Wrapper","cmsImagePlusTextWrapper":"fr-ec-cms-image-plus-text-Wrapper","cms-image-plus-text-collection--3-colum-small":"fr-ec-cms-image-plus-text-collection--3-colum-small","cmsImagePlusTextCollection3ColumSmall":"fr-ec-cms-image-plus-text-collection--3-colum-small"};

var CmsImagePlusTextCollection = function CmsImagePlusTextCollection(_a) {
  var layout = _a.layout,
      items = _a.items,
      className = _a.className,
      props = __rest(_a, ["layout", "items", "className"]);

  var layoutMap = {
    fourColumn: styles$1N.cmsImagePlusTextCollection4Column,
    fourColumnSmall: styles$1N.cmsImagePlusTextCollection4ColumnSmall,
    fourColumnVertical: styles$1N.cmsImagePlusTextCollection4ColumnVertical,
    singleMedia: styles$1N.cmsImagePlusTextCollectionSingleMedia,
    threeColumn: styles$1N.cmsImagePlusTextCollection3Column,
    threeColumnSmall: styles$1N.cmsImagePlusTextCollection3ColumnSmall,
    twoColumn: styles$1N.cmsImagePlusTextCollection2Column,
    withProductCollection: styles$1N.cmsImagePlusTextCollectionWithProductCollection
  };
  var imagePlusText = Children.map(items, function (child, i) {
    return /*#__PURE__*/createElement(Fragment, {
      key: i
    }, child);
  });
  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$1N.cmsImagePlusTextCollection, layoutMap[layout], className)
  }, props), imagePlusText);
};
CmsImagePlusTextCollection.displayName = 'CoreCmsImagePlusTextCollection';

var styles$1O = {"template-full-gutter--min-height":"fr-ec-template-full-gutter--min-height","templateFullGutterMinHeight":"fr-ec-template-full-gutter--min-height"};

var TemplateFullGutter = function TemplateFullGutter(_a) {
  var navigationPath = _a.navigationPath,
      mainContent = _a.mainContent,
      _b = _a.toggleMinHeight,
      toggleMinHeight = _b === void 0 ? true : _b,
      className = _a.className,
      props = __rest(_a, ["navigationPath", "mainContent", "toggleMinHeight", "className"]);

  return /*#__PURE__*/createElement(LayoutWrapper, __assign({
    className: className,
    element: "section"
  }, props), navigationPath && /*#__PURE__*/createElement(Layout, {
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, navigationPath), /*#__PURE__*/createElement(Layout, {
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    className: toggleMinHeight ? styles$1O.templateFullGutterMinHeight : ''
  }, mainContent));
};
TemplateFullGutter.displayName = 'CoreTemplateFullGutter';

var styles$1P = {"template-media-information--min-height":"fr-ec-template-media-information--min-height","templateMediaInformationMinHeight":"fr-ec-template-media-information--min-height","template-media-information-enable-sticky-interaction":"fr-ec-template-media-information-enable-sticky-interaction","templateMediaInformationEnableStickyInteraction":"fr-ec-template-media-information-enable-sticky-interaction"};

var TemplateMediaInformation = function TemplateMediaInformation(_a) {
  var navigationPath = _a.navigationPath,
      pageHeading = _a.pageHeading,
      mainContent = _a.mainContent,
      mediaContent = _a.mediaContent,
      subContent = _a.subContent,
      className = _a.className,
      _b = _a.toggleStickyInteraction,
      toggleStickyInteraction = _b === void 0 ? false : _b,
      _c = _a.toggleMinHeight,
      toggleMinHeight = _c === void 0 ? true : _c,
      props = __rest(_a, ["navigationPath", "pageHeading", "mainContent", "mediaContent", "subContent", "className", "toggleStickyInteraction", "toggleMinHeight"]);

  return /*#__PURE__*/createElement(LayoutWrapper, __assign({
    element: "section",
    className: className
  }, props), navigationPath && /*#__PURE__*/createElement(Layout, {
    element: "nav",
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, navigationPath), pageHeading && /*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 12
    },
    gutter: {
      sm: false,
      md: true,
      lg: true
    }
  }, pageHeading), (mediaContent || mainContent) && /*#__PURE__*/createElement(Layout, {
    element: "section"
  }, mediaContent && /*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 5
    },
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    className: toggleStickyInteraction ? styles$1P.templateMediaInformationEnableStickyInteraction : ''
  }, mediaContent), mainContent && /*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 7
    },
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    inset: {
      left: {
        sm: false,
        md: false,
        lg: true
      }
    }
  }, mainContent)), subContent && /*#__PURE__*/createElement(Layout, {
    element: "section",
    colSpan: {
      sm: 4,
      md: 12,
      lg: 12
    },
    gutter: {
      sm: false,
      md: true,
      lg: true
    },
    className: toggleMinHeight ? styles$1P.templateMediaInformationMinHeight : ''
  }, subContent));
};
TemplateMediaInformation.displayName = 'CoreTemplateMediaInformation';

var styles$1Q = {"cms-category-image-container":"fr-ec-cms-category-image-container","cmsCategoryImageContainer":"fr-ec-cms-category-image-container"};

var CmsCategoryImageContainer = function CmsCategoryImageContainer(_a) {
  var children = _a.children,
      gaCategory = _a.gaCategory,
      className = _a.className,
      props = __rest(_a, ["children", "gaCategory", "className"]);

  return /*#__PURE__*/createElement("div", __assign({
    "data-category": gaCategory,
    className: joinClasses(className, styles$1Q.cmsCategoryImageContainer)
  }, props), children);
};
CmsCategoryImageContainer.displayName = 'CoreCmsCategoryImageContainer';

var styles$1R = {"cms-link-button--is-small":"fr-ec-cms-link-button--is-small","cmsLinkButtonIsSmall":"fr-ec-cms-link-button--is-small"};

var CmsLinkButton = function CmsLinkButton(_a) {
  var label = _a.label,
      url = _a.url,
      target = _a.target,
      _b = _a.type,
      type = _b === void 0 ? 'primary' : _b,
      disabled = _a.disabled,
      uppercase = _a.uppercase,
      _c = _a.gaCategory,
      gaCategory = _c === void 0 ? '' : _c,
      _d = _a.gaLabel,
      gaLabel = _d === void 0 ? '' : _d,
      gaAction = _a.gaAction,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      className = _a.className,
      isSmall = _a.isSmall,
      props = __rest(_a, ["label", "url", "target", "type", "disabled", "uppercase", "gaCategory", "gaLabel", "gaAction", "gaValue", "gaCallback", "className", "isSmall"]);

  var rootTag = 'a';
  var absoluteUrlPattern = isAbsoluteUrl(url);
  var attributes = {};

  if (absoluteUrlPattern) {
    attributes = {
      href: url,
      target: target || '_blank'
    };
  } else if (url) {
    rootTag = Link$1; // Default target behaviour of Link is similar to that of '_self'.
    // But if you specify target property explicitly, it refreshes the page.
    // @ts-ignore

    attributes.to = url;

    if (target && target !== '_self') {
      // @ts-ignore
      attributes.target = target;
    }
  }

  return /*#__PURE__*/createElement(Button, __assign({
    className: joinClasses(isSmall && styles$1R.cmsLinkButtonIsSmall, className),
    element: rootTag,
    variant: type === 'highPrimary' ? 'transactional' : type,
    disabled: disabled,
    textTransform: uppercase ? 'all-caps' : 'normal',
    gaLabel: gaLabel,
    gaCategory: gaCategory,
    gaAction: gaAction,
    gaValue: gaValue,
    gaCallback: gaCallback,
    isSmall: isSmall
  }, attributes, props), label);
};
CmsLinkButton.displayName = 'CoreCmsLinkButton';
CmsLinkButton.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var styles$1S = {"cms-accordion-list-item":"fr-ec-cms-accordion-list-item","cmsAccordionListItem":"fr-ec-cms-accordion-list-item","title":"fr-ec-title"};

var CmsAccordionListItem = function CmsAccordionListItem(_a) {
  var label = _a.label,
      url = _a.url,
      target = _a.target,
      gaLabel = _a.gaLabel,
      gaCategory = _a.gaCategory,
      className = _a.className,
      props = __rest(_a, ["label", "url", "target", "gaLabel", "gaCategory", "className"]);

  var rootTag = 'a';
  var absoluteUrlPattern = isAbsoluteUrl(url);
  var attributes = {};

  if (absoluteUrlPattern) {
    attributes = {
      href: url,
      target: target || '_blank'
    };
  } else if (url) {
    rootTag = Link$1;
    attributes = {
      target: target,
      to: url
    };
  }

  return /*#__PURE__*/createElement(LinkNavigation, __assign({
    className: joinClasses(className, styles$1S.cmsAccordionListItem),
    element: rootTag,
    gaCategory: gaCategory,
    gaLabel: gaLabel
  }, props, attributes), label);
};
CmsAccordionListItem.displayName = 'CoreCmsAccordionListItem';

var CmsAccordionList = function CmsAccordionList(_a) {
  var children = _a.children,
      _b = _a.type,
      type = _b === void 0 ? 'small' : _b,
      className = _a.className,
      _c = _a.indented,
      indented = _c === void 0 ? true : _c,
      props = __rest(_a, ["children", "type", "className", "indented"]);

  var typeToPadding = {
    large: 'vertical-large',
    small: 'vertical'
  };
  return /*#__PURE__*/createElement(LinkNavigationGroup, __assign({
    className: className,
    indented: indented,
    labelId: useId('accordion-list'),
    variant: typeToPadding[type]
  }, props), children);
};
CmsAccordionList.displayName = 'CoreCmsAccordionList';

var styles$1T = {"cms-media-banner":"fr-ec-cms-media-banner","cmsMediaBanner":"fr-ec-cms-media-banner","cms-media-banner__container":"fr-ec-cms-media-banner__container","cmsMediaBannerContainer":"fr-ec-cms-media-banner__container","cms-media-banner--full-stretch":"fr-ec-cms-media-banner--full-stretch","cmsMediaBannerFullStretch":"fr-ec-cms-media-banner--full-stretch","cms-media-banner__full-stretch-container":"fr-ec-cms-media-banner__full-stretch-container","cmsMediaBannerFullStretchContainer":"fr-ec-cms-media-banner__full-stretch-container","cms-media-banner__separate-container":"fr-ec-cms-media-banner__separate-container","cmsMediaBannerSeparateContainer":"fr-ec-cms-media-banner__separate-container","cms-media-banner__child-container--non-full-screen":"fr-ec-cms-media-banner__child-container--non-full-screen","cmsMediaBannerChildContainerNonFullScreen":"fr-ec-cms-media-banner__child-container--non-full-screen","cms-media-banner__separate-type":"fr-ec-cms-media-banner__separate-type","cmsMediaBannerSeparateType":"fr-ec-cms-media-banner__separate-type","cms-media-banner__separate-type-full-screen":"fr-ec-cms-media-banner__separate-type-full-screen","cmsMediaBannerSeparateTypeFullScreen":"fr-ec-cms-media-banner__separate-type-full-screen","cms-media-banner__separate-type-full-screen-container":"fr-ec-cms-media-banner__separate-type-full-screen-container","cmsMediaBannerSeparateTypeFullScreenContainer":"fr-ec-cms-media-banner__separate-type-full-screen-container","image--ratio-1x1":"fr-ec-image--ratio-1x1","imageRatio1X1":"fr-ec-image--ratio-1x1","image__no-image-container":"fr-ec-image__no-image-container","imageNoImageContainer":"fr-ec-image__no-image-container","cms-media-banner--bg-with-white-text":"fr-ec-cms-media-banner--bg-with-white-text","cmsMediaBannerBgWithWhiteText":"fr-ec-cms-media-banner--bg-with-white-text","no-image":"fr-ec-no-image","noImage":"fr-ec-no-image","no-image__video":"fr-ec-no-image__video","noImageVideo":"fr-ec-no-image__video","no-image__label":"fr-ec-no-image__label","noImageLabel":"fr-ec-no-image__label","no-image__icon":"fr-ec-no-image__icon","noImageIcon":"fr-ec-no-image__icon","cms-media-banner--crop-image-middle":"fr-ec-cms-media-banner--crop-image-middle","cmsMediaBannerCropImageMiddle":"fr-ec-cms-media-banner--crop-image-middle","cms-media-banner__logo-container":"fr-ec-cms-media-banner__logo-container","cmsMediaBannerLogoContainer":"fr-ec-cms-media-banner__logo-container","cms-media-banner__logo-container--with-full-screen":"fr-ec-cms-media-banner__logo-container--with-full-screen","cmsMediaBannerLogoContainerWithFullScreen":"fr-ec-cms-media-banner__logo-container--with-full-screen","cms-media-banner__logo-container--with-separate-full-screen":"fr-ec-cms-media-banner__logo-container--with-separate-full-screen","cmsMediaBannerLogoContainerWithSeparateFullScreen":"fr-ec-cms-media-banner__logo-container--with-separate-full-screen","cms-media-banner__separate-full-screen-layout-wrapper":"fr-ec-cms-media-banner__separate-full-screen-layout-wrapper","cmsMediaBannerSeparateFullScreenLayoutWrapper":"fr-ec-cms-media-banner__separate-full-screen-layout-wrapper","image":"fr-ec-image","image__img":"fr-ec-image__img","imageImg":"fr-ec-image__img","medi-banner__model-name-white":"fr-ec-medi-banner__model-name-white","mediBannerModelNameWhite":"fr-ec-medi-banner__model-name-white","medi-banner__model-name-black":"fr-ec-medi-banner__model-name-black","mediBannerModelNameBlack":"fr-ec-medi-banner__model-name-black","cms-media-banner__model-name":"fr-ec-cms-media-banner__model-name","cmsMediaBannerModelName":"fr-ec-cms-media-banner__model-name","cms-media-banner__model-name--with-fullscreen":"fr-ec-cms-media-banner__model-name--with-fullscreen","cmsMediaBannerModelNameWithFullscreen":"fr-ec-cms-media-banner__model-name--with-fullscreen","cms-media-banner__model-name--without-fullscreen":"fr-ec-cms-media-banner__model-name--without-fullscreen","cmsMediaBannerModelNameWithoutFullscreen":"fr-ec-cms-media-banner__model-name--without-fullscreen","cms-media-banner__layout-wrapper--full-screen":"fr-ec-cms-media-banner__layout-wrapper--full-screen","cmsMediaBannerLayoutWrapperFullScreen":"fr-ec-cms-media-banner__layout-wrapper--full-screen","cms-media-banner__layout-wrapper":"fr-ec-cms-media-banner__layout-wrapper","cmsMediaBannerLayoutWrapper":"fr-ec-cms-media-banner__layout-wrapper","cms-media-banner__button":"fr-ec-cms-media-banner__button","cmsMediaBannerButton":"fr-ec-cms-media-banner__button","cms-media-banner__separate-type-button":"fr-ec-cms-media-banner__separate-type-button","cmsMediaBannerSeparateTypeButton":"fr-ec-cms-media-banner__separate-type-button","cms-media-banner--full-screen__button":"fr-ec-cms-media-banner--full-screen__button","cmsMediaBannerFullScreenButton":"fr-ec-cms-media-banner--full-screen__button","cms-media-banner__text-container":"fr-ec-cms-media-banner__text-container","cmsMediaBannerTextContainer":"fr-ec-cms-media-banner__text-container","cms-media-banner__text-container--normal-full-screen":"fr-ec-cms-media-banner__text-container--normal-full-screen","cmsMediaBannerTextContainerNormalFullScreen":"fr-ec-cms-media-banner__text-container--normal-full-screen","cms-media-banner__text-container--normal-non-full-screen":"fr-ec-cms-media-banner__text-container--normal-non-full-screen","cmsMediaBannerTextContainerNormalNonFullScreen":"fr-ec-cms-media-banner__text-container--normal-non-full-screen","cms-media-banner--full-screen__overlay":"fr-ec-cms-media-banner--full-screen__overlay","cmsMediaBannerFullScreenOverlay":"fr-ec-cms-media-banner--full-screen__overlay","cms-media-banner--full-screen__overlay--left":"fr-ec-cms-media-banner--full-screen__overlay--left","cmsMediaBannerFullScreenOverlayLeft":"fr-ec-cms-media-banner--full-screen__overlay--left","cms-media-banner--full-screen__overlay--right":"fr-ec-cms-media-banner--full-screen__overlay--right","cmsMediaBannerFullScreenOverlayRight":"fr-ec-cms-media-banner--full-screen__overlay--right","cms-media-banner__separate_text-container":"fr-ec-cms-media-banner__separate_text-container","cmsMediaBannerSeparateTextContainer":"fr-ec-cms-media-banner__separate_text-container","cms-media-banner__separate-type-fullscreen_text-container":"fr-ec-cms-media-banner__separate-type-fullscreen_text-container","cmsMediaBannerSeparateTypeFullscreenTextContainer":"fr-ec-cms-media-banner__separate-type-fullscreen_text-container","cms-media-banner__text-container--with-price-full-screen":"fr-ec-cms-media-banner__text-container--with-price-full-screen","cmsMediaBannerTextContainerWithPriceFullScreen":"fr-ec-cms-media-banner__text-container--with-price-full-screen","cms-media-banner__copy-right-text":"fr-ec-cms-media-banner__copy-right-text","cmsMediaBannerCopyRightText":"fr-ec-cms-media-banner__copy-right-text","cms-media-banner__separate-copy-right-text":"fr-ec-cms-media-banner__separate-copy-right-text","cmsMediaBannerSeparateCopyRightText":"fr-ec-cms-media-banner__separate-copy-right-text","cms-media-banner__separate-copy-right-text-normal":"fr-ec-cms-media-banner__separate-copy-right-text-normal","cmsMediaBannerSeparateCopyRightTextNormal":"fr-ec-cms-media-banner__separate-copy-right-text-normal","cms-media-banner__category-text":"fr-ec-cms-media-banner__category-text","cmsMediaBannerCategoryText":"fr-ec-cms-media-banner__category-text","cms-media-banner__title":"fr-ec-cms-media-banner__title","cmsMediaBannerTitle":"fr-ec-cms-media-banner__title","cms-media-banner__separate-title":"fr-ec-cms-media-banner__separate-title","cmsMediaBannerSeparateTitle":"fr-ec-cms-media-banner__separate-title","cms-media-banner__margin-top":"fr-ec-cms-media-banner__margin-top","cmsMediaBannerMarginTop":"fr-ec-cms-media-banner__margin-top","cms-media-banner__description":"fr-ec-cms-media-banner__description","cmsMediaBannerDescription":"fr-ec-cms-media-banner__description","cms-media-banner__product-name":"fr-ec-cms-media-banner__product-name","cmsMediaBannerProductName":"fr-ec-cms-media-banner__product-name","cms-media-banner--text-black":"fr-ec-cms-media-banner--text-black","cmsMediaBannerTextBlack":"fr-ec-cms-media-banner--text-black","cms-media-banner--text-white":"fr-ec-cms-media-banner--text-white","cmsMediaBannerTextWhite":"fr-ec-cms-media-banner--text-white","cms-media-banner__flag-text":"fr-ec-cms-media-banner__flag-text","cmsMediaBannerFlagText":"fr-ec-cms-media-banner__flag-text","cms-media-banner__flag-text--label":"fr-ec-cms-media-banner__flag-text--label","cmsMediaBannerFlagTextLabel":"fr-ec-cms-media-banner__flag-text--label","cms-media-banner__flag-text--label-white":"fr-ec-cms-media-banner__flag-text--label-white","cmsMediaBannerFlagTextLabelWhite":"fr-ec-cms-media-banner__flag-text--label-white","cms-media-banner__flag-text--label-black":"fr-ec-cms-media-banner__flag-text--label-black","cmsMediaBannerFlagTextLabelBlack":"fr-ec-cms-media-banner__flag-text--label-black","cms-media-banner__flag-text--label--separate-type":"fr-ec-cms-media-banner__flag-text--label--separate-type","cmsMediaBannerFlagTextLabelSeparateType":"fr-ec-cms-media-banner__flag-text--label--separate-type","cms-media-banner__separate-price-container":"fr-ec-cms-media-banner__separate-price-container","cmsMediaBannerSeparatePriceContainer":"fr-ec-cms-media-banner__separate-price-container","cms-media-banner__price":"fr-ec-cms-media-banner__price","cmsMediaBannerPrice":"fr-ec-cms-media-banner__price","price-text--l1":"fr-ec-price-text--l1","priceTextL1":"fr-ec-price-text--l1","cms-media-banner__price--separate":"fr-ec-cms-media-banner__price--separate","cmsMediaBannerPriceSeparate":"fr-ec-cms-media-banner__price--separate","price-text--large":"fr-ec-price-text--large","priceTextLarge":"fr-ec-price-text--large","cms-media-banner__price-white":"fr-ec-cms-media-banner__price-white","cmsMediaBannerPriceWhite":"fr-ec-cms-media-banner__price-white","cms-media-banner__price-black":"fr-ec-cms-media-banner__price-black","cmsMediaBannerPriceBlack":"fr-ec-cms-media-banner__price-black","content-alignment--alignment-baseline":"fr-ec-content-alignment--alignment-baseline","contentAlignmentAlignmentBaseline":"fr-ec-content-alignment--alignment-baseline","cms-media-banner__copy-right-text-white":"fr-ec-cms-media-banner__copy-right-text-white","cmsMediaBannerCopyRightTextWhite":"fr-ec-cms-media-banner__copy-right-text-white","cms-media-banner__copy-right-text-black":"fr-ec-cms-media-banner__copy-right-text-black","cmsMediaBannerCopyRightTextBlack":"fr-ec-cms-media-banner__copy-right-text-black","cms-media-banner__separate-product-name":"fr-ec-cms-media-banner__separate-product-name","cmsMediaBannerSeparateProductName":"fr-ec-cms-media-banner__separate-product-name","cms-media-banner--no-text-shadow":"fr-ec-cms-media-banner--no-text-shadow","cmsMediaBannerNoTextShadow":"fr-ec-cms-media-banner--no-text-shadow","cms-media-banner__description-separate-type":"fr-ec-cms-media-banner__description-separate-type","cmsMediaBannerDescriptionSeparateType":"fr-ec-cms-media-banner__description-separate-type","cms-media-banner__button-wrapper":"fr-ec-cms-media-banner__button-wrapper","cmsMediaBannerButtonWrapper":"fr-ec-cms-media-banner__button-wrapper","cms-media-banner__text-container--with-price-non-full-screen":"fr-ec-cms-media-banner__text-container--with-price-non-full-screen","cmsMediaBannerTextContainerWithPriceNonFullScreen":"fr-ec-cms-media-banner__text-container--with-price-non-full-screen","cms-media-banner__separate-copy-right-text-non-full-screen":"fr-ec-cms-media-banner__separate-copy-right-text-non-full-screen","cmsMediaBannerSeparateCopyRightTextNonFullScreen":"fr-ec-cms-media-banner__separate-copy-right-text-non-full-screen","cms-media-banner__flag-text__separate":"fr-ec-cms-media-banner__flag-text__separate","cmsMediaBannerFlagTextSeparate":"fr-ec-cms-media-banner__flag-text__separate","cms-media-banner__separate-button-wrapper":"fr-ec-cms-media-banner__separate-button-wrapper","cmsMediaBannerSeparateButtonWrapper":"fr-ec-cms-media-banner__separate-button-wrapper","cms-media-banner--right-top":"fr-ec-cms-media-banner--right-top","cmsMediaBannerRightTop":"fr-ec-cms-media-banner--right-top","cms-media-banner--right-middle":"fr-ec-cms-media-banner--right-middle","cmsMediaBannerRightMiddle":"fr-ec-cms-media-banner--right-middle","cms-media-banner--right-bottom":"fr-ec-cms-media-banner--right-bottom","cmsMediaBannerRightBottom":"fr-ec-cms-media-banner--right-bottom","cms-media-banner__price--separate-full-screen":"fr-ec-cms-media-banner__price--separate-full-screen","cmsMediaBannerPriceSeparateFullScreen":"fr-ec-cms-media-banner__price--separate-full-screen","cms-media-banner__separate-button-wrapper-full-screen":"fr-ec-cms-media-banner__separate-button-wrapper-full-screen","cmsMediaBannerSeparateButtonWrapperFullScreen":"fr-ec-cms-media-banner__separate-button-wrapper-full-screen","cms-media-banner__separate-button-full-screen":"fr-ec-cms-media-banner__separate-button-full-screen","cmsMediaBannerSeparateButtonFullScreen":"fr-ec-cms-media-banner__separate-button-full-screen","cms-media-banner__description-separate-type--full-screen":"fr-ec-cms-media-banner__description-separate-type--full-screen","cmsMediaBannerDescriptionSeparateTypeFullScreen":"fr-ec-cms-media-banner__description-separate-type--full-screen","cms-media-banner__separate-type-non-full-screen":"fr-ec-cms-media-banner__separate-type-non-full-screen","cmsMediaBannerSeparateTypeNonFullScreen":"fr-ec-cms-media-banner__separate-type-non-full-screen","cms-media-banner--normal":"fr-ec-cms-media-banner--normal","cmsMediaBannerNormal":"fr-ec-cms-media-banner--normal","cms-media-banner__button-wrapper-normal":"fr-ec-cms-media-banner__button-wrapper-normal","cmsMediaBannerButtonWrapperNormal":"fr-ec-cms-media-banner__button-wrapper-normal","cms-media-banner__description--normal":"fr-ec-cms-media-banner__description--normal","cmsMediaBannerDescriptionNormal":"fr-ec-cms-media-banner__description--normal"};

var _a$1, _b, _c;
var BLACK = 'black';
var WHITE = 'white';
var NORMAL = 'normal';
var SEPARATE_NORMAL = 'separateNormal';
var SEPARATE_WITHPRICE = 'separateWithPrice';
var WITHPRICE = 'withPrice';
var copyrighTextColorStyle = (_a$1 = {}, _a$1[WHITE] = styles$1T.cmsMediaBannerCopyRightTextWhite, _a$1[BLACK] = styles$1T.cmsMediaBannerCopyRightTextBlack, _a$1);
var mediaBannerModelTextColor = (_b = {}, _b[BLACK] = styles$1T.mediBannerModelNameBlack, _b[WHITE] = styles$1T.mediBannerModelNameWhite, _b);
var mediaBannerFlagTextStyles = (_c = {}, _c[BLACK] = styles$1T.cmsMediaBannerFlagTextLabelBlack, _c[WHITE] = styles$1T.cmsMediaBannerFlagTextLabelWhite, _c);

var getText = function getText(text) {
  return text && text.replace(/\\n|\n/g, '\n');
};

var CmsMediaBanner = function CmsMediaBanner(_a) {
  var description = _a.description,
      title = _a.title,
      _b = _a.textColor,
      textColor = _b === void 0 ? 'white' : _b,
      logoImage = _a.logoImage,
      priceText = _a.priceText,
      _c = _a.priceTextColor,
      priceTextColor = _c === void 0 ? 'white' : _c,
      priceLabel = _a.priceLabel,
      productName = _a.productName,
      buttonLabel = _a.buttonLabel,
      _d = _a.type,
      type = _d === void 0 ? 'normal' : _d,
      children = _a.children,
      modelName = _a.modelName,
      _e = _a.modelNameColor,
      modelNameColor = _e === void 0 ? 'white' : _e,
      categoryText = _a.categoryText,
      copyrightText = _a.copyrightText,
      _f = _a.copyrightTextColor,
      copyrightTextColor = _f === void 0 ? 'white' : _f,
      _g = _a.isFullScreen,
      isFullScreen = _g === void 0 ? true : _g,
      flagText = _a.flagText,
      props = __rest(_a, ["description", "title", "textColor", "logoImage", "priceText", "priceTextColor", "priceLabel", "productName", "buttonLabel", "className", "type", "children", "modelName", "modelNameColor", "categoryText", "copyrightText", "copyrightTextColor", "isFullScreen", "flagText"]);
  var isFullScreenValue = isFullScreen ? 'full-screen' : 'non-full-screen';
  var varientClass = type === NORMAL && joinClasses(styles$1T.cmsMediaBannerNormal);
  var bgColorStyle = textColor === WHITE ? styles$1T.cmsMediaBannerBgWithWhiteText : '';
  var isTypeSeparateType = type === SEPARATE_NORMAL || type === SEPARATE_WITHPRICE;
  var isTypeWithPrice = type === SEPARATE_WITHPRICE || type === WITHPRICE;
  var textBlackClass = textColor === 'black' ? styles$1T.cmsMediaBannerTextBlack : styles$1T.cmsMediaBannerTextWhite;
  var width = getViewportWidth();
  var isLargeScreenDevice = width > designTokens_3.mqMediumScreenMaxWidthLimit;
  var isSmallScreenDevice = width < designTokens_3.mqSmallScreenMaxWidthLimit;

  var ModelName = function ModelName() {
    var modelNameClass = joinClasses(styles$1T.cmsMediaBannerModelName, mediaBannerModelTextColor[modelNameColor]);
    return modelName ? /*#__PURE__*/createElement(Caption, {
      color: "primary-dark",
      element: "p",
      variant: "standard",
      className: joinClasses(modelNameClass, !isFullScreen && styles$1T.cmsMediaBannerModelNameWithoutFullscreen, !isTypeSeparateType && isFullScreen && styles$1T.cmsMediaBannerModelNameWithFullscreen)
    }, modelName) : null;
  };

  var LogoContainer = function LogoContainer() {
    if (!Array.isArray(logoImage)) {
      return null;
    }

    var Logo = logoImage && /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$1T.cmsMediaBannerLogoContainer, isFullScreen && isTypeSeparateType && styles$1T.cmsMediaBannerLogoContainerWithSeparateFullScreen, isFullScreen && !isTypeSeparateType && styles$1T.cmsMediaBannerLogoContainerWithFullScreen)
    }, logoImage.map(function (logo, index) {
      return /*#__PURE__*/createElement(Fragment, {
        key: index
      }, logo);
    }));
    return !isTypeSeparateType ? Logo : isFullScreen ? /*#__PURE__*/createElement(LayoutWrapper, {
      element: "div",
      className: isFullScreen && styles$1T.cmsMediaBannerSeparateFullScreenLayoutWrapper || ''
    }, /*#__PURE__*/createElement(Layout, {
      element: "div",
      gutter: {
        sm: false,
        md: false,
        lg: true
      },
      className: styles$1T.cmsMediaBannerLayoutWrapperFullScreen
    }, Logo)) : Logo;
  };

  var CopyrightText = function CopyrightText() {
    var copyrightStyles = isTypeSeparateType ? joinClasses(styles$1T.cmsMediaBannerSeparateCopyRightText, !isFullScreen && styles$1T.cmsMediaBannerSeparateCopyRightTextNonFullScreen, copyrighTextColorStyle[copyrightTextColor]) : joinClasses(styles$1T.cmsMediaBannerCopyRightText, copyrighTextColorStyle[copyrightTextColor]);
    return copyrightText ? /*#__PURE__*/createElement(Caption, {
      textTransform: "normal",
      element: "p",
      variant: "media-banner-copyright",
      className: copyrightStyles
    }, getText(copyrightText)) : null;
  };

  var TextContainer = function TextContainer() {
    var buttonClass = '';
    var buttonWrapper = '';

    if (isTypeSeparateType) {
      buttonClass = joinClasses(styles$1T.cmsMediaBannerButton, styles$1T.cmsMediaBannerSeparateTypeButton, isFullScreen && styles$1T.cmsMediaBannerSeparateButtonFullScreen, isFullScreen || isSmallScreenDevice ? typographyStyles.titleSmall : typographyStyles.buttonSmall);
      buttonWrapper = joinClasses(styles$1T.cmsMediaBannerSeparateButtonWrapper, isFullScreen && styles$1T.cmsMediaBannerSeparateButtonWrapperFullScreen);
    }

    if (!isTypeSeparateType) {
      buttonWrapper = joinClasses(styles$1T.cmsMediaBannerButtonWrapper, type === NORMAL && styles$1T.cmsMediaBannerButtonWrapperNormal);
      buttonClass = joinClasses(styles$1T.cmsMediaBannerButton, isFullScreen && styles$1T.cmsMediaBannerFullScreenButton, typographyStyles.buttonSmall);
    }

    return /*#__PURE__*/createElement(ContentAlignment, {
      element: "div",
      direction: "column",
      className: joinClasses(varientClass, styles$1T.cmsMediaBannerTextContainer, type === NORMAL && styles$1T["cms-media-banner__text-container--normal-" + isFullScreenValue], isTypeSeparateType && styles$1T.cmsMediaBannerSeparateTextContainer, isFullScreen && isTypeSeparateType && styles$1T.cmsMediaBannerSeparateTypeFullscreenTextContainer, type === WITHPRICE && styles$1T["cms-media-banner__text-container--with-price-" + isFullScreenValue]),
      alignment: "flex-start",
      justifyContent: "flex-end"
    }, flagText && /*#__PURE__*/createElement(Label, {
      color: textColor === BLACK ? "primary-dark" : "primary-light",
      className: joinClasses(styles$1T.cmsMediaBannerFlagTextLabel, isTypeSeparateType && styles$1T.cmsMediaBannerFlagTextLabelSeparateType, mediaBannerFlagTextStyles[textColor]),
      element: "label",
      variant: isTypeSeparateType ? "standard-emphasized" : "large"
    }, getText(flagText)), categoryText && isFullScreen && type === NORMAL && /*#__PURE__*/createElement(Title, {
      textTransform: "normal",
      element: "span",
      variant: "media-banner-category-name",
      className: joinClasses(styles$1T.cmsMediaBannerCategoryText, textBlackClass)
    }, getText(categoryText)), title && type !== SEPARATE_WITHPRICE && /*#__PURE__*/createElement(Display, {
      textTransform: "normal",
      element: 'h2',
      variant: isTypeSeparateType ? isSmallScreenDevice ? 'display4' : 'display2' : 'display1',
      className: joinClasses(styles$1T.cmsMediaBannerTitle, isFullScreen && type === NORMAL && styles$1T.cmsMediaBannerMarginTop, isTypeSeparateType && styles$1T.cmsMediaBannerNoTextShadow, textBlackClass)
    }, getText(title)), isTypeWithPrice && productName && /*#__PURE__*/createElement(Title, {
      textTransform: "normal",
      element: "span",
      variant: "media-banner-product-name",
      className: joinClasses(styles$1T.cmsMediaBannerProductName, isTypeSeparateType && styles$1T.cmsMediaBannerSeparateProductName, textBlackClass)
    }, getText(productName)), /*#__PURE__*/createElement("div", {
      className: buttonWrapper
    }, /*#__PURE__*/createElement("div", {
      className: isTypeSeparateType ? styles$1T.cmsMediaBannerSeparatePriceContainer : ''
    }, description && !isTypeWithPrice && (isTypeSeparateType ? isLargeScreenDevice ? /*#__PURE__*/createElement(Title, {
      textTransform: "normal",
      element: "h5",
      variant: 'media-banner-product-name',
      className: joinClasses(styles$1T.cmsMediaBannerDescription, styles$1T.cmsMediaBannerDescriptionSeparateType, textBlackClass)
    }, getText(description)) : /*#__PURE__*/createElement(Body, {
      textTransform: "normal",
      element: "h5",
      variant: 'standard',
      className: joinClasses(styles$1T.cmsMediaBannerDescriptionSeparateType, isFullScreen && styles$1T.cmsMediaBannerDescriptionSeparateTypeFullScreen, textBlackClass)
    }, getText(description)) : /*#__PURE__*/createElement(Title, {
      textTransform: "normal",
      element: "h5",
      variant: 'media-banner-category-name',
      className: joinClasses(styles$1T.cmsMediaBannerDescription, type === NORMAL && styles$1T.cmsMediaBannerDescriptionNormal, textBlackClass)
    }, getText(description))), isTypeWithPrice && priceText && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Price, {
      element: "p",
      size: isTypeSeparateType ? 'large' : 'l1',
      children: priceText,
      variant: "promotional",
      className: joinClasses(styles$1T.cmsMediaBannerPrice, styles$1T["cms-media-banner__price--separate-" + isFullScreenValue], isTypeSeparateType && styles$1T.cmsMediaBannerPriceSeparate, styles$1T["cms-media-banner__price-" + priceTextColor])
    }), priceLabel && /*#__PURE__*/createElement(FlagText, {
      textTransform: "normal",
      variant: "large",
      element: "p",
      className: joinClasses(styles$1T.cmsMediaBannerFlagText, isTypeSeparateType && styles$1T.cmsMediaBannerFlagTextSeparate, styles$1T["cms-media-banner__price-" + priceTextColor])
    }, getText(priceLabel)))), buttonLabel && /*#__PURE__*/createElement("span", {
      className: buttonClass
    }, buttonLabel)), !isTypeSeparateType && /*#__PURE__*/createElement(CopyrightText, null));
  };

  var CmsMediaBannerChild = function CmsMediaBannerChild() {
    var childComponent = null;
    var containerClassName = isTypeSeparateType ? joinClasses(styles$1T.cmsMediaBannerContainer, isFullScreen && styles$1T.cmsMediaBannerFullStretchContainer, bgColorStyle, styles$1T.cmsMediaBannerCropImageMiddle, styles$1T.cmsMediaBannerSeparateContainer, isFullScreen && styles$1T.cmsMediaBannerSeparateTypeFullScreenContainer) : joinClasses(styles$1T.cmsMediaBannerContainer, isFullScreen && styles$1T.cmsMediaBannerFullStretchContainer, bgColorStyle, styles$1T.cmsMediaBannerCropImageMiddle, styles$1T["cms-media-banner__child-container--" + isFullScreenValue]);
    var mediaBannerchildren = Children.map(children, function (child, index) {
      return /*#__PURE__*/createElement(Fragment, {
        key: index
      }, child);
    });

    if (isTypeSeparateType) {
      childComponent = /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(LogoContainer, null), /*#__PURE__*/createElement("div", {
        className: containerClassName
      }, mediaBannerchildren, /*#__PURE__*/createElement(ModelName, null), /*#__PURE__*/createElement(CopyrightText, null)), /*#__PURE__*/createElement(TextContainer, null));
    } else if (isFullScreen) {
      childComponent = /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
        className: containerClassName
      }, mediaBannerchildren), /*#__PURE__*/createElement(LayoutWrapper, {
        element: "div",
        className: styles$1T.cmsMediaBannerLayoutWrapper
      }, /*#__PURE__*/createElement(Layout, {
        element: "div",
        gutter: {
          sm: false,
          md: true,
          lg: true
        },
        className: styles$1T.cmsMediaBannerLayoutWrapperFullScreen
      }, /*#__PURE__*/createElement(ModelName, null), /*#__PURE__*/createElement(LogoContainer, null), /*#__PURE__*/createElement(TextContainer, null))));
    } else {
      childComponent = /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
        className: containerClassName
      }, mediaBannerchildren), /*#__PURE__*/createElement(ModelName, null), /*#__PURE__*/createElement(LogoContainer, null), /*#__PURE__*/createElement(TextContainer, null));
    }

    return childComponent;
  };

  var componentClassName = isTypeSeparateType ? joinClasses(styles$1T.cmsMediaBanner, isFullScreen && styles$1T.cmsMediaBannerFullStretch, styles$1T.cmsMediaBannerSeparateType, styles$1T["cms-media-banner__separate-type-" + isFullScreenValue]) : joinClasses(styles$1T.cmsMediaBanner, isFullScreen && styles$1T.cmsMediaBannerFullStretch);
  return /*#__PURE__*/createElement("div", __assign({}, props, {
    className: componentClassName
  }), /*#__PURE__*/createElement(CmsMediaBannerChild, null));
};
CmsMediaBanner.displayName = 'CoreMediaBanner';
CmsMediaBanner.defaultProps = {
  copyrightTextColor: 'white',
  priceTextColor: 'red',
  textColor: 'white',
  type: 'normal'
};

var styles$1U = {"cms-ticker":"fr-ec-cms-ticker","cmsTicker":"fr-ec-cms-ticker","caption":"fr-ec-caption","link-navigation":"fr-ec-link-navigation","linkNavigation":"fr-ec-link-navigation","button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon","cms-ticker-primary":"fr-ec-cms-ticker-primary","cmsTickerPrimary":"fr-ec-cms-ticker-primary","cms-ticker-secondary":"fr-ec-cms-ticker-secondary","cmsTickerSecondary":"fr-ec-cms-ticker-secondary","cms-ticker-attention":"fr-ec-cms-ticker-attention","cmsTickerAttention":"fr-ec-cms-ticker-attention","title":"fr-ec-title","button-icon--light":"fr-ec-button-icon--light","buttonIconLight":"fr-ec-button-icon--light"};

var CmsTicker = function CmsTicker(_a) {
  var messageOne = _a.messageOne,
      _b = _a.typeOne,
      typeOne = _b === void 0 ? 'primary' : _b,
      _c = _a.variant,
      variant = _c === void 0 ? 'static' : _c,
      toggleCloseButton = _a.toggleCloseButton,
      url = _a.url,
      iconBrand = _a.iconBrand,
      className = _a.className,
      props = __rest(_a, ["messageOne", "typeOne", "variant", "toggleCloseButton", "url", "iconBrand", "className"]);

  var _d = useState(false),
      closeTicker = _d[0],
      setCloseTickerValue = _d[1];

  var color = typeOne === 'secondary' ? 'primary-dark' : 'primary-light';
  var buttonIconColor = typeOne === 'secondary' ? 'dark' : 'light';
  var CmsTickerComponent = /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(className, styles$1U.cmsTicker, styles$1U["cms-ticker-" + typeOne])
  }, props), toggleCloseButton && /*#__PURE__*/createElement(ButtonIcon, {
    element: 'button',
    icon: "close",
    label: "Close",
    hideLabel: true,
    onClick: function onClick() {
      return setCloseTickerValue(true);
    },
    variant: buttonIconColor,
    iconBrand: iconBrand
  }), variant === 'withLink' && url ? /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(LinkNavigation, {
    element: 'a',
    href: url
  }, /*#__PURE__*/createElement(Caption, {
    color: color,
    element: "p",
    textAlign: "left"
  }, messageOne)), /*#__PURE__*/createElement(ButtonIcon, {
    element: 'a',
    icon: "chevron-right",
    label: "Go to",
    hideLabel: true,
    href: url,
    variant: buttonIconColor,
    iconBrand: iconBrand
  })) : /*#__PURE__*/createElement(Caption, {
    color: color,
    element: "p",
    textAlign: "center"
  }, messageOne));
  return closeTicker ? null : CmsTickerComponent;
};
CmsTicker.displayName = 'CoreCmsTicker';

var styles$1V = {"cms-contents-card":"fr-ec-cms-contents-card","cmsContentsCard":"fr-ec-cms-contents-card"};

var CmsContentsCard = function CmsContentsCard(_a) {
  var _b = _a.type,
      type = _b === void 0 ? 'fullscreen' : _b,
      content = _a.content,
      className = _a.className,
      props = __rest(_a, ["type", "content", "className"]);

  var colSpan = function colSpan() {
    if (type === 'fullscreen' || type === 'contained') {
      return {
        lg: 12,
        sm: 4,
        md: 12
      };
    } else if (type === 'centered') {
      return {
        lg: 10,
        sm: 4,
        md: 10
      };
    } else {
      return {
        lg: 8,
        sm: 4,
        md: 8
      };
    }
  };

  return /*#__PURE__*/createElement(ContentAlignment, __assign({
    justifyContent: "center",
    direction: "row",
    className: joinClasses(className, styles$1V.cmsContentsCard),
    element: "div"
  }, props), /*#__PURE__*/createElement(Layout, {
    colSpan: colSpan(),
    gutter: {
      sm: type === 'fullscreen' ? false : true,
      md: true,
      lg: true
    }
  }, content));
};
CmsContentsCard.displayName = 'CoreCmsContentsCard';

var styles$1W = {"accordion-tab-group-wrapper":"fr-ec-accordion-tab-group-wrapper","accordionTabGroupWrapper":"fr-ec-accordion-tab-group-wrapper","accordion-tab-group":"fr-ec-accordion-tab-group","accordionTabGroup":"fr-ec-accordion-tab-group","accordion-tab-group__content":"fr-ec-accordion-tab-group__content","accordionTabGroupContent":"fr-ec-accordion-tab-group__content"};

var AccordionTabGroup =
/** @class */
function (_super) {
  __extends(AccordionTabGroup, _super);

  function AccordionTabGroup(props) {
    var _this = _super.call(this, props) || this;

    _this.onClick = function (label, child, tabOnclick) {
      return function (event, activeTabId) {
        _this.setState({
          activeTabId: activeTabId
        });

        if (tabOnclick) {
          tabOnclick(event, label, child);
        }
      };
    };

    var tabChilds = Children.toArray(props.children).filter(isValidElement);
    var activeChild = tabChilds.find(function (tabItem) {
      return Boolean(tabItem.props && tabItem.props.isActive);
    }) || tabChilds[0];
    var activeChildProps = activeChild ? activeChild.props : {};
    _this.state = {
      activeTabId: activeChildProps.headingText
    };
    return _this;
  }

  AccordionTabGroup.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        className = _a.className,
        props = __rest(_a, ["children", "className"]);

    var activeTabId = this.state.activeTabId;
    var activeContent = null;
    var childrenWithProps = Children.toArray(children).filter(isValidElement).map(function (child) {
      if (child.props.headingText === activeTabId) {
        activeContent = child.props.children;
      }

      return /*#__PURE__*/cloneElement(child, {
        accordionType: 'nav',
        isActive: child.props.headingText === activeTabId,
        key: child.props.headingText,
        onClick: _this.onClick(child.props.headingText, child, child.props.onClick)
      });
    });
    return /*#__PURE__*/createElement("div", __assign({
      className: joinClasses(styles$1W.accordionTabGroupWrapper, className)
    }, props), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$1W.accordionTabGroup),
      role: "tablist"
    }, childrenWithProps), /*#__PURE__*/createElement("div", {
      role: "tabpanel",
      className: styles$1W.accordionTabGroupContent
    }, activeContent));
  };

  AccordionTabGroup.displayName = 'CoreAccordionTabGroup';
  AccordionTabGroup.defaultProps = {};
  return AccordionTabGroup;
}(Component);

var styles$1X = {"cms-accordion-group":"fr-ec-cms-accordion-group","cmsAccordionGroup":"fr-ec-cms-accordion-group","cms-accordion-group--nav":"fr-ec-cms-accordion-group--nav","cmsAccordionGroupNav":"fr-ec-cms-accordion-group--nav","accordion-tab-group__content":"fr-ec-accordion-tab-group__content","accordionTabGroupContent":"fr-ec-accordion-tab-group__content","link-navigation":"fr-ec-link-navigation","linkNavigation":"fr-ec-link-navigation"};

var CmsAccordionGroup = function CmsAccordionGroup(_a) {
  var items = _a.items,
      _b = _a.type,
      type = _b === void 0 ? 'default' : _b,
      className = _a.className,
      props = __rest(_a, ["items", "type", "className"]);

  var width = getViewportWidth();

  var _c = useState(getCurrentMediaQueryBreakpoint()),
      screenSize = _c[0],
      setScreenSize = _c[1];

  var _d = useState(0),
      activeIndex = _d[0],
      setActiveIndex = _d[1];

  var _e = useState(false),
      display = _e[0],
      setDisplay = _e[1];

  var col1 = [];
  var col2 = [];
  var col3 = [];
  React__default.Children.forEach(items, function (child, index) {
    if (index % 3 === 0) {
      col1.push(child);
    }

    if (index % 3 === 1) {
      col2.push(child);
    }

    if (index % 3 === 2) {
      col3.push(child);
    }
  });
  var accordionsLgView = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", null, col1), /*#__PURE__*/React__default.createElement("div", null, col2), /*#__PURE__*/React__default.createElement("div", null, col3));

  var onResize = function onResize() {
    setScreenSize(getCurrentMediaQueryBreakpoint());
  };

  var _onClick = function onClick(index) {
    setActiveIndex(index);
    setDisplay(true);
  };

  var categoryLinkContent = null;
  var categoryLinks = React__default.Children.toArray(items).filter(React__default.isValidElement).map(function (child, index) {
    if (index === activeIndex) {
      categoryLinkContent = child.props.children;
    }

    return /*#__PURE__*/React__default.cloneElement(child, {
      key: index,
      onClick: function onClick() {
        return _onClick(index);
      }
    });
  });

  if (type === 'nav' && width >= designTokens_3.mqMediumScreenMinWidthLimit) {
    return /*#__PURE__*/React__default.createElement(AccordionTabGroup, __assign({
      className: joinClasses(type === 'nav' && styles$1X.cmsAccordionGroupNav)
    }, props), items);
  } else if (type === 'nav' && width < designTokens_3.mqMediumScreenMinWidthLimit) {
    return /*#__PURE__*/React__default.createElement("div", __assign({}, props), /*#__PURE__*/React__default.createElement("div", null, categoryLinks), display && /*#__PURE__*/React__default.createElement("div", null, categoryLinkContent));
  } else {
    return /*#__PURE__*/React__default.createElement(Measure, {
      onResize: debounce(100, onResize)
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/React__default.createElement("div", __assign({
        ref: measureRef,
        className: joinClasses(className, styles$1X.cmsAccordionGroup)
      }, props), screenSize === 'lg' ? accordionsLgView : items);
    });
  }
};
CmsAccordionGroup.displayName = 'CoreCmsAccordionGroup';

var CmsHorizontalRule = function CmsHorizontalRule(_a) {
  var props = __rest(_a, []);

  return /*#__PURE__*/createElement(Keyline, __assign({}, props));
};
CmsHorizontalRule.displayName = 'CoreCmsHorizontalRule';

var Anchor = function Anchor(_a) {
  var id = _a.id,
      className = _a.className;
  return /*#__PURE__*/createElement("span", {
    id: id,
    className: className
  });
};

var CmsAnchor = function CmsAnchor(props) {
  return /*#__PURE__*/createElement(Anchor, __assign({}, props));
};
CmsAnchor.displayName = 'CoreCmsAnchor';

var styles$1Y = {"cms-user-review":"fr-ec-cms-user-review","cmsUserReview":"fr-ec-cms-user-review","rating":"fr-ec-rating"};

var CmsUserReview = function CmsUserReview(_a) {
  var _b = _a.ratingValue,
      ratingValue = _b === void 0 ? 5 : _b,
      title = _a.title,
      comment = _a.comment,
      userInformation = _a.userInformation,
      className = _a.className,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["ratingValue", "title", "comment", "userInformation", "className", "iconBrand"]);

  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(className, styles$1Y.cmsUserReview)
  }, props), title && /*#__PURE__*/createElement(Title, {
    element: "h1",
    variant: "large",
    className: spacingStyles.mbSpacing04
  }, title), /*#__PURE__*/createElement(RatingStatic, {
    value: ratingValue,
    ariaLabel: "rating",
    className: styles$1Y.rating,
    iconBrand: iconBrand
  }), /*#__PURE__*/createElement(Body, {
    className: spacingStyles.mbSpacing04,
    variant: "standard",
    element: "p"
  }, comment), /*#__PURE__*/createElement(Body, {
    variant: "small",
    element: "p",
    color: "secondary"
  }, userInformation));
};
CmsUserReview.displayName = 'CoreCmsUserReview';

var styles$1Z = {"cms-tappable-grid":"fr-ec-cms-tappable-grid","cmsTappableGrid":"fr-ec-cms-tappable-grid","cms-tappable-grid--gender-typography":"fr-ec-cms-tappable-grid--gender-typography","cmsTappableGridGenderTypography":"fr-ec-cms-tappable-grid--gender-typography","tile":"fr-ec-tile","content-alignment":"fr-ec-content-alignment","contentAlignment":"fr-ec-content-alignment","title":"fr-ec-title","cms-tappable-grid--gender":"fr-ec-cms-tappable-grid--gender","cmsTappableGridGender":"fr-ec-cms-tappable-grid-gender","cms-tappable-grid--two-column":"fr-ec-cms-tappable-grid--two-column","cmsTappableGridTwoColumn":"fr-ec-cms-tappable-grid--two-column","cms-tappable-grid--three-column":"fr-ec-cms-tappable-grid--three-column","cmsTappableGridThreeColumn":"fr-ec-cms-tappable-grid--three-column","cms-tappable-grid--four-column":"fr-ec-cms-tappable-grid--four-column","cmsTappableGridFourColumn":"fr-ec-cms-tappable-grid--four-column","cms-tappable-grid--item-gender":"fr-ec-cms-tappable-grid--item-gender","cmsTappableGridItemGender":"fr-ec-cms-tappable-grid--item-gender","cms-tappable-item-text":"fr-ec-cms-tappable-item-text","cmsTappableItemText":"fr-ec-cms-tappable-item-text","cms-tappable-grid-gender":"fr-ec-cms-tappable-grid-gender"};

var CmsTappableGrid = function CmsTappableGrid(_a) {
  var id = _a.id,
      items = _a.items,
      className = _a.className,
      _b = _a.type,
      type = _b === void 0 ? 'threeColumn' : _b,
      props = __rest(_a, ["id", "items", "className", "type"]);

  var gridType = {
    fourColumn: 'four-column',
    gender: 'gender',
    threeColumn: 'three-column',
    twoColumn: 'two-column'
  };
  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(className, styles$1Z.cmsTappableGrid, styles$1Z["cms-tappable-grid--" + gridType[type]], type === 'gender' && styles$1Z.cmsTappableGridGenderTypography),
    id: id
  }, props), items && Children.map(items, function (item, index) {
    return /*#__PURE__*/cloneElement(item, {
      className: type === 'gender' ? styles$1Z.cmsTappableGridItemGender : '',
      key: index
    });
  }));
};
CmsTappableGrid.displayName = 'CoreCmsTappableGrid';

var styles$1_ = {"cms-heading--color-normal":"fr-ec-cms-heading--color-normal","cmsHeadingColorNormal":"fr-ec-cms-heading--color-normal","cms-heading--color-weak":"fr-ec-cms-heading--color-weak","cmsHeadingColorWeak":"fr-ec-cms-heading--color-weak","cms-heading--color-caution":"fr-ec-cms-heading--color-caution","cmsHeadingColorCaution":"fr-ec-cms-heading--color-caution"};

var CmsHeading = function CmsHeading(_a) {
  var content = _a.content,
      _b = _a.type,
      type = _b === void 0 ? 'display1' : _b,
      _c = _a.htmlTag,
      htmlTag = _c === void 0 ? 'h1' : _c,
      _d = _a.align,
      align = _d === void 0 ? 'left' : _d,
      _e = _a.color,
      color = _e === void 0 ? 'normal' : _e,
      _f = _a.margins,
      margins = _f === void 0 ? 'withMargin' : _f,
      id = _a.id,
      gaLabel = _a.gaLabel,
      gaCategory = _a.gaCategory,
      className = _a.className,
      subContent = _a.subContent,
      props = __rest(_a, ["content", "type", "htmlTag", "align", "color", "margins", "id", "gaLabel", "gaCategory", "className", "subContent"]);

  var gaProps = null;

  if (gaCategory && gaLabel) {
    gaProps = {
      'data-category': gaCategory,
      'data-label': gaLabel
    };
  }

  return /*#__PURE__*/createElement("header", __assign({
    className: joinClasses(className, margins === 'withMargin' ? spacingStyles.mbSpacing04 : '')
  }, props), /*#__PURE__*/createElement(Display, __assign({
    element: htmlTag === 'none' ? 'div' : htmlTag,
    id: id,
    variant: type,
    textAlign: align,
    className: styles$1_["cms-heading--color-" + color]
  }, gaProps), content), /*#__PURE__*/createElement(Body, {
    element: "p",
    variant: "standard",
    className: spacingStyles.mtSpacing03,
    textAlign: align
  }, subContent));
};
CmsHeading.displayName = 'CoreCmsHeading';

var CmsSnsButton = function CmsSnsButton(_a) {
  var link = _a.link,
      type = _a.type,
      _b = _a.gaCategory,
      gaCategory = _b === void 0 ? '' : _b,
      _c = _a.gaLabel,
      gaLabel = _c === void 0 ? '' : _c,
      gaAction = _a.gaAction,
      gaValue = _a.gaValue,
      className = _a.className,
      gaCallback = _a.gaCallback,
      id = _a.id;
  var socialLinks = [{
    name: 'facebook',
    url: link,
    src: 'https://asset.uniqlo.com/g/icons/sns_facebook.svg'
  }, {
    name: 'twitter',
    url: link,
    src: 'https://asset.uniqlo.com/g/icons/sns_twitter.svg'
  }, {
    name: 'line',
    url: link,
    src: 'https://asset.uniqlo.com/g/icons/sns_line.svg'
  }, {
    name: 'pinterest',
    url: link,
    src: 'https://asset.uniqlo.com/g/icons/sns_pinterest.svg'
  }, {
    name: 'email',
    url: link,
    src: 'https://asset.uniqlo.com/g/icons/mail.svg'
  }];
  var snsButtonInfo = socialLinks.filter(function (item) {
    return item.name === type;
  })[0];
  return /*#__PURE__*/createElement(LinkImage, {
    className: className,
    src: snsButtonInfo.src,
    alt: snsButtonInfo.name,
    element: "a",
    href: snsButtonInfo.url,
    gaLabel: gaLabel,
    gaCategory: gaCategory,
    gaValue: gaValue,
    gaCallback: gaCallback,
    gaAction: gaAction,
    id: id
  });
};
CmsSnsButton.displayName = 'CoreCmsSnsButton';
CmsSnsButton.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var styles$1$ = {"cms-list":"fr-ec-cms-list","cmsList":"fr-ec-cms-list","cms-list-default":"fr-ec-cms-list-default","cmsListDefault":"fr-ec-cms-list-default"};

var CmsList = function CmsList(_a) {
  var _b = _a.type,
      type = _b === void 0 ? 'default' : _b,
      className = _a.className,
      children = _a.children,
      props = __rest(_a, ["type", "className", "children"]);

  var spacing = {
    bordered: '24',
    'bordered-no-spacing': 'none',
    "default": '24',
    'default-no-spacing': 'none'
  };
  var keylines = ['bordered-no-spacing', 'bordered'];
  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(className, styles$1$.cmsList)
  }, props), /*#__PURE__*/createElement(CollectionList, {
    className: styles$1$["cms-list-" + type],
    spacing: spacing[type],
    keylines: keylines.includes(type) ? 'bottom-top' : 'none'
  }, children));
};
CmsList.displayName = 'CoreCmsList';

var styles$20 = {"item-tag":"fr-ec-item-tag","itemTag":"fr-ec-item-tag","item-tag--bubble":"fr-ec-item-tag--bubble","itemTagBubble":"fr-ec-item-tag--bubble","item-tag--icon-container":"fr-ec-item-tag--icon-container","itemTagIconContainer":"fr-ec-item-tag--icon-container","item-tag--outer-circle":"fr-ec-item-tag--outer-circle","itemTagOuterCircle":"fr-ec-item-tag--outer-circle","item-tag--outer-circle-opacity":"fr-ec-item-tag--outer-circle-opacity","itemTagOuterCircleOpacity":"fr-ec-item-tag--outer-circle-opacity","item-tag--outline":"fr-ec-item-tag--outline","itemTagOutline":"fr-ec-item-tag--outline","item-tag--toggle-arrow":"fr-ec-item-tag--toggle-arrow","itemTagToggleArrow":"fr-ec-item-tag--toggle-arrow","item-tag-pop-up-container--position":"fr-ec-item-tag-pop-up-container--position","itemTagPopUpContainerPosition":"fr-ec-item-tag-pop-up-container--position","item-tag-pop-up-container--position-right":"fr-ec-item-tag-pop-up-container--position-right","itemTagPopUpContainerPositionRight":"fr-ec-item-tag-pop-up-container--position-right","item-tag-pop-up-container--position-left":"fr-ec-item-tag-pop-up-container--position-left","itemTagPopUpContainerPositionLeft":"fr-ec-item-tag-pop-up-container--position-left","item-tag-pop-up-container--position-top":"fr-ec-item-tag-pop-up-container--position-top","itemTagPopUpContainerPositionTop":"fr-ec-item-tag-pop-up-container--position-top","item-tag-pop-up-container--position-bottom":"fr-ec-item-tag-pop-up-container--position-bottom","itemTagPopUpContainerPositionBottom":"fr-ec-item-tag-pop-up-container--position-bottom","item-tag--pop-up-container":"fr-ec-item-tag--pop-up-container","itemTagPopUpContainer":"fr-ec-item-tag--pop-up-container","item-tag--pop-up-container-arrow-active":"fr-ec-item-tag--pop-up-container-arrow-active","itemTagPopUpContainerArrowActive":"fr-ec-item-tag--pop-up-container-arrow-active","item-tag--pop-up-container-none":"fr-ec-item-tag--pop-up-container-none","itemTagPopUpContainerNone":"fr-ec-item-tag--pop-up-container-none","item-tag--pop-up-container-with-arrow":"fr-ec-item-tag--pop-up-container-with-arrow","itemTagPopUpContainerWithArrow":"fr-ec-item-tag--pop-up-container-with-arrow","item-tag--title-container":"fr-ec-item-tag--title-container","itemTagTitleContainer":"fr-ec-item-tag--title-container","item-tag--title-container-with-arrow":"fr-ec-item-tag--title-container-with-arrow","itemTagTitleContainerWithArrow":"fr-ec-item-tag--title-container-with-arrow","item-tag--container--left":"fr-ec-item-tag--container--left","itemTagContainerLeft":"fr-ec-item-tag--container--left","item-tag--container--right":"fr-ec-item-tag--container--right","itemTagContainerRight":"fr-ec-item-tag--container--right","item-tag--container--top":"fr-ec-item-tag--container--top","itemTagContainerTop":"fr-ec-item-tag--container--top","item-tag--container--bottom":"fr-ec-item-tag--container--bottom","itemTagContainerBottom":"fr-ec-item-tag--container--bottom","item-tag-pop-up-container--left":"fr-ec-item-tag-pop-up-container--left","itemTagPopUpContainerLeft":"fr-ec-item-tag-pop-up-container--left","item-tag-pop-up-container--right":"fr-ec-item-tag-pop-up-container--right","itemTagPopUpContainerRight":"fr-ec-item-tag-pop-up-container--right","item-tag-pop-up-container--top":"fr-ec-item-tag-pop-up-container--top","itemTagPopUpContainerTop":"fr-ec-item-tag-pop-up-container--top","item-tag-pop-up-container--bottom":"fr-ec-item-tag-pop-up-container--bottom","itemTagPopUpContainerBottom":"fr-ec-item-tag-pop-up-container--bottom","item-tag--icon-check-mark":"fr-ec-item-tag--icon-check-mark","itemTagIconCheckMark":"fr-ec-item-tag--icon-check-mark","item-tag--title":"fr-ec-item-tag--title","itemTagTitle":"fr-ec-item-tag--title","item-tag--sub-title":"fr-ec-item-tag--sub-title","itemTagSubTitle":"fr-ec-item-tag--sub-title","item-tag--icon-check-mark-active":"fr-ec-item-tag--icon-check-mark-active","itemTagIconCheckMarkActive":"fr-ec-item-tag--icon-check-mark-active","item-tag--pulse-effect":"fr-ec-item-tag--pulse-effect","itemTagPulseEffect":"fr-ec-item-tag--pulse-effect"};

var ItemTag = function ItemTag(_a) {
  var labelTitle = _a.labelTitle,
      labelSubTitle = _a.labelSubTitle,
      toggleArrow = _a.toggleArrow,
      isActive = _a.isActive,
      dotOnClick = _a.dotOnClick,
      popupOnClick = _a.popupOnClick,
      popupPosition = _a.popupPosition,
      positionCoordinates = _a.positionCoordinates,
      iconBrand = _a.iconBrand,
      pulseEffect = _a.pulseEffect,
      className = _a.className,
      props = __rest(_a, ["labelTitle", "labelSubTitle", "toggleArrow", "isActive", "dotOnClick", "popupOnClick", "popupPosition", "positionCoordinates", "iconBrand", "pulseEffect", "className"]);

  var componentRef = useRef(null);

  var _b = useState(0),
      height = _b[0],
      getComponentDomHeight = _b[1];

  var _c = useState(0),
      width = _c[0],
      getComponentDomWidth = _c[1];

  useEffect(function () {
    var element = componentRef && componentRef.current;

    if (element) {
      getComponentDomHeight(element.getBoundingClientRect().height);
      getComponentDomWidth(element.getBoundingClientRect().width);
    }
  }, [componentRef && componentRef.current]);

  var setStyleValues = function setStyleValues() {
    // To manage exact positioning of the style tag
    switch (popupPosition) {
      case 'left':
        {
          return {
            top: "calc((-" + height + "px / 2) + 0.5rem)"
          };
        }

      case 'right':
        {
          return {
            top: "calc((-" + height + "px / 2) + 0.5rem)"
          };
        }

      case 'top':
        {
          return {
            left: "calc((-" + width + "px / 2) + 0.5em)"
          };
        }

      case 'bottom':
        {
          return {
            left: "calc((-" + width + "px / 2) + 0.5em)"
          };
        }

      default:
        {
          return undefined;
        }
    }
  };

  var onDotClick = function onDotClick(e) {
    if (dotOnClick) {
      dotOnClick(e);
    }
  };

  var onPopUpClick = function onPopUpClick(e) {
    if (popupOnClick) {
      popupOnClick(e);
    }
  };

  var isPulseEffectOn = pulseEffect && !isActive;
  return /*#__PURE__*/createElement(ContentAlignment, __assign({
    element: "div",
    direction: "row",
    alignment: "center",
    justifyContent: "space-between",
    className: joinClasses(styles$20.itemTag, styles$20["item-tag--container--" + popupPosition], className),
    style: {
      left: positionCoordinates[0] + "%",
      top: positionCoordinates[1] + "%"
    }
  }, props), /*#__PURE__*/createElement("div", {
    className: styles$20.itemTagBubble
  }, /*#__PURE__*/createElement("label", {
    onClick: onDotClick,
    role: "button",
    className: styles$20.itemTagOutline,
    tabIndex: 0
  }), /*#__PURE__*/createElement("div", {
    className: joinClasses(isActive && styles$20.itemTagOuterCircleOpacity, styles$20.itemTagOuterCircle)
  }, /*#__PURE__*/createElement("label", {
    className: joinClasses(styles$20.itemTagIconContainer, isPulseEffectOn && styles$20.itemTagPulseEffect),
    onClick: onDotClick,
    role: "button"
  }, /*#__PURE__*/createElement("span", {
    className: styles$20.itemTagIconCheckMark
  }))), /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$20.itemTagPopUpContainerPosition, styles$20["item-tag-pop-up-container--position-" + popupPosition], !isActive && styles$20.itemTagPopUpContainerNone),
    style: setStyleValues()
  }, /*#__PURE__*/createElement("div", {
    onClick: onPopUpClick,
    className: joinClasses(styles$20.itemTagPopUpContainer, toggleArrow && styles$20.itemTagPopUpContainerWithArrow, styles$20["item-tag-pop-up-container--" + popupPosition]),
    ref: componentRef,
    role: "button"
  }, /*#__PURE__*/createElement(ContentAlignment, {
    element: "div",
    direction: "column",
    className: joinClasses(styles$20.itemTagTitleContainer, toggleArrow && styles$20.itemTagTitleContainerWithArrow)
  }, /*#__PURE__*/createElement(Title, {
    variant: "small",
    element: "span",
    className: styles$20.itemTagTitle
  }, labelTitle), labelSubTitle && /*#__PURE__*/createElement(HintText, {
    variant: "standard",
    element: "span",
    className: styles$20.itemTagSubTitle
  }, labelSubTitle)), toggleArrow && /*#__PURE__*/createElement(Icon, {
    name: iconBrand ? iconBrand + "chevron-right" : 'chevron-right',
    className: styles$20.itemTagToggleArrow
  })))));
};
ItemTag.displayName = 'CoreItemTag';

var styles$21 = {"item-tags":"fr-ec-item-tags","itemTags":"fr-ec-item-tags","item-tags--toggle-icon":"fr-ec-item-tags--toggle-icon","itemTagsToggleIcon":"fr-ec-item-tags--toggle-icon","item-tags--count":"fr-ec-item-tags--count","itemTagsCount":"fr-ec-item-tags--count","item-tags--toggle-icon-container":"fr-ec-item-tags--toggle-icon-container","itemTagsToggleIconContainer":"fr-ec-item-tags--toggle-icon-container","item-tags--animation":"fr-ec-item-tags--animation","itemTagsAnimation":"fr-ec-item-tags--animation","item-tag--pulse-effect":"fr-ec-item-tag--pulse-effect","itemTagPulseEffect":"fr-ec-item-tag--pulse-effect","pulse-white":"fr-ec-pulse-white","pulseWhite":"fr-ec-pulse-white","pulse-black":"fr-ec-pulse-black","pulseBlack":"fr-ec-pulse-black"};

var ItemTags = function ItemTags(_a) {
  var children = _a.children,
      variant = _a.variant,
      isItemToggleActive = _a.isItemToggleActive,
      onToggle = _a.onToggle,
      className = _a.className,
      _b = _a.pulseEffect,
      pulseEffect = _b === void 0 ? true : _b,
      props = __rest(_a, ["children", "variant", "isItemToggleActive", "onToggle", "className", "pulseEffect"]);

  var isStylingBook = variant === 'stylingBook';
  var componentRef = useRef(null);

  var onActiveButtonClick = function onActiveButtonClick(event) {
    if (onToggle) {
      onToggle(event);
    }
  };

  var updateAnimation = function updateAnimation() {
    if (componentRef.current) {
      componentRef.current.classList.remove('fr-ec-item-tags--animation');
      setTimeout(function () {
        var _a;

        if (componentRef.current) {
          (_a = componentRef.current) === null || _a === void 0 ? void 0 : _a.classList.add('fr-ec-item-tags--animation');
        }
      }, 10);
    }
  };

  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(className, styles$21.itemTags, styles$21.itemTagsAnimation),
    ref: componentRef
  }, props), isStylingBook ? isItemToggleActive && Children.map(children, function (child, i) {
    return /*#__PURE__*/cloneElement(child, {
      isActive: true,
      key: i
    });
  }) : Children.map(children, function (child, i) {
    return /*#__PURE__*/cloneElement(child, {
      dotOnClick: function dotOnClick(e) {
        updateAnimation();

        if (child.props.dotOnClick) {
          child.props.dotOnClick(e);
        }
      },
      key: i,
      pulseEffect: pulseEffect
    });
  }), isStylingBook && /*#__PURE__*/createElement("div", {
    className: styles$21.itemTagsToggleIconContainer,
    onClick: onActiveButtonClick,
    role: "button"
  }, /*#__PURE__*/createElement(Icon, {
    name: "item",
    className: styles$21.itemTagsToggleIcon
  }), isItemToggleActive && /*#__PURE__*/createElement(HintText, {
    variant: "standard",
    element: "span",
    color: "primary-light",
    className: styles$21.itemTagsCount
  }, ' ', children.length)));
};
ItemTags.displayName = 'CoreItemTags';

var contentChild = function contentChild(props) {
  return /*#__PURE__*/createElement(Fragment, __assign({}, props));
};

var ContentVisibilityHoc = isViewport(contentChild);
var CmsContentVisibility = function CmsContentVisibility(_a) {
  var _b = _a.mobileVisibility,
      mobileVisibility = _b === void 0 ? true : _b,
      _c = _a.tabletVisibility,
      tabletVisibility = _c === void 0 ? true : _c,
      _d = _a.pcVisibility,
      pcVisibility = _d === void 0 ? true : _d,
      props = __rest(_a, ["mobileVisibility", "tabletVisibility", "pcVisibility"]);

  var visibilityProp = {
    lg: pcVisibility,
    md: tabletVisibility,
    sm: mobileVisibility
  };
  return /*#__PURE__*/createElement(ContentVisibilityHoc, __assign({
    visible: visibilityProp
  }, props));
};
ContentVisibilityHoc.displayName = 'CoreCmsContentVisibility';

var styles$22 = {"cms-text":"fr-ec-cms-text","cmsText":"fr-ec-cms-text"};

var CmsText = function CmsText(_a) {
  var content = _a.content,
      _b = _a.type,
      type = _b === void 0 ? 'normal' : _b,
      centered = _a.centered,
      className = _a.className,
      props = __rest(_a, ["content", "type", "centered", "className"]);

  var color = {
    normal: 'primary-dark',
    caution: 'error',
    weak: 'secondary'
  };
  return /*#__PURE__*/createElement(Body, __assign({
    element: "p",
    className: joinClasses(className, styles$22.cmsText),
    textAlign: centered ? 'center' : 'left',
    color: color[type]
  }, props), content);
};
CmsText.displayName = 'CoreCmsText';

var styles$23 = {"file-input":"fr-ec-file-input","fileInput":"fr-ec-file-input","file-input--link":"fr-ec-file-input--link","fileInputLink":"fr-ec-file-input--link","file-input--button-link":"fr-ec-file-input--button-link","fileInputButtonLink":"fr-ec-file-input--button-link","file-input-button-link--button":"fr-ec-file-input-button-link--button","fileInputButtonLinkButton":"fr-ec-file-input-button-link--button","file-input-button-label--button":"fr-ec-file-input-button-label--button","fileInputButtonLabelButton":"fr-ec-file-input-button-label--button","file-input__input":"fr-ec-file-input__input","fileInputInput":"fr-ec-file-input__input","button--variant-primary":"fr-ec-button--variant-primary","buttonVariantPrimary":"fr-ec-button--variant-primary","button__icon":"fr-ec-button__icon","buttonIcon":"fr-ec-button__icon"};

var FileInput = function FileInput(_a) {
  var accept = _a.accept,
      onChange = _a.onChange,
      _b = _a.variant,
      variant = _b === void 0 ? 'button' : _b,
      label = _a.label,
      icon = _a.icon,
      className = _a.className,
      iconBrand = _a.iconBrand;

  var handleChange = function handleChange(event) {
    if (onChange) {
      onChange(event);
    }
  };

  var isButton = variant === 'button';
  var element = isButton ? 'button' : 'a';
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("label", {
    className: joinClasses(className, styles$23.fileInput, styles$23["file-input--" + variant])
  }, /*#__PURE__*/createElement("input", {
    accept: accept,
    type: "file",
    id: "file",
    "aria-label": "File browser example",
    onChange: handleChange,
    className: styles$23.fileInputInput
  }), /*#__PURE__*/createElement(Button, {
    to: "",
    element: element,
    variant: 'primary',
    isSmall: false,
    icon: icon,
    className: variant === 'link' ? styles$23.fileInputButtonLink : '',
    iconBrand: iconBrand
  }, /*#__PURE__*/createElement(Body, {
    variant: "standard",
    element: "span",
    className: styles$23["file-input-button-label--" + variant]
  }, label))));
};
FileInput.displayName = 'CoreFileInput';

var styles$24 = {"cms-banner-collection":"fr-ec-cms-banner-collection","cmsBannerCollection":"fr-ec-cms-banner-collection","cms-banner--item":"fr-ec-cms-banner--item","cmsBannerItem":"fr-ec-cms-banner--item"};

var CmsBannerCollection = function CmsBannerCollection(_a) {
  var children = _a.children,
      className = _a.className,
      props = __rest(_a, ["children", "className"]);

  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$24.cmsBannerCollection, className)
  }, props), Children.map(children, function (child, i) {
    return /*#__PURE__*/createElement("div", {
      className: styles$24.cmsBannerItem,
      key: i
    }, child);
  }));
};
CmsBannerCollection.displayName = 'CoreCmsBannerCollection';

var styles$25 = {"search-history-item":"fr-ec-search-history-item","searchHistoryItem":"fr-ec-search-history-item","search-history-item--focus":"fr-ec-search-history-item--focus","searchHistoryItemFocus":"fr-ec-search-history-item--focus","button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon","search-history-item__icon":"fr-ec-search-history-item__icon","searchHistoryItemIcon":"fr-ec-search-history-item__icon","search-history-item__content":"fr-ec-search-history-item__content","searchHistoryItemContent":"fr-ec-search-history-item__content","search-history-item__title":"fr-ec-search-history-item__title","searchHistoryItemTitle":"fr-ec-search-history-item__title"};

var SearchHistoryItem = function SearchHistoryItem(_a) {
  var title = _a.title,
      onDismiss = _a.onDismiss,
      className = _a.className,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["title", "onDismiss", "className", "iconBrand"]);

  var onClose = function onClose(event) {
    event.stopPropagation();

    if (onDismiss) {
      onDismiss(event);
    }
  };

  return /*#__PURE__*/createElement(Tile, __assign({
    tabIndex: -1
  }, props), /*#__PURE__*/createElement(ContentAlignment, {
    element: "div",
    direction: "row",
    className: joinClasses(styles$25.searchHistoryItem, className)
  }, /*#__PURE__*/createElement("div", {
    tabIndex: -1,
    className: joinClasses(styles$25.searchHistoryItemContent, styles$25.searchHistoryItem)
  }, /*#__PURE__*/createElement("div", {
    tabIndex: 0,
    className: styles$25.searchHistoryItemFocus
  }, /*#__PURE__*/createElement(Body, {
    className: styles$25.searchHistoryItemTitle,
    element: 'p'
  }, title), /*#__PURE__*/createElement(ButtonIcon, {
    type: "button",
    element: "button",
    icon: "close",
    variant: "dark",
    hideLabel: true,
    onMouseDown: onClose,
    tabIndex: -1,
    label: 'Close',
    iconBrand: iconBrand
  })))));
};
SearchHistoryItem.displayName = 'CoreSearchHistoryItem';

var styles$26 = {"fixed-panel":"fr-ec-fixed-panel","fixedPanel":"fr-ec-fixed-panel","fixed-panel__first-row":"fr-ec-fixed-panel__first-row","fixedPanelFirstRow":"fr-ec-fixed-panel__first-row","body":"fr-ec-body","fixed-panel__second-row":"fr-ec-fixed-panel__second-row","fixedPanelSecondRow":"fr-ec-fixed-panel__second-row","fixed-panel__price-label":"fr-ec-fixed-panel__price-label","fixedPanelPriceLabel":"fr-ec-fixed-panel__price-label","fixed-panel__btn-container":"fr-ec-fixed-panel__btn-container","fixedPanelBtnContainer":"fr-ec-fixed-panel__btn-container","fixed-panel__button-layout-wrapper":"fr-ec-fixed-panel__button-layout-wrapper","fixedPanelButtonLayoutWrapper":"fr-ec-fixed-panel__button-layout-wrapper","fixed-panel__button-layout":"fr-ec-fixed-panel__button-layout","fixedPanelButtonLayout":"fr-ec-fixed-panel__button-layout","fixed-panel--hidden":"fr-ec-fixed-panel--hidden","fixedPanelHidden":"fr-ec-fixed-panel--hidden","fixed-panel__inner":"fr-ec-fixed-panel__inner","fixedPanelInner":"fr-ec-fixed-panel__inner","fixed-panel__price-container":"fr-ec-fixed-panel__price-container","fixedPanelPriceContainer":"fr-ec-fixed-panel__price-container","button":"fr-ec-button"};

var FixedPanel = function FixedPanel(_a) {
  var description = _a.description,
      TotalLabel = _a.TotalLabel,
      TotalPrice = _a.TotalPrice,
      Button = _a.Button,
      className = _a.className,
      _b = _a.variant,
      variant = _b === void 0 ? 'default' : _b,
      _c = _a.idToHidePanel,
      idToHidePanel = _c === void 0 ? '' : _c,
      content = _a.content;

  var _d = useState(false),
      isHidden = _d[0],
      setIsHidden = _d[1];

  var _e = useState(false),
      isHiddenOnScroll = _e[0],
      setIsHiddenOnScroll = _e[1];

  var scrollTop = isInBrowser$1() ? window.pageYOffset : 0;
  var options = {
    threshold: 0.5
  };

  var callIntersectionObserver = function callIntersectionObserver(entries) {
    var entry = entries[0];
    var element = document.getElementById(idToHidePanel);
    var rootElement = entry === null || entry === void 0 ? void 0 : entry.rootBounds;

    if (element && rootElement) {
      var _a = element.getBoundingClientRect(),
          height = _a.height,
          top_1 = _a.top;

      var viewportHeight = rootElement.height;

      if (variant === 'default' || variant === "showInAllDevices") {
        setIsHidden(entry.isIntersecting);
      } else if (variant === 'ScrollDownToHide') {
        setIsHidden(entry.isIntersecting || viewportHeight >= height / 2 + top_1);
      }
    }
  };

  var handleScroll = function handleScroll() {
    if (variant === 'ScrollDownToHide') {
      var currScroll = window.pageYOffset;

      if (currScroll > 0) {
        if (currScroll > scrollTop) {
          setIsHiddenOnScroll(true);
        } else if (currScroll < scrollTop) {
          setIsHiddenOnScroll(false);
        }

        scrollTop = currScroll;
      }
    } else if (variant === 'default' || variant === "showInAllDevices") {
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
        setIsHiddenOnScroll(true);
      } else {
        setIsHiddenOnScroll(false);
      }
    }
  };

  useEffect(function () {
    var element = document.getElementById(idToHidePanel);
    var observer = new IntersectionObserver(callIntersectionObserver, options);

    if (element) {
      observer.observe(element);
    }

    return function () {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [options]);
  useEffect(function () {
    if (isInBrowser$1()) {
      window.addEventListener('scroll', handleScroll);
    }

    return function () {
      if (isInBrowser$1()) {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  });
  return Button ? variant === 'default' ? /*#__PURE__*/React__default.createElement(Layout, {
    visible: {
      sm: true,
      md: true,
      lg: false
    },
    element: "div",
    className: joinClasses(className, styles$26.fixedPanel, isHidden ? styles$26.fixedPanelHidden : isHiddenOnScroll ? styles$26.fixedPanelHidden : '')
  }, /*#__PURE__*/React__default.createElement(Keyline, null), /*#__PURE__*/React__default.createElement("div", {
    className: styles$26.fixedPanelInner
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$26.fixedPanelFirstRow
  }, typeof description === 'string' ? /*#__PURE__*/React__default.createElement(Body, {
    element: "p",
    variant: "standard"
  }, description) : description === null || description === void 0 ? void 0 : description.map(function (item, index) {
    return /*#__PURE__*/React__default.createElement(Body, {
      element: "p",
      variant: "standard",
      key: index
    }, item);
  }), content), /*#__PURE__*/React__default.createElement(ContentAlignment, {
    element: "div",
    direction: "row",
    className: styles$26.fixedPanelSecondRow,
    justifyContent: "center"
  }, TotalLabel && TotalPrice && /*#__PURE__*/React__default.createElement("div", {
    className: styles$26.fixedPanelPriceContainer
  }, /*#__PURE__*/React__default.createElement(Body, {
    element: "p",
    variant: "small",
    textAlign: "center",
    className: styles$26.fixedPanelPriceLabel
  }, TotalLabel), /*#__PURE__*/React__default.createElement(Title, {
    element: "p",
    variant: "large-emphasized",
    textAlign: "center"
  }, TotalPrice)), /*#__PURE__*/React__default.createElement("div", {
    className: styles$26.fixedPanelBtnContainer
  }, Button)))) : /*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(styles$26.fixedPanelButtonLayoutWrapper, isHidden ? styles$26.fixedPanelHidden : isHiddenOnScroll ? styles$26.fixedPanelHidden : '')
  }, /*#__PURE__*/React__default.createElement(Keyline, null), /*#__PURE__*/React__default.createElement(Layout, {
    visible: {
      sm: true,
      md: true,
      lg: true
    },
    element: "div",
    className: joinClasses(className, styles$26.fixedPanelButtonLayout)
  }, Button)) : null;
};
FixedPanel.displayName = 'CoreFixedPanel';

var styles$27 = {"balloon-tip":"fr-ec-balloon-tip","balloonTip":"fr-ec-balloon-tip","balloon-tip__icon":"fr-ec-balloon-tip__icon","balloonTipIcon":"fr-ec-balloon-tip__icon","balloon-tip__content":"fr-ec-balloon-tip__content","balloonTipContent":"fr-ec-balloon-tip__content","balloon-tip__arrow-top-center":"fr-ec-balloon-tip__arrow-top-center","balloonTipArrowTopCenter":"fr-ec-balloon-tip__arrow-top-center","balloon-tip__arrow-top-left":"fr-ec-balloon-tip__arrow-top-left","balloonTipArrowTopLeft":"fr-ec-balloon-tip__arrow-top-left","balloon-tip__arrow-top-right":"fr-ec-balloon-tip__arrow-top-right","balloonTipArrowTopRight":"fr-ec-balloon-tip__arrow-top-right","bounceTop":"fr-ec-bounceTop","balloon-tip__arrow-bottom-center":"fr-ec-balloon-tip__arrow-bottom-center","balloonTipArrowBottomCenter":"fr-ec-balloon-tip__arrow-bottom-center","balloon-tip__arrow-bottom-left":"fr-ec-balloon-tip__arrow-bottom-left","balloonTipArrowBottomLeft":"fr-ec-balloon-tip__arrow-bottom-left","balloon-tip__arrow-bottom-right":"fr-ec-balloon-tip__arrow-bottom-right","balloonTipArrowBottomRight":"fr-ec-balloon-tip__arrow-bottom-right","bounceBottom":"fr-ec-bounceBottom","button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon"};

var BalloonTip = function BalloonTip(_a) {
  var content = _a.content,
      ariaLabel = _a.ariaLabel,
      id = _a.id,
      onClick = _a.onClick,
      _b = _a.top,
      top = _b === void 0 ? 0 : _b,
      left = _a.left,
      right = _a.right,
      iconBrand = _a.iconBrand,
      _c = _a.arrowPosition,
      arrowPosition = _c === void 0 ? 'bottom-center' : _c;
  var leftVal = left !== undefined ? left + "px" : 'auto';
  var rightVal = right !== undefined ? right + "px" : 'auto';
  return /*#__PURE__*/createElement(ContentAlignment, {
    alignment: "center",
    direction: "row",
    element: "div",
    fluidHeight: false,
    justifyContent: "flex-start",
    className: joinClasses(styles$27.balloonTip, styles$27.balloonTip + "__arrow-" + arrowPosition),
    "aria-label": ariaLabel,
    id: id,
    style: {
      top: top + "px",
      left: leftVal,
      right: rightVal
    }
  }, /*#__PURE__*/createElement(Caption, {
    color: "primary-light",
    element: "p",
    variant: "standard",
    className: styles$27.balloonTipContent
  }, content), /*#__PURE__*/createElement(ButtonIcon, {
    id: id,
    element: "button",
    type: "button",
    icon: 'close',
    hideLabel: true,
    onMouseDown: onClick,
    onClick: onClick,
    label: ariaLabel || '',
    className: styles$27.balloonTipIcon,
    iconBrand: iconBrand
  }));
};
BalloonTip.displayName = 'CoreBalloonTip';

var styles$28 = {"balloon-tip-container":"fr-ec-balloon-tip-container","balloonTipContainer":"fr-ec-balloon-tip-container"};

var BalloonTipContainer = function BalloonTipContainer(_a) {
  var children = _a.children;
  return /*#__PURE__*/createElement("div", {
    className: styles$28.balloonTipContainer
  }, children);
};
BalloonTipContainer.displayName = 'CoreBalloonTipContainer';

var styles$29 = {"cms-quote-review-group-row":"fr-ec-cms-quote-review-group-row","cmsQuoteReviewGroupRow":"fr-ec-cms-quote-review-group-row","cms-quote-review-group-row--two-column":"fr-ec-cms-quote-review-group-row--two-column","cmsQuoteReviewGroupRowTwoColumn":"fr-ec-cms-quote-review-group-row--two-column","cms-quote-review__container":"fr-ec-cms-quote-review__container","cmsQuoteReviewContainer":"fr-ec-cms-quote-review__container","cms-quote-review-group-row--three-column":"fr-ec-cms-quote-review-group-row--three-column","cmsQuoteReviewGroupRowThreeColumn":"fr-ec-cms-quote-review-group-row--three-column"};

var CmsQuoteReviewGroup = function CmsQuoteReviewGroup(_a) {
  var children = _a.children;

  var _b = useState(getCurrentMediaQueryBreakpoint()),
      screenSize = _b[0],
      setScreenSize = _b[1];

  var childrenIntoSubsets = function childrenIntoSubsets(childEl, subsetSize) {
    var res = [];

    for (var i = 0; i < Children.toArray(childEl).length; i += subsetSize) {
      var chunk = Children.toArray(childEl).slice(i, i + subsetSize);
      res.push(chunk);
    }

    return res;
  };

  var onResize = function onResize() {
    return setScreenSize(getCurrentMediaQueryBreakpoint());
  };

  var childQuoteComponent = function childQuoteComponent() {
    if (screenSize === 'lg') {
      var childRows = childrenIntoSubsets(children, 3);
      var childQuotes = childRows.map(function (childco, index) {
        return /*#__PURE__*/createElement(ContentAlignment, {
          className: joinClasses(styles$29.cmsQuoteReviewGroupRow, childco.length === 3 && styles$29.cmsQuoteReviewGroupRowThreeColumn, childco.length === 2 && styles$29.cmsQuoteReviewGroupRowTwoColumn),
          key: index,
          element: 'div',
          direction: 'row'
        }, childco);
      });
      return childQuotes;
    } else if (screenSize === 'md') {
      var childRows_1 = childrenIntoSubsets(children, 2);

      var childQuotes = function childQuotes() {
        return childRows_1.map(function (childco, index) {
          return /*#__PURE__*/createElement(ContentAlignment, {
            className: joinClasses(styles$29.cmsQuoteReviewGroupRow, childco.length === 2 && styles$29.cmsQuoteReviewGroupRowTwoColumn),
            key: index,
            element: 'div',
            direction: 'row'
          }, childco);
        });
      };

      return childQuotes();
    } else {
      return /*#__PURE__*/createElement("div", {
        className: styles$29.cmsQuoteReviewGroupRow
      }, children);
    }
  };

  return /*#__PURE__*/createElement(Measure, {
    bounds: true,
    onResize: onResize
  }, function (_a) {
    var measureRef = _a.measureRef;
    return /*#__PURE__*/createElement("div", {
      ref: measureRef
    }, childQuoteComponent());
  });
};
CmsQuoteReviewGroup.displayName = 'CoreCmsQuoteReviewGroup';

var styles$2a = {"product-table":"fr-ec-product-table","productTable":"fr-ec-product-table","comparison-table":"fr-ec-comparison-table","comparisonTable":"fr-ec-comparison-table","product-table-current-product":"fr-ec-product-table-current-product","productTableCurrentProduct":"fr-ec-product-table-current-product","product-table-similar-product":"fr-ec-product-table-similar-product","productTableSimilarProduct":"fr-ec-product-table-similar-product","carousel-slide":"fr-ec-carousel-slide","carouselSlide":"fr-ec-carousel-slide","product-tile-resize-wrapper":"fr-ec-product-tile-resize-wrapper","productTileResizeWrapper":"fr-ec-product-tile-resize-wrapper","title":"fr-ec-title","product-tile__product-info":"fr-ec-product-tile__product-info","productTileProductInfo":"fr-ec-product-tile__product-info","product-tile__end":"fr-ec-product-tile__end","productTileEnd":"fr-ec-product-tile__end","data-table":"fr-ec-data-table","dataTable":"fr-ec-data-table","carousel":"fr-ec-carousel","carousel__scrollbar-hide":"fr-ec-carousel__scrollbar-hide","carouselScrollbarHide":"fr-ec-carousel__scrollbar-hide","carousel__container":"fr-ec-carousel__container","carouselContainer":"fr-ec-carousel__container","carousel__frame":"fr-ec-carousel__frame","carouselFrame":"fr-ec-carousel__frame","carousel-slide__container":"fr-ec-carousel-slide__container","carouselSlideContainer":"fr-ec-carousel-slide__container","comparison-table-heading":"fr-ec-comparison-table-heading","comparisonTableHeading":"fr-ec-comparison-table-heading","comparison-table-content":"fr-ec-comparison-table-content","comparisonTableContent":"fr-ec-comparison-table-content","caption":"fr-ec-caption","product-table-similar-product--no-overflow":"fr-ec-product-table-similar-product--no-overflow","productTableSimilarProductNoOverflow":"fr-ec-product-table-similar-product--no-overflow","content-alignment--direction-column":"fr-ec-content-alignment--direction-column","contentAlignmentDirectionColumn":"fr-ec-content-alignment--direction-column","product-table--no-border":"fr-ec-product-table--no-border","productTableNoBorder":"fr-ec-product-table--no-border","product-table-inner-container":"fr-ec-product-table-inner-container","productTableInnerContainer":"fr-ec-product-table-inner-container"};

var ProductTable = function ProductTable(_a) {
  var _b = _a.currentProductLabel,
      currentProductLabel = _b === void 0 ? 'The product you are viewing' : _b,
      _c = _a.similarProductsLabel,
      similarProductsLabel = _c === void 0 ? 'Similar products' : _c,
      currentProductDetails = _a.currentProductDetails,
      similarProductsCarousel = _a.similarProductsCarousel;
  var displayCount = {
    'lg': 3.2,
    'md': 3.6,
    'sm': 1.5
  };

  var _d = useState(getCurrentMediaQueryBreakpoint()),
      screenSize = _d[0],
      setScreenSize = _d[1];

  var _e = useState(0),
      productWidth = _e[0],
      setProductWidth = _e[1];

  var onResize = function onResize(contentRect) {
    setScreenSize(getCurrentMediaQueryBreakpoint());

    if (contentRect.bounds) {
      var containerWidth = contentRect.bounds.width;
      var itemWidth = containerWidth / (displayCount[screenSize] + 1);

      if (itemWidth) {
        setProductWidth(itemWidth);
      }
    }
  };

  var carouselDefaultProps = __assign({
    arrowPositionSelector: ".fr-ec-image",
    displayCount: displayCount[screenSize],
    indicator: 'none',
    noPadding: true
  }, screenSize === 'md' && {
    hasArrows: false
  });

  var similarProductsArray = React__default.Children.toArray(similarProductsCarousel);
  var similarProductsChild = /*#__PURE__*/React__default.isValidElement(similarProductsArray[0]) ? similarProductsArray[0].props.children : [];
  var similarProductsWithoutCarousel = React__default.Children.map(similarProductsChild, function (item) {
    return /*#__PURE__*/React__default.createElement(ContentAlignment, {
      element: 'div',
      direction: 'column'
    }, item);
  });
  return /*#__PURE__*/React__default.createElement(Measure, {
    bounds: true,
    onResize: onResize
  }, function (_a) {
    var measureRef = _a.measureRef;
    return /*#__PURE__*/React__default.createElement("div", {
      className: joinClasses(styles$2a.productTable, similarProductsChild.length < displayCount[screenSize] && styles$2a.productTableNoBorder),
      ref: measureRef
    }, /*#__PURE__*/React__default.createElement(ContentAlignment, __assign({
      element: 'div',
      direction: 'column'
    }, similarProductsChild.length < displayCount[screenSize] && {
      className: styles$2a.productTableInnerContainer
    }), /*#__PURE__*/React__default.createElement(ContentAlignment, {
      element: 'div',
      direction: 'row'
    }, currentProductLabel && /*#__PURE__*/React__default.createElement(Title, {
      className: styles$2a.productTableCurrentProduct,
      style: {
        width: similarProductsChild.length > displayCount[screenSize] ? 100 / (displayCount[screenSize] + 1) + "%" : productWidth + "px"
      },
      element: 'h1'
    }, currentProductLabel), similarProductsLabel && /*#__PURE__*/React__default.createElement(Title, {
      className: styles$2a.productTableSimilarProduct,
      style: {
        width: similarProductsChild.length > displayCount[screenSize] ? 100 - 100 / (displayCount[screenSize] + 1) + "%" : similarProductsChild.length * productWidth + "px"
      },
      element: 'h1'
    }, similarProductsLabel)), /*#__PURE__*/React__default.createElement(ContentAlignment, {
      element: 'div',
      direction: 'row'
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$2a.productTableCurrentProduct,
      style: {
        width: similarProductsChild.length > displayCount[screenSize] ? 100 / (displayCount[screenSize] + 1) + "%" : productWidth + "px"
      }
    }, currentProductDetails), /*#__PURE__*/React__default.createElement("div", {
      className: joinClasses(styles$2a.productTableSimilarProduct, similarProductsChild.length < displayCount[screenSize] && styles$2a.productTableSimilarProductNoOverflow),
      style: {
        width: similarProductsChild.length > displayCount[screenSize] ? 100 - 100 / (displayCount[screenSize] + 1) + "%" : similarProductsChild.length * productWidth + "px"
      }
    }, similarProductsChild.length > displayCount[screenSize] ? /*#__PURE__*/React__default.cloneElement(similarProductsCarousel, __assign({}, carouselDefaultProps)) : similarProductsWithoutCarousel))));
  });
};
ProductTable.displayName = 'CoreProductTable';

var styles$2b = {"button-toggle-group":"fr-ec-button-toggle-group","buttonToggleGroup":"fr-ec-button-toggle-group","button-toggle-group-single-column":"fr-ec-button-toggle-group-single-column","buttonToggleGroupSingleColumn":"fr-ec-button-toggle-group-single-column"};

var ButtonToggleGroup = function ButtonToggleGroup(_a) {
  var children = _a.children,
      columnCount = _a.columnCount,
      keyLines = _a.keyLines,
      props = __rest(_a, ["children", "columnCount", "keyLines"]);

  var arrayChildren = Children.toArray(children);
  return /*#__PURE__*/createElement("div", __assign({}, props, {
    className: columnCount === 1 ? styles$2b.buttonToggleGroupSingleColumn : styles$2b.buttonToggleGroup
  }), Children.map(arrayChildren, function (child, i) {
    return /*#__PURE__*/createElement("div", null, keyLines === true ? i === 0 || (columnCount === 2 ? i === 1 : i === 0) ? /*#__PURE__*/createElement(Keyline, null) : '' : '', child, keyLines === true ? /*#__PURE__*/createElement(Keyline, null) : '');
  }));
};
ButtonToggleGroup.displayName = 'CoreButtonToggleGroup';
ButtonToggleGroup.defaultProps = {
  columnCount: 2,
  keyLines: true
};

var styles$2c = {"typeahead-group":"fr-ec-typeahead-group","typeaheadGroup":"fr-ec-typeahead-group","typeahead-group__tab":"fr-ec-typeahead-group__tab","typeaheadGroupTab":"fr-ec-typeahead-group__tab","tab--is-active":"fr-ec-tab--is-active","tabIsActive":"fr-ec-tab--is-active","typeahead-group__tab-group":"fr-ec-typeahead-group__tab-group","typeaheadGroupTabGroup":"fr-ec-typeahead-group__tab-group","typeahead-group__sections":"fr-ec-typeahead-group__sections","typeaheadGroupSections":"fr-ec-typeahead-group__sections","typeahead-group__typeahead":"fr-ec-typeahead-group__typeahead","typeaheadGroupTypeahead":"fr-ec-typeahead-group__typeahead","typeahead-group__all-section":"fr-ec-typeahead-group__all-section","typeaheadGroupAllSection":"fr-ec-typeahead-group__all-section"};

var TypeaheadGroup = function TypeaheadGroup(_a) {
  var className = _a.className,
      _b = _a.allLabel,
      allLabel = _b === void 0 ? 'All' : _b,
      typeaheads = _a.typeaheads,
      _c = _a.sections,
      sections = _c === void 0 ? [] : _c,
      sectionTypeaheads = _a.sectionTypeaheads,
      typeaheadsCount = _a.typeaheadsCount,
      allTabSectionsCount = _a.allTabSectionsCount,
      gaAction = _a.gaAction,
      gaCallback = _a.gaCallback,
      gaCategory = _a.gaCategory,
      gaLabel = _a.gaLabel,
      gaValue = _a.gaValue,
      allTabOnClick = _a.allTabOnClick,
      sectionTabsOnClick = _a.sectionTabsOnClick,
      iconBrand = _a.iconBrand,
      _d = _a.variant,
      variant = _d === void 0 ? "default" : _d;

  var tabLabelArray = __spreadArrays([allLabel], sections);

  var sectionsLength = sections.length;
  var allTabSectionsCountArray = [];
  var renewalVariant = variant === "ec-renewal";

  for (var i = 0; i < sectionsLength; i++) {
    allTabSectionsCountArray.push(5);
  }

  var tabs = sections && sections.map(function (section, index) {
    return /*#__PURE__*/createElement(Tab, {
      label: section,
      key: section,
      gaAction: gaAction === null || gaAction === void 0 ? void 0 : gaAction[index + 1],
      gaCallback: gaCallback,
      gaLabel: gaLabel === null || gaLabel === void 0 ? void 0 : gaLabel[index + 1],
      gaValue: gaValue === null || gaValue === void 0 ? void 0 : gaValue[index + 1],
      gaCategory: gaCategory === null || gaCategory === void 0 ? void 0 : gaCategory[index + 1],
      onClick: sectionTabsOnClick === null || sectionTabsOnClick === void 0 ? void 0 : sectionTabsOnClick[index],
      className: renewalVariant ? styles$2c.typeaheadGroupTab : ""
    }, /*#__PURE__*/createElement("div", {
      className: styles$2c.typeaheadGroupTypeahead
    }, sectionTypeaheads && sectionTypeaheads[index].map(function (item) {
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/cloneElement(item, {
        activeTabName: tabLabelArray[index + 1]
      }));
    })));
  });
  return /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$2c.typeaheadGroup, className)
  }, /*#__PURE__*/createElement(TabGroup, {
    variant: "small",
    iconBrand: iconBrand,
    className: renewalVariant ? styles$2c.typeaheadGroupTabGroup : ""
  }, /*#__PURE__*/createElement(Tab, {
    label: allLabel,
    gaAction: gaAction === null || gaAction === void 0 ? void 0 : gaAction[0],
    gaCallback: gaCallback,
    gaLabel: gaLabel === null || gaLabel === void 0 ? void 0 : gaLabel[0],
    gaValue: gaValue === null || gaValue === void 0 ? void 0 : gaValue[0],
    gaCategory: gaCategory === null || gaCategory === void 0 ? void 0 : gaCategory[0],
    onClick: allTabOnClick,
    className: renewalVariant ? styles$2c.typeaheadGroupTab : ""
  }, /*#__PURE__*/createElement(Fragment, null, typeaheads && /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$2c.typeaheadGroupAllSection, spacingStyles.mbSpacing05)
  }, typeaheads && typeaheads.slice(0, typeaheadsCount).map(function (item, index) {
    return /*#__PURE__*/createElement(Fragment, {
      key: index
    }, /*#__PURE__*/cloneElement(item, {
      activeTabName: tabLabelArray[0]
    }));
  })), sectionTypeaheads && sectionTypeaheads.map(function (
  /* tslint:disable */
  item, index) {
    var items = item.slice(0, allTabSectionsCount !== undefined ? allTabSectionsCount[index] : allTabSectionsCountArray[index]);
    return /*#__PURE__*/createElement(Fragment, {
      key: index
    }, /*#__PURE__*/createElement(Title, {
      element: "h1",
      color: "primary-dark",
      className: styles$2c.typeaheadGroupSections
    }, sections[index]), /*#__PURE__*/createElement("div", {
      className: styles$2c.typeaheadGroupTypeahead
    }, items.map(function (item) {
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/cloneElement(item, {
        activeTabName: tabLabelArray[0]
      }));
    })));
  }))), tabs));
};
TypeaheadGroup.displayName = 'CoreTypeaheadGroup';

var styles$2d = {"cms-selected-store":"fr-ec-cms-selected-store","cmsSelectedStore":"fr-ec-cms-selected-store"};

var CmsSelectedStore = function CmsSelectedStore(_a) {
  var className = _a.className,
      props = __rest(_a, ["className"]);

  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$2d.cmsSelectedStore, className)
  }, props));
};
CmsSelectedStore.displayName = 'CmsSelectedStore';

var DataTableCellStyles = {"data-table-cell":"fr-ec-data-table-cell","dataTableCell":"fr-ec-data-table-cell","data-table-cell--image":"fr-ec-data-table-cell--image","dataTableCellImage":"fr-ec-data-table-cell--image","data-table-cell--tool-tip":"fr-ec-data-table-cell--tool-tip","dataTableCellToolTip":"fr-ec-data-table-cell--tool-tip","data-table-cell--button":"fr-ec-data-table-cell--button","dataTableCellButton":"fr-ec-data-table-cell--button","data-table-cell--empty":"fr-ec-data-table-cell--empty","dataTableCellEmpty":"fr-ec-data-table-cell--empty","image-overlay":"fr-ec-image-overlay","imageOverlay":"fr-ec-image-overlay","image-overlay__content":"fr-ec-image-overlay__content","imageOverlayContent":"fr-ec-image-overlay__content","image-overlay__label":"fr-ec-image-overlay__label","imageOverlayLabel":"fr-ec-image-overlay__label","image":"fr-ec-image","data-table-cell--text-align-start":"fr-ec-data-table-cell--text-align-start","dataTableCellTextAlignStart":"fr-ec-data-table-cell--text-align-start","data-table-cell--text-align-center":"fr-ec-data-table-cell--text-align-center","dataTableCellTextAlignCenter":"fr-ec-data-table-cell--text-align-center","data-table-cell--text-align-end":"fr-ec-data-table-cell--text-align-end","dataTableCellTextAlignEnd":"fr-ec-data-table-cell--text-align-end","data-table-cell--highlighted":"fr-ec-data-table-cell--highlighted","dataTableCellHighlighted":"fr-ec-data-table-cell--highlighted","data-table-cell--no-wrap":"fr-ec-data-table-cell--no-wrap","dataTableCellNoWrap":"fr-ec-data-table-cell--no-wrap","data-table-cell--multi-lines":"fr-ec-data-table-cell--multi-lines","dataTableCellMultiLines":"fr-ec-data-table-cell--multi-lines"};

var DataTableCell = function DataTableCell(_a) {
  var Element = _a.element,
      className = _a.className,
      _b = _a.alignment,
      alignment = _b === void 0 ? 'start' : _b,
      width = _a.width,
      props = __rest(_a, ["element", "className", "alignment", "width"]);

  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign({
      className: joinClasses(DataTableCellStyles.dataTableCell, DataTableCellStyles["data-table-cell--text-align-" + alignment], className),
      style: {
        width: width
      }
    }, props))
  );
};
DataTableCell.displayName = 'CoreDataTableCell';
DataTableCell.defaultProps = {
  alignment: 'start'
};

var DataTableRowStyles = {"data-table-row":"fr-ec-data-table-row","dataTableRow":"fr-ec-data-table-row","data-table-row--highlighted":"fr-ec-data-table-row--highlighted","dataTableRowHighlighted":"fr-ec-data-table-row--highlighted","data-table-row--heading":"fr-ec-data-table-row--heading","dataTableRowHeading":"fr-ec-data-table-row--heading","data-table-cell":"fr-ec-data-table-cell","dataTableCell":"fr-ec-data-table-cell"};

var DataTableRow = function DataTableRow(_a) {
  var className = _a.className,
      props = __rest(_a, ["className"]);

  return /*#__PURE__*/createElement("tr", __assign({
    className: joinClasses(DataTableRowStyles.dataTableRow, className)
  }, props));
};
DataTableRow.displayName = 'CoreDataTableRow';

var scrollbarStyles = {"data-table-scroll__container":"fr-ec-data-table-scroll__container","dataTableScrollContainer":"fr-ec-data-table-scroll__container","data-table-container":"fr-ec-data-table-container","dataTableContainer":"fr-ec-data-table-container","data-table":"fr-ec-data-table","dataTable":"fr-ec-data-table","data-table-scroll__scrollbar":"fr-ec-data-table-scroll__scrollbar","dataTableScrollScrollbar":"fr-ec-data-table-scroll__scrollbar","data-table-scroll__button":"fr-ec-data-table-scroll__button","dataTableScrollButton":"fr-ec-data-table-scroll__button","data-table-scroll__track-and-thumb":"fr-ec-data-table-scroll__track-and-thumb","dataTableScrollTrackAndThumb":"fr-ec-data-table-scroll__track-and-thumb","data-table-scroll__track":"fr-ec-data-table-scroll__track","dataTableScrollTrack":"fr-ec-data-table-scroll__track","data-table-scroll__thumb":"fr-ec-data-table-scroll__thumb","dataTableScrollThumb":"fr-ec-data-table-scroll__thumb","data-table-show-more":"fr-ec-data-table-show-more","dataTableShowMore":"fr-ec-data-table-show-more"};

var DataTableScrollContainer = function DataTableScrollContainer(_a) {
  var children = _a.children,
      className = _a.className,
      iconBrand = _a.iconBrand,
      showMore = _a.showMore,
      rows = _a.rows,
      props = __rest(_a, ["children", "className", "iconBrand", "showMore", "rows"]);

  var TRACK_WIDTH = 30;
  var SCROLL_JITTER = 1;
  var tableRef = useRef(null);
  var scrollContainerRef = useRef(null);
  var scrollTrackRef = useRef(null);
  var scrollThumbRef = useRef(null);

  var _b = useState(TRACK_WIDTH),
      thumbWidth = _b[0],
      setThumbWidth = _b[1];

  var _c = useState(null),
      scrollStartPosition = _c[0],
      setScrollStartPosition = _c[1];

  var _d = useState(0),
      initialScrollLeft = _d[0],
      setInitialScrollLeft = _d[1];

  var _e = useState(false),
      isDragging = _e[0],
      setIsDragging = _e[1];

  var _f = useState(null),
      isOverflowing = _f[0],
      setIsOverflowing = _f[1];

  var _g = useState(isTouchDevice('touchPoints')),
      isTouchDevices = _g[0],
      setTouchDevices = _g[1];

  var _h = useState('body'),
      touchElement = _h[0],
      setTouchElement = _h[1];

  var _j = useState(0),
      currentScrollLeft = _j[0],
      setCurrentScrollLeft = _j[1];

  var _k = useState(0),
      scrollDeltaX = _k[0],
      setScrollDeltaX = _k[1];

  var scrollTouchTimerRef = useRef(null);
  /**
   * Set states to show scroll arrows
   */

  var setScrollArrows = function setScrollArrows() {
    if (tableRef.current) {
      var _a = tableRef.current,
          tableScrollWidth = _a.scrollWidth,
          tableClientWidth = _a.clientWidth,
          scrollLeft = _a.scrollLeft;
      setScrollDeltaX(tableScrollWidth - tableClientWidth - scrollLeft);
      setCurrentScrollLeft(scrollLeft || 0);
    }
  };
  /**
   * Function to show and hide scroll, true will show the scroll
   */


  var toggleScroll = function toggleScroll(show, grab) {
    var isDragged = grab !== undefined ? grab : isDragging;

    if (scrollContainerRef === null || scrollContainerRef === void 0 ? void 0 : scrollContainerRef.current) {
      if (show || isDragged) {
        scrollContainerRef.current.style.opacity = '1';
        scrollContainerRef.current.style.transition = 'opacity 0.6s linear';
      } else {
        scrollContainerRef.current.style.opacity = '0';
      }
    }
  };

  var onTouchAndMouseDown = useCallback(function (e, touchEl) {
    var _a;

    e.stopPropagation();
    var touch = (_a = e.touches) === null || _a === void 0 ? void 0 : _a[0]; // touch event related conditions

    if (touchEl) {
      clearTimeout(scrollTouchTimerRef.current);
      setTouchElement(touchEl);
      toggleScroll(true, true);
    }

    setScrollStartPosition(e.clientX || touch.clientX);

    if (tableRef.current) {
      setInitialScrollLeft(tableRef.current.scrollLeft);
    }

    setIsDragging(true);
  }, []);
  var onTouchAndMouseUp = useCallback(function (e) {
    var scrollContainerNode = scrollContainerRef.current;
    var tableNode = tableRef.current;
    setScrollArrows();

    if (isDragging) {
      if (!(scrollContainerNode && scrollContainerNode.contains(e.target)) && !(tableNode && tableNode.contains(e.target))) {
        toggleScroll(false, false);
      }

      setIsDragging(false);
    }

    if (e.type === 'touchend') {
      scrollTouchTimerRef.current = setTimeout(function () {
        return toggleScroll(false, false);
      }, 1000);
    }
  }, [isDragging]);
  var onMouseMove = useCallback(function (e) {
    if (isDragging) {
      var _a = tableRef.current,
          tableScrollWidth = _a.scrollWidth,
          tableOffsetWidth = _a.offsetWidth;
      var deltaX = (e.clientX - (scrollStartPosition || 0)) * (tableOffsetWidth / thumbWidth);
      var newScrollLeft = Math.min(initialScrollLeft + deltaX, tableScrollWidth - tableOffsetWidth);

      if (tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) {
        tableRef.current.scrollLeft = newScrollLeft;
      }
    }
  }, [isDragging, scrollStartPosition, thumbWidth]);
  var onTouchMove = useCallback(function (e) {
    var _a;

    var touch = (_a = e.touches) === null || _a === void 0 ? void 0 : _a[0];

    if (isDragging) {
      var _b = tableRef.current,
          tableScrollWidth = _b.scrollWidth,
          tableOffsetWidth = _b.offsetWidth;
      var deltaX = (touch.clientX - (scrollStartPosition || 0)) * (tableOffsetWidth / thumbWidth);
      var newScrollLeft = 0;

      if (touchElement === 'body') {
        newScrollLeft = -1 * (-1 * initialScrollLeft + deltaX);
      } else if (touchElement === 'thumb') {
        newScrollLeft = Math.min(initialScrollLeft + deltaX, tableScrollWidth - tableOffsetWidth);
      }

      if (tableRef === null || tableRef === void 0 ? void 0 : tableRef.current) {
        tableRef.current.scrollLeft = newScrollLeft;
      }
    }
  }, [isDragging, scrollStartPosition, thumbWidth]);

  var onScreenResize = function onScreenResize() {
    setTouchDevices(isTouchDevice('userAgent'));

    if (tableRef.current) {
      var _a = tableRef.current,
          clientWidth = _a.clientWidth,
          scrollWidth = _a.scrollWidth;

      if (scrollTrackRef.current) {
        var trackSize = scrollTrackRef.current.clientWidth;
        setThumbWidth(Math.max(clientWidth / scrollWidth * trackSize, TRACK_WIDTH));
      }

      if (scrollWidth > clientWidth) {
        setIsOverflowing(true);
      } else {
        setIsOverflowing(false);
      }
    }

    setScrollArrows();
    toggleScroll(false);
  };

  var onScrollButtonClick = function onScrollButtonClick(direction) {
    var current = tableRef.current;

    if (current) {
      var scrollAmount = direction === 'right' ? TRACK_WIDTH : -1 * TRACK_WIDTH;
      current.scrollBy({
        left: scrollAmount,
        behavior: 'smooth'
      });
    }
  };

  var onTrackClick = useCallback(function (e) {
    var _a;

    var touch = (_a = e.touches) === null || _a === void 0 ? void 0 : _a[0];
    e.preventDefault();
    e.stopPropagation();
    var trackElement = scrollTrackRef.current;
    var tableElement = tableRef.current;

    if (trackElement && tableElement) {
      var target = e.target;
      var rect = target.getBoundingClientRect();
      var trackLeft = rect.left;
      var thumbOffset = -(thumbWidth / 2);
      var clickRatio = ((e.clientX || touch.clientX) - trackLeft + thumbOffset) / trackElement.clientWidth;
      var scrollAmount = Math.floor(clickRatio * tableElement.scrollWidth);
      tableElement.scrollTo({
        behavior: 'smooth',
        left: scrollAmount
      });
    }
  }, [thumbWidth]);
  var setThumbPosition = useCallback(function () {
    if (!tableRef.current || !scrollTrackRef.current || !scrollThumbRef.current) {
      return;
    }

    var _a = tableRef.current,
        scrollLeft = _a.scrollLeft,
        scrollWidth = _a.scrollWidth;
    var clientWidth = scrollTrackRef.current.clientWidth;
    var newLeft = +scrollLeft / +scrollWidth * clientWidth;
    newLeft = Math.min(newLeft, clientWidth - thumbWidth);
    var thumb = scrollThumbRef.current;
    thumb.style.left = newLeft + "px";
  }, []);
  useEffect(function () {
    return function () {
      return clearTimeout(scrollTouchTimerRef.current);
    };
  }, []);
  /**
   * Mouse click events
   */

  useEffect(function () {
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onTouchAndMouseUp);
    document.addEventListener('mouseleave', onTouchAndMouseUp);
    return function () {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onTouchAndMouseUp);
      document.removeEventListener('mouseleave', onTouchAndMouseUp);
    };
  }, [onMouseMove, onTouchAndMouseUp]);
  /**
   * Touch events
   */

  useEffect(function () {
    document.addEventListener('touchmove', onTouchMove);
    document.addEventListener('touchcancel', onTouchAndMouseUp);
    document.addEventListener('touchend', onTouchAndMouseUp);
    return function () {
      document.removeEventListener('touchmove', onTouchMove);
      document.removeEventListener('touchcancel', onTouchAndMouseUp);
      document.removeEventListener('touchend', onTouchAndMouseUp);
    };
  }, [onMouseMove, onTouchAndMouseUp]);
  useEffect(function () {
    onScreenResize();
  }, [rows]);
  return /*#__PURE__*/React__default.createElement(Measure, {
    bounds: true,
    onResize: onScreenResize
  }, function (_a) {
    var measureRef = _a.measureRef;
    return isOverflowing || isOverflowing === null ? /*#__PURE__*/React__default.createElement("div", {
      className: className
    }, /*#__PURE__*/React__default.createElement("div", __assign({
      className: scrollbarStyles.dataTableScrollContainer,
      onMouseOver: function onMouseOver() {
        return toggleScroll(true);
      },
      onMouseLeave: function onMouseLeave() {
        return toggleScroll(false);
      },
      onTouchStart: function onTouchStart(e) {
        return onTouchAndMouseDown(e, 'body');
      },
      role: "table",
      ref: measureRef
    }, props), /*#__PURE__*/React__default.createElement("div", {
      className: scrollbarStyles.dataTableContainer,
      ref: tableRef,
      onScroll: setThumbPosition
    }, children), /*#__PURE__*/React__default.createElement("div", {
      className: scrollbarStyles.dataTableScrollScrollbar,
      ref: scrollContainerRef
    }, /*#__PURE__*/React__default.createElement("div", {
      className: scrollbarStyles.dataTableScrollTrackAndThumb
    }, /*#__PURE__*/React__default.createElement("div", {
      className: scrollbarStyles.dataTableScrollTrack,
      ref: scrollTrackRef,
      onClick: onTrackClick,
      style: {
        cursor: isDragging ? 'grabbing' : ''
      },
      role: "button"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: scrollbarStyles.dataTableScrollThumb,
      ref: scrollThumbRef,
      onMouseDown: onTouchAndMouseDown,
      onTouchStart: function onTouchStart(e) {
        return onTouchAndMouseDown(e, 'thumb');
      },
      style: {
        cursor: isDragging ? 'grabbing' : 'grab',
        width: thumbWidth + "px"
      },
      role: "button"
    })), !isTouchDevices && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ButtonIcon, {
      element: "button",
      hideLabel: true,
      icon: "chevron-left",
      iconBrand: iconBrand,
      label: "left-arrow",
      className: scrollbarStyles.dataTableScrollButton,
      onClick: function onClick() {
        return onScrollButtonClick('left');
      },
      disabled: currentScrollLeft === 0
    }), /*#__PURE__*/React__default.createElement(ButtonIcon, {
      element: "button",
      hideLabel: true,
      icon: "chevron-right",
      iconBrand: iconBrand,
      label: "right-arrow",
      className: scrollbarStyles.dataTableScrollButton,
      onClick: function onClick() {
        return onScrollButtonClick('right');
      },
      disabled: scrollDeltaX <= SCROLL_JITTER
    })))), showMore && /*#__PURE__*/React__default.createElement(ContentAlignment, {
      direction: "column",
      element: 'div',
      alignment: "center",
      className: scrollbarStyles.dataTableShowMore
    }, showMore)) : /*#__PURE__*/React__default.createElement("div", {
      className: joinClasses(scrollbarStyles.dataTableContainer, className),
      ref: tableRef
    }, showMore ? /*#__PURE__*/React__default.createElement(ContentAlignment, {
      style: {
        width: 'fit-content'
      },
      direction: "column",
      element: 'div',
      alignment: "center"
    }, children, /*#__PURE__*/React__default.cloneElement(showMore, {
      className: joinClasses(showMore.props.className, scrollbarStyles.dataTableShowMore)
    })) : children);
  });
};

var styles$2e = {"cms-promotion-banner":"fr-ec-cms-promotion-banner","cmsPromotionBanner":"fr-ec-cms-promotion-banner","cms-promotion-banner--back-ground-black":"fr-ec-cms-promotion-banner--back-ground-black","cmsPromotionBannerBackGroundBlack":"fr-ec-cms-promotion-banner--back-ground-black","cms-promotion-banner--back-ground-blue":"fr-ec-cms-promotion-banner--back-ground-blue","cmsPromotionBannerBackGroundBlue":"fr-ec-cms-promotion-banner--back-ground-blue","cms-promotion-banner__main-image":"fr-ec-cms-promotion-banner__main-image","cmsPromotionBannerMainImage":"fr-ec-cms-promotion-banner__main-image","image":"fr-ec-image","cms-promotion-banner__text-container":"fr-ec-cms-promotion-banner__text-container","cmsPromotionBannerTextContainer":"fr-ec-cms-promotion-banner__text-container","cms-promotion-banner__text-wrapper":"fr-ec-cms-promotion-banner__text-wrapper","cmsPromotionBannerTextWrapper":"fr-ec-cms-promotion-banner__text-wrapper","cms-promotion-banner__icon":"fr-ec-cms-promotion-banner__icon","cmsPromotionBannerIcon":"fr-ec-cms-promotion-banner__icon","cms-promotion-banner__promotion-text-hidden":"fr-ec-cms-promotion-banner__promotion-text-hidden","cmsPromotionBannerPromotionTextHidden":"fr-ec-cms-promotion-banner__promotion-text-hidden","cms-promotion-banner__promotion-text":"fr-ec-cms-promotion-banner__promotion-text","cmsPromotionBannerPromotionText":"fr-ec-cms-promotion-banner__promotion-text","promotion-text-loop":"fr-ec-promotion-text-loop","promotionTextLoop":"fr-ec-promotion-text-loop"};

var CmsPromotionBanner = function CmsPromotionBanner(_a) {
  var icon = _a.icon,
      logo = _a.logo,
      mainImage = _a.mainImage,
      promotionText = _a.promotionText,
      _b = _a.backgroundColor,
      backgroundColor = _b === void 0 ? 'black' : _b,
      gaLabel = _a.gaLabel,
      gaCategory = _a.gaCategory,
      link = _a.link,
      target = _a.target,
      className = _a.className,
      onClick = _a.onClick,
      gaCallback = _a.gaCallback,
      gaAction = _a.gaAction,
      gaValue = _a.gaValue,
      props = __rest(_a, ["icon", "logo", "mainImage", "promotionText", "backgroundColor", "gaLabel", "gaCategory", "link", "target", "className", "onClick", "gaCallback", "gaAction", "gaValue"]);
  /*
  Text animation should maintain constant speed.
  As per specs to translate 275px container width it will take 10s
  which means in 1s it will translate 275/10 => 27.5px
  */


  var pixelsPerSecond = 27.5;
  var textPadding = 120;

  var _c = React__default.useState(0),
      duplicateTextCount = _c[0],
      setDuplicateTextCount = _c[1];

  var _d = React__default.useState(0),
      textWrapperWidth = _d[0],
      setTextWrapperWidth = _d[1];

  var _e = React__default.useState(0),
      textContentWidth = _e[0],
      setTextContentWidth = _e[1];

  var _f = useState(getCurrentMediaQueryBreakpoint()),
      screenSize = _f[0],
      setScreenSize = _f[1];

  var textWrapperRef = useRef(null);
  var rootTag = 'a';
  var absoluteUrlPattern = isAbsoluteUrl(link);
  var attributes = {};

  if (absoluteUrlPattern) {
    attributes = {
      href: link,
      target: target || '_blank'
    };
  } else if (link) {
    rootTag = Link$1; // Default target behaviour of Link is similar to that of '_self'.
    // But if you specify target property explicitly, it refreshes the page.
    // @ts-ignore

    attributes.to = link;

    if (target && target !== '_self') {
      // @ts-ignore
      attributes.target = target;
    }
  }

  var gaProps = {};

  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };

    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }

  var onClickCallback = function onClickCallback(e) {
    // For callback
    if (onClick) {
      onClick(e);
    }

    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    }
  };

  useEffect(function () {
    var textEl = document.getElementsByClassName('fr-ec-cms-promotion-banner__promotion-text-hidden');

    if (textWrapperRef.current) {
      var clientWidth = textWrapperRef.current.clientWidth;

      if (textEl[0]) {
        var duplicateCount = clientWidth < textEl[0].clientWidth ? 2 : Math.ceil(clientWidth / textEl[0].clientWidth) + 1;
        setDuplicateTextCount(duplicateCount);
        setTextWrapperWidth(clientWidth);
        setTextContentWidth(textEl[0].clientWidth);
      }
    }
  }, [screenSize, promotionText]);

  var onResize = function onResize() {
    setScreenSize(getCurrentMediaQueryBreakpoint());
  };

  var promotionTextDuplicater = function promotionTextDuplicater(promotionLabel) {
    var duplicateCount = duplicateTextCount;
    var textList = [];

    for (var i = 0; i < duplicateCount; i++) {
      var transitionDistance = textWrapperWidth + (textContentWidth - textPadding);
      var animationTime = transitionDistance / pixelsPerSecond;
      var transitionDelay = textContentWidth * animationTime / transitionDistance;
      var transitionTime = transitionDelay * duplicateCount;
      var deltaTime = animationTime - transitionTime;
      var delayTime = i > 0 ? transitionDelay * i + deltaTime : deltaTime;
      var initialPosition = transitionTime * transitionDistance / animationTime - transitionDistance + textWrapperWidth;
      textList.push( /*#__PURE__*/React__default.createElement(Body, {
        key: i,
        className: styles$2e.cmsPromotionBannerPromotionText,
        element: 'h1',
        variant: 'small',
        style: {
          animation: "fr-ec-promotion-text-loop " + transitionTime + "s infinite linear " + delayTime + "s",
          transform: "translate(" + initialPosition + "px)"
        }
      }, promotionLabel));
    }

    return textList;
  };

  return /*#__PURE__*/React__default.createElement(Measure, {
    bounds: true,
    onResize: onResize
  }, function (_a) {
    var measureRef = _a.measureRef;
    return /*#__PURE__*/React__default.createElement("div", __assign({
      className: joinClasses(styles$2e["cms-promotion-banner--back-ground-" + backgroundColor], className),
      role: 'status',
      onClick: onClickCallback
    }, props, gaProps, {
      ref: measureRef
    }), /*#__PURE__*/React__default.createElement(ContentAlignment, __assign({
      className: styles$2e.cmsPromotionBanner,
      element: rootTag,
      direction: 'row',
      justifyContent: 'center'
    }, attributes), mainImage && /*#__PURE__*/React__default.createElement("div", {
      className: styles$2e.cmsPromotionBannerMainImage
    }, mainImage), /*#__PURE__*/React__default.createElement("div", {
      className: styles$2e.cmsPromotionBannerTextContainer
    }, /*#__PURE__*/React__default.createElement("div", {
      className: styles$2e.cmsPromotionBannerTextWrapper,
      ref: textWrapperRef
    }, /*#__PURE__*/React__default.createElement(Body, {
      className: styles$2e.cmsPromotionBannerPromotionTextHidden,
      element: 'h1',
      variant: 'small'
    }, promotionText), promotionTextDuplicater(promotionText)), logo), icon && /*#__PURE__*/React__default.createElement("div", {
      className: styles$2e.cmsPromotionBannerIcon
    }, icon)));
  });
};
CmsPromotionBanner.displayName = 'CoreCmsPromotionBanner';
CmsPromotionBanner.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var CmsFooterInformation = function CmsFooterInformation(_a) {
  var _b = _a.type,
      type = _b === void 0 ? 'footer' : _b,
      children = _a.children;
  return type === 'footer' ? /*#__PURE__*/createElement(Fragment, null, children) : /*#__PURE__*/createElement("div", null);
};
CmsFooterInformation.displayName = 'CoreCmsFooterInformation';

var styles$2f = {"bottom-navigation":"fr-ec-bottom-navigation","bottomNavigation":"fr-ec-bottom-navigation","bottom-navigation--column":"fr-ec-bottom-navigation--column","bottomNavigationColumn":"fr-ec-bottom-navigation--column","bottom-navigation--flyout-area":"fr-ec-bottom-navigation--flyout-area","bottomNavigationFlyoutArea":"fr-ec-bottom-navigation--flyout-area","bottom-navigation-wrapper":"fr-ec-bottom-navigation-wrapper","bottomNavigationWrapper":"fr-ec-bottom-navigation-wrapper","bottom-navigation__iq-area":"fr-ec-bottom-navigation__iq-area","bottomNavigationIqArea":"fr-ec-bottom-navigation__iq-area","bottom-navigation__iq-container":"fr-ec-bottom-navigation__iq-container","bottomNavigationIqContainer":"fr-ec-bottom-navigation__iq-container","button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon","image":"fr-ec-image","bottom-navigation_wrapper-membership":"fr-ec-bottom-navigation_wrapper-membership","bottomNavigationWrapperMembership":"fr-ec-bottom-navigation_wrapper-membership","bottom-navigation__container-membership":"fr-ec-bottom-navigation__container-membership","bottomNavigationContainerMembership":"fr-ec-bottom-navigation__container-membership","bottom-navigation__icon":"fr-ec-bottom-navigation__icon","bottomNavigationIcon":"fr-ec-bottom-navigation__icon","bottom-navigation__container":"fr-ec-bottom-navigation__container","bottomNavigationContainer":"fr-ec-bottom-navigation__container","bottom-navigation__container-search":"fr-ec-bottom-navigation__container-search","bottomNavigationContainerSearch":"fr-ec-bottom-navigation__container-search","bottom-navigation__button-membership":"fr-ec-bottom-navigation__button-membership","bottomNavigationButtonMembership":"fr-ec-bottom-navigation__button-membership","search-wrapper":"fr-ec-search-wrapper","searchWrapper":"fr-ec-search-wrapper","bottom-navigation__icon-wrapper":"fr-ec-bottom-navigation__icon-wrapper","bottomNavigationIconWrapper":"fr-ec-bottom-navigation__icon-wrapper","bottom-navigation__icon-wrapper-center":"fr-ec-bottom-navigation__icon-wrapper-center","bottomNavigationIconWrapperCenter":"fr-ec-bottom-navigation__icon-wrapper-center","bottom-navigation__icon-center":"fr-ec-bottom-navigation__icon-center","bottomNavigationIconCenter":"fr-ec-bottom-navigation__icon-center","bottom-navigation--layout-wrapper":"fr-ec-bottom-navigation--layout-wrapper","bottomNavigationLayoutWrapper":"fr-ec-bottom-navigation--layout-wrapper","bottom-navigation__search-history__delete-icon--disabled":"fr-ec-bottom-navigation__search-history__delete-icon--disabled","bottomNavigationSearchHistoryDeleteIconDisabled":"fr-ec-bottom-navigation__search-history__delete-icon--disabled","bottom-navigation__search-history-collection":"fr-ec-bottom-navigation__search-history-collection","bottomNavigationSearchHistoryCollection":"fr-ec-bottom-navigation__search-history-collection","collection-list__item":"fr-ec-collection-list__item","collectionListItem":"fr-ec-collection-list__item","bottom-navigation__search-history-collection__items":"fr-ec-bottom-navigation__search-history-collection__items","bottomNavigationSearchHistoryCollectionItems":"fr-ec-bottom-navigation__search-history-collection__items","bottom-navigation__no-search-history--section":"fr-ec-bottom-navigation__no-search-history--section","bottomNavigationNoSearchHistorySection":"fr-ec-bottom-navigation__no-search-history--section","bottom-navigation--layout-wrapper-without-icon":"fr-ec-bottom-navigation--layout-wrapper-without-icon","bottomNavigationLayoutWrapperWithoutIcon":"fr-ec-bottom-navigation--layout-wrapper-without-icon","layout-wrapper":"fr-ec-layout-wrapper","layoutWrapper":"fr-ec-layout-wrapper"};

var BottomNavigation = function BottomNavigation(_a) {
  var iqChatBotArea = _a.iqChatBotArea,
      searchFocused = _a.searchFocused,
      hasSearchValue = _a.hasSearchValue,
      primaryOptionsIcon = _a.primaryOptionsIcon,
      primaryOptionsLabel = _a.primaryOptionsLabel,
      primaryOptionsCallback = _a.primaryOptionsCallback,
      searchArea = _a.searchArea,
      secondaryOptionsIcon = _a.secondaryOptionsIcon,
      secondaryOptionsCallback = _a.secondaryOptionsCallback,
      _b = _a.variant,
      variant = _b === void 0 ? "default" : _b,
      searchFlyoutArea = _a.searchFlyoutArea,
      searchHistoryItems = _a.searchHistoryItems,
      showSearchHistory = _a.showSearchHistory,
      searchHistoryLabel = _a.searchHistoryLabel,
      noSearchHistorySection = _a.noSearchHistorySection,
      onDeleteSearchHistory = _a.onDeleteSearchHistory,
      _c = _a.showTrendingWords,
      showTrendingWords = _c === void 0 ? false : _c,
      trendingWordsLabel = _a.trendingWordsLabel,
      trendingWords = _a.trendingWords,
      iconBrand = _a.iconBrand;

  var _d = useState(searchFocused),
      toggleArrow = _d[0],
      setToggleArrow = _d[1];

  var _e = useState(hasSearchValue),
      hasValue = _e[0],
      setValueStatus = _e[1];

  var _f = useState(0),
      bottomVal = _f[0],
      setBottomVal = _f[1];

  var bottomRef = useRef(null);
  var searchWrapperRef = useRef(null);
  var width = getViewportWidth();
  var isArrowVisible = toggleArrow ? width > designTokens_3.mqMediumScreenMaxWidthLimit : true;
  useEffect(function () {
    setToggleArrow(searchFocused);
    setValueStatus(hasSearchValue);

    if (bottomRef && bottomRef.current) {
      setBottomVal(bottomRef.current.getBoundingClientRect().height);
    }
  }, [searchFocused, hasSearchValue, bottomRef.current, toggleArrow]);
  var isSecondaryIconVisible = toggleArrow || hasValue && !searchFocused;

  var getSearchHistoryTitle = function getSearchHistoryTitle(label, iconBrandVal) {
    if (label === void 0) {
      label = '';
    }

    return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Title, {
      element: "p",
      variant: "standard"
    }, label || 'Search History'), /*#__PURE__*/createElement(ButtonIcon, {
      type: "button",
      element: "button",
      icon: "delete",
      iconBrand: iconBrandVal,
      hideLabel: true,
      onMouseDown: onDeleteSearchHistory,
      tabIndex: -1,
      label: "Delete",
      disabled: searchHistoryItems && searchHistoryItems.length > 0 ? false : true,
      className: searchHistoryItems && searchHistoryItems.length > 0 ? '' : styles$2f.bottomNavigationSearchHistoryDeleteIconDisabled
    }));
  };

  return /*#__PURE__*/createElement(Fragment, null, (searchFlyoutArea || showSearchHistory) && /*#__PURE__*/createElement("div", {
    ref: searchWrapperRef,
    className: styles$2f.bottomNavigationFlyoutArea,
    style: {
      paddingBottom: bottomVal + 12 + "px"
    }
  }, searchFlyoutArea, showSearchHistory && /*#__PURE__*/createElement(LayoutWrapper, {
    element: "div"
  }, /*#__PURE__*/createElement(Layout, {
    element: "div",
    gutter: true,
    colSpan: {
      lg: 10,
      sm: 12,
      md: 12
    }
  }, /*#__PURE__*/createElement(CollectionList, {
    spacing: "none",
    role: "dialog",
    "aria-live": "assertive",
    "aria-atomic": "true",
    className: joinClasses(styles$2f.bottomNavigationSearchHistoryCollection, showTrendingWords && trendingWordsLabel && styles$2f.bottomNavigationSearchHistoryCollectionItems)
  }, showTrendingWords && trendingWordsLabel && /*#__PURE__*/createElement(Title, {
    variant: "standard",
    element: "h5"
  }, trendingWordsLabel), showTrendingWords && trendingWords, getSearchHistoryTitle(searchHistoryLabel, iconBrand), searchHistoryItems && searchHistoryItems.length > 0 ? searchHistoryItems : /*#__PURE__*/createElement("div", {
    className: styles$2f.bottomNavigationNoSearchHistorySection
  }, noSearchHistorySection ? noSearchHistorySection : /*#__PURE__*/createElement(Body, {
    variant: "standard",
    element: "p"
  }, "If there is a search history, it will be displayed here.")))))), /*#__PURE__*/createElement("div", {
    ref: bottomRef,
    className: joinClasses(styles$2f.bottomNavigation, variant === "search" && styles$2f.bottomNavigationContainerSearch)
  }, variant === "search" && iqChatBotArea && /*#__PURE__*/createElement("div", {
    className: styles$2f.bottomNavigationIqArea
  }, iqChatBotArea), variant === "search" && /*#__PURE__*/createElement(LayoutWrapper, {
    element: "div"
  }, /*#__PURE__*/createElement(Layout, {
    element: "div",
    gutter: {
      sm: !toggleArrow,
      md: !toggleArrow,
      lg: true
    },
    className: joinClasses(styles$2f.bottomNavigationLayoutWrapper, toggleArrow && styles$2f.bottomNavigationLayoutWrapperWithoutIcon)
  }, toggleArrow && /*#__PURE__*/createElement(ButtonIcon, {
    icon: "chevron-left",
    label: '',
    element: "button",
    onClick: function onClick() {
      return setToggleArrow(!toggleArrow);
    }
  }), searchArea, secondaryOptionsIcon && !isSecondaryIconVisible && /*#__PURE__*/createElement("div", {
    className: styles$2f.bottomNavigationIqContainer
  }, secondaryOptionsIcon.map(function (item, index) {
    return item && /*#__PURE__*/createElement(ButtonIcon, {
      label: "",
      hideLabel: true,
      element: "a",
      icon: item,
      key: index,
      onClick: function onClick(e) {
        var _a;

        return item && secondaryOptionsCallback && secondaryOptionsCallback[index] && ((_a = secondaryOptionsCallback[index]) === null || _a === void 0 ? void 0 : _a.call(secondaryOptionsCallback, e));
      }
    });
  })))), variant === "membership" ? /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$2f.bottomNavigationWrapper, styles$2f.bottomNavigationWrapperMembership)
  }, primaryOptionsIcon && primaryOptionsIcon[1] && /*#__PURE__*/createElement(Button, {
    onClick: function onClick(e) {
      var _a;

      return primaryOptionsCallback && primaryOptionsCallback[1] && ((_a = primaryOptionsCallback[1]) === null || _a === void 0 ? void 0 : _a.call(primaryOptionsCallback, e));
    },
    element: "button",
    children: primaryOptionsLabel && primaryOptionsLabel[1],
    variant: "primary",
    isSmall: false,
    icon: primaryOptionsIcon[1],
    className: styles$2f.bottomNavigationButtonMembership
  })) : (isArrowVisible || hasValue && !searchFocused) && /*#__PURE__*/createElement("div", {
    className: styles$2f.bottomNavigationWrapper
  }, /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$2f.bottomNavigationContainer)
  }, primaryOptionsIcon && primaryOptionsIcon.map(function (item, index) {
    var isCenterIcon = index === 1;
    return /*#__PURE__*/createElement("div", {
      role: "button",
      key: index + "icon",
      className: joinClasses(item ? styles$2f.bottomNavigationIconWrapper : "", isCenterIcon && styles$2f.bottomNavigationIconWrapperCenter),
      onClick: function onClick(e) {
        var _a;

        return item && primaryOptionsCallback && primaryOptionsCallback[index] && ((_a = primaryOptionsCallback[index]) === null || _a === void 0 ? void 0 : _a.call(primaryOptionsCallback, e));
      }
    }, item ? /*#__PURE__*/createElement(Icon, {
      name: item,
      key: index,
      className: joinClasses(styles$2f.bottomNavigationIcon, isCenterIcon && styles$2f.bottomNavigationIconCenter)
    }) : /*#__PURE__*/createElement("div", {
      className: styles$2f.bottomNavigationIcon
    }));
  })))));
};
BottomNavigation.displayName = 'BottomNavigation';

var styles$2g = {"image-plus-text":"fr-ec-image-plus-text","imagePlusText":"fr-ec-image-plus-text","image-plus-text__media":"fr-ec-image-plus-text__media","imagePlusTextMedia":"fr-ec-image-plus-text__media","image-plus-text__title":"fr-ec-image-plus-text__title","imagePlusTextTitle":"fr-ec-image-plus-text__title","image-plus-text__wrapper":"fr-ec-image-plus-text__wrapper","imagePlusTextWrapper":"fr-ec-image-plus-text__wrapper"};

var ImagePlusText = function ImagePlusText(_a) {
  var _b = _a.variant,
      variant = _b === void 0 ? 'carouselGrid' : _b,
      media = _a.media,
      title = _a.title,
      description = _a.description,
      className = _a.className,
      props = __rest(_a, ["variant", "media", "title", "description", "className"]);

  var renderComponent = function renderComponent() {
    if (variant === 'classCategoryItem') {
      return /*#__PURE__*/createElement(ContentAlignment, __assign({
        direction: "column",
        element: "div",
        className: joinClasses(className, styles$2g.imagePlusText)
      }, props), media, title && /*#__PURE__*/createElement(Caption, {
        variant: "standard",
        element: "span",
        wordBreak: "break-word",
        className: styles$2g.imagePlusTextTitle
      }, title));
    }

    return /*#__PURE__*/createElement(ContentAlignment, __assign({
      direction: "column",
      element: "div",
      className: joinClasses(className, styles$2g.imagePlusText)
    }, props), media, /*#__PURE__*/createElement("div", {
      className: styles$2g.imagePlusTextWrapper
    }, title && /*#__PURE__*/createElement(Title, {
      variant: "small",
      element: "div",
      wordBreak: "break-word",
      className: spacingStyles.mtSpacing03
    }, title), description && /*#__PURE__*/createElement(Caption, {
      variant: "small",
      color: "secondary",
      element: "div",
      wordBreak: "break-word",
      className: spacingStyles.mtSpacing01
    }, description)));
  };

  return /*#__PURE__*/createElement(Fragment, null, renderComponent());
};
ImagePlusText.displayName = 'CoreImagePlusText';

var styles$2h = {"link":"fr-ec-link","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","link--default":"fr-ec-link--default","linkDefault":"fr-ec-link--default","link--fill":"fr-ec-link--fill","linkFill":"fr-ec-link--fill"};

var Link = function Link(_a) {
  var _b = _a.element,
      Element = _b === void 0 ? 'a' : _b,
      url = _a.url,
      _c = _a.gaCategory,
      gaCategory = _c === void 0 ? '' : _c,
      _d = _a.gaLabel,
      gaLabel = _d === void 0 ? '' : _d,
      gaAction = _a.gaAction,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      target = _a.target,
      className = _a.className,
      _e = _a.variant,
      variant = _e === void 0 ? 'default' : _e,
      onClick = _a.onClick,
      _f = _a.activeTabName,
      activeTabName = _f === void 0 ? '' : _f,
      props = __rest(_a, ["element", "url", "gaCategory", "gaLabel", "gaAction", "gaValue", "gaCallback", "target", "className", "variant", "onClick", "activeTabName"]);

  var absoluteUrlPattern = isAbsoluteUrl(url);
  var attributes = {};

  if (absoluteUrlPattern) {
    attributes = {
      href: url,
      target: target || '_blank'
    };
  } else if (url) {
    Element = Link$1; // Default target behaviour of Link is similar to that of '_self'.
    // But if you specify target property explicitly, it refreshes the page.
    // @ts-ignore

    attributes.to = url;

    if (target && target !== '_self') {
      // @ts-ignore
      attributes.target = target;
    }
  }

  var onClickHandler = function onClickHandler(e) {
    // For callback
    if (onClick) {
      onClick(e, activeTabName);
    } // For event tracking


    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel, gaAction);
    }
  };

  var gaProps = null;

  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };

    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }

  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign({
      tabIndex: 0,
      className: joinClasses(styles$2h.link, Element === 'button' && resetStyles.buttonReset, styles$2h["link--" + variant], interactionsStyles.cursorPointer, className),
      href: url,
      onClick: onClickHandler
    }, gaProps, attributes, props))
  );
};
Link.displayName = 'CoreLink';
Link.defaultProps = {
  activeTabName: '',
  element: 'a',
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null,
  variant: 'default'
};

var styles$2i = {"category-list":"fr-ec-category-list","categoryList":"fr-ec-category-list","category-list__children":"fr-ec-category-list__children","categoryListChildren":"fr-ec-category-list__children"};

var CategoryList = function CategoryList(_a) {
  var children = _a.children,
      className = _a.className,
      props = __rest(_a, ["children", "className"]);

  var childrenWithProps = Children.toArray(children).filter(isValidElement).map(function (child, index) {
    return /*#__PURE__*/createElement(Fragment, {
      key: index
    }, child);
  });
  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(className, styles$2i.categoryList)
  }, props), /*#__PURE__*/createElement("div", {
    className: styles$2i.categoryListChildren
  }, childrenWithProps));
};
CategoryList.displayName = 'CoreCategoryList';

var styles$2j = {"class-item":"fr-ec-class-item","classItem":"fr-ec-class-item"};

var ClassItem = function ClassItem(_a) {
  var content = _a.content,
      children = _a.children,
      onClassItemClick = _a.onClassItemClick,
      gaCategory = _a.gaCategory,
      gaLabel = _a.gaLabel,
      gaCallback = _a.gaCallback,
      gaAction = _a.gaAction,
      gaValue = _a.gaValue,
      className = _a.className,
      childIndex = _a.childIndex,
      props = __rest(_a, ["content", "children", "onClassItemClick", "gaCategory", "gaLabel", "gaCallback", "gaAction", "gaValue", "className", "childIndex"]);

  var gaProps = null;

  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };

    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }

  var handleClassItemClick = function handleClassItemClick(event) {
    if (onClassItemClick) {
      onClassItemClick(childIndex, content.props.title, children);
    }

    if (gaCallback) {
      gaCallback(event.currentTarget, gaLabel, gaAction);
    }
  };

  return /*#__PURE__*/createElement("div", __assign({
    role: "button",
    className: joinClasses(className, styles$2j.classItem)
  }, props, gaProps, {
    onClick: handleClassItemClick
  }), content);
};
ClassItem.displayName = 'CoreClassItem';
ClassItem.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var styles$2k = {"class-list":"fr-ec-class-list","classList":"fr-ec-class-list","class-list__children":"fr-ec-class-list__children","classListChildren":"fr-ec-class-list__children","class-list__item-back-wrapper":"fr-ec-class-list__item-back-wrapper","classListItemBackWrapper":"fr-ec-class-list__item-back-wrapper","button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon","class-list__item-wrapper":"fr-ec-class-list__item-wrapper","classListItemWrapper":"fr-ec-class-list__item-wrapper"};

var ClassList = function ClassList(_a) {
  var children = _a.children,
      className = _a.className,
      props = __rest(_a, ["children", "className"]);

  var _b = useState(null),
      currentIndex = _b[0],
      setCurrentIndex = _b[1];

  var _c = useState(null),
      clickedItemContent = _c[0],
      setClickedItemContent = _c[1];

  var _d = useState(''),
      title = _d[0],
      setTitle = _d[1];

  var onClassItemClick = function onClassItemClick(index, titleText, content) {
    setCurrentIndex(index);
    setClickedItemContent(content);
    setTitle(titleText);
  };

  var onBackArrowClick = function onBackArrowClick() {
    setCurrentIndex(null);
  };

  var childrenWithProps = Children.toArray(children).filter(isValidElement).map(function (child, index) {
    return /*#__PURE__*/createElement(Fragment, {
      key: index
    }, /*#__PURE__*/cloneElement(child, {
      childIndex: index,
      onClassItemClick: onClassItemClick
    }));
  });

  if (currentIndex === null) {
    return /*#__PURE__*/createElement("div", __assign({
      className: joinClasses(className, styles$2k.classList)
    }, props), /*#__PURE__*/createElement("div", {
      className: styles$2k.classListChildren
    }, childrenWithProps));
  } else {
    return /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
      className: styles$2k.classListItemBackWrapper
    }, /*#__PURE__*/createElement(ButtonIcon, {
      element: "button",
      onClick: onBackArrowClick,
      hideLabel: true,
      label: 'back',
      icon: "chevron-left",
      title: "",
      variant: "dark"
    }), /*#__PURE__*/createElement(Display, {
      element: "h1",
      variant: "display4"
    }, title)), clickedItemContent);
  }
};
ClassList.displayName = 'CoreClassList';

var styles$2l = {"vertical-scroll":"fr-ec-vertical-scroll","verticalScroll":"fr-ec-vertical-scroll","vertical-container":"fr-ec-vertical-container","verticalContainer":"fr-ec-vertical-container","swiper-slide":"fr-ec-swiper-slide","swiperSlide":"fr-ec-swiper-slide","swiper-container-vertical":"fr-ec-swiper-container-vertical","swiperContainerVertical":"fr-ec-swiper-container-vertical","swiper-pagination-bullets":"fr-ec-swiper-pagination-bullets","swiperPaginationBullets":"fr-ec-swiper-pagination-bullets","swiper-vertical-pagination-bullet":"fr-ec-swiper-vertical-pagination-bullet","swiperVerticalPaginationBullet":"fr-ec-swiper-vertical-pagination-bullet","swiper-vertical-pagination-bullet-active":"fr-ec-swiper-vertical-pagination-bullet-active","swiperVerticalPaginationBulletActive":"fr-ec-swiper-vertical-pagination-bullet-active","swiper-container":"fr-ec-swiper-container","swiperContainer":"fr-ec-swiper-container","vertical-scroll-wrapper":"fr-ec-vertical-scroll-wrapper","verticalScrollWrapper":"fr-ec-vertical-scroll-wrapper","vertical-scroll-with-overflow":"fr-ec-vertical-scroll-with-overflow","verticalScrollWithOverflow":"fr-ec-vertical-scroll-with-overflow","vertical-scroll-without-overflow":"fr-ec-vertical-scroll-without-overflow","verticalScrollWithoutOverflow":"fr-ec-vertical-scroll-without-overflow"};

var VerticalScroll =
/** @class */
function (_super) {
  __extends(VerticalScroll, _super);

  function VerticalScroll(props) {
    var _this = _super.call(this, props) || this;

    _this.enableSwiper = function () {
      _this.swiperInstance.mousewheel.enable();

      _this.swiperInstance.allowTouchMove = true;

      _this.swiperInstance.keyboard.enable();

      _this.scrollTopValue = window.pageYOffset;
    };

    _this.componentDidUpdate = function (prevProps) {
      if (_this.swiperInstance) {
        if (prevProps.resetTrigger !== _this.props.resetTrigger) {
          _this.swiperInstance.slideTo(0);

          _this.enableSwiper();
        }

        _this.swiperInstance.update();
      }
    };

    _this.componentWillUnmount = function () {
      if (isInBrowser$1()) {
        document.getElementsByTagName('body')[0].style.overflow = '';
        document.getElementsByTagName('body')[0].classList.remove(styles$2l.verticalScrollWithOverflow, styles$2l.verticalScrollWithoutOverflow);
      }
    };

    _this.reSizeHandler = function () {
      if (_this.swiperRef.current) {
        var headerElem = document.querySelector(_this.headerClassName);

        _this.setState({
          headerHeight: headerElem && headerElem.offsetHeight || 0,
          isReRender: !_this.state.isReRender
        });

        _this.swiperInstance.update();
      }
    };

    _this.beforeResize = function () {
      if (getOS() === 'iOS' && getCurrentMediaQueryBreakpoint() === 'sm' && _this.swiperInstance.swipeDirection && _this.swiperInstance.swipeDirection === 'next') {
        _this.setState({
          isIosScrollResize: true
        });
      }
    };

    _this.onSlideTransitionEnd = function () {
      if (_this.state.isIosScrollResize) {
        _this.setState({
          isIosScrollResize: false
        });
      }
    };

    _this.onSlideChange = function () {
      var swiperInstance = _this.swiperInstance;

      if (swiperInstance) {
        var activeSlide_1 = swiperInstance.activeIndex;
        var prevSlide = swiperInstance.previousIndex;
        var slideWrapper = Array.from(swiperInstance.$wrapperEl)[0];
        var slides_1 = Array.from(swiperInstance.slides || []);
        var videos = Array.from(slideWrapper.getElementsByTagName('video') || []);

        _this.setState({
          activeSection: activeSlide_1
        });

        videos.forEach(function (video, index) {
          video.muted = true; // eslint-disable-line no-param-reassign

          var isVisible = slides_1[activeSlide_1].contains(video);

          if (video.readyState !== 0) {
            if (!isVisible) {
              video.pause();
            } else if (video.paused) {
              video.classList.remove('played');
              video.play();
            }
          }
        });

        if (prevSlide === slides_1.length - 1) {
          setTimeout(function () {
            document.getElementsByTagName('body')[0].style.overflow = 'hidden';
            document.getElementsByTagName('body')[0].classList.remove(styles$2l.verticalScrollWithOverflow);
            document.getElementsByTagName('body')[0].classList.add(styles$2l.verticalScrollWithoutOverflow);
          }, 1000);
        }

        var wDelta = prevSlide < activeSlide_1 ? 'down' : 'up';

        if (wDelta === 'down' && window.innerHeight - _this.state.headerHeight > swiperInstance.height || wDelta === 'up' && swiperInstance.height > window.innerHeight - _this.state.headerHeight) {
          _this.setState({
            isReRender: !_this.state.isReRender
          });

          swiperInstance.update();
        }
      }
    };

    _this.swiperRef = /*#__PURE__*/createRef();
    _this.swiperSlideRef = [];
    _this.swiperInstance = null;
    _this.scrollTopValue = 0;
    _this.headerClassName = '.fr-ec-cms-promotion-banner--back-ground-black';
    _this.state = {
      activeSection: 0,
      headerHeight: 0,
      isIosScrollResize: false,
      isReRender: false
    };
    return _this;
  }

  VerticalScroll.prototype.componentDidMount = function () {
    var _this = this;

    document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    document.getElementsByTagName('body')[0].classList.add(styles$2l.verticalScrollWithoutOverflow);
    setTimeout(function () {
      window.scrollTo(0, 0);
    }, 2000);
    var headerElem = document.querySelector(this.headerClassName);
    this.setState({
      headerHeight: headerElem && headerElem.offsetHeight || 0
    });
    this.swiperInstance = new swiper(this.swiperRef.current, {
      centeredSlides: true,
      direction: 'vertical',
      keyboard: {
        enabled: true,
        onlyInViewport: false
      },
      loop: true,
      mousewheel: {
        forceToAxis: true,
        invert: true,
        releaseOnEdges: true
      },
      on: {
        beforeResize: function beforeResize() {
          return _this.beforeResize();
        },
        slideChange: function slideChange() {
          return _this.onSlideChange();
        },
        slideNextTransitionEnd: function slideNextTransitionEnd() {
          return _this.onSlideTransitionEnd();
        },
        slidePrevTransitionEnd: function slidePrevTransitionEnd() {
          return _this.onSlideTransitionEnd();
        }
      },
      pagination: {
        bulletActiveClass: 'swiper-vertical-pagination-bullet-active',
        bulletClass: 'swiper-vertical-pagination-bullet',
        bulletElement: 'span',
        clickable: false,
        el: '.swiper-pagination-v',
        type: 'bullets'
      },
      releaseOnEdges: true,
      slidesPerView: 1,
      speed: getCurrentMediaQueryBreakpoint() === 'lg' ? 800 : 400,
      touchReleaseOnEdges: true
    }); // initialise the overflow condition to hidden.

    if (isInBrowser$1()) {
      window.addEventListener('resize', this.reSizeHandler);
    }

    if (document.getElementsByTagName('body')[0] && this.swiperRef.current) {
      var element = this.swiperRef.current.getBoundingClientRect();

      if (Math.round(element.bottom) === window.innerHeight + (headerElem && Math.round(headerElem.offsetHeight) || 73) && this.scrollTopValue === 0) {
        this.swiperInstance.mousewheel.enable();
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
        document.getElementsByTagName('body')[0].classList.add(styles$2l.verticalScrollWithoutOverflow);
        this.swiperInstance.allowTouchMove = true;
        this.swiperInstance.keyboard.enable();
      }
    }
  };

  VerticalScroll.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        className = _a.className,
        gaLabel = _a.gaLabel,
        gaCategory = _a.gaCategory,
        props = __rest(_a, ["children", "className", "gaLabel", "gaCategory"]);

    var _b = this.state,
        headerHeight = _b.headerHeight,
        activeSection = _b.activeSection;
    var childrenWithProps = Children.toArray(children).filter(isValidElement).map(function (child, index) {
      return /*#__PURE__*/createElement("div", {
        key: index,
        className: joinClasses('swiper-slide'),
        ref: function ref(_ref) {
          return _this.swiperSlideRef[index] = _ref;
        }
      }, /*#__PURE__*/cloneElement(child, {
        parentActiveIndex: activeSection,
        parentGaCategory: 'L1'
      }));
    });
    var gaProps = null;

    if (gaCategory && gaLabel) {
      gaProps = {
        'data-category': gaCategory,
        'data-label': gaLabel
      };
    }

    return /*#__PURE__*/createElement("div", __assign({
      className: joinClasses(styles$2l.verticalScrollWrapper, className)
    }, gaProps, props), /*#__PURE__*/createElement("div", {
      style: {
        position: 'relative'
      }
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$2l.verticalScroll, className),
      style: {
        height: "calc(100vh - " + headerHeight + "px)"
      }
    }, /*#__PURE__*/createElement("div", {
      ref: this.swiperRef,
      className: joinClasses(styles$2l.verticalContainer, 'swiper-container-v', className)
    }, /*#__PURE__*/createElement("div", {
      className: "swiper-wrapper"
    }, childrenWithProps), /*#__PURE__*/createElement("div", {
      className: joinClasses('swiper-pagination', 'swiper-pagination-v')
    })))));
  };

  VerticalScroll.displayName = 'CoreVerticalScroll';
  return VerticalScroll;
}(Component);

var styles$2m = {"template-navigation-gender-tab":"fr-ec-template-navigation-gender-tab","templateNavigationGenderTab":"fr-ec-template-navigation-gender-tab","tabs":"fr-ec-tabs","template-navigation__bottom-nav-container":"fr-ec-template-navigation__bottom-nav-container","templateNavigationBottomNavContainer":"fr-ec-template-navigation__bottom-nav-container","bottom-navigation":"fr-ec-bottom-navigation","bottomNavigation":"fr-ec-bottom-navigation","cms-smart-banner":"fr-ec-cms-smart-banner","cmsSmartBanner":"fr-ec-cms-smart-banner"};

var TemplateNavigation = function TemplateNavigation(_a) {
  var navigationHeaderSection = _a.navigationHeaderSection,
      genderTabSection = _a.genderTabSection,
      bottomNavigationSection = _a.bottomNavigationSection,
      smartBannerSection = _a.smartBannerSection,
      className = _a.className,
      props = __rest(_a, ["navigationHeaderSection", "genderTabSection", "bottomNavigationSection", "smartBannerSection", "className"]);

  var _b = useState(getCurrentMediaQueryBreakpoint()),
      screenSize = _b[0],
      setScreenSize = _b[1];

  useEffect(function () {
    window.addEventListener('resize', onResize);
    updateTabPosition();
  }, []);

  var updateTabPosition = function updateTabPosition() {
    var _a;

    if (isInBrowser$1()) {
      var navheaderClasses = document.getElementsByClassName('fr-ec-template-navigation-nav-header');
      var tabgroupHeaderClasses = document.getElementsByClassName('fr-ec-tabs');
      var navHeader = document.getElementsByClassName('fr-ec-navigation-header');
      var navheaderClass = navheaderClasses[0];
      var tabGroupHeaderClass = tabgroupHeaderClasses[0];

      if (navheaderClass && tabGroupHeaderClass && navHeader) {
        var isSticky = (_a = navHeader[0]) === null || _a === void 0 ? void 0 : _a.classList.contains('fr-ec-navigation-header--with-sticky');

        if (getCurrentMediaQueryBreakpoint() === 'sm') {
          tabGroupHeaderClass.style.top = '';
          tabGroupHeaderClass.style.left = '';
        } else {
          tabGroupHeaderClass.style.top = navheaderClass.getBoundingClientRect().top + (navheaderClass.getBoundingClientRect().height - tabGroupHeaderClass.getBoundingClientRect().height) + "px";
          tabGroupHeaderClass.style.left = navheaderClass.getBoundingClientRect().left + navheaderClass.getBoundingClientRect().width / 4 + "px";

          if (isSticky) {
            tabGroupHeaderClass.style.position = 'fixed';
          }
        }
      }
    }
  };

  var onResize = function onResize() {
    setScreenSize(getCurrentMediaQueryBreakpoint());
    updateTabPosition();
  };

  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(LayoutWrapper, __assign({
    className: className,
    element: "section"
  }, props), /*#__PURE__*/createElement(Layout, {
    className: 'fr-ec-template-navigation-nav-header',
    gutter: {
      sm: false,
      md: false,
      lg: false
    },
    visible: {
      sm: true,
      md: true,
      lg: true
    }
  }, navigationHeaderSection), /*#__PURE__*/createElement(Layout, {
    className: screenSize === 'sm' ? '' : styles$2m.templateNavigationGenderTab,
    gutter: {
      sm: false,
      md: false,
      lg: false
    },
    visible: {
      sm: true,
      md: true,
      lg: true
    },
    colSpan: {
      sm: 4,
      md: 12,
      lg: 12
    }
  }, genderTabSection)), /*#__PURE__*/createElement("div", {
    className: styles$2m.templateNavigationBottomNavContainer
  }, bottomNavigationSection, smartBannerSection));
};
TemplateNavigation.displayName = 'TemplateNavigation';

var styles$2n = {"tabs":"fr-ec-tabs","tabs__content":"fr-ec-tabs__content","tabsContent":"fr-ec-tabs__content","tabs__black":"fr-ec-tabs__black","tabsBlack":"fr-ec-tabs__black"};

var Tabs =
/** @class */
function (_super) {
  __extends(Tabs, _super);

  function Tabs(props) {
    var _this = _super.call(this, props) || this;

    _this.onClick = function (label, index, child, tabOnclick) {
      return function (event, activeTabLabel) {
        _this.setState({
          activeTabId: index,
          activeTabLabel: activeTabLabel
        });

        if (tabOnclick) {
          tabOnclick(event, label, index, child);
        }
      };
    };

    var tabChilds = Children.toArray(props.children).filter(isValidElement);
    var activeChild = tabChilds.find(function (tabItem, index) {
      return Boolean(tabItem.props && index === _this.props.defaultIndex);
    }) || tabChilds[0];
    var activeChildProps = activeChild ? activeChild.props : {};
    var activeChildWithLabel = tabChilds.find(function (tabItem) {
      return Boolean(tabItem.props && tabItem.props.isActive);
    }) || tabChilds[0];
    var activeChildWithLabelProps = activeChildWithLabel ? activeChildWithLabel.props : {};
    _this.state = {
      activeTabId: activeChildProps.index ? activeChildProps.index : 0,
      activeTabLabel: activeChildWithLabelProps.label
    };
    return _this;
  }

  Tabs.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.defaultIndex !== this.props.defaultIndex) {
      this.setState({
        activeTabId: Number(this.props.defaultIndex)
      });
    }
  };

  Tabs.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        className = _a.className,
        id = _a.id,
        _b = _a.type,
        type = _b === void 0 ? 'black' : _b;
    var _c = this.state,
        activeTabId = _c.activeTabId,
        activeTabLabel = _c.activeTabLabel;
    var activeContent = null;
    var childrenWithProps = Children.toArray(children).filter(isValidElement).map(function (child, index) {
      var tabLabel = child.props.label;

      if (child.props.isActive !== undefined ? child.props.label === activeTabLabel : child.props.index === activeTabId) {
        activeContent = child.props.children;
      }

      return /*#__PURE__*/cloneElement(child, {
        isActive: child.props.isActive !== undefined ? child.props.label === activeTabLabel : child.props.index === activeTabId,
        key: tabLabel.toUpperCase(),
        label: tabLabel,
        onClick: _this.onClick(tabLabel, child.props.index, child, child.props.onClick),
        textTransform: 'all-caps',
        type: type === 'black' ? 'black' : 'white',
        variant: 'gender'
      });
    });
    var childrenWithPropsWrapper = /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$2n.tabs, className, type === 'black' && styles$2n.tabsBlack),
      role: "tablist"
    }, childrenWithProps);
    return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Fragment, {
      key: id
    }, childrenWithPropsWrapper, /*#__PURE__*/createElement("div", {
      role: "tabpanel",
      className: styles$2n.tabsContent
    }, activeContent)));
  };

  Tabs.displayName = 'CoreTabs';
  Tabs.defaultProps = {
    defaultIndex: 0
  };
  return Tabs;
}(Component);

var styles$2o = {"vertical-scroll-group":"fr-ec-vertical-scroll-group","verticalScrollGroup":"fr-ec-vertical-scroll-group","tabs":"fr-ec-tabs","floating-ticker-wrapper":"fr-ec-floating-ticker-wrapper","floatingTickerWrapper":"fr-ec-floating-ticker-wrapper"};

var VerticalScrollGroup = function VerticalScrollGroup(_a) {
  var children = _a.children,
      genderTabs = _a.genderTabs,
      defaultIndex = _a.defaultIndex,
      floatingTickers = _a.floatingTickers,
      gaCategory = _a.gaCategory,
      gaLabel = _a.gaLabel;
  var TabWithVerticalScrolls = children && genderTabs && children.map(function (child, index) {
    return /*#__PURE__*/cloneElement(genderTabs[index], {
      children: child,
      isActive: genderTabs[index].props.isActive,
      key: index,
      label: genderTabs[index].props.label,
      type: genderTabs[index].props.type
    });
  });
  var tabs = genderTabs && /*#__PURE__*/createElement(Tabs, {
    variant: "gender",
    children: TabWithVerticalScrolls,
    type: "white",
    defaultIndex: defaultIndex
  });
  var gaProps = null;

  if (gaCategory && gaLabel) {
    gaProps = {
      'data-category': gaCategory,
      'data-label': gaLabel
    };
  }

  return /*#__PURE__*/createElement("div", __assign({
    className: styles$2o.verticalScrollGroup
  }, gaProps), tabs, /*#__PURE__*/createElement(LayoutWrapper, {
    element: "div"
  }, /*#__PURE__*/createElement(GutterContainer, null, /*#__PURE__*/createElement("div", {
    className: styles$2o.floatingTickerWrapper
  }, floatingTickers))));
};
VerticalScrollGroup.displayName = 'CoreVerticalScrollGroup';

var styles$2p = {"template-home":"fr-ec-template-home","templateHome":"fr-ec-template-home","template-home--with-promotion-banner":"fr-ec-template-home--with-promotion-banner","templateHomeWithPromotionBanner":"fr-ec-template-home--with-promotion-banner","navigation-header--variant-ecrenewal":"fr-ec-navigation-header--variant-ecrenewal","navigationHeaderVariantEcrenewal":"fr-ec-navigation-header--variant-ecrenewal","navigation-header--with-sticky":"fr-ec-navigation-header--with-sticky","navigationHeaderWithSticky":"fr-ec-navigation-header--with-sticky","template-home--navigation-header-wrapper":"fr-ec-template-home--navigation-header-wrapper","templateHomeNavigationHeaderWrapper":"fr-ec-template-home--navigation-header-wrapper","tabs":"fr-ec-tabs","media-banner":"fr-ec-media-banner","mediaBanner":"fr-ec-media-banner","template-home--with-smart-banner":"fr-ec-template-home--with-smart-banner","templateHomeWithSmartBanner":"fr-ec-template-home--with-smart-banner","bottom-navigation-wrapper":"fr-ec-bottom-navigation-wrapper","bottomNavigationWrapper":"fr-ec-bottom-navigation-wrapper","floating-ticker-wrapper":"fr-ec-floating-ticker-wrapper","floatingTickerWrapper":"fr-ec-floating-ticker-wrapper"};

var TemplateHome = function TemplateHome(_a) {
  var bottomNavigationSection = _a.bottomNavigationSection,
      className = _a.className,
      navigationHeaderSection = _a.navigationHeaderSection,
      promotionBannerSection = _a.promotionBannerSection,
      smartBannerSection = _a.smartBannerSection,
      verticalScrollGroupSection = _a.verticalScrollGroupSection,
      props = __rest(_a, ["bottomNavigationSection", "className", "navigationHeaderSection", "promotionBannerSection", "smartBannerSection", "verticalScrollGroupSection"]);

  return /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$2p.templateHome, promotionBannerSection && styles$2p.templateHomeWithPromotionBanner, smartBannerSection && styles$2p.templateHomeWithSmartBanner)
  }, promotionBannerSection, /*#__PURE__*/createElement(LayoutWrapper, __assign({
    className: joinClasses(className, styles$2p.templateHomeNavigationHeaderWrapper),
    element: "section"
  }, props), /*#__PURE__*/createElement(Layout, {
    className: "fr-ec-template-navigation-nav-header",
    gutter: {
      sm: false,
      md: false,
      lg: false
    },
    visible: {
      sm: true,
      md: true,
      lg: true
    }
  }, navigationHeaderSection)), verticalScrollGroupSection, bottomNavigationSection, smartBannerSection);
};
TemplateHome.displayName = 'CoreTemplateHome';

var styles$2q = {"no-image":"fr-ec-no-image","noImage":"fr-ec-no-image","no-image__video":"fr-ec-no-image__video","noImageVideo":"fr-ec-no-image__video","no-image__icon":"fr-ec-no-image__icon","noImageIcon":"fr-ec-no-image__icon","no-image__icon--video":"fr-ec-no-image__icon--video","noImageIconVideo":"fr-ec-no-image__icon--video","no-image__label":"fr-ec-no-image__label","noImageLabel":"fr-ec-no-image__label","no-image__label--label-only":"fr-ec-no-image__label--label-only","noImageLabelLabelOnly":"fr-ec-no-image__label--label-only","no-image__label--large":"fr-ec-no-image__label--large","noImageLabelLarge":"fr-ec-no-image__label--large","no-image__video-label":"fr-ec-no-image__video-label","noImageVideoLabel":"fr-ec-no-image__video-label","no-image__video-subtitle":"fr-ec-no-image__video-subtitle","noImageVideoSubtitle":"fr-ec-no-image__video-subtitle","no-image__icon--user":"fr-ec-no-image__icon--user","noImageIconUser":"fr-ec-no-image__icon--user"};

var NoImage = function NoImage(_a) {
  var _b = _a.imageType,
      imageType = _b === void 0 ? 'normal' : _b,
      _c = _a.noImageLabel,
      noImageLabel = _c === void 0 ? '' : _c,
      className = _a.className,
      _d = _a.imageSize,
      imageSize = _d === void 0 ? 'default' : _d,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["imageType", "noImageLabel", "className", "imageSize", "iconBrand"]);

  var noImageWrappeRef = useRef(null);

  var _e = useState(0),
      width = _e[0],
      setWidth = _e[1];

  useEffect(function () {
    if (noImageWrappeRef.current) {
      setWidth(noImageWrappeRef.current.offsetWidth);
    }
  }, []);

  var getTextSize = function getTextSize() {
    var textSize = width * 18 / 250;
    return textSize;
  };

  var noImageLabelStyle = getTextSize() !== 0 ? {
    fontSize: getTextSize() + "px"
  } : {};
  var breakPoint = getViewportWidth() > 600 ? 'largeAndMedium' : 'small';
  var getSize = {
    "default": '28%',
    euro: '13px',
    large: '20%',
    small: '48%',
    smallest: '56%'
  };

  var getIcons = function getIcons(imageTypes) {
    var iconName = {
      euro: 'euro',
      icon: 'prohibited',
      product: 'product'
    };
    return iconBrand ? "" + iconBrand + iconName[imageTypes] : "" + iconName[imageTypes];
  };

  switch (imageType) {
    case 'normal':
      return /*#__PURE__*/createElement("div", __assign({
        className: joinClasses(styles$2q.noImage, className)
      }, props));

    case 'labelonly':
      return /*#__PURE__*/createElement("div", {
        ref: noImageWrappeRef
      }, /*#__PURE__*/createElement(ContentAlignment, __assign({
        element: "div",
        justifyContent: "center",
        direction: "row",
        alignment: "center",
        className: joinClasses(styles$2q.noImage, className)
      }, props), (imageSize === 'large' || imageSize === 'default') && noImageLabel && (breakPoint === 'largeAndMedium' ? /*#__PURE__*/createElement(FlagText, {
        className: joinClasses(styles$2q.noImageLabelLabelOnly),
        variant: "large",
        element: "p",
        textAlign: "center",
        style: noImageLabelStyle
      }, noImageLabel) : /*#__PURE__*/createElement(FlagText, {
        className: joinClasses(styles$2q.noImageLabelLabelOnly),
        variant: "standard",
        element: "p",
        textAlign: "center",
        style: noImageLabelStyle
      }, noImageLabel))));

    case 'video':
      {
        return /*#__PURE__*/createElement("div", {
          ref: noImageWrappeRef
        }, /*#__PURE__*/createElement(ContentAlignment, __assign({
          element: "div",
          justifyContent: "center",
          direction: "column",
          alignment: "center",
          className: joinClasses(styles$2q.noImageVideo, className)
        }, props), /*#__PURE__*/createElement(Icon, {
          name: iconBrand ? iconBrand + "no-video" : 'no-video',
          className: joinClasses(styles$2q.noImageIcon, styles$2q.noImageIconVideo),
          size: getSize["default"]
        }), noImageLabel && typeof noImageLabel === 'string' && /*#__PURE__*/createElement(Body, {
          element: "p",
          className: joinClasses(styles$2q.noImageLabel, styles$2q.noImageLabelLarge),
          style: noImageLabelStyle
        }, noImageLabel), _typeof(noImageLabel) === 'object' && /*#__PURE__*/createElement(Fragment, null, noImageLabel.text_error_failed_to_get_pdp_movie && /*#__PURE__*/createElement("div", {
          className: styles$2q.noImageVideoLabel,
          style: noImageLabelStyle
        }, noImageLabel.text_error_failed_to_get_pdp_movie), noImageLabel.text_error_failed_to_get_pdp_movie_instruction_01 && /*#__PURE__*/createElement(Body, {
          element: "p",
          className: joinClasses(styles$2q.noImageLabel, styles$2q.noImageLabelLarge, styles$2q.noImageVideoSubtitle),
          style: noImageLabelStyle
        }, noImageLabel.text_error_failed_to_get_pdp_movie_instruction_01))));
      }

    case 'user':
      return /*#__PURE__*/createElement(ContentAlignment, __assign({
        element: "div",
        justifyContent: "center",
        direction: "row",
        alignment: "center",
        className: joinClasses(styles$2q.noImage, className)
      }, props), /*#__PURE__*/createElement("div", {
        className: joinClasses(styles$2q.noImageIcon)
      }, /*#__PURE__*/createElement("div", {
        className: styles$2q.noImageIconUser
      }, /*#__PURE__*/createElement("img", {
        src: "https://asset.uniqlo.com/g/pictures/user-profile.svg",
        alt: "user profile"
      }))));

    default:
      return /*#__PURE__*/createElement("div", {
        ref: noImageWrappeRef
      }, /*#__PURE__*/createElement(ContentAlignment, __assign({
        element: "div",
        justifyContent: "center",
        direction: "column",
        alignment: "center",
        className: joinClasses(styles$2q.noImage, className, 'test')
      }, props), /*#__PURE__*/createElement(Icon, {
        name: getIcons(imageType),
        className: styles$2q.noImageIcon,
        size: getSize[imageType === 'euro' ? 'euro' : imageSize]
      }), (imageSize === 'large' || imageSize === 'default') && noImageLabel && /*#__PURE__*/createElement(Body, {
        element: "p",
        className: joinClasses(styles$2q.noImageLabel, imageSize === 'large' && styles$2q.noImageLabelLarge),
        style: noImageLabelStyle
      }, noImageLabel)));
  }
};
NoImage.displayName = 'CoreNoImage';

var styles$1$3 = {"video-inline":"fr-ec-video-inline","videoInline":"fr-ec-video-inline","video-inline--with-poster-image":"fr-ec-video-inline--with-poster-image","videoInlineWithPosterImage":"fr-ec-video-inline--with-poster-image","video-inline--1x1":"fr-ec-video-inline--1x1","videoInline1X1":"fr-ec-video-inline--1x1","video-inline--2x1":"fr-ec-video-inline--2x1","videoInline2X1":"fr-ec-video-inline--2x1","video-inline--2x3":"fr-ec-video-inline--2x3","videoInline2X3":"fr-ec-video-inline--2x3","video-inline--3x1":"fr-ec-video-inline--3x1","videoInline3X1":"fr-ec-video-inline--3x1","video-inline--3x2":"fr-ec-video-inline--3x2","videoInline3X2":"fr-ec-video-inline--3x2","video-inline--3x4":"fr-ec-video-inline--3x4","videoInline3X4":"fr-ec-video-inline--3x4","video-inline--5x2":"fr-ec-video-inline--5x2","videoInline5X2":"fr-ec-video-inline--5x2","video-inline--16x9":"fr-ec-video-inline--16x9","videoInline16X9":"fr-ec-video-inline--16x9","video-inline__video":"fr-ec-video-inline__video","videoInlineVideo":"fr-ec-video-inline__video","poster-image":"fr-ec-poster-image","posterImage":"fr-ec-poster-image","controls":"fr-ec-controls","controls__progress-bar":"fr-ec-controls__progress-bar","controlsProgressBar":"fr-ec-controls__progress-bar","controls__progress-bar--fill":"fr-ec-controls__progress-bar--fill","controlsProgressBarFill":"fr-ec-controls__progress-bar--fill","button-icon--light":"fr-ec-button-icon--light","buttonIconLight":"fr-ec-button-icon--light"};

var CoreVideoInline = function CoreVideoInline(_a) {
  var _b = _a.src,
      src = _b === void 0 ? '' : _b,
      loop = _a.loop,
      _c = _a.posterImage,
      posterImage = _c === void 0 ? '' : _c,
      autoPlay = _a.autoPlay,
      muted = _a.muted,
      altText = _a.altText,
      className = _a.className,
      onInitialPlay = _a.onInitialPlay,
      onPlay = _a.onPlay,
      _d = _a.noVideoLabel,
      noVideoLabel = _d === void 0 ? '' : _d,
      _e = _a.videoRatio,
      videoRatio = _e === void 0 ? '2x1' : _e,
      _f = _a.videoType,
      videoType = _f === void 0 ? 'normal' : _f,
      progressBar = _a.progressBar,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["src", "loop", "posterImage", "autoPlay", "muted", "altText", "className", "onEnded", "onError", "onInitialPlay", "onPlay", "noVideoLabel", "videoRatio", "videoType", "progressBar", "iconBrand"]);

  var videoRef = React__default.useRef(null);
  var progressRef = React__default.useRef(null);

  var _g = React__default.useState(true),
      validPosterImage = _g[0],
      setValidPosterImage = _g[1];

  var _h = React__default.useState(false),
      inValidVideo = _h[0],
      setInValidVideo = _h[1];

  var _j = React__default.useState(true),
      showVideoProgressBar = _j[0],
      setVideoProgressBar = _j[1];

  var _k = React__default.useState(false),
      initialPlay = _k[0],
      setInitialPlay = _k[1];

  var _l = React__default.useState(false),
      isPlaying = _l[0],
      setIsPlaying = _l[1];

  var _m = React__default.useState(false),
      isEnded = _m[0],
      setIsEnded = _m[1];

  var usePrevious = function usePrevious(value) {
    var ref = React__default.useRef();
    React__default.useEffect(function () {
      ref.current = value;
    });
    return ref.current;
  };

  var previousSrc = usePrevious(src);
  React__default.useEffect(function () {
    var _a;

    if (videoRef.current && autoPlay && !muted) {
      videoRef.current.muted = true;
    }

    if (isInBrowser$1()) {
      window.addEventListener('scroll', debounce(100, handleScroll));
    }

    if (previousSrc !== src) {
      (_a = videoRef.current) === null || _a === void 0 ? void 0 : _a.load();
    }

    return function () {
      if (isInBrowser$1()) {
        window.removeEventListener('scroll', debounce(100, handleScroll));
      }
    };
  }, [videoRef, autoPlay, src]);

  var onVideoError = function onVideoError() {
    setVideoProgressBar(false); // networkState - Represents the current network state of the video element.
    // when it's value is 3 - no video source found.

    if (videoRef.current && videoRef.current.networkState === 3 && !inValidVideo && (!validPosterImage && videoType === 'normal' || videoType === 'product')) {
      setInValidVideo(true);
    }
  };

  var onVideoEnd = function onVideoEnd() {
    setIsEnded(true);

    if (videoRef.current) {
      if (validPosterImage || videoType !== 'product') {
        videoRef.current.autoplay = false;
      }

      videoRef.current.classList.add('played'); // Fix for IE to pause video on end for non looped videos

      if (!loop) {
        videoRef.current.pause();
      }
    }
  };

  var onPosterImageError = function onPosterImageError() {
    setValidPosterImage(!validPosterImage);
  };

  var checkViewport = function checkViewport(el) {
    var _a = el.getBoundingClientRect(),
        top = _a.top,
        left = _a.left,
        bottom = _a.bottom,
        right = _a.right,
        height = _a.height,
        width = _a.width;

    if (top + height > 0 && left + width > 0 && bottom - height < window.innerHeight && right - width < window.innerWidth) {
      return true;
    } else {
      return false;
    }
  };

  var handleScroll = function handleScroll() {
    if (videoRef.current && videoRef.current.readyState !== 0) {
      var hasPlayed = videoRef.current.classList.contains('played');
      var isVisible = checkViewport(videoRef.current);

      if (videoRef.current.networkState < 3 && !hasPlayed) {
        // To avoid the condition of video getting played on scroll(for videos with-out loop in carousel and image-gallery)
        if (isVisible) {
          if (videoRef.current.paused) {
            videoRef.current.play();
            videoRef.current.style.zIndex = '1';
          }
        } else if (!videoRef.current.paused) {
          videoRef.current.pause();
        }
      } else if (hasPlayed && !isVisible) {
        // To play the video while it is visible when scrolling, after showing the poster image.
        videoRef.current.classList.remove('played');
      }
    }
  };

  var onVideoPlay = function onVideoPlay(event) {
    setIsPlaying(true);
    setIsEnded(false);

    if (onPlay) {
      onPlay(event);
    }

    if (!initialPlay && onInitialPlay) {
      onInitialPlay(event);
      setInitialPlay(true);
    }
  };

  var ratioToStyle = {
    '1x1': styles$1$3.videoInline1X1,
    '2x1': styles$1$3.videoInline2X1,
    '2x3': styles$1$3.videoInline2X3,
    '3x1': styles$1$3.videoInline3X1,
    '3x2': styles$1$3.videoInline3X2,
    '3x4': styles$1$3.videoInline3X4,
    '5x2': styles$1$3.videoInline5X2,
    // tslint:disable-next-line: object-literal-sort-keys
    '16x9': styles$1$3.videoInline16X9
  };

  var onTimeUpdate = function onTimeUpdate(event) {
    var video = event.currentTarget;
    var currentPercentage = video.currentTime / video.duration * 100;

    if (progressRef.current) {
      progressRef.current.style.width = currentPercentage + "%";
    }
  };

  var videoSeek = function videoSeek(event) {
    var rect = event.currentTarget.getBoundingClientRect();
    var x = event.clientX - rect.left;
    var percentage = x / rect.width * 100;

    if (videoRef.current) {
      videoRef.current.currentTime = videoRef.current.duration / 100 * percentage;
    }
  };

  var videoPausePlay = function videoPausePlay() {
    if (videoRef.current) {
      if (videoRef.current.paused) {
        videoRef.current.play();
        setIsPlaying(true);
      } else {
        videoRef.current.pause();
        setIsPlaying(false);
      }
    }
  };

  return /*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(styles$1$3.videoInline, ratioToStyle[videoRatio], className, videoType === 'normal' && styles$1$3.videoInlineWithPosterImage),
    style: {
      backgroundImage: "url(" + posterImage + ")"
    }
  }, !inValidVideo ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("video", __assign({
    poster: 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 20 20"><rect fill="none" width="20" height="20" /></svg>',
    "aria-label": altText,
    controls: false,
    loop: loop,
    autoPlay: autoPlay,
    muted: muted,
    onEnded: onVideoEnd,
    className: styles$1$3.videoInlineVideo,
    ref: videoRef,
    onError: onVideoError,
    playsInline: true,
    preload: 'metadata',
    onPlay: onVideoPlay,
    onTimeUpdate: onTimeUpdate
  }, props), /*#__PURE__*/React__default.createElement("source", {
    type: "video/mp4",
    src: src
  }), altText), /*#__PURE__*/React__default.createElement("img", {
    src: posterImage,
    className: styles$1$3.posterImage,
    onError: onPosterImageError,
    alt: "poster-image"
  }), showVideoProgressBar && progressBar && /*#__PURE__*/React__default.createElement("div", {
    className: styles$1$3.controls
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$1$3.controlsProgressBar,
    onClick: function onClick(e) {
      return videoSeek(e);
    },
    role: "progressbar"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles$1$3.controlsProgressBarFill,
    ref: progressRef
  })), /*#__PURE__*/React__default.createElement(ButtonIcon, {
    element: 'button',
    icon: isPlaying && !isEnded ? 'pause' : 'play',
    label: "",
    variant: "light",
    onClick: function onClick() {
      return videoPausePlay();
    },
    iconBrand: iconBrand
  }))) : /*#__PURE__*/React__default.createElement(NoImage, {
    imageType: 'video',
    noImageLabel: noVideoLabel,
    iconBrand: iconBrand
  }));
};

var VideoInline = function VideoInline(_a) {
  var src = _a.src,
      posterImage = _a.posterImage,
      videoRatio = _a.videoRatio,
      smallMediumVideoUrl = _a.smallMediumVideoUrl,
      largeVideoUrl = _a.largeVideoUrl,
      smallMediumPosterImage = _a.smallMediumPosterImage,
      largePosterImage = _a.largePosterImage,
      smallMediumVideoRatio = _a.smallMediumVideoRatio,
      largeVideoRatio = _a.largeVideoRatio,
      altText = _a.altText,
      loop = _a.loop,
      height = _a.height,
      className = _a.className,
      videoWidth = _a.width,
      progressBar = _a.progressBar,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["src", "posterImage", "videoRatio", "smallMediumVideoUrl", "largeVideoUrl", "smallMediumPosterImage", "largePosterImage", "smallMediumVideoRatio", "largeVideoRatio", "altText", "loop", "height", "className", "width", "progressBar", "iconBrand"]);

  var width = getViewportWidth();
  var isWidthLessthanLargeDevicewidth = width < designTokens_3.mqMediumScreenMaxWidthLimit;
  var smallMediumVideoUrlValue = src || smallMediumVideoUrl || largeVideoUrl || '';
  var largeVideoUrlValue = src || largeVideoUrl || smallMediumVideoUrl || '';
  var smallMediumVideoRatioValue = videoRatio || smallMediumVideoRatio || largeVideoRatio || '1x1';
  var largeVideoValue = videoRatio || largeVideoRatio || smallMediumVideoRatio || '2x1';
  var largePosterImageValue = posterImage || largePosterImage || smallMediumPosterImage || '';
  var smallMediumPosterImageValue = posterImage || smallMediumPosterImage || largePosterImage || '';

  if (isWidthLessthanLargeDevicewidth || src) {
    return /*#__PURE__*/React__default.createElement(CoreVideoInline, __assign({
      key: 0,
      loop: loop,
      src: smallMediumVideoUrlValue,
      posterImage: smallMediumPosterImageValue,
      autoPlay: true,
      muted: true,
      altText: altText,
      videoRatio: smallMediumVideoRatioValue,
      className: className,
      width: videoWidth,
      height: height,
      progressBar: progressBar,
      iconBrand: iconBrand
    }, props));
  } else {
    return /*#__PURE__*/React__default.createElement(CoreVideoInline, __assign({
      key: 1,
      loop: loop,
      src: largeVideoUrlValue,
      posterImage: largePosterImageValue,
      autoPlay: true,
      muted: true,
      altText: altText,
      width: videoWidth,
      height: height,
      className: className,
      videoRatio: largeVideoValue,
      progressBar: progressBar,
      iconBrand: iconBrand
    }, props));
  }
};
VideoInline.displayName = 'CoreVideoInline';
VideoInline.defaultProps = {
  autoPlay: true,
  loop: true,
  muted: true
};

var styles$2$1 = {"media-carousel":"fr-ec-media-carousel","mediaCarousel":"fr-ec-media-carousel","media-carousel__navigation-btn":"fr-ec-media-carousel__navigation-btn","mediaCarouselNavigationBtn":"fr-ec-media-carousel__navigation-btn","media-carousel-arrow-container--with-pinch-zoom":"fr-ec-media-carousel-arrow-container--with-pinch-zoom","mediaCarouselArrowContainerWithPinchZoom":"fr-ec-media-carousel-arrow-container--with-pinch-zoom","pagination-pinch-zoom-wrapper":"fr-ec-pagination-pinch-zoom-wrapper","paginationPinchZoomWrapper":"fr-ec-pagination-pinch-zoom-wrapper","swiper-pagination-pinch-zoom":"fr-ec-swiper-pagination-pinch-zoom","swiperPaginationPinchZoom":"fr-ec-swiper-pagination-pinch-zoom","swiper-current-slide":"fr-ec-swiper-current-slide","swiperCurrentSlide":"fr-ec-swiper-current-slide","swiper-total-slide":"fr-ec-swiper-total-slide","swiperTotalSlide":"fr-ec-swiper-total-slide","swiper-slash":"fr-ec-swiper-slash","swiperSlash":"fr-ec-swiper-slash","pinch-zoom-carousel-close":"fr-ec-pinch-zoom-carousel-close","pinchZoomCarouselClose":"fr-ec-pinch-zoom-carousel-close","hide-pagination-pinch-zoom":"fr-ec-hide-pagination-pinch-zoom","hidePaginationPinchZoom":"fr-ec-hide-pagination-pinch-zoom","media-carousel__pagination":"fr-ec-media-carousel__pagination","mediaCarouselPagination":"fr-ec-media-carousel__pagination","media-carousel__pagination-overlay":"fr-ec-media-carousel__pagination-overlay","mediaCarouselPaginationOverlay":"fr-ec-media-carousel__pagination-overlay","media-carousel__button-prev":"fr-ec-media-carousel__button-prev","mediaCarouselButtonPrev":"fr-ec-media-carousel__button-prev","media-carousel__button-next":"fr-ec-media-carousel__button-next","mediaCarouselButtonNext":"fr-ec-media-carousel__button-next","media-carousel__navigation-btn-label":"fr-ec-media-carousel__navigation-btn-label","mediaCarouselNavigationBtnLabel":"fr-ec-media-carousel__navigation-btn-label","media-carousel__icon":"fr-ec-media-carousel__icon","mediaCarouselIcon":"fr-ec-media-carousel__icon","media-carousel__pause-icon":"fr-ec-media-carousel__pause-icon","mediaCarouselPauseIcon":"fr-ec-media-carousel__pause-icon","media-carousel__icon-button":"fr-ec-media-carousel__icon-button","mediaCarouselIconButton":"fr-ec-media-carousel__icon-button","swiper-container-horizontal":"fr-ec-swiper-container-horizontal","swiperContainerHorizontal":"fr-ec-swiper-container-horizontal","swiper-pagination":"fr-ec-swiper-pagination","swiperPagination":"fr-ec-swiper-pagination","swiper-pagination-bullet":"fr-ec-swiper-pagination-bullet","swiperPaginationBullet":"fr-ec-swiper-pagination-bullet","swiper-pagination-bullet-active":"fr-ec-swiper-pagination-bullet-active","swiperPaginationBulletActive":"fr-ec-swiper-pagination-bullet-active","swiper-pagination-bullets":"fr-ec-swiper-pagination-bullets","swiperPaginationBullets":"fr-ec-swiper-pagination-bullets","loader-wrapper":"fr-ec-loader-wrapper","loaderWrapper":"fr-ec-loader-wrapper","swiper-pagination-bullet--non-auto":"fr-ec-swiper-pagination-bullet--non-auto","swiperPaginationBulletNonAuto":"fr-ec-swiper-pagination-bullet--non-auto","swiper-pagination-h":"fr-ec-swiper-pagination-h","swiperPaginationH":"fr-ec-swiper-pagination-h","swiper-pagination-fraction":"fr-ec-swiper-pagination-fraction","swiperPaginationFraction":"fr-ec-swiper-pagination-fraction","pagination-loader":"fr-ec-pagination-loader","paginationLoader":"fr-ec-pagination-loader","complete-progress":"fr-ec-complete-progress","completeProgress":"fr-ec-complete-progress","pagination-loader__half-circle":"fr-ec-pagination-loader__half-circle","paginationLoaderHalfCircle":"fr-ec-pagination-loader__half-circle","pagination-loader__half-circle--left":"fr-ec-pagination-loader__half-circle--left","paginationLoaderHalfCircleLeft":"fr-ec-pagination-loader__half-circle--left","left-spin":"fr-ec-left-spin","leftSpin":"fr-ec-left-spin","pagination-loader__half-circle--right":"fr-ec-pagination-loader__half-circle--right","paginationLoaderHalfCircleRight":"fr-ec-pagination-loader__half-circle--right","right-spin":"fr-ec-right-spin","rightSpin":"fr-ec-right-spin","loader-common-animation":"fr-ec-loader-common-animation","loaderCommonAnimation":"fr-ec-loader-common-animation","loader-track":"fr-ec-loader-track","loaderTrack":"fr-ec-loader-track","media-carousel__arrow-container":"fr-ec-media-carousel__arrow-container","mediaCarouselArrowContainer":"fr-ec-media-carousel__arrow-container","media-carousel__arrows":"fr-ec-media-carousel__arrows","mediaCarouselArrows":"fr-ec-media-carousel__arrows","media-carousel__arrows--prev-arrow":"fr-ec-media-carousel__arrows--prev-arrow","mediaCarouselArrowsPrevArrow":"fr-ec-media-carousel__arrows--prev-arrow","media-carousel__arrows--next-arrow":"fr-ec-media-carousel__arrows--next-arrow","mediaCarouselArrowsNextArrow":"fr-ec-media-carousel__arrows--next-arrow","swiper-wrapper":"fr-ec-swiper-wrapper","swiperWrapper":"fr-ec-swiper-wrapper","media-carousel-progress-circle":"fr-ec-media-carousel-progress-circle","mediaCarouselProgressCircle":"fr-ec-media-carousel-progress-circle","stroke":"fr-ec-stroke"};

var MediaCarousel =
/** @class */
function (_super) {
  __extends(MediaCarousel, _super);

  function MediaCarousel(props) {
    var _this = _super.call(this, props) || this;

    _this.onSlideChange = function () {
      var swiperInstance = _this.swiperInstance;

      if (!_this.props.enablePinchZoom) {
        setTimeout(function () {
          swiperInstance.loopDestroy();
          swiperInstance.loopCreate();
        });
      }

      var isPlaying = _this.state.isPlaying;

      if (swiperInstance) {
        var activeSlide_1 = swiperInstance.activeIndex;

        _this.setState({
          activeSlide: activeSlide_1
        });

        var slideWrapper = Array.from(swiperInstance.$wrapperEl)[0];
        var slides_1 = Array.from(slideWrapper.getElementsByClassName('swiper-slide') || []);
        var videos = Array.from(slideWrapper.getElementsByTagName('video') || []);
        var progress = Array.from(document.getElementsByClassName(styles$2$1.mediaCarouselProgressCircle) || []);
        progress.forEach(function (circle) {
          circle.classList.remove(styles$2$1.mediaCarouselProgressCircle);
          var animateTimeout = setTimeout(function () {
            circle.classList.add(styles$2$1.mediaCarouselProgressCircle);
            circle.style.animationPlayState = isPlaying === null || isPlaying ? 'running' : 'paused';
            clearTimeout(animateTimeout);
          }, 0);
        });
        videos.forEach(function (video) {
          var isVisible = slides_1[activeSlide_1].contains(video);

          if (video.readyState !== 0) {
            if (!isVisible) {
              video.pause();
            } else if (video.paused) {
              video.classList.remove('played');
              video.play();
              video.style.zIndex = '1';
            }
          }
        });
      }
    };

    _this.onKeyBoardPress = function (e) {
      if (e.key === 'ArrowRight') {
        _this.swiperInstance.slideNext();
      }

      if (e.key === 'ArrowLeft') {
        _this.swiperInstance.slidePrev();
      }
    };

    _this.handleZoomChange = function (scale, imageEl) {
      var swiperInstance = _this.swiperInstance;

      if (imageEl.alt !== 'poster-image') {
        if (scale > 1) {
          _this.setState({
            isZoomed: true
          });

          swiperInstance.allowTouchMove = false;
        } else {
          _this.setState({
            isZoomed: false
          });

          swiperInstance.allowTouchMove = true;
        }
      }
    };

    _this.handleToggle = function () {
      if (_this.swiperInstance.autoplay.running) {
        _this.swiperInstance.autoplay.stop();

        _this.setState({
          isPlaying: false
        });
      } else {
        _this.swiperInstance.autoplay.start();

        _this.setState({
          isPlaying: true
        });
      }
    };

    _this.onCloseButtonClick = function () {
      if (_this.props.onPinchZoomCloseClick) {
        _this.props.onPinchZoomCloseClick(_this.state.activeSlide);
      }
    };

    _this.progressCircle = function () {
      var isPlaying = _this.state.isPlaying;
      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("svg", {
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
        focusable: "false",
        role: "presentation",
        style: {
          width: '25px',
          height: '25px',
          position: 'absolute',
          zIndex: 21
        }
      }, /*#__PURE__*/createElement("path", {
        style: {
          animationPlayState: isPlaying === null || isPlaying ? 'running' : 'paused'
        },
        "stroke-width": "1.5",
        className: styles$2$1.mediaCarouselProgressCircle,
        d: "M9,16.457 C4.889,16.457 1.543,13.112 1.543,9 C1.543,4.888 4.889,1.543 9,1.543 C13.111,1.543 16.457,4.888 16.457,9 C16.457,13.112 13.111,16.457 9,16.4579"
      })), isPlaying === null || isPlaying ? /*#__PURE__*/createElement(Icon, {
        name: _this.props.iconBrand ? _this.props.iconBrand + "pause" : 'pause',
        className: styles$2$1.mediaCarouselPauseIcon,
        size: "24"
      }) : /*#__PURE__*/createElement(Icon, {
        name: _this.props.iconBrand ? _this.props.iconBrand + "play" : 'play',
        className: styles$2$1.mediaCarouselPauseIcon,
        size: "24"
      }));
    };

    _this.swiperRef = /*#__PURE__*/createRef();
    _this.swiperInstance = null;
    _this.state = {
      activeSlide: _this.props.activeSlideIndex || 0,
      isPlaying: _this.swiperInstance && _this.swiperInstance.autoplay.running,
      isZoomed: false
    };
    return _this;
  }

  MediaCarousel.prototype.componentDidMount = function () {
    var _this = this;

    var pinchZoomSettings = this.props.enablePinchZoom ? {
      loop: false,
      pagination: {
        clickable: true,
        currentClass: 'swiper-current-slide',
        el: '.swiper-pagination',
        renderFraction: function renderFraction(currentClass, totalClass) {
          return "<span class=\"" + joinClasses(currentClass, typographyStyles.hintTextStandard) + "\"></span><span class=\"" + joinClasses('swiper-slash', typographyStyles.hintTextStandard) + "\">|</span><span class=\"" + joinClasses(totalClass, typographyStyles.hintTextStandard) + "\"></span>";
        },
        totalClass: 'swiper-total-slide',
        type: 'fraction'
      },
      passiveListeners: false,
      zoom: {
        maxRatio: 3,
        minRatio: 1
      }
    } : {
      loop: true,
      pagination: {
        clickable: true,
        el: '.swiper-pagination',
        type: 'bullets'
      }
    };
    this.swiperInstance = new swiper(this.swiperRef.current, __assign(__assign({
      autoplay: this.props.autoplay ? {
        delay: this.props.delay || 3400,
        disableOnInteraction: false
      } : false,
      direction: 'horizontal',
      initialSlide: this.props.activeSlideIndex || 0,
      keyboard: {
        enabled: false
      }
    }, pinchZoomSettings), {
      mousewheel: {
        forceToAxis: true,
        invert: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      },
      observeParents: true,
      observer: true,
      on: {
        slideChange: function slideChange() {
          return _this.onSlideChange();
        },
        zoomChange: function zoomChange(scale, imageEl) {
          return _this.handleZoomChange(scale, imageEl);
        }
      },
      parallax: true,
      slidesPerView: '1',
      speed: getCurrentMediaQueryBreakpoint() === 'lg' ? 800 : 400,
      touchReleaseOnEdges: true
    }));

    if (this.swiperInstance) {
      document.addEventListener('keydown', this.onKeyBoardPress);
    }
  };

  MediaCarousel.prototype.componentWillUnmount = function () {
    document.removeEventListener('keydown', this.onKeyBoardPress);
  };

  MediaCarousel.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        autoplay = _a.autoplay,
        id = _a.id,
        _b = _a.hasArrows,
        hasArrows = _b === void 0 ? true : _b,
        _c = _a.enablePinchZoom,
        enablePinchZoom = _c === void 0 ? false : _c,
        pinchZoomItems = _a.pinchZoomItems,
        _d = _a.pinchZoomCloseLabel,
        pinchZoomCloseLabel = _d === void 0 ? '' : _d,
        className = _a.className,
        iconBrand = _a.iconBrand,
        parentActiveIndex = _a.parentActiveIndex,
        parentGaCategory = _a.parentGaCategory,
        props = __rest(_a, ["children", "autoplay", "id", "hasArrows", "enablePinchZoom", "pinchZoomItems", "pinchZoomCloseLabel", "className", "iconBrand", "gaCategory", "gaLabel", "parentActiveIndex", "parentGaCategory"]);

    var _e = this.state,
        isZoomed = _e.isZoomed;
    var childrenWithProps = enablePinchZoom ? pinchZoomItems === null || pinchZoomItems === void 0 ? void 0 : pinchZoomItems.map(function (item, index) {
      return item.isVideo ? /*#__PURE__*/createElement("div", {
        key: index,
        className: "swiper-slide"
      }, /*#__PURE__*/createElement(VideoInline, {
        posterImage: item.posterImage,
        loop: true,
        src: item.src,
        muted: false,
        videoRatio: "1x1",
        videoType: 'product',
        key: item.key
      })) : /*#__PURE__*/createElement("div", {
        key: index,
        className: "swiper-slide"
      }, /*#__PURE__*/createElement("div", {
        className: "swiper-zoom-container"
      }, /*#__PURE__*/createElement("img", {
        src: item.src,
        alt: item.alt,
        key: item.key
      })));
    }) : Children.toArray(children).map(function (child, index) {
      var childGAProps = null;
      childGAProps = {
        'data-gtm-action': 'Read',
        'data-gtm-category': parentGaCategory,
        'data-gtm-event-name': 'ua_event',
        'data-gtm-label': parentActiveIndex + "_" + (index + 1),
        'data-gtm-trigger': 'inView',
        id: "cms-link-" + parentActiveIndex + "_" + (index + 1)
      };
      return parentActiveIndex !== undefined ? /*#__PURE__*/createElement("div", __assign({
        key: index,
        className: "swiper-slide"
      }, childGAProps), /*#__PURE__*/cloneElement(child, {
        gaCategory: parentGaCategory,
        gaLabel: parentActiveIndex + "_" + (index + 1),
        key: child.props.label
      })) : /*#__PURE__*/createElement("div", {
        key: index,
        className: "swiper-slide"
      }, /*#__PURE__*/cloneElement(child, {
        key: child.props.label
      }));
    });
    var gaProps = null;

    if (this.props.gaCategory && this.props.gaLabel) {
      gaProps = {
        'data-category': this.props.gaCategory,
        'data-label': this.props.gaLabel
      };
    }

    return /*#__PURE__*/createElement(Fragment, null, enablePinchZoom && !isZoomed && /*#__PURE__*/createElement("div", {
      className: styles$2$1.pinchZoomCarouselClose
    }, /*#__PURE__*/createElement(ButtonIcon, {
      element: "button",
      icon: "close-big",
      label: pinchZoomCloseLabel,
      variant: "dark",
      onClick: this.onCloseButtonClick,
      iconBrand: iconBrand
    })), /*#__PURE__*/createElement("div", __assign({
      className: joinClasses('swiper-container', styles$2$1.mediaCarousel, className),
      id: id,
      ref: this.swiperRef
    }, gaProps, props), /*#__PURE__*/createElement("div", {
      className: 'swiper-wrapper'
    }, childrenWithProps), hasArrows && !enablePinchZoom && /*#__PURE__*/createElement("div", {
      className: styles$2$1.mediaCarouselArrowContainer
    }, children && children.length > 1 && /*#__PURE__*/createElement("button", {
      "aria-hidden": true,
      className: joinClasses(styles$2$1.mediaCarouselNavigationBtn, 'swiper-button-prev', styles$2$1.mediaCarouselButtonPrev)
    }, /*#__PURE__*/createElement("span", {
      className: joinClasses(styles$2$1.mediaCarouselIcon, styles$2$1.mediaCarouselArrows, styles$2$1.mediaCarouselArrowsPrevArrow)
    })), children && children.length > 1 && /*#__PURE__*/createElement("button", {
      "aria-hidden": true,
      className: joinClasses(styles$2$1.mediaCarouselNavigationBtn, 'swiper-button-next', styles$2$1.mediaCarouselButtonNext)
    }, /*#__PURE__*/createElement("span", {
      className: joinClasses(styles$2$1.mediaCarouselIcon, styles$2$1.mediaCarouselArrows, styles$2$1.mediaCarouselArrowsNextArrow)
    }))), enablePinchZoom && /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$2$1.mediaCarouselArrowContainer, styles$2$1.mediaCarouselArrowContainerWithPinchZoom, isZoomed && styles$2$1.hidePaginationPinchZoom)
    }, /*#__PURE__*/createElement("button", {
      "aria-hidden": true,
      className: joinClasses(styles$2$1.mediaCarouselNavigationBtn, 'swiper-button-prev', styles$2$1.mediaCarouselButtonPrev)
    }, /*#__PURE__*/createElement(Icon, {
      name: iconBrand ? iconBrand + "chevron-left" : 'chevron-left'
    })), /*#__PURE__*/createElement("button", {
      "aria-hidden": true,
      className: joinClasses(styles$2$1.mediaCarouselNavigationBtn, 'swiper-button-next', styles$2$1.mediaCarouselButtonNext)
    }, /*#__PURE__*/createElement(Icon, {
      name: iconBrand ? iconBrand + "chevron-right" : 'chevron-right'
    }))), !enablePinchZoom ? /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
      className: styles$2$1.mediaCarouselPagination
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses('swiper-pagination', 'swiper-pagination-h')
    }), autoplay && /*#__PURE__*/createElement("button", {
      onClick: this.handleToggle,
      "aria-hidden": true,
      className: styles$2$1.mediaCarouselIconButton
    }, this.progressCircle())), /*#__PURE__*/createElement("div", {
      className: styles$2$1.mediaCarouselPaginationOverlay
    })) : /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$2$1.paginationPinchZoomWrapper, isZoomed && styles$2$1.hidePaginationPinchZoom)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses('swiper-pagination', 'swiper-pagination-pinch-zoom')
    })))));
  };

  MediaCarousel.displayName = 'CoreMediaCarousel';
  return MediaCarousel;
}(Component);

var ARROW_INCREMENT_NONE = 'none';
var ARROW_INCREMENT_SINGLE = 'single';
var ARROW_INCREMENT_PAGE = 'page';

var INDICATOR_NONE = 'none';
var INDICATOR_PAGES = 'pages';

var getElementVerticalCenterInParent = function getElementVerticalCenterInParent(element, parent) {
  var elementRect = element.getBoundingClientRect();
  var parentRect = parent.getBoundingClientRect();
  return elementRect.top - parentRect.top + elementRect.height / 2;
};

var styles$3$1 = {"carousel":"fr-ec-carousel","carousel__scrollbar-hide":"fr-ec-carousel__scrollbar-hide","carouselScrollbarHide":"fr-ec-carousel__scrollbar-hide","carousel__container":"fr-ec-carousel__container","carouselContainer":"fr-ec-carousel__container","carousel__frame":"fr-ec-carousel__frame","carouselFrame":"fr-ec-carousel__frame","carousel__frame--padded":"fr-ec-carousel__frame--padded","carouselFramePadded":"fr-ec-carousel__frame--padded","carousel__frame--shifting":"fr-ec-carousel__frame--shifting","carouselFrameShifting":"fr-ec-carousel__frame--shifting","carousel--with-pinch-zoom":"fr-ec-carousel--with-pinch-zoom","carouselWithPinchZoom":"fr-ec-carousel--with-pinch-zoom","pinch-zoom-carousel-indicator":"fr-ec-pinch-zoom-carousel-indicator","pinchZoomCarouselIndicator":"fr-ec-pinch-zoom-carousel-indicator","pinch-zoom-carousel-wrapper":"fr-ec-pinch-zoom-carousel-wrapper","pinchZoomCarouselWrapper":"fr-ec-pinch-zoom-carousel-wrapper","swiper-slide":"fr-ec-swiper-slide","swiperSlide":"fr-ec-swiper-slide","media-carousel":"fr-ec-media-carousel","mediaCarousel":"fr-ec-media-carousel","carousel__skip":"fr-ec-carousel__skip","carouselSkip":"fr-ec-carousel__skip","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","carousel__bottom-section":"fr-ec-carousel__bottom-section","carouselBottomSection":"fr-ec-carousel__bottom-section","carousel__bottom-section--none":"fr-ec-carousel__bottom-section--none","carouselBottomSectionNone":"fr-ec-carousel__bottom-section--none","carousel__bottom-section--with-number":"fr-ec-carousel__bottom-section--with-number","carouselBottomSectionWithNumber":"fr-ec-carousel__bottom-section--with-number","carousel__bottom-section--with-number-bottom":"fr-ec-carousel__bottom-section--with-number-bottom","carouselBottomSectionWithNumberBottom":"fr-ec-carousel__bottom-section--with-number-bottom","actionable-content--with-link-text":"fr-ec-actionable-content--with-link-text","actionableContentWithLinkText":"fr-ec-actionable-content--with-link-text","link-text--standalone-primary":"fr-ec-link-text--standalone-primary","linkTextStandalonePrimary":"fr-ec-link-text--standalone-primary","caption":"fr-ec-caption","carousel__model-details-wrapper":"fr-ec-carousel__model-details-wrapper","carouselModelDetailsWrapper":"fr-ec-carousel__model-details-wrapper","actionable-content__content--link-text":"fr-ec-actionable-content__content--link-text","actionableContentContentLinkText":"fr-ec-actionable-content__content--link-text","actionable-content__actions--link-text":"fr-ec-actionable-content__actions--link-text","actionableContentActionsLinkText":"fr-ec-actionable-content__actions--link-text","carousel__model-details--with-auto-slide":"fr-ec-carousel__model-details--with-auto-slide","carouselModelDetailsWithAutoSlide":"fr-ec-carousel__model-details--with-auto-slide","carousel__autoplay-button":"fr-ec-carousel__autoplay-button","carouselAutoplayButton":"fr-ec-carousel__autoplay-button","carousel-mobile":"fr-ec-carousel-mobile","carouselMobile":"fr-ec-carousel-mobile","carousel_frame--display-count-one":"fr-ec-carousel_frame--display-count-one","carouselFrameDisplayCountOne":"fr-ec-carousel_frame--display-count-one","carousel__frame--styling-variant-sm":"fr-ec-carousel__frame--styling-variant-sm","carouselFrameStylingVariantSm":"fr-ec-carousel__frame--styling-variant-sm","carousel-medium":"fr-ec-carousel-medium","carouselMedium":"fr-ec-carousel-medium","carousel__bottom-section--with-number-top":"fr-ec-carousel__bottom-section--with-number-top","carouselBottomSectionWithNumberTop":"fr-ec-carousel__bottom-section--with-number-top"};

var SCROLL_JITTER = 1;
var RE_SCROLL_ATTEMPTS = 2;

var CarouselBase =
/** @class */
function (_super) {
  __extends(CarouselBase, _super);

  function CarouselBase(props) {
    var _this = _super.call(this, props) || this;

    _this.frameRef = /*#__PURE__*/createRef();
    _this.lastElementRef = /*#__PURE__*/createRef();
    _this.isTouching = false;
    _this.scrollLeft = 0;
    _this.frameWidth = 0;
    _this.isMaxScroll = false;
    _this.reScrollAttempts = 0;
    _this.timer = 0;
    _this.mouseDown = false;

    _this.componentDidMount = function () {
      // TODO: Remove this if this is breaking some where, commenting this to fix UXDS-3813
      // if (isInBrowser()) {
      //   document.addEventListener('mousedown', this.handleMouseDown, true);
      //   document.addEventListener('focus', this.handleDocumentFocus, true);
      // }
      if (_this.props.autoSlide) {
        _this.timer = setInterval(_this.onAutoScroll('next'), _this.props.autoSlideInterval);
        var element_1 = _this.frameRef.current;
        var frameWidth = element_1.getBoundingClientRect().width;
        var slideWidth = Math.round(frameWidth / _this.props.displayCount);

        _this.setState({
          slideWidth: slideWidth
        });

        if (element_1.lastElementChild && element_1.firstElementChild) {
          if (_this.props.maxIndex <= 1) {
            var firstElementChild = element_1.firstElementChild.cloneNode(true);
            var lastElementChild = element_1.lastElementChild.cloneNode(true);
            firstElementChild.style.width = slideWidth + "px";
            lastElementChild.style.width = slideWidth + "px";
            element_1.insertBefore(lastElementChild, element_1.firstElementChild);
            element_1.appendChild(firstElementChild);
          } else {
            element_1.insertBefore(element_1.lastElementChild, element_1.firstElementChild);
          }

          element_1.style.width = slideWidth + "px";
          element_1.style.marginLeft = "-" + slideWidth + "px";
          setTimeout(function () {
            return element_1.style.transition = 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
          });
        }
      }
    };

    _this.componentDidUpdate = function (prevProps) {
      if (prevProps.arrowPositionSelector !== _this.props.arrowPositionSelector) {
        _this.updateArrowOffset();
      }

      if (prevProps.index !== _this.props.index) {
        _this.scrollToIndex(_this.props.index, false);
      }

      if (_this.props.slidesTotal !== prevProps.slidesTotal || _this.props.displayCount !== prevProps.displayCount) {
        _this.onResize(false);
      }
    };

    _this.componentWillUnmount = function () {
      // TODO: Remove this if this is breaking some where, commenting this to fix UXDS-3813
      // if (isInBrowser()) {
      //   document.removeEventListener('mousedown', this.handleMouseDown, true);
      //   document.removeEventListener('focus', this.handleDocumentFocus, true);
      // }
      if (_this.timer) {
        clearInterval(_this.timer);
      }
    };

    _this.onAutoScroll = function (direction) {
      return function () {
        var element = _this.frameRef.current;

        if (!element) {
          return;
        }

        if (direction === 'next') {
          element.style.transform = "translate(-" + _this.state.slideWidth + "px)";
          setTimeout(function () {
            if (element && element.firstElementChild) {
              element.appendChild(element.firstElementChild);
              element.style.transition = 'none';
              element.style.transform = 'translate(0)';
              setTimeout(function () {
                return element.style.transition = 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
              }, 30);

              _this.onIndexChange(_this.state.index >= _this.props.slidesTotal - 1 ? 0 : _this.state.index + 1);
            }
          }, 600);
        } else {
          element.style.transform = "translate(" + _this.state.slideWidth + "px)";
          setTimeout(function () {
            if (element && element.lastElementChild) {
              element.insertBefore(element.lastElementChild, element.firstElementChild);
              element.style.transition = 'none';
              element.style.transform = 'translate(0)';
              setTimeout(function () {
                return element.style.transition = 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
              }, 30);

              _this.onIndexChange(_this.state.index - 1);
            }
          }, 600);
        }
      };
    };

    _this.updateScrollValues = function () {
      var frameElement = _this.frameRef.current;
      _this.scrollLeft = frameElement ? frameElement.scrollLeft : 0;
      var frameScrollWidth = frameElement ? frameElement.scrollWidth : 0;
      _this.isMaxScroll = Math.abs(frameScrollWidth - _this.frameWidth - _this.scrollLeft) < SCROLL_JITTER;
    };

    _this.updateArrowOffset = function () {
      var frameElement = _this.frameRef.current;
      var offset;
      var video = 'video';
      var container = _this.frameRef.current;

      if (frameElement) {
        var childElements = Array.from(container.getElementsByTagName('li') || []);
        var firstElement = childElements[0];
        var videoElement = firstElement && firstElement.querySelector(video);
        var arrowPositionSelector = _this.props.arrowPositionSelector;

        if (videoElement) {
          arrowPositionSelector = video;
        }

        if (frameElement && arrowPositionSelector) {
          var element = frameElement.querySelector(arrowPositionSelector);

          if (element) {
            offset = getElementVerticalCenterInParent(element, frameElement);
          }
        }

        if (offset !== _this.state.arrowOffset) {
          _this.setState({
            arrowOffset: offset
          });
        }
      }
    };

    _this.scrollToIndex = function (index, instant) {
      if (instant === void 0) {
        instant = false;
      }

      var left = _this.state.slideWidth * index;

      if (Math.abs(_this.scrollLeft - left) < SCROLL_JITTER) {
        // Already there.
        if (_this.state.index !== index) {
          _this.onIndexChange(index);
        }

        return;
      }

      var element = _this.frameRef.current;

      if (!element) {
        return;
      }

      if (element.scrollTo && !instant) {
        element.scrollTo({
          behavior: 'smooth',
          left: left
        });
      } else {
        element.scrollLeft = left;
      }
    };

    _this.handleOnScroll = function (_) {
      _this.updateScrollValues();

      if (_this.isTouching) {
        return;
      }

      var index = _this.isMaxScroll ? _this.props.maxIndex : Math.round(_this.scrollLeft / _this.state.slideWidth);
      var isSnapped = Math.abs(index * _this.state.slideWidth - _this.scrollLeft) < SCROLL_JITTER;

      if (!_this.isMaxScroll && !isSnapped && _this.reScrollAttempts <= RE_SCROLL_ATTEMPTS) {
        /* For the browsers that do not support scroll snapping we need to manually run scroll to closest index, and hope it will get there */
        _this.reScrollAttempts++;

        _this.scrollToIndex(index);
      } else {
        _this.reScrollAttempts = 0;

        if (index === _this.userRequestedIndex) {
          _this.onIndexChange(index);

          _this.userRequestedIndex = undefined;
        } else if (_this.state.index !== index) {
          _this.onIndexChange(index);
        }
      }
    }; // TODO: Remove this if this is breaking some where, commenting this to fix UXDS-3813
    // handleMouseDown = (_: MouseEvent) => {
    //   this.mouseDown = true;
    // };
    // handleDocumentFocus = (_: FocusEvent) => {
    //   // console.log('focus', this.mouseDown);
    //   if (!this.mouseDown) {
    //     const frameElement = this.frameRef.current;
    //     const activeElement = document.activeElement;
    //     if (frameElement && activeElement && frameElement.contains(activeElement)) {
    //       const box = activeElement.getBoundingClientRect();
    //       if (Math.round(this.props.slidesPerPage * this.state.slideWidth) <= Math.round(box.left)) {
    //         this.userRequestedIndex = this.state.index + 1;
    //         this.scrollToIndex(this.userRequestedIndex, true);
    //         // console.log('focus', 'slide');
    //       }
    //     }
    //   }
    //   this.mouseDown = false;
    // };


    _this.onPageClick = function (index) {
      _this.userRequestedIndex = index;

      _this.scrollToIndex(index);
    };

    _this.onSkipClick = function (_) {
      var lastElementRef = _this.lastElementRef.current;

      if (lastElementRef) {
        lastElementRef.focus();
      }
    }; // Function to handle video pause and play when sliding in carousel


    _this.handleVideoChange = function (index) {
      if (_this.props.autoSlide) {
        var element = _this.frameRef.current;
        var childElements_1 = Array.from(element.getElementsByTagName('li') || []);
        var videos = Array.from(element.getElementsByTagName('video') || []);
        videos.forEach(function (video) {
          var isVisible = childElements_1[1].contains(video);

          if (video.readyState !== 0) {
            if (!isVisible) {
              video.pause();
            } else if (video.paused) {
              video.classList.remove('played');
              video.play();
              video.style.zIndex = '1';
            }
          }
        });
      } else {
        var _a = _this.props,
            displayCount = _a.displayCount,
            slidesTotal = _a.slidesTotal;
        var element = _this.frameRef.current;
        var childElements_2 = Array.from(element.getElementsByTagName('li') || []);
        var videos = Array.from(element.getElementsByTagName('video') || []);

        var videoIndexes_1 = __spreadArrays(_this.state.videoIndexes);

        var visibleIndexes_1 = __spreadArrays(range(index, index + displayCount > slidesTotal ? slidesTotal : index + displayCount));

        videos.forEach(function (video, ind) {
          var isVisible = visibleIndexes_1.some(function (indx) {
            return childElements_2[indx].contains(video);
          });

          if (video.readyState !== 0) {
            if (childElements_2[index].contains(video) || isVisible) {
              if (video.classList.contains('played')) {
                video.classList.remove('played');
                video.play();
              } else if (video.paused && videoIndexes_1.findIndex(function (it) {
                return it === ind;
              }) !== -1) {
                video.play();
                videoIndexes_1 = videoIndexes_1.filter(function (it) {
                  return it !== ind;
                });
              }

              video.style.zIndex = '1';
            } else if (video && !video.paused && !isVisible) {
              videoIndexes_1 = __spreadArrays(videoIndexes_1, [ind]);
              video.pause();
            }
          }
        });

        _this.setState({
          videoIndexes: videoIndexes_1
        });
      }
    };

    _this.onIndexChange = function (index) {
      _this.setState({
        index: index
      });

      _this.handleVideoChange(index);

      if (_this.props.onIndexChange) {
        _this.props.onIndexChange(index);
      }
    };

    _this.onResize = function (isDomUpdate) {
      if (isDomUpdate === void 0) {
        isDomUpdate = true;
      }

      var frameElement = _this.frameRef.current;
      var isMobileWidth = getCurrentMediaQueryBreakpoint() === BP_SMALL;
      var isMediumWidth = getCurrentMediaQueryBreakpoint() === BP_MEDIUM;

      if (frameElement && frameElement) {
        _this.frameWidth = frameElement.getBoundingClientRect().width;

        if (_this.props.autoSlide) {
          var slideWidth = Math.round(_this.frameWidth / _this.props.displayCount);
          frameElement.style.width = slideWidth + "px";
          frameElement.style.marginLeft = "-" + slideWidth + "px";
        }

        _this.setState({
          isMedium: isMediumWidth,
          isMobile: isMobileWidth,
          slideWidth: Math.round(_this.frameWidth / _this.props.displayCount)
        }, function () {
          _this.updateScrollValues();

          _this.updateArrowOffset();

          _this.scrollToIndex(isDomUpdate ? _this.state.index : _this.props.index, true);
        });
      }
    };

    _this.onArrowClick = function (direction) {
      if (_this.props.autoSlide) {
        _this.onAutoScroll(direction)();
      } else {
        var arrowIncrement = _this.props.arrowIncrement;
        _this.userRequestedIndex = direction === ARROW_DIRECTION_NEXT ? _this.getNextIndex(_this.state.index, arrowIncrement) : _this.getPrevIndex(_this.state.index, arrowIncrement);

        _this.scrollToIndex(_this.userRequestedIndex);
      }
    };

    _this.getPrevIndex = function (index, arrowsIncrementType) {
      switch (arrowsIncrementType) {
        case ARROW_INCREMENT_SINGLE:
          return Math.max(index - 1, 0);

        case ARROW_INCREMENT_PAGE:
          return Math.max(index - _this.props.slidesPerPage, 0);

        case ARROW_INCREMENT_NONE:
        default:
          return 0;
      }
    };

    _this.getNextIndex = function (index, arrowsIncrementType) {
      switch (arrowsIncrementType) {
        case ARROW_INCREMENT_SINGLE:
          return Math.min(index + 1, _this.props.maxIndex);

        case ARROW_INCREMENT_PAGE:
          return Math.min(index + _this.props.slidesPerPage, _this.props.maxIndex);

        case ARROW_INCREMENT_NONE:
        default:
          return _this.props.maxIndex;
      }
    };

    _this.getTouchEvents = function () {
      return {
        onTouchCancel: function onTouchCancel(_) {
          _this.isTouching = false;
        },
        onTouchEnd: function onTouchEnd(_) {
          _this.isTouching = false;
        },
        onTouchStart: function onTouchStart(_) {
          _this.isTouching = true;
        }
      };
    };

    _this.onAutoSlidePauseButtonClick = function (event) {
      if (_this.state.autoSlide) {
        _this.setState({
          autoSlide: !_this.state.autoSlide
        });

        clearInterval(_this.timer);
      } else {
        _this.setState({
          autoSlide: !_this.state.autoSlide
        });

        _this.timer = setInterval(_this.onAutoScroll('next'), _this.props.autoSlideInterval);
      }

      if (_this.props.onAutoSlideTrigger) {
        _this.props.onAutoSlideTrigger(event);
      }
    };

    _this.getClickedSlideIndex = function (slideIndex) {
      _this.setState({
        clickedSlideIndex: slideIndex,
        isOpen: true
      });
    };

    _this.onRequestClose = function (activeSlide) {
      _this.setState({
        isOpen: false
      });

      if (_this.state.index !== activeSlide) {
        _this.onIndexChange(activeSlide);
      }
    };

    _this.state = {
      autoSlide: _this.props.autoSlide,
      clickedSlideIndex: 0,
      index: _this.props.index,
      isMedium: false,
      isMobile: false,
      isOpen: false,
      slideWidth: 0,
      videoIndexes: []
    };
    return _this;
  }

  CarouselBase.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        indicator = _a.indicator,
        arrowIncrement = _a.arrowIncrement,
        slidesTotal = _a.slidesTotal,
        displayCount = _a.displayCount,
        slidesPerPage = _a.slidesPerPage,
        noPadding = _a.noPadding,
        slidePlaceholder = _a.slidePlaceholder,
        _b = _a.skipLinkText,
        skipLinkText = _b === void 0 ? '' : _b,
        carouselAriaLabel = _a.carouselAriaLabel,
        skipToId = _a.skipToId,
        autoSlide = _a.autoSlide,
        className = _a.className,
        keyboardNavigation = _a.keyboardNavigation,
        modelDetailsText = _a.modelDetailsText,
        modelDetailsLink = _a.modelDetailsLink,
        onArrowTrigger = _a.onArrowTrigger,
        _c = _a.hasArrows,
        hasArrows = _c === void 0 ? true : _c,
        _d = _a.variant,
        variant = _d === void 0 ? 'default' : _d,
        pinchZoomItems = _a.pinchZoomItems,
        enablePinchZoom = _a.enablePinchZoom,
        pinchZoomCloseLabel = _a.pinchZoomCloseLabel,
        iconBrand = _a.iconBrand,
        rest = __rest(_a, ["children", "indicator", "arrowIncrement", "slidesTotal", "displayCount", "slidesPerPage", "maxIndex", "noPadding", "slidePlaceholder", "skipLinkText", "carouselAriaLabel", "arrowPositionSelector", "onIndexChange", "skipToId", "autoSlide", "autoSlideInterval", "className", "keyboardNavigation", "modelDetailsText", "modelDetailsLink", "onAutoSlideTrigger", "onArrowTrigger", "hasArrows", "variant", "pinchZoomItems", "enablePinchZoom", "pinchZoomCloseLabel", "iconBrand"]);

    var _e = this.state,
        index = _e.index,
        clickedSlideIndex = _e.clickedSlideIndex,
        arrowOffset = _e.arrowOffset,
        isOpen = _e.isOpen;
    var showPrevArrow = arrowIncrement !== ARROW_INCREMENT_NONE && this.getPrevIndex(index, arrowIncrement) < index;
    var showNextArrow = arrowIncrement !== ARROW_INCREMENT_NONE && this.getNextIndex(index, arrowIncrement) > index;
    var skipLinkProps = skipToId ? {
      href: "#" + skipToId,
      element: 'a'
    } : {
      onClick: this.onSkipClick,
      element: 'button'
    };
    return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Measure, {
      onResize: debounce(100, function () {
        return _this.onResize(true);
      })
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/createElement("div", __assign({
        className: joinClasses(styles$3$1.carousel, className),
        ref: measureRef,
        "aria-label": carouselAriaLabel
      }, rest), keyboardNavigation === 'item' && /*#__PURE__*/createElement(Button, __assign({}, skipLinkProps, {
        className: styles$3$1.carouselSkip,
        variant: "primary",
        isSmall: true,
        iconBrand: iconBrand
      }), skipLinkText), /*#__PURE__*/createElement("div", {
        className: styles$3$1.carouselScrollbarHide
      }, /*#__PURE__*/createElement("div", {
        className: styles$3$1.carouselContainer
      }, /*#__PURE__*/createElement("ul", __assign({
        className: joinClasses(noPadding ? styles$3$1.carouselFrame : styles$3$1.carouselFramePadded, autoSlide && styles$3$1.carouselFrameShifting, variant === 'styling' && styles$3$1.carouselFrameStylingVariantSm, displayCount === 1 && styles$3$1.carouselFrameDisplayCountOne),
        ref: _this.frameRef,
        onScroll: debounce(100, _this.handleOnScroll)
      }, _this.getTouchEvents(), {
        tabIndex: -1
      }), /*#__PURE__*/createElement(CarouselSlides, {
        currentIndex: index,
        displayCount: _this.props.autoSlide ? 1 : displayCount,
        placeholder: slidePlaceholder,
        noPadding: noPadding,
        slideWidth: _this.state.slideWidth,
        isMobile: _this.state.isMobile,
        isMedium: _this.state.isMedium,
        carouselVariant: variant,
        getClickedSlideIndex: _this.getClickedSlideIndex,
        enablePinchZoom: enablePinchZoom ? true : false
      }, children)), showPrevArrow && hasArrows && /*#__PURE__*/createElement(CarouselArrow, {
        displayCount: displayCount,
        keyboardNavigation: autoSlide ? 'arrow' : keyboardNavigation,
        direction: ARROW_DIRECTION_PREV,
        topOffset: arrowOffset,
        onClick: _this.onArrowClick,
        onArrowTrigger: onArrowTrigger,
        carouselVariant: variant,
        iconBrand: iconBrand
      }), showNextArrow && hasArrows && /*#__PURE__*/createElement(CarouselArrow, {
        displayCount: displayCount,
        keyboardNavigation: autoSlide ? 'arrow' : keyboardNavigation,
        direction: ARROW_DIRECTION_NEXT,
        topOffset: arrowOffset,
        onClick: _this.onArrowClick,
        onArrowTrigger: onArrowTrigger,
        carouselVariant: variant,
        iconBrand: iconBrand
      }))), variant && variant === 'media-gallery' ? /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
        className: joinClasses(styles$3$1.carouselBottomSection, styles$3$1.carouselBottomSectionWithNumberTop)
      }, /*#__PURE__*/createElement(CarouselPagination, {
        currentIndex: index,
        total: slidesTotal,
        itemsPerPage: slidesPerPage,
        indicatorType: indicator,
        forceLast: _this.isMaxScroll,
        autoSlide: autoSlide,
        carouselVariant: variant
      })), /*#__PURE__*/createElement("div", {
        className: joinClasses(styles$3$1.carouselBottomSection, styles$3$1.carouselBottomSectionWithNumberBottom)
      }, autoSlide && /*#__PURE__*/createElement(ButtonIcon, {
        className: styles$3$1.carouselAutoplayButton,
        "aria-label": _this.state.autoSlide ? 'pause' : 'play',
        element: "button",
        icon: _this.state.autoSlide ? 'pause' : 'play',
        onClick: _this.onAutoSlidePauseButtonClick,
        hideLabel: true,
        label: "",
        iconBrand: iconBrand
      }), modelDetailsText && indicator === 'number' && !modelDetailsLink && /*#__PURE__*/createElement(Caption, {
        element: "span",
        variant: "small",
        color: "secondary",
        className: joinClasses(autoSlide && styles$3$1.carouselModelDetailsWithAutoSlide)
      }, modelDetailsText), modelDetailsText && indicator === 'number' && modelDetailsLink && /*#__PURE__*/createElement(ActionableContent, {
        className: styles$3$1.carouselModelDetailsWrapper,
        variant: "link-text",
        actions: modelDetailsLink,
        content: /*#__PURE__*/createElement(Caption, {
          element: "span",
          className: joinClasses(autoSlide && styles$3$1.carouselModelDetailsWithAutoSlide),
          variant: "small",
          color: "secondary"
        }, modelDetailsText)
      }), !modelDetailsText && indicator === 'number' && modelDetailsLink && modelDetailsLink)) : /*#__PURE__*/createElement("div", {
        className: joinClasses(styles$3$1.carouselBottomSection, indicator === 'number' && styles$3$1.carouselBottomSectionWithNumber, variant !== 'default' && styles$3$1.carouselMobile, variant === 'image-plus-text' && styles$3$1.carouselMedium, indicator === 'none' && styles$3$1.carouselBottomSectionNone, indicator === 'pages' && Math.ceil(slidesTotal / slidesPerPage) <= 1 && styles$3$1.carouselBottomSectionNone)
      }, /*#__PURE__*/createElement(CarouselPagination, {
        currentIndex: index,
        total: slidesTotal,
        itemsPerPage: slidesPerPage,
        indicatorType: indicator,
        forceLast: _this.isMaxScroll,
        autoSlide: autoSlide,
        carouselVariant: variant
      }), autoSlide && /*#__PURE__*/createElement(ButtonIcon, {
        className: styles$3$1.carouselAutoplayButton,
        "aria-label": _this.state.autoSlide ? 'pause' : 'play',
        element: "button",
        icon: _this.state.autoSlide ? 'pause' : 'play',
        onClick: _this.onAutoSlidePauseButtonClick,
        hideLabel: true,
        label: "",
        iconBrand: iconBrand
      }), modelDetailsText && indicator === 'number' && !modelDetailsLink && /*#__PURE__*/createElement(Body, {
        element: "span",
        color: "secondary",
        variant: "small",
        className: joinClasses(autoSlide && styles$3$1.carouselModelDetailsWithAutoSlide)
      }, modelDetailsText), modelDetailsText && indicator === 'number' && modelDetailsLink && /*#__PURE__*/createElement(ActionableContent, {
        className: styles$3$1.carouselModelDetailsWrapper,
        variant: "link-text",
        actions: modelDetailsLink,
        content: /*#__PURE__*/createElement(Body, {
          element: "span",
          color: "secondary",
          variant: "small",
          className: joinClasses(autoSlide && styles$3$1.carouselModelDetailsWithAutoSlide)
        }, modelDetailsText)
      }), !modelDetailsText && indicator === 'number' && modelDetailsLink && modelDetailsLink), !skipToId && /*#__PURE__*/createElement("div", {
        ref: _this.lastElementRef,
        tabIndex: -1,
        "aria-hidden": "true"
      }));
    }), isOpen && /*#__PURE__*/createElement("div", {
      className: styles$3$1.carouselWithPinchZoom
    }, /*#__PURE__*/createElement("div", {
      className: styles$3$1.pinchZoomCarouselWrapper
    }, /*#__PURE__*/createElement(MediaCarousel, {
      activeSlideIndex: clickedSlideIndex,
      children: [],
      enablePinchZoom: enablePinchZoom,
      pinchZoomItems: pinchZoomItems,
      onPinchZoomCloseClick: this.onRequestClose,
      pinchZoomCloseLabel: pinchZoomCloseLabel,
      iconBrand: iconBrand
    }))));
  };

  return CarouselBase;
}(Component);

var Carousel =
/** @class */
function (_super) {
  __extends(Carousel, _super);

  function Carousel(props) {
    var _this = _super.call(this, props) || this;

    _this.onWindowSize = debounce(100, function (_) {
      _this.setState({
        breakpoint: getCurrentMediaQueryBreakpoint()
      });
    });

    _this.componentDidMount = function () {
      if (isInBrowser$1()) {
        window.addEventListener('resize', _this.onWindowSize);
      }
    };

    _this.componentWillUnmount = function () {
      if (isInBrowser$1()) {
        window.removeEventListener('resize', _this.onWindowSize);
      }
    };

    _this.state = {
      breakpoint: getCurrentMediaQueryBreakpoint()
    };
    return _this;
  }

  Carousel.prototype.render = function () {
    var _a = this.props,
        _b = _a.displayCount,
        displayCount = _b === void 0 ? 1 : _b,
        _c = _a.indicator,
        indicator = _c === void 0 ? INDICATOR_PAGES : _c,
        _d = _a.index,
        index = _d === void 0 ? 0 : _d,
        children = _a.children,
        _e = _a.arrowsIncrement,
        arrowsIncrement = _e === void 0 ? ARROW_INCREMENT_PAGE : _e,
        _f = _a.autoSlide,
        autoSlide = _f === void 0 ? false : _f,
        _g = _a.autoSlideInterval,
        autoSlideInterval = _g === void 0 ? 6000 : _g,
        _h = _a.keyboardNavigation,
        keyboardNavigation = _h === void 0 ? 'item' : _h,
        _j = _a.variant,
        variant = _j === void 0 ? 'default' : _j,
        hasArrows = _a.hasArrows,
        pinchZoomItems = _a.pinchZoomItems,
        _k = _a.enablePinchZoom,
        enablePinchZoom = _k === void 0 ? false : _k,
        _l = _a.pinchZoomCloseLabel,
        pinchZoomCloseLabel = _l === void 0 ? '' : _l,
        iconBrand = _a.iconBrand,
        rest = __rest(_a, ["displayCount", "indicator", "index", "children", "arrowsIncrement", "autoSlide", "autoSlideInterval", "keyboardNavigation", "variant", "hasArrows", "pinchZoomItems", "enablePinchZoom", "pinchZoomCloseLabel", "iconBrand"]);

    var displayCountProp = Math.max(typeof displayCount === 'number' ? displayCount : displayCount[this.state.breakpoint], 1);
    var slidesPerPage = Math.floor(displayCountProp);
    var indicatorProp = typeof indicator === 'string' ? indicator : indicator[this.state.breakpoint];
    var arrowsIncrementProp = typeof arrowsIncrement === 'string' ? arrowsIncrement : arrowsIncrement[this.state.breakpoint];
    var slidesTotal = Children.toArray(children).length;
    var maxIndex = Math.max(slidesTotal - slidesPerPage, 0);
    var indexProp = index < 0 ? 0 : Math.min(maxIndex, index); // const noPaddingProp = noPadding || displayCountProp === 1;

    var noPaddingProp = displayCountProp === 1;
    var slideInterval = autoSlideInterval < 0 ? 0 : autoSlideInterval;
    var gaProps = null;

    if (this.props.gaCategory && this.props.gaLabel) {
      gaProps = {
        'data-category': this.props.gaCategory,
        'data-label': this.props.gaLabel
      };
    }

    return /*#__PURE__*/createElement(CarouselBase, __assign({
      displayCount: displayCountProp,
      indicator: indicatorProp,
      index: indexProp,
      maxIndex: maxIndex,
      slidesTotal: slidesTotal,
      arrowIncrement: arrowsIncrementProp,
      slidesPerPage: slidesPerPage,
      noPadding: noPaddingProp,
      autoSlide: autoSlide,
      autoSlideInterval: slideInterval,
      keyboardNavigation: keyboardNavigation,
      variant: variant,
      hasArrows: hasArrows,
      pinchZoomItems: pinchZoomItems,
      enablePinchZoom: enablePinchZoom,
      pinchZoomCloseLabel: pinchZoomCloseLabel,
      iconBrand: iconBrand
    }, gaProps, rest), children);
  };

  Carousel.displayName = 'CoreCarousel';
  Carousel.defaultProps = {
    arrowsIncrement: ARROW_INCREMENT_PAGE,
    displayCount: 1,
    index: 0,
    indicator: INDICATOR_PAGES,
    noPadding: false
  };
  return Carousel;
}(Component);

var styles$4$1 = {"checkbox":"fr-ec-checkbox","checkbox__label":"fr-ec-checkbox__label","checkboxLabel":"fr-ec-checkbox__label","checkbox__children":"fr-ec-checkbox__children","checkboxChildren":"fr-ec-checkbox__children","checkbox__image":"fr-ec-checkbox__image","checkboxImage":"fr-ec-checkbox__image","no-image":"fr-ec-no-image","noImage":"fr-ec-no-image","checkbox__input":"fr-ec-checkbox__input","checkboxInput":"fr-ec-checkbox__input","checkbox__input--image":"fr-ec-checkbox__input--image","checkboxInputImage":"fr-ec-checkbox__input--image","checkbox__check":"fr-ec-checkbox__check","checkboxCheck":"fr-ec-checkbox__check","checkbox__input--default":"fr-ec-checkbox__input--default","checkboxInputDefault":"fr-ec-checkbox__input--default","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","borderIn":"fr-ec-borderIn","checkbox__input--white":"fr-ec-checkbox__input--white","checkboxInputWhite":"fr-ec-checkbox__input--white","checkbox__input--gray":"fr-ec-checkbox__input--gray","checkboxInputGray":"fr-ec-checkbox__input--gray","checkbox__input--black":"fr-ec-checkbox__input--black","checkboxInputBlack":"fr-ec-checkbox__input--black","checkbox__input--pink":"fr-ec-checkbox__input--pink","checkboxInputPink":"fr-ec-checkbox__input--pink","checkbox__input--red":"fr-ec-checkbox__input--red","checkboxInputRed":"fr-ec-checkbox__input--red","checkbox__input--orange":"fr-ec-checkbox__input--orange","checkboxInputOrange":"fr-ec-checkbox__input--orange","checkbox__input--beige":"fr-ec-checkbox__input--beige","checkboxInputBeige":"fr-ec-checkbox__input--beige","checkbox__input--brown":"fr-ec-checkbox__input--brown","checkboxInputBrown":"fr-ec-checkbox__input--brown","checkbox__input--yellow":"fr-ec-checkbox__input--yellow","checkboxInputYellow":"fr-ec-checkbox__input--yellow","checkbox__input--green":"fr-ec-checkbox__input--green","checkboxInputGreen":"fr-ec-checkbox__input--green","checkbox__input--blue":"fr-ec-checkbox__input--blue","checkboxInputBlue":"fr-ec-checkbox__input--blue","checkbox__input--purple":"fr-ec-checkbox__input--purple","checkboxInputPurple":"fr-ec-checkbox__input--purple"};

var Checkbox = /*#__PURE__*/forwardRef(function (_a, ref) {
  var label = _a.label,
      name = _a.name,
      checked = _a.checked,
      onChange = _a.onChange,
      value = _a.value,
      color = _a.color,
      id = _a.id,
      disabled = _a.disabled,
      children = _a.children,
      className = _a.className,
      labelVariant = _a.labelVariant,
      iconBrand = _a.iconBrand,
      image = _a.image,
      props = __rest(_a, ["label", "name", "checked", "onChange", "value", "color", "id", "disabled", "children", "className", "labelVariant", "iconBrand", "image"]);

  var hasChildren = Children.toArray(children).length > 0;
  var childrenId = hasChildren ? id + "__content" : '';

  var _b = useState(false),
      noImage = _b[0],
      toggleNoImage = _b[1];

  var handleImageErrored = function handleImageErrored(event) {
    toggleNoImage(true);
  };

  return /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$4$1.checkbox, className)
  }, /*#__PURE__*/createElement("input", __assign({
    type: "checkbox",
    className: joinClasses(styles$4$1.checkboxInput, image ? styles$4$1["checkbox__input--image"] : styles$4$1["checkbox__input--" + color] || styles$4$1.checkboxInputDefault, interactionsStyles.cursorPointer),
    value: value,
    name: name,
    checked: checked,
    onChange: onChange,
    id: id,
    disabled: disabled,
    "aria-describedby": childrenId,
    ref: ref
  }, props)), /*#__PURE__*/createElement("label", {
    htmlFor: id,
    className: joinClasses(styles$4$1.checkboxLabel, resetStyles.maxWidthReset, interactionsStyles.cursorPointer)
  }, image ? !noImage ? /*#__PURE__*/createElement("img", {
    className: styles$4$1.checkboxImage,
    src: image,
    onError: handleImageErrored,
    alt: "default image"
  }) : /*#__PURE__*/createElement(NoImage, {
    className: styles$4$1.checkboxImage,
    iconBrand: iconBrand,
    imageSize: "small",
    imageType: "icon"
  }) : null, checked ? /*#__PURE__*/createElement(Icon, {
    className: styles$4$1.checkboxCheck,
    name: iconBrand ? iconBrand + "check-large" : 'check-large'
  }) : null, /*#__PURE__*/createElement(Label, {
    element: "span",
    variant: labelVariant,
    color: disabled ? 'disabled' : 'primary-dark'
  }, label)), hasChildren && /*#__PURE__*/createElement("div", {
    id: childrenId,
    className: styles$4$1.checkboxChildren
  }, children));
});
Checkbox.displayName = 'CoreCheckbox';
Checkbox.defaultProps = {
  disabled: false,
  labelVariant: 'standard'
};

var styles$5$1 = {"dropdown":"fr-ec-dropdown","dropdown__container":"fr-ec-dropdown__container","dropdownContainer":"fr-ec-dropdown__container","dropdown__input":"fr-ec-dropdown__input","dropdownInput":"fr-ec-dropdown__input","dropdown__hidden-options":"fr-ec-dropdown__hidden-options","dropdownHiddenOptions":"fr-ec-dropdown__hidden-options","dropdown__input-container":"fr-ec-dropdown__input-container","dropdownInputContainer":"fr-ec-dropdown__input-container","dropdown__list":"fr-ec-dropdown__list","dropdownList":"fr-ec-dropdown__list","dropdown__list--show":"fr-ec-dropdown__list--show","dropdownListShow":"fr-ec-dropdown__list--show","dropdown__option-positioning-top":"fr-ec-dropdown__option-positioning-top","dropdownOptionPositioningTop":"fr-ec-dropdown__option-positioning-top","dropdown__input-container--fit-to-content":"fr-ec-dropdown__input-container--fit-to-content","dropdownInputContainerFitToContent":"fr-ec-dropdown__input-container--fit-to-content","dropdown__input-inner-container":"fr-ec-dropdown__input-inner-container","dropdownInputInnerContainer":"fr-ec-dropdown__input-inner-container","dropdown__hidden-option":"fr-ec-dropdown__hidden-option","dropdownHiddenOption":"fr-ec-dropdown__hidden-option","dropdown__list--max-height":"fr-ec-dropdown__list--max-height","dropdownListMaxHeight":"fr-ec-dropdown__list--max-height","dropdown__list--option-position-top":"fr-ec-dropdown__list--option-position-top","dropdownListOptionPositionTop":"fr-ec-dropdown__list--option-position-top","dropdown__container--fit-to-content":"fr-ec-dropdown__container--fit-to-content","dropdownContainerFitToContent":"fr-ec-dropdown__container--fit-to-content","dropdown__option":"fr-ec-dropdown__option","dropdownOption":"fr-ec-dropdown__option","dropdown__option-selected-icon":"fr-ec-dropdown__option-selected-icon","dropdownOptionSelectedIcon":"fr-ec-dropdown__option-selected-icon","dropdown__option--active":"fr-ec-dropdown__option--active","dropdownOptionActive":"fr-ec-dropdown__option--active","dropdown__option--required-placeholder":"fr-ec-dropdown__option--required-placeholder","dropdownOptionRequiredPlaceholder":"fr-ec-dropdown__option--required-placeholder","dropdown__option-media":"fr-ec-dropdown__option-media","dropdownOptionMedia":"fr-ec-dropdown__option-media","dropdown__icon":"fr-ec-dropdown__icon","dropdownIcon":"fr-ec-dropdown__icon","dropdown__label":"fr-ec-dropdown__label","dropdownLabel":"fr-ec-dropdown__label","dropdown__input--has-value":"fr-ec-dropdown__input--has-value","dropdownInputHasValue":"fr-ec-dropdown__input--has-value","dropdown__input--error":"fr-ec-dropdown__input--error","dropdownInputError":"fr-ec-dropdown__input--error","dropdown__input--with-placeholder":"fr-ec-dropdown__input--with-placeholder","dropdownInputWithPlaceholder":"fr-ec-dropdown__input--with-placeholder","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","dropdown__mobile-wrapper":"fr-ec-dropdown__mobile-wrapper","dropdownMobileWrapper":"fr-ec-dropdown__mobile-wrapper","dropdown__icon-mobile":"fr-ec-dropdown__icon-mobile","dropdownIconMobile":"fr-ec-dropdown__icon-mobile"};

var KEYCODE$1;

(function (KEYCODE) {
  KEYCODE[KEYCODE["DOWN"] = 40] = "DOWN";
  KEYCODE[KEYCODE["ENTER"] = 13] = "ENTER";
  KEYCODE[KEYCODE["ESC"] = 27] = "ESC";
  KEYCODE[KEYCODE["TAB"] = 9] = "TAB";
  KEYCODE[KEYCODE["UP"] = 38] = "UP";
})(KEYCODE$1 || (KEYCODE$1 = {}));

var DropdownComponent =
/** @class */
function (_super) {
  __extends(DropdownComponent, _super);

  function DropdownComponent(props) {
    var _this = _super.call(this, props) || this;

    _this.getSelectedValue = function () {
      var _a = _this.props,
          _b = _a.value,
          value = _b === void 0 ? '' : _b,
          _c = _a.options,
          options = _c === void 0 ? [] : _c,
          _d = _a.placeholder,
          placeholder = _d === void 0 ? '' : _d;

      if (value) {
        var selectedOption = options.find(function (item) {
          return item.value === value;
        });
        return selectedOption || {
          label: '',
          value: ''
        };
      } else {
        return placeholder ? {
          label: placeholder,
          media: undefined,
          value: ''
        } : __assign({}, options[0]);
      }
    };

    _this.getRenderOptions = function () {
      var mediaProps = {
        className: styles$5$1.dropdownOptionMedia,
        noImage: {
          imageType: 'euro'
        }
      };
      var _a = _this.props,
          placeholder = _a.placeholder,
          options = _a.options;
      var modifiedOptions = options.map(function (item) {
        var _a;

        return item.media ? __assign(__assign({}, item), {
          media: (_a = Children.map(item.media, function (child, i) {
            return /*#__PURE__*/cloneElement(child, mediaProps);
          })) === null || _a === void 0 ? void 0 : _a[0]
        }) : item;
      });
      return placeholder ? __spreadArrays([{
        label: placeholder,
        value: ''
      }], modifiedOptions) : modifiedOptions;
    };

    _this.globalClickListener = function () {
      if (_this.state.dropDownMenuVisible) {
        _this.setState({
          show: true,
          dropDownMenuVisible: false
        });
      } else {
        _this.setState({
          show: false,
          dropDownMenuVisible: false
        });
      }
    };

    _this.handleDropdownChange = function (item, notSelectable) {
      return function (event) {
        event.preventDefault();

        if (!notSelectable) {
          _this.setState({
            hoverItem: item,
            selected: item,
            show: false
          });

          if (_this.props.onChange) {
            _this.props.onChange(event, item.value);
          }
        }
      };
    };

    _this.setOptionsPostion = function () {
      var _a, _b;

      if (isInBrowser$1()) {
        var dropdownPosition = (_a = _this.dropdownRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        var dropdownListPosition = (_b = _this.dropdownListRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();

        if (dropdownListPosition && dropdownPosition) {
          var isVisible = dropdownPosition.bottom + 44 + dropdownListPosition.height <= window.innerHeight;

          if (isVisible) {
            _this.setState({
              showOptionBelow: true
            });
          } else {
            _this.setState({
              showOptionBelow: false
            });
          }

          if (_this.context) {
            /*
            this is for fixed positioned dropdown
            top value of the dropdown is added with the height of the dropdown input and the padding.
            Added width for dropdown select menu based on dropdown input width
             */
            var bottomVal = "calc(" + dropdownPosition.top + "px + 44px + 8px)";

            _this.setState({
              bottomVal: isVisible ? bottomVal : "calc(" + (window.innerHeight - dropdownPosition.bottom) + "px)",
              selectMenuWidth: dropdownPosition.width + "px"
            });
          }
        }
      }
    };

    _this.handleInputClick = function (event) {
      _this.setOptionsPostion();

      if (!_this.state.dropDownMenuVisible && _this.state.show) {
        _this.setState({
          dropDownMenuVisible: false,
          show: false
        });
      } else {
        _this.setState(function (prevState) {
          return {
            dropDownMenuVisible: !prevState.dropDownMenuVisible,
            hoverItem: _this.state.selected,
            show: !prevState.show
          };
        }, function () {
          if (_this.state.show) {
            document.addEventListener('click', _this.globalClickListener);
          }
        });
      }

      if (_this.props.onClick) {
        _this.props.onClick(event, _this.state.selected.value);
      }
    };

    _this.handleMouseDown = function (event) {
      if (event.keyCode === KEYCODE$1.TAB && !_this.state.show) {
        return false;
      }

      var hoverItem = _this.state.hoverItem;
      var _a = _this.props,
          placeholder = _a.placeholder,
          required = _a.required;

      var renderOptions = _this.getRenderOptions();

      var hoverIndex = renderOptions.findIndex(function (option) {
        return option.label === hoverItem.label;
      });

      if (event.keyCode === KEYCODE$1.ESC) {
        _this.setState({
          show: false,
          hoverItem: _this.state.selected
        });
      }

      if (event.keyCode === KEYCODE$1.ENTER && !(required && placeholder && placeholder === hoverItem.label)) {
        _this.setState({
          show: false,
          selected: hoverItem
        });

        if (_this.props.onChange) {
          _this.props.onChange(event, hoverItem.value);
        }
      }

      if (event.keyCode === KEYCODE$1.DOWN) {
        if (!_this.state.show) {
          _this.setOptionsPostion();

          _this.setState({
            show: true
          });
        } else if (hoverIndex + 1 < renderOptions.length) {
          _this.setState({
            hoverItem: renderOptions[hoverIndex + 1]
          }, function () {
            var _a;

            return (_a = document.querySelector("#option-" + (hoverIndex + 1))) === null || _a === void 0 ? void 0 : _a.focus();
          });
        }
      }

      if (event.keyCode === KEYCODE$1.UP && hoverIndex - 1 >= 0) {
        _this.setState({
          hoverItem: renderOptions[hoverIndex - 1]
        }, function () {
          var _a;

          return (_a = document.querySelector("#option-" + (hoverIndex - 1))) === null || _a === void 0 ? void 0 : _a.focus();
        });
      }

      return true;
    };

    _this.handleInputBlur = function (event) {
      var hasClass = event.relatedTarget !== null ? event.relatedTarget.classList.contains(styles$5$1.dropdownInput) : false;

      if (!_this.state.dropDownMenuVisible && !_this.state.show && event.relatedTarget !== null && !hasClass) {
        _this.setState({
          show: true,
          hoverItem: _this.state.selected
        });
      }

      if (_this.props.onBlur) {
        _this.props.onBlur(event, _this.state.selected.value);
      }
    };

    _this.handleChange = function (event) {
      _this.setState({
        hoverItem: {
          value: event.target.value,
          label: event.target.value
        },
        selected: {
          value: event.target.value,
          label: event.target.value
        }
      });

      if (_this.props.onChange) {
        _this.props.onChange(event, event.target.value);
      }
    };

    _this.handleSelectBlur = function (event) {
      if (_this.props.onBlur) {
        _this.props.onBlur(event, _this.state.selected.value);
      }
    };

    _this.state = {
      bottomVal: 'auto',
      dropDownMenuVisible: false,
      hoverItem: _this.getSelectedValue(),
      selectMenuWidth: '0px',
      selected: _this.getSelectedValue(),
      show: false,
      showOptionBelow: true
    };
    _this.dropdownRef = props.forwardRef || /*#__PURE__*/createRef();
    _this.dropdownListRef = /*#__PURE__*/createRef();
    return _this;
  }

  DropdownComponent.prototype.componentDidMount = function () {
    document.addEventListener('click', this.globalClickListener);
    window.addEventListener('scroll', this.setOptionsPostion);
    window.addEventListener('resize', this.setOptionsPostion);
  };

  DropdownComponent.prototype.componentWillUnmount = function () {
    document.removeEventListener('click', this.globalClickListener);
    window.removeEventListener('scroll', this.setOptionsPostion);
    window.removeEventListener('resize', this.setOptionsPostion);
  };

  DropdownComponent.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _a;

    if (prevProps.value !== this.props.value || prevProps.options !== this.props.options) {
      this.setState({
        selected: this.getSelectedValue()
      });
    }

    var dropdownPosition = (_a = this.dropdownRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();

    if (prevState.selectMenuWidth !== (dropdownPosition === null || dropdownPosition === void 0 ? void 0 : dropdownPosition.width) + "px") {
      this.setState({
        selectMenuWidth: (dropdownPosition === null || dropdownPosition === void 0 ? void 0 : dropdownPosition.width) + "px"
      });
    }
  };

  DropdownComponent.prototype.render = function () {
    var _this = this;

    var _a;

    var _b = this.props,
        placeholder = _b.placeholder,
        _c = _b.options,
        options = _c === void 0 ? [] : _c,
        hideLabel = _b.hideLabel,
        id = _b.id,
        label = _b.label,
        disabled = _b.disabled,
        required = _b.required,
        error = _b.error,
        helptext = _b.helptext,
        _d = _b.updateMaxHeight,
        updateMaxHeight = _d === void 0 ? false : _d,
        fitToContent = _b.fitToContent,
        className = _b.className,
        _e = _b.isNative,
        isNative = _e === void 0 ? false : _e,
        iconBrand = _b.iconBrand,
        dropdownMenuWidth = _b.dropdownMenuWidth,
        other = __rest(_b, ["placeholder", "options", "hideLabel", "id", "label", "disabled", "required", "onChange", "onBlur", "onClick", "forwardRef", "error", "helptext", "updateMaxHeight", "value", "fitToContent", "className", "isNative", "iconBrand", "dropdownMenuWidth", "optionPosition"]);

    var _g = this.state,
        selected = _g.selected;
    var iOSOrAndroid = getOS() === 'android' || getOS() === 'iOS';
    var hintErrorId = helptext || error ? id + "-hint-error" : undefined;
    var renderOptions = this.getRenderOptions();
    var dropdownContainerClasses = joinClasses(styles$5$1.dropdownContainer, fitToContent ? styles$5$1.dropdownContainerFitToContent : '');
    var inputClasses = joinClasses(resetStyles.maxWidthReset, styles$5$1.dropdownInput, typographyStyles.formText, selected.label === placeholder && !selected.value ? styles$5$1.dropdownInputWithPlaceholder : styles$5$1.dropdownInputHasValue, error ? styles$5$1.dropdownInputError : '');
    var dropDownPositioning = this.props.optionPosition === 'top' && this.props.updateMaxHeight ? {
      bottom: '79px',
      width: this.state.selectMenuWidth
    } : this.context ? this.state.showOptionBelow ? {
      top: this.state.bottomVal,
      width: this.state.selectMenuWidth
    } : {
      bottom: this.state.bottomVal,
      width: this.state.selectMenuWidth
    } : dropdownMenuWidth ? {
      width: dropdownMenuWidth + "px"
    } : {};
    var dropdownPosition = (_a = this.dropdownRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
    var isElementVisible = false;

    if (dropdownPosition) {
      isElementVisible = dropdownPosition.top >= 0 && dropdownPosition.left >= 0 && dropdownPosition.bottom <= (window.innerHeight || document.documentElement.clientHeight) && dropdownPosition.right <= (window.innerWidth || document.documentElement.clientWidth);
    }

    return /*#__PURE__*/createElement(Fragment, null, !(isNative && iOSOrAndroid) ? /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$5$1.dropdown, className)
    }, /*#__PURE__*/createElement("div", {
      className: dropdownContainerClasses
    }, !hideLabel && label && /*#__PURE__*/createElement(LabelInput, {
      htmlFor: id,
      label: label,
      element: "label",
      className: joinClasses(styles$5$1.dropdownLabel, resetStyles.maxWidthReset),
      disabled: disabled,
      required: required
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$5$1.dropdownInputContainer, fitToContent && styles$5$1.dropdownInputContainerFitToContent)
    }, /*#__PURE__*/createElement("select", __assign({
      className: joinClasses(inputClasses, styles$5$1.dropdownHiddenOptions),
      ref: this.dropdownRef,
      required: required,
      value: selected.value,
      // tslint:disable-next-line
      onChange: function onChange() {}
    }, other), placeholder &&
    /*#__PURE__*/
    // tslint:disable-next-line:react-a11y-role-has-required-aria-props
    createElement("option", {
      value: "",
      className: styles$5$1.dropdownHiddenOption,
      disabled: required
    }, placeholder), options.map(function (option, index) {
      return /*#__PURE__*/createElement("option", {
        value: option.value,
        key: index,
        className: styles$5$1.dropdownHiddenOption,
        "aria-selected": selected.value === option.value
      }, option.label);
    })), /*#__PURE__*/createElement("div", {
      className: styles$5$1.dropdownInputInnerContainer
    }, selected.media ? /*#__PURE__*/createElement(Fragment, null, selected.label && renderOptions.filter(function (item) {
      return item.value === selected.value;
    })[0].media, /*#__PURE__*/createElement("input", {
      value: selected.label,
      className: joinClasses(inputClasses, interactionsStyles.cursorPointer),
      onClick: this.handleInputClick,
      onKeyDown: this.handleMouseDown,
      disabled: disabled,
      required: required,
      onBlur: this.handleInputBlur,
      readOnly: true
    })) : /*#__PURE__*/createElement("input", {
      value: selected.label,
      className: joinClasses(inputClasses, interactionsStyles.cursorPointer),
      onClick: this.handleInputClick,
      onKeyDown: this.handleMouseDown,
      disabled: disabled,
      required: required,
      onBlur: this.handleInputBlur,
      readOnly: true
    }), /*#__PURE__*/createElement(Icon, {
      name: iconBrand ? iconBrand + "arrow-down" : 'arrow-down',
      className: styles$5$1.dropdownIcon
    })))), /*#__PURE__*/createElement("ul", {
      role: "listbox",
      className: joinClasses(styles$5$1.dropdownList, this.props.optionPosition === 'top' && this.props.updateMaxHeight ? styles$5$1.dropdownListOptionPositionTop : '', !this.state.showOptionBelow && styles$5$1.dropdownOptionPositioningTop, updateMaxHeight && styles$5$1.dropdownListMaxHeight, this.state.show ? this.context ? isElementVisible && styles$5$1.dropdownListShow : styles$5$1.dropdownListShow : ''),
      style: dropDownPositioning,
      ref: this.dropdownListRef
    }, renderOptions.map(function (item, index) {
      return /*#__PURE__*/createElement("li", {
        className: joinClasses(styles$5$1.dropdownOption, required && placeholder && index === 0 && styles$5$1.dropdownOptionRequiredPlaceholder, selected.label === item.label && selected.value === item.value && styles$5$1.dropdownOptionActive),
        onClick: _this.handleDropdownChange(item, Boolean(required && placeholder && index === 0)),
        role: "option",
        "aria-selected": selected.label === item.label,
        key: item.value,
        value: item.value,
        tabIndex: 0,
        id: "option-" + index,
        onKeyDown: _this.handleMouseDown
      }, /*#__PURE__*/createElement(Icon, {
        className: styles$5$1.dropdownOptionSelectedIcon,
        name: iconBrand ? iconBrand + "check-large" : 'check-large',
        size: "24",
        variant: "default"
      }), item.media ? /*#__PURE__*/createElement(ContentAlignment, {
        element: 'div',
        direction: 'row',
        alignment: "center"
      }, item.media, /*#__PURE__*/createElement("span", {
        className: typographyStyles.formText
      }, item.label)) : /*#__PURE__*/createElement("span", {
        className: typographyStyles.formText
      }, item.label));
    })), helptext || error ? /*#__PURE__*/createElement(HintError, {
      error: error,
      hint: helptext,
      id: hintErrorId,
      disabled: disabled
    }) : null) : /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$5$1.dropdown, className)
    }, /*#__PURE__*/createElement("div", {
      className: dropdownContainerClasses
    }, !hideLabel && label && /*#__PURE__*/createElement(LabelInput, {
      htmlFor: id,
      label: label,
      element: "label",
      className: joinClasses(styles$5$1.dropdownLabel, resetStyles.maxWidthReset),
      disabled: disabled,
      required: required
    }), /*#__PURE__*/createElement("div", {
      className: styles$5$1.dropdownMobileWrapper
    }, /*#__PURE__*/createElement("select", __assign({
      className: joinClasses(inputClasses),
      ref: this.dropdownRef,
      required: required,
      value: this.state.selected.value,
      disabled: disabled,
      // tslint:disable-next-line
      onChange: this.handleChange,
      onBlur: this.handleSelectBlur
    }, other), placeholder &&
    /*#__PURE__*/
    // tslint:disable-next-line:react-a11y-role-has-required-aria-props
    createElement("option", {
      value: "",
      disabled: required
    }, placeholder), options.map(function (option, index) {
      return /*#__PURE__*/createElement("option", {
        value: option.value,
        key: index,
        className: styles$5$1.dropdownHiddenOption,
        "aria-selected": selected.value === option.value
      }, option.label);
    })), /*#__PURE__*/createElement(Icon, {
      name: "arrow-down",
      className: joinClasses(styles$5$1.dropdownIcon, styles$5$1.dropdownIconMobile)
    }))), helptext || error ? /*#__PURE__*/createElement(HintError, {
      error: error,
      hint: helptext,
      id: hintErrorId,
      disabled: disabled
    }) : null));
  };

  DropdownComponent.contextType = DropDownContext;
  return DropdownComponent;
}(Component);

var Dropdown = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/createElement(DropdownComponent, __assign({
    forwardRef: ref
  }, props));
});
Dropdown.defaultProps = {
  hideLabel: false,
  isNative: false
};
Dropdown.displayName = 'CoreDropdown';

var styles$6$1 = {"cms-floating-ticker":"fr-ec-cms-floating-ticker","cmsFloatingTicker":"fr-ec-cms-floating-ticker","label":"fr-ec-label","caption":"fr-ec-caption","ticker__button":"fr-ec-ticker__button","tickerButton":"fr-ec-ticker__button"};

var getText$1 = function getText(text) {
  return text === null || text === void 0 ? void 0 : text.replace(/\\n|\n/g, '\n');
};

var CmsFloatingTicker = function CmsFloatingTicker(_a) {
  var message = _a.message,
      enableClose = _a.enableClose,
      linkUrl = _a.linkUrl,
      linkTarget = _a.linkTarget,
      onClose = _a.onClose,
      _b = _a.gaCategory,
      gaCategory = _b === void 0 ? '' : _b,
      _c = _a.gaLabel,
      gaLabel = _c === void 0 ? '' : _c,
      gaAction = _a.gaAction,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      className = _a.className,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["message", "enableClose", "linkUrl", "linkTarget", "onClose", "gaCategory", "gaLabel", "gaAction", "gaValue", "gaCallback", "className", "iconBrand"]);

  var _d = useState(true),
      isVisible = _d[0],
      setVisible = _d[1];

  var onTickerDismiss = function onTickerDismiss() {
    setVisible(false);

    if (onClose) {
      onClose();
    }
  };

  var rootTag = 'a';
  var absoluteUrlPattern = linkUrl && isAbsoluteUrl(linkUrl);
  var attributes = {};

  if (absoluteUrlPattern) {
    attributes = {
      href: linkUrl,
      target: linkTarget || '_blank'
    };
  } else if (linkUrl) {
    rootTag = Link$1; // Default target behaviour of Link is similar to that of '_self'.
    // But if you specify target property explicitly, it refreshes the page.
    // @ts-ignore

    attributes.to = linkUrl;

    if (linkTarget && linkTarget !== '_self') {
      // @ts-ignore
      attributes.target = linkTarget;
    }
  }

  return isVisible ? /*#__PURE__*/createElement(Ticker, __assign({
    variant: "secondary",
    closeButton: enableClose,
    className: joinClasses(className, styles$6$1.cmsFloatingTicker),
    onDismiss: onTickerDismiss,
    gaLabel: gaLabel,
    gaCategory: gaCategory,
    gaAction: gaAction,
    gaValue: gaValue,
    gaCallback: gaCallback,
    iconBrand: iconBrand
  }, props), linkUrl ? /*#__PURE__*/createElement(LinkText, __assign({
    element: rootTag,
    variant: "standalone-small",
    iconBrand: iconBrand
  }, attributes), getText$1(message)) : /*#__PURE__*/createElement(Body, {
    element: "span",
    key: "child-label",
    variant: "small"
  }, getText$1(message))) : null;
};
CmsFloatingTicker.displayName = 'CoreCmsFloatingTicker';
CmsFloatingTicker.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var styles$7$1 = {"flyout-navigation__column-wrapper":"fr-ec-flyout-navigation__column-wrapper","flyoutNavigationColumnWrapper":"fr-ec-flyout-navigation__column-wrapper","flyout-navigation__content-column-wrapper":"fr-ec-flyout-navigation__content-column-wrapper","flyoutNavigationContentColumnWrapper":"fr-ec-flyout-navigation__content-column-wrapper","flyout-navigation__content":"fr-ec-flyout-navigation__content","flyoutNavigationContent":"fr-ec-flyout-navigation__content","flyout-navigation__featured-column":"fr-ec-flyout-navigation__featured-column","flyoutNavigationFeaturedColumn":"fr-ec-flyout-navigation__featured-column","flyout-navigation":"fr-ec-flyout-navigation","flyoutNavigation":"fr-ec-flyout-navigation"};

var FlyoutNavigation = function FlyoutNavigation(_a) {
  var content = _a.content,
      aside = _a.aside,
      main = _a.main,
      className = _a.className,
      _b = _a.element,
      Element = _b === void 0 ? 'div' : _b,
      onDismiss = _a.onDismiss,
      _c = _a.modalCloseLabel,
      modalCloseLabel = _c === void 0 ? '' : _c,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["content", "aside", "main", "className", "element", "onDismiss", "modalCloseLabel", "iconBrand"]);

  return /*#__PURE__*/createElement(Element, __assign({
    className: joinClasses(styles$7$1.flyoutNavigation, className)
  }, props), /*#__PURE__*/createElement(LayoutWrapper, {
    element: "div"
  }, /*#__PURE__*/createElement(Layout, null, /*#__PURE__*/createElement("div", {
    className: styles$7$1.flyoutNavigationContent
  }, content, /*#__PURE__*/createElement(ButtonIcon, {
    iconSize: "24px",
    icon: "close-big",
    label: modalCloseLabel,
    element: "button",
    variant: "dark",
    onClick: onDismiss,
    iconBrand: iconBrand
  })), /*#__PURE__*/createElement("div", {
    className: styles$7$1.flyoutNavigationColumnWrapper
  }, /*#__PURE__*/createElement("div", {
    className: styles$7$1.flyoutNavigationContentColumnWrapper
  }, main), /*#__PURE__*/createElement("div", {
    className: styles$7$1.flyoutNavigationFeaturedColumn
  }, aside)))));
};
FlyoutNavigation.displayName = 'CoreFlyoutNavigation';
FlyoutNavigation.defaultProps = {
  element: 'div'
};

var styles$8$1 = {"image":"fr-ec-image","image__img":"fr-ec-image__img","imageImg":"fr-ec-image__img","image__no-image-container":"fr-ec-image__no-image-container","imageNoImageContainer":"fr-ec-image__no-image-container","image--ratio-1x1":"fr-ec-image--ratio-1x1","imageRatio1X1":"fr-ec-image--ratio-1x1","image--ratio-16x9":"fr-ec-image--ratio-16x9","imageRatio16X9":"fr-ec-image--ratio-16x9","image--ratio-4x3":"fr-ec-image--ratio-4x3","imageRatio4X3":"fr-ec-image--ratio-4x3","image--ratio-3x4":"fr-ec-image--ratio-3x4","imageRatio3X4":"fr-ec-image--ratio-3x4","image--ratio-3x1":"fr-ec-image--ratio-3x1","imageRatio3X1":"fr-ec-image--ratio-3x1","image--ratio-5x2":"fr-ec-image--ratio-5x2","imageRatio5X2":"fr-ec-image--ratio-5x2","image--ratio-6x1":"fr-ec-image--ratio-6x1","imageRatio6X1":"fr-ec-image--ratio-6x1","image--ratio-2x1":"fr-ec-image--ratio-2x1","imageRatio2X1":"fr-ec-image--ratio-2x1","image--full-width":"fr-ec-image--full-width","imageFullWidth":"fr-ec-image--full-width","no-image":"fr-ec-no-image","noImage":"fr-ec-no-image","image--bg-none":"fr-ec-image--bg-none","imageBgNone":"fr-ec-image--bg-none","image--fixed-height":"fr-ec-image--fixed-height","imageFixedHeight":"fr-ec-image--fixed-height","image__img--fixed-height":"fr-ec-image__img--fixed-height","imageImgFixedHeight":"fr-ec-image__img--fixed-height"};

var IMAGE_RATIO_1X1 = '1x1';
var IMAGE_RATIO_16X9 = '16x9';
var IMAGE_RATIO_3X4 = '3x4';
var IMAGE_RATIO_4X3 = '4x3';
var IMAGE_RATIO_2X1 = '2x1';
var IMAGE_RATIO_6X1 = '6x1';
var IMAGE_RATIO_3X1 = '3x1';
var IMAGE_RATIO_5X2 = '5x2';
var IMAGE_FULL_WIDTH = 'full-width';

var BaseImage =
/** @class */
function (_super) {
  __extends(BaseImage, _super);

  function BaseImage(props) {
    var _this = _super.call(this, props) || this;

    _this.elementRef = /*#__PURE__*/React__default.createRef();

    _this.onErrorHandler = function (event) {
      var noImage = _this.props.noImage;

      if (noImage && event.currentTarget.src !== noImage && typeof noImage === 'string') {
        _this.setState({
          imageUrl: noImage
        });
      } else {
        _this.setState({
          bgColor: true
        });
      }

      if (_this.props.onError) {
        _this.props.onError(event);
      } else {
        _this.setState({
          error: true
        });
      }
    };

    _this.onLoadHandler = function (event) {
      var bgColor = _this.state.bgColor;

      if (bgColor) {
        _this.setState({
          bgColor: false
        });
      }

      if (_this.props.onLoad) {
        _this.props.onLoad(event);
      }

      if (_this.elementRef && _this.elementRef.current && _this.state.imageUrl && _this.elementRef.current.naturalWidth) {
        _this.setState({
          loadingComplete: true
        });
      }
    };

    _this.state = {
      bgColor: false,
      error: false,
      imageUrl: props.src
    };
    return _this;
  }

  BaseImage.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.src !== prevProps.src) {
      this.setState({
        error: false,
        imageUrl: this.props.src
      });
    }
  };

  BaseImage.prototype.render = function () {
    var _a;

    var _b = this.props,
        alt = _b.alt,
        loading = _b.loading,
        _c = _b.ratio,
        ratio = _c === void 0 ? IMAGE_RATIO_1X1 : _c,
        className = _b.className,
        noImage = _b.noImage,
        iconBrand = _b.iconBrand,
        _d = _b.heightInPx,
        heightInPx = _d === void 0 ? 20 : _d,
        props = __rest(_b, ["alt", "loading", "ratio", "className", "noImage", "iconBrand", "src", "heightInPx"]);

    var imgProps = {
      alt: alt,
      className: ratio !== 'fixed-height' ? styles$8$1.imageImg : styles$8$1.imageImgFixedHeight,
      loading: loading,
      onError: this.onErrorHandler,
      onLoad: this.onLoadHandler,
      src: this.state.imageUrl
    };
    var ratioToStyle = (_a = {}, _a[IMAGE_RATIO_16X9] = styles$8$1.imageRatio16X9, _a[IMAGE_RATIO_1X1] = styles$8$1.imageRatio1X1, _a[IMAGE_RATIO_3X4] = styles$8$1.imageRatio3X4, _a[IMAGE_RATIO_4X3] = styles$8$1.imageRatio4X3, _a[IMAGE_RATIO_3X1] = styles$8$1.imageRatio3X1, _a[IMAGE_RATIO_2X1] = styles$8$1.imageRatio2X1, _a[IMAGE_RATIO_6X1] = styles$8$1.imageRatio6X1, _a[IMAGE_RATIO_5X2] = styles$8$1.imageRatio5X2, _a[IMAGE_FULL_WIDTH] = styles$8$1.imageFullWidth, _a);
    var imageContainerStyle = this.state.bgColor ? joinClasses(styles$8$1.image, styles$8$1.imageNoImageContainer, ratioToStyle[ratio], className) : joinClasses(styles$8$1.image, ratioToStyle[ratio], className);
    var fixedHeight = ratio === 'fixed-height' && heightInPx + "px";
    var renderImage = this.state.error && _typeof(noImage) === 'object' ? /*#__PURE__*/React__default.createElement("div", __assign({
      className: joinClasses(styles$8$1.image, ratioToStyle[ratio], className)
    }, props), /*#__PURE__*/React__default.createElement(NoImage, __assign({
      iconBrand: iconBrand
    }, noImage))) : fixedHeight ? /*#__PURE__*/React__default.createElement("div", {
      className: joinClasses(styles$8$1.imageFixedHeight, className),
      style: {
        height: fixedHeight
      }
    }, /*#__PURE__*/React__default.createElement("img", __assign({}, imgProps))) : /*#__PURE__*/React__default.createElement("div", __assign({
      style: this.state.bgColor ? {
        backgroundColor: '#DADADA'
      } : {
        backgroundImage: "url(" + this.state.imageUrl + ")"
      },
      className: joinClasses(imageContainerStyle, this.state.loadingComplete && styles$8$1.imageBgNone)
    }, props), /*#__PURE__*/React__default.createElement("img", __assign({}, imgProps, {
      ref: this.elementRef
    })));
    return renderImage;
  };

  BaseImage.displayName = 'CoreImage';
  BaseImage.defaultProps = {
    disabled: false,
    loadingComplete: false,
    unavailable: false
  };
  return BaseImage;
}(Component);

var Image = function Image(_a) {
  var src = _a.src,
      ratio = _a.ratio,
      noImage = _a.noImage,
      alt = _a.alt,
      altText = _a.altText,
      className = _a.className,
      _b = _a.noImageLabel,
      noImageLabel = _b === void 0 ? '' : _b,
      smallMediumImageRatio = _a.smallMediumImageRatio,
      smallMediumImageUrl = _a.smallMediumImageUrl,
      largeImageRatio = _a.largeImageRatio,
      largeImageUrl = _a.largeImageUrl,
      _c = _a.heightInPx,
      heightInPx = _c === void 0 ? 20 : _c,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["src", "ratio", "noImage", "alt", "altText", "className", "noImageLabel", "smallMediumImageRatio", "smallMediumImageUrl", "largeImageRatio", "largeImageUrl", "heightInPx", "iconBrand"]);

  var width = getViewportWidth();
  var smallMediumImageRatioValue = smallMediumImageRatio || largeImageRatio || '1x1';
  var largeImageRatioValue = largeImageRatio || smallMediumImageRatio || '2x1';
  var smallMediumImageUrlValue = smallMediumImageUrl || largeImageUrl || '';
  var largeImageUrlValue = largeImageUrl || smallMediumImageUrl || '';

  if (src) {
    return /*#__PURE__*/React__default.createElement(BaseImage, __assign({
      src: src,
      ratio: ratio,
      alt: alt,
      className: className,
      noImage: noImage,
      key: 'image-key',
      iconBrand: iconBrand,
      heightInPx: heightInPx
    }, props));
  } else if (width > designTokens_3.mqMediumScreenMaxWidthLimit) {
    return /*#__PURE__*/React__default.createElement(BaseImage, __assign({
      src: largeImageUrlValue,
      ratio: largeImageRatioValue,
      alt: altText,
      className: className,
      noImage: {
        imageSize: 'large',
        imageType: 'icon',
        noImageLabel: noImageLabel
      },
      key: 'large-image-key',
      iconBrand: iconBrand
    }, props));
  } else {
    return /*#__PURE__*/React__default.createElement(BaseImage, __assign({
      src: smallMediumImageUrlValue,
      ratio: smallMediumImageRatioValue,
      alt: altText,
      noImage: {
        imageSize: 'default',
        imageType: 'icon',
        noImageLabel: noImageLabel
      },
      className: className,
      key: 'small-medium-image-key',
      iconBrand: iconBrand
    }, props));
  }
};
Image.displayName = 'CoreImage';
Image.defaultProps = {
  disabled: false,
  loadingComplete: false,
  unavailable: false
};

var styles$9$1 = {"label-input":"fr-ec-label-input","labelInput":"fr-ec-label-input","label-input__required-badge":"fr-ec-label-input__required-badge","labelInputRequiredBadge":"fr-ec-label-input__required-badge","lang-ja":"fr-ec-lang-ja","langJa":"fr-ec-lang-ja"};

var LabelInput = function LabelInput(_a) {
  var children = _a.children,
      label = _a.label,
      required = _a.required,
      className = _a.className,
      disabled = _a.disabled,
      _b = _a.element,
      element = _b === void 0 ? 'label' : _b,
      props = __rest(_a, ["children", "label", "required", "className", "disabled", "element"]);

  return /*#__PURE__*/createElement("div", {
    className: joinClasses(className, styles$9$1.labelInput)
  }, element === 'label' ? /*#__PURE__*/createElement(Label, __assign({
    element: "label",
    variant: "standard"
  }, props, {
    color: disabled ? 'disabled' : 'primary-dark'
  }), label, required && /*#__PURE__*/createElement("span", {
    className: styles$9$1.labelInputRequiredBadge
  })) : /*#__PURE__*/createElement(Body, __assign({
    element: "span",
    variant: "standard"
  }, props, {
    color: disabled ? 'disabled' : 'primary-dark'
  }), label, required && /*#__PURE__*/createElement("span", {
    className: styles$9$1.labelInputRequiredBadge
  })), children);
};
LabelInput.displayName = 'CoreLabelInput';
LabelInput.defaultProps = {
  element: 'label'
};

var styles$a$1 = {"link-text":"fr-ec-link-text","linkText":"fr-ec-link-text","body--underlined":"fr-ec-body--underlined","bodyUnderlined":"fr-ec-body--underlined","body--small-underlined":"fr-ec-body--small-underlined","bodySmallUnderlined":"fr-ec-body--small-underlined","link-text--standalone-primary":"fr-ec-link-text--standalone-primary","linkTextStandalonePrimary":"fr-ec-link-text--standalone-primary","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","link-text__icon--start":"fr-ec-link-text__icon--start","linkTextIconStart":"fr-ec-link-text__icon--start","link-text__icon--end":"fr-ec-link-text__icon--end","linkTextIconEnd":"fr-ec-link-text__icon--end","link-text--inline":"fr-ec-link-text--inline","linkTextInline":"fr-ec-link-text--inline","link-text--inline-secondary":"fr-ec-link-text--inline-secondary","linkTextInlineSecondary":"fr-ec-link-text--inline-secondary","body":"fr-ec-body","link-text--standalone-secondary":"fr-ec-link-text--standalone-secondary","linkTextStandaloneSecondary":"fr-ec-link-text--standalone-secondary","link-text--disabled":"fr-ec-link-text--disabled","linkTextDisabled":"fr-ec-link-text--disabled","link-text--with-icon":"fr-ec-link-text--with-icon","linkTextWithIcon":"fr-ec-link-text--with-icon"};

var iconPositionStyle = {
  end: styles$a$1.linkTextIconEnd,
  start: styles$a$1.linkTextIconStart
};
var LinkText = function LinkText(_a) {
  var Element = _a.element,
      _b = _a.variant,
      variant = _b === void 0 ? 'standalone-primary' : _b,
      className = _a.className,
      children = _a.children,
      icon = _a.icon,
      disabled = _a.disabled,
      ariaLabel = _a.ariaLabel,
      href = _a.href,
      to = _a.to,
      _c = _a.iconPosition,
      iconPosition = _c === void 0 ? 'start' : _c,
      gaAction = _a.gaAction,
      gaCategory = _a.gaCategory,
      gaLabel = _a.gaLabel,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      onClick = _a.onClick,
      _d = _a.wordBreak,
      wordBreak = _d === void 0 ? 'none' : _d,
      iconBrand = _a.iconBrand,
      _e = _a.target,
      target = _e === void 0 ? '_self' : _e,
      props = __rest(_a, ["element", "variant", "className", "children", "icon", "disabled", "ariaLabel", "href", "to", "iconPosition", "gaAction", "gaCategory", "gaLabel", "gaValue", "gaCallback", "onClick", "wordBreak", "iconBrand", "target"]);

  var gaProps = null;

  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };

    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }

  var iconTemplate = icon && /*#__PURE__*/createElement(Icon, {
    name: iconBrand ? "" + iconBrand + icon : icon,
    key: iconPosition,
    className: joinClasses(disabled && styles$a$1.linkTextDisabled, iconPositionStyle[iconPosition])
  });
  var renderChildrenWithoutStandaloneSecondaryText = /*#__PURE__*/createElement(Body, {
    element: "span",
    variant: "underlined",
    key: "child-label"
  }, children);
  var renderChildrenWithInlineSecondaryText = /*#__PURE__*/createElement(Body, {
    element: "span",
    variant: "small",
    key: "child-label"
  }, children);
  var renderChildrenWithStandaloneSecondaryText = /*#__PURE__*/createElement(Body, {
    element: "span",
    className: disabled ? styles$a$1.linkTextDisabled : '',
    variant: "standard",
    key: "child-label"
  }, children);
  var renderChildrenWithStandaloneSmallText = /*#__PURE__*/createElement(Body, {
    element: "span",
    variant: "small-underlined",
    key: "child-label"
  }, children);
  var renderChildrenWithStandaloneTitleLarge = /*#__PURE__*/createElement(Title, {
    element: "span",
    variant: "large-underlined",
    key: "child-label"
  }, children);

  var onClickHandler = function onClickHandler(e) {
    // Reduce the header height if the header element is present
    if (isInBrowser()) {
      var headerEl = document.getElementsByTagName('header')[0];
      var headerOffset = 0;
      var offsetVal = 16;

      if (headerEl) {
        headerOffset = headerEl.offsetHeight;
      }

      if (href && href[0] === '#') {
        e.preventDefault();
        var btn = document.getElementById(href.slice(1));

        if (btn) {
          var offset = btn.offsetTop;
          window.scrollTo({
            behavior: 'smooth',
            left: 0,
            top: offset - (headerOffset + offsetVal)
          });
        }
      }
    } // For callback


    if (onClick) {
      onClick(e);
    } // For event tracking


    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    }
  };

  var renderChildren = variant === 'standalone-secondary' ? renderChildrenWithStandaloneSecondaryText : variant === 'standalone-small' ? renderChildrenWithStandaloneSmallText : variant === 'inline-secondary' ? renderChildrenWithInlineSecondaryText : variant === 'standalone-title-large' ? renderChildrenWithStandaloneTitleLarge : renderChildrenWithoutStandaloneSecondaryText;
  return (
    /*#__PURE__*/
    // @ts-ignore
    createElement(Element, __assign({
      className: joinClasses(styles$a$1.linkText, styles$a$1["link-text--" + variant], icon && styles$a$1.linkTextWithIcon, disabled && styles$a$1.linkTextDisabled, interactionsStyles.cursorPointer, Element === 'button' && resetStyles.buttonReset, addWordBreak(wordBreak === 'break-word'), className),
      role: "link",
      "aria-label": ariaLabel || children,
      "aria-disabled": disabled,
      disabled: disabled,
      onClick: onClickHandler
    }, !disabled ? {
      href: href,
      to: to
    } : {}, Element !== 'button' && {
      target: target
    }, props, gaProps), icon ? /*#__PURE__*/createElement(ContentAlignment, {
      element: "span",
      direction: "row",
      alignment: "center"
    }, iconPosition === 'end' ? [renderChildren, iconTemplate] : [iconTemplate, renderChildren]) : renderChildren)
  );
};
LinkText.displayName = 'CoreLinkText';
LinkText.defaultProps = {
  disabled: false,
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null,
  iconPosition: 'start',
  variant: 'standalone-primary'
};

var styles$b$1 = {"link-region__text":"fr-ec-link-region__text","linkRegionText":"fr-ec-link-region__text","body--underlined":"fr-ec-body--underlined","bodyUnderlined":"fr-ec-body--underlined","body--small-underlined":"fr-ec-body--small-underlined","bodySmallUnderlined":"fr-ec-body--small-underlined","link-region__text-disabled":"fr-ec-link-region__text-disabled","linkRegionTextDisabled":"fr-ec-link-region__text-disabled"};

var LinkRegion = function LinkRegion(_a) {
  var label = _a.label,
      _b = _a.ariaLabel,
      ariaLabel = _b === void 0 ? "Selected region " + label : _b,
      gaAction = _a.gaAction,
      gaCategory = _a.gaCategory,
      gaLabel = _a.gaLabel,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      className = _a.className,
      iconBrand = _a.iconBrand,
      disabled = _a.disabled,
      target = _a.target,
      props = __rest(_a, ["label", "ariaLabel", "gaAction", "gaCategory", "gaLabel", "gaValue", "gaCallback", "className", "iconBrand", "disabled", "target"]);

  return /*#__PURE__*/createElement(ContentAlignment, {
    element: "span",
    direction: "row",
    alignment: "center",
    className: className
  }, /*#__PURE__*/createElement(Icon, {
    name: iconBrand ? iconBrand + "global" : 'global',
    className: joinClasses(disabled && styles$b$1.linkRegionTextDisabled)
  }), /*#__PURE__*/createElement(LinkText, __assign({
    className: joinClasses(styles$b$1.linkRegionText, disabled && styles$b$1.linkRegionTextDisabled),
    "aria-label": ariaLabel,
    gaLabel: gaLabel,
    gaCategory: gaCategory,
    gaAction: gaAction,
    gaValue: gaValue,
    gaCallback: gaCallback
  }, target && {
    target: target
  }, props), label));
};
LinkRegion.displayName = 'CoreLinkRegion';
LinkRegion.defaultProps = {
  disabled: false,
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var styles$c$1 = {"style-user-info":"fr-ec-style-user-info","styleUserInfo":"fr-ec-style-user-info","style-user-info-large":"fr-ec-style-user-info-large","styleUserInfoLarge":"fr-ec-style-user-info-large","style-user-info-container":"fr-ec-style-user-info-container","styleUserInfoContainer":"fr-ec-style-user-info-container","style-user-info-image":"fr-ec-style-user-info-image","styleUserInfoImage":"fr-ec-style-user-info-image","style-user-info-large-container":"fr-ec-style-user-info-large-container","styleUserInfoLargeContainer":"fr-ec-style-user-info-large-container","style-user-info-link":"fr-ec-style-user-info-link","styleUserInfoLink":"fr-ec-style-user-info-link","tile":"fr-ec-tile","caption":"fr-ec-caption","style-user-info-name":"fr-ec-style-user-info-name","styleUserInfoName":"fr-ec-style-user-info-name","style-user-info-image--small":"fr-ec-style-user-info-image--small","styleUserInfoImageSmall":"fr-ec-style-user-info-image--small","style-user-info-image--large":"fr-ec-style-user-info-image--large","styleUserInfoImageLarge":"fr-ec-style-user-info-image--large","style-user-info-image--default":"fr-ec-style-user-info-image--default","styleUserInfoImageDefault":"fr-ec-style-user-info-image--default","style-user-info-instaImage--small":"fr-ec-style-user-info-instaImage--small","styleUserInfoInstaImageSmall":"fr-ec-style-user-info-instaImage--small","style-user-info-instaImage--large":"fr-ec-style-user-info-instaImage--large","styleUserInfoInstaImageLarge":"fr-ec-style-user-info-instaImage--large","style-user-info-instaImage--default":"fr-ec-style-user-info-instaImage--default","styleUserInfoInstaImageDefault":"fr-ec-style-user-info-instaImage--default","style-user-info-size-wrapper":"fr-ec-style-user-info-size-wrapper","styleUserInfoSizeWrapper":"fr-ec-style-user-info-size-wrapper","style-user-info-section":"fr-ec-style-user-info-section","styleUserInfoSection":"fr-ec-style-user-info-section","style-user-info-section--small":"fr-ec-style-user-info-section--small","styleUserInfoSectionSmall":"fr-ec-style-user-info-section--small","style-user-info-section--default":"fr-ec-style-user-info-section--default","styleUserInfoSectionDefault":"fr-ec-style-user-info-section--default","style-user-info-name--default":"fr-ec-style-user-info-name--default","styleUserInfoNameDefault":"fr-ec-style-user-info-name--default","style-user-info-name--small":"fr-ec-style-user-info-name--small","styleUserInfoNameSmall":"fr-ec-style-user-info-name--small","style-user-info-profile_name":"fr-ec-style-user-info-profile_name","styleUserInfoProfileName":"fr-ec-style-user-info-profile_name","style-user-info-profile_name--with-icon":"fr-ec-style-user-info-profile_name--with-icon","styleUserInfoProfileNameWithIcon":"fr-ec-style-user-info-profile_name--with-icon","style-user-info-profile_name--without-icon":"fr-ec-style-user-info-profile_name--without-icon","styleUserInfoProfileNameWithoutIcon":"fr-ec-style-user-info-profile_name--without-icon","style-user-info-size":"fr-ec-style-user-info-size","styleUserInfoSize":"fr-ec-style-user-info-size","style-user-info-profile-image":"fr-ec-style-user-info-profile-image","styleUserInfoProfileImage":"fr-ec-style-user-info-profile-image","style-user-info-date":"fr-ec-style-user-info-date","styleUserInfoDate":"fr-ec-style-user-info-date","style-user-info-review":"fr-ec-style-user-info-review","styleUserInfoReview":"fr-ec-style-user-info-review","style-user-info-review--large":"fr-ec-style-user-info-review--large","styleUserInfoReviewLarge":"fr-ec-style-user-info-review--large","style-user-info-date--large":"fr-ec-style-user-info-date--large","styleUserInfoDateLarge":"fr-ec-style-user-info-date--large","style-user-info-review--small":"fr-ec-style-user-info-review--small","styleUserInfoReviewSmall":"fr-ec-style-user-info-review--small","style-user-info-date--small":"fr-ec-style-user-info-date--small","styleUserInfoDateSmall":"fr-ec-style-user-info-date--small","style-user-info__carousel-image":"fr-ec-style-user-info__carousel-image","styleUserInfoCarouselImage":"fr-ec-style-user-info__carousel-image","style-user-info__carousel-profile-name":"fr-ec-style-user-info__carousel-profile-name","styleUserInfoCarouselProfileName":"fr-ec-style-user-info__carousel-profile-name","style-user-info__carousel-size":"fr-ec-style-user-info__carousel-size","styleUserInfoCarouselSize":"fr-ec-style-user-info__carousel-size","style-user-info-icon":"fr-ec-style-user-info-icon","styleUserInfoIcon":"fr-ec-style-user-info-icon","style-user-info__carousel-size-details":"fr-ec-style-user-info__carousel-size-details","styleUserInfoCarouselSizeDetails":"fr-ec-style-user-info__carousel-size-details","style-user-info__carousel-name":"fr-ec-style-user-info__carousel-name","styleUserInfoCarouselName":"fr-ec-style-user-info__carousel-name","style-user-info__carousel-section":"fr-ec-style-user-info__carousel-section","styleUserInfoCarouselSection":"fr-ec-style-user-info__carousel-section","style-user-info-carousel-size-width":"fr-ec-style-user-info-carousel-size-width","styleUserInfoCarouselSizeWidth":"fr-ec-style-user-info-carousel-size-width"};

var StyleUserInfo = function StyleUserInfo(_a) {
  var className = _a.className,
      profileImage = _a.profileImage,
      _b = _a.userName,
      userName = _b === void 0 ? '' : _b,
      storeInfo = _a.storeInfo,
      approvedDate = _a.approvedDate,
      heightUnit = _a.heightUnit,
      modelHeight = _a.modelHeight,
      _c = _a.variant,
      variant = _c === void 0 ? 'default' : _c,
      userReview = _a.userReview,
      size = _a.size,
      sizeText = _a.sizeText,
      approvedDateText = _a.approvedDateText,
      _d = _a.isBadge,
      isBadge = _d === void 0 ? false : _d,
      storeLink = _a.storeLink,
      personalPageLink = _a.personalPageLink,
      _e = _a.labelElement,
      labelElement = _e === void 0 ? 'span' : _e,
      userNameGaAction = _a.userNameGaAction,
      storeNameGaAction = _a.storeNameGaAction,
      gaCategory = _a.gaCategory,
      userNameGaLabel = _a.userNameGaLabel,
      storeNameGaLabel = _a.storeNameGaLabel,
      gaCallback = _a.gaCallback,
      gaValue = _a.gaValue,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["className", "profileImage", "userName", "storeInfo", "approvedDate", "heightUnit", "modelHeight", "variant", "userReview", "size", "sizeText", "approvedDateText", "isBadge", "storeLink", "personalPageLink", "labelElement", "userNameGaAction", "storeNameGaAction", "gaCategory", "userNameGaLabel", "storeNameGaLabel", "gaCallback", "gaValue", "iconBrand"]);

  var captionVariant = {
    "default": 'small',
    large: 'large',
    small: 'standard'
  };
  var instaImage = /*#__PURE__*/createElement(Image, {
    key: "0",
    alt: "Accessibility",
    ratio: "1x1",
    src: "https://asset.uniqlo.com/g/pictures/instagram-gradient.png",
    noImage: {
      imageSize: 'smallest',
      imageType: 'user'
    },
    iconBrand: iconBrand
  });
  var isDefault = variant === 'default';
  var isLarge = variant === 'large';
  var image = profileImage ? profileImage : instaImage;
  var profileImageContainer = personalPageLink ? /*#__PURE__*/createElement(Tile, {
    className: styles$c$1.styleUserInfoLink,
    gaLabel: userNameGaLabel,
    gaCategory: gaCategory,
    gaAction: userNameGaAction,
    gaValue: gaValue,
    gaCallback: gaCallback,
    href: personalPageLink,
    target: "_self"
  }, /*#__PURE__*/createElement("div", {
    className: profileImage ? joinClasses(styles$c$1.styleUserInfoImage, styles$c$1["style-user-info-image--" + variant]) : joinClasses(styles$c$1.styleUserInfoImage, styles$c$1["style-user-info-image--" + variant], styles$c$1["style-user-info-instaImage--" + variant])
  }, image)) : /*#__PURE__*/createElement("div", {
    className: styles$c$1.styleUserInfoLink
  }, /*#__PURE__*/createElement("div", {
    className: profileImage ? joinClasses(styles$c$1.styleUserInfoImage, styles$c$1["style-user-info-image--" + variant]) : joinClasses(styles$c$1.styleUserInfoImage, styles$c$1["style-user-info-image--" + variant], styles$c$1["style-user-info-instaImage--" + variant])
  }, image));

  var profileNameSection = function profileNameSection() {
    return /*#__PURE__*/createElement(ContentAlignment, {
      element: "div",
      direction: "row",
      alignment: "baseline",
      className: joinClasses(styles$c$1.styleUserInfoName, styles$c$1["style-user-info-name--" + variant])
    }, personalPageLink ? /*#__PURE__*/createElement(Tile, {
      className: styles$c$1.styleUserInfoLink,
      gaLabel: userNameGaLabel,
      gaCategory: gaCategory,
      gaAction: userNameGaAction,
      gaValue: gaValue,
      gaCallback: gaCallback,
      href: personalPageLink,
      target: "_self"
    }, /*#__PURE__*/createElement(Caption, {
      variant: captionVariant[variant],
      element: labelElement,
      className: joinClasses(styles$c$1.styleUserInfoProfileName, isBadge && !isDefault ? styles$c$1.styleUserInfoProfileNameWithIcon : styles$c$1.styleUserInfoProfileNameWithoutIcon)
    }, userName)) : /*#__PURE__*/createElement("div", {
      className: styles$c$1.styleUserInfoLink
    }, /*#__PURE__*/createElement(Caption, {
      variant: captionVariant[variant],
      element: labelElement,
      className: joinClasses(styles$c$1.styleUserInfoProfileName, isBadge && !isDefault ? styles$c$1.styleUserInfoProfileNameWithIcon : styles$c$1.styleUserInfoProfileNameWithoutIcon)
    }, userName)), isBadge && !isDefault && /*#__PURE__*/createElement(Icon, {
      name: iconBrand ? iconBrand + "verified-badge" : 'verified-badge',
      className: styles$c$1.styleUserInfoIcon
    }), modelHeight && (personalPageLink ? /*#__PURE__*/createElement(Tile, {
      className: joinClasses(styles$c$1.styleUserInfoLink, styles$c$1.styleUserInfoSizeWrapper),
      gaLabel: userNameGaLabel,
      gaCategory: gaCategory,
      gaAction: userNameGaAction,
      gaValue: gaValue,
      gaCallback: gaCallback,
      href: personalPageLink,
      target: "_self"
    }, /*#__PURE__*/createElement(Caption, {
      element: "p",
      variant: captionVariant[variant],
      className: joinClasses(styles$c$1.styleUserInfoSize, modelHeight === '-' ? styles$c$1.styleUserInfoCarouselSizeWidth : null)
    }, "" + (modelHeight || '-') + (heightUnit || ''))) : /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$c$1.styleUserInfoLink, styles$c$1.styleUserInfoSizeWrapper)
    }, /*#__PURE__*/createElement(Caption, {
      element: "p",
      variant: captionVariant[variant],
      className: joinClasses(styles$c$1.styleUserInfoSize, modelHeight === '-' ? styles$c$1.styleUserInfoCarouselSizeWidth : null)
    }, "" + (modelHeight || '-') + (heightUnit || '')))));
  };

  var imageSection = /*#__PURE__*/createElement(ContentAlignment, {
    element: "section",
    direction: "row",
    className: styles$c$1.styleUserInfoContainer
  }, !isLarge && profileImageContainer, /*#__PURE__*/createElement("section", {
    className: joinClasses(styles$c$1.styleUserInfoSection, styles$c$1["style-user-info-section--" + variant])
  }, profileNameSection(), storeInfo && (storeLink ? /*#__PURE__*/createElement(Tile, {
    className: styles$c$1.styleUserInfoLink,
    gaLabel: storeNameGaLabel,
    gaCategory: gaCategory,
    gaAction: storeNameGaAction,
    gaValue: gaValue,
    gaCallback: gaCallback,
    href: storeLink,
    target: "_self"
  }, /*#__PURE__*/createElement(Caption, {
    element: "p",
    variant: "small",
    color: "secondary"
  }, storeInfo)) : /*#__PURE__*/createElement("div", {
    className: styles$c$1.styleUserInfoLink
  }, /*#__PURE__*/createElement(Caption, {
    element: "p",
    variant: "small",
    color: "secondary"
  }, storeInfo))), isDefault && size && /*#__PURE__*/createElement(Caption, {
    element: "p",
    variant: "extra-small",
    className: styles$c$1.styleUserInfoCarouselSizeDetails
  }, "" + (sizeText || '') + (size || '-'))));
  return /*#__PURE__*/createElement(ContentAlignment, __assign({
    element: "section",
    direction: "column",
    className: joinClasses(styles$c$1.styleUserInfo, isLarge && styles$c$1.styleUserInfoLarge, className)
  }, props), isLarge && profileImageContainer, /*#__PURE__*/createElement("div", {
    className: isLarge && styles$c$1.styleUserInfoLargeContainer || ''
  }, imageSection, !isDefault && userReview && /*#__PURE__*/createElement(Caption, {
    element: "p",
    variant: "standard",
    className: joinClasses(styles$c$1.styleUserInfoReview, styles$c$1["style-user-info-review--" + variant])
  }, userReview), !isDefault && approvedDate && /*#__PURE__*/createElement(Caption, {
    element: "p",
    variant: "small",
    className: joinClasses(styles$c$1.styleUserInfoDate, styles$c$1["style-user-info-date--" + variant])
  }, approvedDate + " " + (approvedDateText || ''))));
};
StyleUserInfo.displayName = 'CoreStyleUserInfo';
StyleUserInfo.defaultProps = {
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaValue: null,
  storeNameGaAction: 'click',
  storeNameGaLabel: '',
  userName: '',
  userNameGaAction: 'click',
  userNameGaLabel: ''
};

var styles$d$1 = {"cms-media-carousel--normal":"fr-ec-cms-media-carousel--normal","cmsMediaCarouselNormal":"fr-ec-cms-media-carousel--normal","media-carousel":"fr-ec-media-carousel","mediaCarousel":"fr-ec-media-carousel"};

var CmsMediaCarousel = function CmsMediaCarousel(_a) {
  var children = _a.children,
      _b = _a.carouselType,
      carouselType = _b === void 0 ? 'normal' : _b,
      _c = _a.autoplay,
      autoplay = _c === void 0 ? false : _c,
      delay = _a.delay,
      id = _a.id,
      _d = _a.hasArrows,
      hasArrows = _d === void 0 ? true : _d,
      gaCategory = _a.gaCategory,
      gaLabel = _a.gaLabel,
      className = _a.className,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["children", "carouselType", "autoplay", "delay", "id", "hasArrows", "gaCategory", "gaLabel", "className", "iconBrand"]);

  return /*#__PURE__*/createElement(Fragment, null, carouselType === 'normal' ? /*#__PURE__*/createElement(Carousel, __assign({
    className: className,
    autoSlide: autoplay,
    autoSlideInterval: delay,
    variant: "default",
    id: id,
    gaCategory: gaCategory,
    gaLabel: gaLabel,
    hasArrows: hasArrows,
    iconBrand: iconBrand
  }, props), children) : /*#__PURE__*/createElement(MediaCarousel, __assign({
    children: children,
    autoplay: autoplay,
    delay: delay,
    id: id,
    gaCategory: gaCategory,
    gaLabel: gaLabel,
    hasArrows: hasArrows,
    className: joinClasses(className, carouselType === 'mediaBanner' ? styles$d$1.cmsMediaCarouselNormal : ''),
    iconBrand: iconBrand
  }, props)));
};
CmsMediaCarousel.displayName = 'CoreCmsMediaCarousel';

var styles$e$1 = {"navigation-header":"fr-ec-navigation-header","navigationHeader":"fr-ec-navigation-header","link-primary-nav":"fr-ec-link-primary-nav","linkPrimaryNav":"fr-ec-link-primary-nav","link-primary-nav__text-wrapper":"fr-ec-link-primary-nav__text-wrapper","linkPrimaryNavTextWrapper":"fr-ec-link-primary-nav__text-wrapper","navigation-header__overlay":"fr-ec-navigation-header__overlay","navigationHeaderOverlay":"fr-ec-navigation-header__overlay","overlay-backdrop":"fr-ec-overlay-backdrop","overlayBackdrop":"fr-ec-overlay-backdrop","navigation-header-menu":"fr-ec-navigation-header-menu","navigationHeaderMenu":"fr-ec-navigation-header-menu","navigation-header__search-wrapper":"fr-ec-navigation-header__search-wrapper","navigationHeaderSearchWrapper":"fr-ec-navigation-header__search-wrapper","search-wrapper":"fr-ec-search-wrapper","searchWrapper":"fr-ec-search-wrapper","search-wrapper__icon":"fr-ec-search-wrapper__icon","searchWrapperIcon":"fr-ec-search-wrapper__icon","navigation-header__wrapper":"fr-ec-navigation-header__wrapper","navigationHeaderWrapper":"fr-ec-navigation-header__wrapper","navigation-header-with-empty-space":"fr-ec-navigation-header-with-empty-space","navigationHeaderWithEmptySpace":"fr-ec-navigation-header-with-empty-space","navigation-header__left":"fr-ec-navigation-header__left","navigationHeaderLeft":"fr-ec-navigation-header__left","navigation-header__right":"fr-ec-navigation-header__right","navigationHeaderRight":"fr-ec-navigation-header__right","navigation-header__center":"fr-ec-navigation-header__center","navigationHeaderCenter":"fr-ec-navigation-header__center","navigation-header__column":"fr-ec-navigation-header__column","navigationHeaderColumn":"fr-ec-navigation-header__column","navigation-header__column--content":"fr-ec-navigation-header__column--content","navigationHeaderColumnContent":"fr-ec-navigation-header__column--content","navigation-header__column--nav":"fr-ec-navigation-header__column--nav","navigationHeaderColumnNav":"fr-ec-navigation-header__column--nav","navigation-header__column--search":"fr-ec-navigation-header__column--search","navigationHeaderColumnSearch":"fr-ec-navigation-header__column--search","navigation-header__dropdown-wrapper":"fr-ec-navigation-header__dropdown-wrapper","navigationHeaderDropdownWrapper":"fr-ec-navigation-header__dropdown-wrapper","navigation-header--with-dropdown":"fr-ec-navigation-header--with-dropdown","navigationHeaderWithDropdown":"fr-ec-navigation-header--with-dropdown","navigation-header--with-sticky":"fr-ec-navigation-header--with-sticky","navigationHeaderWithSticky":"fr-ec-navigation-header--with-sticky","search__typeahead-collection":"fr-ec-search__typeahead-collection","searchTypeaheadCollection":"fr-ec-search__typeahead-collection","search-history-collection":"fr-ec-search-history-collection","searchHistoryCollection":"fr-ec-search-history-collection","navigation-header--checkout-menu":"fr-ec-navigation-header--checkout-menu","navigationHeaderCheckoutMenu":"fr-ec-navigation-header--checkout-menu","navigation-header--checkout-flyout":"fr-ec-navigation-header--checkout-flyout","navigationHeaderCheckoutFlyout":"fr-ec-navigation-header--checkout-flyout","navigation-header__column--checkout":"fr-ec-navigation-header__column--checkout","navigationHeaderColumnCheckout":"fr-ec-navigation-header__column--checkout","navigation-header__checkout-spacing":"fr-ec-navigation-header__checkout-spacing","navigationHeaderCheckoutSpacing":"fr-ec-navigation-header__checkout-spacing","navigation-header__checkout--dropdown-wrapper":"fr-ec-navigation-header__checkout--dropdown-wrapper","navigationHeaderCheckoutDropdownWrapper":"fr-ec-navigation-header__checkout--dropdown-wrapper","navigation-header--flyout-padding":"fr-ec-navigation-header--flyout-padding","navigationHeaderFlyoutPadding":"fr-ec-navigation-header--flyout-padding","navigation-header--checkout-icon":"fr-ec-navigation-header--checkout-icon","navigationHeaderCheckoutIcon":"fr-ec-navigation-header--checkout-icon","navigation-header__uq-icon":"fr-ec-navigation-header__uq-icon","navigationHeaderUqIcon":"fr-ec-navigation-header__uq-icon","link-image":"fr-ec-link-image","linkImage":"fr-ec-link-image","navigation-header__logo":"fr-ec-navigation-header__logo","navigationHeaderLogo":"fr-ec-navigation-header__logo","navigation-header--variant-ecrenewal":"fr-ec-navigation-header--variant-ecrenewal","navigationHeaderVariantEcrenewal":"fr-ec-navigation-header--variant-ecrenewal","navigation-header--variant-ecrenewal-black":"fr-ec-navigation-header--variant-ecrenewal-black","navigationHeaderVariantEcrenewalBlack":"fr-ec-navigation-header--variant-ecrenewal-black","navigation-header-notdefault-with-empty-space":"fr-ec-navigation-header-notdefault-with-empty-space","navigationHeaderNotdefaultWithEmptySpace":"fr-ec-navigation-header-notdefault-with-empty-space","button-icon__icon-container":"fr-ec-button-icon__icon-container","buttonIconIconContainer":"fr-ec-button-icon__icon-container"};

var NavigationHeader = function NavigationHeader(_a) {
  var linkImageArea = _a.linkImageArea,
      contentArea = _a.contentArea,
      searchArea = _a.searchArea,
      primaryMenuArea = _a.primaryMenuArea,
      _b = _a.enableDropdown,
      enableDropdown = _b === void 0 ? false : _b,
      dropdownButtonIcon = _a.dropdownButtonIcon,
      dropdownButtonlabel = _a.dropdownButtonlabel,
      flyoutChildren = _a.flyoutChildren,
      className = _a.className,
      _c = _a.toggleFlyout,
      toggleFlyout = _c === void 0 ? false : _c,
      _d = _a.sticky,
      sticky = _d === void 0 ? true : _d,
      featureImage = _a.featureImage,
      onToggleFlyout = _a.onToggleFlyout,
      searchLabel = _a.searchLabel,
      searchDismissLabel = _a.searchDismissLabel,
      itemCount = _a.itemCount,
      itemLabel = _a.itemLabel,
      totalPrice = _a.totalPrice,
      _e = _a.flyoutChildrenPadding,
      flyoutChildrenPadding = _e === void 0 ? false : _e,
      _f = _a.type,
      type = _f === void 0 ? 'default' : _f,
      iconBrand = _a.iconBrand,
      _g = _a.variant,
      variant = _g === void 0 ? 'default' : _g,
      props = __rest(_a, ["linkImageArea", "contentArea", "searchArea", "primaryMenuArea", "enableDropdown", "dropdownButtonIcon", "dropdownButtonlabel", "flyoutChildren", "className", "toggleFlyout", "sticky", "featureImage", "onToggleFlyout", "searchLabel", "searchDismissLabel", "itemCount", "itemLabel", "totalPrice", "flyoutChildrenPadding", "type", "iconBrand", "variant"]);

  var width = getViewportWidth();

  var _h = useState(toggleFlyout),
      flyoutToggler = _h[0],
      setFlyoutToggler = _h[1];

  var _j = useState(false),
      activeSearch = _j[0],
      setActiveSearch = _j[1];

  var _k = useState(false),
      isTouchDevices = _k[0],
      setIsTouchDevices = _k[1];

  var smallMediumDevice = width < designTokens_3.mqMediumScreenMaxWidthLimit;
  var showCheckoutContent = type === 'orderSummary' && smallMediumDevice;
  var toggleFlyoutOpen = type === 'orderSummary' ? toggleFlyout && smallMediumDevice : toggleFlyout;

  var handleSearch = function handleSearch() {
    setActiveSearch(true);

    if (isInBrowser$1()) {
      setTimeout(function () {
        var searchEle = document.querySelector('.fr-ec-navigation-header form[role="search"] > input');
        searchEle.focus();
      }, 500);
    }
  };

  useEffect(function () {
    var searchEle = document.querySelector('.fr-ec-navigation-header form[role="search"] > input');

    if (isInBrowser$1() && searchEle) {
      var tempInput_1 = document.createElement('input');
      tempInput_1.style.position = 'absolute';
      tempInput_1.style.top = searchEle.getBoundingClientRect().top + 'px';
      tempInput_1.style.left = searchEle.getBoundingClientRect().left + 'px';
      tempInput_1.style.height = '0';
      tempInput_1.style.opacity = '0';
      document.forms[0].appendChild(tempInput_1);
      tempInput_1.focus();
      setTimeout(function () {
        searchEle.focus();
        searchEle.click();
        document.forms[0].removeChild(tempInput_1);
      }, 500);
    }
  }, [activeSearch]);

  var closeSearch = function closeSearch() {
    return setActiveSearch(false);
  };

  var dropdownList = /*#__PURE__*/createElement(Flyout, {
    className: joinClasses(showCheckoutContent ? styles$e$1.navigationHeaderCheckoutFlyout : '', flyoutChildrenPadding && styles$e$1.navigationHeaderFlyoutPadding),
    colSpan: {
      md: 12,
      lg: 4
    }
  }, Children.toArray(flyoutChildren).filter(isValidElement).map(function (child) {
    return child && child.props && child.props.children;
  }));
  useEffect(function () {
    if (isInBrowser$1()) {
      setIsTouchDevices(isTouchDevice('touchPoints'));
    }
  }, []);
  var dropdownTemplate = /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$e$1.navigationHeaderDropdownWrapper, type === 'orderSummary' && styles$e$1.navigationHeaderCheckoutDropdownWrapper)
  }, !isTouchDevices && {
    onMouseLeave: function onMouseLeave() {
      return setFlyoutToggler(false);
    }
  }), dropdownButtonIcon && dropdownButtonlabel && /*#__PURE__*/createElement(ButtonIcon, __assign({
    icon: dropdownButtonIcon,
    label: dropdownButtonlabel,
    element: "button",
    variant: "dark",
    iconBrand: iconBrand
  }, !isTouchDevices ? {
    onMouseEnter: function onMouseEnter() {
      return setFlyoutToggler(true);
    }
  } : {
    onClick: onToggleFlyout
  })), (flyoutToggler || toggleFlyout) && dropdownList);
  var iconsArray = Children.toArray(contentArea);
  var contentAreaIcons = Children.toArray(contentArea).map(function (child, index) {
    if (index < iconsArray.length - 1 || featureImage && index < iconsArray.length) {
      return /*#__PURE__*/createElement(Fragment, {
        key: index
      }, child);
    } else {
      return /*#__PURE__*/cloneElement(child, {
        className: styles$e$1.navigationHeaderMenu,
        key: index
      });
    }
  });
  var ecRenewalVariants = variant === 'default' ? 'default' : 'ecrenewal';
  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("header", __assign({
    className: joinClasses(styles$e$1.navigationHeader, className, enableDropdown && styles$e$1.navigationHeaderWithDropdown, sticky && styles$e$1.navigationHeaderWithSticky, styles$e$1["navigation-header--variant-" + ecRenewalVariants], variant === 'black' && styles$e$1.navigationHeaderVariantEcrenewalBlack)
  }, props), /*#__PURE__*/createElement(LayoutWrapper, {
    element: "div"
  }, /*#__PURE__*/createElement(Layout, {
    element: "div",
    gutter: {
      sm: variant === 'default',
      md: true,
      lg: true
    },
    className: styles$e$1.navigationHeaderWrapper
  }, !activeSearch && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("nav", {
    className: styles$e$1.navigationHeaderLeft,
    "aria-label": "navigation left"
  }, /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$e$1.navigationHeaderColumn, featureImage ? styles$e$1.navigationHeaderUqIcon : styles$e$1.navigationHeaderLogo)
  }, linkImageArea.map(function (item, index) {
    return /*#__PURE__*/createElement(Fragment, {
      key: index
    }, item);
  })), /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$e$1.navigationHeaderColumn, styles$e$1.navigationHeaderColumnNav)
  }, primaryMenuArea)), featureImage && /*#__PURE__*/createElement("nav", {
    className: styles$e$1.navigationHeaderCenter,
    "aria-label": "navigation center"
  }, featureImage), /*#__PURE__*/createElement("nav", {
    className: styles$e$1.navigationHeaderRight,
    "aria-label": "navigation right"
  }, /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$e$1.navigationHeaderColumn, showCheckoutContent ? styles$e$1.navigationHeaderColumnCheckout : styles$e$1.navigationHeaderColumnContent)
  }, searchArea && !activeSearch && /*#__PURE__*/createElement(ButtonIcon, __assign({
    icon: 'search',
    element: "button",
    variant: "dark",
    onClick: handleSearch,
    iconBrand: iconBrand
  }, searchLabel ? {
    label: searchLabel
  } : {
    label: ''
  })), contentAreaIcons, showCheckoutContent && /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Body, {
    element: "span",
    variant: "small",
    className: styles$e$1.navigationHeaderCheckoutSpacing
  }, itemCount + " " + itemLabel), /*#__PURE__*/createElement(Title, {
    element: "span",
    variant: "large-emphasized",
    className: styles$e$1.navigationHeaderCheckoutSpacing
  }, totalPrice), /*#__PURE__*/createElement(ButtonIcon, {
    className: styles$e$1.navigationHeaderCheckoutIcon,
    onClick: onToggleFlyout,
    key: "[object Object]-0",
    disabled: false,
    element: "a",
    hideLabel: false,
    href: "#",
    icon: toggleFlyoutOpen ? 'chevron-up' : 'chevron-down',
    label: "",
    title: "",
    variant: "dark",
    iconBrand: iconBrand
  })), enableDropdown && dropdownTemplate))), searchArea && activeSearch && /*#__PURE__*/createElement("div", {
    className: styles$e$1.navigationHeaderSearchWrapper
  }, searchArea, /*#__PURE__*/createElement(ButtonIcon, __assign({
    className: styles$e$1.searchWrapperIcon,
    element: "button",
    icon: "close-big",
    variant: "dark",
    onClick: closeSearch,
    iconBrand: iconBrand
  }, searchDismissLabel ? {
    label: searchDismissLabel
  } : {
    label: ''
  })))))), sticky && /*#__PURE__*/createElement("div", {
    className: variant === 'default' ? styles$e$1.navigationHeaderWithEmptySpace : styles$e$1.navigationHeaderNotdefaultWithEmptySpace
  }), toggleFlyoutOpen && /*#__PURE__*/createElement(OverlayBackdrop, {
    className: joinClasses(styles$e$1.navigationHeaderOverlay, interactionsStyles.cursorPointer),
    onClick: onToggleFlyout
  }));
};
NavigationHeader.displayName = 'CoreNavigationHeader';
NavigationHeader.defaultProps = {
  sticky: true,
  toggleFlyout: false
};

var styles$f$1 = {"radio-group":"fr-ec-radio-group","radioGroup":"fr-ec-radio-group","radio-group__legend":"fr-ec-radio-group__legend","radioGroupLegend":"fr-ec-radio-group__legend","radio-group__radio-wrapper":"fr-ec-radio-group__radio-wrapper","radioGroupRadioWrapper":"fr-ec-radio-group__radio-wrapper","radio-group__radios":"fr-ec-radio-group__radios","radioGroupRadios":"fr-ec-radio-group__radios","radio-group--last-child":"fr-ec-radio-group--last-child","radioGroupLastChild":"fr-ec-radio-group--last-child","radio-group--wrapper":"fr-ec-radio-group--wrapper","radioGroupWrapper":"fr-ec-radio-group--wrapper"};

var RadioGroup = function RadioGroup(_a) {
  var id = _a.id,
      legend = _a.legend,
      error = _a.error,
      hint = _a.hint,
      children = _a.children,
      required = _a.required,
      className = _a.className,
      _b = _a.columnCount,
      columnCount = _b === void 0 ? 1 : _b,
      props = __rest(_a, ["id", "legend", "error", "hint", "children", "required", "className", "columnCount"]);

  var _c = useState(getCurrentMediaQueryBreakpoint()),
      breakpoint = _c[0],
      setBreakPointValue = _c[1];

  var hintErrorId = error || hint ? id + "-hint-error" : undefined;
  var columnCountProp = Math.max(typeof columnCount === 'number' ? columnCount : columnCount[breakpoint], 1);
  var childCount = Array.isArray(children) && children.length || 0;
  var radios = React__default.Children.map(children, function (child, index) {
    if (child.props !== undefined) {
      var lastChildColumn = childCount - index <= columnCountProp;
      return /*#__PURE__*/React__default.createElement("div", {
        key: "radio-" + child.props.id,
        className: joinClasses(styles$f$1.radioGroupRadioWrapper, lastChildColumn && styles$f$1.radioGroupLastChild)
      }, child);
    }

    return null;
  });
  var onWindowSize = debounce(100, function (_) {
    setBreakPointValue(getCurrentMediaQueryBreakpoint());
  });
  useEffect(function () {
    if (isInBrowser$1()) {
      window.addEventListener('resize', onWindowSize);
    }

    return function () {
      if (isInBrowser$1()) {
        window.removeEventListener('scroll', onWindowSize);
      }
    };
  }, []);
  return /*#__PURE__*/React__default.createElement("fieldset", __assign({
    id: id,
    className: joinClasses(styles$f$1.radioGroup, resetStyles.fieldsetReset, legend && styles$f$1.radioGroupWrapper, className),
    "aria-describedby": hintErrorId
  }, props), legend && /*#__PURE__*/React__default.createElement(LabelInput, {
    label: legend,
    element: "legend",
    required: required,
    className: styles$f$1.radioGroupLegend
  }), columnCountProp === 1 ? radios : /*#__PURE__*/React__default.createElement("div", {
    className: styles$f$1.radioGroupRadios
  }, radios), hint || error ? /*#__PURE__*/React__default.createElement(HintError, {
    error: error,
    id: hintErrorId,
    hint: hint
  }) : null);
};
RadioGroup.displayName = 'CoreRadioGroup';
RadioGroup.defaultProps = {
  required: false
};

var styles$g$1 = {"scale-input__label":"fr-ec-scale-input__label","scaleInputLabel":"fr-ec-scale-input__label","scale-input__label-input":"fr-ec-scale-input__label-input","scaleInputLabelInput":"fr-ec-scale-input__label-input","scale-input__container":"fr-ec-scale-input__container","scaleInputContainer":"fr-ec-scale-input__container","scale-input__option":"fr-ec-scale-input__option","scaleInputOption":"fr-ec-scale-input__option","scale-input__radio":"fr-ec-scale-input__radio","scaleInputRadio":"fr-ec-scale-input__radio","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","radio__label":"fr-ec-radio__label","radioLabel":"fr-ec-radio__label","radio__wrapper":"fr-ec-radio__wrapper","radioWrapper":"fr-ec-radio__wrapper","radio__input":"fr-ec-radio__input","radioInput":"fr-ec-radio__input","radio__circle":"fr-ec-radio__circle","radioCircle":"fr-ec-radio__circle"};

var ScaleInput = /*#__PURE__*/forwardRef(function (_a, ref) {
  var legend = _a.legend,
      error = _a.error,
      hint = _a.hint,
      children = _a.children,
      id = _a.id,
      className = _a.className,
      required = _a.required,
      props = __rest(_a, ["legend", "error", "hint", "children", "id", "className", "required"]);

  var hintErrorId = id + "-hint-error";
  var radioChildren = Children.map(children, function (child, i) {
    var showLabel = !child.props.hideLabel;
    return /*#__PURE__*/createElement("div", {
      key: child.key || i,
      className: styles$g$1.scaleInputOption
    }, /*#__PURE__*/cloneElement(child, {
      className: joinClasses(child.props.className, styles$g$1.scaleInputRadio),
      hideLabel: true
    }), showLabel ? /*#__PURE__*/createElement(Label, {
      element: "label",
      variant: "standard",
      "aria-hidden": true,
      className: styles$g$1.scaleInputLabel
    }, child.props.label) : null);
  });
  return /*#__PURE__*/createElement("fieldset", __assign({
    id: id,
    className: joinClasses(resetStyles.fieldsetReset, className),
    "aria-describedby": hintErrorId
  }, props), /*#__PURE__*/createElement(LabelInput, {
    label: legend,
    element: "label",
    required: required,
    className: styles$g$1.scaleInputLabelInput
  }), /*#__PURE__*/createElement("div", {
    className: styles$g$1.scaleInputContainer,
    ref: ref
  }, radioChildren), hint || error ? /*#__PURE__*/createElement(HintError, {
    error: error,
    hint: hint,
    id: hintErrorId
  }) : null);
});
ScaleInput.displayName = 'CoreScaleInput';
ScaleInput.defaultProps = {
  required: false
};

var styles$h$1 = {"search-wrapper":"fr-ec-search-wrapper","searchWrapper":"fr-ec-search-wrapper","search":"fr-ec-search","search__form":"fr-ec-search__form","searchForm":"fr-ec-search__form","search__input":"fr-ec-search__input","searchInput":"fr-ec-search__input","search__input-rounded":"fr-ec-search__input-rounded","searchInputRounded":"fr-ec-search__input-rounded","search__input-rounded-without-search":"fr-ec-search__input-rounded-without-search","searchInputRoundedWithoutSearch":"fr-ec-search__input-rounded-without-search","search__input-rounded-active":"fr-ec-search__input-rounded-active","searchInputRoundedActive":"fr-ec-search__input-rounded-active","search__input-rounded_image":"fr-ec-search__input-rounded_image","searchInputRoundedImage":"fr-ec-search__input-rounded_image","body--standard":"fr-ec-body--standard","bodyStandard":"fr-ec-body--standard","search__input--no-value":"fr-ec-search__input--no-value","searchInputNoValue":"fr-ec-search__input--no-value","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","search__input--status-error":"fr-ec-search__input--status-error","searchInputStatusError":"fr-ec-search__input--status-error","search__clear-button":"fr-ec-search__clear-button","searchClearButton":"fr-ec-search__clear-button","icon":"fr-ec-icon","search__button":"fr-ec-search__button","searchButton":"fr-ec-search__button","search__label":"fr-ec-search__label","searchLabel":"fr-ec-search__label","search__hint-error":"fr-ec-search__hint-error","searchHintError":"fr-ec-search__hint-error","search__hint-error--disabled":"fr-ec-search__hint-error--disabled","searchHintErrorDisabled":"fr-ec-search__hint-error--disabled","search__button--status-error":"fr-ec-search__button--status-error","searchButtonStatusError":"fr-ec-search__button--status-error","search__typeahead-collection":"fr-ec-search__typeahead-collection","searchTypeaheadCollection":"fr-ec-search__typeahead-collection","search-history-collection":"fr-ec-search-history-collection","searchHistoryCollection":"fr-ec-search-history-collection","collection-list__item":"fr-ec-collection-list__item","collectionListItem":"fr-ec-collection-list__item","search-history-collection__items":"fr-ec-search-history-collection__items","searchHistoryCollectionItems":"fr-ec-search-history-collection__items","search-history__delete-icon--disabled":"fr-ec-search-history__delete-icon--disabled","searchHistoryDeleteIconDisabled":"fr-ec-search-history__delete-icon--disabled","search__input-rounded--image-search":"fr-ec-search__input-rounded--image-search","searchInputRoundedImageSearch":"fr-ec-search__input-rounded--image-search","no-search-history--section":"fr-ec-no-search-history--section","noSearchHistorySection":"fr-ec-no-search-history--section","search__image-search-icon":"fr-ec-search__image-search-icon","searchImageSearchIcon":"fr-ec-search__image-search-icon","search__icon_rounded":"fr-ec-search__icon_rounded","searchIconRounded":"fr-ec-search__icon_rounded","search__icon_rounded-error":"fr-ec-search__icon_rounded-error","searchIconRoundedError":"fr-ec-search__icon_rounded-error","search__input--status-error-rounded":"fr-ec-search__input--status-error-rounded","searchInputStatusErrorRounded":"fr-ec-search__input--status-error-rounded","search-wrapper__is-full-screen":"fr-ec-search-wrapper__is-full-screen","searchWrapperIsFullScreen":"fr-ec-search-wrapper__is-full-screen","search-wrapper__icon-is-full-screen":"fr-ec-search-wrapper__icon-is-full-screen","searchWrapperIconIsFullScreen":"fr-ec-search-wrapper__icon-is-full-screen","search__icon_rounded-disabled":"fr-ec-search__icon_rounded-disabled","searchIconRoundedDisabled":"fr-ec-search__icon_rounded-disabled","tab-group":"fr-ec-tab-group","tabGroup":"fr-ec-tab-group"};

var SearchComponent =
/** @class */
function (_super) {
  __extends(SearchComponent, _super);

  function SearchComponent(props) {
    var _this = _super.call(this, props) || this;

    _this.handleClickOutside = function (event) {
      if (event.target !== _this.searchWrapperRef.current && _this.searchWrapperRef.current && !_this.searchWrapperRef.current.contains(event.target) && _this.props.onBlur && _this.state.isFocused) {
        _this.onSearchBlur(event);
      }
    };

    _this.handleValueChange = function (event) {
      _this.setState({
        value: event.target.value
      });

      if (_this.props.onChange) {
        _this.props.onChange(event);
      }
    };

    _this.handleClearValue = function (event) {
      _this.setState({
        value: ''
      });

      if (_this.props.onClear) {
        _this.props.onClear(event);
      }

      _this.focusSearchField();
    };

    _this.handleSubmit = function (event) {
      if (_this.props.onSearch) {
        _this.props.onSearch(_this.currentValue);
      }

      var node = _this.searchFieldRef.current;

      if (node) {
        node.blur();
      }

      event.preventDefault();
    };

    _this.focusSearchField = function () {
      var node = _this.searchFieldRef.current;

      if (node) {
        node.focus();
      }
    };

    _this.blurSearchField = function () {
      var node = _this.searchFieldRef.current;

      if (node) {
        node.blur();
      }
    };

    _this.onSearchFocus = function (event) {
      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }

      _this.setState({
        isFocused: true
      }, function () {
        return _this.focusSearchField();
      });
    };

    _this.onSearchBlur = function (event) {
      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }

      _this.setState({
        isFocused: false
      });
    };

    _this.getSearchHistoryTitle = function (label, iconBrand) {
      if (label === void 0) {
        label = '';
      }

      return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(Title, {
        element: "p",
        variant: "standard"
      }, label || 'Search History'), /*#__PURE__*/createElement(ButtonIcon, {
        type: "button",
        element: "button",
        icon: "delete",
        iconBrand: iconBrand,
        hideLabel: true,
        onMouseDown: _this.props.onDeleteSearchHistory,
        tabIndex: -1,
        label: "Delete",
        disabled: _this.props.searchHistoryItems && _this.props.searchHistoryItems.length > 0 ? false : true,
        className: _this.props.searchHistoryItems && _this.props.searchHistoryItems.length > 0 ? '' : styles$h$1.searchHistoryDeleteIconDisabled
      }));
    };

    _this.state = {
      isFocused: false,
      value: _this.props.value || ''
    };
    _this.searchFieldRef = props.forwardRef || /*#__PURE__*/createRef();
    _this.searchWrapperRef = props.forwardRef || /*#__PURE__*/createRef();
    return _this;
  }

  SearchComponent.prototype.componentDidMount = function () {
    if (isInBrowser$1()) {
      document.addEventListener('click', this.handleClickOutside, true);
    }
  };

  Object.defineProperty(SearchComponent.prototype, "currentValue", {
    get: function get() {
      return this.props.value !== undefined ? this.props.value : this.state.value;
    },
    enumerable: true,
    configurable: true
  });

  SearchComponent.prototype.render = function () {
    var _a = this.props,
        _b = _a.autoComplete,
        autoComplete = _b === void 0 ? 'on' : _b,
        id = _a.id,
        label = _a.label,
        _c = _a.imageSearchButtonLabel,
        imageSearchButtonLabel = _c === void 0 ? '' : _c,
        clearButtonLabel = _a.clearButtonLabel,
        searchButtonLabel = _a.searchButtonLabel,
        error = _a.error,
        helptext = _a.helptext,
        placeholder = _a.placeholder,
        disabled = _a.disabled,
        required = _a.required,
        className = _a.className,
        ariaLabel = _a.ariaLabel,
        typeaheadItems = _a.typeaheadItems,
        searchHistoryItems = _a.searchHistoryItems,
        showSearchHistory = _a.showSearchHistory,
        searchHistoryLabel = _a.searchHistoryLabel,
        noSearchHistorySection = _a.noSearchHistorySection,
        imageSearchLink = _a.imageSearchLink,
        _d = _a.showTrendingWords,
        showTrendingWords = _d === void 0 ? false : _d,
        trendingWordsLabel = _a.trendingWordsLabel,
        trendingWords = _a.trendingWords,
        iconBrand = _a.iconBrand,
        isFullscreen = _a.isFullscreen,
        _e = _a.variant,
        variant = _e === void 0 ? "default" : _e,
        other = __rest(_a, ["autoComplete", "id", "label", "imageSearchButtonLabel", "clearButtonLabel", "searchButtonLabel", "onFocus", "onBlur", "error", "helptext", "placeholder", "disabled", "required", "forwardRef", "onClear", "onSearch", "onChange", "className", "ariaLabel", "typeaheadItems", "searchHistoryItems", "showSearchHistory", "searchHistoryLabel", "noSearchHistorySection", "onDeleteSearchHistory", "imageSearchLink", "showTrendingWords", "trendingWordsLabel", "trendingWords", "iconBrand", "isFullscreen", "variant"]);

    var hintErrorId = error || helptext ? id + "-hint-error" : undefined;
    var labelId = 'search-label';
    var isRounded = variant === "rounded";
    var searchComponent = /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$h$1.searchWrapper, className),
      ref: this.searchWrapperRef
    }, /*#__PURE__*/createElement("div", {
      className: styles$h$1.search
    }, /*#__PURE__*/createElement("form", {
      role: "search",
      className: joinClasses(styles$h$1.searchForm, (error || helptext) && spacingStyles.mbSpacing02),
      onSubmit: this.handleSubmit,
      action: ""
    }, isRounded && !this.state.isFocused && /*#__PURE__*/createElement(ButtonIcon, {
      type: "button",
      element: "button",
      icon: "search",
      className: styles$h$1.searchInputRoundedImage,
      variant: "dark",
      label: imageSearchButtonLabel,
      hideLabel: true,
      disabled: disabled,
      tabIndex: error ? -1 : 0,
      iconBrand: iconBrand
    }), /*#__PURE__*/createElement("input", __assign({
      type: "search",
      id: id,
      className: joinClasses(styles$h$1.searchInput, error && styles$h$1.searchInputStatusError, bodyStyles.body, typographyStyles.bodyStandard, resetStyles.textinputReset, !this.currentValue ? styles$h$1.searchInputNoValue : '', isRounded && styles$h$1.searchInputRounded, isRounded && error && (imageSearchLink ? styles$h$1.searchInputStatusErrorRounded : ""), isRounded && this.state.isFocused && styles$h$1.searchInputRoundedActive, !imageSearchLink && isRounded && styles$h$1.searchInputRoundedWithoutSearch, isRounded && imageSearchLink && styles$h$1.searchInputRoundedImageSearch),
      placeholder: placeholder
    }, label ? {
      'aria-labelledby': labelId
    } : {
      'aria-label': ariaLabel
    }, {
      "aria-describedby": hintErrorId,
      onChange: this.handleValueChange,
      onFocus: this.onSearchFocus,
      value: this.currentValue,
      ref: this.searchFieldRef,
      autoComplete: autoComplete,
      disabled: disabled,
      required: required
    }, other)), imageSearchLink && !this.currentValue && /*#__PURE__*/createElement(ButtonIcon, {
      type: "button",
      element: "button",
      icon: "visual-search",
      className: joinClasses(styles$h$1.searchImageSearchIcon, isRounded && styles$h$1.searchIconRounded, !disabled && error && isRounded && styles$h$1.searchIconRoundedError, isRounded && disabled && styles$h$1.searchIconRoundedDisabled),
      variant: "dark",
      label: imageSearchButtonLabel,
      hideLabel: true,
      onClick: function onClick() {
        return window.location.href = imageSearchLink;
      },
      disabled: disabled,
      tabIndex: error ? -1 : 0,
      iconBrand: iconBrand
    }), !isRounded && /*#__PURE__*/createElement(ButtonIcon, {
      type: "submit",
      element: "button",
      icon: "search",
      className: joinClasses(styles$h$1.searchButton, error && styles$h$1.searchButtonStatusError),
      label: searchButtonLabel,
      variant: "light",
      hideLabel: true,
      onClick: this.handleSubmit,
      disabled: disabled,
      tabIndex: error ? -1 : 0,
      iconBrand: iconBrand
    }), this.currentValue && /*#__PURE__*/createElement(ButtonIcon, {
      type: "button",
      element: "button",
      icon: "close",
      className: joinClasses(styles$h$1.searchClearButton, isRounded && styles$h$1.searchIconRounded, isRounded && disabled && styles$h$1.searchIconRoundedDisabled, !disabled && error && isRounded && styles$h$1.searchIconRoundedError),
      label: clearButtonLabel,
      variant: "dark",
      hideLabel: true,
      onClick: this.handleClearValue,
      disabled: disabled,
      tabIndex: error ? -1 : 0,
      iconBrand: iconBrand
    })), label && /*#__PURE__*/createElement(LabelInput, {
      htmlFor: id,
      label: label,
      id: labelId,
      element: "label",
      className: joinClasses(styles$h$1.searchLabel, resetStyles.maxWidthReset),
      required: required
    }), (error || helptext) && /*#__PURE__*/createElement(HintError, {
      error: error,
      hint: helptext,
      id: hintErrorId,
      className: joinClasses(styles$h$1.searchHintError, disabled && styles$h$1.searchHintErrorDisabled)
    })), this.state.isFocused && this.currentValue && typeaheadItems && /*#__PURE__*/createElement(CollectionList, {
      spacing: "none",
      role: "dialog",
      "aria-live": "assertive",
      "aria-atomic": "true",
      className: styles$h$1.searchTypeaheadCollection,
      onTouchMove: this.blurSearchField
    }, typeaheadItems), showSearchHistory && /*#__PURE__*/createElement(CollectionList, {
      spacing: "none",
      role: "dialog",
      "aria-live": "assertive",
      "aria-atomic": "true",
      className: joinClasses(styles$h$1.searchHistoryCollection, showTrendingWords && trendingWordsLabel && styles$h$1.searchHistoryCollectionItems),
      onTouchMove: this.blurSearchField
    }, showTrendingWords && trendingWordsLabel && /*#__PURE__*/createElement(Title, {
      variant: "standard",
      element: "h5"
    }, trendingWordsLabel), showTrendingWords && trendingWords, this.getSearchHistoryTitle(searchHistoryLabel, iconBrand), searchHistoryItems && searchHistoryItems.length > 0 ? searchHistoryItems : /*#__PURE__*/createElement("div", {
      className: styles$h$1.noSearchHistorySection
    }, noSearchHistorySection ? noSearchHistorySection : /*#__PURE__*/createElement(Body, {
      variant: "standard",
      element: "p"
    }, "If there is a search history, it will be displayed here."))));
    return isFullscreen && getCurrentMediaQueryBreakpoint() === 'sm' && (this.state.isFocused || showSearchHistory) ? /*#__PURE__*/createElement("div", {
      className: styles$h$1.searchWrapperIsFullScreen
    }, searchComponent, /*#__PURE__*/createElement(ButtonIcon, __assign({
      className: styles$h$1.searchWrapperIconIsFullScreen,
      element: "button",
      icon: "close-big",
      variant: "dark",
      onClick: this.handleClickOutside,
      iconBrand: iconBrand
    }, clearButtonLabel ? {
      label: clearButtonLabel
    } : {
      label: ''
    }))) : searchComponent;
  };

  return SearchComponent;
}(Component);

var Search = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/createElement(SearchComponent, __assign({
    forwardRef: ref
  }, props));
});
Search.displayName = 'CoreSearch';

var styles$i$1 = {"stepper":"fr-ec-stepper","stepper__step":"fr-ec-stepper__step","stepperStep":"fr-ec-stepper__step","stepper--active":"fr-ec-stepper--active","stepperActive":"fr-ec-stepper--active","label":"fr-ec-label","caption":"fr-ec-caption","stepper-static":"fr-ec-stepper-static","stepperStatic":"fr-ec-stepper-static"};

var Stepper = function Stepper(_a) {
  var _b = _a.isActive,
      isActive = _b === void 0 ? false : _b,
      children = _a.children,
      label = _a.label,
      onClick = _a.onClick,
      props = __rest(_a, ["isActive", "children", "label", "onClick"]);

  return /*#__PURE__*/createElement("button", __assign({
    className: joinClasses(styles$i$1.stepper, isActive && styles$i$1.stepperActive, !onClick && styles$i$1.stepperStatic),
    onClick: onClick
  }, props, {
    "aria-label": "Step " + children + ", " + label
  }), /*#__PURE__*/createElement(Label, {
    element: "span",
    variant: "standard",
    className: styles$i$1.stepperStep
  }, children), /*#__PURE__*/createElement(Caption, {
    element: "span"
  }, label));
};
Stepper.displayName = 'CoreStepper';

var TableRowStyles = {"table-row--with-border":"fr-ec-table-row--with-border","tableRowWithBorder":"fr-ec-table-row--with-border"};

var textAlign = function textAlign(align) {
  switch (align) {
    case 'center':
      return 'center';

    case 'end':
      return 'right';

    default:
      return 'left';
  }
};

var TableBody = function TableBody(_a) {
  var rows = _a.rows,
      columnStyles = _a.columnStyles,
      spacing = _a.spacing,
      rest = __rest(_a, ["rows", "columnStyles", "spacing"]);

  return /*#__PURE__*/createElement("tbody", __assign({}, rest), rows.map(function (_a, i) {
    var content = _a.content,
        _b = _a.bottomKeyline,
        bottomKeyline = _b === void 0 ? false : _b,
        _c = _a.typography,
        typography = _c === void 0 ? 'body' : _c,
        _d = _a.emphasized,
        emphasized = _d === void 0 ? false : _d,
        contentClassName = _a.contentClassName,
        props = __rest(_a, ["content", "bottomKeyline", "typography", "emphasized", "contentClassName"]);

    var isChildString = Children.toArray(content).every(function (x) {
      return typeof x === 'string';
    });

    if (isChildString) {
      return /*#__PURE__*/createElement(TableRow, {
        key: i,
        className: bottomKeyline ? TableRowStyles['table-row--with-border'] : ''
      }, Children.toArray(content).map(function (cell, j) {
        return columnStyles[j] && /*#__PURE__*/createElement(TableCell, __assign({
          key: j,
          element: "td",
          className: joinClasses(spacing === '8px' ? TableCellStyles.tableCellBodyVerticalPaddingDefault : TableCellStyles.tableCellBodyVerticalPadding4, bottomKeyline && (spacing === '8px' ? TableCellStyles.tableCellBorderBottomDefault : TableCellStyles.tableCellBorderBottom), contentClassName && contentClassName[j])
        }, columnStyles[j], props), typography === 'body' ? /*#__PURE__*/createElement(Body, {
          element: "span",
          variant: emphasized ? 'standard-emphasized' : 'standard',
          textAlign: textAlign(columnStyles[j].alignment)
        }, cell) : /*#__PURE__*/createElement(Title, {
          element: "h4",
          variant: emphasized ? 'large-emphasized' : 'large',
          textAlign: textAlign(columnStyles[j].alignment)
        }, cell));
      }));
    }

    return /*#__PURE__*/createElement(TableRow, {
      key: i,
      className: bottomKeyline ? TableRowStyles['table-row--with-border'] : ''
    }, Children.toArray(content).map(function (cell, j) {
      return columnStyles[j] && /*#__PURE__*/createElement(TableCell, __assign({
        colSpan: 2,
        width: '100%',
        alignment: "start",
        key: j,
        element: "td",
        className: joinClasses(spacing === '8px' ? TableCellStyles.tableCellBodyVerticalPaddingDefault : TableCellStyles.tableCellBodyVerticalPadding4, bottomKeyline && (spacing === '8px' ? TableCellStyles.tableCellBorderBottomDefault : TableCellStyles.tableCellBorderBottom), contentClassName && contentClassName[j], TableCellStyles.tableCellAccordion)
      }, columnStyles[j], props), cell);
    }));
  }));
};
TableBody.defaultProps = {
  spacing: '8px'
};
TableBody.displayName = 'CoreTableBody';

var styles$j$1 = {"table":"fr-ec-table","table--with-footer":"fr-ec-table--with-footer","tableWithFooter":"fr-ec-table--with-footer","table-cell":"fr-ec-table-cell","tableCell":"fr-ec-table-cell","table-container":"fr-ec-table-container","tableContainer":"fr-ec-table-container","table-container--background-white":"fr-ec-table-container--background-white","tableContainerBackgroundWhite":"fr-ec-table-container--background-white"};

var Table = function Table(_a) {
  var rows = _a.rows,
      columnStyles = _a.columnStyles,
      className = _a.className,
      background = _a.background,
      spacing = _a.spacing,
      props = __rest(_a, ["rows", "columnStyles", "className", "background", "spacing"]);

  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(background === 'grey' ? styles$j$1.tableContainer : styles$j$1.tableContainerBackgroundWhite, className)
  }, props), /*#__PURE__*/createElement("table", {
    className: styles$j$1.table
  }, /*#__PURE__*/createElement(TableBody, {
    rows: rows,
    columnStyles: columnStyles,
    spacing: spacing
  })));
};
Table.defaultProps = {
  background: 'grey',
  spacing: '8px'
};
Table.displayName = 'CoreTable';

var styles$k$1 = {"text-area":"fr-ec-text-area","textArea":"fr-ec-text-area","text-area__input":"fr-ec-text-area__input","textAreaInput":"fr-ec-text-area__input","text-area__label":"fr-ec-text-area__label","textAreaLabel":"fr-ec-text-area__label","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","text-area__input--error":"fr-ec-text-area__input--error","textAreaInputError":"fr-ec-text-area__input--error","text-area__info-wrapper":"fr-ec-text-area__info-wrapper","textAreaInfoWrapper":"fr-ec-text-area__info-wrapper","text-area__character-count-wrapper":"fr-ec-text-area__character-count-wrapper","textAreaCharacterCountWrapper":"fr-ec-text-area__character-count-wrapper","text-area__character-count":"fr-ec-text-area__character-count","textAreaCharacterCount":"fr-ec-text-area__character-count"};

var testId$2 = {
  'data-testid': 'CoreTextArea'
};

var formatPxStringAsNumber = function formatPxStringAsNumber(pxString) {
  return parseInt(pxString.replace('px', ''), 10);
};

var getNonContentHeight = function getNonContentHeight(el) {
  var computedStyle = getComputedStyle(el);
  return ['padding-top', 'padding-bottom', 'border-top-width', 'border-bottom-width'].reduce(function (total, prop) {
    return total + formatPxStringAsNumber(computedStyle.getPropertyValue(prop));
  }, 0);
};

var adjustElementLineCount = function adjustElementLineCount(el, minLines, maxLines) {
  if (minLines === void 0) {
    minLines = TextAreaComponent.defaultProps.minLines;
  }

  if (maxLines === void 0) {
    maxLines = TextAreaComponent.defaultProps.maxLines;
  }

  el.style.height = 'inherit';
  var computedStyle = getComputedStyle(el);
  var lineHeight = formatPxStringAsNumber(computedStyle.getPropertyValue('line-height'));
  var currentLines = Math.floor(el.scrollHeight / lineHeight);
  var newLines = Math.max(minLines, Math.min(maxLines, currentLines));
  var newHeight = newLines * lineHeight + (getBrowser() === 'firefox' ? getNonContentHeight(el) : 0);
  el.style.height = newHeight + "px";
};

var TextAreaComponent =
/** @class */
function (_super) {
  __extends(TextAreaComponent, _super);

  function TextAreaComponent(props) {
    var _this = _super.call(this, props) || this;

    _this.onChange = function (event) {
      var currentTarget = event.currentTarget;
      var _a = _this.props,
          onChange = _a.onChange,
          value = _a.value;

      if (typeof value === 'undefined') {
        _this.setState({
          characterCount: currentTarget.value.length
        });
      }

      adjustElementLineCount(currentTarget);

      if (onChange) {
        onChange(event);
      }
    };

    _this.state = {
      characterCount: props.value ? props.value.length : 0
    };
    _this.textareaRef = props.forwardRef || /*#__PURE__*/createRef();
    return _this;
  }

  TextAreaComponent.prototype.componentDidUpdate = function (_a) {
    var oldValue = _a.value;
    var newValue = this.props.value;

    if (oldValue !== newValue) {
      this.setState({
        characterCount: newValue ? newValue.length : 0
      });
    }
  };

  TextAreaComponent.prototype.componentDidMount = function () {
    var current = this.textareaRef.current;

    if (current) {
      adjustElementLineCount(current);
    }
  };

  TextAreaComponent.prototype.render = function () {
    var _a = this.props,
        maxCharacters = _a.maxCharacters,
        description = _a.description,
        label = _a.label,
        id = _a.id,
        _b = _a.disabled,
        disabled = _b === void 0 ? false : _b,
        error = _a.error,
        required = _a.required,
        charCountAriaLabel = _a.charCountAriaLabel,
        className = _a.className,
        props = __rest(_a, ["maxCharacters", "description", "label", "id", "disabled", "error", "required", "onChange", "charCountAriaLabel", "forwardRef", "className"]);

    var characterCount = this.state.characterCount;
    var hintErrorId = error || description ? id + "-hint-error" : '';
    var countId = maxCharacters ? id + "-char-count" : '';
    var characterCountError = Boolean(maxCharacters && characterCount > maxCharacters);
    return /*#__PURE__*/createElement("div", __assign({
      className: joinClasses(styles$k$1.textArea, className)
    }, testId$2), /*#__PURE__*/createElement("textarea", __assign({
      ref: this.textareaRef,
      id: id,
      className: joinClasses(styles$k$1.textAreaInput, bodyStyles.body, typographyStyles.formText, error && styles$k$1.textAreaInputError),
      disabled: disabled,
      "aria-describedby": countId + " " + hintErrorId,
      onChange: this.onChange
    }, props)), /*#__PURE__*/createElement(LabelInput, {
      htmlFor: id,
      label: label,
      element: "label",
      className: joinClasses(styles$k$1.textAreaLabel, resetStyles.maxWidthReset),
      disabled: disabled,
      required: required
    }), description || error || maxCharacters ? /*#__PURE__*/createElement("div", {
      className: styles$k$1.textAreaInfoWrapper
    }, description || error ? /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement(HintError, {
      error: error,
      hint: description,
      id: hintErrorId,
      disabled: disabled
    })) : null, maxCharacters && /*#__PURE__*/createElement("div", {
      className: styles$k$1.textAreaCharacterCountWrapper
    }, /*#__PURE__*/createElement(HintError, {
      id: countId,
      className: styles$k$1.textAreaCharacterCount,
      "aria-label": charCountAriaLabel + ": " + (maxCharacters - characterCount),
      hint: characterCount + "/" + maxCharacters,
      error: characterCountError ? characterCount + "/" + maxCharacters : undefined,
      disabled: disabled
    }))) : null);
  };

  TextAreaComponent.defaultProps = {
    disabled: false,
    maxLines: 6,
    minLines: 3
  };
  return TextAreaComponent;
}(Component);

var TextArea = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/createElement(TextAreaComponent, __assign({
    forwardRef: ref
  }, props));
});
TextArea.displayName = 'CoreTextArea';
TextArea.defaultProps = {
  disabled: false
};

var styles$l$1 = {"text-field":"fr-ec-text-field","textField":"fr-ec-text-field","text-field__input-wrapper":"fr-ec-text-field__input-wrapper","textFieldInputWrapper":"fr-ec-text-field__input-wrapper","text-field__input-focus":"fr-ec-text-field__input-focus","textFieldInputFocus":"fr-ec-text-field__input-focus","text-field__input-focus-error":"fr-ec-text-field__input-focus-error","textFieldInputFocusError":"fr-ec-text-field__input-focus-error","text-field__input":"fr-ec-text-field__input","textFieldInput":"fr-ec-text-field__input","text-field__wrapper-class":"fr-ec-text-field__wrapper-class","textFieldWrapperClass":"fr-ec-text-field__wrapper-class","text-field__data-list-arrow-icon":"fr-ec-text-field__data-list-arrow-icon","textFieldDataListArrowIcon":"fr-ec-text-field__data-list-arrow-icon","text-field__input--status-error":"fr-ec-text-field__input--status-error","textFieldInputStatusError":"fr-ec-text-field__input--status-error","button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon","text-field__data-list":"fr-ec-text-field__data-list","textFieldDataList":"fr-ec-text-field__data-list","text-field__data-list-options":"fr-ec-text-field__data-list-options","textFieldDataListOptions":"fr-ec-text-field__data-list-options","text-field__input-value":"fr-ec-text-field__input-value","textFieldInputValue":"fr-ec-text-field__input-value","text-field__input-affix":"fr-ec-text-field__input-affix","textFieldInputAffix":"fr-ec-text-field__input-affix","text-field__label":"fr-ec-text-field__label","textFieldLabel":"fr-ec-text-field__label","text-field__label-text":"fr-ec-text-field__label-text","textFieldLabelText":"fr-ec-text-field__label-text","text-field__label-sub":"fr-ec-text-field__label-sub","textFieldLabelSub":"fr-ec-text-field__label-sub","text-field__hint-error":"fr-ec-text-field__hint-error","textFieldHintError":"fr-ec-text-field__hint-error","text-field__input-affix--status-error":"fr-ec-text-field__input-affix--status-error","textFieldInputAffixStatusError":"fr-ec-text-field__input-affix--status-error","text-field__input-prefix":"fr-ec-text-field__input-prefix","textFieldInputPrefix":"fr-ec-text-field__input-prefix","text-field__input-suffix":"fr-ec-text-field__input-suffix","textFieldInputSuffix":"fr-ec-text-field__input-suffix","text-field__input-affix--image-wrapper":"fr-ec-text-field__input-affix--image-wrapper","textFieldInputAffixImageWrapper":"fr-ec-text-field__input-affix--image-wrapper","text-field__input-affix--dropdown-wrapper":"fr-ec-text-field__input-affix--dropdown-wrapper","textFieldInputAffixDropdownWrapper":"fr-ec-text-field__input-affix--dropdown-wrapper","text-field__input-affix-image":"fr-ec-text-field__input-affix-image","textFieldInputAffixImage":"fr-ec-text-field__input-affix-image","text-field__input-affix--dropdown":"fr-ec-text-field__input-affix--dropdown","textFieldInputAffixDropdown":"fr-ec-text-field__input-affix--dropdown","dropdown__container":"fr-ec-dropdown__container","dropdownContainer":"fr-ec-dropdown__container","dropdown__input":"fr-ec-dropdown__input","dropdownInput":"fr-ec-dropdown__input","dropdown__icon":"fr-ec-dropdown__icon","dropdownIcon":"fr-ec-dropdown__icon","dropdown":"fr-ec-dropdown","dropdown__list":"fr-ec-dropdown__list","dropdownList":"fr-ec-dropdown__list","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","text-field__input-affix--button-icon":"fr-ec-text-field__input-affix--button-icon","textFieldInputAffixButtonIcon":"fr-ec-text-field__input-affix--button-icon","text-field__input--affix-prefix":"fr-ec-text-field__input--affix-prefix","textFieldInputAffixPrefix":"fr-ec-text-field__input--affix-prefix","text-field__input--affix-suffix":"fr-ec-text-field__input--affix-suffix","textFieldInputAffixSuffix":"fr-ec-text-field__input--affix-suffix","text-field__input--distinct-prefix":"fr-ec-text-field__input--distinct-prefix","textFieldInputDistinctPrefix":"fr-ec-text-field__input--distinct-prefix","text-field__input--distinct-suffix":"fr-ec-text-field__input--distinct-suffix","textFieldInputDistinctSuffix":"fr-ec-text-field__input--distinct-suffix","text-field__input--no-prefix":"fr-ec-text-field__input--no-prefix","textFieldInputNoPrefix":"fr-ec-text-field__input--no-prefix","text-field__input--no-suffix":"fr-ec-text-field__input--no-suffix","textFieldInputNoSuffix":"fr-ec-text-field__input--no-suffix"};

var statusToInputFieldPrefixSuffix = {
  combinedPrefix: styles$l$1.textFieldInputAffixPrefix,
  combinedSuffix: styles$l$1.textFieldInputAffixSuffix,
  distinctPrefix: styles$l$1.textFieldInputDistinctPrefix,
  distinctSuffix: styles$l$1.textFieldInputDistinctSuffix,
  normalPrefix: styles$l$1.textFieldInputNoPrefix,
  normalSuffix: styles$l$1.textFieldInputNoSuffix
};

var TextFieldComponent =
/** @class */
function (_super) {
  __extends(TextFieldComponent, _super);

  function TextFieldComponent(props) {
    var _this = _super.call(this, props) || this;

    _this.handleFocus = function (event) {
      _this.setState({
        isFocus: true,
        isActive: true
      });

      if (_this.props.onFocus) {
        _this.props.onFocus(event);
      }
    };

    _this.handleBlur = function (event) {
      _this.setState({
        isFocus: false,
        isActive: false
      });

      if (_this.props.onBlur) {
        _this.props.onBlur(event);
      }
    };

    _this.onResize = function (contentRect) {
      if (contentRect.bounds) {
        var viewPortWidth = contentRect.bounds.width;

        _this.setState({
          viewPortWidth: viewPortWidth
        });
      }
    };

    _this.handleArrowClick = function () {
      _this.setState({
        isActive: !_this.state.isActive
      });
    };

    _this.handleOptionClick = function (event, item) {
      _this.setState({
        isActive: false,
        inputValue: item.label
      });

      if (_this.props.onChange) {
        _this.props.onChange(event, item.value);
      }
    };

    _this.onInputChangeHandler = function (event) {
      _this.setState({
        inputValue: event.target.value
      });

      if (_this.props.onChange) {
        _this.props.onChange(event, event.target.value);
      }
    };

    _this.renderAffix = function (affix, isPrefix) {
      var _a = _this.props,
          error = _a.error,
          _b = _a.disabled,
          disabled = _b === void 0 ? false : _b;
      var affixClassNames = joinClasses(styles$l$1.textFieldInputAffix, error && !disabled && styles$l$1.textFieldInputAffixStatusError);
      var affixNoIconClass = isPrefix ? styles$l$1.textFieldInputPrefix : styles$l$1.textFieldInputSuffix;

      if (typeof affix === 'string') {
        return /*#__PURE__*/createElement(Body, {
          element: "span",
          className: joinClasses(affixClassNames, affixNoIconClass)
        }, affix);
      } else if (affix.type && /*#__PURE__*/isValidElement(affix) && ( // @ts-ignore
      affix.type.displayName === 'CoreImage' || affix.type.displayName === 'Image')) {
        return /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$l$1.textFieldInputAffixImageWrapper, affixClassNames, affixNoIconClass)
        }, /*#__PURE__*/cloneElement(affix, {
          className: styles$l$1.textFieldInputAffixImage
        }));
      } else if (affix.type && /*#__PURE__*/isValidElement(affix) && ( // @ts-ignore
      affix.type.displayName === 'CoreDropdown' || affix.type.displayName === 'Dropdown')) {
        return /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$l$1.textFieldInputAffixDropdownWrapper, affixClassNames, affixNoIconClass)
        }, /*#__PURE__*/cloneElement(affix, {
          className: styles$l$1.textFieldInputAffixDropdown,
          dropdownMenuWidth: _this.state.viewPortWidth
        }));
      }

      return /*#__PURE__*/createElement("div", {
        className: joinClasses(affixClassNames, styles$l$1.textFieldInputAffixButtonIcon)
      }, /*#__PURE__*/cloneElement(affix, __assign({}, disabled ? {
        disabled: disabled,
        href: undefined,
        to: undefined
      } : {})));
    };

    _this.getAffixType = function (affix) {
      if (!affix) {
        return 'normal';
      }

      if (typeof affix === 'string' || // @ts-ignore
      affix.type && (affix.type.displayName === 'CoreImage' || affix.type.displayName === 'Image')) {
        return 'combined';
      }

      return 'distinct';
    };

    _this.state = {
      inputValue: '',
      isActive: false,
      isFocus: false,
      viewPortWidth: 0
    };
    return _this;
  }

  TextFieldComponent.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        id = _a.id,
        label = _a.label,
        title = _a.title,
        subLabel = _a.subLabel,
        helptext = _a.helptext,
        error = _a.error,
        value = _a.value,
        required = _a.required,
        disabled = _a.disabled,
        prefixContent = _a.prefixContent,
        suffixContent = _a.suffixContent,
        className = _a.className,
        forwardRef = _a.forwardRef,
        options = _a.options,
        errorStatus = _a.errorStatus,
        iconBrand = _a.iconBrand,
        props = __rest(_a, ["id", "label", "title", "subLabel", "helptext", "error", "value", "onChange", "onFocus", "onBlur", "required", "disabled", "prefixContent", "suffixContent", "className", "forwardRef", "options", "errorStatus", "iconBrand"]);

    var isFocus = this.state.isFocus;
    var hintErrorId = error || helptext ? id + "-hint-error" : undefined;
    var textFieldContent = /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$l$1.textFieldInputWrapper, !disabled && isFocus && styles$l$1.textFieldInputFocus, !disabled && Boolean(value) && styles$l$1.textFieldInputValue, (errorStatus || error) && styles$l$1.textFieldInputStatusError, (errorStatus || error) && !disabled && isFocus && styles$l$1.textFieldInputFocusError)
    }, prefixContent && this.renderAffix(prefixContent, true), /*#__PURE__*/createElement("input", __assign({
      id: id,
      className: joinClasses(styles$l$1.textFieldInput, statusToInputFieldPrefixSuffix[this.getAffixType(prefixContent) + "Prefix"], statusToInputFieldPrefixSuffix[this.getAffixType(suffixContent) + "Suffix"], typographyStyles.formText, resetStyles.textinputReset)
    }, props, {
      "aria-describedby": hintErrorId,
      onChange: this.onInputChangeHandler,
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      required: required,
      value: !(options && Boolean(options.length)) ? value : this.state.inputValue,
      disabled: disabled,
      ref: forwardRef,
      title: title
    })), suffixContent && this.renderAffix(suffixContent, false)), options && Boolean(options.length) && /*#__PURE__*/createElement(ButtonIcon, {
      className: styles$l$1.textFieldDataListArrowIcon,
      element: "button",
      icon: "arrow-down",
      iconBrand: iconBrand,
      label: "",
      hideLabel: true,
      onClick: this.handleArrowClick
    }), options && Boolean(options.length) && this.state.isActive && /*#__PURE__*/createElement("ul", {
      className: styles$l$1.textFieldDataList
    }, options.filter(function (item) {
      if (!_this.state.inputValue) {
        return true;
      }

      if (item.label.toLocaleLowerCase().includes(_this.state.inputValue.toLocaleLowerCase())) {
        return true;
      }

      return false;
    }).map(function (item) {
      return (
        /*#__PURE__*/
        // tslint:disable-next-line:react-a11y-role-has-required-aria-props
        createElement("li", {
          value: item.value,
          role: "option",
          onMouseDown: function onMouseDown(event) {
            return _this.handleOptionClick(event, item);
          },
          tabIndex: 0,
          className: styles$l$1.textFieldDataListOptions
        }, /*#__PURE__*/createElement(Body, {
          element: "span",
          variant: "standard"
        }, item.label))
      );
    })));
    return /*#__PURE__*/createElement(Measure, {
      bounds: true,
      onResize: debounce(100, this.onResize)
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/createElement("div", {
        ref: measureRef,
        className: joinClasses(styles$l$1.textField, className)
      }, options && Boolean(options.length) ? /*#__PURE__*/createElement("div", {
        className: styles$l$1.textFieldWrapperClass
      }, textFieldContent) : textFieldContent, /*#__PURE__*/createElement(ContentAlignment, {
        element: "div",
        direction: "row",
        alignment: "baseline",
        className: styles$l$1.textFieldLabel
      }, label && /*#__PURE__*/createElement(LabelInput, {
        htmlFor: id,
        label: label,
        element: "label",
        className: joinClasses(styles$l$1.textFieldLabelText, resetStyles.maxWidthReset),
        disabled: disabled,
        required: required
      }), label && subLabel && /*#__PURE__*/createElement(HintError, {
        hint: subLabel,
        id: hintErrorId,
        className: styles$l$1.textFieldLabelSub,
        disabled: disabled
      })), helptext || error ? /*#__PURE__*/createElement(HintError, {
        error: error,
        hint: helptext,
        id: hintErrorId,
        className: styles$l$1.textFieldHintError,
        disabled: disabled
      }) : null);
    });
  };

  return TextFieldComponent;
}(Component);

var TextField = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/createElement(TextFieldComponent, __assign({
    forwardRef: ref
  }, props));
});
TextField.displayName = 'CoreTextField';

var styles$m$1 = {"toast":"fr-ec-toast","toast--attention":"fr-ec-toast--attention","toastAttention":"fr-ec-toast--attention","toast__icon":"fr-ec-toast__icon","toastIcon":"fr-ec-toast__icon","toast__caption":"fr-ec-toast__caption","toastCaption":"fr-ec-toast__caption","toast__button-container":"fr-ec-toast__button-container","toastButtonContainer":"fr-ec-toast__button-container","toast--close-button":"fr-ec-toast--close-button","toastCloseButton":"fr-ec-toast--close-button"};

var Toast = function Toast(_a) {
  var icon = _a.icon,
      children = _a.children,
      className = _a.className,
      linkTextLabel = _a.linkTextLabel,
      linkTextIcon = _a.linkTextIcon,
      element = _a.element,
      _b = _a.variant,
      variant = _b === void 0 ? 'dark' : _b,
      _c = _a.autoClose,
      autoClose = _c === void 0 ? false : _c,
      _d = _a.autoCloseDelay,
      autoCloseDelay = _d === void 0 ? 5000 : _d,
      _e = _a.enableCloseButton,
      enableCloseButton = _e === void 0 ? false : _e,
      onClose = _a.onClose,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["icon", "children", "className", "linkTextLabel", "linkTextIcon", "element", "variant", "autoClose", "autoCloseDelay", "enableCloseButton", "onClose", "iconBrand"]);

  var _f = useState(autoClose),
      showAutoHideToaster = _f[0],
      setHideToaster = _f[1];

  var _g = useState(false),
      closeToaster = _g[0],
      setCloseToasterValue = _g[1];

  var closeToast = function closeToast() {
    setCloseToasterValue(true);

    if (onClose) {
      onClose();
    }
  };

  var ToastComponent = /*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(styles$m$1.toast, styles$m$1["toast--" + variant], className)
  }, icon && /*#__PURE__*/React__default.createElement("div", {
    className: styles$m$1.toastIcon
  }, /*#__PURE__*/React__default.createElement(Icon, {
    name: iconBrand ? "" + iconBrand + icon : icon
  })), /*#__PURE__*/React__default.createElement(Caption, {
    element: "p",
    className: joinClasses(styles$m$1.toastCaption, resetStyles.maxWidthReset),
    color: "primary-light"
  }, children), linkTextLabel && element && /*#__PURE__*/React__default.createElement("div", {
    className: styles$m$1.toastButtonContainer
  },
  /*#__PURE__*/
  // @ts-ignore
  React__default.createElement(LinkText, __assign({
    element: element,
    icon: linkTextIcon,
    iconBrand: iconBrand
  }, props), linkTextLabel)), enableCloseButton && /*#__PURE__*/React__default.createElement("div", {
    className: styles$m$1.toastCloseButton
  }, /*#__PURE__*/React__default.createElement(ButtonIcon, {
    hideLabel: true,
    onClick: closeToast,
    element: "button",
    label: "close",
    icon: "close-big",
    variant: "light",
    iconBrand: iconBrand
  })));
  useEffect(function () {
    setTimeout(function () {
      if (showAutoHideToaster) {
        setHideToaster(false);

        if (onClose) {
          onClose();
        }
      }
    }, autoCloseDelay);
  }, [showAutoHideToaster]);
  return showAutoHideToaster ? ToastComponent : !autoClose && !closeToaster ? ToastComponent : null;
};
Toast.displayName = 'CoreToast';

var styles$n$1 = {"gender-tabs":"fr-ec-gender-tabs","genderTabs":"fr-ec-gender-tabs","gender-tabs__list":"fr-ec-gender-tabs__list","genderTabsList":"fr-ec-gender-tabs__list","link-primary-nav":"fr-ec-link-primary-nav","linkPrimaryNav":"fr-ec-link-primary-nav","link-primary-nav__text-wrapper":"fr-ec-link-primary-nav__text-wrapper","linkPrimaryNavTextWrapper":"fr-ec-link-primary-nav__text-wrapper","link-primary-nav--active":"fr-ec-link-primary-nav--active","linkPrimaryNavActive":"fr-ec-link-primary-nav--active","gender-tabs--enable-auto-hide":"fr-ec-gender-tabs--enable-auto-hide","genderTabsEnableAutoHide":"fr-ec-gender-tabs--enable-auto-hide","gender-tabs-disable-auto-hide-wrapper":"fr-ec-gender-tabs-disable-auto-hide-wrapper","genderTabsDisableAutoHideWrapper":"fr-ec-gender-tabs-disable-auto-hide-wrapper","gender-tabs--disable-auto-hide":"fr-ec-gender-tabs--disable-auto-hide","genderTabsDisableAutoHide":"fr-ec-gender-tabs--disable-auto-hide","gender-tabs__enable-auto-hide-wrapper":"fr-ec-gender-tabs__enable-auto-hide-wrapper","genderTabsEnableAutoHideWrapper":"fr-ec-gender-tabs__enable-auto-hide-wrapper","gender-tabs__promotion-banner-wrapper":"fr-ec-gender-tabs__promotion-banner-wrapper","genderTabsPromotionBannerWrapper":"fr-ec-gender-tabs__promotion-banner-wrapper","gender-tabs--disable-auto-hide-wrapper-with-promotion-banner":"fr-ec-gender-tabs--disable-auto-hide-wrapper-with-promotion-banner","genderTabsDisableAutoHideWrapperWithPromotionBanner":"fr-ec-gender-tabs--disable-auto-hide-wrapper-with-promotion-banner","gender-tabs--disable-auto-hide-promotion-banner":"fr-ec-gender-tabs--disable-auto-hide-promotion-banner","genderTabsDisableAutoHidePromotionBanner":"fr-ec-gender-tabs--disable-auto-hide-promotion-banner","gender-tabs--enable-auto-hide-wrapper-with-promotion-banner":"fr-ec-gender-tabs--enable-auto-hide-wrapper-with-promotion-banner","genderTabsEnableAutoHideWrapperWithPromotionBanner":"fr-ec-gender-tabs--enable-auto-hide-wrapper-with-promotion-banner","gender-tabs--enable-auto-hide-promotion-banner":"fr-ec-gender-tabs--enable-auto-hide-promotion-banner","genderTabsEnableAutoHidePromotionBanner":"fr-ec-gender-tabs--enable-auto-hide-promotion-banner","gender-tabs---auto-hide-wrapper-with-promotion-banner-only":"fr-ec-gender-tabs---auto-hide-wrapper-with-promotion-banner-only","genderTabsAutoHideWrapperWithPromotionBannerOnly":"fr-ec-gender-tabs---auto-hide-wrapper-with-promotion-banner-only","gender-tabs---auto-hide-promotion-banner-only":"fr-ec-gender-tabs---auto-hide-promotion-banner-only","genderTabsAutoHidePromotionBannerOnly":"fr-ec-gender-tabs---auto-hide-promotion-banner-only","cms-tab-group":"fr-ec-cms-tab-group","cmsTabGroup":"fr-ec-cms-tab-group"};

var GenderTabs = function GenderTabs(_a) {
  var childrenArray = _a.childrenArray,
      className = _a.className,
      defaultIndex = _a.defaultIndex,
      enableAutoHide = _a.enableAutoHide,
      promotionBanner = _a.promotionBanner,
      props = __rest(_a, ["childrenArray", "className", "defaultIndex", "enableAutoHide", "onChangeTab", "inVerticalScroll", "promotionBanner"]);

  var genderRef = useRef(null);
  var promotionBannerRef = useRef(null);

  var _c = useState(false),
      goingUp = _c[0],
      setGoingUp = _c[1];

  var prevScrollY = useRef(0);
  useEffect(function () {
    var genderEle = genderRef;
    var bannerEle = promotionBannerRef;

    var handleScroll = function handleScroll() {
      var headerEl = document.getElementsByTagName('header')[0];
      var headerOffset = 0;

      if (headerEl) {
        headerOffset = headerEl.offsetHeight;
      }

      var currentScrollY = window.pageYOffset;

      if (prevScrollY.current < currentScrollY && goingUp) {
        setGoingUp(false);
      }

      if (prevScrollY.current > currentScrollY && !goingUp) {
        setGoingUp(true);
      }

      if (enableAutoHide) {
        if (genderEle.current) {
          if (!goingUp && currentScrollY > genderEle.current.offsetHeight) {
            genderEle.current.style.top = 0;
          } else if (goingUp && currentScrollY > genderEle.current.offsetHeight) {
            genderEle.current.style.top = headerOffset + "px";
          }
        }

        if (bannerEle.current) {
          if (!goingUp && currentScrollY > bannerEle.current.offsetHeight) {
            bannerEle.current.style.top = 0;
          } else if (goingUp && currentScrollY > bannerEle.current.offsetHeight) {
            bannerEle.current.style.top = headerOffset + (genderEle.current ? genderEle.current.offsetHeight : 0) + "px";
          }
        }
      } else {
        if (bannerEle.current) {
          if (!goingUp && currentScrollY > bannerEle.current.offsetHeight) {
            bannerEle.current.style.top = 0;
          } else if (goingUp && currentScrollY < bannerEle.current.offsetHeight) {
            bannerEle.current.style.top = headerOffset + (genderEle.current ? genderEle.current.offsetHeight : 0) + "px";
          }
        }
      }

      prevScrollY.current = currentScrollY;
    };

    if (isInBrowser()) {
      window.addEventListener('scroll', handleScroll, {
        passive: true
      });
    }

    return function () {
      if (isInBrowser()) {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  }, [goingUp]);
  return /*#__PURE__*/createElement(Fragment, null, !enableAutoHide ? /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$n$1.genderTabsDisableAutoHideWrapper, promotionBanner ? childrenArray && childrenArray.length > 0 ? styles$n$1.genderTabsDisableAutoHideWrapperWithPromotionBanner : styles$n$1.genderTabsAutoHideWrapperWithPromotionBannerOnly : '')
  }, props), childrenArray && childrenArray.length > 0 && /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$n$1.genderTabs, className, styles$n$1.genderTabsDisableAutoHide),
    ref: genderRef
  }, props), /*#__PURE__*/createElement("div", {
    className: styles$n$1.genderTabsList
  }, /*#__PURE__*/createElement(CmsTabGroup, {
    tabsType: 'verticalscroll-gender',
    defaultIndex: defaultIndex
  }, childrenArray))), promotionBanner && /*#__PURE__*/createElement("div", {
    ref: promotionBannerRef,
    className: joinClasses(styles$n$1.genderTabsPromotionBannerWrapper, childrenArray.length > 0 ? styles$n$1.genderTabsDisableAutoHidePromotionBanner : styles$n$1.genderTabsAutoHidePromotionBannerOnly)
  }, promotionBanner)) : /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$n$1.genderTabsEnableAutoHideWrapper, promotionBanner ? childrenArray.length > 0 ? styles$n$1.genderTabsEnableAutoHideWrapperWithPromotionBanner : styles$n$1.genderTabsAutoHideWrapperWithPromotionBannerOnly : '')
  }, props), childrenArray.length > 0 && /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$n$1.genderTabs, className, enableAutoHide ? styles$n$1.genderTabsEnableAutoHide : ''),
    ref: genderRef
  }, /*#__PURE__*/createElement("div", {
    className: styles$n$1.genderTabsList
  }, /*#__PURE__*/createElement(CmsTabGroup, {
    tabsType: 'verticalscroll-gender',
    defaultIndex: defaultIndex
  }, childrenArray))), promotionBanner && /*#__PURE__*/createElement("div", {
    ref: promotionBannerRef,
    className: joinClasses(styles$n$1.genderTabsPromotionBannerWrapper, childrenArray.length > 0 ? styles$n$1.genderTabsEnableAutoHidePromotionBanner : styles$n$1.genderTabsAutoHidePromotionBannerOnly)
  }, promotionBanner)));
};
GenderTabs.displayName = 'CoreGenderTabs';
GenderTabs.defaultProps = {
  defaultIndex: 0,
  enableAutoHide: true
};

var styles$o$1 = {"product-tile":"fr-ec-product-tile","productTile":"fr-ec-product-tile","product-tile__horizontal":"fr-ec-product-tile__horizontal","productTileHorizontal":"fr-ec-product-tile__horizontal","product-tile__vertical":"fr-ec-product-tile__vertical","productTileVertical":"fr-ec-product-tile__vertical","product-tile__horizontal_spacing":"fr-ec-product-tile__horizontal_spacing","productTileHorizontalSpacing":"fr-ec-product-tile__horizontal_spacing","product-tile__toggle":"fr-ec-product-tile__toggle","productTileToggle":"fr-ec-product-tile__toggle","product-tile__image":"fr-ec-product-tile__image","productTileImage":"fr-ec-product-tile__image","product-tile__chip-group":"fr-ec-product-tile__chip-group","productTileChipGroup":"fr-ec-product-tile__chip-group","chip-group-product-tile__toggle-button":"fr-ec-chip-group-product-tile__toggle-button","chipGroupProductTileToggleButton":"fr-ec-chip-group-product-tile__toggle-button","product-tile__product-info":"fr-ec-product-tile__product-info","productTileProductInfo":"fr-ec-product-tile__product-info","product-tile__status-flags-list":"fr-ec-product-tile__status-flags-list","productTileStatusFlagsList":"fr-ec-product-tile__status-flags-list","product-tile__specs":"fr-ec-product-tile__specs","productTileSpecs":"fr-ec-product-tile__specs","product-tile__status-flags-list-item":"fr-ec-product-tile__status-flags-list-item","productTileStatusFlagsListItem":"fr-ec-product-tile__status-flags-list-item","product-tile__end":"fr-ec-product-tile__end","productTileEnd":"fr-ec-product-tile__end","product-tile__end-product-name":"fr-ec-product-tile__end-product-name","productTileEndProductName":"fr-ec-product-tile__end-product-name","product-tile__end-product-id":"fr-ec-product-tile__end-product-id","productTileEndProductId":"fr-ec-product-tile__end-product-id","product-tile__end-info-block":"fr-ec-product-tile__end-info-block","productTileEndInfoBlock":"fr-ec-product-tile__end-info-block","product-tile__end-info-block-flags":"fr-ec-product-tile__end-info-block-flags","productTileEndInfoBlockFlags":"fr-ec-product-tile__end-info-block-flags","product-tile__end-info-block-price":"fr-ec-product-tile__end-info-block-price","productTileEndInfoBlockPrice":"fr-ec-product-tile__end-info-block-price","product-tile__end-info-block-price-flags":"fr-ec-product-tile__end-info-block-price-flags","productTileEndInfoBlockPriceFlags":"fr-ec-product-tile__end-info-block-price-flags","rating-static__reviews":"fr-ec-rating-static__reviews","ratingStaticReviews":"fr-ec-rating-static__reviews","link-text":"fr-ec-link-text","linkText":"fr-ec-link-text","body":"fr-ec-body","product-tile__end-info-block-tags":"fr-ec-product-tile__end-info-block-tags","productTileEndInfoBlockTags":"fr-ec-product-tile__end-info-block-tags","tag":"fr-ec-tag","product-tile--width-small":"fr-ec-product-tile--width-small","productTileWidthSmall":"fr-ec-product-tile--width-small","chip-group-product-tile__fieldset":"fr-ec-chip-group-product-tile__fieldset","chipGroupProductTileFieldset":"fr-ec-chip-group-product-tile__fieldset","chip-group-product-tile__chip":"fr-ec-chip-group-product-tile__chip","chipGroupProductTileChip":"fr-ec-chip-group-product-tile__chip","chip__input--product-tile":"fr-ec-chip__input--product-tile","chipInputProductTile":"fr-ec-chip__input--product-tile","chip__label--product-tile":"fr-ec-chip__label--product-tile","chipLabelProductTile":"fr-ec-chip__label--product-tile","chip-group-product-tile__fieldset--expanded":"fr-ec-chip-group-product-tile__fieldset--expanded","chipGroupProductTileFieldsetExpanded":"fr-ec-chip-group-product-tile__fieldset--expanded","chip--product-tile":"fr-ec-chip--product-tile","chipProductTile":"fr-ec-chip--product-tile","product-tile-resize-wrapper":"fr-ec-product-tile-resize-wrapper","productTileResizeWrapper":"fr-ec-product-tile-resize-wrapper","product-tile__original-price":"fr-ec-product-tile__original-price","productTileOriginalPrice":"fr-ec-product-tile__original-price"};

var FlagUITypes = {
  GENDER: 'gender',
  LIMITED: 'limited',
  LIMITED_GREY: 'limited-grey',
  NORMAL: 'normal'
};
var containerSizeSmall = 'small';
var containerSizeLarge = 'large';

var isLimitedFlag = function isLimitedFlag(_a) {
  var type = _a.type;
  return type === FlagUITypes.LIMITED || type === FlagUITypes.LIMITED_GREY;
};

var createStringFromFlagsList = function createStringFromFlagsList(flags) {
  return flags && flags.length > 0 ? flags.map(function (_a) {
    var flag = _a.flag;
    return flag;
  }).join(', ') : '';
};

var convertFlagTypeToColor = function convertFlagTypeToColor(type) {
  switch (type) {
    case FlagUITypes.LIMITED:
      return 'promotional';

    case FlagUITypes.NORMAL:
      return 'placeholder';

    default:
      return 'placeholder';
  }
};

var StatusFlags = function StatusFlags(_a) {
  var className = _a.className,
      flags = _a.flags;
  var highlightedFlags = flags.filter(isLimitedFlag);
  var normalFlags = flags.filter(function (flag) {
    return !isLimitedFlag(flag);
  });
  var combinedFlags = createStringFromFlagsList(normalFlags);
  return /*#__PURE__*/createElement("ul", {
    className: joinClasses(styles$o$1.productTileStatusFlagsList, className)
  }, highlightedFlags && highlightedFlags.map(function (_a) {
    var flag = _a.flag,
        type = _a.type;
    return /*#__PURE__*/createElement("li", {
      key: flag,
      className: styles$o$1.productTileStatusFlagsListItem
    }, /*#__PURE__*/createElement(FlagText, {
      element: "p",
      variant: "large",
      color: convertFlagTypeToColor(type)
    }, flag));
  }), combinedFlags && /*#__PURE__*/createElement("li", null, /*#__PURE__*/createElement(FlagText, {
    element: "p",
    variant: "large",
    color: "placeholder",
    className: styles$o$1.productTileStatusFlagsListItem
  }, combinedFlags)));
};

var ProductPrice = function ProductPrice(_a) {
  var price = _a.price,
      originalPrice = _a.originalPrice,
      _b = _a.highlighted,
      highlighted = _b === void 0 ? false : _b,
      tax = _a.tax,
      multiBuy = _a.multiBuy,
      _c = _a.multiPrice,
      multiPrice = _c === void 0 ? false : _c,
      items = _a.items,
      discount = _a.discount,
      _d = _a.priceTypographyVariant,
      priceTypographyVariant = _d === void 0 ? 'small' : _d;
  return /*#__PURE__*/createElement("div", {
    className: styles$o$1.productTileEndInfoBlockPrice
  }, /*#__PURE__*/createElement("div", null, originalPrice && /*#__PURE__*/createElement(Price, {
    element: "p",
    variant: "standard",
    size: "extraSmall",
    strikeThrough: true,
    discount: discount,
    className: styles$o$1.productTileOriginalPrice
  }, originalPrice), multiBuy && !multiPrice && /*#__PURE__*/createElement(Price, {
    element: "p",
    variant: "promotional",
    size: priceTypographyVariant === 'large' ? 'large' : 'small'
  }, multiBuy), highlighted && price && /*#__PURE__*/createElement(Price, {
    element: "p",
    variant: "promotional",
    size: priceTypographyVariant === 'large' ? 'large' : 'small'
  }, price), !highlighted && price && /*#__PURE__*/createElement(Price, {
    element: "p",
    variant: "standard",
    size: priceTypographyVariant === 'large' ? 'large' : 'small'
  }, price), tax && /*#__PURE__*/createElement(Price, {
    element: "p",
    variant: "standard",
    size: priceTypographyVariant === 'large' ? 'large' : 'small'
  }, tax), multiBuy && multiPrice && /*#__PURE__*/createElement(Price, {
    element: "p",
    variant: "promotional",
    size: priceTypographyVariant === 'large' ? 'large' : 'small'
  }, multiBuy)), items && /*#__PURE__*/createElement(StatusFlags, {
    className: styles$o$1.productTileEndInfoBlockPriceFlags,
    flags: items
  }));
};

var ProductTile =
/** @class */
function (_super) {
  __extends(ProductTile, _super);

  function ProductTile(props) {
    var _this = _super.call(this, props) || this;

    _this.linkEnabled = true;

    _this.onToggle = function (event) {
      event.preventDefault();
      event.stopPropagation();
      var onClickFavorite = _this.props.onClickFavorite;

      if (onClickFavorite) {
        onClickFavorite(!_this.props.favorite, event);
      }
    };

    _this.onExpandedToggle = function (isExpanded) {
      _this.setState({
        isExpanded: isExpanded
      });
    };

    _this.onChipClick = function (index) {
      _this.setState({
        currentChip: index,
        // fallthrough to default main image
        imagePreview: _this.props.images[index] || _this.props.imageUrl || _this.props.images[0]
      });
    };

    _this.onChipPreviewSet = function (index) {
      _this.setState({
        imageHover: _this.props.images && _this.props.images[index]
      });
    };

    _this.onChipPreviewClose = function () {
      _this.setState({
        imageHover: undefined
      });
    }; // Disabled to enable click to trigger tile link


    _this.onReviewClick = function () {// e.preventDefault();
      // if (this.props.reviewUrl) {
      //   const route = `/${country}/${language}${this.props.reviewUrl}`;
      //   window.location.href = route;
      // }
    };

    _this.onResize = function (contentRect) {
      if (contentRect.bounds) {
        var width = contentRect.bounds.width; // Check if the container width matches the small breakpoint

        if (width <= 125) {
          _this.setState({
            containerSize: containerSizeSmall
          });
        } // Check if the container width matches the large breakpoint
        else {
            _this.setState({
              containerSize: containerSizeLarge
            });
          }
      }
    };

    _this.disableLink = _this.disableLink.bind(_this);
    _this.enableLink = _this.enableLink.bind(_this);
    _this.enableLinkOnMouseLeave = _this.enableLinkOnMouseLeave.bind(_this);
    _this.onTileClick = _this.onTileClick.bind(_this);
    _this.state = {
      containerSize: containerSizeLarge,
      currentChip: props.currentChip || 0,
      imageHover: undefined,
      imagePreview: props.imageUrl || props.images[0],
      isExpanded: false
    };
    return _this;
  }

  ProductTile.prototype.componentDidUpdate = function (prevProps) {
    if (this.props.imageUrl && this.props.imageUrl !== prevProps.imageUrl) {
      this.setState({
        imagePreview: this.props.imageUrl
      });
    }

    if (prevProps.currentChip !== this.props.currentChip) {
      this.setState({
        currentChip: Number(this.props.currentChip)
      });
    }
  };

  ProductTile.prototype.onTileClick = function (e) {
    if (!this.linkEnabled) {
      e.preventDefault();
    }
  };
  /**
   * When a user clicks on an internal button (from the chip group) it will
   * click through to the anchor underneath.
   * To get around this anytime the mouse enters the ChipGroupProductTile, we
   * disable the link, and anytime it exits, we enable it.
   */


  ProductTile.prototype.disableLink = function () {
    this.linkEnabled = false;
  };

  ProductTile.prototype.enableLink = function () {
    this.linkEnabled = true;
  };
  /**
   * When mousing over interactive elements inside the tile (i.e. ButtonToggle, ChipGroup), we disable the underlying link.
   * On `mouseleave`, we want to re-enable the link.
   * `mouseleave` however triggers when even entering nested DOM nodes.
   * So rather than using the native event target, we check to ensure that
   * the pointer is fact not within the clientBoundingRect of the node we
   * have the `mouseleave` event on
   */


  ProductTile.prototype.enableLinkOnMouseLeave = function (e) {
    var target = e.target,
        screenX = e.screenX,
        screenY = e.screenY; // @ts-ignore

    var clientRect = target.getBoundingClientRect();
    var isNotWithinElementBounds = !isPointInClientRect(clientRect, screenX, screenY);

    if (isNotWithinElementBounds) {
      this.enableLink();
    }
  };

  ProductTile.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        _b = _a.type,
        type = _b === void 0 ? 'wishlist' : _b,
        id = _a.id,
        className = _a.className,
        name = _a.name,
        _c = _a.nameTypographyVariant,
        nameTypographyVariant = _c === void 0 ? 'TitleStandard' : _c,
        favorite = _a.favorite,
        favoriteButtonHidden = _a.favoriteButtonHidden,
        _d = _a.favoriteIconAlt,
        favoriteIconAlt = _d === void 0 ? '' : _d,
        _e = _a.chipImages,
        chipImages = _e === void 0 ? [] : _e,
        _f = _a.sizeRange,
        sizeRange = _f === void 0 ? [] : _f,
        _g = _a.genderName,
        genderName = _g === void 0 ? [] : _g,
        _h = _a.flags,
        flags = _h === void 0 ? [] : _h,
        currentPrice = _a.currentPrice,
        priceHighlighted = _a.priceHighlighted,
        _j = _a.productLink,
        productLink = _j === void 0 ? '' : _j,
        _k = _a.tax,
        tax = _k === void 0 ? '' : _k,
        _l = _a.priceFlags,
        priceFlags = _l === void 0 ? [] : _l,
        ratingCount = _a.ratingCount,
        _m = _a.ratingAverage,
        ratingAverage = _m === void 0 ? '' : _m,
        _o = _a.promotionText,
        promotionText = _o === void 0 ? '' : _o,
        _p = _a.productId,
        productId = _p === void 0 ? '' : _p,
        _q = _a.gaCategory,
        gaCategory = _q === void 0 ? '' : _q,
        _r = _a.gaCallback,
        gaCallback = _r === void 0 ? function () {
      return null;
    } : _r,
        _s = _a.l1Id,
        l1Id = _s === void 0 ? '' : _s,
        _t = _a.noImageLabel,
        noImageLabel = _t === void 0 ? '' : _t,
        _u = _a.maxLinesEllipsis,
        maxLinesEllipsis = _u === void 0 ? 0 : _u,
        _v = _a.productCollectionType,
        productCollectionType = _v === void 0 ? 'grid' : _v,
        iconBrand = _a.iconBrand,
        _w = _a.variant,
        variant = _w === void 0 ? 'vertical' : _w,
        target = _a.target,
        originalPrice = _a.originalPrice,
        discount = _a.discount,
        tags = _a.tags,
        _x = _a.imageRatio,
        imageRatio = _x === void 0 ? '1x1' : _x,
        _y = _a.enableChipInteraction,
        enableChipInteraction = _y === void 0 ? false : _y;
    var _z = this.state,
        currentChip = _z.currentChip,
        imagePreview = _z.imagePreview,
        imageHover = _z.imageHover,
        isExpanded = _z.isExpanded;
    var gaProps = {
      gaCallback: gaCallback,
      gaCategory: gaCategory,
      gaLabel: l1Id || 'l1-id'
    };

    var onClick = function onClick(event) {
      _this.onTileClick(event);
    };

    var mappedChipImages = chipImages ? chipImages.map(function (chipItem, i) {
      return {
        image: chipItem.url,
        label: chipItem.alt,
        name: 'product-chips',
        type: 'radio',
        value: "" + i,
        variant: 'short'
      };
    }) : [];
    var rootTag = 'a';
    var absoluteUrlPattern = isAbsoluteUrl(productLink);
    var attributes = {};

    if (absoluteUrlPattern) {
      attributes = {
        href: productLink,
        target: target || '_self'
      };
    } else if (productLink) {
      rootTag = Link$1; // Default target behaviour of Link is similar to that of '_self'.
      // But if you specify target property explicitly, it refreshes the page.
      // @ts-ignore

      attributes.to = productLink;

      if (target && target !== '_self') {
        // @ts-ignore
        attributes.target = target;
      }
    }

    var imageProps = {
      alt: name,
      iconBrand: iconBrand,
      noImage: {
        imageSize: 'default',
        imageType: 'product',
        noImageLabel: noImageLabel
      },
      ratio: imageRatio,
      src: imageHover || imagePreview || ''
    };
    var genderNames = genderName && genderName.join(', ');
    var sizeRanges = sizeRange && sizeRange.join('-');
    var categories = genderNames && sizeRanges ? genderNames + ", " + sizeRanges : genderNames || sizeRanges;
    var showCategory = categories ? productCollectionType && (productCollectionType === 'grid' || productCollectionType === 'setup') ? true : false : false;
    var showRating = ratingCount && ratingCount > 0 ? productCollectionType && (productCollectionType === 'grid' || productCollectionType === 'setup') ? true : false : false;
    var productTags = tags && tags.length ? tags.map(function (item, i) {
      return /*#__PURE__*/createElement(Tag, {
        key: i,
        variant: item.variant,
        value: item.tag
      });
    }) : null;
    var nameTitleVariant = nameTypographyVariant === 'TitleLarge' ? 'large' : 'standard';
    return /*#__PURE__*/createElement(Measure, {
      bounds: true,
      onResize: debounce(100, this.onResize)
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/createElement("div", {
        ref: measureRef,
        className: styles$o$1.productTileResizeWrapper
      }, /*#__PURE__*/createElement(Tile, __assign({
        tabIndex: 0,
        className: joinClasses(className, styles$o$1.productTile, styles$o$1["product-tile--variant-" + type], styles$o$1["product-tile--width-" + _this.state.containerSize], variant === 'horizontal' ? styles$o$1.productTileHorizontal : styles$o$1.productTileVertical),
        id: id !== null && id !== void 0 ? id : productId,
        onClick: onClick,
        element: rootTag
      }, attributes, gaProps), /*#__PURE__*/createElement("div", {
        className: variant === 'horizontal' ? styles$o$1.productTileHorizontalSpacing : ''
      }, /*#__PURE__*/createElement("div", {
        className: styles$o$1.productTileImage
      }, /*#__PURE__*/createElement(Image, __assign({}, imageProps)), !favoriteButtonHidden && /*#__PURE__*/createElement(ButtonToggle, {
        icon: "heart",
        variant: "icon",
        text: "",
        iconTitle: favoriteIconAlt,
        isToggled: favorite,
        className: styles$o$1.productTileToggle,
        onClick: _this.onToggle,
        onMouseLeave: _this.enableLinkOnMouseLeave,
        onMouseEnter: _this.disableLink,
        onFocus: _this.disableLink,
        onBlur: _this.enableLink,
        iconBrand: iconBrand
      })), (chipImages.length > 0 || showCategory) && /*#__PURE__*/createElement(ContentAlignment, {
        className: styles$o$1.productTileProductInfo,
        element: "div",
        direction: type === 'large' ? 'row' : 'column',
        alignment: "stretch",
        justifyContent: "space-between"
      }, chipImages.length > 0 && /*#__PURE__*/createElement(ChipGroupProductTile, {
        title: [name, 'chipgroup'].join('-'),
        id: [id, 'chipgroup'].join('-'),
        onMouseLeave: _this.enableLinkOnMouseLeave,
        onMouseEnter: _this.disableLink,
        onFocus: _this.disableLink,
        onBlur: _this.enableLink,
        onExpandedToggle: _this.onExpandedToggle,
        expanded: isExpanded,
        expandButtonAlt: "See more chips.",
        collapseButtonAlt: "See fewer chips.",
        className: styles$o$1.productTileChipGroup,
        containerWidth: _this.state.containerSize,
        enableInteraction: enableChipInteraction
      }, chipImages && mappedChipImages ? mappedChipImages.map(function (_a, i) {
        var chipGroupName = _a.name,
            chipProps = __rest(_a, ["name"]);

        return /*#__PURE__*/createElement(Chip, __assign({
          checked: chipProps.value === String(currentChip),
          key: [name, 'chip', i].join('-'),
          id: [id, 'chip', i].join('-'),
          variant: "product-tile",
          onChange: function onChange() {
            return _this.onChipClick(i);
          },
          onMouseOver: function onMouseOver() {
            return _this.onChipPreviewSet(i);
          },
          onMouseLeave: _this.onChipPreviewClose,
          onFocus: function onFocus() {
            _this.disableLink();

            _this.onChipPreviewSet(i);
          },
          onBlur: function onBlur() {
            _this.enableLink();

            _this.onChipPreviewClose();
          },
          name: [id, chipGroupName].join('-'),
          iconBrand: iconBrand
        }, chipProps));
      }) : []), showCategory && /*#__PURE__*/createElement(ContentAlignment, {
        className: styles$o$1['product-tile__specs'],
        element: "div",
        direction: "row",
        justifyContent: "space-between"
      }, /*#__PURE__*/createElement(FlagText, {
        element: "p",
        className: styles$o$1['product-tile__categories'],
        variant: "standard"
      }, categories)))), /*#__PURE__*/createElement("div", {
        className: styles$o$1.productTileEnd
      }, /*#__PURE__*/createElement(Title, {
        style: {
          WebkitLineClamp: maxLinesEllipsis
        },
        variant: nameTitleVariant,
        element: "h3",
        className: styles$o$1.productTileEndProductName
      }, name), productId && /*#__PURE__*/createElement(Body, {
        element: "p",
        variant: "small",
        className: styles$o$1.productTileEndProductId
      }, productId), /*#__PURE__*/createElement(ContentAlignment, {
        element: "div",
        direction: "column",
        justifyContent: "space-between",
        className: styles$o$1.productTileEndInfoBlock
      }, !!flags.length && /*#__PURE__*/createElement(StatusFlags, {
        flags: flags,
        className: styles$o$1.productTileEndInfoBlockFlags
      }), /*#__PURE__*/createElement(ProductPrice, {
        price: currentPrice,
        highlighted: priceHighlighted,
        tax: tax,
        items: priceFlags,
        originalPrice: originalPrice,
        discount: discount,
        priceTypographyVariant: nameTypographyVariant === 'TitleLarge' ? 'large' : 'small'
      }), promotionText && /*#__PURE__*/createElement(Caption, {
        element: "p",
        color: "secondary"
      }, promotionText), showRating && /*#__PURE__*/createElement(RatingStatic, {
        ariaLabel: name,
        reviews: ratingCount,
        value: parseFloat(ratingAverage),
        iconBrand: iconBrand
      }, /*#__PURE__*/createElement(LinkText, {
        element: "button",
        variant: "standalone-small",
        onClick: _this.onReviewClick
      }, "(" + (ratingCount && ratingCount > 999 ? '999+' : ratingCount) + ")")), productTags && /*#__PURE__*/createElement("div", {
        className: styles$o$1.productTileEndInfoBlockTags
      }, productTags)))));
    });
  };

  return ProductTile;
}(Component);

var styles$p$1 = {"tag-filter-group":"fr-ec-tag-filter-group","tagFilterGroup":"fr-ec-tag-filter-group","tag-filter-group__no-wrap-container":"fr-ec-tag-filter-group__no-wrap-container","tagFilterGroupNoWrapContainer":"fr-ec-tag-filter-group__no-wrap-container","tag-filter-group__inner-container":"fr-ec-tag-filter-group__inner-container","tagFilterGroupInnerContainer":"fr-ec-tag-filter-group__inner-container","tag-filter-group--no-wrap":"fr-ec-tag-filter-group--no-wrap","tagFilterGroupNoWrap":"fr-ec-tag-filter-group--no-wrap","tag-filter-group__tag-filter__label":"fr-ec-tag-filter-group__tag-filter__label","tagFilterGroupTagFilterLabel":"fr-ec-tag-filter-group__tag-filter__label","tag-filter__label":"fr-ec-tag-filter__label","tagFilterLabel":"fr-ec-tag-filter__label","collection-list-horizontal__item":"fr-ec-collection-list-horizontal__item","collectionListHorizontalItem":"fr-ec-collection-list-horizontal__item","tag-filter-clear-all-label":"fr-ec-tag-filter-clear-all-label","tagFilterClearAllLabel":"fr-ec-tag-filter-clear-all-label"};

var TagFilterGroup = function TagFilterGroup(_a) {
  var children = _a.children,
      onClear = _a.onClear,
      clearLabel = _a.clearLabel,
      className = _a.className,
      _b = _a.wrap,
      wrap = _b === void 0 ? true : _b,
      props = __rest(_a, ["children", "onClear", "clearLabel", "className", "wrap"]);

  var clickCallback = function clickCallback(e) {
    return onClear && onClear(e, children);
  };

  var showClearAll = Children.toArray(children).filter(isValidElement).filter(function (child) {
    return Boolean(child && !child.props.disabled);
  }).length > 1;
  var childrenWithProps = Children.toArray(children).filter(isValidElement).map(function (child) {
    return /*#__PURE__*/cloneElement(child, {
      className: styles$p$1.tagFilterGroupTagFilterLabel
    });
  });
  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$p$1.tagFilterGroup, !wrap && styles$p$1.tagFilterGroupNoWrapContainer, className)
  }, props), /*#__PURE__*/createElement(CollectionListHorizontal, {
    spacingValue: "16",
    divider: false,
    className: joinClasses(styles$p$1.tagFilterGroupInnerContainer, !wrap && styles$p$1.tagFilterGroupNoWrap, showClearAll && clearLabel && styles$p$1.tagFilterClearAllLabel)
  }, wrap ? children : /*#__PURE__*/createElement(FilterBar, {
    isOverlay: true
  }, childrenWithProps), showClearAll && clearLabel && /*#__PURE__*/createElement(LinkText, {
    element: "button",
    emphasize: false,
    onClick: clickCallback,
    variant: "standalone-primary",
    key: clearLabel
  }, clearLabel)));
};
TagFilterGroup.displayName = 'CoreTagFilterGroup';

var styles$q$1 = {"rating-input__caption":"fr-ec-rating-input__caption","ratingInputCaption":"fr-ec-rating-input__caption","rating-input__caption--inactive":"fr-ec-rating-input__caption--inactive","ratingInputCaptionInactive":"fr-ec-rating-input__caption--inactive","rating-input__group":"fr-ec-rating-input__group","ratingInputGroup":"fr-ec-rating-input__group","rating-input__radio":"fr-ec-rating-input__radio","ratingInputRadio":"fr-ec-rating-input__radio","rating-input__label":"fr-ec-rating-input__label","ratingInputLabel":"fr-ec-rating-input__label","show-focus-border":"fr-ec-show-focus-border","showFocusBorder":"fr-ec-show-focus-border","rating-input__star":"fr-ec-rating-input__star","ratingInputStar":"fr-ec-rating-input__star","rating-input__star--active":"fr-ec-rating-input__star--active","ratingInputStarActive":"fr-ec-rating-input__star--active","rating-input__star--inactive":"fr-ec-rating-input__star--inactive","ratingInputStarInactive":"fr-ec-rating-input__star--inactive"};

var SIZE_ICON = '24';

var getIdForInput = function getIdForInput(parentId, value) {
  return parentId + "-input-" + value;
};

var getValueMapFromOptions = function getValueMapFromOptions(options, id) {
  return options.reduce(function (acc, option) {
    var _a;

    var inputId = getIdForInput(id, option.value);
    return __assign(__assign({}, acc), (_a = {}, _a[inputId] = option.value, _a));
  }, {});
};

var RatingInputComponent =
/** @class */
function (_super) {
  __extends(RatingInputComponent, _super);

  function RatingInputComponent(props) {
    var _this = _super.call(this, props) || this;

    _this.onMouseEnterLabel = function (event) {
      var id = event.currentTarget.getAttribute('for');
      var value = id && _this.valueMap[id];

      _this.setState({
        highlighted: value,
        hovered: value
      });

      if (_this.props.onMouseEnterOption) {
        _this.props.onMouseEnterOption(event);
      }
    };

    _this.onMouseLeaveLabel = function (event) {
      var focused = _this.state.focused;
      var selected = _this.props.selected;
      var value = focused === undefined ? selected : focused;

      _this.setState({
        highlighted: value,
        hovered: undefined
      });

      if (_this.props.onMouseLeaveOption) {
        _this.props.onMouseLeaveOption(event);
      }
    };

    _this.onFocusInput = function (event) {
      var targetValue = event.currentTarget.value;

      _this.setState({
        highlighted: Number(targetValue),
        focused: Number(targetValue)
      });

      if (_this.props.onFocusOption) {
        _this.props.onFocusOption(event);
      }
    };

    _this.onBlurInput = function (event) {
      var hovered = _this.state.hovered;
      var selected = _this.props.selected;
      var value = hovered === undefined ? selected : hovered;

      _this.setState({
        highlighted: value,
        focused: undefined
      });

      if (_this.props.onBlurOption) {
        _this.props.onBlurOption(event);
      }
    };

    var _a = _this.props,
        selected = _a.selected,
        id = _a.id,
        options = _a.options;
    _this.valueMap = getValueMapFromOptions(options, id);
    _this.state = {
      focused: undefined,
      highlighted: selected,
      hovered: undefined
    };
    return _this;
  }

  RatingInputComponent.prototype.componentDidUpdate = function (prevProps) {
    var _a = this.props,
        id = _a.id,
        options = _a.options,
        selected = _a.selected;
    var focused = this.state.focused;
    this.valueMap = getValueMapFromOptions(options, id);
    var value = focused === undefined ? selected : focused;

    if (selected !== prevProps.selected) {
      this.setState({
        highlighted: value,
        hovered: value
      });
    }
  };

  RatingInputComponent.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        legend = _a.legend,
        options = _a.options,
        description = _a.description,
        error = _a.error,
        className = _a.className,
        id = _a.id,
        selected = _a.selected,
        _b = _a.required,
        required = _b === void 0 ? false : _b,
        _c = _a.disabled,
        disabled = _c === void 0 ? false : _c,
        onChangeOption = _a.onChangeOption,
        forwardRef = _a.forwardRef,
        iconBrand = _a.iconBrand,
        props = __rest(_a, ["legend", "options", "description", "error", "className", "id", "selected", "required", "disabled", "onChangeOption", "onMouseEnterOption", "onMouseLeaveOption", "onFocusOption", "onBlurOption", "forwardRef", "iconBrand"]);

    var highlighted = this.state.highlighted;
    var hintErrorId = error && !disabled || description ? id + "-hint-error" : undefined;

    var optionIsHighlighted = function optionIsHighlighted(o) {
      return o.value === highlighted;
    };

    var currentOption = options.find(optionIsHighlighted);
    var ratingCaption = currentOption && currentOption.label;
    var highlightedIndex = options.findIndex(optionIsHighlighted);
    return /*#__PURE__*/createElement("fieldset", __assign({
      className: joinClasses(resetStyles.fieldsetReset, className),
      id: id,
      disabled: disabled,
      "aria-describedby": hintErrorId
    }, props), /*#__PURE__*/createElement(LabelInput, {
      label: legend,
      element: "label",
      required: required,
      disabled: disabled
    }, !disabled && ratingCaption && /*#__PURE__*/createElement(Caption, {
      element: "span",
      className: joinClasses(styles$q$1.ratingInputCaption, highlighted !== selected && styles$q$1.ratingInputCaptionInactive)
    }, ratingCaption)), /*#__PURE__*/createElement("div", {
      className: styles$q$1.ratingInputGroup,
      ref: forwardRef
    }, options.map(function (option, index) {
      var radioId = getIdForInput(id, option.value);
      var filled = !disabled && highlightedIndex >= index;
      return /*#__PURE__*/createElement(Fragment, {
        key: radioId
      }, /*#__PURE__*/createElement("input", {
        type: "radio",
        value: option.value,
        checked: option.value === selected,
        className: styles$q$1.ratingInputRadio,
        id: radioId,
        name: id,
        onFocus: _this.onFocusInput,
        onBlur: _this.onBlurInput,
        onChange: onChangeOption
      }), /*#__PURE__*/createElement("label", {
        key: option.value,
        className: joinClasses(styles$q$1.ratingInputLabel, !disabled && interactionsStyles.cursorPointer),
        htmlFor: radioId,
        onMouseEnter: _this.onMouseEnterLabel,
        onMouseLeave: _this.onMouseLeaveLabel
      }, /*#__PURE__*/createElement(Icon, {
        name: iconBrand ? iconBrand + "star-filled" : 'star-filled',
        size: SIZE_ICON,
        className: joinClasses(styles$q$1.ratingInputStar, filled ? styles$q$1.ratingInputStarActive : styles$q$1.ratingInputStarInactive)
      }), /*#__PURE__*/createElement("span", null, option.label)));
    })), /*#__PURE__*/createElement(HintError, {
      error: error,
      hint: description,
      id: hintErrorId,
      disabled: disabled
    }));
  };

  return RatingInputComponent;
}(Component);
var RatingInput = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/createElement(RatingInputComponent, __assign({
    forwardRef: ref
  }, props));
});
RatingInput.displayName = 'CoreRatingInput';
RatingInput.defaultProps = {
  disabled: false,
  required: false
};

var styles$r$1 = {"media-gallery":"fr-ec-media-gallery","mediaGallery":"fr-ec-media-gallery","media-gallery__preview":"fr-ec-media-gallery__preview","mediaGalleryPreview":"fr-ec-media-gallery__preview","media-gallery__carousel":"fr-ec-media-gallery__carousel","mediaGalleryCarousel":"fr-ec-media-gallery__carousel","media-gallery__preview-chip-container":"fr-ec-media-gallery__preview-chip-container","mediaGalleryPreviewChipContainer":"fr-ec-media-gallery__preview-chip-container","media-gallery__preview-chip-container-inner":"fr-ec-media-gallery__preview-chip-container-inner","mediaGalleryPreviewChipContainerInner":"fr-ec-media-gallery__preview-chip-container-inner","chip--short":"fr-ec-chip--short","chipShort":"fr-ec-chip--short","chip--default":"fr-ec-chip--default","chipDefault":"fr-ec-chip--default","chip":"fr-ec-chip","chip__label":"fr-ec-chip__label","chipLabel":"fr-ec-chip__label","chip__input":"fr-ec-chip__input","chipInput":"fr-ec-chip__input","chip__input--product-tile":"fr-ec-chip__input--product-tile","chipInputProductTile":"fr-ec-chip__input--product-tile","chip__label--product-tile":"fr-ec-chip__label--product-tile","chipLabelProductTile":"fr-ec-chip__label--product-tile","chip__default-icon-container":"fr-ec-chip__default-icon-container","chipDefaultIconContainer":"fr-ec-chip__default-icon-container","media-gallery__preview-button-area":"fr-ec-media-gallery__preview-button-area","mediaGalleryPreviewButtonArea":"fr-ec-media-gallery__preview-button-area","button-icon":"fr-ec-button-icon","buttonIcon":"fr-ec-button-icon","pdp-carousel__frame":"fr-ec-pdp-carousel__frame","pdpCarouselFrame":"fr-ec-pdp-carousel__frame","pdp-carousel__frame--padded":"fr-ec-pdp-carousel__frame--padded","pdpCarouselFramePadded":"fr-ec-pdp-carousel__frame--padded"};

var MediaGallery =
/** @class */
function (_super) {
  __extends(MediaGallery, _super);

  function MediaGallery() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      currentButton: 0,
      index: _this.props.index || 0,
      isDesktop: false,
      isTouchDevices: false,
      numberOfScroll: 1,
      scrollValue: 0
    };

    _this.decrementItem = function () {
      if (_this.state.currentButton > 0) {
        _this.setState(function (prevState) {
          return {
            currentButton: prevState.currentButton - 1,
            scrollValue: prevState.scrollValue + 48
          };
        });
      }
    };

    _this.incrementItem = function () {
      var chipsPerPage = 6;
      var totalChips = _this.props.imageCollection.length;
      var numberOfScroll = totalChips - chipsPerPage;

      if (_this.state.currentButton < numberOfScroll) {
        _this.setState(function (prevState) {
          return {
            currentButton: prevState.currentButton + 1,
            numberOfScroll: numberOfScroll,
            scrollValue: prevState.scrollValue - 48
          };
        });
      }
    };

    _this.setIndex = function (index) {
      return function () {
        _this.setState({
          index: index
        });
      };
    };

    _this.onResize = function () {
      if (isInBrowser$1()) {
        var breakpoint = getCurrentMediaQueryBreakpoint();
        var isDesktop = breakpoint === 'lg';

        _this.setState({
          currentButton: isDesktop ? 0 : _this.state.currentButton,
          isDesktop: isDesktop,
          isTouchDevices: isTouchDevice('userAgent'),
          scrollValue: isDesktop ? 0 : _this.state.scrollValue
        });
      }
    };

    _this.indexChange = function (index) {
      _this.setState({
        index: index
      });

      if (_this.props.onIndexChange) {
        _this.props.onIndexChange(index);
      }
    };

    return _this;
  }

  MediaGallery.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.index !== this.props.index) {
      this.setState({
        index: this.props.index || 0
      });
    }
  };

  MediaGallery.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        className = _a.className,
        carouselAriaLabel = _a.carouselAriaLabel,
        slidePlaceholder = _a.slidePlaceholder,
        skipToId = _a.skipToId,
        skipLinkText = _a.skipLinkText,
        imageCollection = _a.imageCollection,
        pinchZoomItems = _a.pinchZoomItems,
        children = _a.children,
        _b = _a.pinchZoomCloseLabel,
        pinchZoomCloseLabel = _b === void 0 ? '' : _b,
        _c = _a.enablePinchZoom,
        enablePinchZoom = _c === void 0 ? false : _c,
        iconBrand = _a.iconBrand,
        other = __rest(_a, ["className", "carouselAriaLabel", "slidePlaceholder", "skipToId", "skipLinkText", "imageCollection", "pinchZoomItems", "onIndexChange", "children", "pinchZoomCloseLabel", "enablePinchZoom", "iconBrand"]);

    var _d = this.state,
        currentButton = _d.currentButton,
        numberOfScroll = _d.numberOfScroll,
        index = _d.index,
        isTouchDevices = _d.isTouchDevices;
    var chipsPerPage = 6;
    var totalChips = imageCollection.length;
    var showPreviewButtons = totalChips <= chipsPerPage;
    var disableLeftButton = currentButton <= 0;
    var disableRightButton = currentButton === numberOfScroll;
    var translateStyle = {
      transform: "translateY(" + this.state.scrollValue + "px)"
    };

    var getChips = function getChips(chips) {
      return chips.map(function (chip, i) {
        return chip.isVideo ? /*#__PURE__*/createElement(Chip, {
          key: chip.key,
          label: "Video, " + (i + 1) + " out of " + totalChips + " media preview in gallery",
          id: "chip-test" + i,
          variant: "short",
          type: 'radio',
          name: "chip-test" + i,
          checked: i === index,
          onChange: _this.setIndex(i),
          icon: "play",
          iconBrand: iconBrand
        }) : /*#__PURE__*/createElement(Chip, {
          key: chip.key,
          label: "Image, " + (i + 1) + " out of " + totalChips + " media preview in gallery",
          id: "chip-test" + i,
          image: chip.src === '' ? '/invalid-url' : chip.src,
          noImage: chip.noImage,
          variant: "short",
          type: 'radio',
          name: "chip-test" + i,
          checked: i === index,
          onChange: _this.setIndex(i),
          iconBrand: iconBrand
        });
      });
    };

    return /*#__PURE__*/createElement(Measure, {
      onResize: debounce(100, this.onResize)
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/createElement("div", {
        className: joinClasses(styles$r$1.mediaGallery, className),
        ref: measureRef
      }, /*#__PURE__*/createElement(ContentAlignment, {
        element: "div",
        justifyContent: "flex-start",
        direction: "row",
        alignment: "flex-start"
      }, /*#__PURE__*/createElement("div", {
        className: styles$r$1.mediaGalleryPreview
      }, /*#__PURE__*/createElement("div", {
        className: styles$r$1.mediaGalleryPreviewChipContainer
      }, /*#__PURE__*/createElement("div", {
        className: styles$r$1.mediaGalleryPreviewChipContainerInner,
        style: translateStyle
      }, getChips(imageCollection))), !showPreviewButtons && /*#__PURE__*/createElement("div", {
        className: styles$r$1.mediaGalleryPreviewButtonArea
      }, /*#__PURE__*/createElement(Keyline, null), /*#__PURE__*/createElement(ContentAlignment, {
        element: "div",
        justifyContent: "center",
        direction: "column",
        alignment: "center"
      }, /*#__PURE__*/createElement(ButtonIcon, {
        "aria-label": "Scroll Up",
        element: "button",
        icon: "chevron-up",
        disabled: disableLeftButton,
        onClick: _this.decrementItem,
        tabIndex: -1,
        hideLabel: true,
        label: "",
        iconBrand: iconBrand
      }), /*#__PURE__*/createElement(ButtonIcon, {
        "aria-label": "Scroll Down",
        element: "button",
        icon: "chevron-down",
        disabled: disableRightButton,
        onClick: _this.incrementItem,
        tabIndex: -1,
        hideLabel: true,
        label: "",
        iconBrand: iconBrand
      })))), /*#__PURE__*/createElement("div", {
        className: styles$r$1.mediaGalleryCarousel
      }, /*#__PURE__*/createElement(Carousel, __assign({}, other, {
        index: index,
        indicator: 'number',
        skipLinkText: skipLinkText,
        skipToId: skipToId,
        carouselAriaLabel: carouselAriaLabel,
        arrowPositionSelector: "img",
        slidePlaceholder: slidePlaceholder,
        displayCount: 1,
        onIndexChange: _this.indexChange,
        keyboardNavigation: "arrow",
        variant: "media-gallery",
        pinchZoomItems: pinchZoomItems
      }, isTouchDevices && {
        enablePinchZoom: enablePinchZoom
      }, {
        pinchZoomCloseLabel: pinchZoomCloseLabel,
        iconBrand: iconBrand
      }), children))));
    });
  };

  MediaGallery.displayName = 'CoreMediaGallery';
  return MediaGallery;
}(Component);

var styles$s$1 = {"cms-link-text--align-left":"fr-ec-cms-link-text--align-left","cmsLinkTextAlignLeft":"fr-ec-cms-link-text--align-left","cms-link-text--align-center":"fr-ec-cms-link-text--align-center","cmsLinkTextAlignCenter":"fr-ec-cms-link-text--align-center","cms-link-text--align-right":"fr-ec-cms-link-text--align-right","cmsLinkTextAlignRight":"fr-ec-cms-link-text--align-right","cms-link-text":"fr-ec-cms-link-text","cmsLinkText":"fr-ec-cms-link-text","body":"fr-ec-body"};

var cmsLinkTexttypes = {
  colored: 'standalone-secondary',
  underlined: 'standalone-primary'
};
var CmsLinkText = function CmsLinkText(_a) {
  var url = _a.url,
      label = _a.label,
      iconName = _a.iconName,
      iconPosition = _a.iconPosition,
      type = _a.type,
      _b = _a.gaCategory,
      gaCategory = _b === void 0 ? '' : _b,
      _c = _a.gaLabel,
      gaLabel = _c === void 0 ? '' : _c,
      gaAction = _a.gaAction,
      gaValue = _a.gaValue,
      className = _a.className,
      gaCallback = _a.gaCallback,
      target = _a.target,
      _d = _a.alignment,
      alignment = _d === void 0 ? 'left' : _d,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["url", "label", "iconName", "iconPosition", "type", "gaCategory", "gaLabel", "gaAction", "gaValue", "className", "gaCallback", "target", "alignment", "iconBrand"]);

  var rootTag = 'a';
  var absoluteUrlPattern = isAbsoluteUrl(url);
  var attributes = {};

  if (absoluteUrlPattern) {
    attributes = {
      href: url,
      target: target || '_blank'
    };
  } else if (url) {
    rootTag = Link$1; // Default target behaviour of Link is similar to that of '_self'.
    // But if you specify target property explicitly, it refreshes the page.
    // @ts-ignore

    attributes.to = url;

    if (target && target !== '_self') {
      // @ts-ignore
      attributes.target = target;
    }
  }

  return /*#__PURE__*/createElement(LinkText, __assign({
    className: joinClasses(className, styles$s$1.cmsLinkText, styles$s$1["cms-link-text--align-" + alignment]),
    element: rootTag,
    icon: iconName,
    iconPosition: iconPosition,
    variant: cmsLinkTexttypes[type],
    gaLabel: gaLabel,
    gaCategory: gaCategory,
    gaAction: gaAction,
    gaValue: gaValue,
    gaCallback: gaCallback,
    target: target,
    iconBrand: iconBrand
  }, attributes, props), label);
};
CmsLinkText.displayName = 'CoreCmsLinkText';
CmsLinkText.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null,
  iconName: '',
  iconPosition: 'start',
  type: 'underlined'
};

var styles$t$1 = {"cms-image-plus-text-Wrapper":"fr-ec-cms-image-plus-text-Wrapper","cmsImagePlusTextWrapper":"fr-ec-cms-image-plus-text-Wrapper","cms-image-plus-text":"fr-ec-cms-image-plus-text","cmsImagePlusText":"fr-ec-cms-image-plus-text","cms-image-plus-text__media":"fr-ec-cms-image-plus-text__media","cmsImagePlusTextMedia":"fr-ec-cms-image-plus-text__media","cms-image-plus-text__content":"fr-ec-cms-image-plus-text__content","cmsImagePlusTextContent":"fr-ec-cms-image-plus-text__content","cms-image-plus-text__view-item-button":"fr-ec-cms-image-plus-text__view-item-button","cmsImagePlusTextViewItemButton":"fr-ec-cms-image-plus-text__view-item-button","cms-image-plus-text__text-with-price":"fr-ec-cms-image-plus-text__text-with-price","cmsImagePlusTextTextWithPrice":"fr-ec-cms-image-plus-text__text-with-price"};

var CmsImagePlusText = function CmsImagePlusText(_a) {
  var children = _a.children,
      head = _a.head,
      title = _a.title,
      description = _a.description,
      flag = _a.flag,
      link = _a.link,
      _b = _a.linkTarget,
      linkTarget = _b === void 0 ? '_self' : _b,
      linkText = _a.linkText,
      _c = _a.headColor,
      headColor = _c === void 0 ? 'normal' : _c,
      _d = _a.flagColor,
      flagColor = _d === void 0 ? 'normal' : _d,
      _e = _a.priceColor,
      priceColor = _e === void 0 ? 'black' : _e,
      productPrice = _a.productPrice,
      gaCategory = _a.gaCategory,
      gaAction = _a.gaAction,
      gaLabel = _a.gaLabel,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      className = _a.className,
      displayViewItemButton = _a.displayViewItemButton,
      viewItemButtonText = _a.viewItemButtonText,
      _f = _a.textTransform,
      textTransform = _f === void 0 ? 'normal' : _f,
      textWithProductPrice = _a.textWithProductPrice,
      textWithProductPriceSecond = _a.textWithProductPriceSecond,
      productPriceSecond = _a.productPriceSecond,
      _g = _a.priceSize,
      priceSize = _g === void 0 ? 'large' : _g,
      props = __rest(_a, ["children", "head", "title", "description", "flag", "link", "linkTarget", "linkText", "headColor", "flagColor", "priceColor", "productPrice", "gaCategory", "gaAction", "gaLabel", "gaValue", "gaCallback", "className", "displayViewItemButton", "viewItemButtonText", "textTransform", "textWithProductPrice", "textWithProductPriceSecond", "productPriceSecond", "priceSize"]);

  var headColorTypes = {
    caution: 'promotional',
    normal: 'primary-dark',
    weak: 'secondary'
  };
  var width = getViewportWidth();
  var isButtonVisible = width < designTokens_3.mqMediumScreenMinWidthLimit;
  var imagePlusTextChildCompWithButton = /*#__PURE__*/createElement(ImageEnhancements, {
    absolutePositionContent: /*#__PURE__*/createElement("span", {
      className: styles$t$1.cmsImagePlusTextViewItemButton
    }, viewItemButtonText)
  }, children);
  var imagePlusTextTemplate = /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$t$1.cmsImagePlusText)
  }, /*#__PURE__*/createElement("div", {
    className: joinClasses(styles$t$1.cmsImagePlusTextMedia, className)
  }, isButtonVisible && displayViewItemButton && viewItemButtonText ? imagePlusTextChildCompWithButton : children), /*#__PURE__*/createElement("div", {
    className: styles$t$1.cmsImagePlusTextContent
  }, head && /*#__PURE__*/createElement(FlagText, {
    className: spacingStyles.mbSpacing01,
    color: headColorTypes[headColor],
    element: "p",
    variant: "standard"
  }, head), title && /*#__PURE__*/createElement(Title, {
    className: spacingStyles.mbSpacing01,
    variant: "large",
    textTransform: textTransform,
    element: "p",
    wordBreak: "break-word"
  }, title), description && /*#__PURE__*/createElement(Body, {
    className: spacingStyles.mbSpacing02,
    variant: "small",
    element: "p",
    wordBreak: "break-word"
  }, description), productPrice && /*#__PURE__*/createElement(Price, {
    variant: priceColor === 'red' ? 'promotional' : 'standard',
    size: priceSize,
    element: textWithProductPrice ? 'span' : 'p'
  }, textWithProductPrice && /*#__PURE__*/createElement(Body, {
    className: styles$t$1.cmsImagePlusTextTextWithPrice,
    color: priceColor === 'red' ? 'promotional' : 'primary-dark',
    variant: "standard-emphasized",
    element: "span"
  }, textWithProductPrice), productPrice), productPriceSecond && /*#__PURE__*/createElement(Price, {
    variant: priceColor === 'red' ? 'promotional' : 'standard',
    size: priceSize,
    element: textWithProductPriceSecond ? 'span' : 'p'
  }, textWithProductPriceSecond && /*#__PURE__*/createElement(Body, {
    className: styles$t$1.cmsImagePlusTextTextWithPrice,
    color: priceColor === 'red' ? 'promotional' : 'primary-dark',
    variant: "standard-emphasized",
    element: "span"
  }, textWithProductPriceSecond), productPriceSecond), flag && /*#__PURE__*/createElement(FlagText, {
    className: spacingStyles.mbSpacing02,
    variant: "large",
    color: flagColor === 'limited' ? 'promotional' : 'secondary',
    element: "p"
  }, flag), linkText && /*#__PURE__*/createElement(LinkText, {
    element: "a",
    href: link,
    target: linkTarget
  }, linkText)));
  return link ? /*#__PURE__*/createElement(CmsLink, __assign({}, props, {
    url: link,
    target: linkTarget,
    gaLabel: gaLabel,
    gaCategory: gaCategory,
    gaAction: gaAction,
    gaValue: gaValue,
    gaCallback: gaCallback
  }), imagePlusTextTemplate) : /*#__PURE__*/createElement("div", __assign({}, props, {
    className: styles$t$1.cmsImagePlusTextWrapper
  }), imagePlusTextTemplate);
};
CmsImagePlusText.displayName = 'CoreCmsImagePlusText';

var CmsImage = function CmsImage(_a) {
  var altText = _a.altText,
      className = _a.className,
      _b = _a.noImageLabel,
      noImageLabel = _b === void 0 ? '' : _b,
      smallMediumImageRatio = _a.smallMediumImageRatio,
      _c = _a.smallMediumImageUrl,
      smallMediumImageUrl = _c === void 0 ? '' : _c,
      largeImageRatio = _a.largeImageRatio,
      _d = _a.largeImageUrl,
      largeImageUrl = _d === void 0 ? '' : _d,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["altText", "className", "noImageLabel", "smallMediumImageRatio", "smallMediumImageUrl", "largeImageRatio", "largeImageUrl", "iconBrand"]);

  var width = getViewportWidth();
  var smallMediumImageRatioValue = smallMediumImageRatio || largeImageRatio || '1x1';
  var largeImageRatioValue = largeImageRatio || smallMediumImageRatio || '2x1';
  var smallMediumImageUrlValue = smallMediumImageUrl || largeImageUrl || '';
  var largeImageUrlValue = largeImageUrl || smallMediumImageUrl || '';
  var renderImage = width > designTokens_3.mqMediumScreenMaxWidthLimit ? /*#__PURE__*/React__default.createElement(Image, __assign({
    src: largeImageUrlValue,
    ratio: largeImageRatioValue,
    alt: altText,
    className: className,
    noImage: {
      imageSize: 'large',
      imageType: 'icon',
      noImageLabel: noImageLabel
    },
    key: 'large-image-key',
    iconBrand: iconBrand
  }, props)) : /*#__PURE__*/React__default.createElement(Image, {
    src: smallMediumImageUrlValue,
    ratio: smallMediumImageRatioValue,
    alt: altText,
    noImage: {
      imageSize: 'default',
      imageType: 'icon',
      noImageLabel: noImageLabel
    },
    className: className,
    key: 'small-medium-image-key',
    iconBrand: iconBrand
  });
  return renderImage;
};
CmsImage.displayName = 'CoreCmsImage';
CmsImage.defaultProps = {
  largeImageUrl: '',
  smallMediumImageUrl: ''
};

var styles$u$1 = {"cms-category-image":"fr-ec-cms-category-image","cmsCategoryImage":"fr-ec-cms-category-image","cms-category-image--caption":"fr-ec-cms-category-image--caption","cmsCategoryImageCaption":"fr-ec-cms-category-image--caption"};

var CmsCategoryImage = function CmsCategoryImage(_a) {
  var src = _a.src,
      alt = _a.alt,
      text = _a.text,
      categoryLink = _a.categoryLink,
      _b = _a.gaCategory,
      gaCategory = _b === void 0 ? '' : _b,
      _c = _a.gaLabel,
      gaLabel = _c === void 0 ? '' : _c,
      gaAction = _a.gaAction,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      className = _a.className,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["src", "alt", "text", "categoryLink", "gaCategory", "gaLabel", "gaAction", "gaValue", "gaCallback", "className", "iconBrand"]);

  var renderComponent = function renderComponent() {
    return /*#__PURE__*/createElement(ContentAlignment, __assign({
      direction: "column",
      element: "div",
      className: joinClasses(className, styles$u$1.cmsCategoryImage)
    }, props), /*#__PURE__*/createElement(CmsImage, {
      altText: alt,
      smallMediumImageRatio: "1x1",
      largeImageRatio: "1x1",
      smallMediumImageUrl: src,
      largeImageUrl: src,
      iconBrand: iconBrand
    }), /*#__PURE__*/createElement(Caption, {
      variant: "standard",
      element: "span",
      wordBreak: "break-word",
      className: styles$u$1.cmsCategoryImageCaption
    }, text));
  };

  if (categoryLink) {
    return /*#__PURE__*/createElement(CmsLink, __assign({
      url: categoryLink,
      gaCategory: gaCategory,
      gaLabel: gaLabel,
      gaAction: gaAction,
      gaValue: gaValue,
      gaCallback: gaCallback
    }, props), renderComponent());
  }

  return /*#__PURE__*/createElement(Fragment, null, renderComponent());
};
CmsCategoryImage.displayName = 'CoreCmsCategoryImage';

var styles$v$1 = {"cms-video-inline":"fr-ec-cms-video-inline","cmsVideoInline":"fr-ec-cms-video-inline"};

var CmsVideoInline = function CmsVideoInline(_a) {
  var noImageLabel = _a.noImageLabel,
      smallMediumVideoUrl = _a.smallMediumVideoUrl,
      largeVideoUrl = _a.largeVideoUrl,
      smallMediumPosterImage = _a.smallMediumPosterImage,
      largePosterImage = _a.largePosterImage,
      smallMediumVideoRatio = _a.smallMediumVideoRatio,
      largeVideoRatio = _a.largeVideoRatio,
      altText = _a.altText,
      loop = _a.loop,
      height = _a.height,
      className = _a.className,
      videoWidth = _a.width,
      progressBar = _a.progressBar,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["noImageLabel", "smallMediumVideoUrl", "largeVideoUrl", "smallMediumPosterImage", "largePosterImage", "smallMediumVideoRatio", "largeVideoRatio", "altText", "loop", "height", "className", "width", "progressBar", "iconBrand"]);

  var width = getViewportWidth();
  var isWidthLessthanLargeDevicewidth = width < designTokens_3.mqMediumScreenMaxWidthLimit;
  var smallMediumVideoUrlValue = smallMediumVideoUrl || largeVideoUrl || '';
  var largeVideoUrlValue = largeVideoUrl || smallMediumVideoUrl || '';
  var smallMediumVideoRatioValue = smallMediumVideoRatio || largeVideoRatio || '1x1';
  var largeVideoValue = largeVideoRatio || smallMediumVideoRatio || '2x1';
  var largePosterImageValue = largePosterImage || smallMediumPosterImage || '';
  var smallMediumPosterImageValue = smallMediumPosterImage || largePosterImage || '';

  if (isWidthLessthanLargeDevicewidth) {
    return /*#__PURE__*/createElement(VideoInline, __assign({
      key: 0,
      loop: loop,
      src: smallMediumVideoUrlValue,
      posterImage: smallMediumPosterImageValue,
      autoPlay: true,
      muted: true,
      altText: altText,
      videoRatio: smallMediumVideoRatioValue,
      className: joinClasses(className, styles$v$1.cmsVideoInline),
      noVideoLabel: noImageLabel,
      width: videoWidth,
      height: height,
      progressBar: progressBar,
      iconBrand: iconBrand
    }, props));
  } else {
    return /*#__PURE__*/createElement(VideoInline, __assign({
      key: 1,
      loop: loop,
      src: largeVideoUrlValue,
      posterImage: largePosterImageValue,
      autoPlay: true,
      muted: true,
      altText: altText,
      noVideoLabel: noImageLabel,
      width: videoWidth,
      height: height,
      className: joinClasses(className, styles$v$1.cmsVideoInline),
      videoRatio: largeVideoValue,
      progressBar: progressBar,
      iconBrand: iconBrand
    }, props));
  }
};
CmsVideoInline.displayName = 'CoreCmsVideoInline';

var styles$w$1 = {"product-collection":"fr-ec-product-collection","productCollection":"fr-ec-product-collection","product-collection--type-grid":"fr-ec-product-collection--type-grid","productCollectionTypeGrid":"fr-ec-product-collection--type-grid","product-collection--type-ranking":"fr-ec-product-collection--type-ranking","productCollectionTypeRanking":"fr-ec-product-collection--type-ranking","product-collection--type-three-column":"fr-ec-product-collection--type-three-column","productCollectionTypeThreeColumn":"fr-ec-product-collection--type-three-column","product-tile-ranking-wrapper":"fr-ec-product-tile-ranking-wrapper","productTileRankingWrapper":"fr-ec-product-tile-ranking-wrapper","badge-ranking":"fr-ec-badge-ranking","badgeRanking":"fr-ec-badge-ranking","product-collection--type-grid-medium":"fr-ec-product-collection--type-grid-medium","productCollectionTypeGridMedium":"fr-ec-product-collection--type-grid-medium","product-collection--type-grid-small":"fr-ec-product-collection--type-grid-small","productCollectionTypeGridSmall":"fr-ec-product-collection--type-grid-small","product-tile__end":"fr-ec-product-tile__end","productTileEnd":"fr-ec-product-tile__end","product-tile-resize-wrapper":"fr-ec-product-tile-resize-wrapper","productTileResizeWrapper":"fr-ec-product-tile-resize-wrapper","product-tile__product-info":"fr-ec-product-tile__product-info","productTileProductInfo":"fr-ec-product-tile__product-info","tile":"fr-ec-tile","product-collection--type-ranking-carousel":"fr-ec-product-collection--type-ranking-carousel","productCollectionTypeRankingCarousel":"fr-ec-product-collection--type-ranking-carousel","product-tile":"fr-ec-product-tile","productTile":"fr-ec-product-tile","product-collection--type-carousel":"fr-ec-product-collection--type-carousel","productCollectionTypeCarousel":"fr-ec-product-collection--type-carousel","carousel-slide--padded":"fr-ec-carousel-slide--padded","carouselSlidePadded":"fr-ec-carousel-slide--padded","carousel__bottom-section":"fr-ec-carousel__bottom-section","carouselBottomSection":"fr-ec-carousel__bottom-section","carousel-slide":"fr-ec-carousel-slide","carouselSlide":"fr-ec-carousel-slide","product-collection--type-setup":"fr-ec-product-collection--type-setup","productCollectionTypeSetup":"fr-ec-product-collection--type-setup","product-tile__horizontal_spacing":"fr-ec-product-tile__horizontal_spacing","productTileHorizontalSpacing":"fr-ec-product-tile__horizontal_spacing","product-collection--type-setup-small":"fr-ec-product-collection--type-setup-small","productCollectionTypeSetupSmall":"fr-ec-product-collection--type-setup-small"};

var SMALL = 'SMALL';
var MEDIUM = 'MEDIUM';
var LARGE = 'LARGE';
var ProductCollection = function ProductCollection(_a) {
  var _b;

  var type = _a.type,
      products = _a.products,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["type", "products", "iconBrand"]);

  var _c = useState(SMALL),
      gridColumns = _c[0],
      setGridColumns = _c[1];

  var gridColumnStyle = (_b = {}, _b[MEDIUM] = type === 'grid' ? styles$w$1.productCollectionTypeGridMedium : styles$w$1.productCollectionTypeSetup, _b[SMALL] = type === 'grid' ? styles$w$1.productCollectionTypeGridSmall : styles$w$1.productCollectionTypeSetupSmall, _b[LARGE] = type === 'grid' ? styles$w$1.productCollectionTypeGrid : styles$w$1.productCollectionTypeSetup, _b);
  var typeStyles = {
    carousel: styles$w$1.productCollectionTypeCarousel,
    grid: styles$w$1.productCollectionTypeGrid,
    ranking: styles$w$1.productCollectionTypeRanking,
    threeColumn: styles$w$1.productCollectionTypeThreeColumn
  };

  var childWrapper = function childWrapper(productTileChild, index) {
    var productTile = /*#__PURE__*/React__default.cloneElement(productTileChild, __assign(__assign({
      iconBrand: iconBrand
    }, props), {
      maxLinesEllipsis: type === 'grid' ? 0 : 2,
      productCollectionType: type
    }));
    return type === 'ranking' || type === 'rankingCarousel' ? /*#__PURE__*/React__default.createElement("div", {
      className: styles$w$1.productTileRankingWrapper
    }, /*#__PURE__*/React__default.createElement(BadgeRanking, {
      ariaLabel: "Rank" + index,
      rank: index + 1
    }), productTile) : productTile;
  };

  var productTiles = React__default.Children.map(products, function (child, index) {
    return /*#__PURE__*/React__default.cloneElement(childWrapper(child, index));
  });

  var onResizeGrid = function onResizeGrid(contentRect) {
    if (contentRect.bounds) {
      var width = contentRect.bounds.width; // Check if the container width matches the small breakpoint

      if (width <= 599) {
        setGridColumns(SMALL);
      } // Check if the container width matches the medium breakpoint
      else if (width >= 600 && width <= 959) {
          setGridColumns(MEDIUM);
        } // Check if the container width matches the large breakpoint
        else {
            setGridColumns(LARGE);
          }
    }
  };

  var productCollectionComp = /*#__PURE__*/React__default.createElement("div", {
    className: joinClasses(styles$w$1.productCollection, typeStyles[type])
  }, productTiles);

  if (type === 'carousel' || type === 'rankingCarousel') {
    productCollectionComp = /*#__PURE__*/React__default.createElement(Carousel, {
      className: typeStyles[type],
      variant: "default",
      arrowPositionSelector: "img",
      displayCount: {
        lg: 4,
        md: 4,
        sm: 2.4
      },
      indicator: {
        lg: INDICATOR_PAGES,
        md: INDICATOR_PAGES,
        sm: INDICATOR_NONE
      },
      iconBrand: iconBrand
    }, productTiles);
  } else if (type === 'setup' && products.length >= 4) {
    productCollectionComp = /*#__PURE__*/React__default.createElement(Measure, {
      bounds: true,
      onResize: onResizeGrid
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/React__default.createElement("div", {
        ref: measureRef
      }, /*#__PURE__*/React__default.createElement(Carousel, {
        className: typeStyles[type],
        variant: "default",
        arrowPositionSelector: "img",
        displayCount: {
          lg: gridColumns === 'SMALL' ? 2.4 : 4,
          md: gridColumns === 'SMALL' ? 2.4 : 4,
          sm: gridColumns === 'SMALL' ? 2.4 : 4
        },
        indicator: {
          lg: INDICATOR_PAGES,
          md: INDICATOR_PAGES,
          sm: INDICATOR_NONE
        },
        iconBrand: iconBrand
      }, productTiles));
    });
  } else if (type === 'grid' || type === 'setup' && products.length <= 3) {
    productCollectionComp = /*#__PURE__*/React__default.createElement(Measure, {
      bounds: true,
      onResize: onResizeGrid
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/React__default.createElement("div", {
        ref: measureRef
      }, /*#__PURE__*/React__default.createElement("div", {
        className: joinClasses(styles$w$1.productCollection, gridColumnStyle[gridColumns])
      }, type === 'grid' ? productTiles : React__default.Children.map(productTiles, function (child) {
        return /*#__PURE__*/React__default.cloneElement(child, {
          variant: 'horizontal'
        });
      })));
    });
  }

  return productCollectionComp;
};
ProductCollection.displayName = 'CoreProductCollection';

var styles$x$1 = {"cms-accordion--type-large":"fr-ec-cms-accordion--type-large","cmsAccordionTypeLarge":"fr-ec-cms-accordion--type-large","accordion__content--large":"fr-ec-accordion__content--large","accordionContentLarge":"fr-ec-accordion__content--large","cms-accordion--type-small":"fr-ec-cms-accordion--type-small","cmsAccordionTypeSmall":"fr-ec-cms-accordion--type-small","accordion__content--small":"fr-ec-accordion__content--small","accordionContentSmall":"fr-ec-accordion__content--small","cms-accordion-tab":"fr-ec-cms-accordion-tab","cmsAccordionTab":"fr-ec-cms-accordion-tab","icon":"fr-ec-icon","cms-accordion-tab-active-icon":"fr-ec-cms-accordion-tab-active-icon","cmsAccordionTabActiveIcon":"fr-ec-cms-accordion-tab-active-icon","cms-accordion-tab--active":"fr-ec-cms-accordion-tab--active","cmsAccordionTabActive":"fr-ec-cms-accordion-tab--active","cms-accordion--tab-text":"fr-ec-cms-accordion--tab-text","cmsAccordionTabText":"fr-ec-cms-accordion--tab-text"};

var typeToVariant = {
  large: 'large',
  small: 'small'
};
var CmsAccordion = function CmsAccordion(_a) {
  var children = _a.children,
      _b = _a.gaCategory,
      gaCategory = _b === void 0 ? '' : _b,
      _c = _a.gaLabel,
      gaLabel = _c === void 0 ? '' : _c,
      gaAction = _a.gaAction,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      headingText = _a.headingText,
      _d = _a.type,
      type = _d === void 0 ? 'small' : _d,
      expanded = _a.expanded,
      _e = _a.accordionType,
      accordionType = _e === void 0 ? 'default' : _e,
      _f = _a.isActive,
      isActive = _f === void 0 ? false : _f,
      onClick = _a.onClick,
      className = _a.className,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["children", "gaCategory", "gaLabel", "gaAction", "gaValue", "gaCallback", "headingText", "type", "expanded", "accordionType", "isActive", "onClick", "className", "iconBrand"]);

  var width = getViewportWidth();
  var gaProps = null;

  if (gaCategory && gaAction && gaLabel) {
    gaProps = {
      'data-action': gaAction,
      'data-category': gaCategory,
      'data-label': gaLabel
    };

    if (gaValue) {
      gaProps['data-value'] = gaValue;
    }
  }

  var clickCallback = function clickCallback(e) {
    if (onClick) {
      onClick(e, headingText, children);
    } // For event tracking


    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    }
  };

  if (accordionType === 'nav' && width >= 600) {
    return /*#__PURE__*/createElement("button", __assign({
      className: joinClasses(className, styles$x$1.cmsAccordionTab, isActive ? styles$x$1.cmsAccordionTabActive : ''),
      role: "tab",
      "aria-selected": isActive,
      onClick: clickCallback
    }, gaProps, props), /*#__PURE__*/createElement(Body, {
      element: "span",
      variant: isActive ? 'standard-emphasized' : 'standard',
      className: styles$x$1.cmsAccordionTabText,
      color: "primary-dark"
    }, headingText));
  } else if (accordionType === 'nav' && width < 600) {
    return /*#__PURE__*/createElement(LinkCell, __assign({
      element: "button",
      chevron: true,
      iconPosition: "end",
      gaLabel: gaLabel,
      gaCategory: gaCategory,
      gaAction: gaAction,
      gaValue: gaValue,
      gaCallback: gaCallback,
      label: headingText,
      onClick: clickCallback,
      iconBrand: iconBrand
    }, props));
  } else {
    return /*#__PURE__*/createElement(Accordion, __assign({
      element: "div",
      labelElement: "h1",
      label: headingText,
      variant: typeToVariant[type],
      defaultExpanded: expanded,
      gaLabel: gaLabel,
      gaCategory: gaCategory,
      gaAction: gaAction,
      gaValue: gaValue,
      gaCallback: gaCallback,
      className: styles$x$1["cms-accordion--type-" + type],
      iconBrand: iconBrand
    }, props), Children.map(children, function (child, i) {
      if (child.type.displayName === 'CoreCmsAccordionList') {
        return /*#__PURE__*/createElement(Fragment, {
          key: i
        }, /*#__PURE__*/cloneElement(child, {
          type: typeToVariant[type]
        }));
      }

      return /*#__PURE__*/createElement(Fragment, {
        key: i
      }, /*#__PURE__*/cloneElement(child));
    }));
  }
};
CmsAccordion.displayName = 'CoreCmsAccordion';

var CmsTab = function CmsTab(_a) {
  var _b = _a.content,
      content = _b === void 0 ? /*#__PURE__*/createElement("div", null) : _b,
      label = _a.label,
      linkUrl = _a.linkUrl,
      _c = _a.type,
      type = _c === void 0 ? 'normal' : _c,
      _d = _a.uppercase,
      uppercase = _d === void 0 ? false : _d,
      _e = _a.variant,
      variant = _e === void 0 ? 'standard' : _e,
      _f = _a.disabled,
      disabled = _f === void 0 ? false : _f,
      isActive = _a.isActive,
      _g = _a.genderTypography,
      genderTypography = _g === void 0 ? false : _g,
      _h = _a.wording,
      wording = _h === void 0 ? {
    text_baby: 'baby',
    text_boys: 'boys',
    text_carry_kids_baby: 'kids･baby',
    text_girls: 'girls',
    text_kids: 'kids',
    text_men: 'men',
    text_women: 'women'
  } : _h,
      target = _a.target,
      onClick = _a.onClick,
      gaAction = _a.gaAction,
      gaCategory = _a.gaCategory,
      gaLabel = _a.gaLabel,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      props = __rest(_a, ["content", "label", "linkUrl", "type", "uppercase", "variant", "disabled", "isActive", "genderTypography", "wording", "target", "onClick", "gaAction", "gaCategory", "gaLabel", "gaValue", "gaCallback"]);

  var handleClick = function handleClick(event, labelName, index) {
    if (onClick) {
      onClick(event, labelName, index, content);
    }
  };

  var tabLabel = type === 'normal' ? label : wording["text_" + type].toUpperCase();
  return /*#__PURE__*/createElement(Tab, __assign({
    label: tabLabel,
    textTransform: uppercase ? 'all-caps' : 'normal',
    variant: variant,
    disabled: disabled,
    isActive: isActive,
    genderTypography: genderTypography,
    onClick: handleClick,
    url: linkUrl,
    target: target,
    gaLabel: gaLabel,
    gaCategory: gaCategory,
    gaAction: gaAction,
    gaValue: gaValue,
    gaCallback: gaCallback
  }, props), content);
};
CmsTab.displayName = 'CoreCmsTab';
CmsTab.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var CmsTabs = function CmsTabs(_a) {
  var items = _a.items,
      id = _a.id,
      type = _a.type,
      defaultIndex = _a.defaultIndex,
      className = _a.className,
      _b = _a.enableAutoHide,
      enableAutoHide = _b === void 0 ? false : _b,
      iconBrand = _a.iconBrand,
      promotionBanner = _a.promotionBanner,
      props = __rest(_a, ["items", "id", "type", "defaultIndex", "className", "enableAutoHide", "iconBrand", "promotionBanner"]);

  var isGenderTab = type === 'verticalscroll-gender';

  if (isGenderTab) {
    return /*#__PURE__*/createElement(GenderTabs, {
      className: className,
      childrenArray: Children.map(items, function (item, index) {
        return /*#__PURE__*/cloneElement(item, {
          index: index
        });
      }),
      defaultIndex: defaultIndex,
      enableAutoHide: enableAutoHide,
      id: id,
      promotionBanner: promotionBanner
    });
  }

  var swipeable = type === 'normal-swipeable';
  return /*#__PURE__*/createElement(CmsTabGroup, __assign({
    defaultIndex: defaultIndex,
    swipeable: swipeable,
    tabsType: type,
    id: id,
    iconBrand: iconBrand
  }, props), Children.map(items, function (item, index) {
    return /*#__PURE__*/cloneElement(item, {
      index: index
    });
  }));
};
CmsTabs.displayName = 'CoreCmsTabs';

var styles$y$1 = {"cms-tab-group":"fr-ec-cms-tab-group","cmsTabGroup":"fr-ec-cms-tab-group","cms-tab-group__content":"fr-ec-cms-tab-group__content","cmsTabGroupContent":"fr-ec-cms-tab-group__content","tab--standard-boxed":"fr-ec-tab--standard-boxed","tabStandardBoxed":"fr-ec-tab--standard-boxed","swipeable":"fr-ec-swipeable","cms-tabs-wrapper-class":"fr-ec-cms-tabs-wrapper-class","cmsTabsWrapperClass":"fr-ec-cms-tabs-wrapper-class","swipeable__navigation-btn":"fr-ec-swipeable__navigation-btn","swipeableNavigationBtn":"fr-ec-swipeable__navigation-btn","swipeable__navigation-btn-right":"fr-ec-swipeable__navigation-btn-right","swipeableNavigationBtnRight":"fr-ec-swipeable__navigation-btn-right","swipeable__overlay-right":"fr-ec-swipeable__overlay-right","swipeableOverlayRight":"fr-ec-swipeable__overlay-right","swipeable__overlay-left":"fr-ec-swipeable__overlay-left","swipeableOverlayLeft":"fr-ec-swipeable__overlay-left","swipeable__navigation-btn-left":"fr-ec-swipeable__navigation-btn-left","swipeableNavigationBtnLeft":"fr-ec-swipeable__navigation-btn-left","swiper-button-disabled":"fr-ec-swiper-button-disabled","swiperButtonDisabled":"fr-ec-swiper-button-disabled","cms-tab-group--vertical-scroll-gender":"fr-ec-cms-tab-group--vertical-scroll-gender","cmsTabGroupVerticalScrollGender":"fr-ec-cms-tab-group--vertical-scroll-gender","tab":"fr-ec-tab","cms-tab":"fr-ec-cms-tab","cmsTab":"fr-ec-cms-tab","cms-tabs":"fr-ec-cms-tabs","cmsTabs":"fr-ec-cms-tabs"};

var CmsTabGroup =
/** @class */
function (_super) {
  __extends(CmsTabGroup, _super);

  function CmsTabGroup(props) {
    var _this = _super.call(this, props) || this;

    _this.onTouchMove = function () {
      if (_this.swiperInstance) {
        _this.swiperInstance.update();

        _this.setState({
          isBeginning: _this.swiperInstance.isBeginning,
          isEnd: _this.swiperInstance.isEnd
        });
      }
    };

    _this.onClick = function (label, index, child, tabOnclick) {
      return function (event, activeTabLabel) {
        var ActiveTabIndex = event.currentTarget.getAttribute('index');

        _this.setState({
          activeTabId: index,
          activeTabLabel: activeTabLabel
        }, function () {
          if (_this.props.swipeable) {
            _this.swiperInstance.slideTo(Number(ActiveTabIndex));

            _this.swiperInstance.update();
          }

          if (_this.swiperInstance) {
            _this.setState({
              isBeginning: _this.swiperInstance.isBeginning,
              isEnd: _this.swiperInstance.isEnd
            });
          }
        });

        if (tabOnclick) {
          tabOnclick(event, label, index, child);
        }
      };
    };

    _this.onResize = function () {
      var breakpoint = getCurrentMediaQueryBreakpoint();
      var isDesktop = breakpoint === 'lg';

      _this.setState({
        isLargeScreenDevice: isDesktop
      });

      if (_this.swiperInstance) {
        _this.swiperInstance.update();

        _this.setState({
          isBeginning: _this.swiperInstance.isBeginning,
          isEnd: _this.swiperInstance.isEnd
        });
      }
    };

    _this.controlNavigation = function (direction) {
      if (_this.swiperInstance) {
        var slides = _this.swiperInstance.slides || 0;
        var _a = _this.swiperInstance,
            activeIndex = _a.activeIndex,
            isBeginning = _a.isBeginning,
            isEnd = _a.isEnd;
        var nextSlide = direction === 'NEXT' ? isEnd ? slides.length : activeIndex + 1 : isBeginning ? 0 : activeIndex - 1;

        if (direction === 'NEXT') {
          _this.swiperInstance.slideTo(nextSlide);
        } else {
          _this.swiperInstance.slideTo(nextSlide);
        }

        _this.swiperInstance.update();

        _this.setState({
          isBeginning: _this.swiperInstance.isBeginning,
          isEnd: _this.swiperInstance.isEnd
        });
      }
    };

    var tabChilds = Children.toArray(props.children).filter(isValidElement);
    var activeChild = tabChilds.find(function (tabItem, index) {
      return Boolean(tabItem.props && index === _this.props.defaultIndex);
    }) || tabChilds[0];
    var activeChildProps = activeChild ? activeChild.props : {};
    var activeChildWithLabel = tabChilds.find(function (tabItem) {
      return Boolean(tabItem.props && tabItem.props.isActive);
    }) || tabChilds[0];
    var activeChildWithLabelProps = activeChildWithLabel ? activeChildWithLabel.props : {};
    _this.state = {
      activeTabId: activeChildProps.index ? activeChildProps.index : 0,
      activeTabLabel: activeChildWithLabelProps.label,
      isBeginning: false,
      isEnd: false,
      isLargeScreenDevice: false
    };
    _this.swiperRef = /*#__PURE__*/createRef();
    _this.swiperInstance = null;
    return _this;
  }

  CmsTabGroup.prototype.componentDidMount = function () {
    var _this = this;

    if (this.props.swipeable) {
      this.swiperInstance = new swiper(this.swiperRef.current, {
        freeMode: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        observeParents: true,
        observer: true,
        on: {
          sliderMove: function sliderMove() {
            return _this.onTouchMove();
          }
        },
        slidesPerView: 'auto',
        spaceBetween: 0
      });
    }

    if (this.swiperInstance) {
      var activeTabElement = Children.toArray(this.props.children).findIndex(function (child, index) {
        return child.props.isActive !== undefined ? child.props.label === _this.state.activeTabLabel : index === _this.state.activeTabId;
      });

      if (this.props.swipeable) {
        this.swiperInstance.slideTo(Number(activeTabElement));
        this.swiperInstance.update();
      }

      this.setState({
        isBeginning: this.swiperInstance.isBeginning,
        isEnd: this.swiperInstance.isEnd
      });
    }
  };

  CmsTabGroup.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.defaultIndex !== this.props.defaultIndex) {
      this.setState({
        activeTabId: Number(this.props.defaultIndex)
      });
    }
  };

  CmsTabGroup.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        className = _a.className,
        sticky = _a.sticky,
        id = _a.id,
        _b = _a.tabsType,
        tabsType = _b === void 0 ? 'normal' : _b,
        isNavHeader = _a.isNavHeader,
        iconBrand = _a.iconBrand,
        wording = _a.wording;
    var swipeable = this.props.swipeable;
    var _c = this.state,
        activeTabId = _c.activeTabId,
        activeTabLabel = _c.activeTabLabel;
    var activeContent = null;
    var typeMap = {
      'boxed-gender': 'standard-boxed',
      'boxed-normal': 'standard-boxed',
      gender: 'standard',
      normal: 'small',
      'normal-swipeable': 'small-swipeable',
      'verticalscroll-gender': 'small'
    };
    var childrenWithProps = Children.toArray(children).filter(isValidElement).map(function (child, index) {
      var tabLabel = wording && child.props.type !== 'normal' ? wording["text_" + child.props.type] : child.props.label ? child.props.label : '';

      if (child.props.isActive !== undefined ? child.props.label === activeTabLabel : child.props.index === activeTabId) {
        activeContent = child.props.content;
      }

      if (swipeable) {
        return /*#__PURE__*/createElement("li", {
          key: index,
          className: "swiper-slide"
        }, /*#__PURE__*/cloneElement(child, {
          genderTypography: tabsType === 'normal' ? false : tabsType === 'boxed-normal' ? false : tabsType === 'normal-swipeable' ? false : true,
          isActive: child.props.isActive !== undefined ? child.props.label === activeTabLabel : child.props.index === activeTabId,
          key: tabLabel.toUpperCase(),
          label: tabLabel,
          onClick: _this.onClick(tabLabel, child.props.index, child, child.props.onClick),
          variant: typeMap[tabsType],
          wording: wording
        }));
      }

      return /*#__PURE__*/cloneElement(child, {
        genderTypography: tabsType === 'normal' ? false : tabsType === 'boxed-normal' ? false : tabsType === 'normal-swipeable' ? false : true,
        isActive: child.props.isActive !== undefined ? child.props.label === activeTabLabel : child.props.index === activeTabId,
        key: tabLabel.toUpperCase(),
        label: tabLabel,
        onClick: _this.onClick(tabLabel, child.props.index, child, child.props.onClick),
        variant: typeMap[tabsType],
        wording: wording
      });
    });
    var childrenWithPropsWrapper = /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$y$1.cmsTabGroup, tabsType === 'verticalscroll-gender' && styles$y$1.cmsTabGroupVerticalScrollGender, className),
      role: "tablist"
    }, childrenWithProps);
    var withSticky = sticky ? /*#__PURE__*/createElement(StickyContainer, {
      stickySection: 'utilityBar',
      isNavHeader: isNavHeader
    }, childrenWithPropsWrapper) : childrenWithPropsWrapper;
    return /*#__PURE__*/createElement(Fragment, null, swipeable ? /*#__PURE__*/createElement(Measure, {
      onResize: this.onResize
    }, function (_a) {
      var measureRef = _a.measureRef;
      return /*#__PURE__*/createElement("div", {
        ref: measureRef,
        key: id
      }, /*#__PURE__*/createElement("div", {
        className: joinClasses('swiper-container', styles$y$1.swipeable, tabsType === 'verticalscroll-gender' && styles$y$1.cmsTabGroupVerticalScrollGender, className),
        ref: _this.swiperRef
      }, !_this.state.isBeginning && /*#__PURE__*/createElement("div", {
        className: styles$y$1.swipeableOverlayLeft
      }), /*#__PURE__*/createElement("ul", {
        role: "tablist",
        className: joinClasses('swiper-wrapper', styles$y$1.cmsTabsWrapperClass)
      }, childrenWithProps), !_this.state.isEnd && /*#__PURE__*/createElement("div", {
        className: styles$y$1.swipeableOverlayRight
      }), _this.state.isLargeScreenDevice && /*#__PURE__*/createElement(Fragment, null, !_this.state.isBeginning && /*#__PURE__*/createElement(ButtonIcon, {
        element: "button",
        icon: "chevron-left",
        label: "",
        className: joinClasses('swiper-button-prev', styles$y$1.swipeableNavigationBtn, styles$y$1.swipeableNavigationBtnLeft),
        iconBrand: iconBrand,
        onClick: function onClick() {
          return _this.controlNavigation('PREV');
        }
      }), !_this.state.isEnd && /*#__PURE__*/createElement(ButtonIcon, {
        element: "button",
        icon: "chevron-right",
        label: "",
        iconBrand: iconBrand,
        className: joinClasses('swiper-button-next', styles$y$1.swipeableNavigationBtn, styles$y$1.swipeableNavigationBtnRight),
        onClick: function onClick() {
          return _this.controlNavigation('NEXT');
        }
      }))), /*#__PURE__*/createElement("div", {
        role: "tabpanel",
        className: styles$y$1.cmsTabGroupContent
      }, activeContent));
    }) : /*#__PURE__*/createElement(Fragment, {
      key: id
    }, withSticky, /*#__PURE__*/createElement("div", {
      role: "tabpanel",
      className: styles$y$1.cmsTabGroupContent
    }, activeContent)));
  };

  CmsTabGroup.displayName = 'CoreCmsTabGroup';
  CmsTabGroup.defaultProps = {
    defaultIndex: 0,
    isNavHeader: true,
    sticky: false,
    swipeable: false,
    tabsType: 'normal',
    wording: {
      text_baby: 'baby',
      text_boys: 'boys',
      text_carry_kids_baby: 'kids ･ baby',
      text_girls: 'girls',
      text_kids: 'kids',
      text_men: 'men',
      text_women: 'women'
    }
  };
  return CmsTabGroup;
}(Component);

var styles$z$1 = {"cms-transition-button--dynamic":"fr-ec-cms-transition-button--dynamic","cmsTransitionButtonDynamic":"fr-ec-cms-transition-button--dynamic","cms-transition-button--small":"fr-ec-cms-transition-button--small","cmsTransitionButtonSmall":"fr-ec-cms-transition-button--small"};

var CmsTransitionButton = function CmsTransitionButton(_a) {
  var label = _a.label,
      url = _a.url,
      _b = _a.chevronRight,
      chevronRight = _b === void 0 ? true : _b,
      _c = _a.keyline,
      keyline = _c === void 0 ? true : _c,
      _d = _a.type,
      type = _d === void 0 ? 'small' : _d,
      target = _a.target,
      gaCategory = _a.gaCategory,
      gaAction = _a.gaAction,
      gaLabel = _a.gaLabel,
      gaValue = _a.gaValue,
      className = _a.className,
      gaCallback = _a.gaCallback,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["label", "url", "chevronRight", "keyline", "type", "target", "gaCategory", "gaAction", "gaLabel", "gaValue", "className", "gaCallback", "iconBrand"]);

  var rootTag = 'a';
  var attributes = {};
  var absoluteUrlPattern = isAbsoluteUrl(url);

  if (absoluteUrlPattern) {
    attributes = {
      href: url,
      target: target || '_blank'
    };
  } else if (url) {
    rootTag = Link$1;
    attributes = {
      target: target || '_self',
      to: url
    };
  }

  return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement(LinkCell, __assign({
    label: label,
    element: rootTag,
    chevron: chevronRight,
    className: joinClasses(className, type !== 'large' ? styles$z$1["cms-transition-button--" + type] : null),
    iconBrand: iconBrand,
    gaCategory: gaCategory,
    gaAction: gaAction,
    gaLabel: gaLabel,
    gaValue: gaValue,
    gaCallback: gaCallback
  }, attributes, props)), keyline && /*#__PURE__*/createElement(Keyline, null));
};
CmsTransitionButton.displayName = 'CoreCmsTransitionButton';
CmsTransitionButton.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var CmsBreadcrumb = function CmsBreadcrumb(_a) {
  var label = _a.label,
      url = _a.url,
      _b = _a.gaCategory,
      gaCategory = _b === void 0 ? '' : _b,
      _c = _a.gaLabel,
      gaLabel = _c === void 0 ? '' : _c,
      gaAction = _a.gaAction,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      target = _a.target,
      className = _a.className,
      props = __rest(_a, ["label", "url", "gaCategory", "gaLabel", "gaAction", "gaValue", "gaCallback", "target", "className"]);

  var rootTag = 'a';
  var absoluteUrlPattern = isAbsoluteUrl(url || '');
  var attributes = {};

  if (absoluteUrlPattern) {
    attributes = {
      href: url,
      target: target || '_blank'
    };
  } else if (url) {
    rootTag = Link$1; // Default target behaviour of Link is similar to that of '_self'.
    // But if you specify target property explicitly, it refreshes the page.
    // @ts-ignore

    attributes.to = url;

    if (target && target !== '_self') {
      // @ts-ignore
      attributes.target = target;
    }
  }

  return /*#__PURE__*/createElement(Breadcrumb, __assign({
    element: rootTag,
    gaLabel: gaLabel,
    gaCategory: gaCategory,
    gaAction: gaAction,
    gaValue: gaValue,
    gaCallback: gaCallback
  }, attributes, {
    className: className
  }, props), label);
};
CmsBreadcrumb.displayName = 'CoreCmsBreadcrumb';
CmsBreadcrumb.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var CmsAnnotation = function CmsAnnotation(_a) {
  var content = _a.content,
      _b = _a.type,
      type = _b === void 0 ? 'normal' : _b,
      _c = _a.centered,
      centered = _c === void 0 ? false : _c,
      className = _a.className,
      id = _a.id;
  var color = {
    normal: 'primary-dark',
    weak: 'secondary',
    caution: 'error'
  };
  return /*#__PURE__*/createElement(Caption, {
    element: "p",
    variant: "standard",
    textAlign: centered ? 'center' : 'left',
    color: color[type],
    className: className,
    id: id
  }, content);
};
CmsAnnotation.displayName = 'CoreCmsAnnotation';

var styles$A$1 = {"cms-navigation-header-flyout":"fr-ec-cms-navigation-header-flyout","cmsNavigationHeaderFlyout":"fr-ec-cms-navigation-header-flyout","flyout-navigation__content":"fr-ec-flyout-navigation__content","flyoutNavigationContent":"fr-ec-flyout-navigation__content","cms-navigation-header-flyout--mobile":"fr-ec-cms-navigation-header-flyout--mobile","cmsNavigationHeaderFlyoutMobile":"fr-ec-cms-navigation-header-flyout--mobile","link-cell":"fr-ec-link-cell","linkCell":"fr-ec-link-cell","cms-navigation-header-flyout-general-links-container":"fr-ec-cms-navigation-header-flyout-general-links-container","cmsNavigationHeaderFlyoutGeneralLinksContainer":"fr-ec-cms-navigation-header-flyout-general-links-container","link-cell__label":"fr-ec-link-cell__label","linkCellLabel":"fr-ec-link-cell__label","icon":"fr-ec-icon","cms-accordion--type-large":"fr-ec-cms-accordion--type-large","cmsAccordionTypeLarge":"fr-ec-cms-accordion--type-large","cms-accordion--type-small":"fr-ec-cms-accordion--type-small","cmsAccordionTypeSmall":"fr-ec-cms-accordion--type-small","cms-navigation-header-flyout-featured-links-container":"fr-ec-cms-navigation-header-flyout-featured-links-container","cmsNavigationHeaderFlyoutFeaturedLinksContainer":"fr-ec-cms-navigation-header-flyout-featured-links-container","header-overlay":"fr-ec-header-overlay","headerOverlay":"fr-ec-header-overlay","overlay-content":"fr-ec-overlay-content","overlayContent":"fr-ec-overlay-content","cms-navigation-header-flyout--slide":"fr-ec-cms-navigation-header-flyout--slide","cmsNavigationHeaderFlyoutSlide":"fr-ec-cms-navigation-header-flyout--slide","drawer--open":"fr-ec-drawer--open","drawerOpen":"fr-ec-drawer--open","drawer--end":"fr-ec-drawer--end","drawerEnd":"fr-ec-drawer--end","slideInFromLeft":"fr-ec-slideInFromLeft","drawer--close":"fr-ec-drawer--close","drawerClose":"fr-ec-drawer--close","drawer__content":"fr-ec-drawer__content","drawerContent":"fr-ec-drawer__content","cms-navigation-header-flyout--open":"fr-ec-cms-navigation-header-flyout--open","cmsNavigationHeaderFlyoutOpen":"fr-ec-cms-navigation-header-flyout--open","fadeIn":"fr-ec-fadeIn","cms-navigation-header-flyout--close":"fr-ec-cms-navigation-header-flyout--close","cmsNavigationHeaderFlyoutClose":"fr-ec-cms-navigation-header-flyout--close","fadeOut":"fr-ec-fadeOut","flyout-navigation":"fr-ec-flyout-navigation","flyoutNavigation":"fr-ec-flyout-navigation","slideInFlyoutNavigation":"fr-ec-slideInFlyoutNavigation"};

var swiperInstance;
var CmsNavigationHeaderFlyout = function CmsNavigationHeaderFlyout(_a) {
  var genderLinksGroupContainer = _a.genderLinksGroupContainer,
      featuredLinksContainer = _a.featuredLinksContainer,
      otherLinksContainer = _a.otherLinksContainer,
      generalLinksContainer = _a.generalLinksContainer,
      handleFlyoutClose = _a.handleFlyoutClose,
      _b = _a.clickedItemIndex,
      clickedItemIndex = _b === void 0 ? 0 : _b,
      setMouseEnter = _a.setMouseEnter,
      setMouseLeave = _a.setMouseLeave,
      onModalclose = _a.onModalclose,
      _c = _a.genderTypeArray,
      genderTypeArray = _c === void 0 ? [] : _c,
      _d = _a.modalCloseLabel,
      modalCloseLabel = _d === void 0 ? '' : _d,
      className = _a.className,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["genderLinksGroupContainer", "featuredLinksContainer", "otherLinksContainer", "generalLinksContainer", "handleFlyoutClose", "clickedItemIndex", "setMouseEnter", "setMouseLeave", "onModalclose", "genderTypeArray", "modalCloseLabel", "className", "iconBrand"]);

  var width = getViewportWidth();

  var _e = useState(0),
      clickedIndex = _e[0],
      setClickedIndex = _e[1];

  var _f = useState(false),
      hideGenderLinks = _f[0],
      setHideGenderLinks = _f[1];

  var swiperRef = useRef(null);

  var handleGenderLinkClick = function handleGenderLinkClick(index) {
    setClickedIndex(index);

    if (swiperInstance) {
      swiperInstance.slideTo(Number(1));
    }
  };

  var onGenderClick = function onGenderClick() {
    if (swiperInstance) {
      swiperInstance.slideTo(Number(0));
    }
  };

  var onListClick = function onListClick() {
    if (swiperInstance) {
      swiperInstance.slideTo(Number(1));
    }
  };

  var onAccordionClick = function onAccordionClick() {
    if (swiperInstance) {
      swiperInstance.slideTo(Number(2));
    }
  };

  var onSlideChange = function onSlideChange() {
    if (swiperRef && swiperRef.current) {
      swiperRef.current.scrollIntoView();
    }
  };

  useEffect(function () {
    if (swiperRef.current) {
      swiperInstance = new swiper(swiperRef.current, {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        observeParents: true,
        observer: true,
        on: {
          slideChange: function slideChange() {
            return onSlideChange();
          }
        },
        slidesPerView: 1,
        spaceBetween: 0
      });
    }
  }, []);
  var genderLinks = genderTypeArray.map(function (item, index) {
    return /*#__PURE__*/createElement(LinkCell, {
      element: "button",
      disabled: false,
      label: item,
      chevron: true,
      iconPosition: "end",
      onClick: function onClick() {
        return handleGenderLinkClick(index);
      },
      isGenderTypography: true,
      iconBrand: iconBrand
    });
  });

  var handleRequestclose = function handleRequestclose() {
    if (onModalclose) {
      onModalclose();
    }
  };

  var toggleFlyoutClose = function toggleFlyoutClose() {
    setHideGenderLinks(true);
    setTimeout(function () {
      if (setMouseLeave) {
        setMouseLeave();
      }
    }, 50);
  };

  var modifiedGenderLinkContainer = function modifiedGenderLinkContainer(genderGroupContainer) {
    return genderLinksGroupContainer && Children.map(genderGroupContainer, function (genderLinksItem) {
      return /*#__PURE__*/cloneElement(genderLinksItem, {
        categoryContainer: Children.map(genderLinksItem.props.categoryContainer, function (CmsAccordionGroupItems) {
          return /*#__PURE__*/cloneElement(CmsAccordionGroupItems, {
            items: Children.map(CmsAccordionGroupItems.props.items, function (CmsAccordionItems) {
              return /*#__PURE__*/cloneElement(CmsAccordionItems, {
                children: Children.map(CmsAccordionItems.props.children, function (CmsAccordionList) {
                  return /*#__PURE__*/cloneElement(CmsAccordionList, {
                    children: Children.map(CmsAccordionList.props.children, function (CmsAccordionListItems) {
                      return /*#__PURE__*/cloneElement(CmsAccordionListItems, {
                        onClick: handleFlyoutClose
                      });
                    })
                  });
                })
              });
            })
          });
        }),
        salesLinksContainer: Children.map(genderLinksItem.props.salesLinksContainer, function (CmsTransitionButtonItems) {
          return /*#__PURE__*/cloneElement(CmsTransitionButtonItems, {
            onClick: handleFlyoutClose
          });
        })
      });
    })[0];
  };

  var modifiedLinkContainers = function modifiedLinkContainers(linksContainer) {
    var addCloseHandler = function addCloseHandler(linkChild) {
      return ['CoreCmsAccordion', 'CmsAccordion'].includes(linkChild === null || linkChild === void 0 ? void 0 : linkChild.type.displayName) ? /*#__PURE__*/cloneElement(linkChild, {
        children: Children.map(linkChild.props.children, function (CmsAccordionList) {
          return /*#__PURE__*/cloneElement(CmsAccordionList, {
            children: Children.map(CmsAccordionList.props.children, function (CmsAccordionListItems) {
              return /*#__PURE__*/cloneElement(CmsAccordionListItems, {
                onClick: handleFlyoutClose
              });
            })
          });
        })
      }) : /*#__PURE__*/cloneElement(linkChild, {
        onClick: handleFlyoutClose
      });
    };

    var modifiedLinkContainer = linksContainer && Children.map(linksContainer, function (linkItem) {
      return ['CoreLinkCell', 'LinkCell', 'CmsTransitionButton', 'CoreCmsTransitionButton', 'CoreCmsAccordion', 'CmsAccordion'].includes(linkItem.type.displayName) ? addCloseHandler(linkItem) : linkItem;
    });
    return modifiedLinkContainer;
  };

  if (width < designTokens_3.mqMediumScreenMinWidthLimit) {
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(className, styles$A$1.cmsNavigationHeaderFlyout, styles$A$1.cmsNavigationHeaderFlyoutMobile)
    }, /*#__PURE__*/createElement(Drawer, {
      title: "",
      onBackdropClick: handleRequestclose,
      position: "end",
      onRequestClose: handleRequestclose,
      closeLabel: modalCloseLabel,
      isOpen: true,
      iconBrand: iconBrand
    }, /*#__PURE__*/createElement("div", {
      className: "swiper-container",
      ref: swiperRef
    }, /*#__PURE__*/createElement("div", {
      className: "swiper-wrapper"
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses('swiper-slide', styles$A$1.cmsNavigationHeaderFlyoutSlide)
    }, /*#__PURE__*/createElement("div", {
      className: styles$A$1.cmsNavigationHeaderFlyoutGeneralLinksContainer
    }, modifiedLinkContainers(generalLinksContainer)), genderLinks, /*#__PURE__*/createElement("div", {
      className: styles$A$1.cmsNavigationHeaderFlyoutFeaturedLinksContainer
    }, modifiedLinkContainers(featuredLinksContainer)), /*#__PURE__*/createElement("div", null, modifiedLinkContainers(otherLinksContainer))), genderLinksGroupContainer && /*#__PURE__*/cloneElement(modifiedGenderLinkContainer(genderLinksGroupContainer[clickedIndex]), {
      handleFlyoutClose: handleFlyoutClose,
      iconBrand: iconBrand,
      onGenderClick: onGenderClick,
      onListClick: onListClick,
      onAccordionClick: onAccordionClick
    }, null)))));
  }

  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(className, styles$A$1.cmsNavigationHeaderFlyout, !hideGenderLinks ? styles$A$1.cmsNavigationHeaderFlyoutOpen : styles$A$1.cmsNavigationHeaderFlyoutClose),
    onMouseEnter: setMouseEnter,
    onMouseLeave: toggleFlyoutClose
  }, props), genderLinksGroupContainer && /*#__PURE__*/cloneElement(modifiedGenderLinkContainer(genderLinksGroupContainer[clickedItemIndex]), {
    featuredLinksContainer: modifiedLinkContainers(featuredLinksContainer),
    generalLinksContainer: modifiedLinkContainers(generalLinksContainer),
    handleFlyoutClose: handleFlyoutClose,
    iconBrand: iconBrand,
    modalCloseLabel: modalCloseLabel,
    otherLinksContainer: modifiedLinkContainers(otherLinksContainer)
  }, null));
};
CmsNavigationHeaderFlyout.displayName = 'CoreCmsNavigationHeaderFlyout';

var styles$B$1 = {"cms-gender-links-container":"fr-ec-cms-gender-links-container","cmsGenderLinksContainer":"fr-ec-cms-gender-links-container","cms-gender-links-container-links":"fr-ec-cms-gender-links-container-links","cmsGenderLinksContainerLinks":"fr-ec-cms-gender-links-container-links","cms-gender-links-container__general-link-container":"fr-ec-cms-gender-links-container__general-link-container","cmsGenderLinksContainerGeneralLinkContainer":"fr-ec-cms-gender-links-container__general-link-container","cms-gender-links-container-back-to-gender":"fr-ec-cms-gender-links-container-back-to-gender","cmsGenderLinksContainerBackToGender":"fr-ec-cms-gender-links-container-back-to-gender","link-cell":"fr-ec-link-cell","linkCell":"fr-ec-link-cell","icon":"fr-ec-icon","cms-gender-links-container-category-link-content":"fr-ec-cms-gender-links-container-category-link-content","cmsGenderLinksContainerCategoryLinkContent":"fr-ec-cms-gender-links-container-category-link-content","link-navigation-group__list":"fr-ec-link-navigation-group__list","linkNavigationGroupList":"fr-ec-link-navigation-group__list","cms-gender-links-container__featured-link-container":"fr-ec-cms-gender-links-container__featured-link-container","cmsGenderLinksContainerFeaturedLinkContainer":"fr-ec-cms-gender-links-container__featured-link-container","cms-gender-links-container__other-link-container":"fr-ec-cms-gender-links-container__other-link-container","cmsGenderLinksContainerOtherLinkContainer":"fr-ec-cms-gender-links-container__other-link-container","cms-gender-links-container__sales-links-container":"fr-ec-cms-gender-links-container__sales-links-container","cmsGenderLinksContainerSalesLinksContainer":"fr-ec-cms-gender-links-container__sales-links-container","cms-gender-links-container__aside-items-container":"fr-ec-cms-gender-links-container__aside-items-container","cmsGenderLinksContainerAsideItemsContainer":"fr-ec-cms-gender-links-container__aside-items-container","cms-gender-links-container__aside-items-container--content-left":"fr-ec-cms-gender-links-container__aside-items-container--content-left","cmsGenderLinksContainerAsideItemsContainerContentLeft":"fr-ec-cms-gender-links-container__aside-items-container--content-left","cms-gender-links-container__aside-items-container--content-right":"fr-ec-cms-gender-links-container__aside-items-container--content-right","cmsGenderLinksContainerAsideItemsContainerContentRight":"fr-ec-cms-gender-links-container__aside-items-container--content-right","cms-gender-links-container__slide":"fr-ec-cms-gender-links-container__slide","cmsGenderLinksContainerSlide":"fr-ec-cms-gender-links-container__slide"};

var CmsGenderLinksContainer = function CmsGenderLinksContainer(_a) {
  var _b = _a.genderType,
      genderType = _b === void 0 ? '' : _b,
      genderTopLinkLabel = _a.genderTopLinkLabel,
      genderTopLink = _a.genderTopLink,
      salesLinksContainer = _a.salesLinksContainer,
      categoryContainer = _a.categoryContainer,
      featuredLinksContainer = _a.featuredLinksContainer,
      otherLinksContainer = _a.otherLinksContainer,
      generalLinksContainer = _a.generalLinksContainer,
      handleFlyoutClose = _a.handleFlyoutClose,
      modalCloseLabel = _a.modalCloseLabel,
      onGenderClick = _a.onGenderClick,
      className = _a.className,
      iconBrand = _a.iconBrand,
      onListClick = _a.onListClick,
      onAccordionClick = _a.onAccordionClick,
      props = __rest(_a, ["genderType", "genderTopLinkLabel", "genderTopLink", "salesLinksContainer", "categoryContainer", "featuredLinksContainer", "otherLinksContainer", "generalLinksContainer", "handleFlyoutClose", "modalCloseLabel", "onGenderClick", "className", "iconBrand", "onListClick", "onAccordionClick"]);

  var _c = useState(0),
      activeIndex = _c[0],
      setActiveIndex = _c[1];

  var _d = useState(false),
      setDisplay = _d[1];

  var handleClick = function handleClick(index) {
    setActiveIndex(index);
    setDisplay(true);

    if (onAccordionClick) {
      onAccordionClick();
    }
  };

  var rootTag = 'a';
  var absoluteUrlPattern = isAbsoluteUrl(genderTopLink);
  var attributes = {};

  if (absoluteUrlPattern) {
    attributes = {
      href: genderTopLink,
      target: '_blank'
    };
  } else if (genderTopLink) {
    rootTag = Link$1;
    attributes = {
      to: genderTopLink
    };
  }

  var categoryLinkContent = null;
  var categoryContainerHeadingText = '';
  var categoryLinks = Children.toArray(categoryContainer).filter(isValidElement).map(function (child) {
    var categoryLinksChild = Children.toArray(child.props.items);
    return categoryLinksChild.map(function (item, index) {
      if (index === activeIndex) {
        categoryLinkContent = item.props.children;
        categoryContainerHeadingText = item.props.headingText;
      }

      return /*#__PURE__*/cloneElement(item, {
        onClick: function onClick() {
          return handleClick(index);
        },
        accordionType: 'nav'
      });
    });
  });
  var flyoutMainContent = Children.toArray(categoryContainer).filter(isValidElement).map(function (child) {
    return /*#__PURE__*/cloneElement(child, {
      type: 'nav'
    });
  });
  var width = getViewportWidth();
  var asideItems = width > designTokens_3.mqMediumScreenMaxWidthLimit ? /*#__PURE__*/createElement("div", {
    className: styles$B$1.cmsGenderLinksContainerAsideItemsContainer
  }, /*#__PURE__*/createElement("div", {
    className: styles$B$1.cmsGenderLinksContainerAsideItemsContainerContentLeft
  }, salesLinksContainer && /*#__PURE__*/createElement("div", {
    className: styles$B$1.cmsGenderLinksContainerSalesLinksContainer
  }, salesLinksContainer), otherLinksContainer && /*#__PURE__*/createElement("div", {
    className: styles$B$1.cmsGenderLinksContainerOtherLinkContainer
  }, otherLinksContainer)), /*#__PURE__*/createElement("div", {
    className: styles$B$1.cmsGenderLinksContainerAsideItemsContainerContentRight
  }, generalLinksContainer && /*#__PURE__*/createElement("div", {
    className: styles$B$1.cmsGenderLinksContainerGeneralLinkContainer
  }, generalLinksContainer), featuredLinksContainer && /*#__PURE__*/createElement("div", {
    className: styles$B$1.cmsGenderLinksContainerFeaturedLinkContainer
  }, featuredLinksContainer))) : width > designTokens_3.mqSmallScreenMaxWidthLimit && width < designTokens_3.mqLargeScreenMinWidthLimit ? /*#__PURE__*/createElement("div", {
    className: styles$B$1.cmsGenderLinksContainerAsideItemsContainer
  }, /*#__PURE__*/createElement("div", {
    className: styles$B$1.cmsGenderLinksContainerAsideItemsContainerContentRight
  }, generalLinksContainer && /*#__PURE__*/createElement("div", {
    className: styles$B$1.cmsGenderLinksContainerGeneralLinkContainer
  }, generalLinksContainer), salesLinksContainer && /*#__PURE__*/createElement("div", {
    className: styles$B$1.cmsGenderLinksContainerSalesLinksContainer
  }, salesLinksContainer), otherLinksContainer && /*#__PURE__*/createElement("div", {
    className: styles$B$1.cmsGenderLinksContainerOtherLinkContainer
  }, otherLinksContainer), featuredLinksContainer && /*#__PURE__*/createElement("div", {
    className: styles$B$1.cmsGenderLinksContainerFeaturedLinkContainer
  }, featuredLinksContainer))) : null;

  if (width < designTokens_3.mqMediumScreenMinWidthLimit) {
    return /*#__PURE__*/createElement(Fragment, null, /*#__PURE__*/createElement("div", {
      className: joinClasses('swiper-slide', styles$B$1.cmsGenderLinksContainerSlide)
    }, /*#__PURE__*/createElement("div", {
      className: styles$B$1.cmsGenderLinksContainerBackToGender
    }, /*#__PURE__*/createElement(LinkCell, {
      element: "button",
      chevron: false,
      iconPosition: "start",
      label: genderType,
      onClick: onGenderClick,
      icon: "chevron-left",
      isGenderTypography: true,
      iconBrand: iconBrand
    })), /*#__PURE__*/createElement(LinkCell, __assign({
      label: genderTopLinkLabel,
      element: rootTag,
      iconBrand: iconBrand
    }, attributes, {
      onClick: handleFlyoutClose
    })), /*#__PURE__*/createElement("div", null, salesLinksContainer), /*#__PURE__*/createElement("div", {
      className: styles$B$1.cmsGenderLinksContainerLinks
    }, categoryLinks)), /*#__PURE__*/createElement("div", {
      className: joinClasses('swiper-slide', styles$B$1.cmsGenderLinksContainerSlide)
    }, /*#__PURE__*/createElement("div", {
      className: styles$B$1.cmsGenderLinksContainerBackToGender
    }, /*#__PURE__*/createElement(LinkCell, {
      element: "button",
      chevron: false,
      iconPosition: "start",
      label: categoryContainerHeadingText,
      onClick: onListClick,
      icon: "chevron-left",
      iconBrand: iconBrand
    })), /*#__PURE__*/createElement("div", {
      className: styles$B$1.cmsGenderLinksContainerCategoryLinkContent
    }, categoryLinkContent)));
  }

  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(className, styles$B$1.cmsGenderLinksContainer)
  }, props), /*#__PURE__*/createElement(FlyoutNavigation, {
    aside: asideItems,
    main: flyoutMainContent,
    content: genderTopLinkLabel && /*#__PURE__*/createElement(LinkText, __assign({
      element: rootTag
    }, attributes, {
      onClick: handleFlyoutClose
    }), genderTopLinkLabel),
    onDismiss: handleFlyoutClose,
    modalCloseLabel: modalCloseLabel,
    iconBrand: iconBrand
  }));
};
CmsGenderLinksContainer.displayName = 'CoreCmsGenderLinksContainer';

var styles$C$1 = {"cms-tappable-item":"fr-ec-cms-tappable-item","cmsTappableItem":"fr-ec-cms-tappable-item","cms-tappable-image--ratio-1x1":"fr-ec-cms-tappable-image--ratio-1x1","cmsTappableImageRatio1X1":"fr-ec-cms-tappable-image--ratio-1x1","cms-tappable-image--ratio-3x4":"fr-ec-cms-tappable-image--ratio-3x4","cmsTappableImageRatio3X4":"fr-ec-cms-tappable-image--ratio-3x4","cms-tappable-item-text":"fr-ec-cms-tappable-item-text","cmsTappableItemText":"fr-ec-cms-tappable-item-text","cms-tappable-item-image--ratio-3x4":"fr-ec-cms-tappable-item-image--ratio-3x4","cmsTappableItemImageRatio3X4":"fr-ec-cms-tappable-item-image--ratio-3x4","cms-tappable-item-image--ratio-1x1":"fr-ec-cms-tappable-item-image--ratio-1x1","cmsTappableItemImageRatio1X1":"fr-ec-cms-tappable-item-image--ratio-1x1","cms-tappable-item-text--without-image":"fr-ec-cms-tappable-item-text--without-image","cmsTappableItemTextWithoutImage":"fr-ec-cms-tappable-item-text--without-image","cms-tappable-item__title":"fr-ec-cms-tappable-item__title","cmsTappableItemTitle":"fr-ec-cms-tappable-item__title"};

var CmsTappableItem = function CmsTappableItem(_a) {
  var title = _a.title,
      link = _a.link,
      target = _a.target,
      image = _a.image,
      imageAlt = _a.imageAlt,
      gaCategory = _a.gaCategory,
      gaLabel = _a.gaLabel,
      className = _a.className,
      _b = _a.imageRatio,
      imageRatio = _b === void 0 ? '3x4' : _b,
      iconBrand = _a.iconBrand,
      _c = _a.scroll,
      scroll = _c === void 0 ? false : _c,
      props = __rest(_a, ["title", "link", "target", "image", "imageAlt", "gaCategory", "gaLabel", "className", "imageRatio", "iconBrand", "scroll"]);

  var rootTag = link ? 'a' : 'button';
  var absoluteUrlPattern = link && isAbsoluteUrl(link);
  var attributes = {};

  if (link && absoluteUrlPattern) {
    attributes = {
      href: link,
      target: target || '_blank'
    };
  } else if (link && link[0] === '#') {
    rootTag = Link$1; // Default target behaviour of Link is similar to that of '_self'.
    // But if you specify target property explicitly, it refreshes the page.
    // @ts-ignore

    attributes.to = link;

    if (target !== '_self') {
      // @ts-ignore
      attributes.target = target;
    }
  } else if (link) {
    rootTag = Link$1; // Default target behaviour of Link is similar to that of '_self'.
    // But if you specify target property explicitly, it refreshes the page.
    // @ts-ignore

    attributes.to = link;

    if (target && target !== '_self') {
      // @ts-ignore
      attributes.target = target;
    }
  }

  var handleClick = function handleClick(event) {
    // Reduce the header height if the header element is present
    if (isInBrowser$1() && scroll) {
      var headerEl = document.getElementsByTagName('header')[0];
      var headerOffset = 0;
      var offsetVal = 16;

      if (headerEl) {
        headerOffset = headerEl.offsetHeight;
      }

      if (link && link[0] === '#') {
        event.preventDefault();
        var btn = document.getElementById(link.slice(1));

        if (btn) {
          var offset = btn.offsetTop;
          window.scrollTo({
            behavior: 'smooth',
            left: 0,
            top: offset - (headerOffset + offsetVal)
          });
        }
      }
    }
  };

  return /*#__PURE__*/createElement(Tile, __assign({
    element: rootTag,
    className: joinClasses(styles$C$1.cmsTappableItem, className),
    gaCategory: gaCategory,
    gaLabel: gaLabel
  }, attributes, props, {
    onClick: handleClick
  }), image && /*#__PURE__*/createElement("div", {
    className: styles$C$1["cms-tappable-image--ratio-" + imageRatio]
  }, /*#__PURE__*/createElement(Image, {
    ratio: imageRatio,
    src: image,
    alt: imageAlt,
    iconBrand: iconBrand
  })), /*#__PURE__*/createElement(ContentAlignment, {
    element: "div",
    direction: "column",
    alignment: "center",
    justifyContent: "center",
    className: joinClasses(styles$C$1.cmsTappableItemText, image ? styles$C$1["cms-tappable-item-image--ratio-" + imageRatio] : styles$C$1.cmsTappableItemTextWithoutImage)
  }, /*#__PURE__*/createElement(Title, {
    variant: "large",
    color: "primary-dark",
    element: "span",
    className: styles$C$1.cmsTappableItemTitle
  }, title)));
};
CmsTappableItem.displayName = 'CoreCmsTappableItem';

var styles$D$1 = {"cms-smart-banner":"fr-ec-cms-smart-banner","cmsSmartBanner":"fr-ec-cms-smart-banner","cms-smart-banner__image":"fr-ec-cms-smart-banner__image","cmsSmartBannerImage":"fr-ec-cms-smart-banner__image","cms-smart-banner__clickable-area":"fr-ec-cms-smart-banner__clickable-area","cmsSmartBannerClickableArea":"fr-ec-cms-smart-banner__clickable-area","cms-smart-banner__action-button":"fr-ec-cms-smart-banner__action-button","cmsSmartBannerActionButton":"fr-ec-cms-smart-banner__action-button","cms-smart-banner__image-section":"fr-ec-cms-smart-banner__image-section","cmsSmartBannerImageSection":"fr-ec-cms-smart-banner__image-section"};

var CmsSmartBanner = function CmsSmartBanner(_a) {
  var smallImageUrl = _a.smallImageUrl,
      mediumImageUrl = _a.mediumImageUrl,
      altText = _a.altText,
      actionText = _a.actionText,
      gaCategory = _a.gaCategory,
      gaLabel = _a.gaLabel,
      onActionButtonClick = _a.onActionButtonClick,
      onCloseButtonClick = _a.onCloseButtonClick,
      iconBrand = _a.iconBrand,
      gaCallback = _a.gaCallback,
      gaAction = _a.gaAction,
      gaValue = _a.gaValue,
      props = __rest(_a, ["smallImageUrl", "mediumImageUrl", "altText", "actionText", "gaCategory", "gaLabel", "onActionButtonClick", "onCloseButtonClick", "iconBrand", "gaCallback", "gaAction", "gaValue"]);

  var width = getViewportWidth();
  var imageTemplate = width < designTokens_3.mqMediumScreenMinWidthLimit ? /*#__PURE__*/createElement(Image, {
    className: styles$D$1.cmsSmartBannerImage,
    ratio: "3x1",
    src: smallImageUrl,
    alt: altText,
    iconBrand: iconBrand
  }) : /*#__PURE__*/createElement(Image, {
    className: styles$D$1.cmsSmartBannerImage,
    ratio: "6x1",
    src: mediumImageUrl,
    alt: altText,
    iconBrand: iconBrand
  });

  var onClickCallback = function onClickCallback(e) {
    if (onActionButtonClick) {
      onActionButtonClick(e);
    }

    if (gaCallback) {
      gaCallback(e.currentTarget, gaLabel);
    }
  };

  return width < designTokens_3.mqLargeScreenMinWidthLimit ? /*#__PURE__*/createElement(ContentAlignment, __assign({
    direction: "row",
    element: "div",
    className: styles$D$1.cmsSmartBanner,
    alignment: "center"
  }, props), /*#__PURE__*/createElement(ButtonIcon, {
    element: "button",
    icon: "close",
    label: '',
    variant: "dark",
    onClick: onCloseButtonClick,
    iconBrand: iconBrand
  }), /*#__PURE__*/createElement(Tile, {
    className: styles$D$1.cmsSmartBannerClickableArea,
    element: "button",
    gaCategory: gaCategory,
    gaLabel: gaLabel,
    gaAction: gaAction,
    gaValue: gaValue,
    onClick: onClickCallback
  }, /*#__PURE__*/createElement("div", {
    className: styles$D$1.cmsSmartBannerImageSection
  }, imageTemplate), /*#__PURE__*/createElement(Button, {
    className: styles$D$1.cmsSmartBannerActionButton,
    element: "button",
    emphasized: false,
    textTransform: "all-caps",
    variant: "secondary",
    width: "fitContent",
    isSmall: true
  }, actionText))) : null;
};
CmsSmartBanner.displayName = 'CoreCmsSmartBanner';
CmsSmartBanner.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var styles$E$1 = {"cms-quote-review__container":"fr-ec-cms-quote-review__container","cmsQuoteReviewContainer":"fr-ec-cms-quote-review__container","cms-quote-review":"fr-ec-cms-quote-review","cmsQuoteReview":"fr-ec-cms-quote-review","cms-quote-review__quotation":"fr-ec-cms-quote-review__quotation","cmsQuoteReviewQuotation":"fr-ec-cms-quote-review__quotation"};

var CmsQuoteReview = function CmsQuoteReview(_a) {
  var title = _a.title,
      comment = _a.comment,
      userInformation = _a.userInformation,
      className = _a.className,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["title", "comment", "userInformation", "className", "iconBrand"]);

  return /*#__PURE__*/createElement("div", __assign({
    className: joinClasses(styles$E$1.cmsQuoteReviewContainer, className)
  }, props), /*#__PURE__*/createElement("div", {
    className: styles$E$1.cmsQuoteReview
  }, /*#__PURE__*/createElement("div", {
    className: styles$E$1.cmsQuoteReviewQuotation
  }, /*#__PURE__*/createElement(Icon, {
    name: iconBrand ? iconBrand + "quotation-start" : 'quotation-start'
  })), /*#__PURE__*/createElement("div", null, title && /*#__PURE__*/createElement(Title, {
    className: spacingStyles.mbSpacing03,
    variant: "large",
    textAlign: "center",
    element: 'h1'
  }, title), /*#__PURE__*/createElement(Body, {
    element: 'h1',
    variant: "standard"
  }, comment)), /*#__PURE__*/createElement("div", {
    className: styles$E$1.cmsQuoteReviewQuotation
  }, /*#__PURE__*/createElement(Icon, {
    name: iconBrand ? iconBrand + "quotation-end" : 'quotation-end'
  }))), userInformation && /*#__PURE__*/createElement(Body, {
    textAlign: "center",
    color: "secondary",
    variant: "small",
    element: 'h1'
  }, userInformation));
};
CmsQuoteReview.displayName = 'CoreCmsQuoteReview';

var styles$F$1 = {"image-plus-product-text":"fr-ec-image-plus-product-text","imagePlusProductText":"fr-ec-image-plus-product-text","product-tile__horizontal_spacing":"fr-ec-product-tile__horizontal_spacing","productTileHorizontalSpacing":"fr-ec-product-tile__horizontal_spacing","product-tile__end":"fr-ec-product-tile__end","productTileEnd":"fr-ec-product-tile__end","product-tile__end-product-name":"fr-ec-product-tile__end-product-name","productTileEndProductName":"fr-ec-product-tile__end-product-name","product-tile__end-info-block-flags":"fr-ec-product-tile__end-info-block-flags","productTileEndInfoBlockFlags":"fr-ec-product-tile__end-info-block-flags","product-tile__end-info-block-price":"fr-ec-product-tile__end-info-block-price","productTileEndInfoBlockPrice":"fr-ec-product-tile__end-info-block-price","product-tile__end-info-block-price-flags":"fr-ec-product-tile__end-info-block-price-flags","productTileEndInfoBlockPriceFlags":"fr-ec-product-tile__end-info-block-price-flags"};

var ImagePlusProductText = function ImagePlusProductText(_a) {
  var imageUrl = _a.imageUrl,
      imageRatio = _a.imageRatio,
      iconBrand = _a.iconBrand,
      rest = __rest(_a, ["imageUrl", "imageRatio", "iconBrand"]);

  var _b = useState(getCurrentMediaQueryBreakpoint()),
      screenSize = _b[0],
      setScreenSize = _b[1];

  var onResize = function onResize() {
    return setScreenSize(getCurrentMediaQueryBreakpoint());
  };

  var variant = screenSize === 'sm' ? 'vertical' : 'horizontal';
  return /*#__PURE__*/createElement(Measure, {
    bounds: true,
    onResize: onResize
  }, function (_a) {
    var measureRef = _a.measureRef;
    return /*#__PURE__*/createElement("div", {
      className: styles$F$1.imagePlusProductText,
      ref: measureRef
    }, /*#__PURE__*/createElement(ProductTile, __assign({
      images: [imageUrl],
      imageRatio: imageRatio,
      variant: variant,
      favoriteButtonHidden: true,
      nameTypographyVariant: 'TitleLarge',
      iconBrand: iconBrand
    }, rest)));
  });
};
ImagePlusProductText.displayName = 'CoreImagePlusProductText';

var DataTableBody = function DataTableBody(_a) {
  var rows = _a.rows,
      columnStyles = _a.columnStyles,
      rest = __rest(_a, ["rows", "columnStyles", "iconBrand"]);

  var _b = useState([]),
      oddRows = _b[0],
      setOddRows = _b[1];

  useEffect(function () {
    setOddRows(getOddRows());
  }, [rows]);

  var getOddRows = function getOddRows() {
    var headerRows = function headerRows() {
      var rowItem = [];
      rows.forEach(function (item, key) {
        return item.heading && rowItem.push(key);
      });
      return rowItem;
    };

    var rowIndexs = Array(rows.length).fill(null).map(function (_, i) {
      return i;
    });
    var subArrays = [];
    headerRows().forEach(function (item1, index) {
      var lastIndex = index === headerRows().length - 1 ? rows.length - 1 : headerRows()[item1 + 1];
      subArrays.push(rowIndexs.slice(item1, lastIndex));
    });
    var oddItems = subArrays.map(function (subs) {
      return subs.filter(function (_, index) {
        return index !== 0 && index % 2 === 0;
      });
    });
    return oddItems.reduce(function (acc, val) {
      return acc.concat(val);
    }, []);
  };

  var getChild = function getChild(dtCell) {
    var childType;

    if ( /*#__PURE__*/isValidElement(dtCell)) {
      Children.forEach(dtCell, function (child) {
        var _a, _b, _c, _d, _e, _f;

        if (((_a = child.type) === null || _a === void 0 ? void 0 : _a.displayName) === 'ButtonIcon' || ((_b = child.type) === null || _b === void 0 ? void 0 : _b.displayName) === 'CoreButtonIcon') {
          childType = 'ButtonIcon';
        } else if (((_c = child.type) === null || _c === void 0 ? void 0 : _c.displayName) === 'ImageOverlay' || ((_d = child.type) === null || _d === void 0 ? void 0 : _d.displayName) === 'CoreImageOverlay') {
          childType = 'ImageOverlay';
        } else if (((_e = child.type) === null || _e === void 0 ? void 0 : _e.displayName) === 'ContentAlignment' || ((_f = child.type) === null || _f === void 0 ? void 0 : _f.displayName) === 'CoreContentAlignment') {
          childType = 'ContentAlignment';
        } else {
          childType = '';
        }
      });
    }

    return childType;
  };

  var addChildClass = function addChildClass(dtCell) {
    var childClass;

    if (getChild(dtCell) === 'ButtonIcon') {
      childClass = DataTableCellStyles.dataTableCellButton;
    } else if (getChild(dtCell) === 'ImageOverlay') {
      childClass = DataTableCellStyles.dataTableCellImage;
    } else if (getChild(dtCell) === 'ContentAlignment') {
      childClass = DataTableCellStyles.dataTableCellToolTip;
    } else {
      childClass = '';
    }

    return childClass;
  };

  var getToolTipIndex = function getToolTipIndex() {
    var toolTipIndex = [];
    rows.forEach(function (_a, i) {
      var content = _a.content;
      content.forEach(function (cell, j) {
        if (getChild(cell) === 'ContentAlignment') {
          toolTipIndex.push(j);
        }
      });
    });
    var uniqIndex = toolTipIndex.reduce(function (acc, item) {
      if (acc.indexOf(item) < 0) {
        acc.push(item);
      }

      return acc;
    }, []);
    return uniqIndex;
  };

  return /*#__PURE__*/createElement("tbody", __assign({}, rest), rows.map(function (_a, i) {
    var content = _a.content,
        actions = _a.actions,
        _b = _a.typography,
        typography = _b === void 0 ? 'body' : _b,
        emphasized = _a.emphasized,
        contentClassName = _a.contentClassName,
        _c = _a.heading,
        heading = _c === void 0 ? false : _c,
        props = __rest(_a, ["content", "actions", "typography", "emphasized", "contentClassName", "heading"]);

    return /*#__PURE__*/createElement(DataTableRow, {
      key: i,
      className: joinClasses(oddRows.length > 0 && oddRows.includes(i) && DataTableRowStyles.dataTableRowHighlighted, heading && DataTableRowStyles.dataTableRowHeading)
    }, content.map(function (cell, j) {
      return /*#__PURE__*/createElement(DataTableCell, __assign({
        key: j,
        element: j === 0 ? 'th' : 'td',
        className: joinClasses(contentClassName && contentClassName[j], addChildClass(cell), cell.noWrap && DataTableCellStyles.dataTableCellNoWrap, (typeof cell === 'string' || cell.label) && (cell.label || cell).includes('<br>') && DataTableCellStyles.dataTableCellMultiLines)
      }, getToolTipIndex().includes(j) ? {
        alignment: 'start'
      } : (columnStyles === null || columnStyles === void 0 ? void 0 : columnStyles[j]) || {
        alignment: 'center'
      }, props), cell && (typeof cell === 'string' || cell.label ? ((cell === null || cell === void 0 ? void 0 : cell.typography) || typography) === 'body' ? /*#__PURE__*/createElement(Body, {
        element: "span",
        variant: (cell === null || cell === void 0 ? void 0 : cell.emphasized) || emphasized ? 'small-emphasized' : 'small'
      }, ReactHtmlParser(cell.label || cell)) : /*#__PURE__*/createElement(Title, {
        element: "span",
        variant: (cell === null || cell === void 0 ? void 0 : cell.emphasized) || emphasized ? 'small-emphasized' : 'small'
      }, ReactHtmlParser(cell.label || cell)) : Children.map(cell, function (child) {
        return getChild(cell) === 'ButtonIcon' ? /*#__PURE__*/cloneElement(child, {
          onClick: function onClick() {
            return (actions === null || actions === void 0 ? void 0 : actions.onClick) && (actions === null || actions === void 0 ? void 0 : actions.onClick(i, j));
          }
        }) : child;
      })));
    }));
  }));
};
DataTableBody.displayName = 'CoreDataTableBody';

var dataStyles = {"data-table":"fr-ec-data-table","dataTable":"fr-ec-data-table","data-table--with-footer":"fr-ec-data-table--with-footer","dataTableWithFooter":"fr-ec-data-table--with-footer","data-table-cell":"fr-ec-data-table-cell","dataTableCell":"fr-ec-data-table-cell"};

var DataTable = function DataTable(_a) {
  var rows = _a.rows,
      columnStyles = _a.columnStyles,
      className = _a.className,
      iconBrand = _a.iconBrand,
      showMore = _a.showMore,
      props = __rest(_a, ["rows", "columnStyles", "className", "iconBrand", "showMore"]);

  var _b = useState(rows),
      dtRows = _b[0],
      setRows = _b[1];

  var getModifiedRows = function getModifiedRows() {
    var modifiedRow = [];
    var isActions = dtRows.some(function (item) {
      var _a;

      return (_a = item.actions) === null || _a === void 0 ? void 0 : _a.icon;
    });

    if (isActions) {
      dtRows.forEach(function (item, index) {
        var _a, _b, _c, _d;

        return item.actions && ((_a = item.actions) === null || _a === void 0 ? void 0 : _a.icon) && ((_b = item.actions) === null || _b === void 0 ? void 0 : _b.label) ? modifiedRow.push(__assign(__assign({}, dtRows[index]), {
          content: dtRows[index].content.concat( /*#__PURE__*/createElement(ButtonIcon, {
            key: index,
            element: "button",
            icon: (_c = item.actions) === null || _c === void 0 ? void 0 : _c.icon,
            iconBrand: iconBrand,
            label: (_d = item.actions) === null || _d === void 0 ? void 0 : _d.label
          }))
        })) : modifiedRow.push(__assign(__assign({}, dtRows[index]), {
          content: dtRows[index].content.concat(''),
          contentClassName: Array(dtRows[index].content.length).fill('').concat(DataTableCellStyles.dataTableCellEmpty)
        }));
      });
      return modifiedRow;
    }

    return dtRows;
  };

  useEffect(function () {
    setRows(rows);
  }, [rows]);
  return /*#__PURE__*/createElement(DataTableScrollContainer, {
    rows: getModifiedRows(),
    iconBrand: iconBrand,
    showMore: showMore,
    className: className
  }, /*#__PURE__*/createElement("table", __assign({
    className: dataStyles.dataTable
  }, props), /*#__PURE__*/createElement(DataTableBody, {
    rows: getModifiedRows(),
    columnStyles: columnStyles,
    iconBrand: iconBrand
  })));
};
DataTable.displayName = 'CoreDataTable';

var styles$G$1 = {"skeleton":"fr-ec-skeleton","skeleton__pulse":"fr-ec-skeleton__pulse","skeletonPulse":"fr-ec-skeleton__pulse","pulse":"fr-ec-pulse","skeleton__breadcrumb":"fr-ec-skeleton__breadcrumb","skeletonBreadcrumb":"fr-ec-skeleton__breadcrumb","skeleton__heading":"fr-ec-skeleton__heading","skeletonHeading":"fr-ec-skeleton__heading","skeleton__banner":"fr-ec-skeleton__banner","skeletonBanner":"fr-ec-skeleton__banner","skeleton__product-collection-wrapper":"fr-ec-skeleton__product-collection-wrapper","skeletonProductCollectionWrapper":"fr-ec-skeleton__product-collection-wrapper","skeleton__product-collection":"fr-ec-skeleton__product-collection","skeletonProductCollection":"fr-ec-skeleton__product-collection","skeleton__product":"fr-ec-skeleton__product","skeletonProduct":"fr-ec-skeleton__product","skeleton__product-item1":"fr-ec-skeleton__product-item1","skeletonProductItem1":"fr-ec-skeleton__product-item1","skeleton__text-wrapper":"fr-ec-skeleton__text-wrapper","skeletonTextWrapper":"fr-ec-skeleton__text-wrapper","skeleton__product-item2":"fr-ec-skeleton__product-item2","skeletonProductItem2":"fr-ec-skeleton__product-item2","skeleton__product-item3":"fr-ec-skeleton__product-item3","skeletonProductItem3":"fr-ec-skeleton__product-item3","skeleton__product-item-mobile-only":"fr-ec-skeleton__product-item-mobile-only","skeletonProductItemMobileOnly":"fr-ec-skeleton__product-item-mobile-only","skeleton__featured-heading":"fr-ec-skeleton__featured-heading","skeletonFeaturedHeading":"fr-ec-skeleton__featured-heading","skeleton__sub-text":"fr-ec-skeleton__sub-text","skeletonSubText":"fr-ec-skeleton__sub-text","skeleton__sub-text1":"fr-ec-skeleton__sub-text1","skeletonSubText1":"fr-ec-skeleton__sub-text1","skeleton__sub-text2":"fr-ec-skeleton__sub-text2","skeletonSubText2":"fr-ec-skeleton__sub-text2","skeleton__tab":"fr-ec-skeleton__tab","skeletonTab":"fr-ec-skeleton__tab","skeleton__tab--margin":"fr-ec-skeleton__tab--margin","skeletonTabMargin":"fr-ec-skeleton__tab--margin","skeleton__product-collection-heading":"fr-ec-skeleton__product-collection-heading","skeletonProductCollectionHeading":"fr-ec-skeleton__product-collection-heading","skeleton__featured-wrapper":"fr-ec-skeleton__featured-wrapper","skeletonFeaturedWrapper":"fr-ec-skeleton__featured-wrapper","skeleton__featured-product-collection":"fr-ec-skeleton__featured-product-collection","skeletonFeaturedProductCollection":"fr-ec-skeleton__featured-product-collection","skeleton__featured-product":"fr-ec-skeleton__featured-product","skeletonFeaturedProduct":"fr-ec-skeleton__featured-product","skeleton__featured-product-item1":"fr-ec-skeleton__featured-product-item1","skeletonFeaturedProductItem1":"fr-ec-skeleton__featured-product-item1","skeleton__featured-text-wrapper":"fr-ec-skeleton__featured-text-wrapper","skeletonFeaturedTextWrapper":"fr-ec-skeleton__featured-text-wrapper","skeleton__featured-product-item2":"fr-ec-skeleton__featured-product-item2","skeletonFeaturedProductItem2":"fr-ec-skeleton__featured-product-item2","skeleton__featured-product-item3":"fr-ec-skeleton__featured-product-item3","skeletonFeaturedProductItem3":"fr-ec-skeleton__featured-product-item3","skeleton__featured-filter-bar-container":"fr-ec-skeleton__featured-filter-bar-container","skeletonFeaturedFilterBarContainer":"fr-ec-skeleton__featured-filter-bar-container","skeleton__featured-filter-bar":"fr-ec-skeleton__featured-filter-bar","skeletonFeaturedFilterBar":"fr-ec-skeleton__featured-filter-bar","skeleton__featured--first-row":"fr-ec-skeleton__featured--first-row","skeletonFeaturedFirstRow":"fr-ec-skeleton__featured--first-row","skeleton__l2-heading":"fr-ec-skeleton__l2-heading","skeletonL2Heading":"fr-ec-skeleton__l2-heading","skeleton__l2-home-slider":"fr-ec-skeleton__l2-home-slider","skeletonL2HomeSlider":"fr-ec-skeleton__l2-home-slider","skeleton__l2-banner":"fr-ec-skeleton__l2-banner","skeletonL2Banner":"fr-ec-skeleton__l2-banner","skeleton__l2-banner--margin":"fr-ec-skeleton__l2-banner--margin","skeletonL2BannerMargin":"fr-ec-skeleton__l2-banner--margin","skeleton__l2-category-heading":"fr-ec-skeleton__l2-category-heading","skeletonL2CategoryHeading":"fr-ec-skeleton__l2-category-heading","skeleton__l2-category-heading--margin":"fr-ec-skeleton__l2-category-heading--margin","skeletonL2CategoryHeadingMargin":"fr-ec-skeleton__l2-category-heading--margin","skeleton__l2-category-wrapper":"fr-ec-skeleton__l2-category-wrapper","skeletonL2CategoryWrapper":"fr-ec-skeleton__l2-category-wrapper","skeleton__l2-category-collection":"fr-ec-skeleton__l2-category-collection","skeletonL2CategoryCollection":"fr-ec-skeleton__l2-category-collection","skeleton__l2-category-collection--margin":"fr-ec-skeleton__l2-category-collection--margin","skeletonL2CategoryCollectionMargin":"fr-ec-skeleton__l2-category-collection--margin","skeleton__l2-category-items":"fr-ec-skeleton__l2-category-items","skeletonL2CategoryItems":"fr-ec-skeleton__l2-category-items","skeleton__l2-category-item1":"fr-ec-skeleton__l2-category-item1","skeletonL2CategoryItem1":"fr-ec-skeleton__l2-category-item1","skeleton__l2-category-item2":"fr-ec-skeleton__l2-category-item2","skeletonL2CategoryItem2":"fr-ec-skeleton__l2-category-item2","skeleton__l2-view-more":"fr-ec-skeleton__l2-view-more","skeletonL2ViewMore":"fr-ec-skeleton__l2-view-more","skeleton__l2-view-more--margin":"fr-ec-skeleton__l2-view-more--margin","skeletonL2ViewMoreMargin":"fr-ec-skeleton__l2-view-more--margin","skeleton__l2-view-more--margin88":"fr-ec-skeleton__l2-view-more--margin88","skeletonL2ViewMoreMargin88":"fr-ec-skeleton__l2-view-more--margin88","skeleton__l2-topics":"fr-ec-skeleton__l2-topics","skeletonL2Topics":"fr-ec-skeleton__l2-topics","skeleton__l2-topics-section-wrapper":"fr-ec-skeleton__l2-topics-section-wrapper","skeletonL2TopicsSectionWrapper":"fr-ec-skeleton__l2-topics-section-wrapper","skeleton__l2-topics-section-wrapper-margin":"fr-ec-skeleton__l2-topics-section-wrapper-margin","skeletonL2TopicsSectionWrapperMargin":"fr-ec-skeleton__l2-topics-section-wrapper-margin","skeleton__l2-topics-collection":"fr-ec-skeleton__l2-topics-collection","skeletonL2TopicsCollection":"fr-ec-skeleton__l2-topics-collection","skeleton__l2-topics-section":"fr-ec-skeleton__l2-topics-section","skeletonL2TopicsSection":"fr-ec-skeleton__l2-topics-section","skeleton__l2-topic1":"fr-ec-skeleton__l2-topic1","skeletonL2Topic1":"fr-ec-skeleton__l2-topic1","skeleton__l2-topics-wrapper":"fr-ec-skeleton__l2-topics-wrapper","skeletonL2TopicsWrapper":"fr-ec-skeleton__l2-topics-wrapper","skeleton__l2-topic2":"fr-ec-skeleton__l2-topic2","skeletonL2Topic2":"fr-ec-skeleton__l2-topic2","skeleton__l2-topic3":"fr-ec-skeleton__l2-topic3","skeletonL2Topic3":"fr-ec-skeleton__l2-topic3","skeleton__l2-topic4":"fr-ec-skeleton__l2-topic4","skeletonL2Topic4":"fr-ec-skeleton__l2-topic4","skeleton__l2-new-arrivals":"fr-ec-skeleton__l2-new-arrivals","skeletonL2NewArrivals":"fr-ec-skeleton__l2-new-arrivals","skeleton__l2-new-arrivals-description":"fr-ec-skeleton__l2-new-arrivals-description","skeletonL2NewArrivalsDescription":"fr-ec-skeleton__l2-new-arrivals-description","skeleton__l2-with-product-collection":"fr-ec-skeleton__l2-with-product-collection","skeletonL2WithProductCollection":"fr-ec-skeleton__l2-with-product-collection","skeleton__l2-with-large-product":"fr-ec-skeleton__l2-with-large-product","skeletonL2WithLargeProduct":"fr-ec-skeleton__l2-with-large-product","skeleton__l2-large-product-item1":"fr-ec-skeleton__l2-large-product-item1","skeletonL2LargeProductItem1":"fr-ec-skeleton__l2-large-product-item1","skeleton__l2-large-product-item2":"fr-ec-skeleton__l2-large-product-item2","skeletonL2LargeProductItem2":"fr-ec-skeleton__l2-large-product-item2","skeleton__l2-large-product-item3":"fr-ec-skeleton__l2-large-product-item3","skeletonL2LargeProductItem3":"fr-ec-skeleton__l2-large-product-item3","skeleton__l2-with-small-product-collection":"fr-ec-skeleton__l2-with-small-product-collection","skeletonL2WithSmallProductCollection":"fr-ec-skeleton__l2-with-small-product-collection","skeleton__l2-small-product1":"fr-ec-skeleton__l2-small-product1","skeletonL2SmallProduct1":"fr-ec-skeleton__l2-small-product1","skeleton__l2-small-product2":"fr-ec-skeleton__l2-small-product2","skeletonL2SmallProduct2":"fr-ec-skeleton__l2-small-product2","skeleton__l2-small-product3":"fr-ec-skeleton__l2-small-product3","skeletonL2SmallProduct3":"fr-ec-skeleton__l2-small-product3","skeleton__l2-new-arrivals-you":"fr-ec-skeleton__l2-new-arrivals-you","skeletonL2NewArrivalsYou":"fr-ec-skeleton__l2-new-arrivals-you","skeleton__l2-new-arrivals-you-wrapper":"fr-ec-skeleton__l2-new-arrivals-you-wrapper","skeletonL2NewArrivalsYouWrapper":"fr-ec-skeleton__l2-new-arrivals-you-wrapper","skeleton__l2-new-arrivals-you-collection":"fr-ec-skeleton__l2-new-arrivals-you-collection","skeletonL2NewArrivalsYouCollection":"fr-ec-skeleton__l2-new-arrivals-you-collection","skeleton__l2-new-arrival-items":"fr-ec-skeleton__l2-new-arrival-items","skeletonL2NewArrivalItems":"fr-ec-skeleton__l2-new-arrival-items","skeleton__l2-new-arrival-item1":"fr-ec-skeleton__l2-new-arrival-item1","skeletonL2NewArrivalItem1":"fr-ec-skeleton__l2-new-arrival-item1","skeleton__l2-new-arrival-item2":"fr-ec-skeleton__l2-new-arrival-item2","skeletonL2NewArrivalItem2":"fr-ec-skeleton__l2-new-arrival-item2","skeleton__l2-new-arrival-item3":"fr-ec-skeleton__l2-new-arrival-item3","skeletonL2NewArrivalItem3":"fr-ec-skeleton__l2-new-arrival-item3","skeleton__l2-styling-wrapper":"fr-ec-skeleton__l2-styling-wrapper","skeletonL2StylingWrapper":"fr-ec-skeleton__l2-styling-wrapper","skeleton__l2-styling-collection":"fr-ec-skeleton__l2-styling-collection","skeletonL2StylingCollection":"fr-ec-skeleton__l2-styling-collection","skeleton__l2-styling-item":"fr-ec-skeleton__l2-styling-item","skeletonL2StylingItem":"fr-ec-skeleton__l2-styling-item","skeleton__l2-life-wear-wrapper":"fr-ec-skeleton__l2-life-wear-wrapper","skeletonL2LifeWearWrapper":"fr-ec-skeleton__l2-life-wear-wrapper","skeleton__l2-life-wear-collection":"fr-ec-skeleton__l2-life-wear-collection","skeletonL2LifeWearCollection":"fr-ec-skeleton__l2-life-wear-collection","skeleton__l2-life-wear-items":"fr-ec-skeleton__l2-life-wear-items","skeletonL2LifeWearItems":"fr-ec-skeleton__l2-life-wear-items","skeleton__l2-life-wear-item1":"fr-ec-skeleton__l2-life-wear-item1","skeletonL2LifeWearItem1":"fr-ec-skeleton__l2-life-wear-item1","skeleton__l2-life-wear-item2":"fr-ec-skeleton__l2-life-wear-item2","skeletonL2LifeWearItem2":"fr-ec-skeleton__l2-life-wear-item2","skeleton__l2-life-wear-item3":"fr-ec-skeleton__l2-life-wear-item3","skeletonL2LifeWearItem3":"fr-ec-skeleton__l2-life-wear-item3","skeleton__l2-search-category1":"fr-ec-skeleton__l2-search-category1","skeletonL2SearchCategory1":"fr-ec-skeleton__l2-search-category1","skeleton__l2-search-category2":"fr-ec-skeleton__l2-search-category2","skeletonL2SearchCategory2":"fr-ec-skeleton__l2-search-category2","skeleton__l2-search-category3":"fr-ec-skeleton__l2-search-category3","skeletonL2SearchCategory3":"fr-ec-skeleton__l2-search-category3","skeleton__l2-home-slider-full-width":"fr-ec-skeleton__l2-home-slider-full-width","skeletonL2HomeSliderFullWidth":"fr-ec-skeleton__l2-home-slider-full-width","skeleton__l2-home-slider-height-112":"fr-ec-skeleton__l2-home-slider-height-112","skeletonL2HomeSliderHeight112":"fr-ec-skeleton__l2-home-slider-height-112","skeleton__l3--full-width":"fr-ec-skeleton__l3--full-width","skeletonL3FullWidth":"fr-ec-skeleton__l3--full-width","skeleton__l4-heading":"fr-ec-skeleton__l4-heading","skeletonL4Heading":"fr-ec-skeleton__l4-heading","skeleton__pdp-container":"fr-ec-skeleton__pdp-container","skeletonPdpContainer":"fr-ec-skeleton__pdp-container","skeleton__pdp-left-container":"fr-ec-skeleton__pdp-left-container","skeletonPdpLeftContainer":"fr-ec-skeleton__pdp-left-container","skeleton__chip-container":"fr-ec-skeleton__chip-container","skeletonChipContainer":"fr-ec-skeleton__chip-container","skeleton__chip":"fr-ec-skeleton__chip","skeletonChip":"fr-ec-skeleton__chip","skeletonCarousel":"fr-ec-skeletonCarousel","skeleton__pdp-right-container":"fr-ec-skeleton__pdp-right-container","skeletonPdpRightContainer":"fr-ec-skeleton__pdp-right-container","skeleton__label-value":"fr-ec-skeleton__label-value","skeletonLabelValue":"fr-ec-skeleton__label-value","skeleton__chip-container--horizontal":"fr-ec-skeleton__chip-container--horizontal","skeletonChipContainerHorizontal":"fr-ec-skeleton__chip-container--horizontal","skeleton__my-size-assist":"fr-ec-skeleton__my-size-assist","skeletonMySizeAssist":"fr-ec-skeleton__my-size-assist","skeleton__label-value--height-32":"fr-ec-skeleton__label-value--height-32","skeletonLabelValueHeight32":"fr-ec-skeleton__label-value--height-32","skeleton__my-size-assist--height-20":"fr-ec-skeleton__my-size-assist--height-20","skeletonMySizeAssistHeight20":"fr-ec-skeleton__my-size-assist--height-20","skeleton__my-size-assist--width-241":"fr-ec-skeleton__my-size-assist--width-241","skeletonMySizeAssistWidth241":"fr-ec-skeleton__my-size-assist--width-241","skeleton__my-size-assist--width-301":"fr-ec-skeleton__my-size-assist--width-301","skeletonMySizeAssistWidth301":"fr-ec-skeleton__my-size-assist--width-301","skeleton__my-size-assist--width-376":"fr-ec-skeleton__my-size-assist--width-376","skeletonMySizeAssistWidth376":"fr-ec-skeleton__my-size-assist--width-376","skeleton__carousel-bottom-content1":"fr-ec-skeleton__carousel-bottom-content1","skeletonCarouselBottomContent1":"fr-ec-skeleton__carousel-bottom-content1","skeleton__carousel-bottom-content2":"fr-ec-skeleton__carousel-bottom-content2","skeletonCarouselBottomContent2":"fr-ec-skeleton__carousel-bottom-content2","skeleton__carousel-bottom-content2--width-496":"fr-ec-skeleton__carousel-bottom-content2--width-496","skeletonCarouselBottomContent2Width496":"fr-ec-skeleton__carousel-bottom-content2--width-496","skeleton__carousel-bottom-content2--width-621":"fr-ec-skeleton__carousel-bottom-content2--width-621","skeletonCarouselBottomContent2Width621":"fr-ec-skeleton__carousel-bottom-content2--width-621","skeleton__styling-container":"fr-ec-skeleton__styling-container","skeletonStylingContainer":"fr-ec-skeleton__styling-container","skeleton__styling-container--margin":"fr-ec-skeleton__styling-container--margin","skeletonStylingContainerMargin":"fr-ec-skeleton__styling-container--margin","skeleton__styling-item":"fr-ec-skeleton__styling-item","skeletonStylingItem":"fr-ec-skeleton__styling-item","skeleton__view-more-styling":"fr-ec-skeleton__view-more-styling","skeletonViewMoreStyling":"fr-ec-skeleton__view-more-styling","skeleton__user-info-wrapper":"fr-ec-skeleton__user-info-wrapper","skeletonUserInfoWrapper":"fr-ec-skeleton__user-info-wrapper","skeleton__user-info-profile":"fr-ec-skeleton__user-info-profile","skeletonUserInfoProfile":"fr-ec-skeleton__user-info-profile","skeleton__user-info-profile-info":"fr-ec-skeleton__user-info-profile-info","skeletonUserInfoProfileInfo":"fr-ec-skeleton__user-info-profile-info","skeleton__l4-banner":"fr-ec-skeleton__l4-banner","skeletonL4Banner":"fr-ec-skeleton__l4-banner","skeleton__container-125":"fr-ec-skeleton__container-125","skeletonContainer125":"fr-ec-skeleton__container-125","skeleton__tab-bottom":"fr-ec-skeleton__tab-bottom","skeletonTabBottom":"fr-ec-skeleton__tab-bottom","skeleton__product-collection-wrapper_fixed_height":"fr-ec-skeleton__product-collection-wrapper_fixed_height","skeletonProductCollectionWrapperFixedHeight":"fr-ec-skeleton__product-collection-wrapper_fixed_height","skeleton__product-collection_fixed_height":"fr-ec-skeleton__product-collection_fixed_height","skeletonProductCollectionFixedHeight":"fr-ec-skeleton__product-collection_fixed_height","skeleton__product_fixed_height":"fr-ec-skeleton__product_fixed_height","skeletonProductFixedHeight":"fr-ec-skeleton__product_fixed_height","skeleton__product_fixed_height-image":"fr-ec-skeleton__product_fixed_height-image","skeletonProductFixedHeightImage":"fr-ec-skeleton__product_fixed_height-image","skeleton__product_fixed_height-text-wrapper":"fr-ec-skeleton__product_fixed_height-text-wrapper","skeletonProductFixedHeightTextWrapper":"fr-ec-skeleton__product_fixed_height-text-wrapper","skeleton__product_fixed_height-chip":"fr-ec-skeleton__product_fixed_height-chip","skeletonProductFixedHeightChip":"fr-ec-skeleton__product_fixed_height-chip","skeleton__product_fixed_height-item1":"fr-ec-skeleton__product_fixed_height-item1","skeletonProductFixedHeightItem1":"fr-ec-skeleton__product_fixed_height-item1","skeleton__product_fixed_height-item2":"fr-ec-skeleton__product_fixed_height-item2","skeletonProductFixedHeightItem2":"fr-ec-skeleton__product_fixed_height-item2","skeleton__product_fixed_height-item3":"fr-ec-skeleton__product_fixed_height-item3","skeletonProductFixedHeightItem3":"fr-ec-skeleton__product_fixed_height-item3","skeleton__product_fixed_height-mobile-only":"fr-ec-skeleton__product_fixed_height-mobile-only","skeletonProductFixedHeightMobileOnly":"fr-ec-skeleton__product_fixed_height-mobile-only","skeleton__fixed-height-cms-styling-item":"fr-ec-skeleton__fixed-height-cms-styling-item","skeletonFixedHeightCmsStylingItem":"fr-ec-skeleton__fixed-height-cms-styling-item","skeleton__fixed-height-cms-styling-indicator":"fr-ec-skeleton__fixed-height-cms-styling-indicator","skeletonFixedHeightCmsStylingIndicator":"fr-ec-skeleton__fixed-height-cms-styling-indicator","skeleton__navigation-wrapper":"fr-ec-skeleton__navigation-wrapper","skeletonNavigationWrapper":"fr-ec-skeleton__navigation-wrapper","skeleton__navigation-class-list":"fr-ec-skeleton__navigation-class-list","skeletonNavigationClassList":"fr-ec-skeleton__navigation-class-list","skeleton__navigation-class-list-item":"fr-ec-skeleton__navigation-class-list-item","skeletonNavigationClassListItem":"fr-ec-skeleton__navigation-class-list-item","skeleton__navigation-class-list-item-media":"fr-ec-skeleton__navigation-class-list-item-media","skeletonNavigationClassListItemMedia":"fr-ec-skeleton__navigation-class-list-item-media","skeleton__navigation-class-list-item-text":"fr-ec-skeleton__navigation-class-list-item-text","skeletonNavigationClassListItemText":"fr-ec-skeleton__navigation-class-list-item-text","skeleton__navigation-products":"fr-ec-skeleton__navigation-products","skeletonNavigationProducts":"fr-ec-skeleton__navigation-products","skeleton__navigation-product-heading":"fr-ec-skeleton__navigation-product-heading","skeletonNavigationProductHeading":"fr-ec-skeleton__navigation-product-heading","skeleton__navigation-product-banner-heading":"fr-ec-skeleton__navigation-product-banner-heading","skeletonNavigationProductBannerHeading":"fr-ec-skeleton__navigation-product-banner-heading","skeleton__navigation-product-banner":"fr-ec-skeleton__navigation-product-banner","skeletonNavigationProductBanner":"fr-ec-skeleton__navigation-product-banner","skeleton__navigation-product":"fr-ec-skeleton__navigation-product","skeletonNavigationProduct":"fr-ec-skeleton__navigation-product","skeleton__navigation-product-media":"fr-ec-skeleton__navigation-product-media","skeletonNavigationProductMedia":"fr-ec-skeleton__navigation-product-media","skeleton__navigation-product-title":"fr-ec-skeleton__navigation-product-title","skeletonNavigationProductTitle":"fr-ec-skeleton__navigation-product-title","skeleton__navigation-product-sub-title":"fr-ec-skeleton__navigation-product-sub-title","skeletonNavigationProductSubTitle":"fr-ec-skeleton__navigation-product-sub-title","skeleton__navigation-product-description":"fr-ec-skeleton__navigation-product-description","skeletonNavigationProductDescription":"fr-ec-skeleton__navigation-product-description","skeleton--navigation":"fr-ec-skeleton--navigation","skeletonNavigation":"fr-ec-skeleton--navigation"};

var Skeleton = function Skeleton(_a) {
  var className = _a.className,
      variant = _a.variant,
      _b = _a.productCollectionCount,
      productCollectionCount = _b === void 0 ? 6 : _b;

  if (variant === 'L2.5-lineup') {
    var productCollection = function productCollection(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonProduct,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonProductItem1, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonTextWrapper
        }, /*#__PURE__*/createElement(CmsContentVisibility, {
          mobileVisibility: true,
          tabletVisibility: false,
          pcVisibility: false
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonProductItemMobileOnly, styles$G$1.skeletonPulse)
        })), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonProductItem2, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonProductItem3, styles$G$1.skeletonPulse)
        })));
      });
    };

    return /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeleton
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonBreadcrumb, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonHeading, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonBanner, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonProductCollectionWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonProductCollection
    }, productCollection(9))), /*#__PURE__*/createElement("div", null));
  } else if (variant === 'L2.5-featured') {
    var featuredProductCollection = function featuredProductCollection(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonFeaturedProduct,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonFeaturedProductItem1, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonFeaturedTextWrapper
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonFeaturedProductItem2, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonFeaturedProductItem3, styles$G$1.skeletonPulse)
        })));
      });
    };

    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeleton, className)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonBreadcrumb, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonFeaturedHeading, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonSubText, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonSubText1, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonSubText2, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonTab, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonProductCollectionHeading, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonFeaturedWrapper
    }, /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: true,
      tabletVisibility: false,
      pcVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonFeaturedProductCollection, styles$G$1.skeletonFeaturedFirstRow)
    }, featuredProductCollection(3))), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: true,
      pcVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonFeaturedProductCollection, styles$G$1.skeletonFeaturedFirstRow)
    }, featuredProductCollection(4))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonTab, styles$G$1.skeletonTabMargin, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonFeaturedFilterBarContainer)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonFeaturedFilterBar, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonFeaturedFilterBar, styles$G$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonFeaturedProductCollection
    }, featuredProductCollection(16))));
  } else if (variant === 'L2') {
    var skeletonL2Category = function skeletonL2Category(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonL2CategoryItems,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2CategoryItem1, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2CategoryItem2, styles$G$1.skeletonPulse)
        }));
      });
    };

    var skeletonL2Topics = function skeletonL2Topics(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonL2TopicsSection,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2Topic1, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonL2TopicsWrapper
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2Topic2, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2Topic3, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2Topic4, styles$G$1.skeletonPulse)
        })));
      });
    };

    var skeletonL2WithSmallProducts = function skeletonL2WithSmallProducts(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2SmallProduct1, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2SmallProduct2, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2SmallProduct3, styles$G$1.skeletonPulse)
        })));
      });
    };

    var skeletonL2NewArrivals = function skeletonL2NewArrivals(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonL2NewArrivalItems,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2NewArrivalItem1, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2NewArrivalItem2, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2NewArrivalItem3, styles$G$1.skeletonPulse)
        }));
      });
    };

    var skeletonL2Styling = function skeletonL2Styling(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2StylingItem, styles$G$1.skeletonPulse),
          key: index
        });
      });
    };

    var skeletonL2LifeWear = function skeletonL2LifeWear(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonL2LifeWearItems,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2LifeWearItem1, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2LifeWearItem2, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2LifeWearItem3, styles$G$1.skeletonPulse)
        }));
      });
    };

    var width = getViewportWidth();
    var skeletonL2NewArrival = width < designTokens_3.mqMediumScreenMinWidthLimit ? skeletonL2NewArrivals(3) : skeletonL2NewArrivals(4);
    var skeletonL2Categorys = width < designTokens_3.mqMediumScreenMinWidthLimit ? skeletonL2Category(3) : skeletonL2Category(4);
    var skeletonL2Stylings = width < designTokens_3.mqMediumScreenMinWidthLimit ? skeletonL2Styling(3) : skeletonL2Styling(4);
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeleton, className)
    }, /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: true,
      pcVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonFeaturedHeading, styles$G$1.skeletonL2Heading, styles$G$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2HomeSlider, styles$G$1.skeletonL2HomeSliderFullWidth, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2Banner, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2CategoryHeading, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2CategoryWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2CategoryCollection
    }, skeletonL2Category(12))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2ViewMore, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2Topics, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2TopicsSectionWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2TopicsCollection
    }, skeletonL2Topics(3))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivals, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivalsDescription, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2WithProductCollection
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2WithLargeProduct
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2LargeProductItem1, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2LargeProductItem2, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2LargeProductItem3, styles$G$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2WithSmallProductCollection
    }, skeletonL2WithSmallProducts(6))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivalsYou, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2NewArrivalsYouWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2ViewMore, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2Banner, styles$G$1.skeletonL2BannerMargin, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivalsYou, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2NewArrivalsYouWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2ViewMore, styles$G$1.skeletonL2ViewMoreMargin, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivals, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivalsDescription, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2WithProductCollection
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2WithLargeProduct
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2LargeProductItem1, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2LargeProductItem2, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2LargeProductItem3, styles$G$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2WithSmallProductCollection
    }, skeletonL2WithSmallProducts(6))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2CategoryHeading, styles$G$1.skeletonL2CategoryHeadingMargin, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2CategoryWrapper
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2CategoryCollection, styles$G$1.skeletonL2CategoryCollectionMargin)
    }, skeletonL2Categorys)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2ViewMore, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2Banner, styles$G$1.skeletonL2BannerMargin, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivalsYou, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2NewArrivalsYouWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2ViewMore, styles$G$1.skeletonL2ViewMoreMargin, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivals, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivalsDescription, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2WithProductCollection
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2WithLargeProduct
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2LargeProductItem1, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2LargeProductItem2, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2LargeProductItem3, styles$G$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2WithSmallProductCollection
    }, skeletonL2WithSmallProducts(6))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivalsYou, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2NewArrivalsYouWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2ViewMore, styles$G$1.skeletonL2ViewMoreMargin, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivals, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivalsDescription, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2WithProductCollection
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2WithLargeProduct
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2LargeProductItem1, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2LargeProductItem2, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2LargeProductItem3, styles$G$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2WithSmallProductCollection
    }, skeletonL2WithSmallProducts(6))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivalsYou, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2NewArrivalsYouWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2ViewMore, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2Banner, styles$G$1.skeletonL2BannerMargin, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2Topics, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2TopicsSectionWrapper, styles$G$1.skeletonL2TopicsSectionWrapperMargin)
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2TopicsCollection
    }, skeletonL2Topics(3))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2ViewMore, styles$G$1.skeletonL2ViewMoreMargin, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivals, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivalsDescription, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2WithProductCollection
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2WithLargeProduct
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2LargeProductItem1, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2LargeProductItem2, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2LargeProductItem3, styles$G$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2WithSmallProductCollection
    }, skeletonL2WithSmallProducts(6))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivalsYou, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2NewArrivalsYouWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2ViewMore, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2Banner, styles$G$1.skeletonL2BannerMargin, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivalsYou, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2NewArrivalsYouWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2ViewMore, styles$G$1.skeletonL2ViewMoreMargin, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2Topics, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2HomeSlider, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2ViewMore, styles$G$1.skeletonL2ViewMoreMargin, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2Topics, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2HomeSlider, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2ViewMore, styles$G$1.skeletonL2ViewMoreMargin, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2Topics, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2StylingWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2StylingCollection
    }, skeletonL2Stylings)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2ViewMore, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2Banner, styles$G$1.skeletonL2BannerMargin, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2Topics, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: true,
      pcVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2LifeWearWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2LifeWearCollection
    }, skeletonL2LifeWear(3)))), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: true,
      tabletVisibility: false,
      pcVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2TopicsSectionWrapper, styles$G$1.skeletonL2TopicsSectionWrapperMargin)
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2TopicsCollection
    }, skeletonL2Topics(3)))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2ViewMore, styles$G$1.skeletonL2ViewMoreMargin, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2Topics, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: true,
      pcVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2LifeWearWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2LifeWearCollection
    }, skeletonL2LifeWear(3)))), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: true,
      tabletVisibility: false,
      pcVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2TopicsSectionWrapper, styles$G$1.skeletonL2TopicsSectionWrapperMargin)
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2TopicsCollection
    }, skeletonL2Topics(3)))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2ViewMore, styles$G$1.skeletonL2ViewMoreMargin, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2Topics, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2TopicsSectionWrapper, styles$G$1.skeletonL2TopicsSectionWrapperMargin)
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2TopicsCollection
    }, skeletonL2Topics(3))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2ViewMore, styles$G$1.skeletonL2ViewMoreMargin, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2Topics, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2SearchCategory1, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2SearchCategory2, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2SearchCategory3, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2Topics, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2HomeSlider, styles$G$1.skeletonL2HomeSliderHeight112, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2ViewMore, styles$G$1.skeletonL2ViewMoreMargin88, styles$G$1.skeletonPulse)
    }));
  } else if (variant === 'L3') {
    var featuredProductCollection = function featuredProductCollection(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonFeaturedProduct,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonFeaturedProductItem1, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonFeaturedTextWrapper
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonFeaturedProductItem2, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonFeaturedProductItem3, styles$G$1.skeletonPulse, spacingStyles.mbSpacing06)
        })));
      });
    };

    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeleton, className)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonBreadcrumb, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonHeading, styles$G$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL3FullWidth, styles$G$1.skeletonPulse, spacingStyles.mbSpacing02)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL3FullWidth, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonFeaturedFilterBarContainer)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonFeaturedFilterBar, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonFeaturedFilterBar, styles$G$1.skeletonPulse)
    })), /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonFeaturedProductCollection
    }, featuredProductCollection(16)));
  } else if (variant === 'L4') {
    var getChips = function getChips(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index,
          className: joinClasses(styles$G$1.skeletonChip, styles$G$1.skeletonPulse)
        });
      });
    };

    var width = getViewportWidth();

    var skeletonL2NewArrivals = function skeletonL2NewArrivals(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonL2NewArrivalItems,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2NewArrivalItem1, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2NewArrivalItem2, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonL2NewArrivalItem3, styles$G$1.skeletonPulse)
        }));
      });
    };

    var skeletonL2NewArrival = width < designTokens_3.mqMediumScreenMinWidthLimit ? skeletonL2NewArrivals(3) : skeletonL2NewArrivals(4);

    var getStylingItem = function getStylingItem(times, userInfo) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonStylingItem, styles$G$1.skeletonPulse)
        }), userInfo ? /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonUserInfoWrapper)
        }, /*#__PURE__*/createElement(CmsContentVisibility, {
          mobileVisibility: false,
          tabletVisibility: true,
          pcVisibility: true
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonUserInfoProfile, styles$G$1.skeletonPulse)
        })), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonUserInfoProfileInfo, styles$G$1.skeletonPulse)
        })) : null);
      });
    };

    var carouselRightContent = /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonPdpRightContainer)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonLabelValue, styles$G$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonChipContainer, styles$G$1.skeletonChipContainerHorizontal, spacingStyles.mbSpacing05)
    }, getChips(6)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonLabelValue, styles$G$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonChipContainer, styles$G$1.skeletonChipContainerHorizontal, spacingStyles.mbSpacing05)
    }, getChips(6)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonLabelValue, styles$G$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonChipContainer, styles$G$1.skeletonChipContainerHorizontal, spacingStyles.mbSpacing05)
    }, getChips(6)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonMySizeAssist, styles$G$1.skeletonPulse, spacingStyles.mbSpacing05)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonLabelValue, styles$G$1.skeletonLabelValueHeight32, styles$G$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonMySizeAssist, styles$G$1.skeletonMySizeAssistHeight20, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonMySizeAssist, styles$G$1.skeletonMySizeAssistWidth241, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonMySizeAssist, styles$G$1.skeletonMySizeAssistWidth301, styles$G$1.skeletonPulse, spacingStyles.mbSpacing06)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonMySizeAssist, styles$G$1.skeletonMySizeAssistWidth376, styles$G$1.skeletonPulse, spacingStyles.mbSpacing07)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonLabelValue, styles$G$1.skeletonLabelValueHeight32, styles$G$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonMySizeAssist, styles$G$1.skeletonMySizeAssistHeight20, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonMySizeAssist, styles$G$1.skeletonMySizeAssistWidth241, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonMySizeAssist, styles$G$1.skeletonMySizeAssistWidth301, styles$G$1.skeletonPulse)
    }));
    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeleton, className)
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonBreadcrumb, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonHeading, styles$G$1.skeletonPulse, styles$G$1.skeletonL4Heading, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonSubText, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonSubText1, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonSubText2, styles$G$1.skeletonPulse, spacingStyles.mbSpacing02)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonPdpContainer)
    }, /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonPdpLeftContainer)
    }, /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: true,
      pcVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonChipContainer)
    }, getChips(6))), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonCarousel, styles$G$1.skeletonPulse)
    })), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: true,
      tabletVisibility: true,
      pcVisibility: false
    }, carouselRightContent), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: true,
      tabletVisibility: true,
      pcVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonContainer125, styles$G$1.skeletonPulse, spacingStyles.mbSpacing07, spacingStyles.mtSpacing07)
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonCarouselBottomContent1, styles$G$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonCarouselBottomContent2, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonCarouselBottomContent2, styles$G$1.skeletonCarouselBottomContent2Width496, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonCarouselBottomContent2, styles$G$1.skeletonCarouselBottomContent2Width621, styles$G$1.skeletonPulse, spacingStyles.mbSpacing07)
    }), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: true,
      tabletVisibility: false,
      pcVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonCarouselBottomContent1, styles$G$1.skeletonPulse, spacingStyles.mbSpacing04)
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonStylingContainer, styles$G$1.skeletonStylingContainerMargin)
    }, getStylingItem(3, false)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonViewMoreStyling, styles$G$1.skeletonPulse, spacingStyles.mbSpacing07)
    }), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: true,
      tabletVisibility: false,
      pcVisibility: false
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonCarouselBottomContent1, styles$G$1.skeletonPulse, spacingStyles.mbSpacing04)
    })), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonStylingContainer, styles$G$1.skeletonStylingContainerMargin)
    }, getStylingItem(3, true)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonViewMoreStyling, styles$G$1.skeletonPulse, spacingStyles.mbSpacing07)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonCarouselBottomContent1, styles$G$1.skeletonPulse, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonCarouselBottomContent2, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonCarouselBottomContent2, styles$G$1.skeletonCarouselBottomContent2Width496, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonCarouselBottomContent2, styles$G$1.skeletonCarouselBottomContent2Width621, styles$G$1.skeletonPulse, spacingStyles.mbSpacing06)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonViewMoreStyling, styles$G$1.skeletonPulse, spacingStyles.mbSpacing07)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonHeading, styles$G$1.skeletonPulse, styles$G$1.skeletonL4Heading, spacingStyles.mbSpacing04)
    })), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: false,
      pcVisibility: true
    }, carouselRightContent)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivalsYouWrapper, spacingStyles.mbSpacing07)
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonHeading, styles$G$1.skeletonPulse, styles$G$1.skeletonL4Heading, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivalsYouWrapper, spacingStyles.mbSpacing07)
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonHeading, styles$G$1.skeletonPulse, styles$G$1.skeletonL4Heading, spacingStyles.mbSpacing04)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL2NewArrivalsYouWrapper, spacingStyles.mbSpacing07)
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2NewArrivalsYouCollection
    }, skeletonL2NewArrival)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonL4Banner, styles$G$1.skeletonPulse, spacingStyles.mbSpacing08)
    }));
  } else if (variant === 'Spl') {
    var width = getViewportWidth();

    var productCollectionParent = function productCollectionParent(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonBanner, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonProductCollectionWrapper
        }, /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonProductCollection
        }, productCollection_1(6))));
      });
    };

    var productCollection_1 = function productCollection_1(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonProduct,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonProductItem1, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonTextWrapper
        }, /*#__PURE__*/createElement(CmsContentVisibility, {
          mobileVisibility: true,
          tabletVisibility: false,
          pcVisibility: false
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonProductItemMobileOnly, styles$G$1.skeletonPulse)
        })), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonProductItem2, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonProductItem3, styles$G$1.skeletonPulse)
        })));
      });
    };

    return /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeleton
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonBreadcrumb, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonHeading, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonTab, styles$G$1.skeletonPulse)
    }), width < designTokens_3.mqMediumScreenMinWidthLimit ? /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonTabBottom, styles$G$1.skeletonPulse)
    }) : '', productCollectionParent(3), /*#__PURE__*/createElement("div", null));
  } else if (variant === 'fixed-height-product-collection') {
    var productCollection = function productCollection(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonProductFixedHeight,
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonProductFixedHeightImage, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonProductFixedHeightTextWrapper
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonProductFixedHeightChip, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonProductFixedHeightItem1, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement(CmsContentVisibility, {
          mobileVisibility: true,
          tabletVisibility: false,
          pcVisibility: false
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonProductFixedHeightMobileOnly, styles$G$1.skeletonPulse)
        })), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonProductFixedHeightItem2, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonProductFixedHeightItem3, styles$G$1.skeletonPulse)
        })));
      });
    };

    return /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeleton
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonProductCollectionWrapperFixedHeight
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonProductCollectionFixedHeight
    }, productCollection(productCollectionCount || 6))), /*#__PURE__*/createElement("div", null));
  } else if (variant === 'fixed-height-cms-styling') {
    var width = getViewportWidth();

    var skeletonL2Styling = function skeletonL2Styling(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonFixedHeightCmsStylingItem, styles$G$1.skeletonPulse),
          key: index
        });
      });
    };

    var skeletonL2Stylings = width < designTokens_3.mqMediumScreenMinWidthLimit ? skeletonL2Styling(3) : skeletonL2Styling(4);
    return /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeleton
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2StylingWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonL2StylingCollection
    }, skeletonL2Stylings), /*#__PURE__*/createElement(CmsContentVisibility, {
      mobileVisibility: false,
      tabletVisibility: true,
      pcVisibility: true
    }, /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonFixedHeightCmsStylingIndicator, styles$G$1.skeletonPulse)
    }))));
  } else if (variant === 'navigation') {
    var width = getViewportWidth();

    var skeletonClassListItem = function skeletonClassListItem(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonNavigationClassListItem),
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonNavigationClassListItemMedia, styles$G$1.skeletonPulse, spacingStyles.mbSpacing02)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonNavigationClassListItemText, styles$G$1.skeletonPulse)
        }));
      });
    };

    var skeletonNavigationProduct = function skeletonNavigationProduct(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonNavigationProduct),
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonNavigationProductMedia, styles$G$1.skeletonPulse, spacingStyles.mbSpacing01)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonNavigationProductTitle, styles$G$1.skeletonPulse, spacingStyles.mbSpacing01)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonNavigationProductSubTitle, styles$G$1.skeletonPulse, spacingStyles.mbSpacing01)
        }), /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonNavigationProductDescription, styles$G$1.skeletonPulse)
        }));
      });
    };

    var skeletonClassListItems = skeletonClassListItem(16);
    var skeletonNavigationProducts_1 = width <= designTokens_3.mqMediumScreenMaxWidthLimit ? width < designTokens_3.mqMediumScreenMinWidthLimit ? skeletonNavigationProduct(3) : skeletonNavigationProduct(4) : skeletonNavigationProduct(5);

    var skeletonNavigationProductsSection = function skeletonNavigationProductsSection(times) {
      return count(times).map(function (_, index) {
        return /*#__PURE__*/createElement(Fragment, {
          key: index
        }, /*#__PURE__*/createElement("div", {
          className: joinClasses(styles$G$1.skeletonNavigationProductHeading, styles$G$1.skeletonPulse)
        }), /*#__PURE__*/createElement("div", {
          className: styles$G$1.skeletonNavigationProducts
        }, skeletonNavigationProducts_1));
      });
    };

    return /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeleton, styles$G$1.skeletonNavigation)
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonNavigationWrapper
    }, /*#__PURE__*/createElement("div", {
      className: styles$G$1.skeletonNavigationClassList
    }, skeletonClassListItems), /*#__PURE__*/createElement(Fragment, null, skeletonNavigationProductsSection(4)), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonNavigationProductHeading, styles$G$1.skeletonNavigationProductBannerHeading, styles$G$1.skeletonPulse)
    }), /*#__PURE__*/createElement("div", {
      className: joinClasses(styles$G$1.skeletonNavigationProductBanner, styles$G$1.skeletonPulse)
    })));
  }

  return null;
};
Skeleton.displayName = 'CoreSkeleton';

var styles$I$1 = {"image-plus-text-collection":"fr-ec-image-plus-text-collection","imagePlusTextCollection":"fr-ec-image-plus-text-collection","image-plus-text-collection__wrapper":"fr-ec-image-plus-text-collection__wrapper","imagePlusTextCollectionWrapper":"fr-ec-image-plus-text-collection__wrapper","image-plus-text-collection__children":"fr-ec-image-plus-text-collection__children","imagePlusTextCollectionChildren":"fr-ec-image-plus-text-collection__children"};

var ImagePlusTextCollection = function ImagePlusTextCollection(_a) {
  var children = _a.children,
      className = _a.className,
      props = __rest(_a, ["children", "className"]);

  var _b = useState(false),
      isDesktopView = _b[0],
      setDesktopView = _b[1];

  var onResize = function onResize() {
    if (isInBrowser$1()) {
      var breakpoint = getCurrentMediaQueryBreakpoint();
      var isDesktop = breakpoint === 'lg';
      setDesktopView(isDesktop);
    }
  };

  var getContent = function getContent() {
    if (isDesktopView) {
      return /*#__PURE__*/createElement("div", __assign({
        className: joinClasses(className, styles$I$1.imagePlusTextCollectionChildren)
      }, props), children);
    } else {
      return /*#__PURE__*/createElement("div", null, /*#__PURE__*/createElement(Carousel, {
        hasArrows: false,
        variant: "image-plus-text",
        displayCount: {
          lg: 4.8,
          md: 4.8,
          sm: 2.35
        },
        noPadding: true
      }, children));
    }
  };

  return /*#__PURE__*/createElement(Measure, {
    onResize: debounce(100, onResize)
  }, function (_a) {
    var measureRef = _a.measureRef;
    return /*#__PURE__*/createElement("div", __assign({
      className: joinClasses(className, styles$I$1.imagePlusTextCollection)
    }, props, {
      ref: measureRef
    }), getContent());
  });
};
ImagePlusTextCollection.displayName = 'CoreImagePlusTextCollection';

var styles$J$1 = {"floating-ticker":"fr-ec-floating-ticker","floatingTicker":"fr-ec-floating-ticker","ticker__body":"fr-ec-ticker__body","tickerBody":"fr-ec-ticker__body","label":"fr-ec-label","caption":"fr-ec-caption","ticker__button":"fr-ec-ticker__button","tickerButton":"fr-ec-ticker__button"};

var getText$1$1 = function getText(text) {
  return text === null || text === void 0 ? void 0 : text.replace(/\\n|\n/g, '\n');
};

var FloatingTicker = function FloatingTicker(_a) {
  var message = _a.message,
      enableClose = _a.enableClose,
      linkUrl = _a.linkUrl,
      linkTarget = _a.linkTarget,
      onClose = _a.onClose,
      _b = _a.gaCategory,
      gaCategory = _b === void 0 ? '' : _b,
      _c = _a.gaLabel,
      gaLabel = _c === void 0 ? '' : _c,
      gaAction = _a.gaAction,
      gaValue = _a.gaValue,
      gaCallback = _a.gaCallback,
      className = _a.className,
      iconBrand = _a.iconBrand,
      props = __rest(_a, ["message", "enableClose", "linkUrl", "linkTarget", "onClose", "gaCategory", "gaLabel", "gaAction", "gaValue", "gaCallback", "className", "iconBrand"]);

  var _d = useState(true),
      isVisible = _d[0],
      setVisible = _d[1];

  var onTickerDismiss = function onTickerDismiss() {
    setVisible(false);

    if (onClose) {
      onClose();
    }
  };

  var rootTag = 'a';
  var absoluteUrlPattern = linkUrl && isAbsoluteUrl(linkUrl);
  var attributes = {};

  if (absoluteUrlPattern) {
    attributes = {
      href: linkUrl,
      target: linkTarget || '_blank'
    };
  } else if (linkUrl) {
    rootTag = Link$1; // Default target behaviour of Link is similar to that of '_self'.
    // But if you specify target property explicitly, it refreshes the page.
    // @ts-ignore

    attributes.to = linkUrl;

    if (linkTarget && linkTarget !== '_self') {
      // @ts-ignore
      attributes.target = linkTarget;
    }
  }

  return isVisible ? /*#__PURE__*/createElement(Ticker, __assign({
    variant: "secondary",
    closeButton: enableClose,
    className: joinClasses(className, styles$J$1.floatingTicker),
    onDismiss: onTickerDismiss,
    gaLabel: gaLabel,
    gaCategory: gaCategory,
    gaAction: gaAction,
    gaValue: gaValue,
    gaCallback: gaCallback,
    iconBrand: iconBrand
  }, props), linkUrl ? /*#__PURE__*/createElement(LinkText, __assign({
    element: rootTag,
    variant: "standalone-small",
    iconBrand: iconBrand
  }, attributes), getText$1$1(message)) : /*#__PURE__*/createElement(Body, {
    element: "span",
    key: "child-label",
    variant: "small"
  }, getText$1$1(message))) : null;
};
FloatingTicker.displayName = 'CoreFloatingTicker';
FloatingTicker.defaultProps = {
  gaAction: 'click',
  gaCallback: function gaCallback() {
    return null;
  },
  gaCategory: '',
  gaLabel: '',
  gaValue: null
};

var styles$K$1 = {"heading-gap":"fr-ec-heading-gap","headingGap":"fr-ec-heading-gap","heading-link-text--wrap":"fr-ec-heading-link-text--wrap","headingLinkTextWrap":"fr-ec-heading-link-text--wrap"};

var Heading = function Heading(_a) {
  var title = _a.title,
      _b = _a.type,
      type = _b === void 0 ? 'display1' : _b,
      linkText = _a.linkText,
      url = _a.url,
      target = _a.target,
      _c = _a.htmlTag,
      htmlTag = _c === void 0 ? 'h1' : _c,
      gaLabel = _a.gaLabel,
      gaCategory = _a.gaCategory,
      className = _a.className,
      props = __rest(_a, ["title", "type", "linkText", "url", "target", "htmlTag", "id", "gaLabel", "gaCategory", "className"]);

  var gaProps = null;

  if (gaCategory && gaLabel) {
    gaProps = {
      'data-category': gaCategory,
      'data-label': gaLabel
    };
  }

  return /*#__PURE__*/createElement("header", __assign({
    className: joinClasses(className, spacingStyles.mbSpacing04)
  }, props), /*#__PURE__*/createElement(ContentAlignment, {
    direction: "row",
    element: "div",
    justifyContent: "space-between",
    alignment: "center",
    className: styles$K$1.headingGap
  }, /*#__PURE__*/createElement(Display, __assign({
    element: htmlTag === 'none' ? 'div' : htmlTag,
    variant: type
  }, gaProps), title), linkText && /*#__PURE__*/createElement("div", {
    className: styles$K$1.headingLinkTextWrap
  }, /*#__PURE__*/createElement(LinkText, {
    element: "a",
    href: url,
    target: target
  }, linkText))));
};
Heading.displayName = 'CoreHeading';

export { Keyline as $, ActionableContent as A, Badge as B, Caption as C, DeviceType as D, Dropdown as E, ExpandUtility as F, FlagText as G, CmsFloatingTicker as H, Flyout as I, FlyoutNavigation as J, FlyoutSelect as K, Footer as L, FormRow as M, FormRowGroup as N, Graph as O, Grid as P, HeaderOverlay as Q, HeaderPage as R, HeaderSection as S, HintError as T, HintText as U, Icon as V, IconTypography as W, Image as X, ImageEnhancements as Y, ImageOverlay as Z, ImageTypography as _, DeviceTypeContext as a, Accordion as a$, Label as a0, LabelInput as a1, Layout as a2, LayoutWrapper as a3, LinkCell as a4, LinkImage as a5, LinkImageGroup as a6, LinkNavigation as a7, LinkNavigationGroup as a8, LinkPrimaryNav as a9, ShowMore as aA, Spacer as aB, Stepper as aC, StepperGroup as aD, Tab as aE, TabGroup as aF, Table as aG, Tag as aH, TemplateFixedPanel as aI, TemplateInformation as aJ, TextArea as aK, TextField as aL, Tile as aM, Title as aN, Toast as aO, Tooltip as aP, Typeahead as aQ, CmsVerticalScroll as aR, VideoInline as aS, GenderTabs as aT, StylingGrid as aU, StickyContainer as aV, GutterContainer as aW, UtilityBar as aX, ProductTile as aY, FilterLayout as aZ, TemplateILP as a_, LinkRegion as aa, LinkText as ab, LinkTextGroup as ac, List as ad, StyleUserInfo as ae, LoadingIndicator as af, MediaBanner as ag, MediaObject as ah, Modal as ai, NavigationHeader as aj, NavigationRibbon as ak, NoImage as al, OverlayBackdrop as am, OverlayBody as an, PinnedContainer as ao, Price as ap, QueryText as aq, Radio as ar, RadioGroup as as, RatingStatic as at, Review as au, ScaleInput as av, Search as aw, Selector as ax, SelectorGroup as ay, Sheet as az, BadgeRanking as b, ProductTable as b$, TagFilter as b0, TagFilterGroup as b1, RatingInput as b2, ScaleStatic as b3, ScaleStaticItem as b4, TemplatePDP as b5, MediaGallery as b6, CmsSpacer as b7, CmsLinkText as b8, CmsLink as b9, CmsAnnotation as bA, CmsAccordionGroup as bB, CmsNavigationHeaderFlyout as bC, CmsGenderLinksContainer as bD, CmsFloatingTickers as bE, CmsHorizontalRule as bF, CmsAnchor as bG, CmsUserReview as bH, CmsTappableItem as bI, CmsTappableGrid as bJ, CmsHeading as bK, CmsSnsButton as bL, CmsSnsButtons as bM, CmsList as bN, ItemTag as bO, ItemTags as bP, CmsContentVisibility as bQ, CmsText as bR, FileInput as bS, CmsSmartBanner as bT, CmsBannerCollection as bU, SearchHistoryItem as bV, FixedPanel as bW, CmsQuoteReview as bX, CmsQuoteReviewGroup as bY, BalloonTip as bZ, BalloonTipContainer as b_, CmsFooterLinkItem as ba, CmsFooterLinkGroup as bb, CmsFooter as bc, CmsImagePlusText as bd, CmsImagePlusTextCollection as be, TemplateFullGutter as bf, TemplateMediaInformation as bg, CmsCategoryImage as bh, CmsCategoryImageContainer as bi, CmsImage as bj, CmsVideoInline as bk, ProductCollection as bl, CmsLinkButton as bm, CmsLinkButtonContainer as bn, CmsAccordionListItem as bo, CmsAccordionList as bp, CmsAccordion as bq, CmsTab as br, CmsTabs as bs, CmsMediaBanner as bt, CmsTransitionButton as bu, CmsTicker as bv, CmsContentsCard as bw, CmsBreadcrumb as bx, CmsBreadcrumbs as by, CmsMediaCarousel as bz, BadgeText as c, ComparisonTable as c0, ImagePlusProductText as c1, ButtonToggleGroup as c2, TypeaheadGroup as c3, CmsSelectedStore as c4, DataTableCell as c5, DataTableRow as c6, DataTableBody as c7, DataTable as c8, Skeleton as c9, CmsPromotionBanner as ca, CmsFooterInformation as cb, VerticalScroll as cc, Link as cd, ImagePlusText as ce, ImagePlusTextCollection as cf, CategoryList as cg, ClassItem as ch, ClassList as ci, Heading as cj, FloatingTicker as ck, TemplateNavigation as cl, Tabs as cm, BottomNavigation as cn, TemplateHome as co, VerticalScrollGroup as cp, __rest as cq, __assign as cr, Body as d, Breadcrumb as e, BreadcrumbGroup as f, Button as g, ButtonFloating as h, ButtonIcon as i, ButtonLayout as j, ButtonToggle as k, Card as l, Carousel as m, Checkbox as n, CheckboxGroup as o, Chip as p, ChipGroup as q, ChipGroupProductTile as r, CollectionGrid as s, CollectionList as t, CollectionListHorizontal as u, ContentAlignment as v, ContentsCard as w, DescriptionList as x, Display as y, Drawer as z };
